import * as Xl from "react";
import Sa, { isValidElement as aE, useLayoutEffect as Fk, useEffect as gt, useRef as Pt, useCallback as Ir, useMemo as Lr, useState as Qt, useReducer as oE, createContext as ka, useContext as Yo, Fragment as iE, createRef as Uk, forwardRef as Oy } from "react";
import { s as W8, c as Yk } from "./sprinkles-B5Xf7JFz.js";
/* empty css                              */
import { v as lh, b as $k } from "./vars-Blis_QEQ.js";
import { themeVars as lE } from "./theme.js";
var Wk = Object.defineProperty, zk = Object.defineProperties, qk = Object.getOwnPropertyDescriptors, S5 = Object.getOwnPropertySymbols, uE = Object.prototype.hasOwnProperty, sE = Object.prototype.propertyIsEnumerable, g_ = (e, t, a) => t in e ? Wk(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, G = (e, t) => {
  for (var a in t || (t = {}))
    uE.call(t, a) && g_(e, a, t[a]);
  if (S5)
    for (var a of S5(t))
      sE.call(t, a) && g_(e, a, t[a]);
  return e;
}, Te = (e, t) => zk(e, qk(t)), Fe = (e, t) => {
  var a = {};
  for (var i in e)
    uE.call(e, i) && t.indexOf(i) < 0 && (a[i] = e[i]);
  if (e != null && S5)
    for (var i of S5(e))
      t.indexOf(i) < 0 && sE.call(e, i) && (a[i] = e[i]);
  return a;
}, Gk = Object.defineProperty, Kk = Object.defineProperties, Qk = Object.getOwnPropertyDescriptors, C5 = Object.getOwnPropertySymbols, cE = Object.prototype.hasOwnProperty, fE = Object.prototype.propertyIsEnumerable, w_ = (e, t, a) => t in e ? Gk(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, _t = (e, t) => {
  for (var a in t || (t = {}))
    cE.call(t, a) && w_(e, a, t[a]);
  if (C5)
    for (var a of C5(t))
      fE.call(t, a) && w_(e, a, t[a]);
  return e;
}, mn = (e, t) => Kk(e, Qk(t)), jp = (e, t) => {
  var a = {};
  for (var i in e)
    cE.call(e, i) && t.indexOf(i) < 0 && (a[i] = e[i]);
  if (e != null && C5)
    for (var i of C5(e))
      t.indexOf(i) < 0 && fE.call(e, i) && (a[i] = e[i]);
  return a;
};
function T4(...e) {
}
function Xk(e, t) {
  if (e === t)
    return !0;
  if (!e || !t || typeof e != "object" || typeof t != "object")
    return !1;
  const a = Object.keys(e), i = Object.keys(t), { length: h } = a;
  if (i.length !== h)
    return !1;
  for (const g of a)
    if (e[g] !== t[g])
      return !1;
  return !0;
}
function O4(e, t) {
  if (Jk(e)) {
    const a = eL(t) ? t() : t;
    return e(a);
  }
  return e;
}
function Jk(e) {
  return typeof e == "function";
}
function eL(e) {
  return typeof e == "function";
}
function b5(e) {
  return typeof e == "object" && e != null;
}
function tL(e) {
  return typeof e == "number" ? Math.floor(e) === e : String(Math.floor(Number(e))) === e;
}
function hf(e, t) {
  return typeof Object.hasOwn == "function" ? Object.hasOwn(e, t) : Object.prototype.hasOwnProperty.call(e, t);
}
function _l(...e) {
  return (...t) => {
    for (const a of e)
      typeof a == "function" && a(...t);
  };
}
function nL(...e) {
  return e.filter(Boolean).join(" ") || void 0;
}
function Dy(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function rL(e, t) {
  const a = _t({}, e);
  for (const i of t)
    hf(a, i) && delete a[i];
  return a;
}
function aL(e, t) {
  const a = {};
  for (const i of t)
    hf(e, i) && (a[i] = e[i]);
  return a;
}
function dE(e) {
  return e;
}
function Zt(e, t) {
  if (!e)
    throw typeof t != "string" ? new Error("Invariant failed") : new Error(t);
}
function oL(e) {
  return Object.keys(e);
}
function k2(e, ...t) {
  const a = typeof e == "function" ? e(...t) : e;
  return a == null ? !1 : !a;
}
function mf(e) {
  return e.disabled || e["aria-disabled"] === !0 || e["aria-disabled"] === "true";
}
function La(e) {
  const t = {};
  for (const a in e)
    e[a] !== void 0 && (t[a] = e[a]);
  return t;
}
function st(...e) {
  for (const t of e)
    if (t !== void 0)
      return t;
}
function z8(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function iL(e) {
  return !(!e || !aE(e) || !("ref" in e));
}
function lL(e) {
  return iL(e) ? e.ref : null;
}
function uL(e, t) {
  const a = G({}, e);
  for (const i in t) {
    if (!hf(t, i))
      continue;
    if (i === "className") {
      const g = "className";
      a[g] = e[g] ? `${e[g]} ${t[g]}` : t[g];
      continue;
    }
    if (i === "style") {
      const g = "style";
      a[g] = e[g] ? G(G({}, e[g]), t[g]) : t[g];
      continue;
    }
    const h = t[i];
    if (typeof h == "function" && i.startsWith("on")) {
      const g = e[i];
      if (typeof g == "function") {
        a[i] = (...m) => {
          h(...m), g(...m);
        };
        continue;
      }
    }
    a[i] = h;
  }
  return a;
}
var Ap = sL();
function sL() {
  var e;
  return typeof window < "u" && !!((e = window.document) != null && e.createElement);
}
function Qr(e) {
  return e ? e.ownerDocument || e : document;
}
function hE(e) {
  return Qr(e).defaultView || window;
}
function gf(e, t = !1) {
  const { activeElement: a } = Qr(e);
  if (!(a != null && a.nodeName))
    return null;
  if (jy(a) && a.contentDocument)
    return gf(
      a.contentDocument.body,
      t
    );
  if (t) {
    const i = a.getAttribute("aria-activedescendant");
    if (i) {
      const h = Qr(a).getElementById(i);
      if (h)
        return h;
    }
  }
  return a;
}
function ha(e, t) {
  return e === t || e.contains(t);
}
function jy(e) {
  return e.tagName === "IFRAME";
}
function L0(e) {
  const t = e.tagName.toLowerCase();
  return t === "button" ? !0 : t === "input" && e.type ? cL.indexOf(e.type) !== -1 : !1;
}
var cL = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function Ay(e, t) {
  return "matches" in e ? e.matches(t) : "msMatchesSelector" in e ? e.msMatchesSelector(t) : e.webkitMatchesSelector(t);
}
function vE(e) {
  const t = e;
  return t.offsetWidth > 0 || t.offsetHeight > 0 || e.getClientRects().length > 0;
}
function pE(e, t) {
  if ("closest" in e)
    return e.closest(t);
  do {
    if (Ay(e, t))
      return e;
    e = e.parentElement || e.parentNode;
  } while (e !== null && e.nodeType === 1);
  return null;
}
function bl(e) {
  try {
    const t = e instanceof HTMLInputElement && e.selectionStart !== null, a = e.tagName === "TEXTAREA";
    return t || a || !1;
  } catch {
    return !1;
  }
}
function q8(e) {
  return e.isContentEditable || bl(e);
}
function fL(e) {
  if (bl(e))
    return e.value;
  if (e.isContentEditable) {
    const t = Qr(e).createRange();
    return t.selectNodeContents(e), t.toString();
  }
  return "";
}
function G8(e) {
  let t = 0, a = 0;
  if (bl(e))
    t = e.selectionStart || 0, a = e.selectionEnd || 0;
  else if (e.isContentEditable) {
    const i = Qr(e).getSelection();
    if (i != null && i.rangeCount && i.anchorNode && ha(e, i.anchorNode) && i.focusNode && ha(e, i.focusNode)) {
      const h = i.getRangeAt(0), g = h.cloneRange();
      g.selectNodeContents(e), g.setEnd(h.startContainer, h.startOffset), t = g.toString().length, g.setEnd(h.endContainer, h.endOffset), a = g.toString().length;
    }
  }
  return { start: t, end: a };
}
function vh(e, t) {
  const a = ["dialog", "menu", "listbox", "tree", "grid"], i = e == null ? void 0 : e.getAttribute("role");
  return i && a.indexOf(i) !== -1 ? i : t;
}
function ky(e, t) {
  var a;
  const i = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  }, h = vh(e);
  return h && (a = i[h]) != null ? a : t;
}
function Ly(e) {
  if (!e)
    return null;
  if (e.clientHeight && e.scrollHeight > e.clientHeight) {
    const { overflowY: t } = getComputedStyle(e);
    if (t !== "visible" && t !== "hidden")
      return e;
  } else if (e.clientWidth && e.scrollWidth > e.clientWidth) {
    const { overflowX: t } = getComputedStyle(e);
    if (t !== "visible" && t !== "hidden")
      return e;
  }
  return Ly(e.parentElement) || document.scrollingElement || document.body;
}
function S8(e, ...t) {
  /text|search|password|tel|url/i.test(e.type) && e.setSelectionRange(...t);
}
function dL() {
  return Ap && !!navigator.maxTouchPoints;
}
function Iy() {
  return Ap ? /mac|iphone|ipad|ipod/i.test(navigator.platform) : !1;
}
function Hy() {
  return Ap && Iy() && /apple/i.test(navigator.vendor);
}
function hL() {
  return Ap && /firefox\//i.test(navigator.userAgent);
}
function vL() {
  return Ap && navigator.platform.startsWith("Mac") && !dL();
}
function mE(e) {
  return !!(e.currentTarget && !ha(e.currentTarget, e.target));
}
function Ci(e) {
  return e.target === e.currentTarget;
}
function Zy(e) {
  const t = e.currentTarget;
  if (!t)
    return !1;
  const a = Iy();
  if (a && !e.metaKey || !a && !e.ctrlKey)
    return !1;
  const i = t.tagName.toLowerCase();
  return i === "a" || i === "button" && t.type === "submit" || i === "input" && t.type === "submit";
}
function Py(e) {
  const t = e.currentTarget;
  if (!t)
    return !1;
  const a = t.tagName.toLowerCase();
  return e.altKey ? a === "a" || a === "button" && t.type === "submit" || a === "input" && t.type === "submit" : !1;
}
function pL(e, t, a) {
  const i = new Event(t, a);
  return e.dispatchEvent(i);
}
function pp(e, t) {
  const a = new FocusEvent("blur", t), i = e.dispatchEvent(a), h = mn(_t({}, t), { bubbles: !0 });
  return e.dispatchEvent(new FocusEvent("focusout", h)), i;
}
function mL(e, t, a) {
  const i = new KeyboardEvent(t, a);
  return e.dispatchEvent(i);
}
function y_(e, t) {
  const a = new MouseEvent("click", t);
  return e.dispatchEvent(a);
}
function rh(e, t) {
  const a = t || e.currentTarget, i = e.relatedTarget;
  return !i || !ha(a, i);
}
function L2(e, t, a) {
  const i = requestAnimationFrame(() => {
    e.removeEventListener(t, h, !0), a();
  }), h = () => {
    cancelAnimationFrame(i), a();
  };
  return e.addEventListener(t, h, {
    once: !0,
    capture: !0
  }), i;
}
function Uo(e, t, a, i = window) {
  const h = [];
  try {
    i.document.addEventListener(e, t, a);
    for (const m of Array.from(i.frames))
      h.push(Uo(e, t, a, m));
  } catch {
  }
  return () => {
    try {
      i.document.removeEventListener(e, t, a);
    } catch {
    }
    h.forEach((m) => m());
  };
}
var gE = G({}, Xl), x_ = gE.useId, S_ = gE.useInsertionEffect, jn = Ap ? Fk : gt;
function Vy(e) {
  const [t] = Qt(e);
  return t;
}
function wE(e) {
  const t = Pt(e);
  return jn(() => {
    t.current = e;
  }), t;
}
function rt(e) {
  const t = Pt(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return S_ ? S_(() => {
    t.current = e;
  }) : t.current = e, Ir((...a) => {
    var i;
    return (i = t.current) == null ? void 0 : i.call(t, ...a);
  }, []);
}
function An(...e) {
  return Lr(() => {
    if (e.some(Boolean))
      return (t) => {
        e.forEach((a) => z8(a, t));
      };
  }, e);
}
function Ia(e) {
  if (x_) {
    const i = x_();
    return e || i;
  }
  const [t, a] = Qt(e);
  return jn(() => {
    if (e || t)
      return;
    const i = Math.random().toString(36).substr(2, 6);
    a(`id-${i}`);
  }, [e, t]), e || t;
}
function ph(e, t) {
  const a = (g) => {
    if (typeof g == "string")
      return g;
  }, [i, h] = Qt(() => a(t));
  return jn(() => {
    const g = e && "current" in e ? e.current : e;
    h((g == null ? void 0 : g.tagName.toLowerCase()) || a(t));
  }, [e, t]), i;
}
function yE(e, t, a) {
  const [i, h] = Qt(a);
  return jn(() => {
    const g = e && "current" in e ? e.current : e;
    if (!g)
      return;
    const m = () => {
      const S = g.getAttribute(t);
      S != null && h(S);
    }, C = new MutationObserver(m);
    return C.observe(g, { attributeFilter: [t] }), m(), () => C.disconnect();
  }, [e, t]), i;
}
function _1(e, t) {
  const a = Pt(!1);
  gt(() => {
    if (a.current)
      return e();
    a.current = !0;
  }, t), gt(
    () => () => {
      a.current = !1;
    },
    []
  );
}
function gL(e, t) {
  const a = Pt(!1);
  jn(() => {
    if (a.current)
      return e();
    a.current = !0;
  }, t), jn(
    () => () => {
      a.current = !1;
    },
    []
  );
}
function P5() {
  return oE(() => [], []);
}
function er(e) {
  return rt(
    typeof e == "function" ? e : () => e
  );
}
function Vn(e, t, a = []) {
  const i = Ir(
    (h) => (e.wrapElement && (h = e.wrapElement(h)), t(h)),
    [...a, e.wrapElement]
  );
  return Te(G({}, e), { wrapElement: i });
}
function Ny(e = !1, t) {
  const [a, i] = Qt(null);
  return { portalRef: An(i, t), portalNode: a, domReady: !e || a };
}
function xE(e, t, a) {
  const i = e.onLoadedMetadataCapture, h = Lr(() => Object.assign(() => {
  }, Te(G({}, i), { [t]: a })), [i, t, a]);
  return [i == null ? void 0 : i[t], { onLoadedMetadataCapture: h }];
}
function SE() {
  return gt(() => {
    Uo("mousemove", yL, !0), Uo("mousedown", a5, !0), Uo("mouseup", a5, !0), Uo("keydown", a5, !0), Uo("scroll", a5, !0);
  }, []), rt(() => By);
}
var By = !1, C_ = 0, b_ = 0;
function wL(e) {
  const t = e.movementX || e.screenX - C_, a = e.movementY || e.screenY - b_;
  return C_ = e.screenX, b_ = e.screenY, t || a || process.env.NODE_ENV === "test";
}
function yL(e) {
  wL(e) && (By = !0);
}
function a5() {
  By = !1;
}
function V2(e, t) {
  const a = e.__unstableInternals;
  return Zt(a, "Invalid store"), a[t];
}
function fo(e, ...t) {
  let a = e, i = a, h = Symbol(), g = T4;
  const m = /* @__PURE__ */ new Set(), C = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Set(), R = /* @__PURE__ */ new Set(), D = /* @__PURE__ */ new Set(), T = /* @__PURE__ */ new WeakMap(), j = /* @__PURE__ */ new WeakMap(), A = (Se) => (S.add(Se), () => S.delete(Se)), L = () => {
    const Se = m.size, re = Symbol();
    m.add(re);
    const ve = () => {
      m.delete(re), !m.size && g();
    };
    if (Se)
      return ve;
    const K = oL(a).map(
      (xe) => _l(
        ...t.map((Le) => {
          var be;
          const Ue = (be = Le == null ? void 0 : Le.getState) == null ? void 0 : be.call(Le);
          if (Ue && hf(Ue, xe))
            return xa(Le, [xe], (ie) => {
              le(
                xe,
                ie[xe],
                // @ts-expect-error - Not public API. This is just to prevent
                // infinite loops.
                !0
              );
            });
        })
      )
    ), de = [];
    S.forEach((xe) => de.push(xe()));
    const fe = t.map(V5);
    return g = _l(...K, ...de, ...fe), ve;
  }, P = (Se, re, ve = R) => (ve.add(re), j.set(re, Se), () => {
    var K;
    (K = T.get(re)) == null || K(), T.delete(re), j.delete(re), ve.delete(re);
  }), V = (Se, re) => P(Se, re), F = (Se, re) => (T.set(re, re(a, a)), P(Se, re)), Y = (Se, re) => (T.set(re, re(a, i)), P(Se, re, D)), W = (Se) => fo(aL(a, Se), te), Q = (Se) => fo(rL(a, Se), te), $ = () => a, le = (Se, re, ve = !1) => {
    if (!hf(a, Se))
      return;
    const K = O4(re, a[Se]);
    if (K === a[Se])
      return;
    ve || t.forEach((Le) => {
      var be;
      (be = Le == null ? void 0 : Le.setState) == null || be.call(Le, Se, K);
    });
    const de = a;
    a = mn(_t({}, a), { [Se]: K });
    const fe = Symbol();
    h = fe, C.add(Se);
    const xe = (Le, be, Ue) => {
      var ie;
      const _e = j.get(Le), Ze = (mt) => Ue ? Ue.has(mt) : mt === Se;
      (!_e || _e.some(Ze)) && ((ie = T.get(Le)) == null || ie(), T.set(Le, Le(a, be)));
    };
    R.forEach((Le) => {
      xe(Le, de);
    }), queueMicrotask(() => {
      if (h !== fe)
        return;
      const Le = a;
      D.forEach((be) => {
        xe(be, i, C);
      }), i = Le, C.clear();
    });
  }, te = {
    getState: $,
    setState: le,
    __unstableInternals: {
      setup: A,
      init: L,
      subscribe: V,
      sync: F,
      batch: Y,
      pick: W,
      omit: Q
    }
  };
  return te;
}
function Aa(e, ...t) {
  if (e)
    return V2(e, "setup")(...t);
}
function V5(e, ...t) {
  if (e)
    return V2(e, "init")(...t);
}
function CE(e, ...t) {
  if (e)
    return V2(e, "subscribe")(...t);
}
function xa(e, ...t) {
  if (e)
    return V2(e, "sync")(...t);
}
function I2(e, ...t) {
  if (e)
    return V2(e, "batch")(...t);
}
function Tp(e, ...t) {
  if (e)
    return V2(e, "omit")(...t);
}
function bE(e, ...t) {
  if (e)
    return V2(e, "pick")(...t);
}
function kp(...e) {
  const t = e.reduce((i, h) => {
    var g;
    const m = (g = h == null ? void 0 : h.getState) == null ? void 0 : g.call(h);
    return m ? _t(_t({}, i), m) : i;
  }, {});
  return fo(t, ...e);
}
function mh(e, t) {
  if (process.env.NODE_ENV === "production" || !t)
    return;
  const a = Object.entries(e).filter(([g, m]) => g.startsWith("default") && m !== void 0).map(([g]) => {
    var m;
    const C = g.replace("default", "");
    return `${((m = C[0]) == null ? void 0 : m.toLowerCase()) || ""}${C.slice(1)}`;
  });
  if (!a.length)
    return;
  const i = t.getState();
  if (a.filter(
    (g) => hf(i, g)
  ).length)
    throw new Error(
      `Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`
    );
}
var C4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _E(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var K8 = { exports: {} }, C8 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var __;
function xL() {
  if (__) return C8;
  __ = 1;
  var e = Sa;
  function t(T, j) {
    return T === j && (T !== 0 || 1 / T === 1 / j) || T !== T && j !== j;
  }
  var a = typeof Object.is == "function" ? Object.is : t, i = e.useState, h = e.useEffect, g = e.useLayoutEffect, m = e.useDebugValue;
  function C(T, j) {
    var A = j(), L = i({ inst: { value: A, getSnapshot: j } }), P = L[0].inst, V = L[1];
    return g(
      function() {
        P.value = A, P.getSnapshot = j, S(P) && V({ inst: P });
      },
      [T, A, j]
    ), h(
      function() {
        return S(P) && V({ inst: P }), T(function() {
          S(P) && V({ inst: P });
        });
      },
      [T]
    ), m(A), A;
  }
  function S(T) {
    var j = T.getSnapshot;
    T = T.value;
    try {
      var A = j();
      return !a(T, A);
    } catch {
      return !0;
    }
  }
  function R(T, j) {
    return j();
  }
  var D = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? R : C;
  return C8.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : D, C8;
}
var b8 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var R_;
function SL() {
  return R_ || (R_ = 1, process.env.NODE_ENV !== "production" && function() {
    function e(A, L) {
      return A === L && (A !== 0 || 1 / A === 1 / L) || A !== A && L !== L;
    }
    function t(A, L) {
      D || h.startTransition === void 0 || (D = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var P = L();
      if (!T) {
        var V = L();
        g(P, V) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), T = !0);
      }
      V = m({
        inst: { value: P, getSnapshot: L }
      });
      var F = V[0].inst, Y = V[1];
      return S(
        function() {
          F.value = P, F.getSnapshot = L, a(F) && Y({ inst: F });
        },
        [A, P, L]
      ), C(
        function() {
          return a(F) && Y({ inst: F }), A(function() {
            a(F) && Y({ inst: F });
          });
        },
        [A]
      ), R(P), P;
    }
    function a(A) {
      var L = A.getSnapshot;
      A = A.value;
      try {
        var P = L();
        return !g(A, P);
      } catch {
        return !0;
      }
    }
    function i(A, L) {
      return L();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var h = Sa, g = typeof Object.is == "function" ? Object.is : e, m = h.useState, C = h.useEffect, S = h.useLayoutEffect, R = h.useDebugValue, D = !1, T = !1, j = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? i : t;
    b8.useSyncExternalStore = h.useSyncExternalStore !== void 0 ? h.useSyncExternalStore : j, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), b8;
}
process.env.NODE_ENV === "production" ? K8.exports = xL() : K8.exports = SL();
var CL = K8.exports;
const bL = /* @__PURE__ */ _E(CL);
var { useSyncExternalStore: _L } = bL, RL = () => () => {
};
function ja(e, t = dE) {
  const a = Xl.useCallback(
    (h) => e ? CE(e, null, h) : RL(),
    [e]
  ), i = () => {
    const h = typeof t == "string" ? t : null, g = typeof t == "function" ? t : null, m = e == null ? void 0 : e.getState();
    if (g)
      return g(m);
    if (m && h && hf(m, h))
      return m[h];
  };
  return _L(a, i, i);
}
function ir(e, t, a, i) {
  const h = hf(t, a) ? t[a] : void 0, g = i ? t[i] : void 0, m = wE({ value: h, setValue: g });
  jn(() => xa(e, [a], (C, S) => {
    const { value: R, setValue: D } = m.current;
    D && C[a] !== S[a] && C[a] !== R && D(C[a]);
  }), [e, a]), jn(() => {
    if (h !== void 0)
      return e.setState(a, h), I2(e, [a], () => {
        h !== void 0 && e.setState(a, h);
      });
  });
}
function bi(e, t) {
  const [a, i] = Xl.useState(() => e(t));
  jn(() => V5(a), [a]);
  const h = Xl.useCallback(
    (C) => ja(a, C),
    [a]
  ), g = Xl.useMemo(
    () => Te(G({}, a), { useState: h }),
    [a, h]
  ), m = rt(() => {
    i((C) => e(G(G({}, t), C.getState())));
  });
  return [g, m];
}
function EL(e, t) {
  return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
function ML(e) {
  const t = e.map((i, h) => [h, i]);
  let a = !1;
  return t.sort(([i, h], [g, m]) => {
    const C = h.element, S = m.element;
    return C === S || !C || !S ? 0 : EL(C, S) ? (i > g && (a = !0), -1) : (i < g && (a = !0), 1);
  }), a ? t.map(([i, h]) => h) : e;
}
function TL(e) {
  var t;
  const a = e.find((g) => !!g.element), i = [...e].reverse().find((g) => !!g.element);
  let h = (t = a == null ? void 0 : a.element) == null ? void 0 : t.parentElement;
  for (; h && (i != null && i.element); ) {
    if (i && h.contains(i.element))
      return h;
    h = h.parentElement;
  }
  return Qr(h).body;
}
function OL(e) {
  return e == null ? void 0 : e.__unstablePrivateStore;
}
function N5(e = {}) {
  var t;
  mh(e, e.store);
  const a = (t = e.store) == null ? void 0 : t.getState(), i = st(
    e.items,
    a == null ? void 0 : a.items,
    e.defaultItems,
    []
  ), h = new Map(i.map((j) => [j.id, j])), g = {
    items: i,
    renderedItems: st(a == null ? void 0 : a.renderedItems, [])
  }, m = OL(e.store), C = fo(
    { items: i, renderedItems: g.renderedItems },
    m
  ), S = fo(g, e.store), R = (j) => {
    const A = ML(j);
    C.setState("renderedItems", A), S.setState("renderedItems", A);
  };
  Aa(S, () => V5(C)), Aa(C, () => I2(C, ["items"], (j) => {
    S.setState("items", j.items);
  })), Aa(C, () => I2(C, ["renderedItems"], (j) => {
    let A = !0, L = requestAnimationFrame(() => {
      const { renderedItems: Y } = S.getState();
      j.renderedItems !== Y && R(j.renderedItems);
    });
    if (typeof IntersectionObserver != "function")
      return () => cancelAnimationFrame(L);
    const P = () => {
      if (A) {
        A = !1;
        return;
      }
      cancelAnimationFrame(L), L = requestAnimationFrame(() => R(j.renderedItems));
    }, V = TL(j.renderedItems), F = new IntersectionObserver(P, { root: V });
    for (const Y of j.renderedItems)
      Y.element && F.observe(Y.element);
    return () => {
      cancelAnimationFrame(L), F.disconnect();
    };
  }));
  const D = (j, A, L = !1) => {
    let P;
    return A((F) => {
      const Y = F.findIndex(({ id: Q }) => Q === j.id), W = F.slice();
      if (Y !== -1) {
        P = F[Y];
        const Q = _t(_t({}, P), j);
        W[Y] = Q, h.set(j.id, Q);
      } else
        W.push(j), h.set(j.id, j);
      return W;
    }), () => {
      A((F) => {
        if (!P)
          return L && h.delete(j.id), F.filter(({ id: Q }) => Q !== j.id);
        const Y = F.findIndex(({ id: Q }) => Q === j.id);
        if (Y === -1)
          return F;
        const W = F.slice();
        return W[Y] = P, h.set(j.id, P), W;
      });
    };
  }, T = (j) => D(
    j,
    (A) => C.setState("items", A),
    !0
  );
  return mn(_t({}, S), {
    registerItem: T,
    renderItem: (j) => _l(
      T(j),
      D(
        j,
        (A) => C.setState("renderedItems", A)
      )
    ),
    item: (j) => {
      if (!j)
        return null;
      let A = h.get(j);
      if (!A) {
        const { items: L } = S.getState();
        A = L.find((P) => P.id === j), A && h.set(j, A);
      }
      return A || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: C
  });
}
function Fy(e, t, a) {
  return _1(t, [a.store]), ir(e, a, "items", "setItems"), e;
}
function RE(e = {}) {
  const [t, a] = bi(N5, e);
  return Fy(t, a, e);
}
var Q8 = { exports: {} }, b4 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E_;
function DL() {
  if (E_) return b4;
  E_ = 1;
  var e = Sa, t = Symbol.for("react.element"), a = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, h = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, g = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(C, S, R) {
    var D, T = {}, j = null, A = null;
    R !== void 0 && (j = "" + R), S.key !== void 0 && (j = "" + S.key), S.ref !== void 0 && (A = S.ref);
    for (D in S) i.call(S, D) && !g.hasOwnProperty(D) && (T[D] = S[D]);
    if (C && C.defaultProps) for (D in S = C.defaultProps, S) T[D] === void 0 && (T[D] = S[D]);
    return { $$typeof: t, type: C, key: j, ref: A, props: T, _owner: h.current };
  }
  return b4.Fragment = a, b4.jsx = m, b4.jsxs = m, b4;
}
var _4 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M_;
function jL() {
  return M_ || (M_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Sa, t = Symbol.for("react.element"), a = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), m = Symbol.for("react.provider"), C = Symbol.for("react.context"), S = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), D = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), j = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), L = Symbol.iterator, P = "@@iterator";
    function V(X) {
      if (X === null || typeof X != "object")
        return null;
      var $e = L && X[L] || X[P];
      return typeof $e == "function" ? $e : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Y(X) {
      {
        for (var $e = arguments.length, dt = new Array($e > 1 ? $e - 1 : 0), Et = 1; Et < $e; Et++)
          dt[Et - 1] = arguments[Et];
        W("error", X, dt);
      }
    }
    function W(X, $e, dt) {
      {
        var Et = F.ReactDebugCurrentFrame, Nn = Et.getStackAddendum();
        Nn !== "" && ($e += "%s", dt = dt.concat([Nn]));
        var yn = dt.map(function(dn) {
          return String(dn);
        });
        yn.unshift("Warning: " + $e), Function.prototype.apply.call(console[X], console, yn);
      }
    }
    var Q = !1, $ = !1, le = !1, te = !1, Se = !1, re;
    re = Symbol.for("react.module.reference");
    function ve(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === i || X === g || Se || X === h || X === R || X === D || te || X === A || Q || $ || le || typeof X == "object" && X !== null && (X.$$typeof === j || X.$$typeof === T || X.$$typeof === m || X.$$typeof === C || X.$$typeof === S || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === re || X.getModuleId !== void 0));
    }
    function K(X, $e, dt) {
      var Et = X.displayName;
      if (Et)
        return Et;
      var Nn = $e.displayName || $e.name || "";
      return Nn !== "" ? dt + "(" + Nn + ")" : dt;
    }
    function de(X) {
      return X.displayName || "Context";
    }
    function fe(X) {
      if (X == null)
        return null;
      if (typeof X.tag == "number" && Y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof X == "function")
        return X.displayName || X.name || null;
      if (typeof X == "string")
        return X;
      switch (X) {
        case i:
          return "Fragment";
        case a:
          return "Portal";
        case g:
          return "Profiler";
        case h:
          return "StrictMode";
        case R:
          return "Suspense";
        case D:
          return "SuspenseList";
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case C:
            var $e = X;
            return de($e) + ".Consumer";
          case m:
            var dt = X;
            return de(dt._context) + ".Provider";
          case S:
            return K(X, X.render, "ForwardRef");
          case T:
            var Et = X.displayName || null;
            return Et !== null ? Et : fe(X.type) || "Memo";
          case j: {
            var Nn = X, yn = Nn._payload, dn = Nn._init;
            try {
              return fe(dn(yn));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var xe = Object.assign, Le = 0, be, Ue, ie, _e, Ze, mt, Pe;
    function Vt() {
    }
    Vt.__reactDisabledLog = !0;
    function Dt() {
      {
        if (Le === 0) {
          be = console.log, Ue = console.info, ie = console.warn, _e = console.error, Ze = console.group, mt = console.groupCollapsed, Pe = console.groupEnd;
          var X = {
            configurable: !0,
            enumerable: !0,
            value: Vt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: X,
            log: X,
            warn: X,
            error: X,
            group: X,
            groupCollapsed: X,
            groupEnd: X
          });
        }
        Le++;
      }
    }
    function Qe() {
      {
        if (Le--, Le === 0) {
          var X = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: xe({}, X, {
              value: be
            }),
            info: xe({}, X, {
              value: Ue
            }),
            warn: xe({}, X, {
              value: ie
            }),
            error: xe({}, X, {
              value: _e
            }),
            group: xe({}, X, {
              value: Ze
            }),
            groupCollapsed: xe({}, X, {
              value: mt
            }),
            groupEnd: xe({}, X, {
              value: Pe
            })
          });
        }
        Le < 0 && Y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var et = F.ReactCurrentDispatcher, wt;
    function St(X, $e, dt) {
      {
        if (wt === void 0)
          try {
            throw Error();
          } catch (Nn) {
            var Et = Nn.stack.trim().match(/\n( *(at )?)/);
            wt = Et && Et[1] || "";
          }
        return `
` + wt + X;
      }
    }
    var _n = !1, Hr;
    {
      var kn = typeof WeakMap == "function" ? WeakMap : Map;
      Hr = new kn();
    }
    function Wn(X, $e) {
      if (!X || _n)
        return "";
      {
        var dt = Hr.get(X);
        if (dt !== void 0)
          return dt;
      }
      var Et;
      _n = !0;
      var Nn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var yn;
      yn = et.current, et.current = null, Dt();
      try {
        if ($e) {
          var dn = function() {
            throw Error();
          };
          if (Object.defineProperty(dn.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(dn, []);
            } catch (na) {
              Et = na;
            }
            Reflect.construct(X, [], dn);
          } else {
            try {
              dn.call();
            } catch (na) {
              Et = na;
            }
            X.call(dn.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (na) {
            Et = na;
          }
          X();
        }
      } catch (na) {
        if (na && Et && typeof na.stack == "string") {
          for (var hn = na.stack.split(`
`), Za = Et.stack.split(`
`), Rr = hn.length - 1, Er = Za.length - 1; Rr >= 1 && Er >= 0 && hn[Rr] !== Za[Er]; )
            Er--;
          for (; Rr >= 1 && Er >= 0; Rr--, Er--)
            if (hn[Rr] !== Za[Er]) {
              if (Rr !== 1 || Er !== 1)
                do
                  if (Rr--, Er--, Er < 0 || hn[Rr] !== Za[Er]) {
                    var ho = `
` + hn[Rr].replace(" at new ", " at ");
                    return X.displayName && ho.includes("<anonymous>") && (ho = ho.replace("<anonymous>", X.displayName)), typeof X == "function" && Hr.set(X, ho), ho;
                  }
                while (Rr >= 1 && Er >= 0);
              break;
            }
        }
      } finally {
        _n = !1, et.current = yn, Qe(), Error.prepareStackTrace = Nn;
      }
      var vo = X ? X.displayName || X.name : "", Gt = vo ? St(vo) : "";
      return typeof X == "function" && Hr.set(X, Gt), Gt;
    }
    function sr(X, $e, dt) {
      return Wn(X, !1);
    }
    function yr(X) {
      var $e = X.prototype;
      return !!($e && $e.isReactComponent);
    }
    function ea(X, $e, dt) {
      if (X == null)
        return "";
      if (typeof X == "function")
        return Wn(X, yr(X));
      if (typeof X == "string")
        return St(X);
      switch (X) {
        case R:
          return St("Suspense");
        case D:
          return St("SuspenseList");
      }
      if (typeof X == "object")
        switch (X.$$typeof) {
          case S:
            return sr(X.render);
          case T:
            return ea(X.type);
          case j: {
            var Et = X, Nn = Et._payload, yn = Et._init;
            try {
              return ea(yn(Nn));
            } catch {
            }
          }
        }
      return "";
    }
    var Ca = Object.prototype.hasOwnProperty, ft = {}, fn = F.ReactDebugCurrentFrame;
    function Ln(X) {
      if (X) {
        var $e = ea(X.type);
        fn.setExtraStackFrame($e);
      } else
        fn.setExtraStackFrame(null);
    }
    function Nt(X, $e, dt, Et, Nn) {
      {
        var yn = Function.call.bind(Ca);
        for (var dn in X)
          if (yn(X, dn)) {
            var hn = void 0;
            try {
              if (typeof X[dn] != "function") {
                var Za = Error((Et || "React class") + ": " + dt + " type `" + dn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof X[dn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Za.name = "Invariant Violation", Za;
              }
              hn = X[dn]($e, dn, Et, dt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Rr) {
              hn = Rr;
            }
            hn && !(hn instanceof Error) && (Ln(Nn), Y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Et || "React class", dt, dn, typeof hn), Ln(null)), hn instanceof Error && !(hn.message in ft) && (ft[hn.message] = !0, Ln(Nn), Y("Failed %s type: %s", dt, hn.message), Ln(null));
          }
      }
    }
    var gn = Array.isArray;
    function zn(X) {
      return gn(X);
    }
    function Ur(X) {
      {
        var $e = typeof Symbol == "function" && Symbol.toStringTag, dt = $e && X[Symbol.toStringTag] || X.constructor.name || "Object";
        return dt;
      }
    }
    function Xe(X) {
      try {
        return !1;
      } catch {
        return !0;
      }
    }
    function Jt(X) {
      return "" + X;
    }
    function qn(X) {
      if (Xe())
        return Y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ur(X)), Jt(X);
    }
    var Sn = F.ReactCurrentOwner, qe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, yt, Ct;
    function ln(X) {
      if (Ca.call(X, "ref")) {
        var $e = Object.getOwnPropertyDescriptor(X, "ref").get;
        if ($e && $e.isReactWarning)
          return !1;
      }
      return X.ref !== void 0;
    }
    function cr(X) {
      if (Ca.call(X, "key")) {
        var $e = Object.getOwnPropertyDescriptor(X, "key").get;
        if ($e && $e.isReactWarning)
          return !1;
      }
      return X.key !== void 0;
    }
    function ta(X, $e) {
      {
        var dt = function() {
          yt || (yt = !0, Y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $e));
        };
        dt.isReactWarning = !0, Object.defineProperty(X, "key", {
          get: dt,
          configurable: !0
        });
      }
    }
    function xr(X, $e) {
      {
        var dt = function() {
          Ct || (Ct = !0, Y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $e));
        };
        dt.isReactWarning = !0, Object.defineProperty(X, "ref", {
          get: dt,
          configurable: !0
        });
      }
    }
    var Ao = function(X, $e, dt, Et, Nn, yn, dn) {
      var hn = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: X,
        key: $e,
        ref: dt,
        props: dn,
        // Record the component responsible for creating this element.
        _owner: yn
      };
      return hn._store = {}, Object.defineProperty(hn._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(hn, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Et
      }), Object.defineProperty(hn, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Nn
      }), Object.freeze && (Object.freeze(hn.props), Object.freeze(hn)), hn;
    };
    function wn(X, $e, dt, Et, Nn) {
      {
        var yn, dn = {}, hn = null, Za = null;
        dt !== void 0 && (qn(dt), hn = "" + dt), cr($e) && (qn($e.key), hn = "" + $e.key), ln($e) && (Za = $e.ref);
        for (yn in $e)
          Ca.call($e, yn) && !qe.hasOwnProperty(yn) && (dn[yn] = $e[yn]);
        if (X && X.defaultProps) {
          var Rr = X.defaultProps;
          for (yn in Rr)
            dn[yn] === void 0 && (dn[yn] = Rr[yn]);
        }
        if (hn || Za) {
          var Er = typeof X == "function" ? X.displayName || X.name || "Unknown" : X;
          hn && ta(dn, Er), Za && xr(dn, Er);
        }
        return Ao(X, hn, Za, Nn, Et, Sn.current, dn);
      }
    }
    var Gn = F.ReactCurrentOwner, T1 = F.ReactDebugCurrentFrame;
    function Ri(X) {
      if (X) {
        var $e = ea(X.type);
        T1.setExtraStackFrame($e);
      } else
        T1.setExtraStackFrame(null);
    }
    var Jl;
    Jl = !1;
    function qi(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function El() {
      {
        if (Gn.current) {
          var X = fe(Gn.current.type);
          if (X)
            return `

Check the render method of \`` + X + "`.";
        }
        return "";
      }
    }
    function F0(X) {
      return "";
    }
    var O1 = {};
    function bf(X) {
      {
        var $e = El();
        if (!$e) {
          var dt = typeof X == "string" ? X : X.displayName || X.name;
          dt && ($e = `

Check the top-level render call using <` + dt + ">.");
        }
        return $e;
      }
    }
    function D1(X, $e) {
      {
        if (!X._store || X._store.validated || X.key != null)
          return;
        X._store.validated = !0;
        var dt = bf($e);
        if (O1[dt])
          return;
        O1[dt] = !0;
        var Et = "";
        X && X._owner && X._owner !== Gn.current && (Et = " It was passed a child from " + fe(X._owner.type) + "."), Ri(X), Y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', dt, Et), Ri(null);
      }
    }
    function Zu(X, $e) {
      {
        if (typeof X != "object")
          return;
        if (zn(X))
          for (var dt = 0; dt < X.length; dt++) {
            var Et = X[dt];
            qi(Et) && D1(Et, $e);
          }
        else if (qi(X))
          X._store && (X._store.validated = !0);
        else if (X) {
          var Nn = V(X);
          if (typeof Nn == "function" && Nn !== X.entries)
            for (var yn = Nn.call(X), dn; !(dn = yn.next()).done; )
              qi(dn.value) && D1(dn.value, $e);
        }
      }
    }
    function Ml(X) {
      {
        var $e = X.type;
        if ($e == null || typeof $e == "string")
          return;
        var dt;
        if (typeof $e == "function")
          dt = $e.propTypes;
        else if (typeof $e == "object" && ($e.$$typeof === S || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        $e.$$typeof === T))
          dt = $e.propTypes;
        else
          return;
        if (dt) {
          var Et = fe($e);
          Nt(dt, X.props, "prop", Et, X);
        } else if ($e.PropTypes !== void 0 && !Jl) {
          Jl = !0;
          var Nn = fe($e);
          Y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Nn || "Unknown");
        }
        typeof $e.getDefaultProps == "function" && !$e.getDefaultProps.isReactClassApproved && Y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Tl(X) {
      {
        for (var $e = Object.keys(X.props), dt = 0; dt < $e.length; dt++) {
          var Et = $e[dt];
          if (Et !== "children" && Et !== "key") {
            Ri(X), Y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Et), Ri(null);
            break;
          }
        }
        X.ref !== null && (Ri(X), Y("Invalid attribute `ref` supplied to `React.Fragment`."), Ri(null));
      }
    }
    var Wo = {};
    function Ol(X, $e, dt, Et, Nn, yn) {
      {
        var dn = ve(X);
        if (!dn) {
          var hn = "";
          (X === void 0 || typeof X == "object" && X !== null && Object.keys(X).length === 0) && (hn += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Za = F0();
          Za ? hn += Za : hn += El();
          var Rr;
          X === null ? Rr = "null" : zn(X) ? Rr = "array" : X !== void 0 && X.$$typeof === t ? (Rr = "<" + (fe(X.type) || "Unknown") + " />", hn = " Did you accidentally export a JSX literal instead of a component?") : Rr = typeof X, Y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Rr, hn);
        }
        var Er = wn(X, $e, dt, Nn, yn);
        if (Er == null)
          return Er;
        if (dn) {
          var ho = $e.children;
          if (ho !== void 0)
            if (Et)
              if (zn(ho)) {
                for (var vo = 0; vo < ho.length; vo++)
                  Zu(ho[vo], X);
                Object.freeze && Object.freeze(ho);
              } else
                Y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Zu(ho, X);
        }
        if (Ca.call($e, "key")) {
          var Gt = fe(X), na = Object.keys($e).filter(function(j1) {
            return j1 !== "key";
          }), Jn = na.length > 0 ? "{key: someKey, " + na.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Wo[Gt + Jn]) {
            var _f = na.length > 0 ? "{" + na.join(": ..., ") + ": ...}" : "{}";
            Y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Jn, Gt, _f, Gt), Wo[Gt + Jn] = !0;
          }
        }
        return X === i ? Tl(Er) : Ml(Er), Er;
      }
    }
    function eu(X, $e, dt) {
      return Ol(X, $e, dt, !0);
    }
    function js(X, $e, dt) {
      return Ol(X, $e, dt, !1);
    }
    var tu = js, Gi = eu;
    _4.Fragment = i, _4.jsx = tu, _4.jsxs = Gi;
  }()), _4;
}
process.env.NODE_ENV === "production" ? Q8.exports = DL() : Q8.exports = jL();
var f = Q8.exports;
function Oe(e) {
  const t = Xl.forwardRef((a, i) => e(Te(G({}, a), { ref: i })));
  return t.displayName = e.displayName || e.name, t;
}
function Ha(e, t) {
  return Xl.memo(e, t);
}
function Ae(e, t) {
  const a = t, { wrapElement: i, render: h } = a, g = Fe(a, ["wrapElement", "render"]), m = An(t.ref, lL(h));
  let C;
  if (Xl.isValidElement(h)) {
    const S = Te(G({}, h.props), { ref: m });
    C = Xl.cloneElement(h, uL(g, S));
  } else h ? C = h(g) : C = /* @__PURE__ */ f.jsx(e, G({}, g));
  return i ? i(C) : C;
}
function ke(e) {
  const t = (a = {}) => e(a);
  return t.displayName = e.name, t;
}
function _i(e = [], t = []) {
  const a = Xl.createContext(void 0), i = Xl.createContext(void 0), h = () => Xl.useContext(a), g = (R = !1) => {
    const D = Xl.useContext(i), T = h();
    return R ? D : D || T;
  }, m = () => {
    const R = Xl.useContext(i), D = h();
    if (!(R && R === D))
      return D;
  }, C = (R) => e.reduceRight(
    (D, T) => /* @__PURE__ */ f.jsx(T, Te(G({}, R), { children: D })),
    /* @__PURE__ */ f.jsx(a.Provider, G({}, R))
  );
  return {
    context: a,
    scopedContext: i,
    useContext: h,
    useScopedContext: g,
    useProviderContext: m,
    ContextProvider: C,
    ScopedContextProvider: (R) => /* @__PURE__ */ f.jsx(C, Te(G({}, R), { children: t.reduceRight(
      (D, T) => /* @__PURE__ */ f.jsx(T, Te(G({}, R), { children: D })),
      /* @__PURE__ */ f.jsx(i.Provider, G({}, R))
    ) }))
  };
}
var B5 = _i(), EE = B5.useContext, AL = B5.useProviderContext, Uy = B5.ContextProvider, Yy = B5.ScopedContextProvider, kL = "div", LL = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = AL();
    return i = i || g, h = Vn(
      h,
      (m) => /* @__PURE__ */ f.jsx(Yy, { value: i, children: m }),
      [i]
    ), La(h);
  }
), IL = Oe(function(t) {
  const a = LL(t);
  return Ae(kL, a);
});
function HL(e = {}) {
  const t = RE(e);
  return /* @__PURE__ */ f.jsx(Uy, { value: t, children: e.children });
}
var ZL = "div", gh = ke(
  function(t) {
    var a = t, {
      store: i,
      shouldRegisterItem: h = !0,
      getItem: g = dE,
      element: m
    } = a, C = Fe(a, [
      "store",
      "shouldRegisterItem",
      "getItem",
      // @ts-expect-error This prop may come from a collection renderer.
      "element"
    ]);
    const S = EE();
    i = i || S;
    const R = Ia(C.id), D = Pt(m);
    return gt(() => {
      const T = D.current;
      if (!R || !T || !h)
        return;
      const j = g({ id: R, element: T });
      return i == null ? void 0 : i.renderItem(j);
    }, [R, h, g, i]), C = Te(G({}, C), {
      ref: An(D, C.ref)
    }), La(C);
  }
), PL = Oe(function(t) {
  const a = gh(t);
  return Ae(ZL, a);
});
function VL(e = {}) {
  var t;
  mh(e, e.store);
  const a = (t = e.store) == null ? void 0 : t.getState(), i = {
    value: st(
      e.value,
      a == null ? void 0 : a.value,
      e.defaultValue,
      !1
    )
  }, h = fo(i, e.store);
  return mn(_t({}, h), {
    setValue: (g) => h.setState("value", g)
  });
}
function NL(e, t, a) {
  return _1(t, [a.store]), ir(e, a, "value", "setValue"), e;
}
function Y4(e = {}) {
  const [t, a] = bi(VL, e);
  return NL(t, a, e);
}
var ME = _i(), TE = ME.useContext, BL = ME.ContextProvider, OE = ka(!1), DE = ka(!0), $y = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function FL(e) {
  return parseInt(e.getAttribute("tabindex") || "0", 10) < 0;
}
function A0(e) {
  return !(!Ay(e, $y) || !vE(e) || pE(e, "[inert]"));
}
function I4(e) {
  if (!A0(e) || FL(e))
    return !1;
  if (!("form" in e) || !e.form || e.checked || e.type !== "radio")
    return !0;
  const t = e.form.elements.namedItem(e.name);
  if (!t || !("length" in t))
    return !0;
  const a = gf(e);
  return !a || a === e || !("form" in a) || a.form !== e.form || a.name !== e.name;
}
function Wy(e, t) {
  const a = Array.from(
    e.querySelectorAll($y)
  );
  t && a.unshift(e);
  const i = a.filter(A0);
  return i.forEach((h, g) => {
    if (jy(h) && h.contentDocument) {
      const m = h.contentDocument.body;
      i.splice(g, 1, ...Wy(m));
    }
  }), i;
}
function Lp(e, t, a) {
  const i = Array.from(
    e.querySelectorAll($y)
  ), h = i.filter(I4);
  return t && I4(e) && h.unshift(e), h.forEach((g, m) => {
    if (jy(g) && g.contentDocument) {
      const C = g.contentDocument.body, S = Lp(
        C,
        !1,
        a
      );
      h.splice(m, 1, ...S);
    }
  }), !h.length && a ? i : h;
}
function F5(e, t, a) {
  const [i] = Lp(
    e,
    t,
    a
  );
  return i || null;
}
function UL(e, t, a, i) {
  const h = gf(e), g = Wy(e, t), m = g.indexOf(h), C = g.slice(m + 1);
  return C.find(I4) || (a ? g.find(I4) : null) || (i ? C[0] : null) || null;
}
function _8(e, t) {
  return UL(
    document.body,
    !1,
    e,
    t
  );
}
function YL(e, t, a, i) {
  const h = gf(e), g = Wy(e, t).reverse(), m = g.indexOf(h);
  return g.slice(m + 1).find(I4) || null || null || null;
}
function T_(e, t) {
  return YL(
    document.body,
    !1
  );
}
function H2(e) {
  const t = gf(e);
  if (!t)
    return !1;
  if (t === e)
    return !0;
  const a = t.getAttribute("aria-activedescendant");
  return a ? a === e.id : !1;
}
function uh(e) {
  const t = gf(e);
  if (!t)
    return !1;
  if (ha(e, t))
    return !0;
  const a = t.getAttribute("aria-activedescendant");
  return !a || !("id" in e) ? !1 : a === e.id ? !0 : !!e.querySelector(`#${CSS.escape(a)}`);
}
function jE(e) {
  !uh(e) && A0(e) && e.focus();
}
function $L(e) {
  var t;
  const a = (t = e.getAttribute("tabindex")) != null ? t : "";
  e.setAttribute("data-tabindex", a), e.setAttribute("tabindex", "-1");
}
function yp(e, t) {
  Lp(e, t).forEach($L);
}
function _5(e) {
  const t = e.querySelectorAll("[data-tabindex]"), a = (i) => {
    const h = i.getAttribute("data-tabindex");
    i.removeAttribute("data-tabindex"), h ? i.setAttribute("tabindex", h) : i.removeAttribute("tabindex");
  };
  e.hasAttribute("data-tabindex") && a(e), t.forEach(a);
}
function WL(e, t) {
  "scrollIntoView" in e ? (e.focus({ preventScroll: !0 }), e.scrollIntoView(_t({ block: "nearest", inline: "nearest" }, t))) : e.focus();
}
var zL = "div", O_ = Hy(), qL = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
function GL(e) {
  const { tagName: t, readOnly: a, type: i } = e;
  return t === "TEXTAREA" && !a || t === "SELECT" && !a ? !0 : t === "INPUT" && !a ? qL.includes(i) : !!e.isContentEditable;
}
function KL(e) {
  return e.getAttribute("role") !== "combobox" ? !1 : !!e.dataset.name;
}
function QL(e) {
  return "labels" in e ? e.labels : null;
}
function D_(e) {
  return e.tagName.toLowerCase() === "input" && e.type ? e.type === "radio" || e.type === "checkbox" : !1;
}
function XL(e) {
  return e ? e === "button" || e === "summary" || e === "input" || e === "select" || e === "textarea" || e === "a" : !0;
}
function JL(e) {
  return e ? e === "button" || e === "input" || e === "select" || e === "textarea" : !0;
}
function eI(e, t, a, i, h) {
  return e ? t ? a && !i ? -1 : void 0 : a ? h : h || 0 : h;
}
function R8(e, t) {
  return rt((a) => {
    e == null || e(a), !a.defaultPrevented && t && (a.stopPropagation(), a.preventDefault());
  });
}
var zy = !0;
function tI(e) {
  const t = e.target;
  t && "hasAttribute" in t && (t.hasAttribute("data-focus-visible") || (zy = !1));
}
function nI(e) {
  e.metaKey || e.ctrlKey || e.altKey || (zy = !0);
}
var N2 = ke(
  function(t) {
    var a = t, {
      focusable: i = !0,
      accessibleWhenDisabled: h,
      autoFocus: g,
      onFocusVisible: m
    } = a, C = Fe(a, [
      "focusable",
      "accessibleWhenDisabled",
      "autoFocus",
      "onFocusVisible"
    ]);
    const S = Pt(null);
    gt(() => {
      i && (Uo("mousedown", tI, !0), Uo("keydown", nI, !0));
    }, [i]), O_ && gt(() => {
      if (!i)
        return;
      const be = S.current;
      if (!be || !D_(be))
        return;
      const Ue = QL(be);
      if (!Ue)
        return;
      const ie = () => queueMicrotask(() => be.focus());
      return Ue.forEach((_e) => _e.addEventListener("mouseup", ie)), () => {
        Ue.forEach(
          (_e) => _e.removeEventListener("mouseup", ie)
        );
      };
    }, [i]);
    const R = i && mf(C), D = !!R && !h, [T, j] = Qt(!1);
    gt(() => {
      i && D && T && j(!1);
    }, [i, D, T]), gt(() => {
      if (!i || !T)
        return;
      const be = S.current;
      if (!be || typeof IntersectionObserver > "u")
        return;
      const Ue = new IntersectionObserver(() => {
        A0(be) || j(!1);
      });
      return Ue.observe(be), () => Ue.disconnect();
    }, [i, T]);
    const A = R8(
      C.onKeyPressCapture,
      R
    ), L = R8(
      C.onMouseDownCapture,
      R
    ), P = R8(C.onClickCapture, R), V = C.onMouseDown, F = rt((be) => {
      if (V == null || V(be), be.defaultPrevented || !i)
        return;
      const Ue = be.currentTarget;
      if (!O_ || mE(be) || !L0(Ue) && !D_(Ue))
        return;
      let ie = !1;
      const _e = () => {
        ie = !0;
      }, Ze = { capture: !0, once: !0 };
      Ue.addEventListener("focusin", _e, Ze), L2(Ue, "mouseup", () => {
        Ue.removeEventListener("focusin", _e, !0), !ie && jE(Ue);
      });
    }), Y = (be, Ue) => {
      if (Ue && (be.currentTarget = Ue), !i)
        return;
      const ie = be.currentTarget;
      ie && H2(ie) && (m == null || m(be), !be.defaultPrevented && j(!0));
    }, W = C.onKeyDownCapture, Q = rt((be) => {
      if (W == null || W(be), be.defaultPrevented || !i || T || be.metaKey || be.altKey || be.ctrlKey || !Ci(be))
        return;
      const Ue = be.currentTarget;
      queueMicrotask(() => Y(be, Ue));
    }), $ = C.onFocusCapture, le = rt((be) => {
      if ($ == null || $(be), be.defaultPrevented || !i)
        return;
      if (!Ci(be)) {
        j(!1);
        return;
      }
      const Ue = be.currentTarget, ie = () => Y(be, Ue);
      zy || GL(be.target) ? queueMicrotask(ie) : KL(be.target) ? L2(be.target, "focusout", ie) : j(!1);
    }), te = C.onBlur, Se = rt((be) => {
      te == null || te(be), i && rh(be) && j(!1);
    }), re = Yo(DE), ve = rt((be) => {
      i && g && be && re && queueMicrotask(() => {
        H2(be) || A0(be) && be.focus();
      });
    }), K = ph(S), de = i && XL(K), fe = i && JL(K), xe = C.style, Le = Lr(() => D ? G({ pointerEvents: "none" }, xe) : xe, [D, xe]);
    return C = Te(G({
      "data-focus-visible": i && T || void 0,
      "data-autofocus": g || void 0,
      "aria-disabled": R || void 0
    }, C), {
      ref: An(S, ve, C.ref),
      style: Le,
      tabIndex: eI(
        i,
        D,
        de,
        fe,
        C.tabIndex
      ),
      disabled: fe && D ? !0 : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: R ? void 0 : C.contentEditable,
      onKeyPressCapture: A,
      onClickCapture: P,
      onMouseDownCapture: L,
      onMouseDown: F,
      onKeyDownCapture: Q,
      onFocusCapture: le,
      onBlur: Se
    }), La(C);
  }
), rI = Oe(function(t) {
  const a = N2(t);
  return Ae(zL, a);
}), aI = "button";
function j_(e) {
  if (!e.isTrusted)
    return !1;
  const t = e.currentTarget;
  return e.key === "Enter" ? L0(t) || t.tagName === "SUMMARY" || t.tagName === "A" : e.key === " " ? L0(t) || t.tagName === "SUMMARY" || t.tagName === "INPUT" || t.tagName === "SELECT" : !1;
}
var oI = Symbol("command"), U5 = ke(
  function(t) {
    var a = t, { clickOnEnter: i = !0, clickOnSpace: h = !0 } = a, g = Fe(a, ["clickOnEnter", "clickOnSpace"]);
    const m = Pt(null), C = ph(m), S = g.type, [R, D] = Qt(
      () => !!C && L0({ tagName: C, type: S })
    );
    gt(() => {
      m.current && D(L0(m.current));
    }, []);
    const [T, j] = Qt(!1), A = Pt(!1), L = mf(g), [P, V] = xE(g, oI, !0), F = g.onKeyDown, Y = rt(($) => {
      F == null || F($);
      const le = $.currentTarget;
      if ($.defaultPrevented || P || L || !Ci($) || bl(le) || le.isContentEditable)
        return;
      const te = i && $.key === "Enter", Se = h && $.key === " ", re = $.key === "Enter" && !i, ve = $.key === " " && !h;
      if (re || ve) {
        $.preventDefault();
        return;
      }
      if (te || Se) {
        const K = j_($);
        if (te) {
          if (!K) {
            $.preventDefault();
            const de = $, fe = Fe(de, ["view"]), xe = () => y_(le, fe);
            hL() ? L2(le, "keyup", xe) : queueMicrotask(xe);
          }
        } else Se && (A.current = !0, K || ($.preventDefault(), j(!0)));
      }
    }), W = g.onKeyUp, Q = rt(($) => {
      if (W == null || W($), $.defaultPrevented || P || L || $.metaKey)
        return;
      const le = h && $.key === " ";
      if (A.current && le && (A.current = !1, !j_($))) {
        $.preventDefault(), j(!1);
        const te = $.currentTarget, Se = $, re = Fe(Se, ["view"]);
        queueMicrotask(() => y_(te, re));
      }
    });
    return g = Te(G(G({
      "data-active": T || void 0,
      type: R ? "button" : void 0
    }, V), g), {
      ref: An(m, g.ref),
      onKeyDown: Y,
      onKeyUp: Q
    }), g = N2(g), g;
  }
), iI = Oe(function(t) {
  const a = U5(t);
  return Ae(aI, a);
}), AE = "input";
function A_(e, t) {
  t ? e.indeterminate = !0 : e.indeterminate && (e.indeterminate = !1);
}
function lI(e, t) {
  return e === "input" && (!t || t === "checkbox");
}
function k_(e) {
  return Array.isArray(e) ? e.toString() : e;
}
var qy = ke(
  function(t) {
    var a = t, {
      store: i,
      name: h,
      value: g,
      checked: m,
      defaultChecked: C
    } = a, S = Fe(a, [
      "store",
      "name",
      "value",
      "checked",
      "defaultChecked"
    ]);
    const R = TE();
    i = i || R;
    const [D, T] = Qt(C ?? !1), j = ja(i, (re) => {
      if (m !== void 0)
        return m;
      if ((re == null ? void 0 : re.value) === void 0)
        return D;
      if (g != null) {
        if (Array.isArray(re.value)) {
          const ve = k_(g);
          return re.value.includes(ve);
        }
        return re.value === g;
      }
      return Array.isArray(re.value) ? !1 : typeof re.value == "boolean" ? re.value : !1;
    }), A = Pt(null), L = ph(A, AE), P = lI(L, S.type), V = j ? j === "mixed" : void 0, F = j === "mixed" ? !1 : j, Y = mf(S), [W, Q] = P5();
    gt(() => {
      const re = A.current;
      re && (A_(re, V), !P && (re.checked = F, h !== void 0 && (re.name = h), g !== void 0 && (re.value = `${g}`)));
    }, [W, V, P, F, h, g]);
    const $ = S.onChange, le = rt((re) => {
      if (Y) {
        re.stopPropagation(), re.preventDefault();
        return;
      }
      if (A_(re.currentTarget, V), P || (re.currentTarget.checked = !re.currentTarget.checked, Q()), $ == null || $(re), re.defaultPrevented)
        return;
      const ve = re.currentTarget.checked;
      T(ve), i == null || i.setValue((K) => {
        if (g == null)
          return ve;
        const de = k_(g);
        return Array.isArray(K) ? ve ? K.includes(de) ? K : [...K, de] : K.filter((fe) => fe !== de) : K === de ? !1 : de;
      });
    }), te = S.onClick, Se = rt((re) => {
      te == null || te(re), !re.defaultPrevented && (P || le(re));
    });
    return S = Vn(
      S,
      (re) => /* @__PURE__ */ f.jsx(OE.Provider, { value: F, children: re }),
      [F]
    ), S = Te(G({
      role: P ? void 0 : "checkbox",
      type: P ? "checkbox" : void 0,
      "aria-checked": j
    }, S), {
      ref: An(A, S.ref),
      onChange: le,
      onClick: Se
    }), S = U5(G({ clickOnEnter: !P }, S)), La(G({
      name: P ? h : void 0,
      value: P ? g : void 0,
      checked: F
    }, S));
  }
), kE = Oe(function(t) {
  const a = qy(t);
  return Ae(AE, a);
});
function uI(e = {}) {
  const t = Y4(e);
  return /* @__PURE__ */ f.jsx(BL, { value: t, children: e.children });
}
var sI = "span", cI = /* @__PURE__ */ f.jsx(
  "svg",
  {
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    children: /* @__PURE__ */ f.jsx("polyline", { points: "4,8 7,12 12,4" })
  }
);
function fI(e) {
  return e.checked ? e.children || cI : typeof e.children == "function" ? e.children : null;
}
var Y5 = ke(
  function(t) {
    var a = t, { checked: i } = a, h = Fe(a, ["store", "checked"]);
    const g = Yo(OE);
    i = i ?? g;
    const m = fI({ checked: i, children: h.children });
    return h = Te(G({
      "aria-hidden": !0
    }, h), {
      children: m,
      style: G({
        width: "1em",
        height: "1em",
        pointerEvents: "none"
      }, h.style)
    }), La(h);
  }
), dI = Oe(function(t) {
  const a = Y5(t);
  return Ae(sI, a);
}), LE = "button", wh = ke(
  function(t) {
    const a = Pt(null), i = ph(a, LE), [h, g] = Qt(
      () => !!i && L0({ tagName: i, type: t.type })
    );
    return gt(() => {
      a.current && g(L0(a.current));
    }, []), t = Te(G({
      role: !h && i !== "a" ? "button" : void 0
    }, t), {
      ref: An(a, t.ref)
    }), t = U5(t), t;
  }
), $5 = Oe(function(t) {
  const a = wh(t);
  return Ae(LE, a);
});
function L_() {
  return new Promise((e) => requestAnimationFrame(() => e()));
}
function d5(e) {
  return Object.keys(e).some((t) => b5(e[t]) ? d5(e[t]) : !!e[t]);
}
function of(e, t, a) {
  var i;
  const [h, ...g] = Array.isArray(t) ? t : `${t}`.split(".");
  return h == null || !e ? a : g.length ? of(e[h], g, a) : (i = e[h]) != null ? i : a;
}
function gp(e, t, a) {
  const [i, ...h] = Array.isArray(t) ? t : `${t}`.split(".");
  if (i == null)
    return e;
  const g = i, m = tL(g), S = (m ? e || [] : e || {})[g], R = h.length && (Array.isArray(S) || b5(S)) ? gp(S, h, a) : a;
  if (m) {
    const D = Number(g);
    if (e && Array.isArray(e))
      return [
        ...e.slice(0, D),
        R,
        ...e.slice(D + 1)
      ];
    const T = [];
    return T[D] = R, T;
  }
  return mn(_t({}, e), { [g]: R });
}
function X8(e, t) {
  const a = {}, i = Object.keys(e);
  for (const h of i) {
    const g = e[h];
    Array.isArray(g) ? a[h] = g.map((m) => b5(m) ? X8(m, t) : t) : b5(g) ? a[h] = X8(g, t) : a[h] = t;
  }
  return a;
}
function IE(e, t = []) {
  return {
    get(i, h) {
      if (["toString", "valueOf", Symbol.toPrimitive].includes(h))
        return () => t.join(".");
      const g = [...t, h], m = g.join(".");
      if (e[m])
        return e[m];
      const C = new Proxy(i, IE(e, g));
      return e[m] = C, C;
    }
  };
}
function hI(e) {
  return e == null ? void 0 : e.__unstableCallbacks;
}
function vI() {
  const e = /* @__PURE__ */ Object.create(null);
  return new Proxy(/* @__PURE__ */ Object.create(null), IE(e));
}
function pI(e = {}) {
  var t;
  mh(e, e.store);
  const a = (t = e.store) == null ? void 0 : t.getState(), i = N5(e), h = st(
    e.values,
    a == null ? void 0 : a.values,
    e.defaultValues,
    {}
  ), g = st(
    e.errors,
    a == null ? void 0 : a.errors,
    e.defaultErrors,
    {}
  ), m = st(
    e.touched,
    a == null ? void 0 : a.touched,
    e.defaultTouched,
    {}
  ), C = mn(_t({}, i.getState()), {
    values: h,
    errors: g,
    touched: m,
    validating: st(a == null ? void 0 : a.validating, !1),
    submitting: st(a == null ? void 0 : a.submitting, !1),
    submitSucceed: st(a == null ? void 0 : a.submitSucceed, 0),
    submitFailed: st(a == null ? void 0 : a.submitFailed, 0),
    valid: !d5(g)
  }), S = fo(C, i, e.store), R = hI(e.store), D = R == null ? void 0 : R.getState(), T = {
    validate: (D == null ? void 0 : D.validate) || [],
    submit: (D == null ? void 0 : D.submit) || []
  }, j = fo(T, R);
  Aa(S, () => V5(j));
  const A = async () => {
    S.setState("validating", !0), S.setState("errors", {});
    const L = j.getState().validate;
    try {
      for (const P of L)
        await P(S.getState());
      return await L_(), !d5(S.getState().errors);
    } finally {
      S.setState("validating", !1);
    }
  };
  return mn(_t(_t({}, i), S), {
    names: vI(),
    setValues: (L) => S.setState("values", L),
    getValue: (L) => of(S.getState().values, L),
    setValue: (L, P) => S.setState("values", (V) => {
      const F = of(V, L), Y = O4(P, F);
      return Y === F ? V : gp(V, L, Y);
    }),
    pushValue: (L, P) => S.setState("values", (V) => {
      const F = of(V, L, []);
      return gp(V, L, [...F, P]);
    }),
    removeValue: (L, P) => S.setState("values", (V) => {
      const F = of(V, L, []);
      return gp(V, L, [
        ...F.slice(0, P),
        null,
        ...F.slice(P + 1)
      ]);
    }),
    setErrors: (L) => S.setState("errors", L),
    getError: (L) => of(S.getState().errors, L),
    setError: (L, P) => S.setState("errors", (V) => {
      const F = of(V, L), Y = O4(P, F);
      return Y === F ? V : gp(V, L, Y);
    }),
    setTouched: (L) => S.setState("touched", L),
    getFieldTouched: (L) => !!of(S.getState().touched, L),
    setFieldTouched: (L, P) => S.setState("touched", (V) => {
      const F = of(V, L), Y = O4(P, F);
      return Y === F ? V : gp(V, L, Y);
    }),
    onValidate: (L) => (j.setState("validate", (P) => [...P, L]), () => {
      j.setState(
        "validate",
        (P) => P.filter((V) => V !== L)
      );
    }),
    validate: A,
    onSubmit: (L) => (j.setState("submit", (P) => [...P, L]), () => {
      j.setState(
        "submit",
        (P) => P.filter((V) => V !== L)
      );
    }),
    submit: async () => {
      S.setState("submitting", !0), S.setState("touched", X8(S.getState().values, !0));
      try {
        if (await A()) {
          const L = j.getState().submit;
          for (const P of L)
            await P(S.getState());
          if (await L_(), !d5(S.getState().errors))
            return S.setState("submitSucceed", (P) => P + 1), !0;
        }
        return S.setState("submitFailed", (L) => L + 1), !1;
      } catch (L) {
        throw S.setState("submitFailed", (P) => P + 1), L;
      } finally {
        S.setState("submitting", !1);
      }
    },
    reset: () => {
      S.setState("values", h), S.setState("errors", g), S.setState("touched", m), S.setState("validating", !1), S.setState("submitting", !1), S.setState("submitSucceed", 0), S.setState("submitFailed", 0);
    },
    // @ts-expect-error Internal
    __unstableCallbacks: j
  });
}
function mI(e, t, a) {
  e = Fy(e, t, a), ir(e, a, "values", "setValues"), ir(e, a, "errors", "setErrors"), ir(e, a, "touched", "setTouched");
  const i = Ir(
    (m) => e.useState(() => e.getValue(m)),
    [e]
  ), h = Ir(
    (m) => {
      m = rt(m);
      const C = e.useState("items");
      gt(() => e.onValidate(m), [C, m]);
    },
    [e]
  ), g = Ir(
    (m) => {
      m = rt(m);
      const C = e.useState("items");
      gt(() => e.onSubmit(m), [C, m]);
    },
    [e]
  );
  return Lr(
    () => Te(G({}, e), {
      useValue: i,
      useValidate: h,
      useSubmit: g
    }),
    []
  );
}
function Gy(e = {}) {
  const [t, a] = bi(pI, e);
  return mI(t, a, e);
}
var Ky = _i(
  [Uy],
  [Yy]
), Rl = Ky.useContext, gI = Ky.ContextProvider, wI = Ky.ScopedContextProvider, HE = "form";
function yI(e, t) {
  return t.some(
    (a) => a.type === "field" && a.element === e
  );
}
function xI(e) {
  return e.find(
    (t) => {
      var a;
      return t.type === "field" && ((a = t.element) == null ? void 0 : a.getAttribute("aria-invalid")) === "true";
    }
  );
}
var SI = ke(function(t) {
  var a = t, {
    store: i,
    validateOnChange: h = !0,
    validateOnBlur: g = !0,
    resetOnUnmount: m = !1,
    resetOnSubmit: C = !0,
    autoFocusOnSubmit: S = !0
  } = a, R = Fe(a, [
    "store",
    "validateOnChange",
    "validateOnBlur",
    "resetOnUnmount",
    "resetOnSubmit",
    "autoFocusOnSubmit"
  ]);
  const D = Rl();
  i = i || D, Zt(
    i,
    process.env.NODE_ENV !== "production" && "Form must receive a `store` prop or be wrapped in a FormProvider component."
  );
  const T = Pt(null), j = i.useState("values"), A = i.useState("submitSucceed"), L = i.useState("submitFailed"), P = i.useState("items"), V = Vy(j);
  gt(
    () => m ? i == null ? void 0 : i.reset : void 0,
    [m, i]
  ), _1(() => {
    h && j !== V && (i == null || i.validate());
  }, [h, j, V, i]), gt(() => {
    C && A && (i == null || i.reset());
  }, [C, A, i]);
  const [F, Y] = Qt(!1);
  gt(() => {
    if (!F || !L)
      return;
    const ve = xI(P), K = ve == null ? void 0 : ve.element;
    K && (Y(!1), K.focus(), bl(K) && K.select());
  }, [S, L, P]);
  const W = R.onSubmit, Q = rt((ve) => {
    W == null || W(ve), !ve.defaultPrevented && (ve.preventDefault(), i == null || i.submit(), S && Y(!0));
  }), $ = R.onBlur, le = rt((ve) => {
    $ == null || $(ve), !ve.defaultPrevented && g && i && yI(ve.target, i.getState().items) && i.validate();
  }), te = R.onReset, Se = rt((ve) => {
    te == null || te(ve), !ve.defaultPrevented && (ve.preventDefault(), i == null || i.reset());
  });
  R = Vn(
    R,
    (ve) => /* @__PURE__ */ f.jsx(wI, { value: i, children: ve }),
    [i]
  );
  const re = ph(T, HE);
  return R = Te(G({
    role: re !== "form" ? "form" : void 0,
    noValidate: !0
  }, R), {
    ref: An(T, R.ref),
    onSubmit: Q,
    onBlur: le,
    onReset: Se
  }), R;
}), ZE = Oe(function(t) {
  const a = SI(t);
  return Ae(HE, a);
});
function PE(e = {}) {
  const t = Gy(e);
  return /* @__PURE__ */ f.jsx(gI, { value: t, children: e.children });
}
var CI = "input";
function bI(e, t) {
  const a = e.current;
  return a ? a.name === t ? a : a.form ? a.form.elements.namedItem(t) : Qr(a).getElementsByName(t)[0] : null;
}
function E8(e, t, a) {
  return e.useState(
    (i) => i.items.find((h) => h.type === a && h.name === t)
  );
}
var $4 = ke(
  function(t) {
    var a = t, {
      store: i,
      name: h,
      getItem: g,
      touchOnBlur: m = !0
    } = a, C = Fe(a, [
      "store",
      "name",
      "getItem",
      "touchOnBlur"
    ]);
    const S = Rl();
    i = i || S, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormControl must be wrapped in a Form component."
    );
    const R = `${h}`, D = Ia(C.id), T = Pt(null);
    i.useValidate(async () => {
      const $ = bI(T, R);
      $ && (await Promise.resolve(), "validity" in $ && !$.validity.valid && (i == null || i.setError(R, $.validationMessage)));
    });
    const j = Ir(
      ($) => {
        const le = Te(G({}, $), { id: D || $.id, name: R, type: "field" });
        return g ? g(le) : le;
      },
      [D, R, g]
    ), A = C.onBlur, L = er(m), P = rt(($) => {
      A == null || A($), !$.defaultPrevented && L($) && (i == null || i.setFieldTouched(R, !0));
    }), V = E8(i, R, "label"), F = E8(i, R, "error"), Y = E8(i, R, "description"), W = nL(
      F == null ? void 0 : F.id,
      Y == null ? void 0 : Y.id,
      C["aria-describedby"]
    ), Q = i.useState(
      () => !!(i != null && i.getError(R)) && i.getFieldTouched(R)
    );
    return C = Te(G({
      id: D,
      "aria-labelledby": V == null ? void 0 : V.id,
      "aria-invalid": Q
    }, C), {
      "aria-describedby": W || void 0,
      ref: An(T, C.ref),
      onBlur: P
    }), C = gh(Te(G({ store: i }, C), { name: R, getItem: j })), C;
  }
), _I = Ha(
  Oe(function(t) {
    const a = $4(t);
    return Ae(CI, a);
  })
), RI = "input", EI = ke(
  function(t) {
    var a = t, {
      store: i,
      name: h,
      value: g,
      checked: m
    } = a, C = Fe(a, [
      "store",
      "name",
      "value",
      "checked",
      "defaultChecked"
    ]);
    const S = Rl();
    i = i || S, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormCheckbox must be wrapped in a Form component."
    );
    const R = `${h}`, D = Y4({
      value: i.useValue(R),
      setValue: (T) => i == null ? void 0 : i.setValue(R, T)
    });
    return C = qy(G({ store: D, value: g, checked: m }, C)), C = $4(G({
      store: i,
      name: R,
      "aria-labelledby": void 0
    }, C)), C;
  }
), MI = Ha(
  Oe(function(t) {
    const a = EI(t);
    return Ae(RI, a);
  })
), TI = "div", OI = ke(
  function(t) {
    var a = t, {
      store: i,
      name: h,
      getItem: g
    } = a, m = Fe(a, [
      "store",
      "name",
      "getItem"
    ]);
    const C = Rl();
    i = i || C, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormDescription must be wrapped in a Form component."
    );
    const S = Ia(m.id), R = Pt(null), D = `${h}`, T = Ir(
      (j) => {
        const A = Te(G({}, j), {
          id: S || j.id,
          name: D,
          type: "description"
        });
        return g ? g(A) : A;
      },
      [S, D, g]
    );
    return m = Te(G({
      id: S
    }, m), {
      ref: An(R, m.ref)
    }), m = gh(Te(G({ store: i }, m), { getItem: T })), m;
  }
), DI = Ha(
  Oe(function(t) {
    const a = OI(t);
    return Ae(TI, a);
  })
), jI = "div", AI = ke(
  function(t) {
    var a = t, {
      store: i,
      name: h,
      getItem: g
    } = a, m = Fe(a, [
      "store",
      "name",
      "getItem"
    ]);
    const C = Rl();
    i = i || C, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormError must be wrapped in a Form component."
    );
    const S = Ia(m.id), R = Pt(null), D = `${h}`, T = Ir(
      (A) => {
        const L = Te(G({}, A), { id: S || A.id, name: D, type: "error" });
        return g ? g(L) : L;
      },
      [S, D, g]
    ), j = i.useState(() => {
      const A = i == null ? void 0 : i.getError(D);
      if (A != null && i != null && i.getFieldTouched(D))
        return A;
    });
    return m = Te(G({
      id: S,
      role: "alert",
      children: j
    }, m), {
      ref: An(R, m.ref)
    }), m = gh(Te(G({ store: i }, m), { getItem: T })), m;
  }
), VE = Ha(
  Oe(function(t) {
    const a = AI(t);
    return Ae(jI, a);
  })
), kI = "input", LI = ke(
  function(t) {
    return $4(t);
  }
), II = Ha(
  Oe(function(t) {
    const a = LI(t);
    return Ae(kI, a);
  })
), NE = ka(void 0), HI = "div", Qy = ke(
  function(t) {
    const a = Yo(NE), i = Ia(t.id);
    return jn(() => (a == null || a(i), () => a == null ? void 0 : a(void 0)), [a, i]), t = G({
      id: i,
      "aria-hidden": !0
    }, t), La(t);
  }
), ZI = Oe(function(t) {
  const a = Qy(t);
  return Ae(HI, a);
}), PI = "div", VI = ke(
  function(t) {
    var a = t, i = Fe(a, ["store"]);
    return i = Qy(i), i;
  }
), NI = Oe(function(t) {
  const a = VI(t);
  return Ae(PI, a);
}), BI = "div", Xy = ke(
  function(t) {
    const [a, i] = Qt();
    return t = Vn(
      t,
      (h) => /* @__PURE__ */ f.jsx(NE.Provider, { value: i, children: h }),
      []
    ), t = G({
      role: "group",
      "aria-labelledby": a
    }, t), La(t);
  }
), FI = Oe(function(t) {
  const a = Xy(t);
  return Ae(BI, a);
}), UI = "div", BE = ke(
  function(t) {
    var a = t, i = Fe(a, ["store"]);
    return i = Xy(i), i;
  }
), YI = Oe(function(t) {
  const a = BE(t);
  return Ae(UI, a);
}), $I = "input", WI = ke(
  function(t) {
    var a = t, { store: i, name: h } = a, g = Fe(a, ["store", "name"]);
    const m = Rl();
    i = i || m, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormInput must be wrapped in a Form component."
    );
    const C = `${h}`, S = g.onChange, R = rt((T) => {
      S == null || S(T), !T.defaultPrevented && (i == null || i.setValue(C, T.target.value));
    }), D = i.useValue(C);
    return g = Te(G({
      value: D
    }, g), {
      onChange: R
    }), g = N2(g), g = $4(G({ store: i, name: C }, g)), g;
  }
), Jy = Ha(
  Oe(function(t) {
    const a = WI(t);
    return Ae($I, a);
  })
), zI = "label";
function qI(e) {
  return e === "input" || e === "textarea" || e === "select" || e === "meter" || e === "progress";
}
var GI = ke(
  function(t) {
    var a = t, {
      store: i,
      name: h,
      getItem: g
    } = a, m = Fe(a, [
      "store",
      "name",
      "getItem"
    ]);
    const C = Rl();
    i = i || C, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormLabel must be wrapped in a Form component."
    );
    const S = Ia(m.id), R = Pt(null), D = `${h}`, T = Ir(
      (F) => {
        const Y = Te(G({}, F), { id: S || F.id, name: D, type: "label" });
        return g ? g(Y) : Y;
      },
      [S, D, g]
    ), j = i.useState(
      (F) => F.items.find((Y) => Y.type === "field" && Y.name === D)
    ), A = ph(j == null ? void 0 : j.element, "input"), L = qI(A), P = m.onClick, V = rt((F) => {
      if (P == null || P(F), F.defaultPrevented || L)
        return;
      const Y = j == null ? void 0 : j.element;
      Y && queueMicrotask(() => {
        const W = F5(Y, !0, !0);
        W == null || W.focus(), W == null || W.click();
      });
    });
    return m = Te(G({
      id: S,
      render: L ? /* @__PURE__ */ f.jsx("label", {}) : /* @__PURE__ */ f.jsx("span", {}),
      htmlFor: L ? j == null ? void 0 : j.id : void 0
    }, m), {
      ref: An(R, m.ref),
      onClick: V
    }), L || (m = Te(G({}, m), {
      style: G({
        cursor: "default"
      }, m.style)
    })), m = gh(Te(G({ store: i }, m), { getItem: T })), m;
  }
), FE = Ha(
  Oe(function(t) {
    const a = GI(t);
    return Ae(zI, a);
  })
), KI = "button";
function QI(e, t) {
  if (!e)
    return [];
  const a = [];
  for (const i of e) {
    if (i.type !== "field" || !i.name.startsWith(t))
      continue;
    const h = i.name.replace(/(\.\d+)\..+$/, "$1"), g = new RegExp(`^${h}`);
    a.some((m) => g.test(m.name)) || a.push(i);
  }
  return a;
}
var XI = ke(
  function(t) {
    var a = t, {
      store: i,
      value: h,
      name: g,
      getItem: m,
      autoFocusOnClick: C = !0
    } = a, S = Fe(a, [
      "store",
      "value",
      "name",
      "getItem",
      "autoFocusOnClick"
    ]);
    const R = Rl();
    i = i || R, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormPush must be wrapped in a Form component."
    );
    const D = `${g}`, [T, j] = Qt(!1);
    gt(() => {
      var V;
      if (!T)
        return;
      const F = QI(i == null ? void 0 : i.getState().items, D), Y = (V = F == null ? void 0 : F[F.length - 1]) == null ? void 0 : V.element;
      Y && (Y.focus(), j(!1));
    }, [i, T, D]);
    const A = Ir(
      (V) => {
        const F = Te(G({}, V), { type: "button", name: D });
        return m ? m(F) : F;
      },
      [D, m]
    ), L = S.onClick, P = rt((V) => {
      L == null || L(V), !V.defaultPrevented && (i == null || i.pushValue(D, h), C && j(!0));
    });
    return S = Te(G({}, S), {
      onClick: P
    }), S = wh(S), S = gh(Te(G({ store: i }, S), { getItem: A })), S;
  }
), JI = Oe(function(t) {
  const a = XI(t);
  return Ae(KI, a);
}), eH = "div", tH = ke(
  function(t) {
    var a = t, i = Fe(a, ["store"]);
    return i = G({ role: "radiogroup" }, i), i = BE(i), i;
  }
), nH = Oe(function(t) {
  const a = tH(t);
  return Ae(eH, a);
}), W5 = _i(
  [Uy],
  [Yy]
), B2 = W5.useContext, rH = W5.useProviderContext, P0 = W5.ContextProvider, yh = W5.ScopedContextProvider, aH = ka(
  void 0
), UE = ka(
  void 0
), z5 = _i(
  [P0],
  [yh]
), YE = z5.useContext, oH = z5.useProviderContext, iH = z5.ContextProvider, lH = z5.ScopedContextProvider, uH = { id: null };
function sH(e, t, a = !1) {
  const i = e.findIndex((h) => h.id === t);
  return [
    ...e.slice(i + 1),
    ...a ? [uH] : [],
    ...e.slice(0, i)
  ];
}
function cH(e, t) {
  return e.find((a) => !a.disabled);
}
function ah(e, t) {
  return t && e.item(t) || null;
}
function fH(e) {
  const t = [];
  for (const a of e) {
    const i = t.find((h) => {
      var g;
      return ((g = h[0]) == null ? void 0 : g.rowId) === a.rowId;
    });
    i ? i.push(a) : t.push([a]);
  }
  return t;
}
function $E(e, t = !1) {
  if (bl(e))
    e.setSelectionRange(
      t ? e.value.length : 0,
      e.value.length
    );
  else if (e.isContentEditable) {
    const a = Qr(e).getSelection();
    a == null || a.selectAllChildren(e), t && (a == null || a.collapseToEnd());
  }
}
var J8 = Symbol("FOCUS_SILENTLY");
function dH(e) {
  e[J8] = !0, e.focus({ preventScroll: !0 });
}
function hH(e) {
  const t = e[J8];
  return delete e[J8], t;
}
function D4(e, t, a) {
  return !(!t || t === a || !e.item(t.id));
}
var vH = "button";
function pH(e) {
  return q8(e) ? !0 : e.tagName === "INPUT" && !L0(e);
}
function mH(e, t = !1) {
  const a = e.clientHeight, { top: i } = e.getBoundingClientRect(), h = Math.max(a * 0.875, a - 40) * 1.5, g = t ? a - h + i : h + i;
  return e.tagName === "HTML" ? g + e.scrollTop : g;
}
function gH(e, t = !1) {
  const { top: a } = e.getBoundingClientRect();
  return t ? a + e.clientHeight : a;
}
function I_(e, t, a, i = !1) {
  var h;
  if (!t || !a)
    return;
  const { renderedItems: g } = t.getState(), m = Ly(e);
  if (!m)
    return;
  const C = mH(m, i);
  let S, R;
  for (let D = 0; D < g.length; D += 1) {
    const T = S;
    if (S = a(D), !S)
      break;
    if (S === T)
      continue;
    const j = (h = ah(t, S)) == null ? void 0 : h.element;
    if (!j)
      continue;
    const L = gH(j, i) - C, P = Math.abs(L);
    if (i && L <= 0 || !i && L >= 0) {
      R !== void 0 && R < P && (S = T);
      break;
    }
    R = P;
  }
  return S;
}
function wH(e, t) {
  return Ci(e) ? !1 : D4(t, e.target);
}
function yH(e, t) {
  const a = t.role, [i, h] = Qt(a);
  return jn(() => {
    const g = e.current;
    g && h(g.getAttribute("role") || a);
  }, [a]), i;
}
function xH(e) {
  return e === "option" || e === "treeitem";
}
function SH(e) {
  return e === "option" || e === "tab" || e === "treeitem" || e === "gridcell" || e === "row" || e === "columnheader" || e === "rowheader";
}
var F2 = ke(
  function(t) {
    var a = t, {
      store: i,
      rowId: h,
      preventScrollOnKeyDown: g = !1,
      moveOnKeyPress: m = !0,
      tabbable: C = !1,
      getItem: S,
      "aria-setsize": R,
      "aria-posinset": D
    } = a, T = Fe(a, [
      "store",
      "rowId",
      "preventScrollOnKeyDown",
      "moveOnKeyPress",
      "tabbable",
      "getItem",
      "aria-setsize",
      "aria-posinset"
    ]);
    const j = B2();
    i = i || j;
    const A = Ia(T.id), L = Pt(null), P = Yo(UE), V = ja(i, (Pe) => {
      if (h)
        return h;
      if (Pe && P != null && P.baseElement && P.baseElement === Pe.baseElement)
        return P.id;
    }), Y = mf(T) && !T.accessibleWhenDisabled, W = Ir(
      (Pe) => {
        const Vt = Te(G({}, Pe), {
          id: A || Pe.id,
          rowId: V,
          disabled: !!Y
        });
        return S ? S(Vt) : Vt;
      },
      [A, V, Y, S]
    ), Q = T.onFocus, $ = Pt(!1), le = rt((Pe) => {
      if (Q == null || Q(Pe), Pe.defaultPrevented || mE(Pe) || !A || !i || wH(Pe, i))
        return;
      const { virtualFocus: Vt, baseElement: Dt } = i.getState();
      if (i.setActiveId(A), q8(Pe.currentTarget) && $E(Pe.currentTarget), !Vt || !Ci(Pe) || pH(Pe.currentTarget) || !(Dt != null && Dt.isConnected))
        return;
      $.current = !0, Pe.relatedTarget === Dt || D4(i, Pe.relatedTarget) ? dH(Dt) : Dt.focus();
    }), te = T.onBlurCapture, Se = rt((Pe) => {
      if (te == null || te(Pe), Pe.defaultPrevented)
        return;
      const Vt = i == null ? void 0 : i.getState();
      Vt != null && Vt.virtualFocus && $.current && ($.current = !1, Pe.preventDefault(), Pe.stopPropagation());
    }), re = T.onKeyDown, ve = er(g), K = er(m), de = rt((Pe) => {
      if (re == null || re(Pe), Pe.defaultPrevented || !Ci(Pe) || !i)
        return;
      const { currentTarget: Vt } = Pe, Dt = i.getState(), Qe = i.item(A), et = !!(Qe != null && Qe.rowId), wt = Dt.orientation !== "horizontal", St = Dt.orientation !== "vertical", _n = () => !!(et || St || !Dt.baseElement || !bl(Dt.baseElement)), kn = {
        ArrowUp: (et || wt) && i.up,
        ArrowRight: (et || St) && i.next,
        ArrowDown: (et || wt) && i.down,
        ArrowLeft: (et || St) && i.previous,
        Home: () => {
          if (_n())
            return !et || Pe.ctrlKey ? i == null ? void 0 : i.first() : i == null ? void 0 : i.previous(-1);
        },
        End: () => {
          if (_n())
            return !et || Pe.ctrlKey ? i == null ? void 0 : i.last() : i == null ? void 0 : i.next(-1);
        },
        PageUp: () => I_(Vt, i, i == null ? void 0 : i.up, !0),
        PageDown: () => I_(Vt, i, i == null ? void 0 : i.down)
      }[Pe.key];
      if (kn) {
        if (q8(Vt)) {
          const sr = G8(Vt), yr = St && Pe.key === "ArrowLeft", ea = St && Pe.key === "ArrowRight", Ca = wt && Pe.key === "ArrowUp", ft = wt && Pe.key === "ArrowDown";
          if (ea || ft) {
            const { length: fn } = fL(Vt);
            if (sr.end !== fn)
              return;
          } else if ((yr || Ca) && sr.start !== 0)
            return;
        }
        const Wn = kn();
        if (ve(Pe) || Wn !== void 0) {
          if (!K(Pe))
            return;
          Pe.preventDefault(), i.move(Wn);
        }
      }
    }), fe = ja(
      i,
      (Pe) => (Pe == null ? void 0 : Pe.baseElement) || void 0
    ), xe = Lr(
      () => ({ id: A, baseElement: fe }),
      [A, fe]
    );
    T = Vn(
      T,
      (Pe) => /* @__PURE__ */ f.jsx(aH.Provider, { value: xe, children: Pe }),
      [xe]
    );
    const Le = ja(
      i,
      (Pe) => !!Pe && Pe.activeId === A
    ), be = ja(i, "virtualFocus"), Ue = yH(L, T);
    let ie;
    Le && (xH(Ue) || be && SH(Ue)) && (ie = !0);
    const _e = ja(i, (Pe) => {
      if (R != null)
        return R;
      if (Pe && P != null && P.ariaSetSize && P.baseElement === Pe.baseElement)
        return P.ariaSetSize;
    }), Ze = ja(i, (Pe) => {
      if (D != null)
        return D;
      if (!Pe || !(P != null && P.ariaPosInSet) || P.baseElement !== Pe.baseElement)
        return;
      const Vt = Pe.renderedItems.filter(
        (Dt) => Dt.rowId === V
      );
      return P.ariaPosInSet + Vt.findIndex((Dt) => Dt.id === A);
    }), mt = ja(i, (Pe) => Pe != null && Pe.renderedItems.length ? Pe.virtualFocus ? !1 : C ? !0 : Pe.activeId === A : !0);
    return T = Te(G({
      id: A,
      "aria-selected": ie,
      "data-active-item": Le || void 0
    }, T), {
      ref: An(L, T.ref),
      tabIndex: mt ? T.tabIndex : -1,
      onFocus: le,
      onBlurCapture: Se,
      onKeyDown: de
    }), T = U5(T), T = gh(Te(G({
      store: i
    }, T), {
      getItem: W,
      shouldRegisterItem: A ? T.shouldRegisterItem : !1
    })), La(Te(G({}, T), {
      "aria-setsize": _e,
      "aria-posinset": Ze
    }));
  }
), ey = Ha(
  Oe(function(t) {
    const a = F2(t);
    return Ae(vH, a);
  })
), WE = "input";
function CH(e, t) {
  if (t !== void 0)
    return e != null && t != null ? t === e : !!t;
}
function bH(e, t) {
  return e === "input" && (!t || t === "radio");
}
var ex = ke(function(t) {
  var a = t, {
    store: i,
    name: h,
    value: g,
    checked: m
  } = a, C = Fe(a, [
    "store",
    "name",
    "value",
    "checked"
  ]);
  const S = YE();
  i = i || S;
  const R = Ia(C.id), D = Pt(null), T = ja(
    i,
    (te) => m ?? CH(g, te == null ? void 0 : te.value)
  );
  gt(() => {
    !R || !T || (i == null ? void 0 : i.getState().activeId) === R || i == null || i.setActiveId(R);
  }, [i, T, R]);
  const j = C.onChange, A = ph(D, WE), L = bH(A, C.type), P = mf(C), [V, F] = P5();
  gt(() => {
    const te = D.current;
    te && (L || (T !== void 0 && (te.checked = T), h !== void 0 && (te.name = h), g !== void 0 && (te.value = `${g}`)));
  }, [V, L, T, h, g]);
  const Y = rt((te) => {
    if (P) {
      te.preventDefault(), te.stopPropagation();
      return;
    }
    L || (te.currentTarget.checked = !0, F()), j == null || j(te), !te.defaultPrevented && (i == null || i.setValue(g));
  }), W = C.onClick, Q = rt((te) => {
    W == null || W(te), !te.defaultPrevented && (L || Y(te));
  }), $ = C.onFocus, le = rt((te) => {
    if ($ == null || $(te), te.defaultPrevented || !L || !i)
      return;
    const { moves: Se, activeId: re } = i.getState();
    Se && (R && re !== R || Y(te));
  });
  return C = Te(G({
    id: R,
    role: L ? void 0 : "radio",
    type: L ? "radio" : void 0,
    "aria-checked": T
  }, C), {
    ref: An(D, C.ref),
    onChange: Y,
    onClick: Q,
    onFocus: le
  }), C = F2(G({
    store: i,
    clickOnEnter: !L
  }, C)), La(G({
    name: L ? h : void 0,
    value: L ? g : void 0,
    checked: T
  }, C));
}), zE = Ha(
  Oe(function(t) {
    const a = ex(t);
    return Ae(WE, a);
  })
), _H = "input", RH = ke(
  function(t) {
    var a = t, { store: i, name: h, value: g } = a, m = Fe(a, ["store", "name", "value"]);
    const C = Rl();
    i = i || C, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormRadio must be wrapped in a Form component."
    );
    const S = `${h}`, R = m.onChange, D = rt((A) => {
      R == null || R(A), !A.defaultPrevented && (i == null || i.setValue(S, g));
    }), T = m.checked, j = i.useState(
      () => T ?? (i == null ? void 0 : i.getValue(S)) === g
    );
    return m = Te(G({}, m), {
      checked: j,
      onChange: D
    }), m = ex(G({ value: g }, m)), m = $4(G({
      store: i,
      name: S,
      "aria-labelledby": void 0
    }, m)), m;
  }
), EH = Ha(
  Oe(function(t) {
    const a = RH(t);
    return Ae(_H, a);
  })
), MH = "button";
function TH(e, t, a) {
  const i = e == null ? void 0 : e.filter(
    (m) => m.type === "field" && m.name.startsWith(t)
  ), h = new RegExp(`^${t}\\.(\\d+)`), g = i == null ? void 0 : i.find((m) => {
    const C = m.name.replace(h, "$1");
    return parseInt(C) > a;
  });
  return g || (i == null ? void 0 : i.reverse().find((m) => {
    const C = m.name.replace(h, "$1");
    return parseInt(C) < a;
  }));
}
function OH(e, t) {
  return e == null ? void 0 : e.find((a) => a.type === "button" && a.name === t);
}
var DH = ke(
  function(t) {
    var a = t, {
      store: i,
      name: h,
      index: g,
      autoFocusOnClick: m = !0
    } = a, C = Fe(a, [
      "store",
      "name",
      "index",
      "autoFocusOnClick"
    ]);
    const S = Rl();
    i = i || S, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormRemove must be wrapped in a Form component."
    );
    const R = `${h}`, D = C.onClick, T = rt((j) => {
      var A;
      if (D == null || D(j), j.defaultPrevented || !i || (i.removeValue(R, g), !m))
        return;
      const { items: L } = i.getState(), P = TH(L, R, g), V = P == null ? void 0 : P.element;
      if (V)
        V.focus(), bl(V) && V.select();
      else {
        const F = OH(L, R);
        (A = F == null ? void 0 : F.element) == null || A.focus();
      }
    });
    return C = Te(G({}, C), {
      onClick: T
    }), C = wh(C), C;
  }
), jH = Oe(function(t) {
  const a = DH(t);
  return Ae(MH, a);
}), AH = "button", kH = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = Rl();
    return i = i || g, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormReset must be wrapped in a Form component."
    ), h = G({
      type: "reset",
      disabled: i.useState("submitting")
    }, h), h = wh(h), h;
  }
), LH = Oe(function(t) {
  const a = kH(t);
  return Ae(AH, a);
}), IH = "button", HH = ke(
  function(t) {
    var a = t, { store: i, accessibleWhenDisabled: h = !0 } = a, g = Fe(a, ["store", "accessibleWhenDisabled"]);
    const m = Rl();
    return i = i || m, Zt(
      i,
      process.env.NODE_ENV !== "production" && "FormSubmit must be wrapped in a Form component."
    ), g = G({
      type: "submit",
      disabled: i.useState("submitting")
    }, g), g = wh(Te(G({}, g), { accessibleWhenDisabled: h })), g;
  }
), qE = Oe(function(t) {
  const a = HH(t);
  return Ae(IH, a);
}), ZH = "span", tx = ke(
  function(t) {
    return t = Te(G({}, t), {
      style: G({
        border: 0,
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px"
      }, t.style)
    }), t;
  }
), PH = Oe(function(t) {
  const a = tx(t);
  return Ae(ZH, a);
}), VH = "span", NH = ke(
  function(t) {
    return t = Te(G({
      "data-focus-trap": "",
      tabIndex: 0,
      "aria-hidden": !0
    }, t), {
      style: G({
        // Prevents unintended scroll jumps.
        position: "fixed",
        top: 0,
        left: 0
      }, t.style)
    }), t = tx(t), t;
  }
), xp = Oe(function(t) {
  const a = NH(t);
  return Ae(VH, a);
}), BH = "div", FH = ke(
  function(t) {
    var a = t, { enabled: i = !1 } = a, h = Fe(a, ["enabled"]);
    const g = Pt(null);
    return h = Vn(
      h,
      (m) => {
        const C = () => i ? /* @__PURE__ */ f.jsx(
          xp,
          {
            onFocus: (S) => {
              const R = g.current;
              if (!R)
                return;
              const D = Lp(R, !0), T = D[0], j = D[D.length - 1];
              if (!D.length) {
                R.focus();
                return;
              }
              S.relatedTarget === T ? j == null || j.focus() : T == null || T.focus();
            }
          }
        ) : null;
        return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          C(),
          m,
          C()
        ] });
      },
      [i]
    ), h = Te(G({}, h), {
      ref: An(g, h.ref)
    }), La(h);
  }
), UH = Oe(function(t) {
  const a = FH(t);
  return Ae(BH, a);
});
function GE(e = {}) {
  const t = kp(
    e.store,
    Tp(e.disclosure, ["contentElement", "disclosureElement"])
  );
  mh(e, t);
  const a = t == null ? void 0 : t.getState(), i = st(
    e.open,
    a == null ? void 0 : a.open,
    e.defaultOpen,
    !1
  ), h = st(e.animated, a == null ? void 0 : a.animated, !1), g = {
    open: i,
    animated: h,
    animating: !!h && i,
    mounted: i,
    contentElement: st(a == null ? void 0 : a.contentElement, null),
    disclosureElement: st(a == null ? void 0 : a.disclosureElement, null)
  }, m = fo(g, t);
  return Aa(
    m,
    () => xa(m, ["animated", "animating"], (C) => {
      C.animated || m.setState("animating", !1);
    })
  ), Aa(
    m,
    () => CE(m, ["open"], () => {
      m.getState().animated && m.setState("animating", !0);
    })
  ), Aa(
    m,
    () => xa(m, ["open", "animating"], (C) => {
      m.setState("mounted", C.open || C.animating);
    })
  ), mn(_t({}, m), {
    disclosure: e.disclosure,
    setOpen: (C) => m.setState("open", C),
    show: () => m.setState("open", !0),
    hide: () => m.setState("open", !1),
    toggle: () => m.setState("open", (C) => !C),
    stopAnimation: () => m.setState("animating", !1),
    setContentElement: (C) => m.setState("contentElement", C),
    setDisclosureElement: (C) => m.setState("disclosureElement", C)
  });
}
function KE(e, t, a) {
  return _1(t, [a.store, a.disclosure]), ir(e, a, "open", "setOpen"), ir(e, a, "mounted", "setMounted"), ir(e, a, "animated"), Object.assign(e, { disclosure: a.disclosure });
}
function q5(e = {}) {
  const [t, a] = bi(GE, e);
  return KE(t, a, e);
}
var G5 = _i(), YH = G5.useContext, nx = G5.useProviderContext, QE = G5.ContextProvider, $H = G5.ScopedContextProvider, WH = "button", zH = Symbol("disclosure"), XE = ke(
  function(t) {
    var a = t, { store: i, toggleOnClick: h = !0 } = a, g = Fe(a, ["store", "toggleOnClick"]);
    const m = nx();
    i = i || m, Zt(
      i,
      process.env.NODE_ENV !== "production" && "Disclosure must receive a `store` prop or be wrapped in a DisclosureProvider component."
    );
    const C = Pt(null), [S, R] = Qt(!1), D = i.useState("disclosureElement"), T = i.useState("open");
    gt(() => {
      let Y = D === C.current;
      D != null && D.isConnected || (i == null || i.setDisclosureElement(C.current), Y = !0), R(T && Y);
    }, [D, i, T]);
    const j = g.onClick, A = er(h), [L, P] = xE(g, zH, !0), V = rt((Y) => {
      j == null || j(Y), !Y.defaultPrevented && (L || A(Y) && (i == null || i.setDisclosureElement(Y.currentTarget), i == null || i.toggle()));
    }), F = i.useState("contentElement");
    return g = Te(G(G({
      "aria-expanded": S,
      "aria-controls": F == null ? void 0 : F.id
    }, P), g), {
      ref: An(C, g.ref),
      onClick: V
    }), g = wh(g), g;
  }
), qH = Oe(function(t) {
  const a = XE(t);
  return Ae(WH, a);
});
function GH(e = {}) {
  const t = q5(e);
  return /* @__PURE__ */ f.jsx(QE, { value: t, children: e.children });
}
var W4 = _i(
  [QE],
  [$H]
), z4 = W4.useContext, KH = W4.useScopedContext, K5 = W4.useProviderContext, JE = W4.ContextProvider, rx = W4.ScopedContextProvider, eM = ka(void 0), tM = ka(void 0), ty = { exports: {} }, Gl = {}, o5 = { exports: {} }, M8 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H_;
function QH() {
  return H_ || (H_ = 1, function(e) {
    function t(ie, _e) {
      var Ze = ie.length;
      ie.push(_e);
      e: for (; 0 < Ze; ) {
        var mt = Ze - 1 >>> 1, Pe = ie[mt];
        if (0 < h(Pe, _e)) ie[mt] = _e, ie[Ze] = Pe, Ze = mt;
        else break e;
      }
    }
    function a(ie) {
      return ie.length === 0 ? null : ie[0];
    }
    function i(ie) {
      if (ie.length === 0) return null;
      var _e = ie[0], Ze = ie.pop();
      if (Ze !== _e) {
        ie[0] = Ze;
        e: for (var mt = 0, Pe = ie.length, Vt = Pe >>> 1; mt < Vt; ) {
          var Dt = 2 * (mt + 1) - 1, Qe = ie[Dt], et = Dt + 1, wt = ie[et];
          if (0 > h(Qe, Ze)) et < Pe && 0 > h(wt, Qe) ? (ie[mt] = wt, ie[et] = Ze, mt = et) : (ie[mt] = Qe, ie[Dt] = Ze, mt = Dt);
          else if (et < Pe && 0 > h(wt, Ze)) ie[mt] = wt, ie[et] = Ze, mt = et;
          else break e;
        }
      }
      return _e;
    }
    function h(ie, _e) {
      var Ze = ie.sortIndex - _e.sortIndex;
      return Ze !== 0 ? Ze : ie.id - _e.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var g = performance;
      e.unstable_now = function() {
        return g.now();
      };
    } else {
      var m = Date, C = m.now();
      e.unstable_now = function() {
        return m.now() - C;
      };
    }
    var S = [], R = [], D = 1, T = null, j = 3, A = !1, L = !1, P = !1, V = typeof setTimeout == "function" ? setTimeout : null, F = typeof clearTimeout == "function" ? clearTimeout : null, Y = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function W(ie) {
      for (var _e = a(R); _e !== null; ) {
        if (_e.callback === null) i(R);
        else if (_e.startTime <= ie) i(R), _e.sortIndex = _e.expirationTime, t(S, _e);
        else break;
        _e = a(R);
      }
    }
    function Q(ie) {
      if (P = !1, W(ie), !L) if (a(S) !== null) L = !0, be($);
      else {
        var _e = a(R);
        _e !== null && Ue(Q, _e.startTime - ie);
      }
    }
    function $(ie, _e) {
      L = !1, P && (P = !1, F(Se), Se = -1), A = !0;
      var Ze = j;
      try {
        for (W(_e), T = a(S); T !== null && (!(T.expirationTime > _e) || ie && !K()); ) {
          var mt = T.callback;
          if (typeof mt == "function") {
            T.callback = null, j = T.priorityLevel;
            var Pe = mt(T.expirationTime <= _e);
            _e = e.unstable_now(), typeof Pe == "function" ? T.callback = Pe : T === a(S) && i(S), W(_e);
          } else i(S);
          T = a(S);
        }
        if (T !== null) var Vt = !0;
        else {
          var Dt = a(R);
          Dt !== null && Ue(Q, Dt.startTime - _e), Vt = !1;
        }
        return Vt;
      } finally {
        T = null, j = Ze, A = !1;
      }
    }
    var le = !1, te = null, Se = -1, re = 5, ve = -1;
    function K() {
      return !(e.unstable_now() - ve < re);
    }
    function de() {
      if (te !== null) {
        var ie = e.unstable_now();
        ve = ie;
        var _e = !0;
        try {
          _e = te(!0, ie);
        } finally {
          _e ? fe() : (le = !1, te = null);
        }
      } else le = !1;
    }
    var fe;
    if (typeof Y == "function") fe = function() {
      Y(de);
    };
    else if (typeof MessageChannel < "u") {
      var xe = new MessageChannel(), Le = xe.port2;
      xe.port1.onmessage = de, fe = function() {
        Le.postMessage(null);
      };
    } else fe = function() {
      V(de, 0);
    };
    function be(ie) {
      te = ie, le || (le = !0, fe());
    }
    function Ue(ie, _e) {
      Se = V(function() {
        ie(e.unstable_now());
      }, _e);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(ie) {
      ie.callback = null;
    }, e.unstable_continueExecution = function() {
      L || A || (L = !0, be($));
    }, e.unstable_forceFrameRate = function(ie) {
      0 > ie || 125 < ie ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : re = 0 < ie ? Math.floor(1e3 / ie) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return j;
    }, e.unstable_getFirstCallbackNode = function() {
      return a(S);
    }, e.unstable_next = function(ie) {
      switch (j) {
        case 1:
        case 2:
        case 3:
          var _e = 3;
          break;
        default:
          _e = j;
      }
      var Ze = j;
      j = _e;
      try {
        return ie();
      } finally {
        j = Ze;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(ie, _e) {
      switch (ie) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          ie = 3;
      }
      var Ze = j;
      j = ie;
      try {
        return _e();
      } finally {
        j = Ze;
      }
    }, e.unstable_scheduleCallback = function(ie, _e, Ze) {
      var mt = e.unstable_now();
      switch (typeof Ze == "object" && Ze !== null ? (Ze = Ze.delay, Ze = typeof Ze == "number" && 0 < Ze ? mt + Ze : mt) : Ze = mt, ie) {
        case 1:
          var Pe = -1;
          break;
        case 2:
          Pe = 250;
          break;
        case 5:
          Pe = 1073741823;
          break;
        case 4:
          Pe = 1e4;
          break;
        default:
          Pe = 5e3;
      }
      return Pe = Ze + Pe, ie = { id: D++, callback: _e, priorityLevel: ie, startTime: Ze, expirationTime: Pe, sortIndex: -1 }, Ze > mt ? (ie.sortIndex = Ze, t(R, ie), a(S) === null && ie === a(R) && (P ? (F(Se), Se = -1) : P = !0, Ue(Q, Ze - mt))) : (ie.sortIndex = Pe, t(S, ie), L || A || (L = !0, be($))), ie;
    }, e.unstable_shouldYield = K, e.unstable_wrapCallback = function(ie) {
      var _e = j;
      return function() {
        var Ze = j;
        j = _e;
        try {
          return ie.apply(this, arguments);
        } finally {
          j = Ze;
        }
      };
    };
  }(M8)), M8;
}
var T8 = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z_;
function XH() {
  return Z_ || (Z_ = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = 5;
      function a(qe, yt) {
        var Ct = qe.length;
        qe.push(yt), g(qe, yt, Ct);
      }
      function i(qe) {
        return qe.length === 0 ? null : qe[0];
      }
      function h(qe) {
        if (qe.length === 0)
          return null;
        var yt = qe[0], Ct = qe.pop();
        return Ct !== yt && (qe[0] = Ct, m(qe, Ct, 0)), yt;
      }
      function g(qe, yt, Ct) {
        for (var ln = Ct; ln > 0; ) {
          var cr = ln - 1 >>> 1, ta = qe[cr];
          if (C(ta, yt) > 0)
            qe[cr] = yt, qe[ln] = ta, ln = cr;
          else
            return;
        }
      }
      function m(qe, yt, Ct) {
        for (var ln = Ct, cr = qe.length, ta = cr >>> 1; ln < ta; ) {
          var xr = (ln + 1) * 2 - 1, Ao = qe[xr], wn = xr + 1, Gn = qe[wn];
          if (C(Ao, yt) < 0)
            wn < cr && C(Gn, Ao) < 0 ? (qe[ln] = Gn, qe[wn] = yt, ln = wn) : (qe[ln] = Ao, qe[xr] = yt, ln = xr);
          else if (wn < cr && C(Gn, yt) < 0)
            qe[ln] = Gn, qe[wn] = yt, ln = wn;
          else
            return;
        }
      }
      function C(qe, yt) {
        var Ct = qe.sortIndex - yt.sortIndex;
        return Ct !== 0 ? Ct : qe.id - yt.id;
      }
      var S = 1, R = 2, D = 3, T = 4, j = 5, A = typeof performance == "object" && typeof performance.now == "function";
      if (A) {
        var L = performance;
        e.unstable_now = function() {
          return L.now();
        };
      } else {
        var P = Date, V = P.now();
        e.unstable_now = function() {
          return P.now() - V;
        };
      }
      var F = 1073741823, Y = -1, W = 250, Q = 5e3, $ = 1e4, le = F, te = [], Se = [], re = 1, ve = null, K = D, de = !1, fe = !1, xe = !1, Le = typeof setTimeout == "function" ? setTimeout : null, be = typeof clearTimeout == "function" ? clearTimeout : null, Ue = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function ie(qe) {
        for (var yt = i(Se); yt !== null; ) {
          if (yt.callback === null)
            h(Se);
          else if (yt.startTime <= qe)
            h(Se), yt.sortIndex = yt.expirationTime, a(te, yt);
          else
            return;
          yt = i(Se);
        }
      }
      function _e(qe) {
        if (xe = !1, ie(qe), !fe)
          if (i(te) !== null)
            fe = !0, Ur(Ze);
          else {
            var yt = i(Se);
            yt !== null && Xe(_e, yt.startTime - qe);
          }
      }
      function Ze(qe, yt) {
        fe = !1, xe && (xe = !1, Jt()), de = !0;
        var Ct = K;
        try {
          return mt(qe, yt);
        } finally {
          ve = null, K = Ct, de = !1;
        }
      }
      function mt(qe, yt) {
        var Ct = yt;
        for (ie(Ct), ve = i(te); ve !== null && !(ve.expirationTime > Ct && (!qe || Ca())); ) {
          var ln = ve.callback;
          if (typeof ln == "function") {
            ve.callback = null, K = ve.priorityLevel;
            var cr = ve.expirationTime <= Ct, ta = ln(cr);
            Ct = e.unstable_now(), typeof ta == "function" ? ve.callback = ta : ve === i(te) && h(te), ie(Ct);
          } else
            h(te);
          ve = i(te);
        }
        if (ve !== null)
          return !0;
        var xr = i(Se);
        return xr !== null && Xe(_e, xr.startTime - Ct), !1;
      }
      function Pe(qe, yt) {
        switch (qe) {
          case S:
          case R:
          case D:
          case T:
          case j:
            break;
          default:
            qe = D;
        }
        var Ct = K;
        K = qe;
        try {
          return yt();
        } finally {
          K = Ct;
        }
      }
      function Vt(qe) {
        var yt;
        switch (K) {
          case S:
          case R:
          case D:
            yt = D;
            break;
          default:
            yt = K;
            break;
        }
        var Ct = K;
        K = yt;
        try {
          return qe();
        } finally {
          K = Ct;
        }
      }
      function Dt(qe) {
        var yt = K;
        return function() {
          var Ct = K;
          K = yt;
          try {
            return qe.apply(this, arguments);
          } finally {
            K = Ct;
          }
        };
      }
      function Qe(qe, yt, Ct) {
        var ln = e.unstable_now(), cr;
        if (typeof Ct == "object" && Ct !== null) {
          var ta = Ct.delay;
          typeof ta == "number" && ta > 0 ? cr = ln + ta : cr = ln;
        } else
          cr = ln;
        var xr;
        switch (qe) {
          case S:
            xr = Y;
            break;
          case R:
            xr = W;
            break;
          case j:
            xr = le;
            break;
          case T:
            xr = $;
            break;
          case D:
          default:
            xr = Q;
            break;
        }
        var Ao = cr + xr, wn = {
          id: re++,
          callback: yt,
          priorityLevel: qe,
          startTime: cr,
          expirationTime: Ao,
          sortIndex: -1
        };
        return cr > ln ? (wn.sortIndex = cr, a(Se, wn), i(te) === null && wn === i(Se) && (xe ? Jt() : xe = !0, Xe(_e, cr - ln))) : (wn.sortIndex = Ao, a(te, wn), !fe && !de && (fe = !0, Ur(Ze))), wn;
      }
      function et() {
      }
      function wt() {
        !fe && !de && (fe = !0, Ur(Ze));
      }
      function St() {
        return i(te);
      }
      function _n(qe) {
        qe.callback = null;
      }
      function Hr() {
        return K;
      }
      var kn = !1, Wn = null, sr = -1, yr = t, ea = -1;
      function Ca() {
        var qe = e.unstable_now() - ea;
        return !(qe < yr);
      }
      function ft() {
      }
      function fn(qe) {
        if (qe < 0 || qe > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        qe > 0 ? yr = Math.floor(1e3 / qe) : yr = t;
      }
      var Ln = function() {
        if (Wn !== null) {
          var qe = e.unstable_now();
          ea = qe;
          var yt = !0, Ct = !0;
          try {
            Ct = Wn(yt, qe);
          } finally {
            Ct ? Nt() : (kn = !1, Wn = null);
          }
        } else
          kn = !1;
      }, Nt;
      if (typeof Ue == "function")
        Nt = function() {
          Ue(Ln);
        };
      else if (typeof MessageChannel < "u") {
        var gn = new MessageChannel(), zn = gn.port2;
        gn.port1.onmessage = Ln, Nt = function() {
          zn.postMessage(null);
        };
      } else
        Nt = function() {
          Le(Ln, 0);
        };
      function Ur(qe) {
        Wn = qe, kn || (kn = !0, Nt());
      }
      function Xe(qe, yt) {
        sr = Le(function() {
          qe(e.unstable_now());
        }, yt);
      }
      function Jt() {
        be(sr), sr = -1;
      }
      var qn = ft, Sn = null;
      e.unstable_IdlePriority = j, e.unstable_ImmediatePriority = S, e.unstable_LowPriority = T, e.unstable_NormalPriority = D, e.unstable_Profiling = Sn, e.unstable_UserBlockingPriority = R, e.unstable_cancelCallback = _n, e.unstable_continueExecution = wt, e.unstable_forceFrameRate = fn, e.unstable_getCurrentPriorityLevel = Hr, e.unstable_getFirstCallbackNode = St, e.unstable_next = Vt, e.unstable_pauseExecution = et, e.unstable_requestPaint = qn, e.unstable_runWithPriority = Pe, e.unstable_scheduleCallback = Qe, e.unstable_shouldYield = Ca, e.unstable_wrapCallback = Dt, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(T8)), T8;
}
var P_;
function nM() {
  return P_ || (P_ = 1, process.env.NODE_ENV === "production" ? o5.exports = QH() : o5.exports = XH()), o5.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V_;
function JH() {
  if (V_) return Gl;
  V_ = 1;
  var e = Sa, t = nM();
  function a(o) {
    for (var l = "https://reactjs.org/docs/error-decoder.html?invariant=" + o, v = 1; v < arguments.length; v++) l += "&args[]=" + encodeURIComponent(arguments[v]);
    return "Minified React error #" + o + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var i = /* @__PURE__ */ new Set(), h = {};
  function g(o, l) {
    m(o, l), m(o + "Capture", l);
  }
  function m(o, l) {
    for (h[o] = l, o = 0; o < l.length; o++) i.add(l[o]);
  }
  var C = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), S = Object.prototype.hasOwnProperty, R = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, D = {}, T = {};
  function j(o) {
    return S.call(T, o) ? !0 : S.call(D, o) ? !1 : R.test(o) ? T[o] = !0 : (D[o] = !0, !1);
  }
  function A(o, l, v, w) {
    if (v !== null && v.type === 0) return !1;
    switch (typeof l) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return w ? !1 : v !== null ? !v.acceptsBooleans : (o = o.toLowerCase().slice(0, 5), o !== "data-" && o !== "aria-");
      default:
        return !1;
    }
  }
  function L(o, l, v, w) {
    if (l === null || typeof l > "u" || A(o, l, v, w)) return !0;
    if (w) return !1;
    if (v !== null) switch (v.type) {
      case 3:
        return !l;
      case 4:
        return l === !1;
      case 5:
        return isNaN(l);
      case 6:
        return isNaN(l) || 1 > l;
    }
    return !1;
  }
  function P(o, l, v, w, b, E, Z) {
    this.acceptsBooleans = l === 2 || l === 3 || l === 4, this.attributeName = w, this.attributeNamespace = b, this.mustUseProperty = v, this.propertyName = o, this.type = l, this.sanitizeURL = E, this.removeEmptyString = Z;
  }
  var V = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(o) {
    V[o] = new P(o, 0, !1, o, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(o) {
    var l = o[0];
    V[l] = new P(l, 1, !1, o[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(o) {
    V[o] = new P(o, 2, !1, o.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(o) {
    V[o] = new P(o, 2, !1, o, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(o) {
    V[o] = new P(o, 3, !1, o.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(o) {
    V[o] = new P(o, 3, !0, o, null, !1, !1);
  }), ["capture", "download"].forEach(function(o) {
    V[o] = new P(o, 4, !1, o, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(o) {
    V[o] = new P(o, 6, !1, o, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(o) {
    V[o] = new P(o, 5, !1, o.toLowerCase(), null, !1, !1);
  });
  var F = /[\-:]([a-z])/g;
  function Y(o) {
    return o[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(o) {
    var l = o.replace(
      F,
      Y
    );
    V[l] = new P(l, 1, !1, o, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(o) {
    var l = o.replace(F, Y);
    V[l] = new P(l, 1, !1, o, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(o) {
    var l = o.replace(F, Y);
    V[l] = new P(l, 1, !1, o, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(o) {
    V[o] = new P(o, 1, !1, o.toLowerCase(), null, !1, !1);
  }), V.xlinkHref = new P("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(o) {
    V[o] = new P(o, 1, !1, o.toLowerCase(), null, !0, !0);
  });
  function W(o, l, v, w) {
    var b = V.hasOwnProperty(l) ? V[l] : null;
    (b !== null ? b.type !== 0 : w || !(2 < l.length) || l[0] !== "o" && l[0] !== "O" || l[1] !== "n" && l[1] !== "N") && (L(l, v, b, w) && (v = null), w || b === null ? j(l) && (v === null ? o.removeAttribute(l) : o.setAttribute(l, "" + v)) : b.mustUseProperty ? o[b.propertyName] = v === null ? b.type === 3 ? !1 : "" : v : (l = b.attributeName, w = b.attributeNamespace, v === null ? o.removeAttribute(l) : (b = b.type, v = b === 3 || b === 4 && v === !0 ? "" : "" + v, w ? o.setAttributeNS(w, l, v) : o.setAttribute(l, v))));
  }
  var Q = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $ = Symbol.for("react.element"), le = Symbol.for("react.portal"), te = Symbol.for("react.fragment"), Se = Symbol.for("react.strict_mode"), re = Symbol.for("react.profiler"), ve = Symbol.for("react.provider"), K = Symbol.for("react.context"), de = Symbol.for("react.forward_ref"), fe = Symbol.for("react.suspense"), xe = Symbol.for("react.suspense_list"), Le = Symbol.for("react.memo"), be = Symbol.for("react.lazy"), Ue = Symbol.for("react.offscreen"), ie = Symbol.iterator;
  function _e(o) {
    return o === null || typeof o != "object" ? null : (o = ie && o[ie] || o["@@iterator"], typeof o == "function" ? o : null);
  }
  var Ze = Object.assign, mt;
  function Pe(o) {
    if (mt === void 0) try {
      throw Error();
    } catch (v) {
      var l = v.stack.trim().match(/\n( *(at )?)/);
      mt = l && l[1] || "";
    }
    return `
` + mt + o;
  }
  var Vt = !1;
  function Dt(o, l) {
    if (!o || Vt) return "";
    Vt = !0;
    var v = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (l) if (l = function() {
        throw Error();
      }, Object.defineProperty(l.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(l, []);
        } catch (ye) {
          var w = ye;
        }
        Reflect.construct(o, [], l);
      } else {
        try {
          l.call();
        } catch (ye) {
          w = ye;
        }
        o.call(l.prototype);
      }
      else {
        try {
          throw Error();
        } catch (ye) {
          w = ye;
        }
        o();
      }
    } catch (ye) {
      if (ye && w && typeof ye.stack == "string") {
        for (var b = ye.stack.split(`
`), E = w.stack.split(`
`), Z = b.length - 1, z = E.length - 1; 1 <= Z && 0 <= z && b[Z] !== E[z]; ) z--;
        for (; 1 <= Z && 0 <= z; Z--, z--) if (b[Z] !== E[z]) {
          if (Z !== 1 || z !== 1)
            do
              if (Z--, z--, 0 > z || b[Z] !== E[z]) {
                var ee = `
` + b[Z].replace(" at new ", " at ");
                return o.displayName && ee.includes("<anonymous>") && (ee = ee.replace("<anonymous>", o.displayName)), ee;
              }
            while (1 <= Z && 0 <= z);
          break;
        }
      }
    } finally {
      Vt = !1, Error.prepareStackTrace = v;
    }
    return (o = o ? o.displayName || o.name : "") ? Pe(o) : "";
  }
  function Qe(o) {
    switch (o.tag) {
      case 5:
        return Pe(o.type);
      case 16:
        return Pe("Lazy");
      case 13:
        return Pe("Suspense");
      case 19:
        return Pe("SuspenseList");
      case 0:
      case 2:
      case 15:
        return o = Dt(o.type, !1), o;
      case 11:
        return o = Dt(o.type.render, !1), o;
      case 1:
        return o = Dt(o.type, !0), o;
      default:
        return "";
    }
  }
  function et(o) {
    if (o == null) return null;
    if (typeof o == "function") return o.displayName || o.name || null;
    if (typeof o == "string") return o;
    switch (o) {
      case te:
        return "Fragment";
      case le:
        return "Portal";
      case re:
        return "Profiler";
      case Se:
        return "StrictMode";
      case fe:
        return "Suspense";
      case xe:
        return "SuspenseList";
    }
    if (typeof o == "object") switch (o.$$typeof) {
      case K:
        return (o.displayName || "Context") + ".Consumer";
      case ve:
        return (o._context.displayName || "Context") + ".Provider";
      case de:
        var l = o.render;
        return o = o.displayName, o || (o = l.displayName || l.name || "", o = o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef"), o;
      case Le:
        return l = o.displayName || null, l !== null ? l : et(o.type) || "Memo";
      case be:
        l = o._payload, o = o._init;
        try {
          return et(o(l));
        } catch {
        }
    }
    return null;
  }
  function wt(o) {
    var l = o.type;
    switch (o.tag) {
      case 24:
        return "Cache";
      case 9:
        return (l.displayName || "Context") + ".Consumer";
      case 10:
        return (l._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return o = l.render, o = o.displayName || o.name || "", l.displayName || (o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return l;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return et(l);
      case 8:
        return l === Se ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof l == "function") return l.displayName || l.name || null;
        if (typeof l == "string") return l;
    }
    return null;
  }
  function St(o) {
    switch (typeof o) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return o;
      case "object":
        return o;
      default:
        return "";
    }
  }
  function _n(o) {
    var l = o.type;
    return (o = o.nodeName) && o.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
  }
  function Hr(o) {
    var l = _n(o) ? "checked" : "value", v = Object.getOwnPropertyDescriptor(o.constructor.prototype, l), w = "" + o[l];
    if (!o.hasOwnProperty(l) && typeof v < "u" && typeof v.get == "function" && typeof v.set == "function") {
      var b = v.get, E = v.set;
      return Object.defineProperty(o, l, { configurable: !0, get: function() {
        return b.call(this);
      }, set: function(Z) {
        w = "" + Z, E.call(this, Z);
      } }), Object.defineProperty(o, l, { enumerable: v.enumerable }), { getValue: function() {
        return w;
      }, setValue: function(Z) {
        w = "" + Z;
      }, stopTracking: function() {
        o._valueTracker = null, delete o[l];
      } };
    }
  }
  function kn(o) {
    o._valueTracker || (o._valueTracker = Hr(o));
  }
  function Wn(o) {
    if (!o) return !1;
    var l = o._valueTracker;
    if (!l) return !0;
    var v = l.getValue(), w = "";
    return o && (w = _n(o) ? o.checked ? "true" : "false" : o.value), o = w, o !== v ? (l.setValue(o), !0) : !1;
  }
  function sr(o) {
    if (o = o || (typeof document < "u" ? document : void 0), typeof o > "u") return null;
    try {
      return o.activeElement || o.body;
    } catch {
      return o.body;
    }
  }
  function yr(o, l) {
    var v = l.checked;
    return Ze({}, l, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: v ?? o._wrapperState.initialChecked });
  }
  function ea(o, l) {
    var v = l.defaultValue == null ? "" : l.defaultValue, w = l.checked != null ? l.checked : l.defaultChecked;
    v = St(l.value != null ? l.value : v), o._wrapperState = { initialChecked: w, initialValue: v, controlled: l.type === "checkbox" || l.type === "radio" ? l.checked != null : l.value != null };
  }
  function Ca(o, l) {
    l = l.checked, l != null && W(o, "checked", l, !1);
  }
  function ft(o, l) {
    Ca(o, l);
    var v = St(l.value), w = l.type;
    if (v != null) w === "number" ? (v === 0 && o.value === "" || o.value != v) && (o.value = "" + v) : o.value !== "" + v && (o.value = "" + v);
    else if (w === "submit" || w === "reset") {
      o.removeAttribute("value");
      return;
    }
    l.hasOwnProperty("value") ? Ln(o, l.type, v) : l.hasOwnProperty("defaultValue") && Ln(o, l.type, St(l.defaultValue)), l.checked == null && l.defaultChecked != null && (o.defaultChecked = !!l.defaultChecked);
  }
  function fn(o, l, v) {
    if (l.hasOwnProperty("value") || l.hasOwnProperty("defaultValue")) {
      var w = l.type;
      if (!(w !== "submit" && w !== "reset" || l.value !== void 0 && l.value !== null)) return;
      l = "" + o._wrapperState.initialValue, v || l === o.value || (o.value = l), o.defaultValue = l;
    }
    v = o.name, v !== "" && (o.name = ""), o.defaultChecked = !!o._wrapperState.initialChecked, v !== "" && (o.name = v);
  }
  function Ln(o, l, v) {
    (l !== "number" || sr(o.ownerDocument) !== o) && (v == null ? o.defaultValue = "" + o._wrapperState.initialValue : o.defaultValue !== "" + v && (o.defaultValue = "" + v));
  }
  var Nt = Array.isArray;
  function gn(o, l, v, w) {
    if (o = o.options, l) {
      l = {};
      for (var b = 0; b < v.length; b++) l["$" + v[b]] = !0;
      for (v = 0; v < o.length; v++) b = l.hasOwnProperty("$" + o[v].value), o[v].selected !== b && (o[v].selected = b), b && w && (o[v].defaultSelected = !0);
    } else {
      for (v = "" + St(v), l = null, b = 0; b < o.length; b++) {
        if (o[b].value === v) {
          o[b].selected = !0, w && (o[b].defaultSelected = !0);
          return;
        }
        l !== null || o[b].disabled || (l = o[b]);
      }
      l !== null && (l.selected = !0);
    }
  }
  function zn(o, l) {
    if (l.dangerouslySetInnerHTML != null) throw Error(a(91));
    return Ze({}, l, { value: void 0, defaultValue: void 0, children: "" + o._wrapperState.initialValue });
  }
  function Ur(o, l) {
    var v = l.value;
    if (v == null) {
      if (v = l.children, l = l.defaultValue, v != null) {
        if (l != null) throw Error(a(92));
        if (Nt(v)) {
          if (1 < v.length) throw Error(a(93));
          v = v[0];
        }
        l = v;
      }
      l == null && (l = ""), v = l;
    }
    o._wrapperState = { initialValue: St(v) };
  }
  function Xe(o, l) {
    var v = St(l.value), w = St(l.defaultValue);
    v != null && (v = "" + v, v !== o.value && (o.value = v), l.defaultValue == null && o.defaultValue !== v && (o.defaultValue = v)), w != null && (o.defaultValue = "" + w);
  }
  function Jt(o) {
    var l = o.textContent;
    l === o._wrapperState.initialValue && l !== "" && l !== null && (o.value = l);
  }
  function qn(o) {
    switch (o) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Sn(o, l) {
    return o == null || o === "http://www.w3.org/1999/xhtml" ? qn(l) : o === "http://www.w3.org/2000/svg" && l === "foreignObject" ? "http://www.w3.org/1999/xhtml" : o;
  }
  var qe, yt = function(o) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(l, v, w, b) {
      MSApp.execUnsafeLocalFunction(function() {
        return o(l, v, w, b);
      });
    } : o;
  }(function(o, l) {
    if (o.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in o) o.innerHTML = l;
    else {
      for (qe = qe || document.createElement("div"), qe.innerHTML = "<svg>" + l.valueOf().toString() + "</svg>", l = qe.firstChild; o.firstChild; ) o.removeChild(o.firstChild);
      for (; l.firstChild; ) o.appendChild(l.firstChild);
    }
  });
  function Ct(o, l) {
    if (l) {
      var v = o.firstChild;
      if (v && v === o.lastChild && v.nodeType === 3) {
        v.nodeValue = l;
        return;
      }
    }
    o.textContent = l;
  }
  var ln = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, cr = ["Webkit", "ms", "Moz", "O"];
  Object.keys(ln).forEach(function(o) {
    cr.forEach(function(l) {
      l = l + o.charAt(0).toUpperCase() + o.substring(1), ln[l] = ln[o];
    });
  });
  function ta(o, l, v) {
    return l == null || typeof l == "boolean" || l === "" ? "" : v || typeof l != "number" || l === 0 || ln.hasOwnProperty(o) && ln[o] ? ("" + l).trim() : l + "px";
  }
  function xr(o, l) {
    o = o.style;
    for (var v in l) if (l.hasOwnProperty(v)) {
      var w = v.indexOf("--") === 0, b = ta(v, l[v], w);
      v === "float" && (v = "cssFloat"), w ? o.setProperty(v, b) : o[v] = b;
    }
  }
  var Ao = Ze({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function wn(o, l) {
    if (l) {
      if (Ao[o] && (l.children != null || l.dangerouslySetInnerHTML != null)) throw Error(a(137, o));
      if (l.dangerouslySetInnerHTML != null) {
        if (l.children != null) throw Error(a(60));
        if (typeof l.dangerouslySetInnerHTML != "object" || !("__html" in l.dangerouslySetInnerHTML)) throw Error(a(61));
      }
      if (l.style != null && typeof l.style != "object") throw Error(a(62));
    }
  }
  function Gn(o, l) {
    if (o.indexOf("-") === -1) return typeof l.is == "string";
    switch (o) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var T1 = null;
  function Ri(o) {
    return o = o.target || o.srcElement || window, o.correspondingUseElement && (o = o.correspondingUseElement), o.nodeType === 3 ? o.parentNode : o;
  }
  var Jl = null, qi = null, El = null;
  function F0(o) {
    if (o = zt(o)) {
      if (typeof Jl != "function") throw Error(a(280));
      var l = o.stateNode;
      l && (l = Fs(l), Jl(o.stateNode, o.type, l));
    }
  }
  function O1(o) {
    qi ? El ? El.push(o) : El = [o] : qi = o;
  }
  function bf() {
    if (qi) {
      var o = qi, l = El;
      if (El = qi = null, F0(o), l) for (o = 0; o < l.length; o++) F0(l[o]);
    }
  }
  function D1(o, l) {
    return o(l);
  }
  function Zu() {
  }
  var Ml = !1;
  function Tl(o, l, v) {
    if (Ml) return o(l, v);
    Ml = !0;
    try {
      return D1(o, l, v);
    } finally {
      Ml = !1, (qi !== null || El !== null) && (Zu(), bf());
    }
  }
  function Wo(o, l) {
    var v = o.stateNode;
    if (v === null) return null;
    var w = Fs(v);
    if (w === null) return null;
    v = w[l];
    e: switch (l) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (w = !w.disabled) || (o = o.type, w = !(o === "button" || o === "input" || o === "select" || o === "textarea")), o = !w;
        break e;
      default:
        o = !1;
    }
    if (o) return null;
    if (v && typeof v != "function") throw Error(a(231, l, typeof v));
    return v;
  }
  var Ol = !1;
  if (C) try {
    var eu = {};
    Object.defineProperty(eu, "passive", { get: function() {
      Ol = !0;
    } }), window.addEventListener("test", eu, eu), window.removeEventListener("test", eu, eu);
  } catch {
    Ol = !1;
  }
  function js(o, l, v, w, b, E, Z, z, ee) {
    var ye = Array.prototype.slice.call(arguments, 3);
    try {
      l.apply(v, ye);
    } catch (Ne) {
      this.onError(Ne);
    }
  }
  var tu = !1, Gi = null, X = !1, $e = null, dt = { onError: function(o) {
    tu = !0, Gi = o;
  } };
  function Et(o, l, v, w, b, E, Z, z, ee) {
    tu = !1, Gi = null, js.apply(dt, arguments);
  }
  function Nn(o, l, v, w, b, E, Z, z, ee) {
    if (Et.apply(this, arguments), tu) {
      if (tu) {
        var ye = Gi;
        tu = !1, Gi = null;
      } else throw Error(a(198));
      X || (X = !0, $e = ye);
    }
  }
  function yn(o) {
    var l = o, v = o;
    if (o.alternate) for (; l.return; ) l = l.return;
    else {
      o = l;
      do
        l = o, l.flags & 4098 && (v = l.return), o = l.return;
      while (o);
    }
    return l.tag === 3 ? v : null;
  }
  function dn(o) {
    if (o.tag === 13) {
      var l = o.memoizedState;
      if (l === null && (o = o.alternate, o !== null && (l = o.memoizedState)), l !== null) return l.dehydrated;
    }
    return null;
  }
  function hn(o) {
    if (yn(o) !== o) throw Error(a(188));
  }
  function Za(o) {
    var l = o.alternate;
    if (!l) {
      if (l = yn(o), l === null) throw Error(a(188));
      return l !== o ? null : o;
    }
    for (var v = o, w = l; ; ) {
      var b = v.return;
      if (b === null) break;
      var E = b.alternate;
      if (E === null) {
        if (w = b.return, w !== null) {
          v = w;
          continue;
        }
        break;
      }
      if (b.child === E.child) {
        for (E = b.child; E; ) {
          if (E === v) return hn(b), o;
          if (E === w) return hn(b), l;
          E = E.sibling;
        }
        throw Error(a(188));
      }
      if (v.return !== w.return) v = b, w = E;
      else {
        for (var Z = !1, z = b.child; z; ) {
          if (z === v) {
            Z = !0, v = b, w = E;
            break;
          }
          if (z === w) {
            Z = !0, w = b, v = E;
            break;
          }
          z = z.sibling;
        }
        if (!Z) {
          for (z = E.child; z; ) {
            if (z === v) {
              Z = !0, v = E, w = b;
              break;
            }
            if (z === w) {
              Z = !0, w = E, v = b;
              break;
            }
            z = z.sibling;
          }
          if (!Z) throw Error(a(189));
        }
      }
      if (v.alternate !== w) throw Error(a(190));
    }
    if (v.tag !== 3) throw Error(a(188));
    return v.stateNode.current === v ? o : l;
  }
  function Rr(o) {
    return o = Za(o), o !== null ? Er(o) : null;
  }
  function Er(o) {
    if (o.tag === 5 || o.tag === 6) return o;
    for (o = o.child; o !== null; ) {
      var l = Er(o);
      if (l !== null) return l;
      o = o.sibling;
    }
    return null;
  }
  var ho = t.unstable_scheduleCallback, vo = t.unstable_cancelCallback, Gt = t.unstable_shouldYield, na = t.unstable_requestPaint, Jn = t.unstable_now, _f = t.unstable_getCurrentPriorityLevel, j1 = t.unstable_ImmediatePriority, Eh = t.unstable_UserBlockingPriority, A1 = t.unstable_NormalPriority, Mh = t.unstable_LowPriority, Rf = t.unstable_IdlePriority, U0 = null, Dl = null;
  function Yp(o) {
    if (Dl && typeof Dl.onCommitFiberRoot == "function") try {
      Dl.onCommitFiberRoot(U0, o, void 0, (o.current.flags & 128) === 128);
    } catch {
    }
  }
  var zo = Math.clz32 ? Math.clz32 : Mf, Ef = Math.log, nu = Math.LN2;
  function Mf(o) {
    return o >>>= 0, o === 0 ? 32 : 31 - (Ef(o) / nu | 0) | 0;
  }
  var ru = 64, Tf = 4194304;
  function Pu(o) {
    switch (o & -o) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return o & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return o;
    }
  }
  function As(o, l) {
    var v = o.pendingLanes;
    if (v === 0) return 0;
    var w = 0, b = o.suspendedLanes, E = o.pingedLanes, Z = v & 268435455;
    if (Z !== 0) {
      var z = Z & ~b;
      z !== 0 ? w = Pu(z) : (E &= Z, E !== 0 && (w = Pu(E)));
    } else Z = v & ~b, Z !== 0 ? w = Pu(Z) : E !== 0 && (w = Pu(E));
    if (w === 0) return 0;
    if (l !== 0 && l !== w && !(l & b) && (b = w & -w, E = l & -l, b >= E || b === 16 && (E & 4194240) !== 0)) return l;
    if (w & 4 && (w |= v & 16), l = o.entangledLanes, l !== 0) for (o = o.entanglements, l &= w; 0 < l; ) v = 31 - zo(l), b = 1 << v, w |= o[v], l &= ~b;
    return w;
  }
  function Of(o, l) {
    switch (o) {
      case 1:
      case 2:
      case 4:
        return l + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function $p(o, l) {
    for (var v = o.suspendedLanes, w = o.pingedLanes, b = o.expirationTimes, E = o.pendingLanes; 0 < E; ) {
      var Z = 31 - zo(E), z = 1 << Z, ee = b[Z];
      ee === -1 ? (!(z & v) || z & w) && (b[Z] = Of(z, l)) : ee <= l && (o.expiredLanes |= z), E &= ~z;
    }
  }
  function k1(o) {
    return o = o.pendingLanes & -1073741825, o !== 0 ? o : o & 1073741824 ? 1073741824 : 0;
  }
  function Th() {
    var o = ru;
    return ru <<= 1, !(ru & 4194240) && (ru = 64), o;
  }
  function L1(o) {
    for (var l = [], v = 0; 31 > v; v++) l.push(o);
    return l;
  }
  function Y0(o, l, v) {
    o.pendingLanes |= l, l !== 536870912 && (o.suspendedLanes = 0, o.pingedLanes = 0), o = o.eventTimes, l = 31 - zo(l), o[l] = v;
  }
  function Oh(o, l) {
    var v = o.pendingLanes & ~l;
    o.pendingLanes = l, o.suspendedLanes = 0, o.pingedLanes = 0, o.expiredLanes &= l, o.mutableReadLanes &= l, o.entangledLanes &= l, l = o.entanglements;
    var w = o.eventTimes;
    for (o = o.expirationTimes; 0 < v; ) {
      var b = 31 - zo(v), E = 1 << b;
      l[b] = 0, w[b] = -1, o[b] = -1, v &= ~E;
    }
  }
  function In(o, l) {
    var v = o.entangledLanes |= l;
    for (o = o.entanglements; v; ) {
      var w = 31 - zo(v), b = 1 << w;
      b & l | o[w] & l && (o[w] |= l), v &= ~b;
    }
  }
  var Bn = 0;
  function Vu(o) {
    return o &= -o, 1 < o ? 4 < o ? o & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var en, $0, ko, ks, Ls, Df = !1, va = [], tr = null, Nu = null, Pa = null, Va = /* @__PURE__ */ new Map(), Ei = /* @__PURE__ */ new Map(), Bu = [], Dh = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function jh(o, l) {
    switch (o) {
      case "focusin":
      case "focusout":
        tr = null;
        break;
      case "dragenter":
      case "dragleave":
        Nu = null;
        break;
      case "mouseover":
      case "mouseout":
        Pa = null;
        break;
      case "pointerover":
      case "pointerout":
        Va.delete(l.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Ei.delete(l.pointerId);
    }
  }
  function Fu(o, l, v, w, b, E) {
    return o === null || o.nativeEvent !== E ? (o = { blockedOn: l, domEventName: v, eventSystemFlags: w, nativeEvent: E, targetContainers: [b] }, l !== null && (l = zt(l), l !== null && $0(l)), o) : (o.eventSystemFlags |= w, l = o.targetContainers, b !== null && l.indexOf(b) === -1 && l.push(b), o);
  }
  function Wp(o, l, v, w, b) {
    switch (l) {
      case "focusin":
        return tr = Fu(tr, o, l, v, w, b), !0;
      case "dragenter":
        return Nu = Fu(Nu, o, l, v, w, b), !0;
      case "mouseover":
        return Pa = Fu(Pa, o, l, v, w, b), !0;
      case "pointerover":
        var E = b.pointerId;
        return Va.set(E, Fu(Va.get(E) || null, o, l, v, w, b)), !0;
      case "gotpointercapture":
        return E = b.pointerId, Ei.set(E, Fu(Ei.get(E) || null, o, l, v, w, b)), !0;
    }
    return !1;
  }
  function $2(o) {
    var l = fr(o.target);
    if (l !== null) {
      var v = yn(l);
      if (v !== null) {
        if (l = v.tag, l === 13) {
          if (l = dn(v), l !== null) {
            o.blockedOn = l, Ls(o.priority, function() {
              ko(v);
            });
            return;
          }
        } else if (l === 3 && v.stateNode.current.memoizedState.isDehydrated) {
          o.blockedOn = v.tag === 3 ? v.stateNode.containerInfo : null;
          return;
        }
      }
    }
    o.blockedOn = null;
  }
  function jf(o) {
    if (o.blockedOn !== null) return !1;
    for (var l = o.targetContainers; 0 < l.length; ) {
      var v = K0(o.domEventName, o.eventSystemFlags, l[0], o.nativeEvent);
      if (v === null) {
        v = o.nativeEvent;
        var w = new v.constructor(v.type, v);
        T1 = w, v.target.dispatchEvent(w), T1 = null;
      } else return l = zt(v), l !== null && $0(l), o.blockedOn = v, !1;
      l.shift();
    }
    return !0;
  }
  function W0(o, l, v) {
    jf(o) && v.delete(l);
  }
  function W2() {
    Df = !1, tr !== null && jf(tr) && (tr = null), Nu !== null && jf(Nu) && (Nu = null), Pa !== null && jf(Pa) && (Pa = null), Va.forEach(W0), Ei.forEach(W0);
  }
  function Hn(o, l) {
    o.blockedOn === l && (o.blockedOn = null, Df || (Df = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, W2)));
  }
  function Fn(o) {
    function l(b) {
      return Hn(b, o);
    }
    if (0 < va.length) {
      Hn(va[0], o);
      for (var v = 1; v < va.length; v++) {
        var w = va[v];
        w.blockedOn === o && (w.blockedOn = null);
      }
    }
    for (tr !== null && Hn(tr, o), Nu !== null && Hn(Nu, o), Pa !== null && Hn(Pa, o), Va.forEach(l), Ei.forEach(l), v = 0; v < Bu.length; v++) w = Bu[v], w.blockedOn === o && (w.blockedOn = null);
    for (; 0 < Bu.length && (v = Bu[0], v.blockedOn === null); ) $2(v), v.blockedOn === null && Bu.shift();
  }
  var Is = Q.ReactCurrentBatchConfig, z0 = !0;
  function z2(o, l, v, w) {
    var b = Bn, E = Is.transition;
    Is.transition = null;
    try {
      Bn = 1, q0(o, l, v, w);
    } finally {
      Bn = b, Is.transition = E;
    }
  }
  function q2(o, l, v, w) {
    var b = Bn, E = Is.transition;
    Is.transition = null;
    try {
      Bn = 4, q0(o, l, v, w);
    } finally {
      Bn = b, Is.transition = E;
    }
  }
  function q0(o, l, v, w) {
    if (z0) {
      var b = K0(o, l, v, w);
      if (b === null) sc(o, l, w, G0, v), jh(o, w);
      else if (Wp(b, o, l, v, w)) w.stopPropagation();
      else if (jh(o, w), l & 4 && -1 < Dh.indexOf(o)) {
        for (; b !== null; ) {
          var E = zt(b);
          if (E !== null && en(E), E = K0(o, l, v, w), E === null && sc(o, l, w, G0, v), E === b) break;
          b = E;
        }
        b !== null && w.stopPropagation();
      } else sc(o, l, w, null, v);
    }
  }
  var G0 = null;
  function K0(o, l, v, w) {
    if (G0 = null, o = Ri(w), o = fr(o), o !== null) if (l = yn(o), l === null) o = null;
    else if (v = l.tag, v === 13) {
      if (o = dn(l), o !== null) return o;
      o = null;
    } else if (v === 3) {
      if (l.stateNode.current.memoizedState.isDehydrated) return l.tag === 3 ? l.stateNode.containerInfo : null;
      o = null;
    } else l !== o && (o = null);
    return G0 = o, null;
  }
  function Af(o) {
    switch (o) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (_f()) {
          case j1:
            return 1;
          case Eh:
            return 4;
          case A1:
          case Mh:
            return 16;
          case Rf:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Sr = null, Q0 = null, jl = null;
  function X0() {
    if (jl) return jl;
    var o, l = Q0, v = l.length, w, b = "value" in Sr ? Sr.value : Sr.textContent, E = b.length;
    for (o = 0; o < v && l[o] === b[o]; o++) ;
    var Z = v - o;
    for (w = 1; w <= Z && l[v - w] === b[E - w]; w++) ;
    return jl = b.slice(o, 1 < w ? 1 - w : void 0);
  }
  function Hs(o) {
    var l = o.keyCode;
    return "charCode" in o ? (o = o.charCode, o === 0 && l === 13 && (o = 13)) : o = l, o === 10 && (o = 13), 32 <= o || o === 13 ? o : 0;
  }
  function Xa() {
    return !0;
  }
  function kf() {
    return !1;
  }
  function po(o) {
    function l(v, w, b, E, Z) {
      this._reactName = v, this._targetInst = b, this.type = w, this.nativeEvent = E, this.target = Z, this.currentTarget = null;
      for (var z in o) o.hasOwnProperty(z) && (v = o[z], this[z] = v ? v(E) : E[z]);
      return this.isDefaultPrevented = (E.defaultPrevented != null ? E.defaultPrevented : E.returnValue === !1) ? Xa : kf, this.isPropagationStopped = kf, this;
    }
    return Ze(l.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var v = this.nativeEvent;
      v && (v.preventDefault ? v.preventDefault() : typeof v.returnValue != "unknown" && (v.returnValue = !1), this.isDefaultPrevented = Xa);
    }, stopPropagation: function() {
      var v = this.nativeEvent;
      v && (v.stopPropagation ? v.stopPropagation() : typeof v.cancelBubble != "unknown" && (v.cancelBubble = !0), this.isPropagationStopped = Xa);
    }, persist: function() {
    }, isPersistent: Xa }), l;
  }
  var Zs = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(o) {
    return o.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Lf = po(Zs), ra = Ze({}, Zs, { view: 0, detail: 0 }), If = po(ra), Ja, Hf, eo, au = Ze({}, ra, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: tc, button: 0, buttons: 0, relatedTarget: function(o) {
    return o.relatedTarget === void 0 ? o.fromElement === o.srcElement ? o.toElement : o.fromElement : o.relatedTarget;
  }, movementX: function(o) {
    return "movementX" in o ? o.movementX : (o !== eo && (eo && o.type === "mousemove" ? (Ja = o.screenX - eo.screenX, Hf = o.screenY - eo.screenY) : Hf = Ja = 0, eo = o), Ja);
  }, movementY: function(o) {
    return "movementY" in o ? o.movementY : Hf;
  } }), J0 = po(au), ou = Ze({}, au, { dataTransfer: 0 }), Zf = po(ou), Ah = Ze({}, ra, { relatedTarget: 0 }), hr = po(Ah), iu = Ze({}, Zs, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), ec = po(iu), G2 = Ze({}, Zs, { clipboardData: function(o) {
    return "clipboardData" in o ? o.clipboardData : window.clipboardData;
  } }), Pf = po(G2), K2 = Ze({}, Zs, { data: 0 }), Q2 = po(K2), lu = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, X2 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, I1 = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Uu(o) {
    var l = this.nativeEvent;
    return l.getModifierState ? l.getModifierState(o) : (o = I1[o]) ? !!l[o] : !1;
  }
  function tc() {
    return Uu;
  }
  var J2 = Ze({}, ra, { key: function(o) {
    if (o.key) {
      var l = lu[o.key] || o.key;
      if (l !== "Unidentified") return l;
    }
    return o.type === "keypress" ? (o = Hs(o), o === 13 ? "Enter" : String.fromCharCode(o)) : o.type === "keydown" || o.type === "keyup" ? X2[o.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: tc, charCode: function(o) {
    return o.type === "keypress" ? Hs(o) : 0;
  }, keyCode: function(o) {
    return o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  }, which: function(o) {
    return o.type === "keypress" ? Hs(o) : o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  } }), nc = po(J2), Vf = Ze({}, au, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Na = po(Vf), Al = Ze({}, ra, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: tc }), aa = po(Al), Ki = Ze({}, Zs, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), rc = po(Ki), Nf = Ze({}, au, {
    deltaX: function(o) {
      return "deltaX" in o ? o.deltaX : "wheelDeltaX" in o ? -o.wheelDeltaX : 0;
    },
    deltaY: function(o) {
      return "deltaY" in o ? o.deltaY : "wheelDeltaY" in o ? -o.wheelDeltaY : "wheelDelta" in o ? -o.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), ev = po(Nf), Ba = [9, 13, 27, 32], ac = C && "CompositionEvent" in window, uu = null;
  C && "documentMode" in document && (uu = document.documentMode);
  var Bf = C && "TextEvent" in window && !uu, kh = C && (!ac || uu && 8 < uu && 11 >= uu), tv = " ", nv = !1;
  function Lh(o, l) {
    switch (o) {
      case "keyup":
        return Ba.indexOf(l.keyCode) !== -1;
      case "keydown":
        return l.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function rv(o) {
    return o = o.detail, typeof o == "object" && "data" in o ? o.data : null;
  }
  var H1 = !1;
  function Z1(o, l) {
    switch (o) {
      case "compositionend":
        return rv(l);
      case "keypress":
        return l.which !== 32 ? null : (nv = !0, tv);
      case "textInput":
        return o = l.data, o === tv && nv ? null : o;
      default:
        return null;
    }
  }
  function av(o, l) {
    if (H1) return o === "compositionend" || !ac && Lh(o, l) ? (o = X0(), jl = Q0 = Sr = null, H1 = !1, o) : null;
    switch (o) {
      case "paste":
        return null;
      case "keypress":
        if (!(l.ctrlKey || l.altKey || l.metaKey) || l.ctrlKey && l.altKey) {
          if (l.char && 1 < l.char.length) return l.char;
          if (l.which) return String.fromCharCode(l.which);
        }
        return null;
      case "compositionend":
        return kh && l.locale !== "ko" ? null : l.data;
      default:
        return null;
    }
  }
  var P1 = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function V1(o) {
    var l = o && o.nodeName && o.nodeName.toLowerCase();
    return l === "input" ? !!P1[o.type] : l === "textarea";
  }
  function Ff(o, l, v, w) {
    O1(w), l = cc(l, "onChange"), 0 < l.length && (v = new Lf("onChange", "change", null, v, w), o.push({ event: v, listeners: l }));
  }
  var qo = null, Yu = null;
  function zp(o) {
    sv(o, 0);
  }
  function Uf(o) {
    var l = Kt(o);
    if (Wn(l)) return o;
  }
  function qp(o, l) {
    if (o === "change") return l;
  }
  var Ps = !1;
  if (C) {
    var Go;
    if (C) {
      var Yf = "oninput" in document;
      if (!Yf) {
        var ov = document.createElement("div");
        ov.setAttribute("oninput", "return;"), Yf = typeof ov.oninput == "function";
      }
      Go = Yf;
    } else Go = !1;
    Ps = Go && (!document.documentMode || 9 < document.documentMode);
  }
  function Ih() {
    qo && (qo.detachEvent("onpropertychange", iv), Yu = qo = null);
  }
  function iv(o) {
    if (o.propertyName === "value" && Uf(Yu)) {
      var l = [];
      Ff(l, Yu, o, Ri(o)), Tl(zp, l);
    }
  }
  function lv(o, l, v) {
    o === "focusin" ? (Ih(), qo = l, Yu = v, qo.attachEvent("onpropertychange", iv)) : o === "focusout" && Ih();
  }
  function Gp(o) {
    if (o === "selectionchange" || o === "keyup" || o === "keydown") return Uf(Yu);
  }
  function N1(o, l) {
    if (o === "click") return Uf(l);
  }
  function ue(o, l) {
    if (o === "input" || o === "change") return Uf(l);
  }
  function Re(o, l) {
    return o === l && (o !== 0 || 1 / o === 1 / l) || o !== o && l !== l;
  }
  var ge = typeof Object.is == "function" ? Object.is : Re;
  function Je(o, l) {
    if (ge(o, l)) return !0;
    if (typeof o != "object" || o === null || typeof l != "object" || l === null) return !1;
    var v = Object.keys(o), w = Object.keys(l);
    if (v.length !== w.length) return !1;
    for (w = 0; w < v.length; w++) {
      var b = v[w];
      if (!S.call(l, b) || !ge(o[b], l[b])) return !1;
    }
    return !0;
  }
  function Wt(o) {
    for (; o && o.firstChild; ) o = o.firstChild;
    return o;
  }
  function Rn(o, l) {
    var v = Wt(o);
    o = 0;
    for (var w; v; ) {
      if (v.nodeType === 3) {
        if (w = o + v.textContent.length, o <= l && w >= l) return { node: v, offset: l - o };
        o = w;
      }
      e: {
        for (; v; ) {
          if (v.nextSibling) {
            v = v.nextSibling;
            break e;
          }
          v = v.parentNode;
        }
        v = void 0;
      }
      v = Wt(v);
    }
  }
  function Cr(o, l) {
    return o && l ? o === l ? !0 : o && o.nodeType === 3 ? !1 : l && l.nodeType === 3 ? Cr(o, l.parentNode) : "contains" in o ? o.contains(l) : o.compareDocumentPosition ? !!(o.compareDocumentPosition(l) & 16) : !1 : !1;
  }
  function nr() {
    for (var o = window, l = sr(); l instanceof o.HTMLIFrameElement; ) {
      try {
        var v = typeof l.contentWindow.location.href == "string";
      } catch {
        v = !1;
      }
      if (v) o = l.contentWindow;
      else break;
      l = sr(o.document);
    }
    return l;
  }
  function oc(o) {
    var l = o && o.nodeName && o.nodeName.toLowerCase();
    return l && (l === "input" && (o.type === "text" || o.type === "search" || o.type === "tel" || o.type === "url" || o.type === "password") || l === "textarea" || o.contentEditable === "true");
  }
  function Kp(o) {
    var l = nr(), v = o.focusedElem, w = o.selectionRange;
    if (l !== v && v && v.ownerDocument && Cr(v.ownerDocument.documentElement, v)) {
      if (w !== null && oc(v)) {
        if (l = w.start, o = w.end, o === void 0 && (o = l), "selectionStart" in v) v.selectionStart = l, v.selectionEnd = Math.min(o, v.value.length);
        else if (o = (l = v.ownerDocument || document) && l.defaultView || window, o.getSelection) {
          o = o.getSelection();
          var b = v.textContent.length, E = Math.min(w.start, b);
          w = w.end === void 0 ? E : Math.min(w.end, b), !o.extend && E > w && (b = w, w = E, E = b), b = Rn(v, E);
          var Z = Rn(
            v,
            w
          );
          b && Z && (o.rangeCount !== 1 || o.anchorNode !== b.node || o.anchorOffset !== b.offset || o.focusNode !== Z.node || o.focusOffset !== Z.offset) && (l = l.createRange(), l.setStart(b.node, b.offset), o.removeAllRanges(), E > w ? (o.addRange(l), o.extend(Z.node, Z.offset)) : (l.setEnd(Z.node, Z.offset), o.addRange(l)));
        }
      }
      for (l = [], o = v; o = o.parentNode; ) o.nodeType === 1 && l.push({ element: o, left: o.scrollLeft, top: o.scrollTop });
      for (typeof v.focus == "function" && v.focus(), v = 0; v < l.length; v++) o = l[v], o.element.scrollLeft = o.left, o.element.scrollTop = o.top;
    }
  }
  var Mi = C && "documentMode" in document && 11 >= document.documentMode, su = null, $f = null, kl = null, Vs = !1;
  function pa(o, l, v) {
    var w = v.window === v ? v.document : v.nodeType === 9 ? v : v.ownerDocument;
    Vs || su == null || su !== sr(w) || (w = su, "selectionStart" in w && oc(w) ? w = { start: w.selectionStart, end: w.selectionEnd } : (w = (w.ownerDocument && w.ownerDocument.defaultView || window).getSelection(), w = { anchorNode: w.anchorNode, anchorOffset: w.anchorOffset, focusNode: w.focusNode, focusOffset: w.focusOffset }), kl && Je(kl, w) || (kl = w, w = cc($f, "onSelect"), 0 < w.length && (l = new Lf("onSelect", "select", null, l, v), o.push({ event: l, listeners: w }), l.target = su)));
  }
  function En(o, l) {
    var v = {};
    return v[o.toLowerCase()] = l.toLowerCase(), v["Webkit" + o] = "webkit" + l, v["Moz" + o] = "moz" + l, v;
  }
  var B1 = { animationend: En("Animation", "AnimationEnd"), animationiteration: En("Animation", "AnimationIteration"), animationstart: En("Animation", "AnimationStart"), transitionend: En("Transition", "TransitionEnd") }, Wf = {}, ic = {};
  C && (ic = document.createElement("div").style, "AnimationEvent" in window || (delete B1.animationend.animation, delete B1.animationiteration.animation, delete B1.animationstart.animation), "TransitionEvent" in window || delete B1.transitionend.transition);
  function zf(o) {
    if (Wf[o]) return Wf[o];
    if (!B1[o]) return o;
    var l = B1[o], v;
    for (v in l) if (l.hasOwnProperty(v) && v in ic) return Wf[o] = l[v];
    return o;
  }
  var uv = zf("animationend"), Hh = zf("animationiteration"), Ns = zf("animationstart"), Ko = zf("transitionend"), lc = /* @__PURE__ */ new Map(), Bs = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Qi(o, l) {
    lc.set(o, l), g(l, [o]);
  }
  for (var qf = 0; qf < Bs.length; qf++) {
    var Gf = Bs[qf], F1 = Gf.toLowerCase(), Kf = Gf[0].toUpperCase() + Gf.slice(1);
    Qi(F1, "on" + Kf);
  }
  Qi(uv, "onAnimationEnd"), Qi(Hh, "onAnimationIteration"), Qi(Ns, "onAnimationStart"), Qi("dblclick", "onDoubleClick"), Qi("focusin", "onFocus"), Qi("focusout", "onBlur"), Qi(Ko, "onTransitionEnd"), m("onMouseEnter", ["mouseout", "mouseover"]), m("onMouseLeave", ["mouseout", "mouseover"]), m("onPointerEnter", ["pointerout", "pointerover"]), m("onPointerLeave", ["pointerout", "pointerover"]), g("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), g("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), g("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), g("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Lo = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ti = new Set("cancel close invalid load scroll toggle".split(" ").concat(Lo));
  function U1(o, l, v) {
    var w = o.type || "unknown-event";
    o.currentTarget = v, Nn(w, l, void 0, o), o.currentTarget = null;
  }
  function sv(o, l) {
    l = (l & 4) !== 0;
    for (var v = 0; v < o.length; v++) {
      var w = o[v], b = w.event;
      w = w.listeners;
      e: {
        var E = void 0;
        if (l) for (var Z = w.length - 1; 0 <= Z; Z--) {
          var z = w[Z], ee = z.instance, ye = z.currentTarget;
          if (z = z.listener, ee !== E && b.isPropagationStopped()) break e;
          U1(b, z, ye), E = ee;
        }
        else for (Z = 0; Z < w.length; Z++) {
          if (z = w[Z], ee = z.instance, ye = z.currentTarget, z = z.listener, ee !== E && b.isPropagationStopped()) break e;
          U1(b, z, ye), E = ee;
        }
      }
    }
    if (X) throw o = $e, X = !1, $e = null, o;
  }
  function vr(o, l) {
    var v = l[Xf];
    v === void 0 && (v = l[Xf] = /* @__PURE__ */ new Set());
    var w = o + "__bubble";
    v.has(w) || (uc(l, o, 2, !1), v.add(w));
  }
  function Zh(o, l, v) {
    var w = 0;
    l && (w |= 4), uc(v, o, w, l);
  }
  var $u = "_reactListening" + Math.random().toString(36).slice(2);
  function cu(o) {
    if (!o[$u]) {
      o[$u] = !0, i.forEach(function(v) {
        v !== "selectionchange" && (Ti.has(v) || Zh(v, !1, o), Zh(v, !0, o));
      });
      var l = o.nodeType === 9 ? o : o.ownerDocument;
      l === null || l[$u] || (l[$u] = !0, Zh("selectionchange", !1, l));
    }
  }
  function uc(o, l, v, w) {
    switch (Af(l)) {
      case 1:
        var b = z2;
        break;
      case 4:
        b = q2;
        break;
      default:
        b = q0;
    }
    v = b.bind(null, l, v, o), b = void 0, !Ol || l !== "touchstart" && l !== "touchmove" && l !== "wheel" || (b = !0), w ? b !== void 0 ? o.addEventListener(l, v, { capture: !0, passive: b }) : o.addEventListener(l, v, !0) : b !== void 0 ? o.addEventListener(l, v, { passive: b }) : o.addEventListener(l, v, !1);
  }
  function sc(o, l, v, w, b) {
    var E = w;
    if (!(l & 1) && !(l & 2) && w !== null) e: for (; ; ) {
      if (w === null) return;
      var Z = w.tag;
      if (Z === 3 || Z === 4) {
        var z = w.stateNode.containerInfo;
        if (z === b || z.nodeType === 8 && z.parentNode === b) break;
        if (Z === 4) for (Z = w.return; Z !== null; ) {
          var ee = Z.tag;
          if ((ee === 3 || ee === 4) && (ee = Z.stateNode.containerInfo, ee === b || ee.nodeType === 8 && ee.parentNode === b)) return;
          Z = Z.return;
        }
        for (; z !== null; ) {
          if (Z = fr(z), Z === null) return;
          if (ee = Z.tag, ee === 5 || ee === 6) {
            w = E = Z;
            continue e;
          }
          z = z.parentNode;
        }
      }
      w = w.return;
    }
    Tl(function() {
      var ye = E, Ne = Ri(v), Ye = [];
      e: {
        var Ve = lc.get(o);
        if (Ve !== void 0) {
          var lt = Lf, xt = o;
          switch (o) {
            case "keypress":
              if (Hs(v) === 0) break e;
            case "keydown":
            case "keyup":
              lt = nc;
              break;
            case "focusin":
              xt = "focus", lt = hr;
              break;
            case "focusout":
              xt = "blur", lt = hr;
              break;
            case "beforeblur":
            case "afterblur":
              lt = hr;
              break;
            case "click":
              if (v.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              lt = J0;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              lt = Zf;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              lt = aa;
              break;
            case uv:
            case Hh:
            case Ns:
              lt = ec;
              break;
            case Ko:
              lt = rc;
              break;
            case "scroll":
              lt = If;
              break;
            case "wheel":
              lt = ev;
              break;
            case "copy":
            case "cut":
            case "paste":
              lt = Pf;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              lt = Na;
          }
          var bt = (l & 4) !== 0, Gr = !bt && o === "scroll", ce = bt ? Ve !== null ? Ve + "Capture" : null : Ve;
          bt = [];
          for (var ne = ye, he; ne !== null; ) {
            he = ne;
            var ze = he.stateNode;
            if (he.tag === 5 && ze !== null && (he = ze, ce !== null && (ze = Wo(ne, ce), ze != null && bt.push(Y1(ne, ze, he)))), Gr) break;
            ne = ne.return;
          }
          0 < bt.length && (Ve = new lt(Ve, xt, null, v, Ne), Ye.push({ event: Ve, listeners: bt }));
        }
      }
      if (!(l & 7)) {
        e: {
          if (Ve = o === "mouseover" || o === "pointerover", lt = o === "mouseout" || o === "pointerout", Ve && v !== T1 && (xt = v.relatedTarget || v.fromElement) && (fr(xt) || xt[Jo])) break e;
          if ((lt || Ve) && (Ve = Ne.window === Ne ? Ne : (Ve = Ne.ownerDocument) ? Ve.defaultView || Ve.parentWindow : window, lt ? (xt = v.relatedTarget || v.toElement, lt = ye, xt = xt ? fr(xt) : null, xt !== null && (Gr = yn(xt), xt !== Gr || xt.tag !== 5 && xt.tag !== 6) && (xt = null)) : (lt = null, xt = ye), lt !== xt)) {
            if (bt = J0, ze = "onMouseLeave", ce = "onMouseEnter", ne = "mouse", (o === "pointerout" || o === "pointerover") && (bt = Na, ze = "onPointerLeave", ce = "onPointerEnter", ne = "pointer"), Gr = lt == null ? Ve : Kt(lt), he = xt == null ? Ve : Kt(xt), Ve = new bt(ze, ne + "leave", lt, v, Ne), Ve.target = Gr, Ve.relatedTarget = he, ze = null, fr(Ne) === ye && (bt = new bt(ce, ne + "enter", xt, v, Ne), bt.target = he, bt.relatedTarget = Gr, ze = bt), Gr = ze, lt && xt) t: {
              for (bt = lt, ce = xt, ne = 0, he = bt; he; he = $1(he)) ne++;
              for (he = 0, ze = ce; ze; ze = $1(ze)) he++;
              for (; 0 < ne - he; ) bt = $1(bt), ne--;
              for (; 0 < he - ne; ) ce = $1(ce), he--;
              for (; ne--; ) {
                if (bt === ce || ce !== null && bt === ce.alternate) break t;
                bt = $1(bt), ce = $1(ce);
              }
              bt = null;
            }
            else bt = null;
            lt !== null && oa(Ye, Ve, lt, bt, !1), xt !== null && Gr !== null && oa(Ye, Gr, xt, bt, !0);
          }
        }
        e: {
          if (Ve = ye ? Kt(ye) : window, lt = Ve.nodeName && Ve.nodeName.toLowerCase(), lt === "select" || lt === "input" && Ve.type === "file") var Tt = qp;
          else if (V1(Ve)) if (Ps) Tt = ue;
          else {
            Tt = Gp;
            var Bt = lv;
          }
          else (lt = Ve.nodeName) && lt.toLowerCase() === "input" && (Ve.type === "checkbox" || Ve.type === "radio") && (Tt = N1);
          if (Tt && (Tt = Tt(o, ye))) {
            Ff(Ye, Tt, v, Ne);
            break e;
          }
          Bt && Bt(o, Ve, ye), o === "focusout" && (Bt = Ve._wrapperState) && Bt.controlled && Ve.type === "number" && Ln(Ve, "number", Ve.value);
        }
        switch (Bt = ye ? Kt(ye) : window, o) {
          case "focusin":
            (V1(Bt) || Bt.contentEditable === "true") && (su = Bt, $f = ye, kl = null);
            break;
          case "focusout":
            kl = $f = su = null;
            break;
          case "mousedown":
            Vs = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Vs = !1, pa(Ye, v, Ne);
            break;
          case "selectionchange":
            if (Mi) break;
          case "keydown":
          case "keyup":
            pa(Ye, v, Ne);
        }
        var Ht;
        if (ac) e: {
          switch (o) {
            case "compositionstart":
              var qt = "onCompositionStart";
              break e;
            case "compositionend":
              qt = "onCompositionEnd";
              break e;
            case "compositionupdate":
              qt = "onCompositionUpdate";
              break e;
          }
          qt = void 0;
        }
        else H1 ? Lh(o, v) && (qt = "onCompositionEnd") : o === "keydown" && v.keyCode === 229 && (qt = "onCompositionStart");
        qt && (kh && v.locale !== "ko" && (H1 || qt !== "onCompositionStart" ? qt === "onCompositionEnd" && H1 && (Ht = X0()) : (Sr = Ne, Q0 = "value" in Sr ? Sr.value : Sr.textContent, H1 = !0)), Bt = cc(ye, qt), 0 < Bt.length && (qt = new Q2(qt, o, null, v, Ne), Ye.push({ event: qt, listeners: Bt }), Ht ? qt.data = Ht : (Ht = rv(v), Ht !== null && (qt.data = Ht)))), (Ht = Bf ? Z1(o, v) : av(o, v)) && (ye = cc(ye, "onBeforeInput"), 0 < ye.length && (Ne = new Q2("onBeforeInput", "beforeinput", null, v, Ne), Ye.push({ event: Ne, listeners: ye }), Ne.data = Ht));
      }
      sv(Ye, l);
    });
  }
  function Y1(o, l, v) {
    return { instance: o, listener: l, currentTarget: v };
  }
  function cc(o, l) {
    for (var v = l + "Capture", w = []; o !== null; ) {
      var b = o, E = b.stateNode;
      b.tag === 5 && E !== null && (b = E, E = Wo(o, v), E != null && w.unshift(Y1(o, E, b)), E = Wo(o, l), E != null && w.push(Y1(o, E, b))), o = o.return;
    }
    return w;
  }
  function $1(o) {
    if (o === null) return null;
    do
      o = o.return;
    while (o && o.tag !== 5);
    return o || null;
  }
  function oa(o, l, v, w, b) {
    for (var E = l._reactName, Z = []; v !== null && v !== w; ) {
      var z = v, ee = z.alternate, ye = z.stateNode;
      if (ee !== null && ee === w) break;
      z.tag === 5 && ye !== null && (z = ye, b ? (ee = Wo(v, E), ee != null && Z.unshift(Y1(v, ee, z))) : b || (ee = Wo(v, E), ee != null && Z.push(Y1(v, ee, z)))), v = v.return;
    }
    Z.length !== 0 && o.push({ event: l, listeners: Z });
  }
  var to = /\r\n?/g, fc = /\u0000|\uFFFD/g;
  function Qf(o) {
    return (typeof o == "string" ? o : "" + o).replace(to, `
`).replace(fc, "");
  }
  function fu(o, l, v) {
    if (l = Qf(l), Qf(o) !== l && v) throw Error(a(425));
  }
  function dc() {
  }
  var W1 = null, du = null;
  function hc(o, l) {
    return o === "textarea" || o === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
  }
  var Qo = typeof setTimeout == "function" ? setTimeout : void 0, Wu = typeof clearTimeout == "function" ? clearTimeout : void 0, hu = typeof Promise == "function" ? Promise : void 0, z1 = typeof queueMicrotask == "function" ? queueMicrotask : typeof hu < "u" ? function(o) {
    return hu.resolve(null).then(o).catch(q1);
  } : Qo;
  function q1(o) {
    setTimeout(function() {
      throw o;
    });
  }
  function vc(o, l) {
    var v = l, w = 0;
    do {
      var b = v.nextSibling;
      if (o.removeChild(v), b && b.nodeType === 8) if (v = b.data, v === "/$") {
        if (w === 0) {
          o.removeChild(b), Fn(l);
          return;
        }
        w--;
      } else v !== "$" && v !== "$?" && v !== "$!" || w++;
      v = b;
    } while (v);
    Fn(l);
  }
  function zu(o) {
    for (; o != null; o = o.nextSibling) {
      var l = o.nodeType;
      if (l === 1 || l === 3) break;
      if (l === 8) {
        if (l = o.data, l === "$" || l === "$!" || l === "$?") break;
        if (l === "/$") return null;
      }
    }
    return o;
  }
  function cv(o) {
    o = o.previousSibling;
    for (var l = 0; o; ) {
      if (o.nodeType === 8) {
        var v = o.data;
        if (v === "$" || v === "$!" || v === "$?") {
          if (l === 0) return o;
          l--;
        } else v === "/$" && l++;
      }
      o = o.previousSibling;
    }
    return null;
  }
  var G1 = Math.random().toString(36).slice(2), Oi = "__reactFiber$" + G1, Xo = "__reactProps$" + G1, Jo = "__reactContainer$" + G1, Xf = "__reactEvents$" + G1, H = "__reactListeners$" + G1, Xi = "__reactHandles$" + G1;
  function fr(o) {
    var l = o[Oi];
    if (l) return l;
    for (var v = o.parentNode; v; ) {
      if (l = v[Jo] || v[Oi]) {
        if (v = l.alternate, l.child !== null || v !== null && v.child !== null) for (o = cv(o); o !== null; ) {
          if (v = o[Oi]) return v;
          o = cv(o);
        }
        return l;
      }
      o = v, v = o.parentNode;
    }
    return null;
  }
  function zt(o) {
    return o = o[Oi] || o[Jo], !o || o.tag !== 5 && o.tag !== 6 && o.tag !== 13 && o.tag !== 3 ? null : o;
  }
  function Kt(o) {
    if (o.tag === 5 || o.tag === 6) return o.stateNode;
    throw Error(a(33));
  }
  function Fs(o) {
    return o[Xo] || null;
  }
  var Jf = [], vn = -1;
  function ia(o) {
    return { current: o };
  }
  function Un(o) {
    0 > vn || (o.current = Jf[vn], Jf[vn] = null, vn--);
  }
  function Yn(o, l) {
    vn++, Jf[vn] = o.current, o.current = l;
  }
  var mo = {}, Zr = ia(mo), la = ia(!1), Fa = mo;
  function K1(o, l) {
    var v = o.type.contextTypes;
    if (!v) return mo;
    var w = o.stateNode;
    if (w && w.__reactInternalMemoizedUnmaskedChildContext === l) return w.__reactInternalMemoizedMaskedChildContext;
    var b = {}, E;
    for (E in v) b[E] = l[E];
    return w && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = l, o.__reactInternalMemoizedMaskedChildContext = b), b;
  }
  function Ua(o) {
    return o = o.childContextTypes, o != null;
  }
  function Io() {
    Un(la), Un(Zr);
  }
  function ed(o, l, v) {
    if (Zr.current !== mo) throw Error(a(168));
    Yn(Zr, l), Yn(la, v);
  }
  function Ph(o, l, v) {
    var w = o.stateNode;
    if (l = l.childContextTypes, typeof w.getChildContext != "function") return v;
    w = w.getChildContext();
    for (var b in w) if (!(b in l)) throw Error(a(108, wt(o) || "Unknown", b));
    return Ze({}, v, w);
  }
  function Ho(o) {
    return o = (o = o.stateNode) && o.__reactInternalMemoizedMergedChildContext || mo, Fa = Zr.current, Yn(Zr, o), Yn(la, la.current), !0;
  }
  function qu(o, l, v) {
    var w = o.stateNode;
    if (!w) throw Error(a(169));
    v ? (o = Ph(o, l, Fa), w.__reactInternalMemoizedMergedChildContext = o, Un(la), Un(Zr), Yn(Zr, o)) : Un(la), Yn(la, v);
  }
  var Ji = null, el = !1, pc = !1;
  function td(o) {
    Ji === null ? Ji = [o] : Ji.push(o);
  }
  function vu(o) {
    el = !0, td(o);
  }
  function Di() {
    if (!pc && Ji !== null) {
      pc = !0;
      var o = 0, l = Bn;
      try {
        var v = Ji;
        for (Bn = 1; o < v.length; o++) {
          var w = v[o];
          do
            w = w(!0);
          while (w !== null);
        }
        Ji = null, el = !1;
      } catch (b) {
        throw Ji !== null && (Ji = Ji.slice(o + 1)), ho(j1, Di), b;
      } finally {
        Bn = l, pc = !1;
      }
    }
    return null;
  }
  var tl = [], Mr = 0, nd = null, Ll = 0, ei = [], ti = 0, Us = null, Il = 1, nl = "";
  function Gu(o, l) {
    tl[Mr++] = Ll, tl[Mr++] = nd, nd = o, Ll = l;
  }
  function Vh(o, l, v) {
    ei[ti++] = Il, ei[ti++] = nl, ei[ti++] = Us, Us = o;
    var w = Il;
    o = nl;
    var b = 32 - zo(w) - 1;
    w &= ~(1 << b), v += 1;
    var E = 32 - zo(l) + b;
    if (30 < E) {
      var Z = b - b % 5;
      E = (w & (1 << Z) - 1).toString(32), w >>= Z, b -= Z, Il = 1 << 32 - zo(l) + b | v << b | w, nl = E + o;
    } else Il = 1 << E | v << b | w, nl = o;
  }
  function Q1(o) {
    o.return !== null && (Gu(o, 1), Vh(o, 1, 0));
  }
  function Ys(o) {
    for (; o === nd; ) nd = tl[--Mr], tl[Mr] = null, Ll = tl[--Mr], tl[Mr] = null;
    for (; o === Us; ) Us = ei[--ti], ei[ti] = null, nl = ei[--ti], ei[ti] = null, Il = ei[--ti], ei[ti] = null;
  }
  var Ya = null, Zo = null, br = !1, rl = null;
  function Hl(o, l) {
    var v = Vi(5, null, null, 0);
    v.elementType = "DELETED", v.stateNode = l, v.return = o, l = o.deletions, l === null ? (o.deletions = [v], o.flags |= 16) : l.push(v);
  }
  function Yr(o, l) {
    switch (o.tag) {
      case 5:
        var v = o.type;
        return l = l.nodeType !== 1 || v.toLowerCase() !== l.nodeName.toLowerCase() ? null : l, l !== null ? (o.stateNode = l, Ya = o, Zo = zu(l.firstChild), !0) : !1;
      case 6:
        return l = o.pendingProps === "" || l.nodeType !== 3 ? null : l, l !== null ? (o.stateNode = l, Ya = o, Zo = null, !0) : !1;
      case 13:
        return l = l.nodeType !== 8 ? null : l, l !== null ? (v = Us !== null ? { id: Il, overflow: nl } : null, o.memoizedState = { dehydrated: l, treeContext: v, retryLane: 1073741824 }, v = Vi(18, null, null, 0), v.stateNode = l, v.return = o, o.child = v, Ya = o, Zo = null, !0) : !1;
      default:
        return !1;
    }
  }
  function pu(o) {
    return (o.mode & 1) !== 0 && (o.flags & 128) === 0;
  }
  function $a(o) {
    if (br) {
      var l = Zo;
      if (l) {
        var v = l;
        if (!Yr(o, l)) {
          if (pu(o)) throw Error(a(418));
          l = zu(v.nextSibling);
          var w = Ya;
          l && Yr(o, l) ? Hl(w, v) : (o.flags = o.flags & -4097 | 2, br = !1, Ya = o);
        }
      } else {
        if (pu(o)) throw Error(a(418));
        o.flags = o.flags & -4097 | 2, br = !1, Ya = o;
      }
    }
  }
  function rd(o) {
    for (o = o.return; o !== null && o.tag !== 5 && o.tag !== 3 && o.tag !== 13; ) o = o.return;
    Ya = o;
  }
  function al(o) {
    if (o !== Ya) return !1;
    if (!br) return rd(o), br = !0, !1;
    var l;
    if ((l = o.tag !== 3) && !(l = o.tag !== 5) && (l = o.type, l = l !== "head" && l !== "body" && !hc(o.type, o.memoizedProps)), l && (l = Zo)) {
      if (pu(o)) throw Nh(), Error(a(418));
      for (; l; ) Hl(o, l), l = zu(l.nextSibling);
    }
    if (rd(o), o.tag === 13) {
      if (o = o.memoizedState, o = o !== null ? o.dehydrated : null, !o) throw Error(a(317));
      e: {
        for (o = o.nextSibling, l = 0; o; ) {
          if (o.nodeType === 8) {
            var v = o.data;
            if (v === "/$") {
              if (l === 0) {
                Zo = zu(o.nextSibling);
                break e;
              }
              l--;
            } else v !== "$" && v !== "$!" && v !== "$?" || l++;
          }
          o = o.nextSibling;
        }
        Zo = null;
      }
    } else Zo = Ya ? zu(o.stateNode.nextSibling) : null;
    return !0;
  }
  function Nh() {
    for (var o = Zo; o; ) o = zu(o.nextSibling);
  }
  function ji() {
    Zo = Ya = null, br = !1;
  }
  function Zl(o) {
    rl === null ? rl = [o] : rl.push(o);
  }
  var fv = Q.ReactCurrentBatchConfig;
  function Pl(o, l, v) {
    if (o = v.ref, o !== null && typeof o != "function" && typeof o != "object") {
      if (v._owner) {
        if (v = v._owner, v) {
          if (v.tag !== 1) throw Error(a(309));
          var w = v.stateNode;
        }
        if (!w) throw Error(a(147, o));
        var b = w, E = "" + o;
        return l !== null && l.ref !== null && typeof l.ref == "function" && l.ref._stringRef === E ? l.ref : (l = function(Z) {
          var z = b.refs;
          Z === null ? delete z[E] : z[E] = Z;
        }, l._stringRef = E, l);
      }
      if (typeof o != "string") throw Error(a(284));
      if (!v._owner) throw Error(a(290, o));
    }
    return o;
  }
  function Pr(o, l) {
    throw o = Object.prototype.toString.call(l), Error(a(31, o === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : o));
  }
  function at(o) {
    var l = o._init;
    return l(o._payload);
  }
  function Ai(o) {
    function l(ce, ne) {
      if (o) {
        var he = ce.deletions;
        he === null ? (ce.deletions = [ne], ce.flags |= 16) : he.push(ne);
      }
    }
    function v(ce, ne) {
      if (!o) return null;
      for (; ne !== null; ) l(ce, ne), ne = ne.sibling;
      return null;
    }
    function w(ce, ne) {
      for (ce = /* @__PURE__ */ new Map(); ne !== null; ) ne.key !== null ? ce.set(ne.key, ne) : ce.set(ne.index, ne), ne = ne.sibling;
      return ce;
    }
    function b(ce, ne) {
      return ce = So(ce, ne), ce.index = 0, ce.sibling = null, ce;
    }
    function E(ce, ne, he) {
      return ce.index = he, o ? (he = ce.alternate, he !== null ? (he = he.index, he < ne ? (ce.flags |= 2, ne) : he) : (ce.flags |= 2, ne)) : (ce.flags |= 1048576, ne);
    }
    function Z(ce) {
      return o && ce.alternate === null && (ce.flags |= 2), ce;
    }
    function z(ce, ne, he, ze) {
      return ne === null || ne.tag !== 6 ? (ne = jd(he, ce.mode, ze), ne.return = ce, ne) : (ne = b(ne, he), ne.return = ce, ne);
    }
    function ee(ce, ne, he, ze) {
      var Tt = he.type;
      return Tt === te ? Ne(ce, ne, he.props.children, ze, he.key) : ne !== null && (ne.elementType === Tt || typeof Tt == "object" && Tt !== null && Tt.$$typeof === be && at(Tt) === ne.type) ? (ze = b(ne, he.props), ze.ref = Pl(ce, ne, he), ze.return = ce, ze) : (ze = Dd(he.type, he.key, he.props, null, ce.mode, ze), ze.ref = Pl(ce, ne, he), ze.return = ce, ze);
    }
    function ye(ce, ne, he, ze) {
      return ne === null || ne.tag !== 4 || ne.stateNode.containerInfo !== he.containerInfo || ne.stateNode.implementation !== he.implementation ? (ne = Jh(he, ce.mode, ze), ne.return = ce, ne) : (ne = b(ne, he.children || []), ne.return = ce, ne);
    }
    function Ne(ce, ne, he, ze, Tt) {
      return ne === null || ne.tag !== 7 ? (ne = vs(he, ce.mode, ze, Tt), ne.return = ce, ne) : (ne = b(ne, he), ne.return = ce, ne);
    }
    function Ye(ce, ne, he) {
      if (typeof ne == "string" && ne !== "" || typeof ne == "number") return ne = jd("" + ne, ce.mode, he), ne.return = ce, ne;
      if (typeof ne == "object" && ne !== null) {
        switch (ne.$$typeof) {
          case $:
            return he = Dd(ne.type, ne.key, ne.props, null, ce.mode, he), he.ref = Pl(ce, null, ne), he.return = ce, he;
          case le:
            return ne = Jh(ne, ce.mode, he), ne.return = ce, ne;
          case be:
            var ze = ne._init;
            return Ye(ce, ze(ne._payload), he);
        }
        if (Nt(ne) || _e(ne)) return ne = vs(ne, ce.mode, he, null), ne.return = ce, ne;
        Pr(ce, ne);
      }
      return null;
    }
    function Ve(ce, ne, he, ze) {
      var Tt = ne !== null ? ne.key : null;
      if (typeof he == "string" && he !== "" || typeof he == "number") return Tt !== null ? null : z(ce, ne, "" + he, ze);
      if (typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case $:
            return he.key === Tt ? ee(ce, ne, he, ze) : null;
          case le:
            return he.key === Tt ? ye(ce, ne, he, ze) : null;
          case be:
            return Tt = he._init, Ve(
              ce,
              ne,
              Tt(he._payload),
              ze
            );
        }
        if (Nt(he) || _e(he)) return Tt !== null ? null : Ne(ce, ne, he, ze, null);
        Pr(ce, he);
      }
      return null;
    }
    function lt(ce, ne, he, ze, Tt) {
      if (typeof ze == "string" && ze !== "" || typeof ze == "number") return ce = ce.get(he) || null, z(ne, ce, "" + ze, Tt);
      if (typeof ze == "object" && ze !== null) {
        switch (ze.$$typeof) {
          case $:
            return ce = ce.get(ze.key === null ? he : ze.key) || null, ee(ne, ce, ze, Tt);
          case le:
            return ce = ce.get(ze.key === null ? he : ze.key) || null, ye(ne, ce, ze, Tt);
          case be:
            var Bt = ze._init;
            return lt(ce, ne, he, Bt(ze._payload), Tt);
        }
        if (Nt(ze) || _e(ze)) return ce = ce.get(he) || null, Ne(ne, ce, ze, Tt, null);
        Pr(ne, ze);
      }
      return null;
    }
    function xt(ce, ne, he, ze) {
      for (var Tt = null, Bt = null, Ht = ne, qt = ne = 0, ga = null; Ht !== null && qt < he.length; qt++) {
        Ht.index > qt ? (ga = Ht, Ht = null) : ga = Ht.sibling;
        var Tn = Ve(ce, Ht, he[qt], ze);
        if (Tn === null) {
          Ht === null && (Ht = ga);
          break;
        }
        o && Ht && Tn.alternate === null && l(ce, Ht), ne = E(Tn, ne, qt), Bt === null ? Tt = Tn : Bt.sibling = Tn, Bt = Tn, Ht = ga;
      }
      if (qt === he.length) return v(ce, Ht), br && Gu(ce, qt), Tt;
      if (Ht === null) {
        for (; qt < he.length; qt++) Ht = Ye(ce, he[qt], ze), Ht !== null && (ne = E(Ht, ne, qt), Bt === null ? Tt = Ht : Bt.sibling = Ht, Bt = Ht);
        return br && Gu(ce, qt), Tt;
      }
      for (Ht = w(ce, Ht); qt < he.length; qt++) ga = lt(Ht, ce, qt, he[qt], ze), ga !== null && (o && ga.alternate !== null && Ht.delete(ga.key === null ? qt : ga.key), ne = E(ga, ne, qt), Bt === null ? Tt = ga : Bt.sibling = ga, Bt = ga);
      return o && Ht.forEach(function(ms) {
        return l(ce, ms);
      }), br && Gu(ce, qt), Tt;
    }
    function bt(ce, ne, he, ze) {
      var Tt = _e(he);
      if (typeof Tt != "function") throw Error(a(150));
      if (he = Tt.call(he), he == null) throw Error(a(151));
      for (var Bt = Tt = null, Ht = ne, qt = ne = 0, ga = null, Tn = he.next(); Ht !== null && !Tn.done; qt++, Tn = he.next()) {
        Ht.index > qt ? (ga = Ht, Ht = null) : ga = Ht.sibling;
        var ms = Ve(ce, Ht, Tn.value, ze);
        if (ms === null) {
          Ht === null && (Ht = ga);
          break;
        }
        o && Ht && ms.alternate === null && l(ce, Ht), ne = E(ms, ne, qt), Bt === null ? Tt = ms : Bt.sibling = ms, Bt = ms, Ht = ga;
      }
      if (Tn.done) return v(
        ce,
        Ht
      ), br && Gu(ce, qt), Tt;
      if (Ht === null) {
        for (; !Tn.done; qt++, Tn = he.next()) Tn = Ye(ce, Tn.value, ze), Tn !== null && (ne = E(Tn, ne, qt), Bt === null ? Tt = Tn : Bt.sibling = Tn, Bt = Tn);
        return br && Gu(ce, qt), Tt;
      }
      for (Ht = w(ce, Ht); !Tn.done; qt++, Tn = he.next()) Tn = lt(Ht, ce, qt, Tn.value, ze), Tn !== null && (o && Tn.alternate !== null && Ht.delete(Tn.key === null ? qt : Tn.key), ne = E(Tn, ne, qt), Bt === null ? Tt = Tn : Bt.sibling = Tn, Bt = Tn);
      return o && Ht.forEach(function(dm) {
        return l(ce, dm);
      }), br && Gu(ce, qt), Tt;
    }
    function Gr(ce, ne, he, ze) {
      if (typeof he == "object" && he !== null && he.type === te && he.key === null && (he = he.props.children), typeof he == "object" && he !== null) {
        switch (he.$$typeof) {
          case $:
            e: {
              for (var Tt = he.key, Bt = ne; Bt !== null; ) {
                if (Bt.key === Tt) {
                  if (Tt = he.type, Tt === te) {
                    if (Bt.tag === 7) {
                      v(ce, Bt.sibling), ne = b(Bt, he.props.children), ne.return = ce, ce = ne;
                      break e;
                    }
                  } else if (Bt.elementType === Tt || typeof Tt == "object" && Tt !== null && Tt.$$typeof === be && at(Tt) === Bt.type) {
                    v(ce, Bt.sibling), ne = b(Bt, he.props), ne.ref = Pl(ce, Bt, he), ne.return = ce, ce = ne;
                    break e;
                  }
                  v(ce, Bt);
                  break;
                } else l(ce, Bt);
                Bt = Bt.sibling;
              }
              he.type === te ? (ne = vs(he.props.children, ce.mode, ze, he.key), ne.return = ce, ce = ne) : (ze = Dd(he.type, he.key, he.props, null, ce.mode, ze), ze.ref = Pl(ce, ne, he), ze.return = ce, ce = ze);
            }
            return Z(ce);
          case le:
            e: {
              for (Bt = he.key; ne !== null; ) {
                if (ne.key === Bt) if (ne.tag === 4 && ne.stateNode.containerInfo === he.containerInfo && ne.stateNode.implementation === he.implementation) {
                  v(ce, ne.sibling), ne = b(ne, he.children || []), ne.return = ce, ce = ne;
                  break e;
                } else {
                  v(ce, ne);
                  break;
                }
                else l(ce, ne);
                ne = ne.sibling;
              }
              ne = Jh(he, ce.mode, ze), ne.return = ce, ce = ne;
            }
            return Z(ce);
          case be:
            return Bt = he._init, Gr(ce, ne, Bt(he._payload), ze);
        }
        if (Nt(he)) return xt(ce, ne, he, ze);
        if (_e(he)) return bt(ce, ne, he, ze);
        Pr(ce, he);
      }
      return typeof he == "string" && he !== "" || typeof he == "number" ? (he = "" + he, ne !== null && ne.tag === 6 ? (v(ce, ne.sibling), ne = b(ne, he), ne.return = ce, ce = ne) : (v(ce, ne), ne = jd(he, ce.mode, ze), ne.return = ce, ce = ne), Z(ce)) : v(ce, ne);
    }
    return Gr;
  }
  var Zn = Ai(!0), ad = Ai(!1), mc = ia(null), ni = null, Ku = null, X1 = null;
  function pr() {
    X1 = Ku = ni = null;
  }
  function od(o) {
    var l = mc.current;
    Un(mc), o._currentValue = l;
  }
  function Wa(o, l, v) {
    for (; o !== null; ) {
      var w = o.alternate;
      if ((o.childLanes & l) !== l ? (o.childLanes |= l, w !== null && (w.childLanes |= l)) : w !== null && (w.childLanes & l) !== l && (w.childLanes |= l), o === v) break;
      o = o.return;
    }
  }
  function Qu(o, l) {
    ni = o, X1 = Ku = null, o = o.dependencies, o !== null && o.firstContext !== null && (o.lanes & l && (ua = !0), o.firstContext = null);
  }
  function ri(o) {
    var l = o._currentValue;
    if (X1 !== o) if (o = { context: o, memoizedValue: l, next: null }, Ku === null) {
      if (ni === null) throw Error(a(308));
      Ku = o, ni.dependencies = { lanes: 0, firstContext: o };
    } else Ku = Ku.next = o;
    return l;
  }
  var ol = null;
  function Xu(o) {
    ol === null ? ol = [o] : ol.push(o);
  }
  function id(o, l, v, w) {
    var b = l.interleaved;
    return b === null ? (v.next = v, Xu(l)) : (v.next = b.next, b.next = v), l.interleaved = v, mu(o, w);
  }
  function mu(o, l) {
    o.lanes |= l;
    var v = o.alternate;
    for (v !== null && (v.lanes |= l), v = o, o = o.return; o !== null; ) o.childLanes |= l, v = o.alternate, v !== null && (v.childLanes |= l), v = o, o = o.return;
    return v.tag === 3 ? v.stateNode : null;
  }
  var ki = !1;
  function ld(o) {
    o.updateQueue = { baseState: o.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function dv(o, l) {
    o = o.updateQueue, l.updateQueue === o && (l.updateQueue = { baseState: o.baseState, firstBaseUpdate: o.firstBaseUpdate, lastBaseUpdate: o.lastBaseUpdate, shared: o.shared, effects: o.effects });
  }
  function gu(o, l) {
    return { eventTime: o, lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function ai(o, l, v) {
    var w = o.updateQueue;
    if (w === null) return null;
    if (w = w.shared, Mn & 2) {
      var b = w.pending;
      return b === null ? l.next = l : (l.next = b.next, b.next = l), w.pending = l, mu(o, v);
    }
    return b = w.interleaved, b === null ? (l.next = l, Xu(w)) : (l.next = b.next, b.next = l), w.interleaved = l, mu(o, v);
  }
  function gc(o, l, v) {
    if (l = l.updateQueue, l !== null && (l = l.shared, (v & 4194240) !== 0)) {
      var w = l.lanes;
      w &= o.pendingLanes, v |= w, l.lanes = v, In(o, v);
    }
  }
  function hv(o, l) {
    var v = o.updateQueue, w = o.alternate;
    if (w !== null && (w = w.updateQueue, v === w)) {
      var b = null, E = null;
      if (v = v.firstBaseUpdate, v !== null) {
        do {
          var Z = { eventTime: v.eventTime, lane: v.lane, tag: v.tag, payload: v.payload, callback: v.callback, next: null };
          E === null ? b = E = Z : E = E.next = Z, v = v.next;
        } while (v !== null);
        E === null ? b = E = l : E = E.next = l;
      } else b = E = l;
      v = { baseState: w.baseState, firstBaseUpdate: b, lastBaseUpdate: E, shared: w.shared, effects: w.effects }, o.updateQueue = v;
      return;
    }
    o = v.lastBaseUpdate, o === null ? v.firstBaseUpdate = l : o.next = l, v.lastBaseUpdate = l;
  }
  function J1(o, l, v, w) {
    var b = o.updateQueue;
    ki = !1;
    var E = b.firstBaseUpdate, Z = b.lastBaseUpdate, z = b.shared.pending;
    if (z !== null) {
      b.shared.pending = null;
      var ee = z, ye = ee.next;
      ee.next = null, Z === null ? E = ye : Z.next = ye, Z = ee;
      var Ne = o.alternate;
      Ne !== null && (Ne = Ne.updateQueue, z = Ne.lastBaseUpdate, z !== Z && (z === null ? Ne.firstBaseUpdate = ye : z.next = ye, Ne.lastBaseUpdate = ee));
    }
    if (E !== null) {
      var Ye = b.baseState;
      Z = 0, Ne = ye = ee = null, z = E;
      do {
        var Ve = z.lane, lt = z.eventTime;
        if ((w & Ve) === Ve) {
          Ne !== null && (Ne = Ne.next = {
            eventTime: lt,
            lane: 0,
            tag: z.tag,
            payload: z.payload,
            callback: z.callback,
            next: null
          });
          e: {
            var xt = o, bt = z;
            switch (Ve = l, lt = v, bt.tag) {
              case 1:
                if (xt = bt.payload, typeof xt == "function") {
                  Ye = xt.call(lt, Ye, Ve);
                  break e;
                }
                Ye = xt;
                break e;
              case 3:
                xt.flags = xt.flags & -65537 | 128;
              case 0:
                if (xt = bt.payload, Ve = typeof xt == "function" ? xt.call(lt, Ye, Ve) : xt, Ve == null) break e;
                Ye = Ze({}, Ye, Ve);
                break e;
              case 2:
                ki = !0;
            }
          }
          z.callback !== null && z.lane !== 0 && (o.flags |= 64, Ve = b.effects, Ve === null ? b.effects = [z] : Ve.push(z));
        } else lt = { eventTime: lt, lane: Ve, tag: z.tag, payload: z.payload, callback: z.callback, next: null }, Ne === null ? (ye = Ne = lt, ee = Ye) : Ne = Ne.next = lt, Z |= Ve;
        if (z = z.next, z === null) {
          if (z = b.shared.pending, z === null) break;
          Ve = z, z = Ve.next, Ve.next = null, b.lastBaseUpdate = Ve, b.shared.pending = null;
        }
      } while (!0);
      if (Ne === null && (ee = Ye), b.baseState = ee, b.firstBaseUpdate = ye, b.lastBaseUpdate = Ne, l = b.shared.interleaved, l !== null) {
        b = l;
        do
          Z |= b.lane, b = b.next;
        while (b !== l);
      } else E === null && (b.shared.lanes = 0);
      fs |= Z, o.lanes = Z, o.memoizedState = Ye;
    }
  }
  function Bh(o, l, v) {
    if (o = l.effects, l.effects = null, o !== null) for (l = 0; l < o.length; l++) {
      var w = o[l], b = w.callback;
      if (b !== null) {
        if (w.callback = null, w = v, typeof b != "function") throw Error(a(191, b));
        b.call(w);
      }
    }
  }
  var wc = {}, Vl = ia(wc), yc = ia(wc), $s = ia(wc);
  function wu(o) {
    if (o === wc) throw Error(a(174));
    return o;
  }
  function ud(o, l) {
    switch (Yn($s, l), Yn(yc, o), Yn(Vl, wc), o = l.nodeType, o) {
      case 9:
      case 11:
        l = (l = l.documentElement) ? l.namespaceURI : Sn(null, "");
        break;
      default:
        o = o === 8 ? l.parentNode : l, l = o.namespaceURI || null, o = o.tagName, l = Sn(l, o);
    }
    Un(Vl), Yn(Vl, l);
  }
  function Ju() {
    Un(Vl), Un(yc), Un($s);
  }
  function Fh(o) {
    wu($s.current);
    var l = wu(Vl.current), v = Sn(l, o.type);
    l !== v && (Yn(yc, o), Yn(Vl, v));
  }
  function e0(o) {
    yc.current === o && (Un(Vl), Un(yc));
  }
  var tt = ia(0);
  function on(o) {
    for (var l = o; l !== null; ) {
      if (l.tag === 13) {
        var v = l.memoizedState;
        if (v !== null && (v = v.dehydrated, v === null || v.data === "$?" || v.data === "$!")) return l;
      } else if (l.tag === 19 && l.memoizedProps.revealOrder !== void 0) {
        if (l.flags & 128) return l;
      } else if (l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === o) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === o) return null;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
    return null;
  }
  var Pn = [];
  function _r() {
    for (var o = 0; o < Pn.length; o++) Pn[o]._workInProgressVersionPrimary = null;
    Pn.length = 0;
  }
  var Po = Q.ReactCurrentDispatcher, sd = Q.ReactCurrentBatchConfig, es = 0, Ar = null, $r = null, Wr = null, He = !1, Vr = !1, It = 0, tn = 0;
  function Tr() {
    throw Error(a(321));
  }
  function yu(o, l) {
    if (l === null) return !1;
    for (var v = 0; v < l.length && v < o.length; v++) if (!ge(o[v], l[v])) return !1;
    return !0;
  }
  function no(o, l, v, w, b, E) {
    if (es = E, Ar = l, l.memoizedState = null, l.updateQueue = null, l.lanes = 0, Po.current = o === null || o.memoizedState === null ? Xp : fd, o = v(w, b), Vr) {
      E = 0;
      do {
        if (Vr = !1, It = 0, 25 <= E) throw Error(a(301));
        E += 1, Wr = $r = null, l.updateQueue = null, Po.current = u0, o = v(w, b);
      } while (Vr);
    }
    if (Po.current = Gs, l = $r !== null && $r.next !== null, es = 0, Wr = $r = Ar = null, He = !1, l) throw Error(a(300));
    return o;
  }
  function ts() {
    var o = It !== 0;
    return It = 0, o;
  }
  function go() {
    var o = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Wr === null ? Ar.memoizedState = Wr = o : Wr = Wr.next = o, Wr;
  }
  function ro() {
    if ($r === null) {
      var o = Ar.alternate;
      o = o !== null ? o.memoizedState : null;
    } else o = $r.next;
    var l = Wr === null ? Ar.memoizedState : Wr.next;
    if (l !== null) Wr = l, $r = o;
    else {
      if (o === null) throw Error(a(310));
      $r = o, o = { memoizedState: $r.memoizedState, baseState: $r.baseState, baseQueue: $r.baseQueue, queue: $r.queue, next: null }, Wr === null ? Ar.memoizedState = Wr = o : Wr = Wr.next = o;
    }
    return Wr;
  }
  function ba(o, l) {
    return typeof l == "function" ? l(o) : l;
  }
  function xc(o) {
    var l = ro(), v = l.queue;
    if (v === null) throw Error(a(311));
    v.lastRenderedReducer = o;
    var w = $r, b = w.baseQueue, E = v.pending;
    if (E !== null) {
      if (b !== null) {
        var Z = b.next;
        b.next = E.next, E.next = Z;
      }
      w.baseQueue = b = E, v.pending = null;
    }
    if (b !== null) {
      E = b.next, w = w.baseState;
      var z = Z = null, ee = null, ye = E;
      do {
        var Ne = ye.lane;
        if ((es & Ne) === Ne) ee !== null && (ee = ee.next = { lane: 0, action: ye.action, hasEagerState: ye.hasEagerState, eagerState: ye.eagerState, next: null }), w = ye.hasEagerState ? ye.eagerState : o(w, ye.action);
        else {
          var Ye = {
            lane: Ne,
            action: ye.action,
            hasEagerState: ye.hasEagerState,
            eagerState: ye.eagerState,
            next: null
          };
          ee === null ? (z = ee = Ye, Z = w) : ee = ee.next = Ye, Ar.lanes |= Ne, fs |= Ne;
        }
        ye = ye.next;
      } while (ye !== null && ye !== E);
      ee === null ? Z = w : ee.next = z, ge(w, l.memoizedState) || (ua = !0), l.memoizedState = w, l.baseState = Z, l.baseQueue = ee, v.lastRenderedState = w;
    }
    if (o = v.interleaved, o !== null) {
      b = o;
      do
        E = b.lane, Ar.lanes |= E, fs |= E, b = b.next;
      while (b !== o);
    } else b === null && (v.lanes = 0);
    return [l.memoizedState, v.dispatch];
  }
  function ns(o) {
    var l = ro(), v = l.queue;
    if (v === null) throw Error(a(311));
    v.lastRenderedReducer = o;
    var w = v.dispatch, b = v.pending, E = l.memoizedState;
    if (b !== null) {
      v.pending = null;
      var Z = b = b.next;
      do
        E = o(E, Z.action), Z = Z.next;
      while (Z !== b);
      ge(E, l.memoizedState) || (ua = !0), l.memoizedState = E, l.baseQueue === null && (l.baseState = E), v.lastRenderedState = E;
    }
    return [E, w];
  }
  function t0() {
  }
  function Sc(o, l) {
    var v = Ar, w = ro(), b = l(), E = !ge(w.memoizedState, b);
    if (E && (w.memoizedState = b, ua = !0), w = w.queue, wo(il.bind(null, v, w, o), [o]), w.getSnapshot !== l || E || Wr !== null && Wr.memoizedState.tag & 1) {
      if (v.flags |= 2048, rs(9, ao.bind(null, v, w, b, l), void 0, null), Ma === null) throw Error(a(349));
      es & 30 || Cc(v, l, b);
    }
    return b;
  }
  function Cc(o, l, v) {
    o.flags |= 16384, o = { getSnapshot: l, value: v }, l = Ar.updateQueue, l === null ? (l = { lastEffect: null, stores: null }, Ar.updateQueue = l, l.stores = [o]) : (v = l.stores, v === null ? l.stores = [o] : v.push(o));
  }
  function ao(o, l, v, w) {
    l.value = v, l.getSnapshot = w, n0(l) && bc(o);
  }
  function il(o, l, v) {
    return v(function() {
      n0(l) && bc(o);
    });
  }
  function n0(o) {
    var l = o.getSnapshot;
    o = o.value;
    try {
      var v = l();
      return !ge(o, v);
    } catch {
      return !0;
    }
  }
  function bc(o) {
    var l = mu(o, 1);
    l !== null && ui(l, o, 1, -1);
  }
  function Ws(o) {
    var l = go();
    return typeof o == "function" && (o = o()), l.memoizedState = l.baseState = o, o = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: ba, lastRenderedState: o }, l.queue = o, o = o.dispatch = dr.bind(null, Ar, o), [l.memoizedState, o];
  }
  function rs(o, l, v, w) {
    return o = { tag: o, create: l, destroy: v, deps: w, next: null }, l = Ar.updateQueue, l === null ? (l = { lastEffect: null, stores: null }, Ar.updateQueue = l, l.lastEffect = o.next = o) : (v = l.lastEffect, v === null ? l.lastEffect = o.next = o : (w = v.next, v.next = o, o.next = w, l.lastEffect = o)), o;
  }
  function r0() {
    return ro().memoizedState;
  }
  function zs(o, l, v, w) {
    var b = go();
    Ar.flags |= o, b.memoizedState = rs(1 | l, v, void 0, w === void 0 ? null : w);
  }
  function as(o, l, v, w) {
    var b = ro();
    w = w === void 0 ? null : w;
    var E = void 0;
    if ($r !== null) {
      var Z = $r.memoizedState;
      if (E = Z.destroy, w !== null && yu(w, Z.deps)) {
        b.memoizedState = rs(l, v, E, w);
        return;
      }
    }
    Ar.flags |= o, b.memoizedState = rs(1 | l, v, E, w);
  }
  function qs(o, l) {
    return zs(8390656, 8, o, l);
  }
  function wo(o, l) {
    return as(2048, 8, o, l);
  }
  function cd(o, l) {
    return as(4, 2, o, l);
  }
  function ll(o, l) {
    return as(4, 4, o, l);
  }
  function _c(o, l) {
    if (typeof l == "function") return o = o(), l(o), function() {
      l(null);
    };
    if (l != null) return o = o(), l.current = o, function() {
      l.current = null;
    };
  }
  function Rc(o, l, v) {
    return v = v != null ? v.concat([o]) : null, as(4, 4, _c.bind(null, l, o), v);
  }
  function a0() {
  }
  function o0(o, l) {
    var v = ro();
    l = l === void 0 ? null : l;
    var w = v.memoizedState;
    return w !== null && l !== null && yu(l, w[1]) ? w[0] : (v.memoizedState = [o, l], o);
  }
  function Uh(o, l) {
    var v = ro();
    l = l === void 0 ? null : l;
    var w = v.memoizedState;
    return w !== null && l !== null && yu(l, w[1]) ? w[0] : (o = o(), v.memoizedState = [o, l], o);
  }
  function i0(o, l, v) {
    return es & 21 ? (ge(v, l) || (v = Th(), Ar.lanes |= v, fs |= v, o.baseState = !0), l) : (o.baseState && (o.baseState = !1, ua = !0), o.memoizedState = v);
  }
  function os(o, l) {
    var v = Bn;
    Bn = v !== 0 && 4 > v ? v : 4, o(!0);
    var w = sd.transition;
    sd.transition = {};
    try {
      o(!1), l();
    } finally {
      Bn = v, sd.transition = w;
    }
  }
  function Vo() {
    return ro().memoizedState;
  }
  function Qp(o, l, v) {
    var w = Yl(o);
    if (v = { lane: w, action: v, hasEagerState: !1, eagerState: null, next: null }, l0(o)) _a(l, v);
    else if (v = id(o, l, v, w), v !== null) {
      var b = xo();
      ui(v, o, w, b), yo(v, l, w);
    }
  }
  function dr(o, l, v) {
    var w = Yl(o), b = { lane: w, action: v, hasEagerState: !1, eagerState: null, next: null };
    if (l0(o)) _a(l, b);
    else {
      var E = o.alternate;
      if (o.lanes === 0 && (E === null || E.lanes === 0) && (E = l.lastRenderedReducer, E !== null)) try {
        var Z = l.lastRenderedState, z = E(Z, v);
        if (b.hasEagerState = !0, b.eagerState = z, ge(z, Z)) {
          var ee = l.interleaved;
          ee === null ? (b.next = b, Xu(l)) : (b.next = ee.next, ee.next = b), l.interleaved = b;
          return;
        }
      } catch {
      } finally {
      }
      v = id(o, l, b, w), v !== null && (b = xo(), ui(v, o, w, b), yo(v, l, w));
    }
  }
  function l0(o) {
    var l = o.alternate;
    return o === Ar || l !== null && l === Ar;
  }
  function _a(o, l) {
    Vr = He = !0;
    var v = o.pending;
    v === null ? l.next = l : (l.next = v.next, v.next = l), o.pending = l;
  }
  function yo(o, l, v) {
    if (v & 4194240) {
      var w = l.lanes;
      w &= o.pendingLanes, v |= w, l.lanes = v, In(o, v);
    }
  }
  var Gs = { readContext: ri, useCallback: Tr, useContext: Tr, useEffect: Tr, useImperativeHandle: Tr, useInsertionEffect: Tr, useLayoutEffect: Tr, useMemo: Tr, useReducer: Tr, useRef: Tr, useState: Tr, useDebugValue: Tr, useDeferredValue: Tr, useTransition: Tr, useMutableSource: Tr, useSyncExternalStore: Tr, useId: Tr, unstable_isNewReconciler: !1 }, Xp = { readContext: ri, useCallback: function(o, l) {
    return go().memoizedState = [o, l === void 0 ? null : l], o;
  }, useContext: ri, useEffect: qs, useImperativeHandle: function(o, l, v) {
    return v = v != null ? v.concat([o]) : null, zs(
      4194308,
      4,
      _c.bind(null, l, o),
      v
    );
  }, useLayoutEffect: function(o, l) {
    return zs(4194308, 4, o, l);
  }, useInsertionEffect: function(o, l) {
    return zs(4, 2, o, l);
  }, useMemo: function(o, l) {
    var v = go();
    return l = l === void 0 ? null : l, o = o(), v.memoizedState = [o, l], o;
  }, useReducer: function(o, l, v) {
    var w = go();
    return l = v !== void 0 ? v(l) : l, w.memoizedState = w.baseState = l, o = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: o, lastRenderedState: l }, w.queue = o, o = o.dispatch = Qp.bind(null, Ar, o), [w.memoizedState, o];
  }, useRef: function(o) {
    var l = go();
    return o = { current: o }, l.memoizedState = o;
  }, useState: Ws, useDebugValue: a0, useDeferredValue: function(o) {
    return go().memoizedState = o;
  }, useTransition: function() {
    var o = Ws(!1), l = o[0];
    return o = os.bind(null, o[1]), go().memoizedState = o, [l, o];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(o, l, v) {
    var w = Ar, b = go();
    if (br) {
      if (v === void 0) throw Error(a(407));
      v = v();
    } else {
      if (v = l(), Ma === null) throw Error(a(349));
      es & 30 || Cc(w, l, v);
    }
    b.memoizedState = v;
    var E = { value: v, getSnapshot: l };
    return b.queue = E, qs(il.bind(
      null,
      w,
      E,
      o
    ), [o]), w.flags |= 2048, rs(9, ao.bind(null, w, E, v, l), void 0, null), v;
  }, useId: function() {
    var o = go(), l = Ma.identifierPrefix;
    if (br) {
      var v = nl, w = Il;
      v = (w & ~(1 << 32 - zo(w) - 1)).toString(32) + v, l = ":" + l + "R" + v, v = It++, 0 < v && (l += "H" + v.toString(32)), l += ":";
    } else v = tn++, l = ":" + l + "r" + v.toString(32) + ":";
    return o.memoizedState = l;
  }, unstable_isNewReconciler: !1 }, fd = {
    readContext: ri,
    useCallback: o0,
    useContext: ri,
    useEffect: wo,
    useImperativeHandle: Rc,
    useInsertionEffect: cd,
    useLayoutEffect: ll,
    useMemo: Uh,
    useReducer: xc,
    useRef: r0,
    useState: function() {
      return xc(ba);
    },
    useDebugValue: a0,
    useDeferredValue: function(o) {
      var l = ro();
      return i0(l, $r.memoizedState, o);
    },
    useTransition: function() {
      var o = xc(ba)[0], l = ro().memoizedState;
      return [o, l];
    },
    useMutableSource: t0,
    useSyncExternalStore: Sc,
    useId: Vo,
    unstable_isNewReconciler: !1
  }, u0 = { readContext: ri, useCallback: o0, useContext: ri, useEffect: wo, useImperativeHandle: Rc, useInsertionEffect: cd, useLayoutEffect: ll, useMemo: Uh, useReducer: ns, useRef: r0, useState: function() {
    return ns(ba);
  }, useDebugValue: a0, useDeferredValue: function(o) {
    var l = ro();
    return $r === null ? l.memoizedState = o : i0(l, $r.memoizedState, o);
  }, useTransition: function() {
    var o = ns(ba)[0], l = ro().memoizedState;
    return [o, l];
  }, useMutableSource: t0, useSyncExternalStore: Sc, useId: Vo, unstable_isNewReconciler: !1 };
  function Li(o, l) {
    if (o && o.defaultProps) {
      l = Ze({}, l), o = o.defaultProps;
      for (var v in o) l[v] === void 0 && (l[v] = o[v]);
      return l;
    }
    return l;
  }
  function s0(o, l, v, w) {
    l = o.memoizedState, v = v(w, l), v = v == null ? l : Ze({}, l, v), o.memoizedState = v, o.lanes === 0 && (o.updateQueue.baseState = v);
  }
  var dd = { isMounted: function(o) {
    return (o = o._reactInternals) ? yn(o) === o : !1;
  }, enqueueSetState: function(o, l, v) {
    o = o._reactInternals;
    var w = xo(), b = Yl(o), E = gu(w, b);
    E.payload = l, v != null && (E.callback = v), l = ai(o, E, b), l !== null && (ui(l, o, b, w), gc(l, o, b));
  }, enqueueReplaceState: function(o, l, v) {
    o = o._reactInternals;
    var w = xo(), b = Yl(o), E = gu(w, b);
    E.tag = 1, E.payload = l, v != null && (E.callback = v), l = ai(o, E, b), l !== null && (ui(l, o, b, w), gc(l, o, b));
  }, enqueueForceUpdate: function(o, l) {
    o = o._reactInternals;
    var v = xo(), w = Yl(o), b = gu(v, w);
    b.tag = 2, l != null && (b.callback = l), l = ai(o, b, w), l !== null && (ui(l, o, w, v), gc(l, o, w));
  } };
  function Ec(o, l, v, w, b, E, Z) {
    return o = o.stateNode, typeof o.shouldComponentUpdate == "function" ? o.shouldComponentUpdate(w, E, Z) : l.prototype && l.prototype.isPureReactComponent ? !Je(v, w) || !Je(b, E) : !0;
  }
  function is(o, l, v) {
    var w = !1, b = mo, E = l.contextType;
    return typeof E == "object" && E !== null ? E = ri(E) : (b = Ua(l) ? Fa : Zr.current, w = l.contextTypes, E = (w = w != null) ? K1(o, b) : mo), l = new l(v, E), o.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null, l.updater = dd, o.stateNode = l, l._reactInternals = o, w && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = b, o.__reactInternalMemoizedMaskedChildContext = E), l;
  }
  function c0(o, l, v, w) {
    o = l.state, typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(v, w), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(v, w), l.state !== o && dd.enqueueReplaceState(l, l.state, null);
  }
  function Yh(o, l, v, w) {
    var b = o.stateNode;
    b.props = v, b.state = o.memoizedState, b.refs = {}, ld(o);
    var E = l.contextType;
    typeof E == "object" && E !== null ? b.context = ri(E) : (E = Ua(l) ? Fa : Zr.current, b.context = K1(o, E)), b.state = o.memoizedState, E = l.getDerivedStateFromProps, typeof E == "function" && (s0(o, l, E, v), b.state = o.memoizedState), typeof l.getDerivedStateFromProps == "function" || typeof b.getSnapshotBeforeUpdate == "function" || typeof b.UNSAFE_componentWillMount != "function" && typeof b.componentWillMount != "function" || (l = b.state, typeof b.componentWillMount == "function" && b.componentWillMount(), typeof b.UNSAFE_componentWillMount == "function" && b.UNSAFE_componentWillMount(), l !== b.state && dd.enqueueReplaceState(b, b.state, null), J1(o, v, b, w), b.state = o.memoizedState), typeof b.componentDidMount == "function" && (o.flags |= 4194308);
  }
  function Nl(o, l) {
    try {
      var v = "", w = l;
      do
        v += Qe(w), w = w.return;
      while (w);
      var b = v;
    } catch (E) {
      b = `
Error generating stack: ` + E.message + `
` + E.stack;
    }
    return { value: o, source: l, stack: b, digest: null };
  }
  function hd(o, l, v) {
    return { value: o, source: null, stack: v ?? null, digest: l ?? null };
  }
  function Ks(o, l) {
    try {
      console.error(l.value);
    } catch (v) {
      setTimeout(function() {
        throw v;
      });
    }
  }
  var $h = typeof WeakMap == "function" ? WeakMap : Map;
  function Mc(o, l, v) {
    v = gu(-1, v), v.tag = 3, v.payload = { element: null };
    var w = l.value;
    return v.callback = function() {
      bd || (bd = !0, _d = w), Ks(o, l);
    }, v;
  }
  function Bl(o, l, v) {
    v = gu(-1, v), v.tag = 3;
    var w = o.type.getDerivedStateFromError;
    if (typeof w == "function") {
      var b = l.value;
      v.payload = function() {
        return w(b);
      }, v.callback = function() {
        Ks(o, l);
      };
    }
    var E = o.stateNode;
    return E !== null && typeof E.componentDidCatch == "function" && (v.callback = function() {
      Ks(o, l), typeof w != "function" && (Eu === null ? Eu = /* @__PURE__ */ new Set([this]) : Eu.add(this));
      var Z = l.stack;
      this.componentDidCatch(l.value, { componentStack: Z !== null ? Z : "" });
    }), v;
  }
  function xu(o, l, v) {
    var w = o.pingCache;
    if (w === null) {
      w = o.pingCache = new $h();
      var b = /* @__PURE__ */ new Set();
      w.set(l, b);
    } else b = w.get(l), b === void 0 && (b = /* @__PURE__ */ new Set(), w.set(l, b));
    b.has(v) || (b.add(v), o = Sv.bind(null, o, l, v), l.then(o, o));
  }
  function ls(o) {
    do {
      var l;
      if ((l = o.tag === 13) && (l = o.memoizedState, l = l !== null ? l.dehydrated !== null : !0), l) return o;
      o = o.return;
    } while (o !== null);
    return null;
  }
  function Tc(o, l, v, w, b) {
    return o.mode & 1 ? (o.flags |= 65536, o.lanes = b, o) : (o === l ? o.flags |= 65536 : (o.flags |= 128, v.flags |= 131072, v.flags &= -52805, v.tag === 1 && (v.alternate === null ? v.tag = 17 : (l = gu(-1, 1), l.tag = 2, ai(v, l, 1))), v.lanes |= 1), o);
  }
  var oo = Q.ReactCurrentOwner, ua = !1;
  function At(o, l, v, w) {
    l.child = o === null ? ad(l, null, v, w) : Zn(l, o.child, v, w);
  }
  function Oc(o, l, v, w, b) {
    v = v.render;
    var E = l.ref;
    return Qu(l, b), w = no(o, l, v, w, E, b), v = ts(), o !== null && !ua ? (l.updateQueue = o.updateQueue, l.flags &= -2053, o.lanes &= ~b, rr(o, l, b)) : (br && v && Q1(l), l.flags |= 1, At(o, l, w, b), l.child);
  }
  function vd(o, l, v, w, b) {
    if (o === null) {
      var E = v.type;
      return typeof E == "function" && !Pc(E) && E.defaultProps === void 0 && v.compare === null && v.defaultProps === void 0 ? (l.tag = 15, l.type = E, Su(o, l, E, w, b)) : (o = Dd(v.type, null, w, l, l.mode, b), o.ref = l.ref, o.return = l, l.child = o);
    }
    if (E = o.child, !(o.lanes & b)) {
      var Z = E.memoizedProps;
      if (v = v.compare, v = v !== null ? v : Je, v(Z, w) && o.ref === l.ref) return rr(o, l, b);
    }
    return l.flags |= 1, o = So(E, w), o.ref = l.ref, o.return = l, l.child = o;
  }
  function Su(o, l, v, w, b) {
    if (o !== null) {
      var E = o.memoizedProps;
      if (Je(E, w) && o.ref === l.ref) if (ua = !1, l.pendingProps = w = E, (o.lanes & b) !== 0) o.flags & 131072 && (ua = !0);
      else return l.lanes = o.lanes, rr(o, l, b);
    }
    return Qs(o, l, v, w, b);
  }
  function Wh(o, l, v) {
    var w = l.pendingProps, b = w.children, E = o !== null ? o.memoizedState : null;
    if (w.mode === "hidden") if (!(l.mode & 1)) l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Yn(_u, li), li |= v;
    else {
      if (!(v & 1073741824)) return o = E !== null ? E.baseLanes | v : v, l.lanes = l.childLanes = 1073741824, l.memoizedState = { baseLanes: o, cachePool: null, transitions: null }, l.updateQueue = null, Yn(_u, li), li |= o, null;
      l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, w = E !== null ? E.baseLanes : v, Yn(_u, li), li |= w;
    }
    else E !== null ? (w = E.baseLanes | v, l.memoizedState = null) : w = v, Yn(_u, li), li |= w;
    return At(o, l, b, v), l.child;
  }
  function Dc(o, l) {
    var v = l.ref;
    (o === null && v !== null || o !== null && o.ref !== v) && (l.flags |= 512, l.flags |= 2097152);
  }
  function Qs(o, l, v, w, b) {
    var E = Ua(v) ? Fa : Zr.current;
    return E = K1(l, E), Qu(l, b), v = no(o, l, v, w, E, b), w = ts(), o !== null && !ua ? (l.updateQueue = o.updateQueue, l.flags &= -2053, o.lanes &= ~b, rr(o, l, b)) : (br && w && Q1(l), l.flags |= 1, At(o, l, v, b), l.child);
  }
  function zh(o, l, v, w, b) {
    if (Ua(v)) {
      var E = !0;
      Ho(l);
    } else E = !1;
    if (Qu(l, b), l.stateNode === null) No(o, l), is(l, v, w), Yh(l, v, w, b), w = !0;
    else if (o === null) {
      var Z = l.stateNode, z = l.memoizedProps;
      Z.props = z;
      var ee = Z.context, ye = v.contextType;
      typeof ye == "object" && ye !== null ? ye = ri(ye) : (ye = Ua(v) ? Fa : Zr.current, ye = K1(l, ye));
      var Ne = v.getDerivedStateFromProps, Ye = typeof Ne == "function" || typeof Z.getSnapshotBeforeUpdate == "function";
      Ye || typeof Z.UNSAFE_componentWillReceiveProps != "function" && typeof Z.componentWillReceiveProps != "function" || (z !== w || ee !== ye) && c0(l, Z, w, ye), ki = !1;
      var Ve = l.memoizedState;
      Z.state = Ve, J1(l, w, Z, b), ee = l.memoizedState, z !== w || Ve !== ee || la.current || ki ? (typeof Ne == "function" && (s0(l, v, Ne, w), ee = l.memoizedState), (z = ki || Ec(l, v, z, w, Ve, ee, ye)) ? (Ye || typeof Z.UNSAFE_componentWillMount != "function" && typeof Z.componentWillMount != "function" || (typeof Z.componentWillMount == "function" && Z.componentWillMount(), typeof Z.UNSAFE_componentWillMount == "function" && Z.UNSAFE_componentWillMount()), typeof Z.componentDidMount == "function" && (l.flags |= 4194308)) : (typeof Z.componentDidMount == "function" && (l.flags |= 4194308), l.memoizedProps = w, l.memoizedState = ee), Z.props = w, Z.state = ee, Z.context = ye, w = z) : (typeof Z.componentDidMount == "function" && (l.flags |= 4194308), w = !1);
    } else {
      Z = l.stateNode, dv(o, l), z = l.memoizedProps, ye = l.type === l.elementType ? z : Li(l.type, z), Z.props = ye, Ye = l.pendingProps, Ve = Z.context, ee = v.contextType, typeof ee == "object" && ee !== null ? ee = ri(ee) : (ee = Ua(v) ? Fa : Zr.current, ee = K1(l, ee));
      var lt = v.getDerivedStateFromProps;
      (Ne = typeof lt == "function" || typeof Z.getSnapshotBeforeUpdate == "function") || typeof Z.UNSAFE_componentWillReceiveProps != "function" && typeof Z.componentWillReceiveProps != "function" || (z !== Ye || Ve !== ee) && c0(l, Z, w, ee), ki = !1, Ve = l.memoizedState, Z.state = Ve, J1(l, w, Z, b);
      var xt = l.memoizedState;
      z !== Ye || Ve !== xt || la.current || ki ? (typeof lt == "function" && (s0(l, v, lt, w), xt = l.memoizedState), (ye = ki || Ec(l, v, ye, w, Ve, xt, ee) || !1) ? (Ne || typeof Z.UNSAFE_componentWillUpdate != "function" && typeof Z.componentWillUpdate != "function" || (typeof Z.componentWillUpdate == "function" && Z.componentWillUpdate(w, xt, ee), typeof Z.UNSAFE_componentWillUpdate == "function" && Z.UNSAFE_componentWillUpdate(w, xt, ee)), typeof Z.componentDidUpdate == "function" && (l.flags |= 4), typeof Z.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024)) : (typeof Z.componentDidUpdate != "function" || z === o.memoizedProps && Ve === o.memoizedState || (l.flags |= 4), typeof Z.getSnapshotBeforeUpdate != "function" || z === o.memoizedProps && Ve === o.memoizedState || (l.flags |= 1024), l.memoizedProps = w, l.memoizedState = xt), Z.props = w, Z.state = xt, Z.context = ee, w = ye) : (typeof Z.componentDidUpdate != "function" || z === o.memoizedProps && Ve === o.memoizedState || (l.flags |= 4), typeof Z.getSnapshotBeforeUpdate != "function" || z === o.memoizedProps && Ve === o.memoizedState || (l.flags |= 1024), w = !1);
    }
    return pd(o, l, v, w, E, b);
  }
  function pd(o, l, v, w, b, E) {
    Dc(o, l);
    var Z = (l.flags & 128) !== 0;
    if (!w && !Z) return b && qu(l, v, !1), rr(o, l, E);
    w = l.stateNode, oo.current = l;
    var z = Z && typeof v.getDerivedStateFromError != "function" ? null : w.render();
    return l.flags |= 1, o !== null && Z ? (l.child = Zn(l, o.child, null, E), l.child = Zn(l, null, z, E)) : At(o, l, z, E), l.memoizedState = w.state, b && qu(l, v, !0), l.child;
  }
  function vv(o) {
    var l = o.stateNode;
    l.pendingContext ? ed(o, l.pendingContext, l.pendingContext !== l.context) : l.context && ed(o, l.context, !1), ud(o, l.containerInfo);
  }
  function Ii(o, l, v, w, b) {
    return ji(), Zl(b), l.flags |= 256, At(o, l, v, w), l.child;
  }
  var jc = { dehydrated: null, treeContext: null, retryLane: 0 };
  function f0(o) {
    return { baseLanes: o, cachePool: null, transitions: null };
  }
  function Ac(o, l, v) {
    var w = l.pendingProps, b = tt.current, E = !1, Z = (l.flags & 128) !== 0, z;
    if ((z = Z) || (z = o !== null && o.memoizedState === null ? !1 : (b & 2) !== 0), z ? (E = !0, l.flags &= -129) : (o === null || o.memoizedState !== null) && (b |= 1), Yn(tt, b & 1), o === null)
      return $a(l), o = l.memoizedState, o !== null && (o = o.dehydrated, o !== null) ? (l.mode & 1 ? o.data === "$!" ? l.lanes = 8 : l.lanes = 1073741824 : l.lanes = 1, null) : (Z = w.children, o = w.fallback, E ? (w = l.mode, E = l.child, Z = { mode: "hidden", children: Z }, !(w & 1) && E !== null ? (E.childLanes = 0, E.pendingProps = Z) : E = Vc(Z, w, 0, null), o = vs(o, w, v, null), E.return = l, o.return = l, E.sibling = o, l.child = E, l.child.memoizedState = f0(v), l.memoizedState = jc, o) : Xs(l, Z));
    if (b = o.memoizedState, b !== null && (z = b.dehydrated, z !== null)) return jt(o, l, Z, w, z, b, v);
    if (E) {
      E = w.fallback, Z = l.mode, b = o.child, z = b.sibling;
      var ee = { mode: "hidden", children: w.children };
      return !(Z & 1) && l.child !== b ? (w = l.child, w.childLanes = 0, w.pendingProps = ee, l.deletions = null) : (w = So(b, ee), w.subtreeFlags = b.subtreeFlags & 14680064), z !== null ? E = So(z, E) : (E = vs(E, Z, v, null), E.flags |= 2), E.return = l, w.return = l, w.sibling = E, l.child = w, w = E, E = l.child, Z = o.child.memoizedState, Z = Z === null ? f0(v) : { baseLanes: Z.baseLanes | v, cachePool: null, transitions: Z.transitions }, E.memoizedState = Z, E.childLanes = o.childLanes & ~v, l.memoizedState = jc, w;
    }
    return E = o.child, o = E.sibling, w = So(E, { mode: "visible", children: w.children }), !(l.mode & 1) && (w.lanes = v), w.return = l, w.sibling = null, o !== null && (v = l.deletions, v === null ? (l.deletions = [o], l.flags |= 16) : v.push(o)), l.child = w, l.memoizedState = null, w;
  }
  function Xs(o, l) {
    return l = Vc({ mode: "visible", children: l }, o.mode, 0, null), l.return = o, o.child = l;
  }
  function zr(o, l, v, w) {
    return w !== null && Zl(w), Zn(l, o.child, null, v), o = Xs(l, l.pendingProps.children), o.flags |= 2, l.memoizedState = null, o;
  }
  function jt(o, l, v, w, b, E, Z) {
    if (v)
      return l.flags & 256 ? (l.flags &= -257, w = hd(Error(a(422))), zr(o, l, Z, w)) : l.memoizedState !== null ? (l.child = o.child, l.flags |= 128, null) : (E = w.fallback, b = l.mode, w = Vc({ mode: "visible", children: w.children }, b, 0, null), E = vs(E, b, Z, null), E.flags |= 2, w.return = l, E.return = l, w.sibling = E, l.child = w, l.mode & 1 && Zn(l, o.child, null, Z), l.child.memoizedState = f0(Z), l.memoizedState = jc, E);
    if (!(l.mode & 1)) return zr(o, l, Z, null);
    if (b.data === "$!") {
      if (w = b.nextSibling && b.nextSibling.dataset, w) var z = w.dgst;
      return w = z, E = Error(a(419)), w = hd(E, w, void 0), zr(o, l, Z, w);
    }
    if (z = (Z & o.childLanes) !== 0, ua || z) {
      if (w = Ma, w !== null) {
        switch (Z & -Z) {
          case 4:
            b = 2;
            break;
          case 16:
            b = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            b = 32;
            break;
          case 536870912:
            b = 268435456;
            break;
          default:
            b = 0;
        }
        b = b & (w.suspendedLanes | Z) ? 0 : b, b !== 0 && b !== E.retryLane && (E.retryLane = b, mu(o, b), ui(w, o, b, -1));
      }
      return Md(), w = hd(Error(a(421))), zr(o, l, Z, w);
    }
    return b.data === "$?" ? (l.flags |= 128, l.child = o.child, l = om.bind(null, o), b._reactRetry = l, null) : (o = E.treeContext, Zo = zu(b.nextSibling), Ya = l, br = !0, rl = null, o !== null && (ei[ti++] = Il, ei[ti++] = nl, ei[ti++] = Us, Il = o.id, nl = o.overflow, Us = l), l = Xs(l, w.children), l.flags |= 4096, l);
  }
  function oi(o, l, v) {
    o.lanes |= l;
    var w = o.alternate;
    w !== null && (w.lanes |= l), Wa(o.return, l, v);
  }
  function us(o, l, v, w, b) {
    var E = o.memoizedState;
    E === null ? o.memoizedState = { isBackwards: l, rendering: null, renderingStartTime: 0, last: w, tail: v, tailMode: b } : (E.isBackwards = l, E.rendering = null, E.renderingStartTime = 0, E.last = w, E.tail = v, E.tailMode = b);
  }
  function Hi(o, l, v) {
    var w = l.pendingProps, b = w.revealOrder, E = w.tail;
    if (At(o, l, w.children, v), w = tt.current, w & 2) w = w & 1 | 2, l.flags |= 128;
    else {
      if (o !== null && o.flags & 128) e: for (o = l.child; o !== null; ) {
        if (o.tag === 13) o.memoizedState !== null && oi(o, v, l);
        else if (o.tag === 19) oi(o, v, l);
        else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === l) break e;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === l) break e;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      w &= 1;
    }
    if (Yn(tt, w), !(l.mode & 1)) l.memoizedState = null;
    else switch (b) {
      case "forwards":
        for (v = l.child, b = null; v !== null; ) o = v.alternate, o !== null && on(o) === null && (b = v), v = v.sibling;
        v = b, v === null ? (b = l.child, l.child = null) : (b = v.sibling, v.sibling = null), us(l, !1, b, v, E);
        break;
      case "backwards":
        for (v = null, b = l.child, l.child = null; b !== null; ) {
          if (o = b.alternate, o !== null && on(o) === null) {
            l.child = b;
            break;
          }
          o = b.sibling, b.sibling = v, v = b, b = o;
        }
        us(l, !0, v, null, E);
        break;
      case "together":
        us(l, !1, null, null, void 0);
        break;
      default:
        l.memoizedState = null;
    }
    return l.child;
  }
  function No(o, l) {
    !(l.mode & 1) && o !== null && (o.alternate = null, l.alternate = null, l.flags |= 2);
  }
  function rr(o, l, v) {
    if (o !== null && (l.dependencies = o.dependencies), fs |= l.lanes, !(v & l.childLanes)) return null;
    if (o !== null && l.child !== o.child) throw Error(a(153));
    if (l.child !== null) {
      for (o = l.child, v = So(o, o.pendingProps), l.child = v, v.return = l; o.sibling !== null; ) o = o.sibling, v = v.sibling = So(o, o.pendingProps), v.return = l;
      v.sibling = null;
    }
    return l.child;
  }
  function pv(o, l, v) {
    switch (l.tag) {
      case 3:
        vv(l), ji();
        break;
      case 5:
        Fh(l);
        break;
      case 1:
        Ua(l.type) && Ho(l);
        break;
      case 4:
        ud(l, l.stateNode.containerInfo);
        break;
      case 10:
        var w = l.type._context, b = l.memoizedProps.value;
        Yn(mc, w._currentValue), w._currentValue = b;
        break;
      case 13:
        if (w = l.memoizedState, w !== null)
          return w.dehydrated !== null ? (Yn(tt, tt.current & 1), l.flags |= 128, null) : v & l.child.childLanes ? Ac(o, l, v) : (Yn(tt, tt.current & 1), o = rr(o, l, v), o !== null ? o.sibling : null);
        Yn(tt, tt.current & 1);
        break;
      case 19:
        if (w = (v & l.childLanes) !== 0, o.flags & 128) {
          if (w) return Hi(o, l, v);
          l.flags |= 128;
        }
        if (b = l.memoizedState, b !== null && (b.rendering = null, b.tail = null, b.lastEffect = null), Yn(tt, tt.current), w) break;
        return null;
      case 22:
      case 23:
        return l.lanes = 0, Wh(o, l, v);
    }
    return rr(o, l, v);
  }
  var za, qh, md, gd;
  za = function(o, l) {
    for (var v = l.child; v !== null; ) {
      if (v.tag === 5 || v.tag === 6) o.appendChild(v.stateNode);
      else if (v.tag !== 4 && v.child !== null) {
        v.child.return = v, v = v.child;
        continue;
      }
      if (v === l) break;
      for (; v.sibling === null; ) {
        if (v.return === null || v.return === l) return;
        v = v.return;
      }
      v.sibling.return = v.return, v = v.sibling;
    }
  }, qh = function() {
  }, md = function(o, l, v, w) {
    var b = o.memoizedProps;
    if (b !== w) {
      o = l.stateNode, wu(Vl.current);
      var E = null;
      switch (v) {
        case "input":
          b = yr(o, b), w = yr(o, w), E = [];
          break;
        case "select":
          b = Ze({}, b, { value: void 0 }), w = Ze({}, w, { value: void 0 }), E = [];
          break;
        case "textarea":
          b = zn(o, b), w = zn(o, w), E = [];
          break;
        default:
          typeof b.onClick != "function" && typeof w.onClick == "function" && (o.onclick = dc);
      }
      wn(v, w);
      var Z;
      v = null;
      for (ye in b) if (!w.hasOwnProperty(ye) && b.hasOwnProperty(ye) && b[ye] != null) if (ye === "style") {
        var z = b[ye];
        for (Z in z) z.hasOwnProperty(Z) && (v || (v = {}), v[Z] = "");
      } else ye !== "dangerouslySetInnerHTML" && ye !== "children" && ye !== "suppressContentEditableWarning" && ye !== "suppressHydrationWarning" && ye !== "autoFocus" && (h.hasOwnProperty(ye) ? E || (E = []) : (E = E || []).push(ye, null));
      for (ye in w) {
        var ee = w[ye];
        if (z = b != null ? b[ye] : void 0, w.hasOwnProperty(ye) && ee !== z && (ee != null || z != null)) if (ye === "style") if (z) {
          for (Z in z) !z.hasOwnProperty(Z) || ee && ee.hasOwnProperty(Z) || (v || (v = {}), v[Z] = "");
          for (Z in ee) ee.hasOwnProperty(Z) && z[Z] !== ee[Z] && (v || (v = {}), v[Z] = ee[Z]);
        } else v || (E || (E = []), E.push(
          ye,
          v
        )), v = ee;
        else ye === "dangerouslySetInnerHTML" ? (ee = ee ? ee.__html : void 0, z = z ? z.__html : void 0, ee != null && z !== ee && (E = E || []).push(ye, ee)) : ye === "children" ? typeof ee != "string" && typeof ee != "number" || (E = E || []).push(ye, "" + ee) : ye !== "suppressContentEditableWarning" && ye !== "suppressHydrationWarning" && (h.hasOwnProperty(ye) ? (ee != null && ye === "onScroll" && vr("scroll", o), E || z === ee || (E = [])) : (E = E || []).push(ye, ee));
      }
      v && (E = E || []).push("style", v);
      var ye = E;
      (l.updateQueue = ye) && (l.flags |= 4);
    }
  }, gd = function(o, l, v, w) {
    v !== w && (l.flags |= 4);
  };
  function ss(o, l) {
    if (!br) switch (o.tailMode) {
      case "hidden":
        l = o.tail;
        for (var v = null; l !== null; ) l.alternate !== null && (v = l), l = l.sibling;
        v === null ? o.tail = null : v.sibling = null;
        break;
      case "collapsed":
        v = o.tail;
        for (var w = null; v !== null; ) v.alternate !== null && (w = v), v = v.sibling;
        w === null ? l || o.tail === null ? o.tail = null : o.tail.sibling = null : w.sibling = null;
    }
  }
  function Ra(o) {
    var l = o.alternate !== null && o.alternate.child === o.child, v = 0, w = 0;
    if (l) for (var b = o.child; b !== null; ) v |= b.lanes | b.childLanes, w |= b.subtreeFlags & 14680064, w |= b.flags & 14680064, b.return = o, b = b.sibling;
    else for (b = o.child; b !== null; ) v |= b.lanes | b.childLanes, w |= b.subtreeFlags, w |= b.flags, b.return = o, b = b.sibling;
    return o.subtreeFlags |= w, o.childLanes = v, l;
  }
  function Jp(o, l, v) {
    var w = l.pendingProps;
    switch (Ys(l), l.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Ra(l), null;
      case 1:
        return Ua(l.type) && Io(), Ra(l), null;
      case 3:
        return w = l.stateNode, Ju(), Un(la), Un(Zr), _r(), w.pendingContext && (w.context = w.pendingContext, w.pendingContext = null), (o === null || o.child === null) && (al(l) ? l.flags |= 4 : o === null || o.memoizedState.isDehydrated && !(l.flags & 256) || (l.flags |= 1024, rl !== null && (Ed(rl), rl = null))), qh(o, l), Ra(l), null;
      case 5:
        e0(l);
        var b = wu($s.current);
        if (v = l.type, o !== null && l.stateNode != null) md(o, l, v, w, b), o.ref !== l.ref && (l.flags |= 512, l.flags |= 2097152);
        else {
          if (!w) {
            if (l.stateNode === null) throw Error(a(166));
            return Ra(l), null;
          }
          if (o = wu(Vl.current), al(l)) {
            w = l.stateNode, v = l.type;
            var E = l.memoizedProps;
            switch (w[Oi] = l, w[Xo] = E, o = (l.mode & 1) !== 0, v) {
              case "dialog":
                vr("cancel", w), vr("close", w);
                break;
              case "iframe":
              case "object":
              case "embed":
                vr("load", w);
                break;
              case "video":
              case "audio":
                for (b = 0; b < Lo.length; b++) vr(Lo[b], w);
                break;
              case "source":
                vr("error", w);
                break;
              case "img":
              case "image":
              case "link":
                vr(
                  "error",
                  w
                ), vr("load", w);
                break;
              case "details":
                vr("toggle", w);
                break;
              case "input":
                ea(w, E), vr("invalid", w);
                break;
              case "select":
                w._wrapperState = { wasMultiple: !!E.multiple }, vr("invalid", w);
                break;
              case "textarea":
                Ur(w, E), vr("invalid", w);
            }
            wn(v, E), b = null;
            for (var Z in E) if (E.hasOwnProperty(Z)) {
              var z = E[Z];
              Z === "children" ? typeof z == "string" ? w.textContent !== z && (E.suppressHydrationWarning !== !0 && fu(w.textContent, z, o), b = ["children", z]) : typeof z == "number" && w.textContent !== "" + z && (E.suppressHydrationWarning !== !0 && fu(
                w.textContent,
                z,
                o
              ), b = ["children", "" + z]) : h.hasOwnProperty(Z) && z != null && Z === "onScroll" && vr("scroll", w);
            }
            switch (v) {
              case "input":
                kn(w), fn(w, E, !0);
                break;
              case "textarea":
                kn(w), Jt(w);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof E.onClick == "function" && (w.onclick = dc);
            }
            w = b, l.updateQueue = w, w !== null && (l.flags |= 4);
          } else {
            Z = b.nodeType === 9 ? b : b.ownerDocument, o === "http://www.w3.org/1999/xhtml" && (o = qn(v)), o === "http://www.w3.org/1999/xhtml" ? v === "script" ? (o = Z.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild)) : typeof w.is == "string" ? o = Z.createElement(v, { is: w.is }) : (o = Z.createElement(v), v === "select" && (Z = o, w.multiple ? Z.multiple = !0 : w.size && (Z.size = w.size))) : o = Z.createElementNS(o, v), o[Oi] = l, o[Xo] = w, za(o, l, !1, !1), l.stateNode = o;
            e: {
              switch (Z = Gn(v, w), v) {
                case "dialog":
                  vr("cancel", o), vr("close", o), b = w;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  vr("load", o), b = w;
                  break;
                case "video":
                case "audio":
                  for (b = 0; b < Lo.length; b++) vr(Lo[b], o);
                  b = w;
                  break;
                case "source":
                  vr("error", o), b = w;
                  break;
                case "img":
                case "image":
                case "link":
                  vr(
                    "error",
                    o
                  ), vr("load", o), b = w;
                  break;
                case "details":
                  vr("toggle", o), b = w;
                  break;
                case "input":
                  ea(o, w), b = yr(o, w), vr("invalid", o);
                  break;
                case "option":
                  b = w;
                  break;
                case "select":
                  o._wrapperState = { wasMultiple: !!w.multiple }, b = Ze({}, w, { value: void 0 }), vr("invalid", o);
                  break;
                case "textarea":
                  Ur(o, w), b = zn(o, w), vr("invalid", o);
                  break;
                default:
                  b = w;
              }
              wn(v, b), z = b;
              for (E in z) if (z.hasOwnProperty(E)) {
                var ee = z[E];
                E === "style" ? xr(o, ee) : E === "dangerouslySetInnerHTML" ? (ee = ee ? ee.__html : void 0, ee != null && yt(o, ee)) : E === "children" ? typeof ee == "string" ? (v !== "textarea" || ee !== "") && Ct(o, ee) : typeof ee == "number" && Ct(o, "" + ee) : E !== "suppressContentEditableWarning" && E !== "suppressHydrationWarning" && E !== "autoFocus" && (h.hasOwnProperty(E) ? ee != null && E === "onScroll" && vr("scroll", o) : ee != null && W(o, E, ee, Z));
              }
              switch (v) {
                case "input":
                  kn(o), fn(o, w, !1);
                  break;
                case "textarea":
                  kn(o), Jt(o);
                  break;
                case "option":
                  w.value != null && o.setAttribute("value", "" + St(w.value));
                  break;
                case "select":
                  o.multiple = !!w.multiple, E = w.value, E != null ? gn(o, !!w.multiple, E, !1) : w.defaultValue != null && gn(
                    o,
                    !!w.multiple,
                    w.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof b.onClick == "function" && (o.onclick = dc);
              }
              switch (v) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  w = !!w.autoFocus;
                  break e;
                case "img":
                  w = !0;
                  break e;
                default:
                  w = !1;
              }
            }
            w && (l.flags |= 4);
          }
          l.ref !== null && (l.flags |= 512, l.flags |= 2097152);
        }
        return Ra(l), null;
      case 6:
        if (o && l.stateNode != null) gd(o, l, o.memoizedProps, w);
        else {
          if (typeof w != "string" && l.stateNode === null) throw Error(a(166));
          if (v = wu($s.current), wu(Vl.current), al(l)) {
            if (w = l.stateNode, v = l.memoizedProps, w[Oi] = l, (E = w.nodeValue !== v) && (o = Ya, o !== null)) switch (o.tag) {
              case 3:
                fu(w.nodeValue, v, (o.mode & 1) !== 0);
                break;
              case 5:
                o.memoizedProps.suppressHydrationWarning !== !0 && fu(w.nodeValue, v, (o.mode & 1) !== 0);
            }
            E && (l.flags |= 4);
          } else w = (v.nodeType === 9 ? v : v.ownerDocument).createTextNode(w), w[Oi] = l, l.stateNode = w;
        }
        return Ra(l), null;
      case 13:
        if (Un(tt), w = l.memoizedState, o === null || o.memoizedState !== null && o.memoizedState.dehydrated !== null) {
          if (br && Zo !== null && l.mode & 1 && !(l.flags & 128)) Nh(), ji(), l.flags |= 98560, E = !1;
          else if (E = al(l), w !== null && w.dehydrated !== null) {
            if (o === null) {
              if (!E) throw Error(a(318));
              if (E = l.memoizedState, E = E !== null ? E.dehydrated : null, !E) throw Error(a(317));
              E[Oi] = l;
            } else ji(), !(l.flags & 128) && (l.memoizedState = null), l.flags |= 4;
            Ra(l), E = !1;
          } else rl !== null && (Ed(rl), rl = null), E = !0;
          if (!E) return l.flags & 65536 ? l : null;
        }
        return l.flags & 128 ? (l.lanes = v, l) : (w = w !== null, w !== (o !== null && o.memoizedState !== null) && w && (l.child.flags |= 8192, l.mode & 1 && (o === null || tt.current & 1 ? qr === 0 && (qr = 3) : Md())), l.updateQueue !== null && (l.flags |= 4), Ra(l), null);
      case 4:
        return Ju(), qh(o, l), o === null && cu(l.stateNode.containerInfo), Ra(l), null;
      case 10:
        return od(l.type._context), Ra(l), null;
      case 17:
        return Ua(l.type) && Io(), Ra(l), null;
      case 19:
        if (Un(tt), E = l.memoizedState, E === null) return Ra(l), null;
        if (w = (l.flags & 128) !== 0, Z = E.rendering, Z === null) if (w) ss(E, !1);
        else {
          if (qr !== 0 || o !== null && o.flags & 128) for (o = l.child; o !== null; ) {
            if (Z = on(o), Z !== null) {
              for (l.flags |= 128, ss(E, !1), w = Z.updateQueue, w !== null && (l.updateQueue = w, l.flags |= 4), l.subtreeFlags = 0, w = v, v = l.child; v !== null; ) E = v, o = w, E.flags &= 14680066, Z = E.alternate, Z === null ? (E.childLanes = 0, E.lanes = o, E.child = null, E.subtreeFlags = 0, E.memoizedProps = null, E.memoizedState = null, E.updateQueue = null, E.dependencies = null, E.stateNode = null) : (E.childLanes = Z.childLanes, E.lanes = Z.lanes, E.child = Z.child, E.subtreeFlags = 0, E.deletions = null, E.memoizedProps = Z.memoizedProps, E.memoizedState = Z.memoizedState, E.updateQueue = Z.updateQueue, E.type = Z.type, o = Z.dependencies, E.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }), v = v.sibling;
              return Yn(tt, tt.current & 1 | 2), l.child;
            }
            o = o.sibling;
          }
          E.tail !== null && Jn() > vl && (l.flags |= 128, w = !0, ss(E, !1), l.lanes = 4194304);
        }
        else {
          if (!w) if (o = on(Z), o !== null) {
            if (l.flags |= 128, w = !0, v = o.updateQueue, v !== null && (l.updateQueue = v, l.flags |= 4), ss(E, !0), E.tail === null && E.tailMode === "hidden" && !Z.alternate && !br) return Ra(l), null;
          } else 2 * Jn() - E.renderingStartTime > vl && v !== 1073741824 && (l.flags |= 128, w = !0, ss(E, !1), l.lanes = 4194304);
          E.isBackwards ? (Z.sibling = l.child, l.child = Z) : (v = E.last, v !== null ? v.sibling = Z : l.child = Z, E.last = Z);
        }
        return E.tail !== null ? (l = E.tail, E.rendering = l, E.tail = l.sibling, E.renderingStartTime = Jn(), l.sibling = null, v = tt.current, Yn(tt, w ? v & 1 | 2 : v & 1), l) : (Ra(l), null);
      case 22:
      case 23:
        return Kh(), w = l.memoizedState !== null, o !== null && o.memoizedState !== null !== w && (l.flags |= 8192), w && l.mode & 1 ? li & 1073741824 && (Ra(l), l.subtreeFlags & 6 && (l.flags |= 8192)) : Ra(l), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(a(156, l.tag));
  }
  function em(o, l) {
    switch (Ys(l), l.tag) {
      case 1:
        return Ua(l.type) && Io(), o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, l) : null;
      case 3:
        return Ju(), Un(la), Un(Zr), _r(), o = l.flags, o & 65536 && !(o & 128) ? (l.flags = o & -65537 | 128, l) : null;
      case 5:
        return e0(l), null;
      case 13:
        if (Un(tt), o = l.memoizedState, o !== null && o.dehydrated !== null) {
          if (l.alternate === null) throw Error(a(340));
          ji();
        }
        return o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, l) : null;
      case 19:
        return Un(tt), null;
      case 4:
        return Ju(), null;
      case 10:
        return od(l.type._context), null;
      case 22:
      case 23:
        return Kh(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var d0 = !1, Or = !1, io = typeof WeakSet == "function" ? WeakSet : Set, ht = null;
  function Js(o, l) {
    var v = o.ref;
    if (v !== null) if (typeof v == "function") try {
      v(null);
    } catch (w) {
      kr(o, l, w);
    }
    else v.current = null;
  }
  function kc(o, l, v) {
    try {
      v();
    } catch (w) {
      kr(o, l, w);
    }
  }
  var Gh = !1;
  function tm(o, l) {
    if (W1 = z0, o = nr(), oc(o)) {
      if ("selectionStart" in o) var v = { start: o.selectionStart, end: o.selectionEnd };
      else {
        v = (v = o.ownerDocument) && v.defaultView || window;
        var w = v.getSelection && v.getSelection();
        if (w && w.rangeCount !== 0) {
          v = w.anchorNode;
          var b = w.anchorOffset, E = w.focusNode;
          w = w.focusOffset;
          var Z = 0, z = -1, ee = -1, ye = 0, Ne = 0, Ye = o, Ve = null;
          e: for (; ; ) {
            for (var lt; Ye !== v || b !== 0 && Ye.nodeType !== 3 || (z = Z + b), Ye !== E || w !== 0 && Ye.nodeType !== 3 || (ee = Z + w), Ye.nodeType === 3 && (Z += Ye.nodeValue.length), (lt = Ye.firstChild) !== null; )
              Ve = Ye, Ye = lt;
            for (; ; ) {
              if (Ye === o) break e;
              if (Ve === v && ++ye === b && (z = Z), Ve === E && ++Ne === w && (ee = Z), (lt = Ye.nextSibling) !== null) break;
              Ye = Ve, Ve = Ye.parentNode;
            }
            Ye = lt;
          }
          v = z === -1 || ee === -1 ? null : { start: z, end: ee };
        } else v = null;
      }
      v = v || { start: 0, end: 0 };
    } else v = null;
    for (du = { focusedElem: o, selectionRange: v }, z0 = !1, ht = l; ht !== null; ) if (l = ht, o = l.child, (l.subtreeFlags & 1028) !== 0 && o !== null) o.return = l, ht = o;
    else for (; ht !== null; ) {
      l = ht;
      try {
        var xt = l.alternate;
        if (l.flags & 1024) switch (l.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (xt !== null) {
              var bt = xt.memoizedProps, Gr = xt.memoizedState, ce = l.stateNode, ne = ce.getSnapshotBeforeUpdate(l.elementType === l.type ? bt : Li(l.type, bt), Gr);
              ce.__reactInternalSnapshotBeforeUpdate = ne;
            }
            break;
          case 3:
            var he = l.stateNode.containerInfo;
            he.nodeType === 1 ? he.textContent = "" : he.nodeType === 9 && he.documentElement && he.removeChild(he.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(a(163));
        }
      } catch (ze) {
        kr(l, l.return, ze);
      }
      if (o = l.sibling, o !== null) {
        o.return = l.return, ht = o;
        break;
      }
      ht = l.return;
    }
    return xt = Gh, Gh = !1, xt;
  }
  function ul(o, l, v) {
    var w = l.updateQueue;
    if (w = w !== null ? w.lastEffect : null, w !== null) {
      var b = w = w.next;
      do {
        if ((b.tag & o) === o) {
          var E = b.destroy;
          b.destroy = void 0, E !== void 0 && kc(l, v, E);
        }
        b = b.next;
      } while (b !== w);
    }
  }
  function cs(o, l) {
    if (l = l.updateQueue, l = l !== null ? l.lastEffect : null, l !== null) {
      var v = l = l.next;
      do {
        if ((v.tag & o) === o) {
          var w = v.create;
          v.destroy = w();
        }
        v = v.next;
      } while (v !== l);
    }
  }
  function sl(o) {
    var l = o.ref;
    if (l !== null) {
      var v = o.stateNode;
      switch (o.tag) {
        case 5:
          o = v;
          break;
        default:
          o = v;
      }
      typeof l == "function" ? l(o) : l.current = o;
    }
  }
  function Cu(o) {
    var l = o.alternate;
    l !== null && (o.alternate = null, Cu(l)), o.child = null, o.deletions = null, o.sibling = null, o.tag === 5 && (l = o.stateNode, l !== null && (delete l[Oi], delete l[Xo], delete l[Xf], delete l[H], delete l[Xi])), o.stateNode = null, o.return = null, o.dependencies = null, o.memoizedProps = null, o.memoizedState = null, o.pendingProps = null, o.stateNode = null, o.updateQueue = null;
  }
  function bu(o) {
    return o.tag === 5 || o.tag === 3 || o.tag === 4;
  }
  function h0(o) {
    e: for (; ; ) {
      for (; o.sibling === null; ) {
        if (o.return === null || bu(o.return)) return null;
        o = o.return;
      }
      for (o.sibling.return = o.return, o = o.sibling; o.tag !== 5 && o.tag !== 6 && o.tag !== 18; ) {
        if (o.flags & 2 || o.child === null || o.tag === 4) continue e;
        o.child.return = o, o = o.child;
      }
      if (!(o.flags & 2)) return o.stateNode;
    }
  }
  function e1(o, l, v) {
    var w = o.tag;
    if (w === 5 || w === 6) o = o.stateNode, l ? v.nodeType === 8 ? v.parentNode.insertBefore(o, l) : v.insertBefore(o, l) : (v.nodeType === 8 ? (l = v.parentNode, l.insertBefore(o, v)) : (l = v, l.appendChild(o)), v = v._reactRootContainer, v != null || l.onclick !== null || (l.onclick = dc));
    else if (w !== 4 && (o = o.child, o !== null)) for (e1(o, l, v), o = o.sibling; o !== null; ) e1(o, l, v), o = o.sibling;
  }
  function cl(o, l, v) {
    var w = o.tag;
    if (w === 5 || w === 6) o = o.stateNode, l ? v.insertBefore(o, l) : v.appendChild(o);
    else if (w !== 4 && (o = o.child, o !== null)) for (cl(o, l, v), o = o.sibling; o !== null; ) cl(o, l, v), o = o.sibling;
  }
  var Ea = null, fl = !1;
  function Fl(o, l, v) {
    for (v = v.child; v !== null; ) wd(o, l, v), v = v.sibling;
  }
  function wd(o, l, v) {
    if (Dl && typeof Dl.onCommitFiberUnmount == "function") try {
      Dl.onCommitFiberUnmount(U0, v);
    } catch {
    }
    switch (v.tag) {
      case 5:
        Or || Js(v, l);
      case 6:
        var w = Ea, b = fl;
        Ea = null, Fl(o, l, v), Ea = w, fl = b, Ea !== null && (fl ? (o = Ea, v = v.stateNode, o.nodeType === 8 ? o.parentNode.removeChild(v) : o.removeChild(v)) : Ea.removeChild(v.stateNode));
        break;
      case 18:
        Ea !== null && (fl ? (o = Ea, v = v.stateNode, o.nodeType === 8 ? vc(o.parentNode, v) : o.nodeType === 1 && vc(o, v), Fn(o)) : vc(Ea, v.stateNode));
        break;
      case 4:
        w = Ea, b = fl, Ea = v.stateNode.containerInfo, fl = !0, Fl(o, l, v), Ea = w, fl = b;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Or && (w = v.updateQueue, w !== null && (w = w.lastEffect, w !== null))) {
          b = w = w.next;
          do {
            var E = b, Z = E.destroy;
            E = E.tag, Z !== void 0 && (E & 2 || E & 4) && kc(v, l, Z), b = b.next;
          } while (b !== w);
        }
        Fl(o, l, v);
        break;
      case 1:
        if (!Or && (Js(v, l), w = v.stateNode, typeof w.componentWillUnmount == "function")) try {
          w.props = v.memoizedProps, w.state = v.memoizedState, w.componentWillUnmount();
        } catch (z) {
          kr(v, l, z);
        }
        Fl(o, l, v);
        break;
      case 21:
        Fl(o, l, v);
        break;
      case 22:
        v.mode & 1 ? (Or = (w = Or) || v.memoizedState !== null, Fl(o, l, v), Or = w) : Fl(o, l, v);
        break;
      default:
        Fl(o, l, v);
    }
  }
  function Ul(o) {
    var l = o.updateQueue;
    if (l !== null) {
      o.updateQueue = null;
      var v = o.stateNode;
      v === null && (v = o.stateNode = new io()), l.forEach(function(w) {
        var b = im.bind(null, o, w);
        v.has(w) || (v.add(w), w.then(b, b));
      });
    }
  }
  function ii(o, l) {
    var v = l.deletions;
    if (v !== null) for (var w = 0; w < v.length; w++) {
      var b = v[w];
      try {
        var E = o, Z = l, z = Z;
        e: for (; z !== null; ) {
          switch (z.tag) {
            case 5:
              Ea = z.stateNode, fl = !1;
              break e;
            case 3:
              Ea = z.stateNode.containerInfo, fl = !0;
              break e;
            case 4:
              Ea = z.stateNode.containerInfo, fl = !0;
              break e;
          }
          z = z.return;
        }
        if (Ea === null) throw Error(a(160));
        wd(E, Z, b), Ea = null, fl = !1;
        var ee = b.alternate;
        ee !== null && (ee.return = null), b.return = null;
      } catch (ye) {
        kr(b, l, ye);
      }
    }
    if (l.subtreeFlags & 12854) for (l = l.child; l !== null; ) yd(l, o), l = l.sibling;
  }
  function yd(o, l) {
    var v = o.alternate, w = o.flags;
    switch (o.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (ii(l, o), dl(o), w & 4) {
          try {
            ul(3, o, o.return), cs(3, o);
          } catch (bt) {
            kr(o, o.return, bt);
          }
          try {
            ul(5, o, o.return);
          } catch (bt) {
            kr(o, o.return, bt);
          }
        }
        break;
      case 1:
        ii(l, o), dl(o), w & 512 && v !== null && Js(v, v.return);
        break;
      case 5:
        if (ii(l, o), dl(o), w & 512 && v !== null && Js(v, v.return), o.flags & 32) {
          var b = o.stateNode;
          try {
            Ct(b, "");
          } catch (bt) {
            kr(o, o.return, bt);
          }
        }
        if (w & 4 && (b = o.stateNode, b != null)) {
          var E = o.memoizedProps, Z = v !== null ? v.memoizedProps : E, z = o.type, ee = o.updateQueue;
          if (o.updateQueue = null, ee !== null) try {
            z === "input" && E.type === "radio" && E.name != null && Ca(b, E), Gn(z, Z);
            var ye = Gn(z, E);
            for (Z = 0; Z < ee.length; Z += 2) {
              var Ne = ee[Z], Ye = ee[Z + 1];
              Ne === "style" ? xr(b, Ye) : Ne === "dangerouslySetInnerHTML" ? yt(b, Ye) : Ne === "children" ? Ct(b, Ye) : W(b, Ne, Ye, ye);
            }
            switch (z) {
              case "input":
                ft(b, E);
                break;
              case "textarea":
                Xe(b, E);
                break;
              case "select":
                var Ve = b._wrapperState.wasMultiple;
                b._wrapperState.wasMultiple = !!E.multiple;
                var lt = E.value;
                lt != null ? gn(b, !!E.multiple, lt, !1) : Ve !== !!E.multiple && (E.defaultValue != null ? gn(
                  b,
                  !!E.multiple,
                  E.defaultValue,
                  !0
                ) : gn(b, !!E.multiple, E.multiple ? [] : "", !1));
            }
            b[Xo] = E;
          } catch (bt) {
            kr(o, o.return, bt);
          }
        }
        break;
      case 6:
        if (ii(l, o), dl(o), w & 4) {
          if (o.stateNode === null) throw Error(a(162));
          b = o.stateNode, E = o.memoizedProps;
          try {
            b.nodeValue = E;
          } catch (bt) {
            kr(o, o.return, bt);
          }
        }
        break;
      case 3:
        if (ii(l, o), dl(o), w & 4 && v !== null && v.memoizedState.isDehydrated) try {
          Fn(l.containerInfo);
        } catch (bt) {
          kr(o, o.return, bt);
        }
        break;
      case 4:
        ii(l, o), dl(o);
        break;
      case 13:
        ii(l, o), dl(o), b = o.child, b.flags & 8192 && (E = b.memoizedState !== null, b.stateNode.isHidden = E, !E || b.alternate !== null && b.alternate.memoizedState !== null || (Hc = Jn())), w & 4 && Ul(o);
        break;
      case 22:
        if (Ne = v !== null && v.memoizedState !== null, o.mode & 1 ? (Or = (ye = Or) || Ne, ii(l, o), Or = ye) : ii(l, o), dl(o), w & 8192) {
          if (ye = o.memoizedState !== null, (o.stateNode.isHidden = ye) && !Ne && o.mode & 1) for (ht = o, Ne = o.child; Ne !== null; ) {
            for (Ye = ht = Ne; ht !== null; ) {
              switch (Ve = ht, lt = Ve.child, Ve.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  ul(4, Ve, Ve.return);
                  break;
                case 1:
                  Js(Ve, Ve.return);
                  var xt = Ve.stateNode;
                  if (typeof xt.componentWillUnmount == "function") {
                    w = Ve, v = Ve.return;
                    try {
                      l = w, xt.props = l.memoizedProps, xt.state = l.memoizedState, xt.componentWillUnmount();
                    } catch (bt) {
                      kr(w, v, bt);
                    }
                  }
                  break;
                case 5:
                  Js(Ve, Ve.return);
                  break;
                case 22:
                  if (Ve.memoizedState !== null) {
                    Zi(Ye);
                    continue;
                  }
              }
              lt !== null ? (lt.return = Ve, ht = lt) : Zi(Ye);
            }
            Ne = Ne.sibling;
          }
          e: for (Ne = null, Ye = o; ; ) {
            if (Ye.tag === 5) {
              if (Ne === null) {
                Ne = Ye;
                try {
                  b = Ye.stateNode, ye ? (E = b.style, typeof E.setProperty == "function" ? E.setProperty("display", "none", "important") : E.display = "none") : (z = Ye.stateNode, ee = Ye.memoizedProps.style, Z = ee != null && ee.hasOwnProperty("display") ? ee.display : null, z.style.display = ta("display", Z));
                } catch (bt) {
                  kr(o, o.return, bt);
                }
              }
            } else if (Ye.tag === 6) {
              if (Ne === null) try {
                Ye.stateNode.nodeValue = ye ? "" : Ye.memoizedProps;
              } catch (bt) {
                kr(o, o.return, bt);
              }
            } else if ((Ye.tag !== 22 && Ye.tag !== 23 || Ye.memoizedState === null || Ye === o) && Ye.child !== null) {
              Ye.child.return = Ye, Ye = Ye.child;
              continue;
            }
            if (Ye === o) break e;
            for (; Ye.sibling === null; ) {
              if (Ye.return === null || Ye.return === o) break e;
              Ne === Ye && (Ne = null), Ye = Ye.return;
            }
            Ne === Ye && (Ne = null), Ye.sibling.return = Ye.return, Ye = Ye.sibling;
          }
        }
        break;
      case 19:
        ii(l, o), dl(o), w & 4 && Ul(o);
        break;
      case 21:
        break;
      default:
        ii(
          l,
          o
        ), dl(o);
    }
  }
  function dl(o) {
    var l = o.flags;
    if (l & 2) {
      try {
        e: {
          for (var v = o.return; v !== null; ) {
            if (bu(v)) {
              var w = v;
              break e;
            }
            v = v.return;
          }
          throw Error(a(160));
        }
        switch (w.tag) {
          case 5:
            var b = w.stateNode;
            w.flags & 32 && (Ct(b, ""), w.flags &= -33);
            var E = h0(o);
            cl(o, E, b);
            break;
          case 3:
          case 4:
            var Z = w.stateNode.containerInfo, z = h0(o);
            e1(o, z, Z);
            break;
          default:
            throw Error(a(161));
        }
      } catch (ee) {
        kr(o, o.return, ee);
      }
      o.flags &= -3;
    }
    l & 4096 && (o.flags &= -4097);
  }
  function t1(o, l, v) {
    ht = o, xd(o);
  }
  function xd(o, l, v) {
    for (var w = (o.mode & 1) !== 0; ht !== null; ) {
      var b = ht, E = b.child;
      if (b.tag === 22 && w) {
        var Z = b.memoizedState !== null || d0;
        if (!Z) {
          var z = b.alternate, ee = z !== null && z.memoizedState !== null || Or;
          z = d0;
          var ye = Or;
          if (d0 = Z, (Or = ee) && !ye) for (ht = b; ht !== null; ) Z = ht, ee = Z.child, Z.tag === 22 && Z.memoizedState !== null ? v0(b) : ee !== null ? (ee.return = Z, ht = ee) : v0(b);
          for (; E !== null; ) ht = E, xd(E), E = E.sibling;
          ht = b, d0 = z, Or = ye;
        }
        hl(o);
      } else b.subtreeFlags & 8772 && E !== null ? (E.return = b, ht = E) : hl(o);
    }
  }
  function hl(o) {
    for (; ht !== null; ) {
      var l = ht;
      if (l.flags & 8772) {
        var v = l.alternate;
        try {
          if (l.flags & 8772) switch (l.tag) {
            case 0:
            case 11:
            case 15:
              Or || cs(5, l);
              break;
            case 1:
              var w = l.stateNode;
              if (l.flags & 4 && !Or) if (v === null) w.componentDidMount();
              else {
                var b = l.elementType === l.type ? v.memoizedProps : Li(l.type, v.memoizedProps);
                w.componentDidUpdate(b, v.memoizedState, w.__reactInternalSnapshotBeforeUpdate);
              }
              var E = l.updateQueue;
              E !== null && Bh(l, E, w);
              break;
            case 3:
              var Z = l.updateQueue;
              if (Z !== null) {
                if (v = null, l.child !== null) switch (l.child.tag) {
                  case 5:
                    v = l.child.stateNode;
                    break;
                  case 1:
                    v = l.child.stateNode;
                }
                Bh(l, Z, v);
              }
              break;
            case 5:
              var z = l.stateNode;
              if (v === null && l.flags & 4) {
                v = z;
                var ee = l.memoizedProps;
                switch (l.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    ee.autoFocus && v.focus();
                    break;
                  case "img":
                    ee.src && (v.src = ee.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (l.memoizedState === null) {
                var ye = l.alternate;
                if (ye !== null) {
                  var Ne = ye.memoizedState;
                  if (Ne !== null) {
                    var Ye = Ne.dehydrated;
                    Ye !== null && Fn(Ye);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(a(163));
          }
          Or || l.flags & 512 && sl(l);
        } catch (Ve) {
          kr(l, l.return, Ve);
        }
      }
      if (l === o) {
        ht = null;
        break;
      }
      if (v = l.sibling, v !== null) {
        v.return = l.return, ht = v;
        break;
      }
      ht = l.return;
    }
  }
  function Zi(o) {
    for (; ht !== null; ) {
      var l = ht;
      if (l === o) {
        ht = null;
        break;
      }
      var v = l.sibling;
      if (v !== null) {
        v.return = l.return, ht = v;
        break;
      }
      ht = l.return;
    }
  }
  function v0(o) {
    for (; ht !== null; ) {
      var l = ht;
      try {
        switch (l.tag) {
          case 0:
          case 11:
          case 15:
            var v = l.return;
            try {
              cs(4, l);
            } catch (ee) {
              kr(l, v, ee);
            }
            break;
          case 1:
            var w = l.stateNode;
            if (typeof w.componentDidMount == "function") {
              var b = l.return;
              try {
                w.componentDidMount();
              } catch (ee) {
                kr(l, b, ee);
              }
            }
            var E = l.return;
            try {
              sl(l);
            } catch (ee) {
              kr(l, E, ee);
            }
            break;
          case 5:
            var Z = l.return;
            try {
              sl(l);
            } catch (ee) {
              kr(l, Z, ee);
            }
        }
      } catch (ee) {
        kr(l, l.return, ee);
      }
      if (l === o) {
        ht = null;
        break;
      }
      var z = l.sibling;
      if (z !== null) {
        z.return = l.return, ht = z;
        break;
      }
      ht = l.return;
    }
  }
  var n1 = Math.ceil, p0 = Q.ReactCurrentDispatcher, Sd = Q.ReactCurrentOwner, Pi = Q.ReactCurrentBatchConfig, Mn = 0, Ma = null, sa = null, ma = 0, li = 0, _u = ia(0), qr = 0, m0 = null, fs = 0, Lc = 0, Cd = 0, Ic = null, Ta = null, Hc = 0, vl = 1 / 0, Ru = null, bd = !1, _d = null, Eu = null, r1 = !1, pl = null, lo = 0, qa = 0, ds = null, g0 = -1, Mu = 0;
  function xo() {
    return Mn & 6 ? Jn() : g0 !== -1 ? g0 : g0 = Jn();
  }
  function Yl(o) {
    return o.mode & 1 ? Mn & 2 && ma !== 0 ? ma & -ma : fv.transition !== null ? (Mu === 0 && (Mu = Th()), Mu) : (o = Bn, o !== 0 || (o = window.event, o = o === void 0 ? 16 : Af(o.type)), o) : 1;
  }
  function ui(o, l, v, w) {
    if (50 < qa) throw qa = 0, ds = null, Error(a(185));
    Y0(o, v, w), (!(Mn & 2) || o !== Ma) && (o === Ma && (!(Mn & 2) && (Lc |= v), qr === 4 && hs(o, ma)), Oa(o, w), v === 1 && Mn === 0 && !(l.mode & 1) && (vl = Jn() + 500, el && Di()));
  }
  function Oa(o, l) {
    var v = o.callbackNode;
    $p(o, l);
    var w = As(o, o === Ma ? ma : 0);
    if (w === 0) v !== null && vo(v), o.callbackNode = null, o.callbackPriority = 0;
    else if (l = w & -w, o.callbackPriority !== l) {
      if (v != null && vo(v), l === 1) o.tag === 0 ? vu(mv.bind(null, o)) : td(mv.bind(null, o)), z1(function() {
        !(Mn & 6) && Di();
      }), v = null;
      else {
        switch (Vu(w)) {
          case 1:
            v = j1;
            break;
          case 4:
            v = Eh;
            break;
          case 16:
            v = A1;
            break;
          case 536870912:
            v = Rf;
            break;
          default:
            v = A1;
        }
        v = _v(v, Rd.bind(null, o));
      }
      o.callbackPriority = l, o.callbackNode = v;
    }
  }
  function Rd(o, l) {
    if (g0 = -1, Mu = 0, Mn & 6) throw Error(a(327));
    var v = o.callbackNode;
    if (y0() && o.callbackNode !== v) return null;
    var w = As(o, o === Ma ? ma : 0);
    if (w === 0) return null;
    if (w & 30 || w & o.expiredLanes || l) l = Td(o, w);
    else {
      l = w;
      var b = Mn;
      Mn |= 2;
      var E = wv();
      (Ma !== o || ma !== l) && (Ru = null, vl = Jn() + 500, o1(o, l));
      do
        try {
          am();
          break;
        } catch (z) {
          gv(o, z);
        }
      while (!0);
      pr(), p0.current = E, Mn = b, sa !== null ? l = 0 : (Ma = null, ma = 0, l = qr);
    }
    if (l !== 0) {
      if (l === 2 && (b = k1(o), b !== 0 && (w = b, l = w0(o, b))), l === 1) throw v = m0, o1(o, 0), hs(o, w), Oa(o, Jn()), v;
      if (l === 6) hs(o, w);
      else {
        if (b = o.current.alternate, !(w & 30) && !nm(b) && (l = Td(o, w), l === 2 && (E = k1(o), E !== 0 && (w = E, l = w0(o, E))), l === 1)) throw v = m0, o1(o, 0), hs(o, w), Oa(o, Jn()), v;
        switch (o.finishedWork = b, o.finishedLanes = w, l) {
          case 0:
          case 1:
            throw Error(a(345));
          case 2:
            i1(o, Ta, Ru);
            break;
          case 3:
            if (hs(o, w), (w & 130023424) === w && (l = Hc + 500 - Jn(), 10 < l)) {
              if (As(o, 0) !== 0) break;
              if (b = o.suspendedLanes, (b & w) !== w) {
                xo(), o.pingedLanes |= o.suspendedLanes & b;
                break;
              }
              o.timeoutHandle = Qo(i1.bind(null, o, Ta, Ru), l);
              break;
            }
            i1(o, Ta, Ru);
            break;
          case 4:
            if (hs(o, w), (w & 4194240) === w) break;
            for (l = o.eventTimes, b = -1; 0 < w; ) {
              var Z = 31 - zo(w);
              E = 1 << Z, Z = l[Z], Z > b && (b = Z), w &= ~E;
            }
            if (w = b, w = Jn() - w, w = (120 > w ? 120 : 480 > w ? 480 : 1080 > w ? 1080 : 1920 > w ? 1920 : 3e3 > w ? 3e3 : 4320 > w ? 4320 : 1960 * n1(w / 1960)) - w, 10 < w) {
              o.timeoutHandle = Qo(i1.bind(null, o, Ta, Ru), w);
              break;
            }
            i1(o, Ta, Ru);
            break;
          case 5:
            i1(o, Ta, Ru);
            break;
          default:
            throw Error(a(329));
        }
      }
    }
    return Oa(o, Jn()), o.callbackNode === v ? Rd.bind(null, o) : null;
  }
  function w0(o, l) {
    var v = Ic;
    return o.current.memoizedState.isDehydrated && (o1(o, l).flags |= 256), o = Td(o, l), o !== 2 && (l = Ta, Ta = v, l !== null && Ed(l)), o;
  }
  function Ed(o) {
    Ta === null ? Ta = o : Ta.push.apply(Ta, o);
  }
  function nm(o) {
    for (var l = o; ; ) {
      if (l.flags & 16384) {
        var v = l.updateQueue;
        if (v !== null && (v = v.stores, v !== null)) for (var w = 0; w < v.length; w++) {
          var b = v[w], E = b.getSnapshot;
          b = b.value;
          try {
            if (!ge(E(), b)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (v = l.child, l.subtreeFlags & 16384 && v !== null) v.return = l, l = v;
      else {
        if (l === o) break;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === o) return !0;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    }
    return !0;
  }
  function hs(o, l) {
    for (l &= ~Cd, l &= ~Lc, o.suspendedLanes |= l, o.pingedLanes &= ~l, o = o.expirationTimes; 0 < l; ) {
      var v = 31 - zo(l), w = 1 << v;
      o[v] = -1, l &= ~w;
    }
  }
  function mv(o) {
    if (Mn & 6) throw Error(a(327));
    y0();
    var l = As(o, 0);
    if (!(l & 1)) return Oa(o, Jn()), null;
    var v = Td(o, l);
    if (o.tag !== 0 && v === 2) {
      var w = k1(o);
      w !== 0 && (l = w, v = w0(o, w));
    }
    if (v === 1) throw v = m0, o1(o, 0), hs(o, l), Oa(o, Jn()), v;
    if (v === 6) throw Error(a(345));
    return o.finishedWork = o.current.alternate, o.finishedLanes = l, i1(o, Ta, Ru), Oa(o, Jn()), null;
  }
  function Zc(o, l) {
    var v = Mn;
    Mn |= 1;
    try {
      return o(l);
    } finally {
      Mn = v, Mn === 0 && (vl = Jn() + 500, el && Di());
    }
  }
  function a1(o) {
    pl !== null && pl.tag === 0 && !(Mn & 6) && y0();
    var l = Mn;
    Mn |= 1;
    var v = Pi.transition, w = Bn;
    try {
      if (Pi.transition = null, Bn = 1, o) return o();
    } finally {
      Bn = w, Pi.transition = v, Mn = l, !(Mn & 6) && Di();
    }
  }
  function Kh() {
    li = _u.current, Un(_u);
  }
  function o1(o, l) {
    o.finishedWork = null, o.finishedLanes = 0;
    var v = o.timeoutHandle;
    if (v !== -1 && (o.timeoutHandle = -1, Wu(v)), sa !== null) for (v = sa.return; v !== null; ) {
      var w = v;
      switch (Ys(w), w.tag) {
        case 1:
          w = w.type.childContextTypes, w != null && Io();
          break;
        case 3:
          Ju(), Un(la), Un(Zr), _r();
          break;
        case 5:
          e0(w);
          break;
        case 4:
          Ju();
          break;
        case 13:
          Un(tt);
          break;
        case 19:
          Un(tt);
          break;
        case 10:
          od(w.type._context);
          break;
        case 22:
        case 23:
          Kh();
      }
      v = v.return;
    }
    if (Ma = o, sa = o = So(o.current, null), ma = li = l, qr = 0, m0 = null, Cd = Lc = fs = 0, Ta = Ic = null, ol !== null) {
      for (l = 0; l < ol.length; l++) if (v = ol[l], w = v.interleaved, w !== null) {
        v.interleaved = null;
        var b = w.next, E = v.pending;
        if (E !== null) {
          var Z = E.next;
          E.next = b, w.next = Z;
        }
        v.pending = w;
      }
      ol = null;
    }
    return o;
  }
  function gv(o, l) {
    do {
      var v = sa;
      try {
        if (pr(), Po.current = Gs, He) {
          for (var w = Ar.memoizedState; w !== null; ) {
            var b = w.queue;
            b !== null && (b.pending = null), w = w.next;
          }
          He = !1;
        }
        if (es = 0, Wr = $r = Ar = null, Vr = !1, It = 0, Sd.current = null, v === null || v.return === null) {
          qr = 1, m0 = l, sa = null;
          break;
        }
        e: {
          var E = o, Z = v.return, z = v, ee = l;
          if (l = ma, z.flags |= 32768, ee !== null && typeof ee == "object" && typeof ee.then == "function") {
            var ye = ee, Ne = z, Ye = Ne.tag;
            if (!(Ne.mode & 1) && (Ye === 0 || Ye === 11 || Ye === 15)) {
              var Ve = Ne.alternate;
              Ve ? (Ne.updateQueue = Ve.updateQueue, Ne.memoizedState = Ve.memoizedState, Ne.lanes = Ve.lanes) : (Ne.updateQueue = null, Ne.memoizedState = null);
            }
            var lt = ls(Z);
            if (lt !== null) {
              lt.flags &= -257, Tc(lt, Z, z, E, l), lt.mode & 1 && xu(E, ye, l), l = lt, ee = ye;
              var xt = l.updateQueue;
              if (xt === null) {
                var bt = /* @__PURE__ */ new Set();
                bt.add(ee), l.updateQueue = bt;
              } else xt.add(ee);
              break e;
            } else {
              if (!(l & 1)) {
                xu(E, ye, l), Md();
                break e;
              }
              ee = Error(a(426));
            }
          } else if (br && z.mode & 1) {
            var Gr = ls(Z);
            if (Gr !== null) {
              !(Gr.flags & 65536) && (Gr.flags |= 256), Tc(Gr, Z, z, E, l), Zl(Nl(ee, z));
              break e;
            }
          }
          E = ee = Nl(ee, z), qr !== 4 && (qr = 2), Ic === null ? Ic = [E] : Ic.push(E), E = Z;
          do {
            switch (E.tag) {
              case 3:
                E.flags |= 65536, l &= -l, E.lanes |= l;
                var ce = Mc(E, ee, l);
                hv(E, ce);
                break e;
              case 1:
                z = ee;
                var ne = E.type, he = E.stateNode;
                if (!(E.flags & 128) && (typeof ne.getDerivedStateFromError == "function" || he !== null && typeof he.componentDidCatch == "function" && (Eu === null || !Eu.has(he)))) {
                  E.flags |= 65536, l &= -l, E.lanes |= l;
                  var ze = Bl(E, z, l);
                  hv(E, ze);
                  break e;
                }
            }
            E = E.return;
          } while (E !== null);
        }
        xv(v);
      } catch (Tt) {
        l = Tt, sa === v && v !== null && (sa = v = v.return);
        continue;
      }
      break;
    } while (!0);
  }
  function wv() {
    var o = p0.current;
    return p0.current = Gs, o === null ? Gs : o;
  }
  function Md() {
    (qr === 0 || qr === 3 || qr === 2) && (qr = 4), Ma === null || !(fs & 268435455) && !(Lc & 268435455) || hs(Ma, ma);
  }
  function Td(o, l) {
    var v = Mn;
    Mn |= 2;
    var w = wv();
    (Ma !== o || ma !== l) && (Ru = null, o1(o, l));
    do
      try {
        rm();
        break;
      } catch (b) {
        gv(o, b);
      }
    while (!0);
    if (pr(), Mn = v, p0.current = w, sa !== null) throw Error(a(261));
    return Ma = null, ma = 0, qr;
  }
  function rm() {
    for (; sa !== null; ) yv(sa);
  }
  function am() {
    for (; sa !== null && !Gt(); ) yv(sa);
  }
  function yv(o) {
    var l = bv(o.alternate, o, li);
    o.memoizedProps = o.pendingProps, l === null ? xv(o) : sa = l, Sd.current = null;
  }
  function xv(o) {
    var l = o;
    do {
      var v = l.alternate;
      if (o = l.return, l.flags & 32768) {
        if (v = em(v, l), v !== null) {
          v.flags &= 32767, sa = v;
          return;
        }
        if (o !== null) o.flags |= 32768, o.subtreeFlags = 0, o.deletions = null;
        else {
          qr = 6, sa = null;
          return;
        }
      } else if (v = Jp(v, l, li), v !== null) {
        sa = v;
        return;
      }
      if (l = l.sibling, l !== null) {
        sa = l;
        return;
      }
      sa = l = o;
    } while (l !== null);
    qr === 0 && (qr = 5);
  }
  function i1(o, l, v) {
    var w = Bn, b = Pi.transition;
    try {
      Pi.transition = null, Bn = 1, Qh(o, l, v, w);
    } finally {
      Pi.transition = b, Bn = w;
    }
    return null;
  }
  function Qh(o, l, v, w) {
    do
      y0();
    while (pl !== null);
    if (Mn & 6) throw Error(a(327));
    v = o.finishedWork;
    var b = o.finishedLanes;
    if (v === null) return null;
    if (o.finishedWork = null, o.finishedLanes = 0, v === o.current) throw Error(a(177));
    o.callbackNode = null, o.callbackPriority = 0;
    var E = v.lanes | v.childLanes;
    if (Oh(o, E), o === Ma && (sa = Ma = null, ma = 0), !(v.subtreeFlags & 2064) && !(v.flags & 2064) || r1 || (r1 = !0, _v(A1, function() {
      return y0(), null;
    })), E = (v.flags & 15990) !== 0, v.subtreeFlags & 15990 || E) {
      E = Pi.transition, Pi.transition = null;
      var Z = Bn;
      Bn = 1;
      var z = Mn;
      Mn |= 4, Sd.current = null, tm(o, v), yd(v, o), Kp(du), z0 = !!W1, du = W1 = null, o.current = v, t1(v), na(), Mn = z, Bn = Z, Pi.transition = E;
    } else o.current = v;
    if (r1 && (r1 = !1, pl = o, lo = b), E = o.pendingLanes, E === 0 && (Eu = null), Yp(v.stateNode), Oa(o, Jn()), l !== null) for (w = o.onRecoverableError, v = 0; v < l.length; v++) b = l[v], w(b.value, { componentStack: b.stack, digest: b.digest });
    if (bd) throw bd = !1, o = _d, _d = null, o;
    return lo & 1 && o.tag !== 0 && y0(), E = o.pendingLanes, E & 1 ? o === ds ? qa++ : (qa = 0, ds = o) : qa = 0, Di(), null;
  }
  function y0() {
    if (pl !== null) {
      var o = Vu(lo), l = Pi.transition, v = Bn;
      try {
        if (Pi.transition = null, Bn = 16 > o ? 16 : o, pl === null) var w = !1;
        else {
          if (o = pl, pl = null, lo = 0, Mn & 6) throw Error(a(331));
          var b = Mn;
          for (Mn |= 4, ht = o.current; ht !== null; ) {
            var E = ht, Z = E.child;
            if (ht.flags & 16) {
              var z = E.deletions;
              if (z !== null) {
                for (var ee = 0; ee < z.length; ee++) {
                  var ye = z[ee];
                  for (ht = ye; ht !== null; ) {
                    var Ne = ht;
                    switch (Ne.tag) {
                      case 0:
                      case 11:
                      case 15:
                        ul(8, Ne, E);
                    }
                    var Ye = Ne.child;
                    if (Ye !== null) Ye.return = Ne, ht = Ye;
                    else for (; ht !== null; ) {
                      Ne = ht;
                      var Ve = Ne.sibling, lt = Ne.return;
                      if (Cu(Ne), Ne === ye) {
                        ht = null;
                        break;
                      }
                      if (Ve !== null) {
                        Ve.return = lt, ht = Ve;
                        break;
                      }
                      ht = lt;
                    }
                  }
                }
                var xt = E.alternate;
                if (xt !== null) {
                  var bt = xt.child;
                  if (bt !== null) {
                    xt.child = null;
                    do {
                      var Gr = bt.sibling;
                      bt.sibling = null, bt = Gr;
                    } while (bt !== null);
                  }
                }
                ht = E;
              }
            }
            if (E.subtreeFlags & 2064 && Z !== null) Z.return = E, ht = Z;
            else e: for (; ht !== null; ) {
              if (E = ht, E.flags & 2048) switch (E.tag) {
                case 0:
                case 11:
                case 15:
                  ul(9, E, E.return);
              }
              var ce = E.sibling;
              if (ce !== null) {
                ce.return = E.return, ht = ce;
                break e;
              }
              ht = E.return;
            }
          }
          var ne = o.current;
          for (ht = ne; ht !== null; ) {
            Z = ht;
            var he = Z.child;
            if (Z.subtreeFlags & 2064 && he !== null) he.return = Z, ht = he;
            else e: for (Z = ne; ht !== null; ) {
              if (z = ht, z.flags & 2048) try {
                switch (z.tag) {
                  case 0:
                  case 11:
                  case 15:
                    cs(9, z);
                }
              } catch (Tt) {
                kr(z, z.return, Tt);
              }
              if (z === Z) {
                ht = null;
                break e;
              }
              var ze = z.sibling;
              if (ze !== null) {
                ze.return = z.return, ht = ze;
                break e;
              }
              ht = z.return;
            }
          }
          if (Mn = b, Di(), Dl && typeof Dl.onPostCommitFiberRoot == "function") try {
            Dl.onPostCommitFiberRoot(U0, o);
          } catch {
          }
          w = !0;
        }
        return w;
      } finally {
        Bn = v, Pi.transition = l;
      }
    }
    return !1;
  }
  function Od(o, l, v) {
    l = Nl(v, l), l = Mc(o, l, 1), o = ai(o, l, 1), l = xo(), o !== null && (Y0(o, 1, l), Oa(o, l));
  }
  function kr(o, l, v) {
    if (o.tag === 3) Od(o, o, v);
    else for (; l !== null; ) {
      if (l.tag === 3) {
        Od(l, o, v);
        break;
      } else if (l.tag === 1) {
        var w = l.stateNode;
        if (typeof l.type.getDerivedStateFromError == "function" || typeof w.componentDidCatch == "function" && (Eu === null || !Eu.has(w))) {
          o = Nl(v, o), o = Bl(l, o, 1), l = ai(l, o, 1), o = xo(), l !== null && (Y0(l, 1, o), Oa(l, o));
          break;
        }
      }
      l = l.return;
    }
  }
  function Sv(o, l, v) {
    var w = o.pingCache;
    w !== null && w.delete(l), l = xo(), o.pingedLanes |= o.suspendedLanes & v, Ma === o && (ma & v) === v && (qr === 4 || qr === 3 && (ma & 130023424) === ma && 500 > Jn() - Hc ? o1(o, 0) : Cd |= v), Oa(o, l);
  }
  function Cv(o, l) {
    l === 0 && (o.mode & 1 ? (l = Tf, Tf <<= 1, !(Tf & 130023424) && (Tf = 4194304)) : l = 1);
    var v = xo();
    o = mu(o, l), o !== null && (Y0(o, l, v), Oa(o, v));
  }
  function om(o) {
    var l = o.memoizedState, v = 0;
    l !== null && (v = l.retryLane), Cv(o, v);
  }
  function im(o, l) {
    var v = 0;
    switch (o.tag) {
      case 13:
        var w = o.stateNode, b = o.memoizedState;
        b !== null && (v = b.retryLane);
        break;
      case 19:
        w = o.stateNode;
        break;
      default:
        throw Error(a(314));
    }
    w !== null && w.delete(l), Cv(o, v);
  }
  var bv;
  bv = function(o, l, v) {
    if (o !== null) if (o.memoizedProps !== l.pendingProps || la.current) ua = !0;
    else {
      if (!(o.lanes & v) && !(l.flags & 128)) return ua = !1, pv(o, l, v);
      ua = !!(o.flags & 131072);
    }
    else ua = !1, br && l.flags & 1048576 && Vh(l, Ll, l.index);
    switch (l.lanes = 0, l.tag) {
      case 2:
        var w = l.type;
        No(o, l), o = l.pendingProps;
        var b = K1(l, Zr.current);
        Qu(l, v), b = no(null, l, w, o, b, v);
        var E = ts();
        return l.flags |= 1, typeof b == "object" && b !== null && typeof b.render == "function" && b.$$typeof === void 0 ? (l.tag = 1, l.memoizedState = null, l.updateQueue = null, Ua(w) ? (E = !0, Ho(l)) : E = !1, l.memoizedState = b.state !== null && b.state !== void 0 ? b.state : null, ld(l), b.updater = dd, l.stateNode = b, b._reactInternals = l, Yh(l, w, o, v), l = pd(null, l, w, !0, E, v)) : (l.tag = 0, br && E && Q1(l), At(null, l, b, v), l = l.child), l;
      case 16:
        w = l.elementType;
        e: {
          switch (No(o, l), o = l.pendingProps, b = w._init, w = b(w._payload), l.type = w, b = l.tag = Xh(w), o = Li(w, o), b) {
            case 0:
              l = Qs(null, l, w, o, v);
              break e;
            case 1:
              l = zh(null, l, w, o, v);
              break e;
            case 11:
              l = Oc(null, l, w, o, v);
              break e;
            case 14:
              l = vd(null, l, w, Li(w.type, o), v);
              break e;
          }
          throw Error(a(
            306,
            w,
            ""
          ));
        }
        return l;
      case 0:
        return w = l.type, b = l.pendingProps, b = l.elementType === w ? b : Li(w, b), Qs(o, l, w, b, v);
      case 1:
        return w = l.type, b = l.pendingProps, b = l.elementType === w ? b : Li(w, b), zh(o, l, w, b, v);
      case 3:
        e: {
          if (vv(l), o === null) throw Error(a(387));
          w = l.pendingProps, E = l.memoizedState, b = E.element, dv(o, l), J1(l, w, null, v);
          var Z = l.memoizedState;
          if (w = Z.element, E.isDehydrated) if (E = { element: w, isDehydrated: !1, cache: Z.cache, pendingSuspenseBoundaries: Z.pendingSuspenseBoundaries, transitions: Z.transitions }, l.updateQueue.baseState = E, l.memoizedState = E, l.flags & 256) {
            b = Nl(Error(a(423)), l), l = Ii(o, l, w, v, b);
            break e;
          } else if (w !== b) {
            b = Nl(Error(a(424)), l), l = Ii(o, l, w, v, b);
            break e;
          } else for (Zo = zu(l.stateNode.containerInfo.firstChild), Ya = l, br = !0, rl = null, v = ad(l, null, w, v), l.child = v; v; ) v.flags = v.flags & -3 | 4096, v = v.sibling;
          else {
            if (ji(), w === b) {
              l = rr(o, l, v);
              break e;
            }
            At(o, l, w, v);
          }
          l = l.child;
        }
        return l;
      case 5:
        return Fh(l), o === null && $a(l), w = l.type, b = l.pendingProps, E = o !== null ? o.memoizedProps : null, Z = b.children, hc(w, b) ? Z = null : E !== null && hc(w, E) && (l.flags |= 32), Dc(o, l), At(o, l, Z, v), l.child;
      case 6:
        return o === null && $a(l), null;
      case 13:
        return Ac(o, l, v);
      case 4:
        return ud(l, l.stateNode.containerInfo), w = l.pendingProps, o === null ? l.child = Zn(l, null, w, v) : At(o, l, w, v), l.child;
      case 11:
        return w = l.type, b = l.pendingProps, b = l.elementType === w ? b : Li(w, b), Oc(o, l, w, b, v);
      case 7:
        return At(o, l, l.pendingProps, v), l.child;
      case 8:
        return At(o, l, l.pendingProps.children, v), l.child;
      case 12:
        return At(o, l, l.pendingProps.children, v), l.child;
      case 10:
        e: {
          if (w = l.type._context, b = l.pendingProps, E = l.memoizedProps, Z = b.value, Yn(mc, w._currentValue), w._currentValue = Z, E !== null) if (ge(E.value, Z)) {
            if (E.children === b.children && !la.current) {
              l = rr(o, l, v);
              break e;
            }
          } else for (E = l.child, E !== null && (E.return = l); E !== null; ) {
            var z = E.dependencies;
            if (z !== null) {
              Z = E.child;
              for (var ee = z.firstContext; ee !== null; ) {
                if (ee.context === w) {
                  if (E.tag === 1) {
                    ee = gu(-1, v & -v), ee.tag = 2;
                    var ye = E.updateQueue;
                    if (ye !== null) {
                      ye = ye.shared;
                      var Ne = ye.pending;
                      Ne === null ? ee.next = ee : (ee.next = Ne.next, Ne.next = ee), ye.pending = ee;
                    }
                  }
                  E.lanes |= v, ee = E.alternate, ee !== null && (ee.lanes |= v), Wa(
                    E.return,
                    v,
                    l
                  ), z.lanes |= v;
                  break;
                }
                ee = ee.next;
              }
            } else if (E.tag === 10) Z = E.type === l.type ? null : E.child;
            else if (E.tag === 18) {
              if (Z = E.return, Z === null) throw Error(a(341));
              Z.lanes |= v, z = Z.alternate, z !== null && (z.lanes |= v), Wa(Z, v, l), Z = E.sibling;
            } else Z = E.child;
            if (Z !== null) Z.return = E;
            else for (Z = E; Z !== null; ) {
              if (Z === l) {
                Z = null;
                break;
              }
              if (E = Z.sibling, E !== null) {
                E.return = Z.return, Z = E;
                break;
              }
              Z = Z.return;
            }
            E = Z;
          }
          At(o, l, b.children, v), l = l.child;
        }
        return l;
      case 9:
        return b = l.type, w = l.pendingProps.children, Qu(l, v), b = ri(b), w = w(b), l.flags |= 1, At(o, l, w, v), l.child;
      case 14:
        return w = l.type, b = Li(w, l.pendingProps), b = Li(w.type, b), vd(o, l, w, b, v);
      case 15:
        return Su(o, l, l.type, l.pendingProps, v);
      case 17:
        return w = l.type, b = l.pendingProps, b = l.elementType === w ? b : Li(w, b), No(o, l), l.tag = 1, Ua(w) ? (o = !0, Ho(l)) : o = !1, Qu(l, v), is(l, w, b), Yh(l, w, b, v), pd(null, l, w, !0, o, v);
      case 19:
        return Hi(o, l, v);
      case 22:
        return Wh(o, l, v);
    }
    throw Error(a(156, l.tag));
  };
  function _v(o, l) {
    return ho(o, l);
  }
  function lm(o, l, v, w) {
    this.tag = o, this.key = v, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = l, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = w, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Vi(o, l, v, w) {
    return new lm(o, l, v, w);
  }
  function Pc(o) {
    return o = o.prototype, !(!o || !o.isReactComponent);
  }
  function Xh(o) {
    if (typeof o == "function") return Pc(o) ? 1 : 0;
    if (o != null) {
      if (o = o.$$typeof, o === de) return 11;
      if (o === Le) return 14;
    }
    return 2;
  }
  function So(o, l) {
    var v = o.alternate;
    return v === null ? (v = Vi(o.tag, l, o.key, o.mode), v.elementType = o.elementType, v.type = o.type, v.stateNode = o.stateNode, v.alternate = o, o.alternate = v) : (v.pendingProps = l, v.type = o.type, v.flags = 0, v.subtreeFlags = 0, v.deletions = null), v.flags = o.flags & 14680064, v.childLanes = o.childLanes, v.lanes = o.lanes, v.child = o.child, v.memoizedProps = o.memoizedProps, v.memoizedState = o.memoizedState, v.updateQueue = o.updateQueue, l = o.dependencies, v.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }, v.sibling = o.sibling, v.index = o.index, v.ref = o.ref, v;
  }
  function Dd(o, l, v, w, b, E) {
    var Z = 2;
    if (w = o, typeof o == "function") Pc(o) && (Z = 1);
    else if (typeof o == "string") Z = 5;
    else e: switch (o) {
      case te:
        return vs(v.children, b, E, l);
      case Se:
        Z = 8, b |= 8;
        break;
      case re:
        return o = Vi(12, v, l, b | 2), o.elementType = re, o.lanes = E, o;
      case fe:
        return o = Vi(13, v, l, b), o.elementType = fe, o.lanes = E, o;
      case xe:
        return o = Vi(19, v, l, b), o.elementType = xe, o.lanes = E, o;
      case Ue:
        return Vc(v, b, E, l);
      default:
        if (typeof o == "object" && o !== null) switch (o.$$typeof) {
          case ve:
            Z = 10;
            break e;
          case K:
            Z = 9;
            break e;
          case de:
            Z = 11;
            break e;
          case Le:
            Z = 14;
            break e;
          case be:
            Z = 16, w = null;
            break e;
        }
        throw Error(a(130, o == null ? o : typeof o, ""));
    }
    return l = Vi(Z, v, l, b), l.elementType = o, l.type = w, l.lanes = E, l;
  }
  function vs(o, l, v, w) {
    return o = Vi(7, o, w, l), o.lanes = v, o;
  }
  function Vc(o, l, v, w) {
    return o = Vi(22, o, w, l), o.elementType = Ue, o.lanes = v, o.stateNode = { isHidden: !1 }, o;
  }
  function jd(o, l, v) {
    return o = Vi(6, o, null, l), o.lanes = v, o;
  }
  function Jh(o, l, v) {
    return l = Vi(4, o.children !== null ? o.children : [], o.key, l), l.lanes = v, l.stateNode = { containerInfo: o.containerInfo, pendingChildren: null, implementation: o.implementation }, l;
  }
  function Rv(o, l, v, w, b) {
    this.tag = l, this.containerInfo = o, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = L1(0), this.expirationTimes = L1(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = L1(0), this.identifierPrefix = w, this.onRecoverableError = b, this.mutableSourceEagerHydrationData = null;
  }
  function e2(o, l, v, w, b, E, Z, z, ee) {
    return o = new Rv(o, l, v, z, ee), l === 1 ? (l = 1, E === !0 && (l |= 8)) : l = 0, E = Vi(3, null, null, l), o.current = E, E.stateNode = o, E.memoizedState = { element: w, isDehydrated: v, cache: null, transitions: null, pendingSuspenseBoundaries: null }, ld(E), o;
  }
  function um(o, l, v) {
    var w = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: le, key: w == null ? null : "" + w, children: o, containerInfo: l, implementation: v };
  }
  function Ev(o) {
    if (!o) return mo;
    o = o._reactInternals;
    e: {
      if (yn(o) !== o || o.tag !== 1) throw Error(a(170));
      var l = o;
      do {
        switch (l.tag) {
          case 3:
            l = l.stateNode.context;
            break e;
          case 1:
            if (Ua(l.type)) {
              l = l.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        l = l.return;
      } while (l !== null);
      throw Error(a(171));
    }
    if (o.tag === 1) {
      var v = o.type;
      if (Ua(v)) return Ph(o, v, l);
    }
    return l;
  }
  function t2(o, l, v, w, b, E, Z, z, ee) {
    return o = e2(v, w, !0, o, b, E, Z, z, ee), o.context = Ev(null), v = o.current, w = xo(), b = Yl(v), E = gu(w, b), E.callback = l ?? null, ai(v, E, b), o.current.lanes = b, Y0(o, b, w), Oa(o, w), o;
  }
  function Nc(o, l, v, w) {
    var b = l.current, E = xo(), Z = Yl(b);
    return v = Ev(v), l.context === null ? l.context = v : l.pendingContext = v, l = gu(E, Z), l.payload = { element: o }, w = w === void 0 ? null : w, w !== null && (l.callback = w), o = ai(b, l, Z), o !== null && (ui(o, b, Z, E), gc(o, b, Z)), Z;
  }
  function Bc(o) {
    if (o = o.current, !o.child) return null;
    switch (o.child.tag) {
      case 5:
        return o.child.stateNode;
      default:
        return o.child.stateNode;
    }
  }
  function l1(o, l) {
    if (o = o.memoizedState, o !== null && o.dehydrated !== null) {
      var v = o.retryLane;
      o.retryLane = v !== 0 && v < l ? v : l;
    }
  }
  function n2(o, l) {
    l1(o, l), (o = o.alternate) && l1(o, l);
  }
  function sm() {
    return null;
  }
  var Mv = typeof reportError == "function" ? reportError : function(o) {
    console.error(o);
  };
  function Ad(o) {
    this._internalRoot = o;
  }
  Fc.prototype.render = Ad.prototype.render = function(o) {
    var l = this._internalRoot;
    if (l === null) throw Error(a(409));
    Nc(o, l, null, null);
  }, Fc.prototype.unmount = Ad.prototype.unmount = function() {
    var o = this._internalRoot;
    if (o !== null) {
      this._internalRoot = null;
      var l = o.containerInfo;
      a1(function() {
        Nc(null, o, null, null);
      }), l[Jo] = null;
    }
  };
  function Fc(o) {
    this._internalRoot = o;
  }
  Fc.prototype.unstable_scheduleHydration = function(o) {
    if (o) {
      var l = ks();
      o = { blockedOn: null, target: o, priority: l };
      for (var v = 0; v < Bu.length && l !== 0 && l < Bu[v].priority; v++) ;
      Bu.splice(v, 0, o), v === 0 && $2(o);
    }
  };
  function r2(o) {
    return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11);
  }
  function Uc(o) {
    return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11 && (o.nodeType !== 8 || o.nodeValue !== " react-mount-point-unstable "));
  }
  function Tv() {
  }
  function cm(o, l, v, w, b) {
    if (b) {
      if (typeof w == "function") {
        var E = w;
        w = function() {
          var ye = Bc(Z);
          E.call(ye);
        };
      }
      var Z = t2(l, w, o, 0, null, !1, !1, "", Tv);
      return o._reactRootContainer = Z, o[Jo] = Z.current, cu(o.nodeType === 8 ? o.parentNode : o), a1(), Z;
    }
    for (; b = o.lastChild; ) o.removeChild(b);
    if (typeof w == "function") {
      var z = w;
      w = function() {
        var ye = Bc(ee);
        z.call(ye);
      };
    }
    var ee = e2(o, 0, !1, null, null, !1, !1, "", Tv);
    return o._reactRootContainer = ee, o[Jo] = ee.current, cu(o.nodeType === 8 ? o.parentNode : o), a1(function() {
      Nc(l, ee, v, w);
    }), ee;
  }
  function ps(o, l, v, w, b) {
    var E = v._reactRootContainer;
    if (E) {
      var Z = E;
      if (typeof b == "function") {
        var z = b;
        b = function() {
          var ee = Bc(Z);
          z.call(ee);
        };
      }
      Nc(l, Z, o, b);
    } else Z = cm(v, l, o, b, w);
    return Bc(Z);
  }
  en = function(o) {
    switch (o.tag) {
      case 3:
        var l = o.stateNode;
        if (l.current.memoizedState.isDehydrated) {
          var v = Pu(l.pendingLanes);
          v !== 0 && (In(l, v | 1), Oa(l, Jn()), !(Mn & 6) && (vl = Jn() + 500, Di()));
        }
        break;
      case 13:
        a1(function() {
          var w = mu(o, 1);
          if (w !== null) {
            var b = xo();
            ui(w, o, 1, b);
          }
        }), n2(o, 1);
    }
  }, $0 = function(o) {
    if (o.tag === 13) {
      var l = mu(o, 134217728);
      if (l !== null) {
        var v = xo();
        ui(l, o, 134217728, v);
      }
      n2(o, 134217728);
    }
  }, ko = function(o) {
    if (o.tag === 13) {
      var l = Yl(o), v = mu(o, l);
      if (v !== null) {
        var w = xo();
        ui(v, o, l, w);
      }
      n2(o, l);
    }
  }, ks = function() {
    return Bn;
  }, Ls = function(o, l) {
    var v = Bn;
    try {
      return Bn = o, l();
    } finally {
      Bn = v;
    }
  }, Jl = function(o, l, v) {
    switch (l) {
      case "input":
        if (ft(o, v), l = v.name, v.type === "radio" && l != null) {
          for (v = o; v.parentNode; ) v = v.parentNode;
          for (v = v.querySelectorAll("input[name=" + JSON.stringify("" + l) + '][type="radio"]'), l = 0; l < v.length; l++) {
            var w = v[l];
            if (w !== o && w.form === o.form) {
              var b = Fs(w);
              if (!b) throw Error(a(90));
              Wn(w), ft(w, b);
            }
          }
        }
        break;
      case "textarea":
        Xe(o, v);
        break;
      case "select":
        l = v.value, l != null && gn(o, !!v.multiple, l, !1);
    }
  }, D1 = Zc, Zu = a1;
  var Yc = { usingClientEntryPoint: !1, Events: [zt, Kt, Fs, O1, bf, Zc] }, Tu = { findFiberByHostInstance: fr, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, fm = { bundleType: Tu.bundleType, version: Tu.version, rendererPackageName: Tu.rendererPackageName, rendererConfig: Tu.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Q.ReactCurrentDispatcher, findHostInstanceByFiber: function(o) {
    return o = Rr(o), o === null ? null : o.stateNode;
  }, findFiberByHostInstance: Tu.findFiberByHostInstance || sm, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var kd = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!kd.isDisabled && kd.supportsFiber) try {
      U0 = kd.inject(fm), Dl = kd;
    } catch {
    }
  }
  return Gl.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Yc, Gl.createPortal = function(o, l) {
    var v = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!r2(l)) throw Error(a(200));
    return um(o, l, null, v);
  }, Gl.createRoot = function(o, l) {
    if (!r2(o)) throw Error(a(299));
    var v = !1, w = "", b = Mv;
    return l != null && (l.unstable_strictMode === !0 && (v = !0), l.identifierPrefix !== void 0 && (w = l.identifierPrefix), l.onRecoverableError !== void 0 && (b = l.onRecoverableError)), l = e2(o, 1, !1, null, null, v, !1, w, b), o[Jo] = l.current, cu(o.nodeType === 8 ? o.parentNode : o), new Ad(l);
  }, Gl.findDOMNode = function(o) {
    if (o == null) return null;
    if (o.nodeType === 1) return o;
    var l = o._reactInternals;
    if (l === void 0)
      throw typeof o.render == "function" ? Error(a(188)) : (o = Object.keys(o).join(","), Error(a(268, o)));
    return o = Rr(l), o = o === null ? null : o.stateNode, o;
  }, Gl.flushSync = function(o) {
    return a1(o);
  }, Gl.hydrate = function(o, l, v) {
    if (!Uc(l)) throw Error(a(200));
    return ps(null, o, l, !0, v);
  }, Gl.hydrateRoot = function(o, l, v) {
    if (!r2(o)) throw Error(a(405));
    var w = v != null && v.hydratedSources || null, b = !1, E = "", Z = Mv;
    if (v != null && (v.unstable_strictMode === !0 && (b = !0), v.identifierPrefix !== void 0 && (E = v.identifierPrefix), v.onRecoverableError !== void 0 && (Z = v.onRecoverableError)), l = t2(l, null, o, 1, v ?? null, b, !1, E, Z), o[Jo] = l.current, cu(o), w) for (o = 0; o < w.length; o++) v = w[o], b = v._getVersion, b = b(v._source), l.mutableSourceEagerHydrationData == null ? l.mutableSourceEagerHydrationData = [v, b] : l.mutableSourceEagerHydrationData.push(
      v,
      b
    );
    return new Fc(l);
  }, Gl.render = function(o, l, v) {
    if (!Uc(l)) throw Error(a(200));
    return ps(null, o, l, !1, v);
  }, Gl.unmountComponentAtNode = function(o) {
    if (!Uc(o)) throw Error(a(40));
    return o._reactRootContainer ? (a1(function() {
      ps(null, null, o, !1, function() {
        o._reactRootContainer = null, o[Jo] = null;
      });
    }), !0) : !1;
  }, Gl.unstable_batchedUpdates = Zc, Gl.unstable_renderSubtreeIntoContainer = function(o, l, v, w) {
    if (!Uc(v)) throw Error(a(200));
    if (o == null || o._reactInternals === void 0) throw Error(a(38));
    return ps(o, l, v, !1, w);
  }, Gl.version = "18.3.1-next-f1338f8080-20240426", Gl;
}
var Kl = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var N_;
function eZ() {
  return N_ || (N_ = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Sa, t = nM(), a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, i = !1;
    function h(n) {
      i = n;
    }
    function g(n) {
      if (!i) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), c = 1; c < r; c++)
          u[c - 1] = arguments[c];
        C("warn", n, u);
      }
    }
    function m(n) {
      if (!i) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), c = 1; c < r; c++)
          u[c - 1] = arguments[c];
        C("error", n, u);
      }
    }
    function C(n, r, u) {
      {
        var c = a.ReactDebugCurrentFrame, p = c.getStackAddendum();
        p !== "" && (r += "%s", u = u.concat([p]));
        var x = u.map(function(_) {
          return String(_);
        });
        x.unshift("Warning: " + r), Function.prototype.apply.call(console[n], console, x);
      }
    }
    var S = 0, R = 1, D = 2, T = 3, j = 4, A = 5, L = 6, P = 7, V = 8, F = 9, Y = 10, W = 11, Q = 12, $ = 13, le = 14, te = 15, Se = 16, re = 17, ve = 18, K = 19, de = 21, fe = 22, xe = 23, Le = 24, be = 25, Ue = !0, ie = !1, _e = !1, Ze = !1, mt = !1, Pe = !0, Vt = /* @__PURE__ */ new Set(), Dt = {}, Qe = {};
    function et(n, r) {
      wt(n, r), wt(n + "Capture", r);
    }
    function wt(n, r) {
      Dt[n] && m("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", n), Dt[n] = r;
      {
        var u = n.toLowerCase();
        Qe[u] = n, n === "onDoubleClick" && (Qe.ondblclick = n);
      }
      for (var c = 0; c < r.length; c++)
        Vt.add(r[c]);
    }
    var St = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", _n = Object.prototype.hasOwnProperty;
    function Hr(n) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, u = r && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return u;
      }
    }
    function kn(n) {
      try {
        return !1;
      } catch {
        return !0;
      }
    }
    function Wn(n) {
      return "" + n;
    }
    function sr(n, r) {
      if (kn())
        return m("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", r, Hr(n)), Wn(n);
    }
    function yr(n) {
      if (kn())
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Hr(n)), Wn(n);
    }
    function ea(n, r) {
      if (kn())
        return m("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", r, Hr(n)), Wn(n);
    }
    function Ca(n, r) {
      if (kn())
        return m("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", r, Hr(n)), Wn(n);
    }
    function ft(n) {
      if (kn())
        return m("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Hr(n)), Wn(n);
    }
    function fn(n) {
      if (kn())
        return m("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Hr(n)), Wn(n);
    }
    var Ln = 0, Nt = 1, gn = 2, zn = 3, Ur = 4, Xe = 5, Jt = 6, qn = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Sn = qn + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", qe = new RegExp("^[" + qn + "][" + Sn + "]*$"), yt = {}, Ct = {};
    function ln(n) {
      return _n.call(Ct, n) ? !0 : _n.call(yt, n) ? !1 : qe.test(n) ? (Ct[n] = !0, !0) : (yt[n] = !0, m("Invalid attribute name: `%s`", n), !1);
    }
    function cr(n, r, u) {
      return r !== null ? r.type === Ln : u ? !1 : n.length > 2 && (n[0] === "o" || n[0] === "O") && (n[1] === "n" || n[1] === "N");
    }
    function ta(n, r, u, c) {
      if (u !== null && u.type === Ln)
        return !1;
      switch (typeof r) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (c)
            return !1;
          if (u !== null)
            return !u.acceptsBooleans;
          var p = n.toLowerCase().slice(0, 5);
          return p !== "data-" && p !== "aria-";
        }
        default:
          return !1;
      }
    }
    function xr(n, r, u, c) {
      if (r === null || typeof r > "u" || ta(n, r, u, c))
        return !0;
      if (c)
        return !1;
      if (u !== null)
        switch (u.type) {
          case zn:
            return !r;
          case Ur:
            return r === !1;
          case Xe:
            return isNaN(r);
          case Jt:
            return isNaN(r) || r < 1;
        }
      return !1;
    }
    function Ao(n) {
      return Gn.hasOwnProperty(n) ? Gn[n] : null;
    }
    function wn(n, r, u, c, p, x, _) {
      this.acceptsBooleans = r === gn || r === zn || r === Ur, this.attributeName = c, this.attributeNamespace = p, this.mustUseProperty = u, this.propertyName = n, this.type = r, this.sanitizeURL = x, this.removeEmptyString = _;
    }
    var Gn = {}, T1 = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    T1.forEach(function(n) {
      Gn[n] = new wn(
        n,
        Ln,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
      var r = n[0], u = n[1];
      Gn[r] = new wn(
        r,
        Nt,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
      Gn[n] = new wn(
        n,
        gn,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
      Gn[n] = new wn(
        n,
        gn,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(n) {
      Gn[n] = new wn(
        n,
        zn,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      Gn[n] = new wn(
        n,
        zn,
        !0,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      Gn[n] = new wn(
        n,
        Ur,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      Gn[n] = new wn(
        n,
        Jt,
        !1,
        // mustUseProperty
        n,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(n) {
      Gn[n] = new wn(
        n,
        Xe,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Ri = /[\-\:]([a-z])/g, Jl = function(n) {
      return n[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var r = n.replace(Ri, Jl);
      Gn[r] = new wn(
        r,
        Nt,
        !1,
        // mustUseProperty
        n,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var r = n.replace(Ri, Jl);
      Gn[r] = new wn(
        r,
        Nt,
        !1,
        // mustUseProperty
        n,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(n) {
      var r = n.replace(Ri, Jl);
      Gn[r] = new wn(
        r,
        Nt,
        !1,
        // mustUseProperty
        n,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(n) {
      Gn[n] = new wn(
        n,
        Nt,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var qi = "xlinkHref";
    Gn[qi] = new wn(
      "xlinkHref",
      Nt,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(n) {
      Gn[n] = new wn(
        n,
        Nt,
        !1,
        // mustUseProperty
        n.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var El = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, F0 = !1;
    function O1(n) {
      !F0 && El.test(n) && (F0 = !0, m("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(n)));
    }
    function bf(n, r, u, c) {
      if (c.mustUseProperty) {
        var p = c.propertyName;
        return n[p];
      } else {
        sr(u, r), c.sanitizeURL && O1("" + u);
        var x = c.attributeName, _ = null;
        if (c.type === Ur) {
          if (n.hasAttribute(x)) {
            var O = n.getAttribute(x);
            return O === "" ? !0 : xr(r, u, c, !1) ? O : O === "" + u ? u : O;
          }
        } else if (n.hasAttribute(x)) {
          if (xr(r, u, c, !1))
            return n.getAttribute(x);
          if (c.type === zn)
            return u;
          _ = n.getAttribute(x);
        }
        return xr(r, u, c, !1) ? _ === null ? u : _ : _ === "" + u ? u : _;
      }
    }
    function D1(n, r, u, c) {
      {
        if (!ln(r))
          return;
        if (!n.hasAttribute(r))
          return u === void 0 ? void 0 : null;
        var p = n.getAttribute(r);
        return sr(u, r), p === "" + u ? u : p;
      }
    }
    function Zu(n, r, u, c) {
      var p = Ao(r);
      if (!cr(r, p, c)) {
        if (xr(r, u, p, c) && (u = null), c || p === null) {
          if (ln(r)) {
            var x = r;
            u === null ? n.removeAttribute(x) : (sr(u, r), n.setAttribute(x, "" + u));
          }
          return;
        }
        var _ = p.mustUseProperty;
        if (_) {
          var O = p.propertyName;
          if (u === null) {
            var k = p.type;
            n[O] = k === zn ? !1 : "";
          } else
            n[O] = u;
          return;
        }
        var N = p.attributeName, U = p.attributeNamespace;
        if (u === null)
          n.removeAttribute(N);
        else {
          var oe = p.type, ae;
          oe === zn || oe === Ur && u === !0 ? ae = "" : (sr(u, N), ae = "" + u, p.sanitizeURL && O1(ae.toString())), U ? n.setAttributeNS(U, N, ae) : n.setAttribute(N, ae);
        }
      }
    }
    var Ml = Symbol.for("react.element"), Tl = Symbol.for("react.portal"), Wo = Symbol.for("react.fragment"), Ol = Symbol.for("react.strict_mode"), eu = Symbol.for("react.profiler"), js = Symbol.for("react.provider"), tu = Symbol.for("react.context"), Gi = Symbol.for("react.forward_ref"), X = Symbol.for("react.suspense"), $e = Symbol.for("react.suspense_list"), dt = Symbol.for("react.memo"), Et = Symbol.for("react.lazy"), Nn = Symbol.for("react.scope"), yn = Symbol.for("react.debug_trace_mode"), dn = Symbol.for("react.offscreen"), hn = Symbol.for("react.legacy_hidden"), Za = Symbol.for("react.cache"), Rr = Symbol.for("react.tracing_marker"), Er = Symbol.iterator, ho = "@@iterator";
    function vo(n) {
      if (n === null || typeof n != "object")
        return null;
      var r = Er && n[Er] || n[ho];
      return typeof r == "function" ? r : null;
    }
    var Gt = Object.assign, na = 0, Jn, _f, j1, Eh, A1, Mh, Rf;
    function U0() {
    }
    U0.__reactDisabledLog = !0;
    function Dl() {
      {
        if (na === 0) {
          Jn = console.log, _f = console.info, j1 = console.warn, Eh = console.error, A1 = console.group, Mh = console.groupCollapsed, Rf = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: U0,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        na++;
      }
    }
    function Yp() {
      {
        if (na--, na === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Gt({}, n, {
              value: Jn
            }),
            info: Gt({}, n, {
              value: _f
            }),
            warn: Gt({}, n, {
              value: j1
            }),
            error: Gt({}, n, {
              value: Eh
            }),
            group: Gt({}, n, {
              value: A1
            }),
            groupCollapsed: Gt({}, n, {
              value: Mh
            }),
            groupEnd: Gt({}, n, {
              value: Rf
            })
          });
        }
        na < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var zo = a.ReactCurrentDispatcher, Ef;
    function nu(n, r, u) {
      {
        if (Ef === void 0)
          try {
            throw Error();
          } catch (p) {
            var c = p.stack.trim().match(/\n( *(at )?)/);
            Ef = c && c[1] || "";
          }
        return `
` + Ef + n;
      }
    }
    var Mf = !1, ru;
    {
      var Tf = typeof WeakMap == "function" ? WeakMap : Map;
      ru = new Tf();
    }
    function Pu(n, r) {
      if (!n || Mf)
        return "";
      {
        var u = ru.get(n);
        if (u !== void 0)
          return u;
      }
      var c;
      Mf = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var x;
      x = zo.current, zo.current = null, Dl();
      try {
        if (r) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (Ce) {
              c = Ce;
            }
            Reflect.construct(n, [], _);
          } else {
            try {
              _.call();
            } catch (Ce) {
              c = Ce;
            }
            n.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ce) {
            c = Ce;
          }
          n();
        }
      } catch (Ce) {
        if (Ce && c && typeof Ce.stack == "string") {
          for (var O = Ce.stack.split(`
`), k = c.stack.split(`
`), N = O.length - 1, U = k.length - 1; N >= 1 && U >= 0 && O[N] !== k[U]; )
            U--;
          for (; N >= 1 && U >= 0; N--, U--)
            if (O[N] !== k[U]) {
              if (N !== 1 || U !== 1)
                do
                  if (N--, U--, U < 0 || O[N] !== k[U]) {
                    var oe = `
` + O[N].replace(" at new ", " at ");
                    return n.displayName && oe.includes("<anonymous>") && (oe = oe.replace("<anonymous>", n.displayName)), typeof n == "function" && ru.set(n, oe), oe;
                  }
                while (N >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        Mf = !1, zo.current = x, Yp(), Error.prepareStackTrace = p;
      }
      var ae = n ? n.displayName || n.name : "", we = ae ? nu(ae) : "";
      return typeof n == "function" && ru.set(n, we), we;
    }
    function As(n, r, u) {
      return Pu(n, !0);
    }
    function Of(n, r, u) {
      return Pu(n, !1);
    }
    function $p(n) {
      var r = n.prototype;
      return !!(r && r.isReactComponent);
    }
    function k1(n, r, u) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return Pu(n, $p(n));
      if (typeof n == "string")
        return nu(n);
      switch (n) {
        case X:
          return nu("Suspense");
        case $e:
          return nu("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case Gi:
            return Of(n.render);
          case dt:
            return k1(n.type);
          case Et: {
            var c = n, p = c._payload, x = c._init;
            try {
              return k1(x(p));
            } catch {
            }
          }
        }
      return "";
    }
    function Th(n) {
      switch (n.tag) {
        case A:
          return nu(n.type);
        case Se:
          return nu("Lazy");
        case $:
          return nu("Suspense");
        case K:
          return nu("SuspenseList");
        case S:
        case D:
        case te:
          return Of(n.type);
        case W:
          return Of(n.type.render);
        case R:
          return As(n.type);
        default:
          return "";
      }
    }
    function L1(n) {
      try {
        var r = "", u = n;
        do
          r += Th(u), u = u.return;
        while (u);
        return r;
      } catch (c) {
        return `
Error generating stack: ` + c.message + `
` + c.stack;
      }
    }
    function Y0(n, r, u) {
      var c = n.displayName;
      if (c)
        return c;
      var p = r.displayName || r.name || "";
      return p !== "" ? u + "(" + p + ")" : u;
    }
    function Oh(n) {
      return n.displayName || "Context";
    }
    function In(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case Wo:
          return "Fragment";
        case Tl:
          return "Portal";
        case eu:
          return "Profiler";
        case Ol:
          return "StrictMode";
        case X:
          return "Suspense";
        case $e:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case tu:
            var r = n;
            return Oh(r) + ".Consumer";
          case js:
            var u = n;
            return Oh(u._context) + ".Provider";
          case Gi:
            return Y0(n, n.render, "ForwardRef");
          case dt:
            var c = n.displayName || null;
            return c !== null ? c : In(n.type) || "Memo";
          case Et: {
            var p = n, x = p._payload, _ = p._init;
            try {
              return In(_(x));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Bn(n, r, u) {
      var c = r.displayName || r.name || "";
      return n.displayName || (c !== "" ? u + "(" + c + ")" : u);
    }
    function Vu(n) {
      return n.displayName || "Context";
    }
    function en(n) {
      var r = n.tag, u = n.type;
      switch (r) {
        case Le:
          return "Cache";
        case F:
          var c = u;
          return Vu(c) + ".Consumer";
        case Y:
          var p = u;
          return Vu(p._context) + ".Provider";
        case ve:
          return "DehydratedFragment";
        case W:
          return Bn(u, u.render, "ForwardRef");
        case P:
          return "Fragment";
        case A:
          return u;
        case j:
          return "Portal";
        case T:
          return "Root";
        case L:
          return "Text";
        case Se:
          return In(u);
        case V:
          return u === Ol ? "StrictMode" : "Mode";
        case fe:
          return "Offscreen";
        case Q:
          return "Profiler";
        case de:
          return "Scope";
        case $:
          return "Suspense";
        case K:
          return "SuspenseList";
        case be:
          return "TracingMarker";
        case R:
        case S:
        case re:
        case D:
        case le:
        case te:
          if (typeof u == "function")
            return u.displayName || u.name || null;
          if (typeof u == "string")
            return u;
          break;
      }
      return null;
    }
    var $0 = a.ReactDebugCurrentFrame, ko = null, ks = !1;
    function Ls() {
      {
        if (ko === null)
          return null;
        var n = ko._debugOwner;
        if (n !== null && typeof n < "u")
          return en(n);
      }
      return null;
    }
    function Df() {
      return ko === null ? "" : L1(ko);
    }
    function va() {
      $0.getCurrentStack = null, ko = null, ks = !1;
    }
    function tr(n) {
      $0.getCurrentStack = n === null ? null : Df, ko = n, ks = !1;
    }
    function Nu() {
      return ko;
    }
    function Pa(n) {
      ks = n;
    }
    function Va(n) {
      return "" + n;
    }
    function Ei(n) {
      switch (typeof n) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return n;
        case "object":
          return fn(n), n;
        default:
          return "";
      }
    }
    var Bu = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Dh(n, r) {
      Bu[r.type] || r.onChange || r.onInput || r.readOnly || r.disabled || r.value == null || m("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), r.onChange || r.readOnly || r.disabled || r.checked == null || m("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function jh(n) {
      var r = n.type, u = n.nodeName;
      return u && u.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
    }
    function Fu(n) {
      return n._valueTracker;
    }
    function Wp(n) {
      n._valueTracker = null;
    }
    function $2(n) {
      var r = "";
      return n && (jh(n) ? r = n.checked ? "true" : "false" : r = n.value), r;
    }
    function jf(n) {
      var r = jh(n) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(n.constructor.prototype, r);
      fn(n[r]);
      var c = "" + n[r];
      if (!(n.hasOwnProperty(r) || typeof u > "u" || typeof u.get != "function" || typeof u.set != "function")) {
        var p = u.get, x = u.set;
        Object.defineProperty(n, r, {
          configurable: !0,
          get: function() {
            return p.call(this);
          },
          set: function(O) {
            fn(O), c = "" + O, x.call(this, O);
          }
        }), Object.defineProperty(n, r, {
          enumerable: u.enumerable
        });
        var _ = {
          getValue: function() {
            return c;
          },
          setValue: function(O) {
            fn(O), c = "" + O;
          },
          stopTracking: function() {
            Wp(n), delete n[r];
          }
        };
        return _;
      }
    }
    function W0(n) {
      Fu(n) || (n._valueTracker = jf(n));
    }
    function W2(n) {
      if (!n)
        return !1;
      var r = Fu(n);
      if (!r)
        return !0;
      var u = r.getValue(), c = $2(n);
      return c !== u ? (r.setValue(c), !0) : !1;
    }
    function Hn(n) {
      if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u")
        return null;
      try {
        return n.activeElement || n.body;
      } catch {
        return n.body;
      }
    }
    var Fn = !1, Is = !1, z0 = !1, z2 = !1;
    function q2(n) {
      var r = n.type === "checkbox" || n.type === "radio";
      return r ? n.checked != null : n.value != null;
    }
    function q0(n, r) {
      var u = n, c = r.checked, p = Gt({}, r, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: c ?? u._wrapperState.initialChecked
      });
      return p;
    }
    function G0(n, r) {
      Dh("input", r), r.checked !== void 0 && r.defaultChecked !== void 0 && !Is && (m("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Ls() || "A component", r.type), Is = !0), r.value !== void 0 && r.defaultValue !== void 0 && !Fn && (m("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Ls() || "A component", r.type), Fn = !0);
      var u = n, c = r.defaultValue == null ? "" : r.defaultValue;
      u._wrapperState = {
        initialChecked: r.checked != null ? r.checked : r.defaultChecked,
        initialValue: Ei(r.value != null ? r.value : c),
        controlled: q2(r)
      };
    }
    function K0(n, r) {
      var u = n, c = r.checked;
      c != null && Zu(u, "checked", c, !1);
    }
    function Af(n, r) {
      var u = n;
      {
        var c = q2(r);
        !u._wrapperState.controlled && c && !z2 && (m("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), z2 = !0), u._wrapperState.controlled && !c && !z0 && (m("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), z0 = !0);
      }
      K0(n, r);
      var p = Ei(r.value), x = r.type;
      if (p != null)
        x === "number" ? (p === 0 && u.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        u.value != p) && (u.value = Va(p)) : u.value !== Va(p) && (u.value = Va(p));
      else if (x === "submit" || x === "reset") {
        u.removeAttribute("value");
        return;
      }
      r.hasOwnProperty("value") ? X0(u, r.type, p) : r.hasOwnProperty("defaultValue") && X0(u, r.type, Ei(r.defaultValue)), r.checked == null && r.defaultChecked != null && (u.defaultChecked = !!r.defaultChecked);
    }
    function Sr(n, r, u) {
      var c = n;
      if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
        var p = r.type, x = p === "submit" || p === "reset";
        if (x && (r.value === void 0 || r.value === null))
          return;
        var _ = Va(c._wrapperState.initialValue);
        u || _ !== c.value && (c.value = _), c.defaultValue = _;
      }
      var O = c.name;
      O !== "" && (c.name = ""), c.defaultChecked = !c.defaultChecked, c.defaultChecked = !!c._wrapperState.initialChecked, O !== "" && (c.name = O);
    }
    function Q0(n, r) {
      var u = n;
      Af(u, r), jl(u, r);
    }
    function jl(n, r) {
      var u = r.name;
      if (r.type === "radio" && u != null) {
        for (var c = n; c.parentNode; )
          c = c.parentNode;
        sr(u, "name");
        for (var p = c.querySelectorAll("input[name=" + JSON.stringify("" + u) + '][type="radio"]'), x = 0; x < p.length; x++) {
          var _ = p[x];
          if (!(_ === n || _.form !== n.form)) {
            var O = se(_);
            if (!O)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            W2(_), Af(_, O);
          }
        }
      }
    }
    function X0(n, r, u) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (r !== "number" || Hn(n.ownerDocument) !== n) && (u == null ? n.defaultValue = Va(n._wrapperState.initialValue) : n.defaultValue !== Va(u) && (n.defaultValue = Va(u)));
    }
    var Hs = !1, Xa = !1, kf = !1;
    function po(n, r) {
      r.value == null && (typeof r.children == "object" && r.children !== null ? e.Children.forEach(r.children, function(u) {
        u != null && (typeof u == "string" || typeof u == "number" || Xa || (Xa = !0, m("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : r.dangerouslySetInnerHTML != null && (kf || (kf = !0, m("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), r.selected != null && !Hs && (m("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Hs = !0);
    }
    function Zs(n, r) {
      r.value != null && n.setAttribute("value", Va(Ei(r.value)));
    }
    var Lf = Array.isArray;
    function ra(n) {
      return Lf(n);
    }
    var If;
    If = !1;
    function Ja() {
      var n = Ls();
      return n ? `

Check the render method of \`` + n + "`." : "";
    }
    var Hf = ["value", "defaultValue"];
    function eo(n) {
      {
        Dh("select", n);
        for (var r = 0; r < Hf.length; r++) {
          var u = Hf[r];
          if (n[u] != null) {
            var c = ra(n[u]);
            n.multiple && !c ? m("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", u, Ja()) : !n.multiple && c && m("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", u, Ja());
          }
        }
      }
    }
    function au(n, r, u, c) {
      var p = n.options;
      if (r) {
        for (var x = u, _ = {}, O = 0; O < x.length; O++)
          _["$" + x[O]] = !0;
        for (var k = 0; k < p.length; k++) {
          var N = _.hasOwnProperty("$" + p[k].value);
          p[k].selected !== N && (p[k].selected = N), N && c && (p[k].defaultSelected = !0);
        }
      } else {
        for (var U = Va(Ei(u)), oe = null, ae = 0; ae < p.length; ae++) {
          if (p[ae].value === U) {
            p[ae].selected = !0, c && (p[ae].defaultSelected = !0);
            return;
          }
          oe === null && !p[ae].disabled && (oe = p[ae]);
        }
        oe !== null && (oe.selected = !0);
      }
    }
    function J0(n, r) {
      return Gt({}, r, {
        value: void 0
      });
    }
    function ou(n, r) {
      var u = n;
      eo(r), u._wrapperState = {
        wasMultiple: !!r.multiple
      }, r.value !== void 0 && r.defaultValue !== void 0 && !If && (m("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), If = !0);
    }
    function Zf(n, r) {
      var u = n;
      u.multiple = !!r.multiple;
      var c = r.value;
      c != null ? au(u, !!r.multiple, c, !1) : r.defaultValue != null && au(u, !!r.multiple, r.defaultValue, !0);
    }
    function Ah(n, r) {
      var u = n, c = u._wrapperState.wasMultiple;
      u._wrapperState.wasMultiple = !!r.multiple;
      var p = r.value;
      p != null ? au(u, !!r.multiple, p, !1) : c !== !!r.multiple && (r.defaultValue != null ? au(u, !!r.multiple, r.defaultValue, !0) : au(u, !!r.multiple, r.multiple ? [] : "", !1));
    }
    function hr(n, r) {
      var u = n, c = r.value;
      c != null && au(u, !!r.multiple, c, !1);
    }
    var iu = !1;
    function ec(n, r) {
      var u = n;
      if (r.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var c = Gt({}, r, {
        value: void 0,
        defaultValue: void 0,
        children: Va(u._wrapperState.initialValue)
      });
      return c;
    }
    function G2(n, r) {
      var u = n;
      Dh("textarea", r), r.value !== void 0 && r.defaultValue !== void 0 && !iu && (m("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", Ls() || "A component"), iu = !0);
      var c = r.value;
      if (c == null) {
        var p = r.children, x = r.defaultValue;
        if (p != null) {
          m("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (x != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (ra(p)) {
              if (p.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              p = p[0];
            }
            x = p;
          }
        }
        x == null && (x = ""), c = x;
      }
      u._wrapperState = {
        initialValue: Ei(c)
      };
    }
    function Pf(n, r) {
      var u = n, c = Ei(r.value), p = Ei(r.defaultValue);
      if (c != null) {
        var x = Va(c);
        x !== u.value && (u.value = x), r.defaultValue == null && u.defaultValue !== x && (u.defaultValue = x);
      }
      p != null && (u.defaultValue = Va(p));
    }
    function K2(n, r) {
      var u = n, c = u.textContent;
      c === u._wrapperState.initialValue && c !== "" && c !== null && (u.value = c);
    }
    function Q2(n, r) {
      Pf(n, r);
    }
    var lu = "http://www.w3.org/1999/xhtml", X2 = "http://www.w3.org/1998/Math/MathML", I1 = "http://www.w3.org/2000/svg";
    function Uu(n) {
      switch (n) {
        case "svg":
          return I1;
        case "math":
          return X2;
        default:
          return lu;
      }
    }
    function tc(n, r) {
      return n == null || n === lu ? Uu(r) : n === I1 && r === "foreignObject" ? lu : n;
    }
    var J2 = function(n) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, u, c, p) {
        MSApp.execUnsafeLocalFunction(function() {
          return n(r, u, c, p);
        });
      } : n;
    }, nc, Vf = J2(function(n, r) {
      if (n.namespaceURI === I1 && !("innerHTML" in n)) {
        nc = nc || document.createElement("div"), nc.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>";
        for (var u = nc.firstChild; n.firstChild; )
          n.removeChild(n.firstChild);
        for (; u.firstChild; )
          n.appendChild(u.firstChild);
        return;
      }
      n.innerHTML = r;
    }), Na = 1, Al = 3, aa = 8, Ki = 9, rc = 11, Nf = function(n, r) {
      if (r) {
        var u = n.firstChild;
        if (u && u === n.lastChild && u.nodeType === Al) {
          u.nodeValue = r;
          return;
        }
      }
      n.textContent = r;
    }, ev = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, Ba = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function ac(n, r) {
      return n + r.charAt(0).toUpperCase() + r.substring(1);
    }
    var uu = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Ba).forEach(function(n) {
      uu.forEach(function(r) {
        Ba[ac(r, n)] = Ba[n];
      });
    });
    function Bf(n, r, u) {
      var c = r == null || typeof r == "boolean" || r === "";
      return c ? "" : !u && typeof r == "number" && r !== 0 && !(Ba.hasOwnProperty(n) && Ba[n]) ? r + "px" : (Ca(r, n), ("" + r).trim());
    }
    var kh = /([A-Z])/g, tv = /^ms-/;
    function nv(n) {
      return n.replace(kh, "-$1").toLowerCase().replace(tv, "-ms-");
    }
    var Lh = function() {
    };
    {
      var rv = /^(?:webkit|moz|o)[A-Z]/, H1 = /^-ms-/, Z1 = /-(.)/g, av = /;\s*$/, P1 = {}, V1 = {}, Ff = !1, qo = !1, Yu = function(n) {
        return n.replace(Z1, function(r, u) {
          return u.toUpperCase();
        });
      }, zp = function(n) {
        P1.hasOwnProperty(n) && P1[n] || (P1[n] = !0, m(
          "Unsupported style property %s. Did you mean %s?",
          n,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Yu(n.replace(H1, "ms-"))
        ));
      }, Uf = function(n) {
        P1.hasOwnProperty(n) && P1[n] || (P1[n] = !0, m("Unsupported vendor-prefixed style property %s. Did you mean %s?", n, n.charAt(0).toUpperCase() + n.slice(1)));
      }, qp = function(n, r) {
        V1.hasOwnProperty(r) && V1[r] || (V1[r] = !0, m(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, n, r.replace(av, "")));
      }, Ps = function(n, r) {
        Ff || (Ff = !0, m("`NaN` is an invalid value for the `%s` css style property.", n));
      }, Go = function(n, r) {
        qo || (qo = !0, m("`Infinity` is an invalid value for the `%s` css style property.", n));
      };
      Lh = function(n, r) {
        n.indexOf("-") > -1 ? zp(n) : rv.test(n) ? Uf(n) : av.test(r) && qp(n, r), typeof r == "number" && (isNaN(r) ? Ps(n, r) : isFinite(r) || Go(n, r));
      };
    }
    var Yf = Lh;
    function ov(n) {
      {
        var r = "", u = "";
        for (var c in n)
          if (n.hasOwnProperty(c)) {
            var p = n[c];
            if (p != null) {
              var x = c.indexOf("--") === 0;
              r += u + (x ? c : nv(c)) + ":", r += Bf(c, p, x), u = ";";
            }
          }
        return r || null;
      }
    }
    function Ih(n, r) {
      var u = n.style;
      for (var c in r)
        if (r.hasOwnProperty(c)) {
          var p = c.indexOf("--") === 0;
          p || Yf(c, r[c]);
          var x = Bf(c, r[c], p);
          c === "float" && (c = "cssFloat"), p ? u.setProperty(c, x) : u[c] = x;
        }
    }
    function iv(n) {
      return n == null || typeof n == "boolean" || n === "";
    }
    function lv(n) {
      var r = {};
      for (var u in n)
        for (var c = ev[u] || [u], p = 0; p < c.length; p++)
          r[c[p]] = u;
      return r;
    }
    function Gp(n, r) {
      {
        if (!r)
          return;
        var u = lv(n), c = lv(r), p = {};
        for (var x in u) {
          var _ = u[x], O = c[x];
          if (O && _ !== O) {
            var k = _ + "," + O;
            if (p[k])
              continue;
            p[k] = !0, m("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", iv(n[_]) ? "Removing" : "Updating", _, O);
          }
        }
      }
    }
    var N1 = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, ue = Gt({
      menuitem: !0
    }, N1), Re = "__html";
    function ge(n, r) {
      if (r) {
        if (ue[n] && (r.children != null || r.dangerouslySetInnerHTML != null))
          throw new Error(n + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (r.dangerouslySetInnerHTML != null) {
          if (r.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof r.dangerouslySetInnerHTML != "object" || !(Re in r.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!r.suppressContentEditableWarning && r.contentEditable && r.children != null && m("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), r.style != null && typeof r.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Je(n, r) {
      if (n.indexOf("-") === -1)
        return typeof r.is == "string";
      switch (n) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Wt = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Rn = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Cr = {}, nr = new RegExp("^(aria)-[" + Sn + "]*$"), oc = new RegExp("^(aria)[A-Z][" + Sn + "]*$");
    function Kp(n, r) {
      {
        if (_n.call(Cr, r) && Cr[r])
          return !0;
        if (oc.test(r)) {
          var u = "aria-" + r.slice(4).toLowerCase(), c = Rn.hasOwnProperty(u) ? u : null;
          if (c == null)
            return m("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", r), Cr[r] = !0, !0;
          if (r !== c)
            return m("Invalid ARIA attribute `%s`. Did you mean `%s`?", r, c), Cr[r] = !0, !0;
        }
        if (nr.test(r)) {
          var p = r.toLowerCase(), x = Rn.hasOwnProperty(p) ? p : null;
          if (x == null)
            return Cr[r] = !0, !1;
          if (r !== x)
            return m("Unknown ARIA attribute `%s`. Did you mean `%s`?", r, x), Cr[r] = !0, !0;
        }
      }
      return !0;
    }
    function Mi(n, r) {
      {
        var u = [];
        for (var c in r) {
          var p = Kp(n, c);
          p || u.push(c);
        }
        var x = u.map(function(_) {
          return "`" + _ + "`";
        }).join(", ");
        u.length === 1 ? m("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", x, n) : u.length > 1 && m("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", x, n);
      }
    }
    function su(n, r) {
      Je(n, r) || Mi(n, r);
    }
    var $f = !1;
    function kl(n, r) {
      {
        if (n !== "input" && n !== "textarea" && n !== "select")
          return;
        r != null && r.value === null && !$f && ($f = !0, n === "select" && r.multiple ? m("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", n) : m("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", n));
      }
    }
    var Vs = function() {
    };
    {
      var pa = {}, En = /^on./, B1 = /^on[^A-Z]/, Wf = new RegExp("^(aria)-[" + Sn + "]*$"), ic = new RegExp("^(aria)[A-Z][" + Sn + "]*$");
      Vs = function(n, r, u, c) {
        if (_n.call(pa, r) && pa[r])
          return !0;
        var p = r.toLowerCase();
        if (p === "onfocusin" || p === "onfocusout")
          return m("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), pa[r] = !0, !0;
        if (c != null) {
          var x = c.registrationNameDependencies, _ = c.possibleRegistrationNames;
          if (x.hasOwnProperty(r))
            return !0;
          var O = _.hasOwnProperty(p) ? _[p] : null;
          if (O != null)
            return m("Invalid event handler property `%s`. Did you mean `%s`?", r, O), pa[r] = !0, !0;
          if (En.test(r))
            return m("Unknown event handler property `%s`. It will be ignored.", r), pa[r] = !0, !0;
        } else if (En.test(r))
          return B1.test(r) && m("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", r), pa[r] = !0, !0;
        if (Wf.test(r) || ic.test(r))
          return !0;
        if (p === "innerhtml")
          return m("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), pa[r] = !0, !0;
        if (p === "aria")
          return m("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), pa[r] = !0, !0;
        if (p === "is" && u !== null && u !== void 0 && typeof u != "string")
          return m("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof u), pa[r] = !0, !0;
        if (typeof u == "number" && isNaN(u))
          return m("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", r), pa[r] = !0, !0;
        var k = Ao(r), N = k !== null && k.type === Ln;
        if (Wt.hasOwnProperty(p)) {
          var U = Wt[p];
          if (U !== r)
            return m("Invalid DOM property `%s`. Did you mean `%s`?", r, U), pa[r] = !0, !0;
        } else if (!N && r !== p)
          return m("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", r, p), pa[r] = !0, !0;
        return typeof u == "boolean" && ta(r, u, k, !1) ? (u ? m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', u, r, r, u, r) : m('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', u, r, r, u, r, r, r), pa[r] = !0, !0) : N ? !0 : ta(r, u, k, !1) ? (pa[r] = !0, !1) : ((u === "false" || u === "true") && k !== null && k.type === zn && (m("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", u, r, u === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', r, u), pa[r] = !0), !0);
      };
    }
    var zf = function(n, r, u) {
      {
        var c = [];
        for (var p in r) {
          var x = Vs(n, p, r[p], u);
          x || c.push(p);
        }
        var _ = c.map(function(O) {
          return "`" + O + "`";
        }).join(", ");
        c.length === 1 ? m("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", _, n) : c.length > 1 && m("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", _, n);
      }
    };
    function uv(n, r, u) {
      Je(n, r) || zf(n, r, u);
    }
    var Hh = 1, Ns = 2, Ko = 4, lc = Hh | Ns | Ko, Bs = null;
    function Qi(n) {
      Bs !== null && m("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Bs = n;
    }
    function qf() {
      Bs === null && m("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Bs = null;
    }
    function Gf(n) {
      return n === Bs;
    }
    function F1(n) {
      var r = n.target || n.srcElement || window;
      return r.correspondingUseElement && (r = r.correspondingUseElement), r.nodeType === Al ? r.parentNode : r;
    }
    var Kf = null, Lo = null, Ti = null;
    function U1(n) {
      var r = q(n);
      if (r) {
        if (typeof Kf != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var u = r.stateNode;
        if (u) {
          var c = se(u);
          Kf(r.stateNode, r.type, c);
        }
      }
    }
    function sv(n) {
      Kf = n;
    }
    function vr(n) {
      Lo ? Ti ? Ti.push(n) : Ti = [n] : Lo = n;
    }
    function Zh() {
      return Lo !== null || Ti !== null;
    }
    function $u() {
      if (Lo) {
        var n = Lo, r = Ti;
        if (Lo = null, Ti = null, U1(n), r)
          for (var u = 0; u < r.length; u++)
            U1(r[u]);
      }
    }
    var cu = function(n, r) {
      return n(r);
    }, uc = function() {
    }, sc = !1;
    function Y1() {
      var n = Zh();
      n && (uc(), $u());
    }
    function cc(n, r, u) {
      if (sc)
        return n(r, u);
      sc = !0;
      try {
        return cu(n, r, u);
      } finally {
        sc = !1, Y1();
      }
    }
    function $1(n, r, u) {
      cu = n, uc = u;
    }
    function oa(n) {
      return n === "button" || n === "input" || n === "select" || n === "textarea";
    }
    function to(n, r, u) {
      switch (n) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(u.disabled && oa(r));
        default:
          return !1;
      }
    }
    function fc(n, r) {
      var u = n.stateNode;
      if (u === null)
        return null;
      var c = se(u);
      if (c === null)
        return null;
      var p = c[r];
      if (to(r, n.type, c))
        return null;
      if (p && typeof p != "function")
        throw new Error("Expected `" + r + "` listener to be a function, instead got a value of `" + typeof p + "` type.");
      return p;
    }
    var Qf = !1;
    if (St)
      try {
        var fu = {};
        Object.defineProperty(fu, "passive", {
          get: function() {
            Qf = !0;
          }
        }), window.addEventListener("test", fu, fu), window.removeEventListener("test", fu, fu);
      } catch {
        Qf = !1;
      }
    function dc(n, r, u, c, p, x, _, O, k) {
      var N = Array.prototype.slice.call(arguments, 3);
      try {
        r.apply(u, N);
      } catch (U) {
        this.onError(U);
      }
    }
    var W1 = dc;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var du = document.createElement("react");
      W1 = function(r, u, c, p, x, _, O, k, N) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var U = document.createEvent("Event"), oe = !1, ae = !0, we = window.event, Ce = Object.getOwnPropertyDescriptor(window, "event");
        function Ee() {
          du.removeEventListener(Me, Ut, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = we);
        }
        var it = Array.prototype.slice.call(arguments, 3);
        function Ut() {
          oe = !0, Ee(), u.apply(c, it), ae = !1;
        }
        var Lt, Dn = !1, xn = !1;
        function pe(me) {
          if (Lt = me.error, Dn = !0, Lt === null && me.colno === 0 && me.lineno === 0 && (xn = !0), me.defaultPrevented && Lt != null && typeof Lt == "object")
            try {
              Lt._suppressLogging = !0;
            } catch {
            }
        }
        var Me = "react-" + (r || "invokeguardedcallback");
        if (window.addEventListener("error", pe), du.addEventListener(Me, Ut, !1), U.initEvent(Me, !1, !1), du.dispatchEvent(U), Ce && Object.defineProperty(window, "event", Ce), oe && ae && (Dn ? xn && (Lt = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Lt = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Lt)), window.removeEventListener("error", pe), !oe)
          return Ee(), dc.apply(this, arguments);
      };
    }
    var hc = W1, Qo = !1, Wu = null, hu = !1, z1 = null, q1 = {
      onError: function(n) {
        Qo = !0, Wu = n;
      }
    };
    function vc(n, r, u, c, p, x, _, O, k) {
      Qo = !1, Wu = null, hc.apply(q1, arguments);
    }
    function zu(n, r, u, c, p, x, _, O, k) {
      if (vc.apply(this, arguments), Qo) {
        var N = Oi();
        hu || (hu = !0, z1 = N);
      }
    }
    function cv() {
      if (hu) {
        var n = z1;
        throw hu = !1, z1 = null, n;
      }
    }
    function G1() {
      return Qo;
    }
    function Oi() {
      if (Qo) {
        var n = Wu;
        return Qo = !1, Wu = null, n;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Xo(n) {
      return n._reactInternals;
    }
    function Jo(n) {
      return n._reactInternals !== void 0;
    }
    function Xf(n, r) {
      n._reactInternals = r;
    }
    var H = (
      /*                      */
      0
    ), Xi = (
      /*                */
      1
    ), fr = (
      /*                    */
      2
    ), zt = (
      /*                       */
      4
    ), Kt = (
      /*                */
      16
    ), Fs = (
      /*                 */
      32
    ), Jf = (
      /*                     */
      64
    ), vn = (
      /*                   */
      128
    ), ia = (
      /*            */
      256
    ), Un = (
      /*                          */
      512
    ), Yn = (
      /*                     */
      1024
    ), mo = (
      /*                      */
      2048
    ), Zr = (
      /*                    */
      4096
    ), la = (
      /*                   */
      8192
    ), Fa = (
      /*             */
      16384
    ), K1 = (
      /*               */
      32767
    ), Ua = (
      /*                   */
      32768
    ), Io = (
      /*                */
      65536
    ), ed = (
      /* */
      131072
    ), Ph = (
      /*                       */
      1048576
    ), Ho = (
      /*                    */
      2097152
    ), qu = (
      /*                 */
      4194304
    ), Ji = (
      /*                */
      8388608
    ), el = (
      /*               */
      16777216
    ), pc = (
      /*              */
      33554432
    ), td = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      zt | Yn | 0
    ), vu = fr | zt | Kt | Fs | Un | Zr | la, Di = zt | Jf | Un | la, tl = mo | Kt, Mr = qu | Ji | Ho, nd = a.ReactCurrentOwner;
    function Ll(n) {
      var r = n, u = n;
      if (n.alternate)
        for (; r.return; )
          r = r.return;
      else {
        var c = r;
        do
          r = c, (r.flags & (fr | Zr)) !== H && (u = r.return), c = r.return;
        while (c);
      }
      return r.tag === T ? u : null;
    }
    function ei(n) {
      if (n.tag === $) {
        var r = n.memoizedState;
        if (r === null) {
          var u = n.alternate;
          u !== null && (r = u.memoizedState);
        }
        if (r !== null)
          return r.dehydrated;
      }
      return null;
    }
    function ti(n) {
      return n.tag === T ? n.stateNode.containerInfo : null;
    }
    function Us(n) {
      return Ll(n) === n;
    }
    function Il(n) {
      {
        var r = nd.current;
        if (r !== null && r.tag === R) {
          var u = r, c = u.stateNode;
          c._warnedAboutRefsInRender || m("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", en(u) || "A component"), c._warnedAboutRefsInRender = !0;
        }
      }
      var p = Xo(n);
      return p ? Ll(p) === p : !1;
    }
    function nl(n) {
      if (Ll(n) !== n)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Gu(n) {
      var r = n.alternate;
      if (!r) {
        var u = Ll(n);
        if (u === null)
          throw new Error("Unable to find node on an unmounted component.");
        return u !== n ? null : n;
      }
      for (var c = n, p = r; ; ) {
        var x = c.return;
        if (x === null)
          break;
        var _ = x.alternate;
        if (_ === null) {
          var O = x.return;
          if (O !== null) {
            c = p = O;
            continue;
          }
          break;
        }
        if (x.child === _.child) {
          for (var k = x.child; k; ) {
            if (k === c)
              return nl(x), n;
            if (k === p)
              return nl(x), r;
            k = k.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (c.return !== p.return)
          c = x, p = _;
        else {
          for (var N = !1, U = x.child; U; ) {
            if (U === c) {
              N = !0, c = x, p = _;
              break;
            }
            if (U === p) {
              N = !0, p = x, c = _;
              break;
            }
            U = U.sibling;
          }
          if (!N) {
            for (U = _.child; U; ) {
              if (U === c) {
                N = !0, c = _, p = x;
                break;
              }
              if (U === p) {
                N = !0, p = _, c = x;
                break;
              }
              U = U.sibling;
            }
            if (!N)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (c.alternate !== p)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (c.tag !== T)
        throw new Error("Unable to find node on an unmounted component.");
      return c.stateNode.current === c ? n : r;
    }
    function Vh(n) {
      var r = Gu(n);
      return r !== null ? Q1(r) : null;
    }
    function Q1(n) {
      if (n.tag === A || n.tag === L)
        return n;
      for (var r = n.child; r !== null; ) {
        var u = Q1(r);
        if (u !== null)
          return u;
        r = r.sibling;
      }
      return null;
    }
    function Ys(n) {
      var r = Gu(n);
      return r !== null ? Ya(r) : null;
    }
    function Ya(n) {
      if (n.tag === A || n.tag === L)
        return n;
      for (var r = n.child; r !== null; ) {
        if (r.tag !== j) {
          var u = Ya(r);
          if (u !== null)
            return u;
        }
        r = r.sibling;
      }
      return null;
    }
    var Zo = t.unstable_scheduleCallback, br = t.unstable_cancelCallback, rl = t.unstable_shouldYield, Hl = t.unstable_requestPaint, Yr = t.unstable_now, pu = t.unstable_getCurrentPriorityLevel, $a = t.unstable_ImmediatePriority, rd = t.unstable_UserBlockingPriority, al = t.unstable_NormalPriority, Nh = t.unstable_LowPriority, ji = t.unstable_IdlePriority, Zl = t.unstable_yieldValue, fv = t.unstable_setDisableYieldValue, Pl = null, Pr = null, at = null, Ai = !1, Zn = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function ad(n) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var r = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (r.isDisabled)
        return !0;
      if (!r.supportsFiber)
        return m("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        n = Gt({}, n, {
          getLaneLabelMap: Wa,
          injectProfilingHooks: od
        }), Pl = r.inject(n), Pr = r;
      } catch (u) {
        m("React instrumentation encountered an error: %s.", u);
      }
      return !!r.checkDCE;
    }
    function mc(n, r) {
      if (Pr && typeof Pr.onScheduleFiberRoot == "function")
        try {
          Pr.onScheduleFiberRoot(Pl, n, r);
        } catch (u) {
          Ai || (Ai = !0, m("React instrumentation encountered an error: %s", u));
        }
    }
    function ni(n, r) {
      if (Pr && typeof Pr.onCommitFiberRoot == "function")
        try {
          var u = (n.current.flags & vn) === vn;
          {
            var c;
            switch (r) {
              case zr:
                c = $a;
                break;
              case jt:
                c = rd;
                break;
              case oi:
                c = al;
                break;
              case us:
                c = ji;
                break;
              default:
                c = al;
                break;
            }
            Pr.onCommitFiberRoot(Pl, n, c, u);
          }
        } catch (p) {
          Ai || (Ai = !0, m("React instrumentation encountered an error: %s", p));
        }
    }
    function Ku(n) {
      if (Pr && typeof Pr.onPostCommitFiberRoot == "function")
        try {
          Pr.onPostCommitFiberRoot(Pl, n);
        } catch (r) {
          Ai || (Ai = !0, m("React instrumentation encountered an error: %s", r));
        }
    }
    function X1(n) {
      if (Pr && typeof Pr.onCommitFiberUnmount == "function")
        try {
          Pr.onCommitFiberUnmount(Pl, n);
        } catch (r) {
          Ai || (Ai = !0, m("React instrumentation encountered an error: %s", r));
        }
    }
    function pr(n) {
      if (typeof Zl == "function" && (fv(n), h(n)), Pr && typeof Pr.setStrictMode == "function")
        try {
          Pr.setStrictMode(Pl, n);
        } catch (r) {
          Ai || (Ai = !0, m("React instrumentation encountered an error: %s", r));
        }
    }
    function od(n) {
      at = n;
    }
    function Wa() {
      {
        for (var n = /* @__PURE__ */ new Map(), r = 1, u = 0; u < Wr; u++) {
          var c = Qp(r);
          n.set(r, c), r *= 2;
        }
        return n;
      }
    }
    function Qu(n) {
      at !== null && typeof at.markCommitStarted == "function" && at.markCommitStarted(n);
    }
    function ri() {
      at !== null && typeof at.markCommitStopped == "function" && at.markCommitStopped();
    }
    function ol(n) {
      at !== null && typeof at.markComponentRenderStarted == "function" && at.markComponentRenderStarted(n);
    }
    function Xu() {
      at !== null && typeof at.markComponentRenderStopped == "function" && at.markComponentRenderStopped();
    }
    function id(n) {
      at !== null && typeof at.markComponentPassiveEffectMountStarted == "function" && at.markComponentPassiveEffectMountStarted(n);
    }
    function mu() {
      at !== null && typeof at.markComponentPassiveEffectMountStopped == "function" && at.markComponentPassiveEffectMountStopped();
    }
    function ki(n) {
      at !== null && typeof at.markComponentPassiveEffectUnmountStarted == "function" && at.markComponentPassiveEffectUnmountStarted(n);
    }
    function ld() {
      at !== null && typeof at.markComponentPassiveEffectUnmountStopped == "function" && at.markComponentPassiveEffectUnmountStopped();
    }
    function dv(n) {
      at !== null && typeof at.markComponentLayoutEffectMountStarted == "function" && at.markComponentLayoutEffectMountStarted(n);
    }
    function gu() {
      at !== null && typeof at.markComponentLayoutEffectMountStopped == "function" && at.markComponentLayoutEffectMountStopped();
    }
    function ai(n) {
      at !== null && typeof at.markComponentLayoutEffectUnmountStarted == "function" && at.markComponentLayoutEffectUnmountStarted(n);
    }
    function gc() {
      at !== null && typeof at.markComponentLayoutEffectUnmountStopped == "function" && at.markComponentLayoutEffectUnmountStopped();
    }
    function hv(n, r, u) {
      at !== null && typeof at.markComponentErrored == "function" && at.markComponentErrored(n, r, u);
    }
    function J1(n, r, u) {
      at !== null && typeof at.markComponentSuspended == "function" && at.markComponentSuspended(n, r, u);
    }
    function Bh(n) {
      at !== null && typeof at.markLayoutEffectsStarted == "function" && at.markLayoutEffectsStarted(n);
    }
    function wc() {
      at !== null && typeof at.markLayoutEffectsStopped == "function" && at.markLayoutEffectsStopped();
    }
    function Vl(n) {
      at !== null && typeof at.markPassiveEffectsStarted == "function" && at.markPassiveEffectsStarted(n);
    }
    function yc() {
      at !== null && typeof at.markPassiveEffectsStopped == "function" && at.markPassiveEffectsStopped();
    }
    function $s(n) {
      at !== null && typeof at.markRenderStarted == "function" && at.markRenderStarted(n);
    }
    function wu() {
      at !== null && typeof at.markRenderYielded == "function" && at.markRenderYielded();
    }
    function ud() {
      at !== null && typeof at.markRenderStopped == "function" && at.markRenderStopped();
    }
    function Ju(n) {
      at !== null && typeof at.markRenderScheduled == "function" && at.markRenderScheduled(n);
    }
    function Fh(n, r) {
      at !== null && typeof at.markForceUpdateScheduled == "function" && at.markForceUpdateScheduled(n, r);
    }
    function e0(n, r) {
      at !== null && typeof at.markStateUpdateScheduled == "function" && at.markStateUpdateScheduled(n, r);
    }
    var tt = (
      /*                         */
      0
    ), on = (
      /*                 */
      1
    ), Pn = (
      /*                    */
      2
    ), _r = (
      /*               */
      8
    ), Po = (
      /*              */
      16
    ), sd = Math.clz32 ? Math.clz32 : $r, es = Math.log, Ar = Math.LN2;
    function $r(n) {
      var r = n >>> 0;
      return r === 0 ? 32 : 31 - (es(r) / Ar | 0) | 0;
    }
    var Wr = 31, He = (
      /*                        */
      0
    ), Vr = (
      /*                          */
      0
    ), It = (
      /*                        */
      1
    ), tn = (
      /*    */
      2
    ), Tr = (
      /*             */
      4
    ), yu = (
      /*            */
      8
    ), no = (
      /*                     */
      16
    ), ts = (
      /*                */
      32
    ), go = (
      /*                       */
      4194240
    ), ro = (
      /*                        */
      64
    ), ba = (
      /*                        */
      128
    ), xc = (
      /*                        */
      256
    ), ns = (
      /*                        */
      512
    ), t0 = (
      /*                        */
      1024
    ), Sc = (
      /*                        */
      2048
    ), Cc = (
      /*                        */
      4096
    ), ao = (
      /*                        */
      8192
    ), il = (
      /*                        */
      16384
    ), n0 = (
      /*                       */
      32768
    ), bc = (
      /*                       */
      65536
    ), Ws = (
      /*                       */
      131072
    ), rs = (
      /*                       */
      262144
    ), r0 = (
      /*                       */
      524288
    ), zs = (
      /*                       */
      1048576
    ), as = (
      /*                       */
      2097152
    ), qs = (
      /*                            */
      130023424
    ), wo = (
      /*                             */
      4194304
    ), cd = (
      /*                             */
      8388608
    ), ll = (
      /*                             */
      16777216
    ), _c = (
      /*                             */
      33554432
    ), Rc = (
      /*                             */
      67108864
    ), a0 = wo, o0 = (
      /*          */
      134217728
    ), Uh = (
      /*                          */
      268435455
    ), i0 = (
      /*               */
      268435456
    ), os = (
      /*                        */
      536870912
    ), Vo = (
      /*                   */
      1073741824
    );
    function Qp(n) {
      {
        if (n & It)
          return "Sync";
        if (n & tn)
          return "InputContinuousHydration";
        if (n & Tr)
          return "InputContinuous";
        if (n & yu)
          return "DefaultHydration";
        if (n & no)
          return "Default";
        if (n & ts)
          return "TransitionHydration";
        if (n & go)
          return "Transition";
        if (n & qs)
          return "Retry";
        if (n & o0)
          return "SelectiveHydration";
        if (n & i0)
          return "IdleHydration";
        if (n & os)
          return "Idle";
        if (n & Vo)
          return "Offscreen";
      }
    }
    var dr = -1, l0 = ro, _a = wo;
    function yo(n) {
      switch (Bl(n)) {
        case It:
          return It;
        case tn:
          return tn;
        case Tr:
          return Tr;
        case yu:
          return yu;
        case no:
          return no;
        case ts:
          return ts;
        case ro:
        case ba:
        case xc:
        case ns:
        case t0:
        case Sc:
        case Cc:
        case ao:
        case il:
        case n0:
        case bc:
        case Ws:
        case rs:
        case r0:
        case zs:
        case as:
          return n & go;
        case wo:
        case cd:
        case ll:
        case _c:
        case Rc:
          return n & qs;
        case o0:
          return o0;
        case i0:
          return i0;
        case os:
          return os;
        case Vo:
          return Vo;
        default:
          return m("Should have found matching lanes. This is a bug in React."), n;
      }
    }
    function Gs(n, r) {
      var u = n.pendingLanes;
      if (u === He)
        return He;
      var c = He, p = n.suspendedLanes, x = n.pingedLanes, _ = u & Uh;
      if (_ !== He) {
        var O = _ & ~p;
        if (O !== He)
          c = yo(O);
        else {
          var k = _ & x;
          k !== He && (c = yo(k));
        }
      } else {
        var N = u & ~p;
        N !== He ? c = yo(N) : x !== He && (c = yo(x));
      }
      if (c === He)
        return He;
      if (r !== He && r !== c && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (r & p) === He) {
        var U = Bl(c), oe = Bl(r);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          U >= oe || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          U === no && (oe & go) !== He
        )
          return r;
      }
      (c & Tr) !== He && (c |= u & no);
      var ae = n.entangledLanes;
      if (ae !== He)
        for (var we = n.entanglements, Ce = c & ae; Ce > 0; ) {
          var Ee = ls(Ce), it = 1 << Ee;
          c |= we[Ee], Ce &= ~it;
        }
      return c;
    }
    function Xp(n, r) {
      for (var u = n.eventTimes, c = dr; r > 0; ) {
        var p = ls(r), x = 1 << p, _ = u[p];
        _ > c && (c = _), r &= ~x;
      }
      return c;
    }
    function fd(n, r) {
      switch (n) {
        case It:
        case tn:
        case Tr:
          return r + 250;
        case yu:
        case no:
        case ts:
        case ro:
        case ba:
        case xc:
        case ns:
        case t0:
        case Sc:
        case Cc:
        case ao:
        case il:
        case n0:
        case bc:
        case Ws:
        case rs:
        case r0:
        case zs:
        case as:
          return r + 5e3;
        case wo:
        case cd:
        case ll:
        case _c:
        case Rc:
          return dr;
        case o0:
        case i0:
        case os:
        case Vo:
          return dr;
        default:
          return m("Should have found matching lanes. This is a bug in React."), dr;
      }
    }
    function u0(n, r) {
      for (var u = n.pendingLanes, c = n.suspendedLanes, p = n.pingedLanes, x = n.expirationTimes, _ = u; _ > 0; ) {
        var O = ls(_), k = 1 << O, N = x[O];
        N === dr ? ((k & c) === He || (k & p) !== He) && (x[O] = fd(k, r)) : N <= r && (n.expiredLanes |= k), _ &= ~k;
      }
    }
    function Li(n) {
      return yo(n.pendingLanes);
    }
    function s0(n) {
      var r = n.pendingLanes & -1073741825;
      return r !== He ? r : r & Vo ? Vo : He;
    }
    function dd(n) {
      return (n & It) !== He;
    }
    function Ec(n) {
      return (n & Uh) !== He;
    }
    function is(n) {
      return (n & qs) === n;
    }
    function c0(n) {
      var r = It | Tr | no;
      return (n & r) === He;
    }
    function Yh(n) {
      return (n & go) === n;
    }
    function Nl(n, r) {
      var u = tn | Tr | yu | no;
      return (r & u) !== He;
    }
    function hd(n, r) {
      return (r & n.expiredLanes) !== He;
    }
    function Ks(n) {
      return (n & go) !== He;
    }
    function $h() {
      var n = l0;
      return l0 <<= 1, (l0 & go) === He && (l0 = ro), n;
    }
    function Mc() {
      var n = _a;
      return _a <<= 1, (_a & qs) === He && (_a = wo), n;
    }
    function Bl(n) {
      return n & -n;
    }
    function xu(n) {
      return Bl(n);
    }
    function ls(n) {
      return 31 - sd(n);
    }
    function Tc(n) {
      return ls(n);
    }
    function oo(n, r) {
      return (n & r) !== He;
    }
    function ua(n, r) {
      return (n & r) === r;
    }
    function At(n, r) {
      return n | r;
    }
    function Oc(n, r) {
      return n & ~r;
    }
    function vd(n, r) {
      return n & r;
    }
    function Su(n) {
      return n;
    }
    function Wh(n, r) {
      return n !== Vr && n < r ? n : r;
    }
    function Dc(n) {
      for (var r = [], u = 0; u < Wr; u++)
        r.push(n);
      return r;
    }
    function Qs(n, r, u) {
      n.pendingLanes |= r, r !== os && (n.suspendedLanes = He, n.pingedLanes = He);
      var c = n.eventTimes, p = Tc(r);
      c[p] = u;
    }
    function zh(n, r) {
      n.suspendedLanes |= r, n.pingedLanes &= ~r;
      for (var u = n.expirationTimes, c = r; c > 0; ) {
        var p = ls(c), x = 1 << p;
        u[p] = dr, c &= ~x;
      }
    }
    function pd(n, r, u) {
      n.pingedLanes |= n.suspendedLanes & r;
    }
    function vv(n, r) {
      var u = n.pendingLanes & ~r;
      n.pendingLanes = r, n.suspendedLanes = He, n.pingedLanes = He, n.expiredLanes &= r, n.mutableReadLanes &= r, n.entangledLanes &= r;
      for (var c = n.entanglements, p = n.eventTimes, x = n.expirationTimes, _ = u; _ > 0; ) {
        var O = ls(_), k = 1 << O;
        c[O] = He, p[O] = dr, x[O] = dr, _ &= ~k;
      }
    }
    function Ii(n, r) {
      for (var u = n.entangledLanes |= r, c = n.entanglements, p = u; p; ) {
        var x = ls(p), _ = 1 << x;
        // Is this one of the newly entangled lanes?
        _ & r | // Is this lane transitively entangled with the newly entangled lanes?
        c[x] & r && (c[x] |= r), p &= ~_;
      }
    }
    function jc(n, r) {
      var u = Bl(r), c;
      switch (u) {
        case Tr:
          c = tn;
          break;
        case no:
          c = yu;
          break;
        case ro:
        case ba:
        case xc:
        case ns:
        case t0:
        case Sc:
        case Cc:
        case ao:
        case il:
        case n0:
        case bc:
        case Ws:
        case rs:
        case r0:
        case zs:
        case as:
        case wo:
        case cd:
        case ll:
        case _c:
        case Rc:
          c = ts;
          break;
        case os:
          c = i0;
          break;
        default:
          c = Vr;
          break;
      }
      return (c & (n.suspendedLanes | r)) !== Vr ? Vr : c;
    }
    function f0(n, r, u) {
      if (Zn)
        for (var c = n.pendingUpdatersLaneMap; u > 0; ) {
          var p = Tc(u), x = 1 << p, _ = c[p];
          _.add(r), u &= ~x;
        }
    }
    function Ac(n, r) {
      if (Zn)
        for (var u = n.pendingUpdatersLaneMap, c = n.memoizedUpdaters; r > 0; ) {
          var p = Tc(r), x = 1 << p, _ = u[p];
          _.size > 0 && (_.forEach(function(O) {
            var k = O.alternate;
            (k === null || !c.has(k)) && c.add(O);
          }), _.clear()), r &= ~x;
        }
    }
    function Xs(n, r) {
      return null;
    }
    var zr = It, jt = Tr, oi = no, us = os, Hi = Vr;
    function No() {
      return Hi;
    }
    function rr(n) {
      Hi = n;
    }
    function pv(n, r) {
      var u = Hi;
      try {
        return Hi = n, r();
      } finally {
        Hi = u;
      }
    }
    function za(n, r) {
      return n !== 0 && n < r ? n : r;
    }
    function qh(n, r) {
      return n > r ? n : r;
    }
    function md(n, r) {
      return n !== 0 && n < r;
    }
    function gd(n) {
      var r = Bl(n);
      return md(zr, r) ? md(jt, r) ? Ec(r) ? oi : us : jt : zr;
    }
    function ss(n) {
      var r = n.current.memoizedState;
      return r.isDehydrated;
    }
    var Ra;
    function Jp(n) {
      Ra = n;
    }
    function em(n) {
      Ra(n);
    }
    var d0;
    function Or(n) {
      d0 = n;
    }
    var io;
    function ht(n) {
      io = n;
    }
    var Js;
    function kc(n) {
      Js = n;
    }
    var Gh;
    function tm(n) {
      Gh = n;
    }
    var ul = !1, cs = [], sl = null, Cu = null, bu = null, h0 = /* @__PURE__ */ new Map(), e1 = /* @__PURE__ */ new Map(), cl = [], Ea = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function fl(n) {
      return Ea.indexOf(n) > -1;
    }
    function Fl(n, r, u, c, p) {
      return {
        blockedOn: n,
        domEventName: r,
        eventSystemFlags: u,
        nativeEvent: p,
        targetContainers: [c]
      };
    }
    function wd(n, r) {
      switch (n) {
        case "focusin":
        case "focusout":
          sl = null;
          break;
        case "dragenter":
        case "dragleave":
          Cu = null;
          break;
        case "mouseover":
        case "mouseout":
          bu = null;
          break;
        case "pointerover":
        case "pointerout": {
          var u = r.pointerId;
          h0.delete(u);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var c = r.pointerId;
          e1.delete(c);
          break;
        }
      }
    }
    function Ul(n, r, u, c, p, x) {
      if (n === null || n.nativeEvent !== x) {
        var _ = Fl(r, u, c, p, x);
        if (r !== null) {
          var O = q(r);
          O !== null && d0(O);
        }
        return _;
      }
      n.eventSystemFlags |= c;
      var k = n.targetContainers;
      return p !== null && k.indexOf(p) === -1 && k.push(p), n;
    }
    function ii(n, r, u, c, p) {
      switch (r) {
        case "focusin": {
          var x = p;
          return sl = Ul(sl, n, r, u, c, x), !0;
        }
        case "dragenter": {
          var _ = p;
          return Cu = Ul(Cu, n, r, u, c, _), !0;
        }
        case "mouseover": {
          var O = p;
          return bu = Ul(bu, n, r, u, c, O), !0;
        }
        case "pointerover": {
          var k = p, N = k.pointerId;
          return h0.set(N, Ul(h0.get(N) || null, n, r, u, c, k)), !0;
        }
        case "gotpointercapture": {
          var U = p, oe = U.pointerId;
          return e1.set(oe, Ul(e1.get(oe) || null, n, r, u, c, U)), !0;
        }
      }
      return !1;
    }
    function yd(n) {
      var r = B(n.target);
      if (r !== null) {
        var u = Ll(r);
        if (u !== null) {
          var c = u.tag;
          if (c === $) {
            var p = ei(u);
            if (p !== null) {
              n.blockedOn = p, Gh(n.priority, function() {
                io(u);
              });
              return;
            }
          } else if (c === T) {
            var x = u.stateNode;
            if (ss(x)) {
              n.blockedOn = ti(u);
              return;
            }
          }
        }
      }
      n.blockedOn = null;
    }
    function dl(n) {
      for (var r = Js(), u = {
        blockedOn: null,
        target: n,
        priority: r
      }, c = 0; c < cl.length && md(r, cl[c].priority); c++)
        ;
      cl.splice(c, 0, u), c === 0 && yd(u);
    }
    function t1(n) {
      if (n.blockedOn !== null)
        return !1;
      for (var r = n.targetContainers; r.length > 0; ) {
        var u = r[0], c = qr(n.domEventName, n.eventSystemFlags, u, n.nativeEvent);
        if (c === null) {
          var p = n.nativeEvent, x = new p.constructor(p.type, p);
          Qi(x), p.target.dispatchEvent(x), qf();
        } else {
          var _ = q(c);
          return _ !== null && d0(_), n.blockedOn = c, !1;
        }
        r.shift();
      }
      return !0;
    }
    function xd(n, r, u) {
      t1(n) && u.delete(r);
    }
    function hl() {
      ul = !1, sl !== null && t1(sl) && (sl = null), Cu !== null && t1(Cu) && (Cu = null), bu !== null && t1(bu) && (bu = null), h0.forEach(xd), e1.forEach(xd);
    }
    function Zi(n, r) {
      n.blockedOn === r && (n.blockedOn = null, ul || (ul = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, hl)));
    }
    function v0(n) {
      if (cs.length > 0) {
        Zi(cs[0], n);
        for (var r = 1; r < cs.length; r++) {
          var u = cs[r];
          u.blockedOn === n && (u.blockedOn = null);
        }
      }
      sl !== null && Zi(sl, n), Cu !== null && Zi(Cu, n), bu !== null && Zi(bu, n);
      var c = function(O) {
        return Zi(O, n);
      };
      h0.forEach(c), e1.forEach(c);
      for (var p = 0; p < cl.length; p++) {
        var x = cl[p];
        x.blockedOn === n && (x.blockedOn = null);
      }
      for (; cl.length > 0; ) {
        var _ = cl[0];
        if (_.blockedOn !== null)
          break;
        yd(_), _.blockedOn === null && cl.shift();
      }
    }
    var n1 = a.ReactCurrentBatchConfig, p0 = !0;
    function Sd(n) {
      p0 = !!n;
    }
    function Pi() {
      return p0;
    }
    function Mn(n, r, u) {
      var c = m0(r), p;
      switch (c) {
        case zr:
          p = Ma;
          break;
        case jt:
          p = sa;
          break;
        case oi:
        default:
          p = ma;
          break;
      }
      return p.bind(null, r, u, n);
    }
    function Ma(n, r, u, c) {
      var p = No(), x = n1.transition;
      n1.transition = null;
      try {
        rr(zr), ma(n, r, u, c);
      } finally {
        rr(p), n1.transition = x;
      }
    }
    function sa(n, r, u, c) {
      var p = No(), x = n1.transition;
      n1.transition = null;
      try {
        rr(jt), ma(n, r, u, c);
      } finally {
        rr(p), n1.transition = x;
      }
    }
    function ma(n, r, u, c) {
      p0 && li(n, r, u, c);
    }
    function li(n, r, u, c) {
      var p = qr(n, r, u, c);
      if (p === null) {
        ci(n, r, c, _u, u), wd(n, c);
        return;
      }
      if (ii(p, n, r, u, c)) {
        c.stopPropagation();
        return;
      }
      if (wd(n, c), r & Ko && fl(n)) {
        for (; p !== null; ) {
          var x = q(p);
          x !== null && em(x);
          var _ = qr(n, r, u, c);
          if (_ === null && ci(n, r, c, _u, u), _ === p)
            break;
          p = _;
        }
        p !== null && c.stopPropagation();
        return;
      }
      ci(n, r, c, null, u);
    }
    var _u = null;
    function qr(n, r, u, c) {
      _u = null;
      var p = F1(c), x = B(p);
      if (x !== null) {
        var _ = Ll(x);
        if (_ === null)
          x = null;
        else {
          var O = _.tag;
          if (O === $) {
            var k = ei(_);
            if (k !== null)
              return k;
            x = null;
          } else if (O === T) {
            var N = _.stateNode;
            if (ss(N))
              return ti(_);
            x = null;
          } else _ !== x && (x = null);
        }
      }
      return _u = x, null;
    }
    function m0(n) {
      switch (n) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return zr;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return jt;
        case "message": {
          var r = pu();
          switch (r) {
            case $a:
              return zr;
            case rd:
              return jt;
            case al:
            case Nh:
              return oi;
            case ji:
              return us;
            default:
              return oi;
          }
        }
        default:
          return oi;
      }
    }
    function fs(n, r, u) {
      return n.addEventListener(r, u, !1), u;
    }
    function Lc(n, r, u) {
      return n.addEventListener(r, u, !0), u;
    }
    function Cd(n, r, u, c) {
      return n.addEventListener(r, u, {
        capture: !0,
        passive: c
      }), u;
    }
    function Ic(n, r, u, c) {
      return n.addEventListener(r, u, {
        passive: c
      }), u;
    }
    var Ta = null, Hc = null, vl = null;
    function Ru(n) {
      return Ta = n, Hc = Eu(), !0;
    }
    function bd() {
      Ta = null, Hc = null, vl = null;
    }
    function _d() {
      if (vl)
        return vl;
      var n, r = Hc, u = r.length, c, p = Eu(), x = p.length;
      for (n = 0; n < u && r[n] === p[n]; n++)
        ;
      var _ = u - n;
      for (c = 1; c <= _ && r[u - c] === p[x - c]; c++)
        ;
      var O = c > 1 ? 1 - c : void 0;
      return vl = p.slice(n, O), vl;
    }
    function Eu() {
      return "value" in Ta ? Ta.value : Ta.textContent;
    }
    function r1(n) {
      var r, u = n.keyCode;
      return "charCode" in n ? (r = n.charCode, r === 0 && u === 13 && (r = 13)) : r = u, r === 10 && (r = 13), r >= 32 || r === 13 ? r : 0;
    }
    function pl() {
      return !0;
    }
    function lo() {
      return !1;
    }
    function qa(n) {
      function r(u, c, p, x, _) {
        this._reactName = u, this._targetInst = p, this.type = c, this.nativeEvent = x, this.target = _, this.currentTarget = null;
        for (var O in n)
          if (n.hasOwnProperty(O)) {
            var k = n[O];
            k ? this[O] = k(x) : this[O] = x[O];
          }
        var N = x.defaultPrevented != null ? x.defaultPrevented : x.returnValue === !1;
        return N ? this.isDefaultPrevented = pl : this.isDefaultPrevented = lo, this.isPropagationStopped = lo, this;
      }
      return Gt(r.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var u = this.nativeEvent;
          u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = pl);
        },
        stopPropagation: function() {
          var u = this.nativeEvent;
          u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = pl);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: pl
      }), r;
    }
    var ds = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(n) {
        return n.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, g0 = qa(ds), Mu = Gt({}, ds, {
      view: 0,
      detail: 0
    }), xo = qa(Mu), Yl, ui, Oa;
    function Rd(n) {
      n !== Oa && (Oa && n.type === "mousemove" ? (Yl = n.screenX - Oa.screenX, ui = n.screenY - Oa.screenY) : (Yl = 0, ui = 0), Oa = n);
    }
    var w0 = Gt({}, Mu, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Qh,
      button: 0,
      buttons: 0,
      relatedTarget: function(n) {
        return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
      },
      movementX: function(n) {
        return "movementX" in n ? n.movementX : (Rd(n), Yl);
      },
      movementY: function(n) {
        return "movementY" in n ? n.movementY : ui;
      }
    }), Ed = qa(w0), nm = Gt({}, w0, {
      dataTransfer: 0
    }), hs = qa(nm), mv = Gt({}, Mu, {
      relatedTarget: 0
    }), Zc = qa(mv), a1 = Gt({}, ds, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Kh = qa(a1), o1 = Gt({}, ds, {
      clipboardData: function(n) {
        return "clipboardData" in n ? n.clipboardData : window.clipboardData;
      }
    }), gv = qa(o1), wv = Gt({}, ds, {
      data: 0
    }), Md = qa(wv), Td = Md, rm = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, am = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function yv(n) {
      if (n.key) {
        var r = rm[n.key] || n.key;
        if (r !== "Unidentified")
          return r;
      }
      if (n.type === "keypress") {
        var u = r1(n);
        return u === 13 ? "Enter" : String.fromCharCode(u);
      }
      return n.type === "keydown" || n.type === "keyup" ? am[n.keyCode] || "Unidentified" : "";
    }
    var xv = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function i1(n) {
      var r = this, u = r.nativeEvent;
      if (u.getModifierState)
        return u.getModifierState(n);
      var c = xv[n];
      return c ? !!u[c] : !1;
    }
    function Qh(n) {
      return i1;
    }
    var y0 = Gt({}, Mu, {
      key: yv,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Qh,
      // Legacy Interface
      charCode: function(n) {
        return n.type === "keypress" ? r1(n) : 0;
      },
      keyCode: function(n) {
        return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      },
      which: function(n) {
        return n.type === "keypress" ? r1(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
      }
    }), Od = qa(y0), kr = Gt({}, w0, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), Sv = qa(kr), Cv = Gt({}, Mu, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Qh
    }), om = qa(Cv), im = Gt({}, ds, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), bv = qa(im), _v = Gt({}, w0, {
      deltaX: function(n) {
        return "deltaX" in n ? n.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in n ? -n.wheelDeltaX : 0
        );
      },
      deltaY: function(n) {
        return "deltaY" in n ? n.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in n ? -n.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in n ? -n.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), lm = qa(_v), Vi = [9, 13, 27, 32], Pc = 229, Xh = St && "CompositionEvent" in window, So = null;
    St && "documentMode" in document && (So = document.documentMode);
    var Dd = St && "TextEvent" in window && !So, vs = St && (!Xh || So && So > 8 && So <= 11), Vc = 32, jd = String.fromCharCode(Vc);
    function Jh() {
      et("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), et("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), et("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), et("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Rv = !1;
    function e2(n) {
      return (n.ctrlKey || n.altKey || n.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(n.ctrlKey && n.altKey);
    }
    function um(n) {
      switch (n) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Ev(n, r) {
      return n === "keydown" && r.keyCode === Pc;
    }
    function t2(n, r) {
      switch (n) {
        case "keyup":
          return Vi.indexOf(r.keyCode) !== -1;
        case "keydown":
          return r.keyCode !== Pc;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Nc(n) {
      var r = n.detail;
      return typeof r == "object" && "data" in r ? r.data : null;
    }
    function Bc(n) {
      return n.locale === "ko";
    }
    var l1 = !1;
    function n2(n, r, u, c, p) {
      var x, _;
      if (Xh ? x = um(r) : l1 ? t2(r, c) && (x = "onCompositionEnd") : Ev(r, c) && (x = "onCompositionStart"), !x)
        return null;
      vs && !Bc(c) && (!l1 && x === "onCompositionStart" ? l1 = Ru(p) : x === "onCompositionEnd" && l1 && (_ = _d()));
      var O = Av(u, x);
      if (O.length > 0) {
        var k = new Md(x, r, null, c, p);
        if (n.push({
          event: k,
          listeners: O
        }), _)
          k.data = _;
        else {
          var N = Nc(c);
          N !== null && (k.data = N);
        }
      }
    }
    function sm(n, r) {
      switch (n) {
        case "compositionend":
          return Nc(r);
        case "keypress":
          var u = r.which;
          return u !== Vc ? null : (Rv = !0, jd);
        case "textInput":
          var c = r.data;
          return c === jd && Rv ? null : c;
        default:
          return null;
      }
    }
    function Mv(n, r) {
      if (l1) {
        if (n === "compositionend" || !Xh && t2(n, r)) {
          var u = _d();
          return bd(), l1 = !1, u;
        }
        return null;
      }
      switch (n) {
        case "paste":
          return null;
        case "keypress":
          if (!e2(r)) {
            if (r.char && r.char.length > 1)
              return r.char;
            if (r.which)
              return String.fromCharCode(r.which);
          }
          return null;
        case "compositionend":
          return vs && !Bc(r) ? null : r.data;
        default:
          return null;
      }
    }
    function Ad(n, r, u, c, p) {
      var x;
      if (Dd ? x = sm(r, c) : x = Mv(r, c), !x)
        return null;
      var _ = Av(u, "onBeforeInput");
      if (_.length > 0) {
        var O = new Td("onBeforeInput", "beforeinput", null, c, p);
        n.push({
          event: O,
          listeners: _
        }), O.data = x;
      }
    }
    function Fc(n, r, u, c, p, x, _) {
      n2(n, r, u, c, p), Ad(n, r, u, c, p);
    }
    var r2 = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Uc(n) {
      var r = n && n.nodeName && n.nodeName.toLowerCase();
      return r === "input" ? !!r2[n.type] : r === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Tv(n) {
      if (!St)
        return !1;
      var r = "on" + n, u = r in document;
      if (!u) {
        var c = document.createElement("div");
        c.setAttribute(r, "return;"), u = typeof c[r] == "function";
      }
      return u;
    }
    function cm() {
      et("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function ps(n, r, u, c) {
      vr(c);
      var p = Av(r, "onChange");
      if (p.length > 0) {
        var x = new g0("onChange", "change", null, u, c);
        n.push({
          event: x,
          listeners: p
        });
      }
    }
    var Yc = null, Tu = null;
    function fm(n) {
      var r = n.nodeName && n.nodeName.toLowerCase();
      return r === "select" || r === "input" && n.type === "file";
    }
    function kd(n) {
      var r = [];
      ps(r, Tu, n, F1(n)), cc(o, r);
    }
    function o(n) {
      M3(n, 0);
    }
    function l(n) {
      var r = J(n);
      if (W2(r))
        return n;
    }
    function v(n, r) {
      if (n === "change")
        return r;
    }
    var w = !1;
    St && (w = Tv("input") && (!document.documentMode || document.documentMode > 9));
    function b(n, r) {
      Yc = n, Tu = r, Yc.attachEvent("onpropertychange", Z);
    }
    function E() {
      Yc && (Yc.detachEvent("onpropertychange", Z), Yc = null, Tu = null);
    }
    function Z(n) {
      n.propertyName === "value" && l(Tu) && kd(n);
    }
    function z(n, r, u) {
      n === "focusin" ? (E(), b(r, u)) : n === "focusout" && E();
    }
    function ee(n, r) {
      if (n === "selectionchange" || n === "keyup" || n === "keydown")
        return l(Tu);
    }
    function ye(n) {
      var r = n.nodeName;
      return r && r.toLowerCase() === "input" && (n.type === "checkbox" || n.type === "radio");
    }
    function Ne(n, r) {
      if (n === "click")
        return l(r);
    }
    function Ye(n, r) {
      if (n === "input" || n === "change")
        return l(r);
    }
    function Ve(n) {
      var r = n._wrapperState;
      !r || !r.controlled || n.type !== "number" || X0(n, "number", n.value);
    }
    function lt(n, r, u, c, p, x, _) {
      var O = u ? J(u) : window, k, N;
      if (fm(O) ? k = v : Uc(O) ? w ? k = Ye : (k = ee, N = z) : ye(O) && (k = Ne), k) {
        var U = k(r, u);
        if (U) {
          ps(n, U, c, p);
          return;
        }
      }
      N && N(r, O, u), r === "focusout" && Ve(O);
    }
    function xt() {
      wt("onMouseEnter", ["mouseout", "mouseover"]), wt("onMouseLeave", ["mouseout", "mouseover"]), wt("onPointerEnter", ["pointerout", "pointerover"]), wt("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function bt(n, r, u, c, p, x, _) {
      var O = r === "mouseover" || r === "pointerover", k = r === "mouseout" || r === "pointerout";
      if (O && !Gf(c)) {
        var N = c.relatedTarget || c.fromElement;
        if (N && (B(N) || I(N)))
          return;
      }
      if (!(!k && !O)) {
        var U;
        if (p.window === p)
          U = p;
        else {
          var oe = p.ownerDocument;
          oe ? U = oe.defaultView || oe.parentWindow : U = window;
        }
        var ae, we;
        if (k) {
          var Ce = c.relatedTarget || c.toElement;
          if (ae = u, we = Ce ? B(Ce) : null, we !== null) {
            var Ee = Ll(we);
            (we !== Ee || we.tag !== A && we.tag !== L) && (we = null);
          }
        } else
          ae = null, we = u;
        if (ae !== we) {
          var it = Ed, Ut = "onMouseLeave", Lt = "onMouseEnter", Dn = "mouse";
          (r === "pointerout" || r === "pointerover") && (it = Sv, Ut = "onPointerLeave", Lt = "onPointerEnter", Dn = "pointer");
          var xn = ae == null ? U : J(ae), pe = we == null ? U : J(we), Me = new it(Ut, Dn + "leave", ae, c, p);
          Me.target = xn, Me.relatedTarget = pe;
          var me = null, We = B(p);
          if (We === u) {
            var pt = new it(Lt, Dn + "enter", we, c, p);
            pt.target = pe, pt.relatedTarget = xn, me = pt;
          }
          O3(n, Me, me, ae, we);
        }
      }
    }
    function Gr(n, r) {
      return n === r && (n !== 0 || 1 / n === 1 / r) || n !== n && r !== r;
    }
    var ce = typeof Object.is == "function" ? Object.is : Gr;
    function ne(n, r) {
      if (ce(n, r))
        return !0;
      if (typeof n != "object" || n === null || typeof r != "object" || r === null)
        return !1;
      var u = Object.keys(n), c = Object.keys(r);
      if (u.length !== c.length)
        return !1;
      for (var p = 0; p < u.length; p++) {
        var x = u[p];
        if (!_n.call(r, x) || !ce(n[x], r[x]))
          return !1;
      }
      return !0;
    }
    function he(n) {
      for (; n && n.firstChild; )
        n = n.firstChild;
      return n;
    }
    function ze(n) {
      for (; n; ) {
        if (n.nextSibling)
          return n.nextSibling;
        n = n.parentNode;
      }
    }
    function Tt(n, r) {
      for (var u = he(n), c = 0, p = 0; u; ) {
        if (u.nodeType === Al) {
          if (p = c + u.textContent.length, c <= r && p >= r)
            return {
              node: u,
              offset: r - c
            };
          c = p;
        }
        u = he(ze(u));
      }
    }
    function Bt(n) {
      var r = n.ownerDocument, u = r && r.defaultView || window, c = u.getSelection && u.getSelection();
      if (!c || c.rangeCount === 0)
        return null;
      var p = c.anchorNode, x = c.anchorOffset, _ = c.focusNode, O = c.focusOffset;
      return Ht(n, p, x, _, O);
    }
    function Ht(n, r, u, c, p) {
      var x = 0, _ = -1, O = -1, k = 0, N = 0, U = n, oe = null;
      e: for (; ; ) {
        for (var ae = null; U === r && (u === 0 || U.nodeType === Al) && (_ = x + u), U === c && (p === 0 || U.nodeType === Al) && (O = x + p), U.nodeType === Al && (x += U.nodeValue.length), (ae = U.firstChild) !== null; )
          oe = U, U = ae;
        for (; ; ) {
          if (U === n)
            break e;
          if (oe === r && ++k === u && (_ = x), oe === c && ++N === p && (O = x), (ae = U.nextSibling) !== null)
            break;
          U = oe, oe = U.parentNode;
        }
        U = ae;
      }
      return _ === -1 || O === -1 ? null : {
        start: _,
        end: O
      };
    }
    function qt(n, r) {
      var u = n.ownerDocument || document, c = u && u.defaultView || window;
      if (c.getSelection) {
        var p = c.getSelection(), x = n.textContent.length, _ = Math.min(r.start, x), O = r.end === void 0 ? _ : Math.min(r.end, x);
        if (!p.extend && _ > O) {
          var k = O;
          O = _, _ = k;
        }
        var N = Tt(n, _), U = Tt(n, O);
        if (N && U) {
          if (p.rangeCount === 1 && p.anchorNode === N.node && p.anchorOffset === N.offset && p.focusNode === U.node && p.focusOffset === U.offset)
            return;
          var oe = u.createRange();
          oe.setStart(N.node, N.offset), p.removeAllRanges(), _ > O ? (p.addRange(oe), p.extend(U.node, U.offset)) : (oe.setEnd(U.node, U.offset), p.addRange(oe));
        }
      }
    }
    function ga(n) {
      return n && n.nodeType === Al;
    }
    function Tn(n, r) {
      return !n || !r ? !1 : n === r ? !0 : ga(n) ? !1 : ga(r) ? Tn(n, r.parentNode) : "contains" in n ? n.contains(r) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(r) & 16) : !1;
    }
    function ms(n) {
      return n && n.ownerDocument && Tn(n.ownerDocument.documentElement, n);
    }
    function dm(n) {
      try {
        return typeof n.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function x3() {
      for (var n = window, r = Hn(); r instanceof n.HTMLIFrameElement; ) {
        if (dm(r))
          n = r.contentWindow;
        else
          return r;
        r = Hn(n.document);
      }
      return r;
    }
    function hm(n) {
      var r = n && n.nodeName && n.nodeName.toLowerCase();
      return r && (r === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || r === "textarea" || n.contentEditable === "true");
    }
    function Pw() {
      var n = x3();
      return {
        focusedElem: n,
        selectionRange: hm(n) ? Nw(n) : null
      };
    }
    function Vw(n) {
      var r = x3(), u = n.focusedElem, c = n.selectionRange;
      if (r !== u && ms(u)) {
        c !== null && hm(u) && Bw(u, c);
        for (var p = [], x = u; x = x.parentNode; )
          x.nodeType === Na && p.push({
            element: x,
            left: x.scrollLeft,
            top: x.scrollTop
          });
        typeof u.focus == "function" && u.focus();
        for (var _ = 0; _ < p.length; _++) {
          var O = p[_];
          O.element.scrollLeft = O.left, O.element.scrollTop = O.top;
        }
      }
    }
    function Nw(n) {
      var r;
      return "selectionStart" in n ? r = {
        start: n.selectionStart,
        end: n.selectionEnd
      } : r = Bt(n), r || {
        start: 0,
        end: 0
      };
    }
    function Bw(n, r) {
      var u = r.start, c = r.end;
      c === void 0 && (c = u), "selectionStart" in n ? (n.selectionStart = u, n.selectionEnd = Math.min(c, n.value.length)) : qt(n, r);
    }
    var Fw = St && "documentMode" in document && document.documentMode <= 11;
    function Uw() {
      et("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Bo = null, vm = null, a2 = null, u1 = !1;
    function un(n) {
      if ("selectionStart" in n && hm(n))
        return {
          start: n.selectionStart,
          end: n.selectionEnd
        };
      var r = n.ownerDocument && n.ownerDocument.defaultView || window, u = r.getSelection();
      return {
        anchorNode: u.anchorNode,
        anchorOffset: u.anchorOffset,
        focusNode: u.focusNode,
        focusOffset: u.focusOffset
      };
    }
    function Yw(n) {
      return n.window === n ? n.document : n.nodeType === Ki ? n : n.ownerDocument;
    }
    function si(n, r, u) {
      var c = Yw(u);
      if (!(u1 || Bo == null || Bo !== Hn(c))) {
        var p = un(Bo);
        if (!a2 || !ne(a2, p)) {
          a2 = p;
          var x = Av(vm, "onSelect");
          if (x.length > 0) {
            var _ = new g0("onSelect", "select", null, r, u);
            n.push({
              event: _,
              listeners: x
            }), _.target = Bo;
          }
        }
      }
    }
    function wa(n, r, u, c, p, x, _) {
      var O = u ? J(u) : window;
      switch (r) {
        case "focusin":
          (Uc(O) || O.contentEditable === "true") && (Bo = O, vm = u, a2 = null);
          break;
        case "focusout":
          Bo = null, vm = null, a2 = null;
          break;
        case "mousedown":
          u1 = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          u1 = !1, si(n, c, p);
          break;
        case "selectionchange":
          if (Fw)
            break;
        case "keydown":
        case "keyup":
          si(n, c, p);
      }
    }
    function Ov(n, r) {
      var u = {};
      return u[n.toLowerCase()] = r.toLowerCase(), u["Webkit" + n] = "webkit" + r, u["Moz" + n] = "moz" + r, u;
    }
    var ml = {
      animationend: Ov("Animation", "AnimationEnd"),
      animationiteration: Ov("Animation", "AnimationIteration"),
      animationstart: Ov("Animation", "AnimationStart"),
      transitionend: Ov("Transition", "TransitionEnd")
    }, pm = {}, S3 = {};
    St && (S3 = document.createElement("div").style, "AnimationEvent" in window || (delete ml.animationend.animation, delete ml.animationiteration.animation, delete ml.animationstart.animation), "TransitionEvent" in window || delete ml.transitionend.transition);
    function Dv(n) {
      if (pm[n])
        return pm[n];
      if (!ml[n])
        return n;
      var r = ml[n];
      for (var u in r)
        if (r.hasOwnProperty(u) && u in S3)
          return pm[n] = r[u];
      return n;
    }
    var C3 = Dv("animationend"), b3 = Dv("animationiteration"), jv = Dv("animationstart"), _3 = Dv("transitionend"), gs = /* @__PURE__ */ new Map(), mm = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Ou(n, r) {
      gs.set(n, r), et(r, [n]);
    }
    function Kr() {
      for (var n = 0; n < mm.length; n++) {
        var r = mm[n], u = r.toLowerCase(), c = r[0].toUpperCase() + r.slice(1);
        Ou(u, "on" + c);
      }
      Ou(C3, "onAnimationEnd"), Ou(b3, "onAnimationIteration"), Ou(jv, "onAnimationStart"), Ou("dblclick", "onDoubleClick"), Ou("focusin", "onFocus"), Ou("focusout", "onBlur"), Ou(_3, "onTransitionEnd");
    }
    function ca(n, r, u, c, p, x, _) {
      var O = gs.get(r);
      if (O !== void 0) {
        var k = g0, N = r;
        switch (r) {
          case "keypress":
            if (r1(c) === 0)
              return;
          case "keydown":
          case "keyup":
            k = Od;
            break;
          case "focusin":
            N = "focus", k = Zc;
            break;
          case "focusout":
            N = "blur", k = Zc;
            break;
          case "beforeblur":
          case "afterblur":
            k = Zc;
            break;
          case "click":
            if (c.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k = Ed;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k = hs;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k = om;
            break;
          case C3:
          case b3:
          case jv:
            k = Kh;
            break;
          case _3:
            k = bv;
            break;
          case "scroll":
            k = xo;
            break;
          case "wheel":
            k = lm;
            break;
          case "copy":
          case "cut":
          case "paste":
            k = gv;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k = Sv;
            break;
        }
        var U = (x & Ko) !== 0;
        {
          var oe = !U && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          r === "scroll", ae = zw(u, O, c.type, U, oe);
          if (ae.length > 0) {
            var we = new k(O, N, null, c, p);
            n.push({
              event: we,
              listeners: ae
            });
          }
        }
      }
    }
    Kr(), xt(), cm(), Uw(), Jh();
    function R3(n, r, u, c, p, x, _) {
      ca(n, r, u, c, p, x);
      var O = (x & lc) === 0;
      O && (bt(n, r, u, c, p), lt(n, r, u, c, p), wa(n, r, u, c, p), Fc(n, r, u, c, p));
    }
    var o2 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], gm = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(o2));
    function E3(n, r, u) {
      var c = n.type || "unknown-event";
      n.currentTarget = u, zu(c, r, void 0, n), n.currentTarget = null;
    }
    function $w(n, r, u) {
      var c;
      if (u)
        for (var p = r.length - 1; p >= 0; p--) {
          var x = r[p], _ = x.instance, O = x.currentTarget, k = x.listener;
          if (_ !== c && n.isPropagationStopped())
            return;
          E3(n, k, O), c = _;
        }
      else
        for (var N = 0; N < r.length; N++) {
          var U = r[N], oe = U.instance, ae = U.currentTarget, we = U.listener;
          if (oe !== c && n.isPropagationStopped())
            return;
          E3(n, we, ae), c = oe;
        }
    }
    function M3(n, r) {
      for (var u = (r & Ko) !== 0, c = 0; c < n.length; c++) {
        var p = n[c], x = p.event, _ = p.listeners;
        $w(x, _, u);
      }
      cv();
    }
    function Ww(n, r, u, c, p) {
      var x = F1(u), _ = [];
      R3(_, n, c, u, x, r), M3(_, r);
    }
    function Dr(n, r) {
      gm.has(n) || m('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', n);
      var u = !1, c = Ie(r), p = s1(n);
      c.has(p) || (wm(r, n, Ns, u), c.add(p));
    }
    function $c(n, r, u) {
      gm.has(n) && !r && m('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', n);
      var c = 0;
      r && (c |= Ko), wm(u, n, c, r);
    }
    var Ld = "_reactListening" + Math.random().toString(36).slice(2);
    function i2(n) {
      if (!n[Ld]) {
        n[Ld] = !0, Vt.forEach(function(u) {
          u !== "selectionchange" && (gm.has(u) || $c(u, !1, n), $c(u, !0, n));
        });
        var r = n.nodeType === Ki ? n : n.ownerDocument;
        r !== null && (r[Ld] || (r[Ld] = !0, $c("selectionchange", !1, r)));
      }
    }
    function wm(n, r, u, c, p) {
      var x = Mn(n, r, u), _ = void 0;
      Qf && (r === "touchstart" || r === "touchmove" || r === "wheel") && (_ = !0), n = n, c ? _ !== void 0 ? Cd(n, r, x, _) : Lc(n, r, x) : _ !== void 0 ? Ic(n, r, x, _) : fs(n, r, x);
    }
    function l2(n, r) {
      return n === r || n.nodeType === aa && n.parentNode === r;
    }
    function ci(n, r, u, c, p) {
      var x = c;
      if (!(r & Hh) && !(r & Ns)) {
        var _ = p;
        if (c !== null) {
          var O = c;
          e: for (; ; ) {
            if (O === null)
              return;
            var k = O.tag;
            if (k === T || k === j) {
              var N = O.stateNode.containerInfo;
              if (l2(N, _))
                break;
              if (k === j)
                for (var U = O.return; U !== null; ) {
                  var oe = U.tag;
                  if (oe === T || oe === j) {
                    var ae = U.stateNode.containerInfo;
                    if (l2(ae, _))
                      return;
                  }
                  U = U.return;
                }
              for (; N !== null; ) {
                var we = B(N);
                if (we === null)
                  return;
                var Ce = we.tag;
                if (Ce === A || Ce === L) {
                  O = x = we;
                  continue e;
                }
                N = N.parentNode;
              }
            }
            O = O.return;
          }
        }
      }
      cc(function() {
        return Ww(n, r, u, x);
      });
    }
    function ws(n, r, u) {
      return {
        instance: n,
        listener: r,
        currentTarget: u
      };
    }
    function zw(n, r, u, c, p, x) {
      for (var _ = r !== null ? r + "Capture" : null, O = c ? _ : r, k = [], N = n, U = null; N !== null; ) {
        var oe = N, ae = oe.stateNode, we = oe.tag;
        if (we === A && ae !== null && (U = ae, O !== null)) {
          var Ce = fc(N, O);
          Ce != null && k.push(ws(N, Ce, U));
        }
        if (p)
          break;
        N = N.return;
      }
      return k;
    }
    function Av(n, r) {
      for (var u = r + "Capture", c = [], p = n; p !== null; ) {
        var x = p, _ = x.stateNode, O = x.tag;
        if (O === A && _ !== null) {
          var k = _, N = fc(p, u);
          N != null && c.unshift(ws(p, N, k));
          var U = fc(p, r);
          U != null && c.push(ws(p, U, k));
        }
        p = p.return;
      }
      return c;
    }
    function Id(n) {
      if (n === null)
        return null;
      do
        n = n.return;
      while (n && n.tag !== A);
      return n || null;
    }
    function qw(n, r) {
      for (var u = n, c = r, p = 0, x = u; x; x = Id(x))
        p++;
      for (var _ = 0, O = c; O; O = Id(O))
        _++;
      for (; p - _ > 0; )
        u = Id(u), p--;
      for (; _ - p > 0; )
        c = Id(c), _--;
      for (var k = p; k--; ) {
        if (u === c || c !== null && u === c.alternate)
          return u;
        u = Id(u), c = Id(c);
      }
      return null;
    }
    function T3(n, r, u, c, p) {
      for (var x = r._reactName, _ = [], O = u; O !== null && O !== c; ) {
        var k = O, N = k.alternate, U = k.stateNode, oe = k.tag;
        if (N !== null && N === c)
          break;
        if (oe === A && U !== null) {
          var ae = U;
          if (p) {
            var we = fc(O, x);
            we != null && _.unshift(ws(O, we, ae));
          } else if (!p) {
            var Ce = fc(O, x);
            Ce != null && _.push(ws(O, Ce, ae));
          }
        }
        O = O.return;
      }
      _.length !== 0 && n.push({
        event: r,
        listeners: _
      });
    }
    function O3(n, r, u, c, p) {
      var x = c && p ? qw(c, p) : null;
      c !== null && T3(n, r, c, x, !1), p !== null && u !== null && T3(n, u, p, x, !0);
    }
    function s1(n, r) {
      return n + "__bubble";
    }
    var Ft = !1, Hd = "dangerouslySetInnerHTML", fi = "suppressContentEditableWarning", c1 = "suppressHydrationWarning", D3 = "autoFocus", Cn = "children", Wc = "style", u2 = "__html", Zd, kv, s2, j3, Lv, A3, k3;
    Zd = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, kv = function(n, r) {
      su(n, r), kl(n, r), uv(n, r, {
        registrationNameDependencies: Dt,
        possibleRegistrationNames: Qe
      });
    }, A3 = St && !document.documentMode, s2 = function(n, r, u) {
      if (!Ft) {
        var c = Iv(u), p = Iv(r);
        p !== c && (Ft = !0, m("Prop `%s` did not match. Server: %s Client: %s", n, JSON.stringify(p), JSON.stringify(c)));
      }
    }, j3 = function(n) {
      if (!Ft) {
        Ft = !0;
        var r = [];
        n.forEach(function(u) {
          r.push(u);
        }), m("Extra attributes from the server: %s", r);
      }
    }, Lv = function(n, r) {
      r === !1 ? m("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", n, n, n) : m("Expected `%s` listener to be a function, instead got a value of `%s` type.", n, typeof r);
    }, k3 = function(n, r) {
      var u = n.namespaceURI === lu ? n.ownerDocument.createElement(n.tagName) : n.ownerDocument.createElementNS(n.namespaceURI, n.tagName);
      return u.innerHTML = r, u.innerHTML;
    };
    var Gw = /\r\n?/g, Kw = /\u0000|\uFFFD/g;
    function Iv(n) {
      ft(n);
      var r = typeof n == "string" ? n : "" + n;
      return r.replace(Gw, `
`).replace(Kw, "");
    }
    function Hv(n, r, u, c) {
      var p = Iv(r), x = Iv(n);
      if (x !== p && (c && (Ft || (Ft = !0, m('Text content did not match. Server: "%s" Client: "%s"', x, p))), u && Ue))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function L3(n) {
      return n.nodeType === Ki ? n : n.ownerDocument;
    }
    function Qw() {
    }
    function Zv(n) {
      n.onclick = Qw;
    }
    function ym(n, r, u, c, p) {
      for (var x in c)
        if (c.hasOwnProperty(x)) {
          var _ = c[x];
          if (x === Wc)
            _ && Object.freeze(_), Ih(r, _);
          else if (x === Hd) {
            var O = _ ? _[u2] : void 0;
            O != null && Vf(r, O);
          } else if (x === Cn)
            if (typeof _ == "string") {
              var k = n !== "textarea" || _ !== "";
              k && Nf(r, _);
            } else typeof _ == "number" && Nf(r, "" + _);
          else x === fi || x === c1 || x === D3 || (Dt.hasOwnProperty(x) ? _ != null && (typeof _ != "function" && Lv(x, _), x === "onScroll" && Dr("scroll", r)) : _ != null && Zu(r, x, _, p));
        }
    }
    function Xw(n, r, u, c) {
      for (var p = 0; p < r.length; p += 2) {
        var x = r[p], _ = r[p + 1];
        x === Wc ? Ih(n, _) : x === Hd ? Vf(n, _) : x === Cn ? Nf(n, _) : Zu(n, x, _, c);
      }
    }
    function xm(n, r, u, c) {
      var p, x = L3(u), _, O = c;
      if (O === lu && (O = Uu(n)), O === lu) {
        if (p = Je(n, r), !p && n !== n.toLowerCase() && m("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", n), n === "script") {
          var k = x.createElement("div");
          k.innerHTML = "<script><\/script>";
          var N = k.firstChild;
          _ = k.removeChild(N);
        } else if (typeof r.is == "string")
          _ = x.createElement(n, {
            is: r.is
          });
        else if (_ = x.createElement(n), n === "select") {
          var U = _;
          r.multiple ? U.multiple = !0 : r.size && (U.size = r.size);
        }
      } else
        _ = x.createElementNS(O, n);
      return O === lu && !p && Object.prototype.toString.call(_) === "[object HTMLUnknownElement]" && !_n.call(Zd, n) && (Zd[n] = !0, m("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", n)), _;
    }
    function Jw(n, r) {
      return L3(r).createTextNode(n);
    }
    function e6(n, r, u, c) {
      var p = Je(r, u);
      kv(r, u);
      var x;
      switch (r) {
        case "dialog":
          Dr("cancel", n), Dr("close", n), x = u;
          break;
        case "iframe":
        case "object":
        case "embed":
          Dr("load", n), x = u;
          break;
        case "video":
        case "audio":
          for (var _ = 0; _ < o2.length; _++)
            Dr(o2[_], n);
          x = u;
          break;
        case "source":
          Dr("error", n), x = u;
          break;
        case "img":
        case "image":
        case "link":
          Dr("error", n), Dr("load", n), x = u;
          break;
        case "details":
          Dr("toggle", n), x = u;
          break;
        case "input":
          G0(n, u), x = q0(n, u), Dr("invalid", n);
          break;
        case "option":
          po(n, u), x = u;
          break;
        case "select":
          ou(n, u), x = J0(n, u), Dr("invalid", n);
          break;
        case "textarea":
          G2(n, u), x = ec(n, u), Dr("invalid", n);
          break;
        default:
          x = u;
      }
      switch (ge(r, x), ym(r, n, c, x, p), r) {
        case "input":
          W0(n), Sr(n, u, !1);
          break;
        case "textarea":
          W0(n), K2(n);
          break;
        case "option":
          Zs(n, u);
          break;
        case "select":
          Zf(n, u);
          break;
        default:
          typeof x.onClick == "function" && Zv(n);
          break;
      }
    }
    function t6(n, r, u, c, p) {
      kv(r, c);
      var x = null, _, O;
      switch (r) {
        case "input":
          _ = q0(n, u), O = q0(n, c), x = [];
          break;
        case "select":
          _ = J0(n, u), O = J0(n, c), x = [];
          break;
        case "textarea":
          _ = ec(n, u), O = ec(n, c), x = [];
          break;
        default:
          _ = u, O = c, typeof _.onClick != "function" && typeof O.onClick == "function" && Zv(n);
          break;
      }
      ge(r, O);
      var k, N, U = null;
      for (k in _)
        if (!(O.hasOwnProperty(k) || !_.hasOwnProperty(k) || _[k] == null))
          if (k === Wc) {
            var oe = _[k];
            for (N in oe)
              oe.hasOwnProperty(N) && (U || (U = {}), U[N] = "");
          } else k === Hd || k === Cn || k === fi || k === c1 || k === D3 || (Dt.hasOwnProperty(k) ? x || (x = []) : (x = x || []).push(k, null));
      for (k in O) {
        var ae = O[k], we = _ != null ? _[k] : void 0;
        if (!(!O.hasOwnProperty(k) || ae === we || ae == null && we == null))
          if (k === Wc)
            if (ae && Object.freeze(ae), we) {
              for (N in we)
                we.hasOwnProperty(N) && (!ae || !ae.hasOwnProperty(N)) && (U || (U = {}), U[N] = "");
              for (N in ae)
                ae.hasOwnProperty(N) && we[N] !== ae[N] && (U || (U = {}), U[N] = ae[N]);
            } else
              U || (x || (x = []), x.push(k, U)), U = ae;
          else if (k === Hd) {
            var Ce = ae ? ae[u2] : void 0, Ee = we ? we[u2] : void 0;
            Ce != null && Ee !== Ce && (x = x || []).push(k, Ce);
          } else k === Cn ? (typeof ae == "string" || typeof ae == "number") && (x = x || []).push(k, "" + ae) : k === fi || k === c1 || (Dt.hasOwnProperty(k) ? (ae != null && (typeof ae != "function" && Lv(k, ae), k === "onScroll" && Dr("scroll", n)), !x && we !== ae && (x = [])) : (x = x || []).push(k, ae));
      }
      return U && (Gp(U, O[Wc]), (x = x || []).push(Wc, U)), x;
    }
    function uo(n, r, u, c, p) {
      u === "input" && p.type === "radio" && p.name != null && K0(n, p);
      var x = Je(u, c), _ = Je(u, p);
      switch (Xw(n, r, x, _), u) {
        case "input":
          Af(n, p);
          break;
        case "textarea":
          Pf(n, p);
          break;
        case "select":
          Ah(n, p);
          break;
      }
    }
    function Ni(n) {
      {
        var r = n.toLowerCase();
        return Wt.hasOwnProperty(r) && Wt[r] || null;
      }
    }
    function n6(n, r, u, c, p, x, _) {
      var O, k;
      switch (O = Je(r, u), kv(r, u), r) {
        case "dialog":
          Dr("cancel", n), Dr("close", n);
          break;
        case "iframe":
        case "object":
        case "embed":
          Dr("load", n);
          break;
        case "video":
        case "audio":
          for (var N = 0; N < o2.length; N++)
            Dr(o2[N], n);
          break;
        case "source":
          Dr("error", n);
          break;
        case "img":
        case "image":
        case "link":
          Dr("error", n), Dr("load", n);
          break;
        case "details":
          Dr("toggle", n);
          break;
        case "input":
          G0(n, u), Dr("invalid", n);
          break;
        case "option":
          po(n, u);
          break;
        case "select":
          ou(n, u), Dr("invalid", n);
          break;
        case "textarea":
          G2(n, u), Dr("invalid", n);
          break;
      }
      ge(r, u);
      {
        k = /* @__PURE__ */ new Set();
        for (var U = n.attributes, oe = 0; oe < U.length; oe++) {
          var ae = U[oe].name.toLowerCase();
          switch (ae) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              k.add(U[oe].name);
          }
        }
      }
      var we = null;
      for (var Ce in u)
        if (u.hasOwnProperty(Ce)) {
          var Ee = u[Ce];
          if (Ce === Cn)
            typeof Ee == "string" ? n.textContent !== Ee && (u[c1] !== !0 && Hv(n.textContent, Ee, x, _), we = [Cn, Ee]) : typeof Ee == "number" && n.textContent !== "" + Ee && (u[c1] !== !0 && Hv(n.textContent, Ee, x, _), we = [Cn, "" + Ee]);
          else if (Dt.hasOwnProperty(Ce))
            Ee != null && (typeof Ee != "function" && Lv(Ce, Ee), Ce === "onScroll" && Dr("scroll", n));
          else if (_ && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof O == "boolean") {
            var it = void 0, Ut = Ao(Ce);
            if (u[c1] !== !0) {
              if (!(Ce === fi || Ce === c1 || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Ce === "value" || Ce === "checked" || Ce === "selected")) {
                if (Ce === Hd) {
                  var Lt = n.innerHTML, Dn = Ee ? Ee[u2] : void 0;
                  if (Dn != null) {
                    var xn = k3(n, Dn);
                    xn !== Lt && s2(Ce, Lt, xn);
                  }
                } else if (Ce === Wc) {
                  if (k.delete(Ce), A3) {
                    var pe = ov(Ee);
                    it = n.getAttribute("style"), pe !== it && s2(Ce, it, pe);
                  }
                } else if (O)
                  k.delete(Ce.toLowerCase()), it = D1(n, Ce, Ee), Ee !== it && s2(Ce, it, Ee);
                else if (!cr(Ce, Ut, O) && !xr(Ce, Ee, Ut, O)) {
                  var Me = !1;
                  if (Ut !== null)
                    k.delete(Ut.attributeName), it = bf(n, Ce, Ee, Ut);
                  else {
                    var me = c;
                    if (me === lu && (me = Uu(r)), me === lu)
                      k.delete(Ce.toLowerCase());
                    else {
                      var We = Ni(Ce);
                      We !== null && We !== Ce && (Me = !0, k.delete(We)), k.delete(Ce);
                    }
                    it = D1(n, Ce, Ee);
                  }
                  var pt = mt;
                  !pt && Ee !== it && !Me && s2(Ce, it, Ee);
                }
              }
            }
          }
        }
      switch (_ && // $FlowFixMe - Should be inferred as not undefined.
      k.size > 0 && u[c1] !== !0 && j3(k), r) {
        case "input":
          W0(n), Sr(n, u, !0);
          break;
        case "textarea":
          W0(n), K2(n);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof u.onClick == "function" && Zv(n);
          break;
      }
      return we;
    }
    function r6(n, r, u) {
      var c = n.nodeValue !== r;
      return c;
    }
    function Sm(n, r) {
      {
        if (Ft)
          return;
        Ft = !0, m("Did not expect server HTML to contain a <%s> in <%s>.", r.nodeName.toLowerCase(), n.nodeName.toLowerCase());
      }
    }
    function Pv(n, r) {
      {
        if (Ft)
          return;
        Ft = !0, m('Did not expect server HTML to contain the text node "%s" in <%s>.', r.nodeValue, n.nodeName.toLowerCase());
      }
    }
    function Cm(n, r, u) {
      {
        if (Ft)
          return;
        Ft = !0, m("Expected server HTML to contain a matching <%s> in <%s>.", r, n.nodeName.toLowerCase());
      }
    }
    function bm(n, r) {
      {
        if (r === "" || Ft)
          return;
        Ft = !0, m('Expected server HTML to contain a matching text node for "%s" in <%s>.', r, n.nodeName.toLowerCase());
      }
    }
    function a6(n, r, u) {
      switch (r) {
        case "input":
          Q0(n, u);
          return;
        case "textarea":
          Q2(n, u);
          return;
        case "select":
          hr(n, u);
          return;
      }
    }
    var Pd = function() {
    }, c2 = function() {
    };
    {
      var o6 = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], I3 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], H3 = I3.concat(["button"]), Z3 = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], P3 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      c2 = function(n, r) {
        var u = Gt({}, n || P3), c = {
          tag: r
        };
        return I3.indexOf(r) !== -1 && (u.aTagInScope = null, u.buttonTagInScope = null, u.nobrTagInScope = null), H3.indexOf(r) !== -1 && (u.pTagInButtonScope = null), o6.indexOf(r) !== -1 && r !== "address" && r !== "div" && r !== "p" && (u.listItemTagAutoclosing = null, u.dlItemTagAutoclosing = null), u.current = c, r === "form" && (u.formTag = c), r === "a" && (u.aTagInScope = c), r === "button" && (u.buttonTagInScope = c), r === "nobr" && (u.nobrTagInScope = c), r === "p" && (u.pTagInButtonScope = c), r === "li" && (u.listItemTagAutoclosing = c), (r === "dd" || r === "dt") && (u.dlItemTagAutoclosing = c), u;
      };
      var i6 = function(n, r) {
        switch (r) {
          case "select":
            return n === "option" || n === "optgroup" || n === "#text";
          case "optgroup":
            return n === "option" || n === "#text";
          case "option":
            return n === "#text";
          case "tr":
            return n === "th" || n === "td" || n === "style" || n === "script" || n === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return n === "tr" || n === "style" || n === "script" || n === "template";
          case "colgroup":
            return n === "col" || n === "template";
          case "table":
            return n === "caption" || n === "colgroup" || n === "tbody" || n === "tfoot" || n === "thead" || n === "style" || n === "script" || n === "template";
          case "head":
            return n === "base" || n === "basefont" || n === "bgsound" || n === "link" || n === "meta" || n === "title" || n === "noscript" || n === "noframes" || n === "style" || n === "script" || n === "template";
          case "html":
            return n === "head" || n === "body" || n === "frameset";
          case "frameset":
            return n === "frame";
          case "#document":
            return n === "html";
        }
        switch (n) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r !== "h1" && r !== "h2" && r !== "h3" && r !== "h4" && r !== "h5" && r !== "h6";
          case "rp":
          case "rt":
            return Z3.indexOf(r) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return r == null;
        }
        return !0;
      }, l6 = function(n, r) {
        switch (n) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r.pTagInButtonScope;
          case "form":
            return r.formTag || r.pTagInButtonScope;
          case "li":
            return r.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return r.dlItemTagAutoclosing;
          case "button":
            return r.buttonTagInScope;
          case "a":
            return r.aTagInScope;
          case "nobr":
            return r.nobrTagInScope;
        }
        return null;
      }, V3 = {};
      Pd = function(n, r, u) {
        u = u || P3;
        var c = u.current, p = c && c.tag;
        r != null && (n != null && m("validateDOMNesting: when childText is passed, childTag should be null"), n = "#text");
        var x = i6(n, p) ? null : c, _ = x ? null : l6(n, u), O = x || _;
        if (O) {
          var k = O.tag, N = !!x + "|" + n + "|" + k;
          if (!V3[N]) {
            V3[N] = !0;
            var U = n, oe = "";
            if (n === "#text" ? /\S/.test(r) ? U = "Text nodes" : (U = "Whitespace text nodes", oe = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : U = "<" + n + ">", x) {
              var ae = "";
              k === "table" && n === "tr" && (ae += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), m("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", U, k, oe, ae);
            } else
              m("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", U, k);
          }
        }
      };
    }
    var f1 = "suppressHydrationWarning", Vv = "$", Nv = "/$", f2 = "$?", d2 = "$!", u6 = "style", Bv = null, Fv = null;
    function s6(n) {
      var r, u, c = n.nodeType;
      switch (c) {
        case Ki:
        case rc: {
          r = c === Ki ? "#document" : "#fragment";
          var p = n.documentElement;
          u = p ? p.namespaceURI : tc(null, "");
          break;
        }
        default: {
          var x = c === aa ? n.parentNode : n, _ = x.namespaceURI || null;
          r = x.tagName, u = tc(_, r);
          break;
        }
      }
      {
        var O = r.toLowerCase(), k = c2(null, O);
        return {
          namespace: u,
          ancestorInfo: k
        };
      }
    }
    function c6(n, r, u) {
      {
        var c = n, p = tc(c.namespace, r), x = c2(c.ancestorInfo, r);
        return {
          namespace: p,
          ancestorInfo: x
        };
      }
    }
    function hS(n) {
      return n;
    }
    function f6(n) {
      Bv = Pi(), Fv = Pw();
      var r = null;
      return Sd(!1), r;
    }
    function d6(n) {
      Vw(Fv), Sd(Bv), Bv = null, Fv = null;
    }
    function h6(n, r, u, c, p) {
      var x;
      {
        var _ = c;
        if (Pd(n, null, _.ancestorInfo), typeof r.children == "string" || typeof r.children == "number") {
          var O = "" + r.children, k = c2(_.ancestorInfo, n);
          Pd(null, O, k);
        }
        x = _.namespace;
      }
      var N = xm(n, r, u, x);
      return d(p, N), De(N, r), N;
    }
    function v6(n, r) {
      n.appendChild(r);
    }
    function p6(n, r, u, c, p) {
      switch (e6(n, r, u, c), r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!u.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function m6(n, r, u, c, p, x) {
      {
        var _ = x;
        if (typeof c.children != typeof u.children && (typeof c.children == "string" || typeof c.children == "number")) {
          var O = "" + c.children, k = c2(_.ancestorInfo, r);
          Pd(null, O, k);
        }
      }
      return t6(n, r, u, c);
    }
    function _m(n, r) {
      return n === "textarea" || n === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
    }
    function g6(n, r, u, c) {
      {
        var p = u;
        Pd(null, n, p.ancestorInfo);
      }
      var x = Jw(n, r);
      return d(c, x), x;
    }
    function w6() {
      var n = window.event;
      return n === void 0 ? oi : m0(n.type);
    }
    var Rm = typeof setTimeout == "function" ? setTimeout : void 0, y6 = typeof clearTimeout == "function" ? clearTimeout : void 0, Em = -1, N3 = typeof Promise == "function" ? Promise : void 0, x6 = typeof queueMicrotask == "function" ? queueMicrotask : typeof N3 < "u" ? function(n) {
      return N3.resolve(null).then(n).catch(S6);
    } : Rm;
    function S6(n) {
      setTimeout(function() {
        throw n;
      });
    }
    function C6(n, r, u, c) {
      switch (r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          u.autoFocus && n.focus();
          return;
        case "img": {
          u.src && (n.src = u.src);
          return;
        }
      }
    }
    function b6(n, r, u, c, p, x) {
      uo(n, r, u, c, p), De(n, p);
    }
    function B3(n) {
      Nf(n, "");
    }
    function _6(n, r, u) {
      n.nodeValue = u;
    }
    function R6(n, r) {
      n.appendChild(r);
    }
    function E6(n, r) {
      var u;
      n.nodeType === aa ? (u = n.parentNode, u.insertBefore(r, n)) : (u = n, u.appendChild(r));
      var c = n._reactRootContainer;
      c == null && u.onclick === null && Zv(u);
    }
    function M6(n, r, u) {
      n.insertBefore(r, u);
    }
    function Mm(n, r, u) {
      n.nodeType === aa ? n.parentNode.insertBefore(r, u) : n.insertBefore(r, u);
    }
    function F3(n, r) {
      n.removeChild(r);
    }
    function U3(n, r) {
      n.nodeType === aa ? n.parentNode.removeChild(r) : n.removeChild(r);
    }
    function Tm(n, r) {
      var u = r, c = 0;
      do {
        var p = u.nextSibling;
        if (n.removeChild(u), p && p.nodeType === aa) {
          var x = p.data;
          if (x === Nv)
            if (c === 0) {
              n.removeChild(p), v0(r);
              return;
            } else
              c--;
          else (x === Vv || x === f2 || x === d2) && c++;
        }
        u = p;
      } while (u);
      v0(r);
    }
    function T6(n, r) {
      n.nodeType === aa ? Tm(n.parentNode, r) : n.nodeType === Na && Tm(n, r), v0(n);
    }
    function O6(n) {
      n = n;
      var r = n.style;
      typeof r.setProperty == "function" ? r.setProperty("display", "none", "important") : r.display = "none";
    }
    function Om(n) {
      n.nodeValue = "";
    }
    function D6(n, r) {
      n = n;
      var u = r[u6], c = u != null && u.hasOwnProperty("display") ? u.display : null;
      n.style.display = Bf("display", c);
    }
    function j6(n, r) {
      n.nodeValue = r;
    }
    function A6(n) {
      n.nodeType === Na ? n.textContent = "" : n.nodeType === Ki && n.documentElement && n.removeChild(n.documentElement);
    }
    function Bi(n, r, u) {
      return n.nodeType !== Na || r.toLowerCase() !== n.nodeName.toLowerCase() ? null : n;
    }
    function Dm(n, r) {
      return r === "" || n.nodeType !== Al ? null : n;
    }
    function k6(n) {
      return n.nodeType !== aa ? null : n;
    }
    function Y3(n) {
      return n.data === f2;
    }
    function jm(n) {
      return n.data === d2;
    }
    function L6(n) {
      var r = n.nextSibling && n.nextSibling.dataset, u, c, p;
      return r && (u = r.dgst, c = r.msg, p = r.stck), {
        message: c,
        digest: u,
        stack: p
      };
    }
    function Am(n, r) {
      n._reactRetry = r;
    }
    function Uv(n) {
      for (; n != null; n = n.nextSibling) {
        var r = n.nodeType;
        if (r === Na || r === Al)
          break;
        if (r === aa) {
          var u = n.data;
          if (u === Vv || u === d2 || u === f2)
            break;
          if (u === Nv)
            return null;
        }
      }
      return n;
    }
    function zc(n) {
      return Uv(n.nextSibling);
    }
    function I6(n) {
      return Uv(n.firstChild);
    }
    function H6(n) {
      return Uv(n.firstChild);
    }
    function Z6(n) {
      return Uv(n.nextSibling);
    }
    function P6(n, r, u, c, p, x, _) {
      d(x, n), De(n, u);
      var O;
      {
        var k = p;
        O = k.namespace;
      }
      var N = (x.mode & on) !== tt;
      return n6(n, r, u, O, c, N, _);
    }
    function $3(n, r, u, c) {
      return d(u, n), r6(n, r);
    }
    function V6(n, r) {
      d(r, n);
    }
    function N6(n) {
      for (var r = n.nextSibling, u = 0; r; ) {
        if (r.nodeType === aa) {
          var c = r.data;
          if (c === Nv) {
            if (u === 0)
              return zc(r);
            u--;
          } else (c === Vv || c === d2 || c === f2) && u++;
        }
        r = r.nextSibling;
      }
      return null;
    }
    function W3(n) {
      for (var r = n.previousSibling, u = 0; r; ) {
        if (r.nodeType === aa) {
          var c = r.data;
          if (c === Vv || c === d2 || c === f2) {
            if (u === 0)
              return r;
            u--;
          } else c === Nv && u++;
        }
        r = r.previousSibling;
      }
      return null;
    }
    function km(n) {
      v0(n);
    }
    function Lm(n) {
      v0(n);
    }
    function B6(n) {
      return n !== "head" && n !== "body";
    }
    function F6(n, r, u, c) {
      var p = !0;
      Hv(r.nodeValue, u, c, p);
    }
    function U6(n, r, u, c, p, x) {
      if (r[f1] !== !0) {
        var _ = !0;
        Hv(c.nodeValue, p, x, _);
      }
    }
    function Y6(n, r) {
      r.nodeType === Na ? Sm(n, r) : r.nodeType === aa || Pv(n, r);
    }
    function $6(n, r) {
      {
        var u = n.parentNode;
        u !== null && (r.nodeType === Na ? Sm(u, r) : r.nodeType === aa || Pv(u, r));
      }
    }
    function W6(n, r, u, c, p) {
      (p || r[f1] !== !0) && (c.nodeType === Na ? Sm(u, c) : c.nodeType === aa || Pv(u, c));
    }
    function z6(n, r, u) {
      Cm(n, r);
    }
    function q6(n, r) {
      bm(n, r);
    }
    function G6(n, r, u) {
      {
        var c = n.parentNode;
        c !== null && Cm(c, r);
      }
    }
    function K6(n, r) {
      {
        var u = n.parentNode;
        u !== null && bm(u, r);
      }
    }
    function Q6(n, r, u, c, p, x) {
      (x || r[f1] !== !0) && Cm(u, c);
    }
    function X6(n, r, u, c, p) {
      (p || r[f1] !== !0) && bm(u, c);
    }
    function J6(n) {
      m("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", n.nodeName.toLowerCase());
    }
    function e7(n) {
      i2(n);
    }
    var Vd = Math.random().toString(36).slice(2), Nd = "__reactFiber$" + Vd, Im = "__reactProps$" + Vd, h2 = "__reactContainer$" + Vd, Hm = "__reactEvents$" + Vd, t7 = "__reactListeners$" + Vd, n7 = "__reactHandles$" + Vd;
    function s(n) {
      delete n[Nd], delete n[Im], delete n[Hm], delete n[t7], delete n[n7];
    }
    function d(n, r) {
      r[Nd] = n;
    }
    function y(n, r) {
      r[h2] = n;
    }
    function M(n) {
      n[h2] = null;
    }
    function I(n) {
      return !!n[h2];
    }
    function B(n) {
      var r = n[Nd];
      if (r)
        return r;
      for (var u = n.parentNode; u; ) {
        if (r = u[h2] || u[Nd], r) {
          var c = r.alternate;
          if (r.child !== null || c !== null && c.child !== null)
            for (var p = W3(n); p !== null; ) {
              var x = p[Nd];
              if (x)
                return x;
              p = W3(p);
            }
          return r;
        }
        n = u, u = n.parentNode;
      }
      return null;
    }
    function q(n) {
      var r = n[Nd] || n[h2];
      return r && (r.tag === A || r.tag === L || r.tag === $ || r.tag === T) ? r : null;
    }
    function J(n) {
      if (n.tag === A || n.tag === L)
        return n.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function se(n) {
      return n[Im] || null;
    }
    function De(n, r) {
      n[Im] = r;
    }
    function Ie(n) {
      var r = n[Hm];
      return r === void 0 && (r = n[Hm] = /* @__PURE__ */ new Set()), r;
    }
    var Be = {}, ot = a.ReactDebugCurrentFrame;
    function Ot(n) {
      if (n) {
        var r = k1(n.type);
        ot.setExtraStackFrame(r);
      } else
        ot.setExtraStackFrame(null);
    }
    function kt(n, r, u, c, p) {
      {
        var x = Function.call.bind(_n);
        for (var _ in n)
          if (x(n, _)) {
            var O = void 0;
            try {
              if (typeof n[_] != "function") {
                var k = Error((c || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw k.name = "Invariant Violation", k;
              }
              O = n[_](r, _, c, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (N) {
              O = N;
            }
            O && !(O instanceof Error) && (Ot(p), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", u, _, typeof O), Ot(null)), O instanceof Error && !(O.message in Be) && (Be[O.message] = !0, Ot(p), m("Failed %s type: %s", u, O.message), Ot(null));
          }
      }
    }
    var sn = [], Yt;
    Yt = [];
    var rn = -1;
    function cn(n) {
      return {
        current: n
      };
    }
    function mr(n, r) {
      if (rn < 0) {
        m("Unexpected pop.");
        return;
      }
      r !== Yt[rn] && m("Unexpected Fiber popped."), n.current = sn[rn], sn[rn] = null, Yt[rn] = null, rn--;
    }
    function ar(n, r, u) {
      rn++, sn[rn] = n.current, Yt[rn] = u, n.current = r;
    }
    var di;
    di = {};
    var $n = {};
    Object.freeze($n);
    var Ga = cn($n), so = cn(!1), Yv = $n;
    function $v(n, r, u) {
      return u && x0(r) ? Yv : Ga.current;
    }
    function vS(n, r, u) {
      {
        var c = n.stateNode;
        c.__reactInternalMemoizedUnmaskedChildContext = r, c.__reactInternalMemoizedMaskedChildContext = u;
      }
    }
    function Wv(n, r) {
      {
        var u = n.type, c = u.contextTypes;
        if (!c)
          return $n;
        var p = n.stateNode;
        if (p && p.__reactInternalMemoizedUnmaskedChildContext === r)
          return p.__reactInternalMemoizedMaskedChildContext;
        var x = {};
        for (var _ in c)
          x[_] = r[_];
        {
          var O = en(n) || "Unknown";
          kt(c, x, "context", O);
        }
        return p && vS(n, r, x), x;
      }
    }
    function z3() {
      return so.current;
    }
    function x0(n) {
      {
        var r = n.childContextTypes;
        return r != null;
      }
    }
    function q3(n) {
      mr(so, n), mr(Ga, n);
    }
    function r7(n) {
      mr(so, n), mr(Ga, n);
    }
    function pS(n, r, u) {
      {
        if (Ga.current !== $n)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        ar(Ga, r, n), ar(so, u, n);
      }
    }
    function mS(n, r, u) {
      {
        var c = n.stateNode, p = r.childContextTypes;
        if (typeof c.getChildContext != "function") {
          {
            var x = en(n) || "Unknown";
            di[x] || (di[x] = !0, m("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", x, x));
          }
          return u;
        }
        var _ = c.getChildContext();
        for (var O in _)
          if (!(O in p))
            throw new Error((en(n) || "Unknown") + '.getChildContext(): key "' + O + '" is not defined in childContextTypes.');
        {
          var k = en(n) || "Unknown";
          kt(p, _, "child context", k);
        }
        return Gt({}, u, _);
      }
    }
    function G3(n) {
      {
        var r = n.stateNode, u = r && r.__reactInternalMemoizedMergedChildContext || $n;
        return Yv = Ga.current, ar(Ga, u, n), ar(so, so.current, n), !0;
      }
    }
    function gS(n, r, u) {
      {
        var c = n.stateNode;
        if (!c)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (u) {
          var p = mS(n, r, Yv);
          c.__reactInternalMemoizedMergedChildContext = p, mr(so, n), mr(Ga, n), ar(Ga, p, n), ar(so, u, n);
        } else
          mr(so, n), ar(so, u, n);
      }
    }
    function GO(n) {
      {
        if (!Us(n) || n.tag !== R)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var r = n;
        do {
          switch (r.tag) {
            case T:
              return r.stateNode.context;
            case R: {
              var u = r.type;
              if (x0(u))
                return r.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          r = r.return;
        } while (r !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Bd = 0, K3 = 1, qc = null, a7 = !1, o7 = !1;
    function wS(n) {
      qc === null ? qc = [n] : qc.push(n);
    }
    function KO(n) {
      a7 = !0, wS(n);
    }
    function yS() {
      a7 && Fd();
    }
    function Fd() {
      if (!o7 && qc !== null) {
        o7 = !0;
        var n = 0, r = No();
        try {
          var u = !0, c = qc;
          for (rr(zr); n < c.length; n++) {
            var p = c[n];
            do
              p = p(u);
            while (p !== null);
          }
          qc = null, a7 = !1;
        } catch (x) {
          throw qc !== null && (qc = qc.slice(n + 1)), Zo($a, Fd), x;
        } finally {
          rr(r), o7 = !1;
        }
      }
      return null;
    }
    var zv = [], qv = 0, Q3 = null, X3 = 0, ys = [], xs = 0, v2 = null, Gc = 1, Kc = "";
    function QO(n) {
      return m2(), (n.flags & Ph) !== H;
    }
    function XO(n) {
      return m2(), X3;
    }
    function JO() {
      var n = Kc, r = Gc, u = r & ~eD(r);
      return u.toString(32) + n;
    }
    function p2(n, r) {
      m2(), zv[qv++] = X3, zv[qv++] = Q3, Q3 = n, X3 = r;
    }
    function xS(n, r, u) {
      m2(), ys[xs++] = Gc, ys[xs++] = Kc, ys[xs++] = v2, v2 = n;
      var c = Gc, p = Kc, x = J3(c) - 1, _ = c & ~(1 << x), O = u + 1, k = J3(r) + x;
      if (k > 30) {
        var N = x - x % 5, U = (1 << N) - 1, oe = (_ & U).toString(32), ae = _ >> N, we = x - N, Ce = J3(r) + we, Ee = O << we, it = Ee | ae, Ut = oe + p;
        Gc = 1 << Ce | it, Kc = Ut;
      } else {
        var Lt = O << x, Dn = Lt | _, xn = p;
        Gc = 1 << k | Dn, Kc = xn;
      }
    }
    function i7(n) {
      m2();
      var r = n.return;
      if (r !== null) {
        var u = 1, c = 0;
        p2(n, u), xS(n, u, c);
      }
    }
    function J3(n) {
      return 32 - sd(n);
    }
    function eD(n) {
      return 1 << J3(n) - 1;
    }
    function l7(n) {
      for (; n === Q3; )
        Q3 = zv[--qv], zv[qv] = null, X3 = zv[--qv], zv[qv] = null;
      for (; n === v2; )
        v2 = ys[--xs], ys[xs] = null, Kc = ys[--xs], ys[xs] = null, Gc = ys[--xs], ys[xs] = null;
    }
    function tD() {
      return m2(), v2 !== null ? {
        id: Gc,
        overflow: Kc
      } : null;
    }
    function nD(n, r) {
      m2(), ys[xs++] = Gc, ys[xs++] = Kc, ys[xs++] = v2, Gc = r.id, Kc = r.overflow, v2 = n;
    }
    function m2() {
      vi() || m("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var hi = null, Ss = null, d1 = !1, g2 = !1, Ud = null;
    function rD() {
      d1 && m("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function SS() {
      g2 = !0;
    }
    function aD() {
      return g2;
    }
    function oD(n) {
      var r = n.stateNode.containerInfo;
      return Ss = H6(r), hi = n, d1 = !0, Ud = null, g2 = !1, !0;
    }
    function iD(n, r, u) {
      return Ss = Z6(r), hi = n, d1 = !0, Ud = null, g2 = !1, u !== null && nD(n, u), !0;
    }
    function CS(n, r) {
      switch (n.tag) {
        case T: {
          Y6(n.stateNode.containerInfo, r);
          break;
        }
        case A: {
          var u = (n.mode & on) !== tt;
          W6(
            n.type,
            n.memoizedProps,
            n.stateNode,
            r,
            // TODO: Delete this argument when we remove the legacy root API.
            u
          );
          break;
        }
        case $: {
          var c = n.memoizedState;
          c.dehydrated !== null && $6(c.dehydrated, r);
          break;
        }
      }
    }
    function bS(n, r) {
      CS(n, r);
      var u = sk();
      u.stateNode = r, u.return = n;
      var c = n.deletions;
      c === null ? (n.deletions = [u], n.flags |= Kt) : c.push(u);
    }
    function u7(n, r) {
      {
        if (g2)
          return;
        switch (n.tag) {
          case T: {
            var u = n.stateNode.containerInfo;
            switch (r.tag) {
              case A:
                var c = r.type;
                z6(u, c);
                break;
              case L:
                var p = r.pendingProps;
                q6(u, p);
                break;
            }
            break;
          }
          case A: {
            var x = n.type, _ = n.memoizedProps, O = n.stateNode;
            switch (r.tag) {
              case A: {
                var k = r.type, N = r.pendingProps, U = (n.mode & on) !== tt;
                Q6(
                  x,
                  _,
                  O,
                  k,
                  N,
                  // TODO: Delete this argument when we remove the legacy root API.
                  U
                );
                break;
              }
              case L: {
                var oe = r.pendingProps, ae = (n.mode & on) !== tt;
                X6(
                  x,
                  _,
                  O,
                  oe,
                  // TODO: Delete this argument when we remove the legacy root API.
                  ae
                );
                break;
              }
            }
            break;
          }
          case $: {
            var we = n.memoizedState, Ce = we.dehydrated;
            if (Ce !== null) switch (r.tag) {
              case A:
                var Ee = r.type;
                G6(Ce, Ee);
                break;
              case L:
                var it = r.pendingProps;
                K6(Ce, it);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function _S(n, r) {
      r.flags = r.flags & -4097 | fr, u7(n, r);
    }
    function RS(n, r) {
      switch (n.tag) {
        case A: {
          var u = n.type, c = Bi(r, u);
          return c !== null ? (n.stateNode = c, hi = n, Ss = I6(c), !0) : !1;
        }
        case L: {
          var p = n.pendingProps, x = Dm(r, p);
          return x !== null ? (n.stateNode = x, hi = n, Ss = null, !0) : !1;
        }
        case $: {
          var _ = k6(r);
          if (_ !== null) {
            var O = {
              dehydrated: _,
              treeContext: tD(),
              retryLane: Vo
            };
            n.memoizedState = O;
            var k = ck(_);
            return k.return = n, n.child = k, hi = n, Ss = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function s7(n) {
      return (n.mode & on) !== tt && (n.flags & vn) === H;
    }
    function c7(n) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function f7(n) {
      if (d1) {
        var r = Ss;
        if (!r) {
          s7(n) && (u7(hi, n), c7()), _S(hi, n), d1 = !1, hi = n;
          return;
        }
        var u = r;
        if (!RS(n, r)) {
          s7(n) && (u7(hi, n), c7()), r = zc(u);
          var c = hi;
          if (!r || !RS(n, r)) {
            _S(hi, n), d1 = !1, hi = n;
            return;
          }
          bS(c, u);
        }
      }
    }
    function lD(n, r, u) {
      var c = n.stateNode, p = !g2, x = P6(c, n.type, n.memoizedProps, r, u, n, p);
      return n.updateQueue = x, x !== null;
    }
    function uD(n) {
      var r = n.stateNode, u = n.memoizedProps, c = $3(r, u, n);
      if (c) {
        var p = hi;
        if (p !== null)
          switch (p.tag) {
            case T: {
              var x = p.stateNode.containerInfo, _ = (p.mode & on) !== tt;
              F6(
                x,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                _
              );
              break;
            }
            case A: {
              var O = p.type, k = p.memoizedProps, N = p.stateNode, U = (p.mode & on) !== tt;
              U6(
                O,
                k,
                N,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                U
              );
              break;
            }
          }
      }
      return c;
    }
    function sD(n) {
      var r = n.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      V6(u, n);
    }
    function cD(n) {
      var r = n.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return N6(u);
    }
    function ES(n) {
      for (var r = n.return; r !== null && r.tag !== A && r.tag !== T && r.tag !== $; )
        r = r.return;
      hi = r;
    }
    function eg(n) {
      if (n !== hi)
        return !1;
      if (!d1)
        return ES(n), d1 = !0, !1;
      if (n.tag !== T && (n.tag !== A || B6(n.type) && !_m(n.type, n.memoizedProps))) {
        var r = Ss;
        if (r)
          if (s7(n))
            MS(n), c7();
          else
            for (; r; )
              bS(n, r), r = zc(r);
      }
      return ES(n), n.tag === $ ? Ss = cD(n) : Ss = hi ? zc(n.stateNode) : null, !0;
    }
    function fD() {
      return d1 && Ss !== null;
    }
    function MS(n) {
      for (var r = Ss; r; )
        CS(n, r), r = zc(r);
    }
    function Gv() {
      hi = null, Ss = null, d1 = !1, g2 = !1;
    }
    function TS() {
      Ud !== null && (Sb(Ud), Ud = null);
    }
    function vi() {
      return d1;
    }
    function d7(n) {
      Ud === null ? Ud = [n] : Ud.push(n);
    }
    var dD = a.ReactCurrentBatchConfig, hD = null;
    function vD() {
      return dD.transition;
    }
    var h1 = {
      recordUnsafeLifecycleWarnings: function(n, r) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(n, r) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var pD = function(n) {
        for (var r = null, u = n; u !== null; )
          u.mode & _r && (r = u), u = u.return;
        return r;
      }, w2 = function(n) {
        var r = [];
        return n.forEach(function(u) {
          r.push(u);
        }), r.sort().join(", ");
      }, Zm = [], Pm = [], Vm = [], Nm = [], Bm = [], Fm = [], y2 = /* @__PURE__ */ new Set();
      h1.recordUnsafeLifecycleWarnings = function(n, r) {
        y2.has(n.type) || (typeof r.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        r.componentWillMount.__suppressDeprecationWarning !== !0 && Zm.push(n), n.mode & _r && typeof r.UNSAFE_componentWillMount == "function" && Pm.push(n), typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Vm.push(n), n.mode & _r && typeof r.UNSAFE_componentWillReceiveProps == "function" && Nm.push(n), typeof r.componentWillUpdate == "function" && r.componentWillUpdate.__suppressDeprecationWarning !== !0 && Bm.push(n), n.mode & _r && typeof r.UNSAFE_componentWillUpdate == "function" && Fm.push(n));
      }, h1.flushPendingUnsafeLifecycleWarnings = function() {
        var n = /* @__PURE__ */ new Set();
        Zm.length > 0 && (Zm.forEach(function(ae) {
          n.add(en(ae) || "Component"), y2.add(ae.type);
        }), Zm = []);
        var r = /* @__PURE__ */ new Set();
        Pm.length > 0 && (Pm.forEach(function(ae) {
          r.add(en(ae) || "Component"), y2.add(ae.type);
        }), Pm = []);
        var u = /* @__PURE__ */ new Set();
        Vm.length > 0 && (Vm.forEach(function(ae) {
          u.add(en(ae) || "Component"), y2.add(ae.type);
        }), Vm = []);
        var c = /* @__PURE__ */ new Set();
        Nm.length > 0 && (Nm.forEach(function(ae) {
          c.add(en(ae) || "Component"), y2.add(ae.type);
        }), Nm = []);
        var p = /* @__PURE__ */ new Set();
        Bm.length > 0 && (Bm.forEach(function(ae) {
          p.add(en(ae) || "Component"), y2.add(ae.type);
        }), Bm = []);
        var x = /* @__PURE__ */ new Set();
        if (Fm.length > 0 && (Fm.forEach(function(ae) {
          x.add(en(ae) || "Component"), y2.add(ae.type);
        }), Fm = []), r.size > 0) {
          var _ = w2(r);
          m(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, _);
        }
        if (c.size > 0) {
          var O = w2(c);
          m(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, O);
        }
        if (x.size > 0) {
          var k = w2(x);
          m(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, k);
        }
        if (n.size > 0) {
          var N = w2(n);
          g(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, N);
        }
        if (u.size > 0) {
          var U = w2(u);
          g(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, U);
        }
        if (p.size > 0) {
          var oe = w2(p);
          g(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, oe);
        }
      };
      var tg = /* @__PURE__ */ new Map(), OS = /* @__PURE__ */ new Set();
      h1.recordLegacyContextWarning = function(n, r) {
        var u = pD(n);
        if (u === null) {
          m("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!OS.has(n.type)) {
          var c = tg.get(u);
          (n.type.contextTypes != null || n.type.childContextTypes != null || r !== null && typeof r.getChildContext == "function") && (c === void 0 && (c = [], tg.set(u, c)), c.push(n));
        }
      }, h1.flushLegacyContextWarning = function() {
        tg.forEach(function(n, r) {
          if (n.length !== 0) {
            var u = n[0], c = /* @__PURE__ */ new Set();
            n.forEach(function(x) {
              c.add(en(x) || "Component"), OS.add(x.type);
            });
            var p = w2(c);
            try {
              tr(u), m(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, p);
            } finally {
              va();
            }
          }
        });
      }, h1.discardPendingWarnings = function() {
        Zm = [], Pm = [], Vm = [], Nm = [], Bm = [], Fm = [], tg = /* @__PURE__ */ new Map();
      };
    }
    var h7, v7, p7, m7, g7, DS = function(n, r) {
    };
    h7 = !1, v7 = !1, p7 = {}, m7 = {}, g7 = {}, DS = function(n, r) {
      if (!(n === null || typeof n != "object") && !(!n._store || n._store.validated || n.key != null)) {
        if (typeof n._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        n._store.validated = !0;
        var u = en(r) || "Component";
        m7[u] || (m7[u] = !0, m('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function mD(n) {
      return n.prototype && n.prototype.isReactComponent;
    }
    function Um(n, r, u) {
      var c = u.ref;
      if (c !== null && typeof c != "function" && typeof c != "object") {
        if ((n.mode & _r || Pe) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(u._owner && u._self && u._owner.stateNode !== u._self) && // Will already throw with "Function components cannot have string refs"
        !(u._owner && u._owner.tag !== R) && // Will already warn with "Function components cannot be given refs"
        !(typeof u.type == "function" && !mD(u.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        u._owner) {
          var p = en(n) || "Component";
          p7[p] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', p, c), p7[p] = !0);
        }
        if (u._owner) {
          var x = u._owner, _;
          if (x) {
            var O = x;
            if (O.tag !== R)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            _ = O.stateNode;
          }
          if (!_)
            throw new Error("Missing owner for string ref " + c + ". This error is likely caused by a bug in React. Please file an issue.");
          var k = _;
          ea(c, "ref");
          var N = "" + c;
          if (r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === N)
            return r.ref;
          var U = function(oe) {
            var ae = k.refs;
            oe === null ? delete ae[N] : ae[N] = oe;
          };
          return U._stringRef = N, U;
        } else {
          if (typeof c != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!u._owner)
            throw new Error("Element ref was specified as a string (" + c + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return c;
    }
    function ng(n, r) {
      var u = Object.prototype.toString.call(r);
      throw new Error("Objects are not valid as a React child (found: " + (u === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : u) + "). If you meant to render a collection of children, use an array instead.");
    }
    function rg(n) {
      {
        var r = en(n) || "Component";
        if (g7[r])
          return;
        g7[r] = !0, m("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function jS(n) {
      var r = n._payload, u = n._init;
      return u(r);
    }
    function AS(n) {
      function r(pe, Me) {
        if (n) {
          var me = pe.deletions;
          me === null ? (pe.deletions = [Me], pe.flags |= Kt) : me.push(Me);
        }
      }
      function u(pe, Me) {
        if (!n)
          return null;
        for (var me = Me; me !== null; )
          r(pe, me), me = me.sibling;
        return null;
      }
      function c(pe, Me) {
        for (var me = /* @__PURE__ */ new Map(), We = Me; We !== null; )
          We.key !== null ? me.set(We.key, We) : me.set(We.index, We), We = We.sibling;
        return me;
      }
      function p(pe, Me) {
        var me = T2(pe, Me);
        return me.index = 0, me.sibling = null, me;
      }
      function x(pe, Me, me) {
        if (pe.index = me, !n)
          return pe.flags |= Ph, Me;
        var We = pe.alternate;
        if (We !== null) {
          var pt = We.index;
          return pt < Me ? (pe.flags |= fr, Me) : pt;
        } else
          return pe.flags |= fr, Me;
      }
      function _(pe) {
        return n && pe.alternate === null && (pe.flags |= fr), pe;
      }
      function O(pe, Me, me, We) {
        if (Me === null || Me.tag !== L) {
          var pt = f8(me, pe.mode, We);
          return pt.return = pe, pt;
        } else {
          var ut = p(Me, me);
          return ut.return = pe, ut;
        }
      }
      function k(pe, Me, me, We) {
        var pt = me.type;
        if (pt === Wo)
          return U(pe, Me, me.props.children, We, me.key);
        if (Me !== null && (Me.elementType === pt || // Keep this check inline so it only runs on the false path:
        Zb(Me, me) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof pt == "object" && pt !== null && pt.$$typeof === Et && jS(pt) === Me.type)) {
          var ut = p(Me, me.props);
          return ut.ref = Um(pe, Me, me), ut.return = pe, ut._debugSource = me._source, ut._debugOwner = me._owner, ut;
        }
        var Xt = c8(me, pe.mode, We);
        return Xt.ref = Um(pe, Me, me), Xt.return = pe, Xt;
      }
      function N(pe, Me, me, We) {
        if (Me === null || Me.tag !== j || Me.stateNode.containerInfo !== me.containerInfo || Me.stateNode.implementation !== me.implementation) {
          var pt = d8(me, pe.mode, We);
          return pt.return = pe, pt;
        } else {
          var ut = p(Me, me.children || []);
          return ut.return = pe, ut;
        }
      }
      function U(pe, Me, me, We, pt) {
        if (Me === null || Me.tag !== P) {
          var ut = eh(me, pe.mode, We, pt);
          return ut.return = pe, ut;
        } else {
          var Xt = p(Me, me);
          return Xt.return = pe, Xt;
        }
      }
      function oe(pe, Me, me) {
        if (typeof Me == "string" && Me !== "" || typeof Me == "number") {
          var We = f8("" + Me, pe.mode, me);
          return We.return = pe, We;
        }
        if (typeof Me == "object" && Me !== null) {
          switch (Me.$$typeof) {
            case Ml: {
              var pt = c8(Me, pe.mode, me);
              return pt.ref = Um(pe, null, Me), pt.return = pe, pt;
            }
            case Tl: {
              var ut = d8(Me, pe.mode, me);
              return ut.return = pe, ut;
            }
            case Et: {
              var Xt = Me._payload, an = Me._init;
              return oe(pe, an(Xt), me);
            }
          }
          if (ra(Me) || vo(Me)) {
            var wr = eh(Me, pe.mode, me, null);
            return wr.return = pe, wr;
          }
          ng(pe, Me);
        }
        return typeof Me == "function" && rg(pe), null;
      }
      function ae(pe, Me, me, We) {
        var pt = Me !== null ? Me.key : null;
        if (typeof me == "string" && me !== "" || typeof me == "number")
          return pt !== null ? null : O(pe, Me, "" + me, We);
        if (typeof me == "object" && me !== null) {
          switch (me.$$typeof) {
            case Ml:
              return me.key === pt ? k(pe, Me, me, We) : null;
            case Tl:
              return me.key === pt ? N(pe, Me, me, We) : null;
            case Et: {
              var ut = me._payload, Xt = me._init;
              return ae(pe, Me, Xt(ut), We);
            }
          }
          if (ra(me) || vo(me))
            return pt !== null ? null : U(pe, Me, me, We, null);
          ng(pe, me);
        }
        return typeof me == "function" && rg(pe), null;
      }
      function we(pe, Me, me, We, pt) {
        if (typeof We == "string" && We !== "" || typeof We == "number") {
          var ut = pe.get(me) || null;
          return O(Me, ut, "" + We, pt);
        }
        if (typeof We == "object" && We !== null) {
          switch (We.$$typeof) {
            case Ml: {
              var Xt = pe.get(We.key === null ? me : We.key) || null;
              return k(Me, Xt, We, pt);
            }
            case Tl: {
              var an = pe.get(We.key === null ? me : We.key) || null;
              return N(Me, an, We, pt);
            }
            case Et:
              var wr = We._payload, Kn = We._init;
              return we(pe, Me, me, Kn(wr), pt);
          }
          if (ra(We) || vo(We)) {
            var Ka = pe.get(me) || null;
            return U(Me, Ka, We, pt, null);
          }
          ng(Me, We);
        }
        return typeof We == "function" && rg(Me), null;
      }
      function Ce(pe, Me, me) {
        {
          if (typeof pe != "object" || pe === null)
            return Me;
          switch (pe.$$typeof) {
            case Ml:
            case Tl:
              DS(pe, me);
              var We = pe.key;
              if (typeof We != "string")
                break;
              if (Me === null) {
                Me = /* @__PURE__ */ new Set(), Me.add(We);
                break;
              }
              if (!Me.has(We)) {
                Me.add(We);
                break;
              }
              m("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", We);
              break;
            case Et:
              var pt = pe._payload, ut = pe._init;
              Ce(ut(pt), Me, me);
              break;
          }
        }
        return Me;
      }
      function Ee(pe, Me, me, We) {
        for (var pt = null, ut = 0; ut < me.length; ut++) {
          var Xt = me[ut];
          pt = Ce(Xt, pt, pe);
        }
        for (var an = null, wr = null, Kn = Me, Ka = 0, Qn = 0, Da = null; Kn !== null && Qn < me.length; Qn++) {
          Kn.index > Qn ? (Da = Kn, Kn = null) : Da = Kn.sibling;
          var Ui = ae(pe, Kn, me[Qn], We);
          if (Ui === null) {
            Kn === null && (Kn = Da);
            break;
          }
          n && Kn && Ui.alternate === null && r(pe, Kn), Ka = x(Ui, Ka, Qn), wr === null ? an = Ui : wr.sibling = Ui, wr = Ui, Kn = Da;
        }
        if (Qn === me.length) {
          if (u(pe, Kn), vi()) {
            var Si = Qn;
            p2(pe, Si);
          }
          return an;
        }
        if (Kn === null) {
          for (; Qn < me.length; Qn++) {
            var ju = oe(pe, me[Qn], We);
            ju !== null && (Ka = x(ju, Ka, Qn), wr === null ? an = ju : wr.sibling = ju, wr = ju);
          }
          if (vi()) {
            var xl = Qn;
            p2(pe, xl);
          }
          return an;
        }
        for (var Sl = c(pe, Kn); Qn < me.length; Qn++) {
          var Yi = we(Sl, pe, Qn, me[Qn], We);
          Yi !== null && (n && Yi.alternate !== null && Sl.delete(Yi.key === null ? Qn : Yi.key), Ka = x(Yi, Ka, Qn), wr === null ? an = Yi : wr.sibling = Yi, wr = Yi);
        }
        if (n && Sl.forEach(function(vp) {
          return r(pe, vp);
        }), vi()) {
          var rf = Qn;
          p2(pe, rf);
        }
        return an;
      }
      function it(pe, Me, me, We) {
        var pt = vo(me);
        if (typeof pt != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          me[Symbol.toStringTag] === "Generator" && (v7 || m("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), v7 = !0), me.entries === pt && (h7 || m("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), h7 = !0);
          var ut = pt.call(me);
          if (ut)
            for (var Xt = null, an = ut.next(); !an.done; an = ut.next()) {
              var wr = an.value;
              Xt = Ce(wr, Xt, pe);
            }
        }
        var Kn = pt.call(me);
        if (Kn == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Ka = null, Qn = null, Da = Me, Ui = 0, Si = 0, ju = null, xl = Kn.next(); Da !== null && !xl.done; Si++, xl = Kn.next()) {
          Da.index > Si ? (ju = Da, Da = null) : ju = Da.sibling;
          var Sl = ae(pe, Da, xl.value, We);
          if (Sl === null) {
            Da === null && (Da = ju);
            break;
          }
          n && Da && Sl.alternate === null && r(pe, Da), Ui = x(Sl, Ui, Si), Qn === null ? Ka = Sl : Qn.sibling = Sl, Qn = Sl, Da = ju;
        }
        if (xl.done) {
          if (u(pe, Da), vi()) {
            var Yi = Si;
            p2(pe, Yi);
          }
          return Ka;
        }
        if (Da === null) {
          for (; !xl.done; Si++, xl = Kn.next()) {
            var rf = oe(pe, xl.value, We);
            rf !== null && (Ui = x(rf, Ui, Si), Qn === null ? Ka = rf : Qn.sibling = rf, Qn = rf);
          }
          if (vi()) {
            var vp = Si;
            p2(pe, vp);
          }
          return Ka;
        }
        for (var S4 = c(pe, Da); !xl.done; Si++, xl = Kn.next()) {
          var T0 = we(S4, pe, Si, xl.value, We);
          T0 !== null && (n && T0.alternate !== null && S4.delete(T0.key === null ? Si : T0.key), Ui = x(T0, Ui, Si), Qn === null ? Ka = T0 : Qn.sibling = T0, Qn = T0);
        }
        if (n && S4.forEach(function(Bk) {
          return r(pe, Bk);
        }), vi()) {
          var Nk = Si;
          p2(pe, Nk);
        }
        return Ka;
      }
      function Ut(pe, Me, me, We) {
        if (Me !== null && Me.tag === L) {
          u(pe, Me.sibling);
          var pt = p(Me, me);
          return pt.return = pe, pt;
        }
        u(pe, Me);
        var ut = f8(me, pe.mode, We);
        return ut.return = pe, ut;
      }
      function Lt(pe, Me, me, We) {
        for (var pt = me.key, ut = Me; ut !== null; ) {
          if (ut.key === pt) {
            var Xt = me.type;
            if (Xt === Wo) {
              if (ut.tag === P) {
                u(pe, ut.sibling);
                var an = p(ut, me.props.children);
                return an.return = pe, an._debugSource = me._source, an._debugOwner = me._owner, an;
              }
            } else if (ut.elementType === Xt || // Keep this check inline so it only runs on the false path:
            Zb(ut, me) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Xt == "object" && Xt !== null && Xt.$$typeof === Et && jS(Xt) === ut.type) {
              u(pe, ut.sibling);
              var wr = p(ut, me.props);
              return wr.ref = Um(pe, ut, me), wr.return = pe, wr._debugSource = me._source, wr._debugOwner = me._owner, wr;
            }
            u(pe, ut);
            break;
          } else
            r(pe, ut);
          ut = ut.sibling;
        }
        if (me.type === Wo) {
          var Kn = eh(me.props.children, pe.mode, We, me.key);
          return Kn.return = pe, Kn;
        } else {
          var Ka = c8(me, pe.mode, We);
          return Ka.ref = Um(pe, Me, me), Ka.return = pe, Ka;
        }
      }
      function Dn(pe, Me, me, We) {
        for (var pt = me.key, ut = Me; ut !== null; ) {
          if (ut.key === pt)
            if (ut.tag === j && ut.stateNode.containerInfo === me.containerInfo && ut.stateNode.implementation === me.implementation) {
              u(pe, ut.sibling);
              var Xt = p(ut, me.children || []);
              return Xt.return = pe, Xt;
            } else {
              u(pe, ut);
              break;
            }
          else
            r(pe, ut);
          ut = ut.sibling;
        }
        var an = d8(me, pe.mode, We);
        return an.return = pe, an;
      }
      function xn(pe, Me, me, We) {
        var pt = typeof me == "object" && me !== null && me.type === Wo && me.key === null;
        if (pt && (me = me.props.children), typeof me == "object" && me !== null) {
          switch (me.$$typeof) {
            case Ml:
              return _(Lt(pe, Me, me, We));
            case Tl:
              return _(Dn(pe, Me, me, We));
            case Et:
              var ut = me._payload, Xt = me._init;
              return xn(pe, Me, Xt(ut), We);
          }
          if (ra(me))
            return Ee(pe, Me, me, We);
          if (vo(me))
            return it(pe, Me, me, We);
          ng(pe, me);
        }
        return typeof me == "string" && me !== "" || typeof me == "number" ? _(Ut(pe, Me, "" + me, We)) : (typeof me == "function" && rg(pe), u(pe, Me));
      }
      return xn;
    }
    var Kv = AS(!0), kS = AS(!1);
    function gD(n, r) {
      if (n !== null && r.child !== n.child)
        throw new Error("Resuming work not yet implemented.");
      if (r.child !== null) {
        var u = r.child, c = T2(u, u.pendingProps);
        for (r.child = c, c.return = r; u.sibling !== null; )
          u = u.sibling, c = c.sibling = T2(u, u.pendingProps), c.return = r;
        c.sibling = null;
      }
    }
    function wD(n, r) {
      for (var u = n.child; u !== null; )
        ak(u, r), u = u.sibling;
    }
    var w7 = cn(null), y7;
    y7 = {};
    var ag = null, Qv = null, x7 = null, og = !1;
    function ig() {
      ag = null, Qv = null, x7 = null, og = !1;
    }
    function LS() {
      og = !0;
    }
    function IS() {
      og = !1;
    }
    function HS(n, r, u) {
      ar(w7, r._currentValue, n), r._currentValue = u, r._currentRenderer !== void 0 && r._currentRenderer !== null && r._currentRenderer !== y7 && m("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), r._currentRenderer = y7;
    }
    function S7(n, r) {
      var u = w7.current;
      mr(w7, r), n._currentValue = u;
    }
    function C7(n, r, u) {
      for (var c = n; c !== null; ) {
        var p = c.alternate;
        if (ua(c.childLanes, r) ? p !== null && !ua(p.childLanes, r) && (p.childLanes = At(p.childLanes, r)) : (c.childLanes = At(c.childLanes, r), p !== null && (p.childLanes = At(p.childLanes, r))), c === u)
          break;
        c = c.return;
      }
      c !== u && m("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function yD(n, r, u) {
      xD(n, r, u);
    }
    function xD(n, r, u) {
      var c = n.child;
      for (c !== null && (c.return = n); c !== null; ) {
        var p = void 0, x = c.dependencies;
        if (x !== null) {
          p = c.child;
          for (var _ = x.firstContext; _ !== null; ) {
            if (_.context === r) {
              if (c.tag === R) {
                var O = xu(u), k = Qc(dr, O);
                k.tag = ug;
                var N = c.updateQueue;
                if (N !== null) {
                  var U = N.shared, oe = U.pending;
                  oe === null ? k.next = k : (k.next = oe.next, oe.next = k), U.pending = k;
                }
              }
              c.lanes = At(c.lanes, u);
              var ae = c.alternate;
              ae !== null && (ae.lanes = At(ae.lanes, u)), C7(c.return, u, n), x.lanes = At(x.lanes, u);
              break;
            }
            _ = _.next;
          }
        } else if (c.tag === Y)
          p = c.type === n.type ? null : c.child;
        else if (c.tag === ve) {
          var we = c.return;
          if (we === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          we.lanes = At(we.lanes, u);
          var Ce = we.alternate;
          Ce !== null && (Ce.lanes = At(Ce.lanes, u)), C7(we, u, n), p = c.sibling;
        } else
          p = c.child;
        if (p !== null)
          p.return = c;
        else
          for (p = c; p !== null; ) {
            if (p === n) {
              p = null;
              break;
            }
            var Ee = p.sibling;
            if (Ee !== null) {
              Ee.return = p.return, p = Ee;
              break;
            }
            p = p.return;
          }
        c = p;
      }
    }
    function Xv(n, r) {
      ag = n, Qv = null, x7 = null;
      var u = n.dependencies;
      if (u !== null) {
        var c = u.firstContext;
        c !== null && (oo(u.lanes, r) && a4(), u.firstContext = null);
      }
    }
    function co(n) {
      og && m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var r = n._currentValue;
      if (x7 !== n) {
        var u = {
          context: n,
          memoizedValue: r,
          next: null
        };
        if (Qv === null) {
          if (ag === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Qv = u, ag.dependencies = {
            lanes: He,
            firstContext: u
          };
        } else
          Qv = Qv.next = u;
      }
      return r;
    }
    var x2 = null;
    function b7(n) {
      x2 === null ? x2 = [n] : x2.push(n);
    }
    function SD() {
      if (x2 !== null) {
        for (var n = 0; n < x2.length; n++) {
          var r = x2[n], u = r.interleaved;
          if (u !== null) {
            r.interleaved = null;
            var c = u.next, p = r.pending;
            if (p !== null) {
              var x = p.next;
              p.next = c, u.next = x;
            }
            r.pending = u;
          }
        }
        x2 = null;
      }
    }
    function ZS(n, r, u, c) {
      var p = r.interleaved;
      return p === null ? (u.next = u, b7(r)) : (u.next = p.next, p.next = u), r.interleaved = u, lg(n, c);
    }
    function CD(n, r, u, c) {
      var p = r.interleaved;
      p === null ? (u.next = u, b7(r)) : (u.next = p.next, p.next = u), r.interleaved = u;
    }
    function bD(n, r, u, c) {
      var p = r.interleaved;
      return p === null ? (u.next = u, b7(r)) : (u.next = p.next, p.next = u), r.interleaved = u, lg(n, c);
    }
    function $l(n, r) {
      return lg(n, r);
    }
    var _D = lg;
    function lg(n, r) {
      n.lanes = At(n.lanes, r);
      var u = n.alternate;
      u !== null && (u.lanes = At(u.lanes, r)), u === null && (n.flags & (fr | Zr)) !== H && kb(n);
      for (var c = n, p = n.return; p !== null; )
        p.childLanes = At(p.childLanes, r), u = p.alternate, u !== null ? u.childLanes = At(u.childLanes, r) : (p.flags & (fr | Zr)) !== H && kb(n), c = p, p = p.return;
      if (c.tag === T) {
        var x = c.stateNode;
        return x;
      } else
        return null;
    }
    var PS = 0, VS = 1, ug = 2, _7 = 3, sg = !1, R7, cg;
    R7 = !1, cg = null;
    function E7(n) {
      var r = {
        baseState: n.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: He
        },
        effects: null
      };
      n.updateQueue = r;
    }
    function NS(n, r) {
      var u = r.updateQueue, c = n.updateQueue;
      if (u === c) {
        var p = {
          baseState: c.baseState,
          firstBaseUpdate: c.firstBaseUpdate,
          lastBaseUpdate: c.lastBaseUpdate,
          shared: c.shared,
          effects: c.effects
        };
        r.updateQueue = p;
      }
    }
    function Qc(n, r) {
      var u = {
        eventTime: n,
        lane: r,
        tag: PS,
        payload: null,
        callback: null,
        next: null
      };
      return u;
    }
    function Yd(n, r, u) {
      var c = n.updateQueue;
      if (c === null)
        return null;
      var p = c.shared;
      if (cg === p && !R7 && (m("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), R7 = !0), SA()) {
        var x = p.pending;
        return x === null ? r.next = r : (r.next = x.next, x.next = r), p.pending = r, _D(n, u);
      } else
        return bD(n, p, r, u);
    }
    function fg(n, r, u) {
      var c = r.updateQueue;
      if (c !== null) {
        var p = c.shared;
        if (Ks(u)) {
          var x = p.lanes;
          x = vd(x, n.pendingLanes);
          var _ = At(x, u);
          p.lanes = _, Ii(n, _);
        }
      }
    }
    function M7(n, r) {
      var u = n.updateQueue, c = n.alternate;
      if (c !== null) {
        var p = c.updateQueue;
        if (u === p) {
          var x = null, _ = null, O = u.firstBaseUpdate;
          if (O !== null) {
            var k = O;
            do {
              var N = {
                eventTime: k.eventTime,
                lane: k.lane,
                tag: k.tag,
                payload: k.payload,
                callback: k.callback,
                next: null
              };
              _ === null ? x = _ = N : (_.next = N, _ = N), k = k.next;
            } while (k !== null);
            _ === null ? x = _ = r : (_.next = r, _ = r);
          } else
            x = _ = r;
          u = {
            baseState: p.baseState,
            firstBaseUpdate: x,
            lastBaseUpdate: _,
            shared: p.shared,
            effects: p.effects
          }, n.updateQueue = u;
          return;
        }
      }
      var U = u.lastBaseUpdate;
      U === null ? u.firstBaseUpdate = r : U.next = r, u.lastBaseUpdate = r;
    }
    function RD(n, r, u, c, p, x) {
      switch (u.tag) {
        case VS: {
          var _ = u.payload;
          if (typeof _ == "function") {
            LS();
            var O = _.call(x, c, p);
            {
              if (n.mode & _r) {
                pr(!0);
                try {
                  _.call(x, c, p);
                } finally {
                  pr(!1);
                }
              }
              IS();
            }
            return O;
          }
          return _;
        }
        case _7:
          n.flags = n.flags & -65537 | vn;
        case PS: {
          var k = u.payload, N;
          if (typeof k == "function") {
            LS(), N = k.call(x, c, p);
            {
              if (n.mode & _r) {
                pr(!0);
                try {
                  k.call(x, c, p);
                } finally {
                  pr(!1);
                }
              }
              IS();
            }
          } else
            N = k;
          return N == null ? c : Gt({}, c, N);
        }
        case ug:
          return sg = !0, c;
      }
      return c;
    }
    function dg(n, r, u, c) {
      var p = n.updateQueue;
      sg = !1, cg = p.shared;
      var x = p.firstBaseUpdate, _ = p.lastBaseUpdate, O = p.shared.pending;
      if (O !== null) {
        p.shared.pending = null;
        var k = O, N = k.next;
        k.next = null, _ === null ? x = N : _.next = N, _ = k;
        var U = n.alternate;
        if (U !== null) {
          var oe = U.updateQueue, ae = oe.lastBaseUpdate;
          ae !== _ && (ae === null ? oe.firstBaseUpdate = N : ae.next = N, oe.lastBaseUpdate = k);
        }
      }
      if (x !== null) {
        var we = p.baseState, Ce = He, Ee = null, it = null, Ut = null, Lt = x;
        do {
          var Dn = Lt.lane, xn = Lt.eventTime;
          if (ua(c, Dn)) {
            if (Ut !== null) {
              var Me = {
                eventTime: xn,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Vr,
                tag: Lt.tag,
                payload: Lt.payload,
                callback: Lt.callback,
                next: null
              };
              Ut = Ut.next = Me;
            }
            we = RD(n, p, Lt, we, r, u);
            var me = Lt.callback;
            if (me !== null && // If the update was already committed, we should not queue its
            // callback again.
            Lt.lane !== Vr) {
              n.flags |= Jf;
              var We = p.effects;
              We === null ? p.effects = [Lt] : We.push(Lt);
            }
          } else {
            var pe = {
              eventTime: xn,
              lane: Dn,
              tag: Lt.tag,
              payload: Lt.payload,
              callback: Lt.callback,
              next: null
            };
            Ut === null ? (it = Ut = pe, Ee = we) : Ut = Ut.next = pe, Ce = At(Ce, Dn);
          }
          if (Lt = Lt.next, Lt === null) {
            if (O = p.shared.pending, O === null)
              break;
            var pt = O, ut = pt.next;
            pt.next = null, Lt = ut, p.lastBaseUpdate = pt, p.shared.pending = null;
          }
        } while (!0);
        Ut === null && (Ee = we), p.baseState = Ee, p.firstBaseUpdate = it, p.lastBaseUpdate = Ut;
        var Xt = p.shared.interleaved;
        if (Xt !== null) {
          var an = Xt;
          do
            Ce = At(Ce, an.lane), an = an.next;
          while (an !== Xt);
        } else x === null && (p.shared.lanes = He);
        m4(Ce), n.lanes = Ce, n.memoizedState = we;
      }
      cg = null;
    }
    function ED(n, r) {
      if (typeof n != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + n));
      n.call(r);
    }
    function BS() {
      sg = !1;
    }
    function hg() {
      return sg;
    }
    function FS(n, r, u) {
      var c = r.effects;
      if (r.effects = null, c !== null)
        for (var p = 0; p < c.length; p++) {
          var x = c[p], _ = x.callback;
          _ !== null && (x.callback = null, ED(_, u));
        }
    }
    var Ym = {}, $d = cn(Ym), $m = cn(Ym), vg = cn(Ym);
    function pg(n) {
      if (n === Ym)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return n;
    }
    function US() {
      var n = pg(vg.current);
      return n;
    }
    function T7(n, r) {
      ar(vg, r, n), ar($m, n, n), ar($d, Ym, n);
      var u = s6(r);
      mr($d, n), ar($d, u, n);
    }
    function Jv(n) {
      mr($d, n), mr($m, n), mr(vg, n);
    }
    function O7() {
      var n = pg($d.current);
      return n;
    }
    function YS(n) {
      pg(vg.current);
      var r = pg($d.current), u = c6(r, n.type);
      r !== u && (ar($m, n, n), ar($d, u, n));
    }
    function D7(n) {
      $m.current === n && (mr($d, n), mr($m, n));
    }
    var MD = 0, $S = 1, WS = 1, Wm = 2, v1 = cn(MD);
    function j7(n, r) {
      return (n & r) !== 0;
    }
    function ep(n) {
      return n & $S;
    }
    function A7(n, r) {
      return n & $S | r;
    }
    function TD(n, r) {
      return n | r;
    }
    function Wd(n, r) {
      ar(v1, r, n);
    }
    function tp(n) {
      mr(v1, n);
    }
    function OD(n, r) {
      var u = n.memoizedState;
      return u !== null ? u.dehydrated !== null : !0;
    }
    function mg(n) {
      for (var r = n; r !== null; ) {
        if (r.tag === $) {
          var u = r.memoizedState;
          if (u !== null) {
            var c = u.dehydrated;
            if (c === null || Y3(c) || jm(c))
              return r;
          }
        } else if (r.tag === K && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        r.memoizedProps.revealOrder !== void 0) {
          var p = (r.flags & vn) !== H;
          if (p)
            return r;
        } else if (r.child !== null) {
          r.child.return = r, r = r.child;
          continue;
        }
        if (r === n)
          return null;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === n)
            return null;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return null;
    }
    var Wl = (
      /*   */
      0
    ), Co = (
      /* */
      1
    ), S0 = (
      /*  */
      2
    ), bo = (
      /*    */
      4
    ), pi = (
      /*   */
      8
    ), k7 = [];
    function L7() {
      for (var n = 0; n < k7.length; n++) {
        var r = k7[n];
        r._workInProgressVersionPrimary = null;
      }
      k7.length = 0;
    }
    function DD(n, r) {
      var u = r._getVersion, c = u(r._source);
      n.mutableSourceEagerHydrationData == null ? n.mutableSourceEagerHydrationData = [r, c] : n.mutableSourceEagerHydrationData.push(r, c);
    }
    var vt = a.ReactCurrentDispatcher, zm = a.ReactCurrentBatchConfig, I7, np;
    I7 = /* @__PURE__ */ new Set();
    var S2 = He, gr = null, _o = null, Ro = null, gg = !1, qm = !1, Gm = 0, jD = 0, AD = 25, je = null, Cs = null, zd = -1, H7 = !1;
    function or() {
      {
        var n = je;
        Cs === null ? Cs = [n] : Cs.push(n);
      }
    }
    function nt() {
      {
        var n = je;
        Cs !== null && (zd++, Cs[zd] !== n && kD(n));
      }
    }
    function rp(n) {
      n != null && !ra(n) && m("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", je, typeof n);
    }
    function kD(n) {
      {
        var r = en(gr);
        if (!I7.has(r) && (I7.add(r), Cs !== null)) {
          for (var u = "", c = 30, p = 0; p <= zd; p++) {
            for (var x = Cs[p], _ = p === zd ? n : x, O = p + 1 + ". " + x; O.length < c; )
              O += " ";
            O += _ + `
`, u += O;
          }
          m(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, r, u);
        }
      }
    }
    function Fi() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Z7(n, r) {
      if (H7)
        return !1;
      if (r === null)
        return m("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", je), !1;
      n.length !== r.length && m(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, je, "[" + r.join(", ") + "]", "[" + n.join(", ") + "]");
      for (var u = 0; u < r.length && u < n.length; u++)
        if (!ce(n[u], r[u]))
          return !1;
      return !0;
    }
    function ap(n, r, u, c, p, x) {
      S2 = x, gr = r, Cs = n !== null ? n._debugHookTypes : null, zd = -1, H7 = n !== null && n.type !== r.type, r.memoizedState = null, r.updateQueue = null, r.lanes = He, n !== null && n.memoizedState !== null ? vt.current = vC : Cs !== null ? vt.current = hC : vt.current = dC;
      var _ = u(c, p);
      if (qm) {
        var O = 0;
        do {
          if (qm = !1, Gm = 0, O >= AD)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          O += 1, H7 = !1, _o = null, Ro = null, r.updateQueue = null, zd = -1, vt.current = pC, _ = u(c, p);
        } while (qm);
      }
      vt.current = Dg, r._debugHookTypes = Cs;
      var k = _o !== null && _o.next !== null;
      if (S2 = He, gr = null, _o = null, Ro = null, je = null, Cs = null, zd = -1, n !== null && (n.flags & Mr) !== (r.flags & Mr) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (n.mode & on) !== tt && m("Internal React error: Expected static flag was missing. Please notify the React team."), gg = !1, k)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return _;
    }
    function op() {
      var n = Gm !== 0;
      return Gm = 0, n;
    }
    function zS(n, r, u) {
      r.updateQueue = n.updateQueue, (r.mode & Po) !== tt ? r.flags &= -50333701 : r.flags &= -2053, n.lanes = Oc(n.lanes, u);
    }
    function qS() {
      if (vt.current = Dg, gg) {
        for (var n = gr.memoizedState; n !== null; ) {
          var r = n.queue;
          r !== null && (r.pending = null), n = n.next;
        }
        gg = !1;
      }
      S2 = He, gr = null, _o = null, Ro = null, Cs = null, zd = -1, je = null, lC = !1, qm = !1, Gm = 0;
    }
    function C0() {
      var n = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Ro === null ? gr.memoizedState = Ro = n : Ro = Ro.next = n, Ro;
    }
    function bs() {
      var n;
      if (_o === null) {
        var r = gr.alternate;
        r !== null ? n = r.memoizedState : n = null;
      } else
        n = _o.next;
      var u;
      if (Ro === null ? u = gr.memoizedState : u = Ro.next, u !== null)
        Ro = u, u = Ro.next, _o = n;
      else {
        if (n === null)
          throw new Error("Rendered more hooks than during the previous render.");
        _o = n;
        var c = {
          memoizedState: _o.memoizedState,
          baseState: _o.baseState,
          baseQueue: _o.baseQueue,
          queue: _o.queue,
          next: null
        };
        Ro === null ? gr.memoizedState = Ro = c : Ro = Ro.next = c;
      }
      return Ro;
    }
    function GS() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function P7(n, r) {
      return typeof r == "function" ? r(n) : r;
    }
    function V7(n, r, u) {
      var c = C0(), p;
      u !== void 0 ? p = u(r) : p = r, c.memoizedState = c.baseState = p;
      var x = {
        pending: null,
        interleaved: null,
        lanes: He,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: p
      };
      c.queue = x;
      var _ = x.dispatch = ZD.bind(null, gr, x);
      return [c.memoizedState, _];
    }
    function N7(n, r, u) {
      var c = bs(), p = c.queue;
      if (p === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      p.lastRenderedReducer = n;
      var x = _o, _ = x.baseQueue, O = p.pending;
      if (O !== null) {
        if (_ !== null) {
          var k = _.next, N = O.next;
          _.next = N, O.next = k;
        }
        x.baseQueue !== _ && m("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), x.baseQueue = _ = O, p.pending = null;
      }
      if (_ !== null) {
        var U = _.next, oe = x.baseState, ae = null, we = null, Ce = null, Ee = U;
        do {
          var it = Ee.lane;
          if (ua(S2, it)) {
            if (Ce !== null) {
              var Lt = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Vr,
                action: Ee.action,
                hasEagerState: Ee.hasEagerState,
                eagerState: Ee.eagerState,
                next: null
              };
              Ce = Ce.next = Lt;
            }
            if (Ee.hasEagerState)
              oe = Ee.eagerState;
            else {
              var Dn = Ee.action;
              oe = n(oe, Dn);
            }
          } else {
            var Ut = {
              lane: it,
              action: Ee.action,
              hasEagerState: Ee.hasEagerState,
              eagerState: Ee.eagerState,
              next: null
            };
            Ce === null ? (we = Ce = Ut, ae = oe) : Ce = Ce.next = Ut, gr.lanes = At(gr.lanes, it), m4(it);
          }
          Ee = Ee.next;
        } while (Ee !== null && Ee !== U);
        Ce === null ? ae = oe : Ce.next = we, ce(oe, c.memoizedState) || a4(), c.memoizedState = oe, c.baseState = ae, c.baseQueue = Ce, p.lastRenderedState = oe;
      }
      var xn = p.interleaved;
      if (xn !== null) {
        var pe = xn;
        do {
          var Me = pe.lane;
          gr.lanes = At(gr.lanes, Me), m4(Me), pe = pe.next;
        } while (pe !== xn);
      } else _ === null && (p.lanes = He);
      var me = p.dispatch;
      return [c.memoizedState, me];
    }
    function B7(n, r, u) {
      var c = bs(), p = c.queue;
      if (p === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      p.lastRenderedReducer = n;
      var x = p.dispatch, _ = p.pending, O = c.memoizedState;
      if (_ !== null) {
        p.pending = null;
        var k = _.next, N = k;
        do {
          var U = N.action;
          O = n(O, U), N = N.next;
        } while (N !== k);
        ce(O, c.memoizedState) || a4(), c.memoizedState = O, c.baseQueue === null && (c.baseState = O), p.lastRenderedState = O;
      }
      return [O, x];
    }
    function IQ(n, r, u) {
    }
    function HQ(n, r, u) {
    }
    function F7(n, r, u) {
      var c = gr, p = C0(), x, _ = vi();
      if (_) {
        if (u === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        x = u(), np || x !== u() && (m("The result of getServerSnapshot should be cached to avoid an infinite loop"), np = !0);
      } else {
        if (x = r(), !np) {
          var O = r();
          ce(x, O) || (m("The result of getSnapshot should be cached to avoid an infinite loop"), np = !0);
        }
        var k = Gg();
        if (k === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Nl(k, S2) || KS(c, r, x);
      }
      p.memoizedState = x;
      var N = {
        value: x,
        getSnapshot: r
      };
      return p.queue = N, Cg(XS.bind(null, c, N, n), [n]), c.flags |= mo, Km(Co | pi, QS.bind(null, c, N, x, r), void 0, null), x;
    }
    function wg(n, r, u) {
      var c = gr, p = bs(), x = r();
      if (!np) {
        var _ = r();
        ce(x, _) || (m("The result of getSnapshot should be cached to avoid an infinite loop"), np = !0);
      }
      var O = p.memoizedState, k = !ce(O, x);
      k && (p.memoizedState = x, a4());
      var N = p.queue;
      if (Xm(XS.bind(null, c, N, n), [n]), N.getSnapshot !== r || k || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Ro !== null && Ro.memoizedState.tag & Co) {
        c.flags |= mo, Km(Co | pi, QS.bind(null, c, N, x, r), void 0, null);
        var U = Gg();
        if (U === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Nl(U, S2) || KS(c, r, x);
      }
      return x;
    }
    function KS(n, r, u) {
      n.flags |= Fa;
      var c = {
        getSnapshot: r,
        value: u
      }, p = gr.updateQueue;
      if (p === null)
        p = GS(), gr.updateQueue = p, p.stores = [c];
      else {
        var x = p.stores;
        x === null ? p.stores = [c] : x.push(c);
      }
    }
    function QS(n, r, u, c) {
      r.value = u, r.getSnapshot = c, JS(r) && eC(n);
    }
    function XS(n, r, u) {
      var c = function() {
        JS(r) && eC(n);
      };
      return u(c);
    }
    function JS(n) {
      var r = n.getSnapshot, u = n.value;
      try {
        var c = r();
        return !ce(u, c);
      } catch {
        return !0;
      }
    }
    function eC(n) {
      var r = $l(n, It);
      r !== null && Oo(r, n, It, dr);
    }
    function yg(n) {
      var r = C0();
      typeof n == "function" && (n = n()), r.memoizedState = r.baseState = n;
      var u = {
        pending: null,
        interleaved: null,
        lanes: He,
        dispatch: null,
        lastRenderedReducer: P7,
        lastRenderedState: n
      };
      r.queue = u;
      var c = u.dispatch = PD.bind(null, gr, u);
      return [r.memoizedState, c];
    }
    function U7(n) {
      return N7(P7);
    }
    function Y7(n) {
      return B7(P7);
    }
    function Km(n, r, u, c) {
      var p = {
        tag: n,
        create: r,
        destroy: u,
        deps: c,
        // Circular
        next: null
      }, x = gr.updateQueue;
      if (x === null)
        x = GS(), gr.updateQueue = x, x.lastEffect = p.next = p;
      else {
        var _ = x.lastEffect;
        if (_ === null)
          x.lastEffect = p.next = p;
        else {
          var O = _.next;
          _.next = p, p.next = O, x.lastEffect = p;
        }
      }
      return p;
    }
    function $7(n) {
      var r = C0();
      {
        var u = {
          current: n
        };
        return r.memoizedState = u, u;
      }
    }
    function xg(n) {
      var r = bs();
      return r.memoizedState;
    }
    function Qm(n, r, u, c) {
      var p = C0(), x = c === void 0 ? null : c;
      gr.flags |= n, p.memoizedState = Km(Co | r, u, void 0, x);
    }
    function Sg(n, r, u, c) {
      var p = bs(), x = c === void 0 ? null : c, _ = void 0;
      if (_o !== null) {
        var O = _o.memoizedState;
        if (_ = O.destroy, x !== null) {
          var k = O.deps;
          if (Z7(x, k)) {
            p.memoizedState = Km(r, u, _, x);
            return;
          }
        }
      }
      gr.flags |= n, p.memoizedState = Km(Co | r, u, _, x);
    }
    function Cg(n, r) {
      return (gr.mode & Po) !== tt ? Qm(pc | mo | Ji, pi, n, r) : Qm(mo | Ji, pi, n, r);
    }
    function Xm(n, r) {
      return Sg(mo, pi, n, r);
    }
    function W7(n, r) {
      return Qm(zt, S0, n, r);
    }
    function bg(n, r) {
      return Sg(zt, S0, n, r);
    }
    function z7(n, r) {
      var u = zt;
      return u |= qu, (gr.mode & Po) !== tt && (u |= el), Qm(u, bo, n, r);
    }
    function _g(n, r) {
      return Sg(zt, bo, n, r);
    }
    function tC(n, r) {
      if (typeof r == "function") {
        var u = r, c = n();
        return u(c), function() {
          u(null);
        };
      } else if (r != null) {
        var p = r;
        p.hasOwnProperty("current") || m("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(p).join(", ") + "}");
        var x = n();
        return p.current = x, function() {
          p.current = null;
        };
      }
    }
    function q7(n, r, u) {
      typeof r != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var c = u != null ? u.concat([n]) : null, p = zt;
      return p |= qu, (gr.mode & Po) !== tt && (p |= el), Qm(p, bo, tC.bind(null, r, n), c);
    }
    function Rg(n, r, u) {
      typeof r != "function" && m("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var c = u != null ? u.concat([n]) : null;
      return Sg(zt, bo, tC.bind(null, r, n), c);
    }
    function LD(n, r) {
    }
    var Eg = LD;
    function G7(n, r) {
      var u = C0(), c = r === void 0 ? null : r;
      return u.memoizedState = [n, c], n;
    }
    function Mg(n, r) {
      var u = bs(), c = r === void 0 ? null : r, p = u.memoizedState;
      if (p !== null && c !== null) {
        var x = p[1];
        if (Z7(c, x))
          return p[0];
      }
      return u.memoizedState = [n, c], n;
    }
    function K7(n, r) {
      var u = C0(), c = r === void 0 ? null : r, p = n();
      return u.memoizedState = [p, c], p;
    }
    function Tg(n, r) {
      var u = bs(), c = r === void 0 ? null : r, p = u.memoizedState;
      if (p !== null && c !== null) {
        var x = p[1];
        if (Z7(c, x))
          return p[0];
      }
      var _ = n();
      return u.memoizedState = [_, c], _;
    }
    function Q7(n) {
      var r = C0();
      return r.memoizedState = n, n;
    }
    function nC(n) {
      var r = bs(), u = _o, c = u.memoizedState;
      return aC(r, c, n);
    }
    function rC(n) {
      var r = bs();
      if (_o === null)
        return r.memoizedState = n, n;
      var u = _o.memoizedState;
      return aC(r, u, n);
    }
    function aC(n, r, u) {
      var c = !c0(S2);
      if (c) {
        if (!ce(u, r)) {
          var p = $h();
          gr.lanes = At(gr.lanes, p), m4(p), n.baseState = !0;
        }
        return r;
      } else
        return n.baseState && (n.baseState = !1, a4()), n.memoizedState = u, u;
    }
    function ID(n, r, u) {
      var c = No();
      rr(za(c, jt)), n(!0);
      var p = zm.transition;
      zm.transition = {};
      var x = zm.transition;
      zm.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        n(!1), r();
      } finally {
        if (rr(c), zm.transition = p, p === null && x._updatedFibers) {
          var _ = x._updatedFibers.size;
          _ > 10 && g("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), x._updatedFibers.clear();
        }
      }
    }
    function X7() {
      var n = yg(!1), r = n[0], u = n[1], c = ID.bind(null, u), p = C0();
      return p.memoizedState = c, [r, c];
    }
    function oC() {
      var n = U7(), r = n[0], u = bs(), c = u.memoizedState;
      return [r, c];
    }
    function iC() {
      var n = Y7(), r = n[0], u = bs(), c = u.memoizedState;
      return [r, c];
    }
    var lC = !1;
    function HD() {
      return lC;
    }
    function J7() {
      var n = C0(), r = Gg(), u = r.identifierPrefix, c;
      if (vi()) {
        var p = JO();
        c = ":" + u + "R" + p;
        var x = Gm++;
        x > 0 && (c += "H" + x.toString(32)), c += ":";
      } else {
        var _ = jD++;
        c = ":" + u + "r" + _.toString(32) + ":";
      }
      return n.memoizedState = c, c;
    }
    function Og() {
      var n = bs(), r = n.memoizedState;
      return r;
    }
    function ZD(n, r, u) {
      typeof arguments[3] == "function" && m("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var c = Xd(n), p = {
        lane: c,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (uC(n))
        sC(r, p);
      else {
        var x = ZS(n, r, p, c);
        if (x !== null) {
          var _ = yl();
          Oo(x, n, c, _), cC(x, r, c);
        }
      }
      fC(n, c);
    }
    function PD(n, r, u) {
      typeof arguments[3] == "function" && m("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var c = Xd(n), p = {
        lane: c,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (uC(n))
        sC(r, p);
      else {
        var x = n.alternate;
        if (n.lanes === He && (x === null || x.lanes === He)) {
          var _ = r.lastRenderedReducer;
          if (_ !== null) {
            var O;
            O = vt.current, vt.current = p1;
            try {
              var k = r.lastRenderedState, N = _(k, u);
              if (p.hasEagerState = !0, p.eagerState = N, ce(N, k)) {
                CD(n, r, p);
                return;
              }
            } catch {
            } finally {
              vt.current = O;
            }
          }
        }
        var U = ZS(n, r, p, c);
        if (U !== null) {
          var oe = yl();
          Oo(U, n, c, oe), cC(U, r, c);
        }
      }
      fC(n, c);
    }
    function uC(n) {
      var r = n.alternate;
      return n === gr || r !== null && r === gr;
    }
    function sC(n, r) {
      qm = gg = !0;
      var u = n.pending;
      u === null ? r.next = r : (r.next = u.next, u.next = r), n.pending = r;
    }
    function cC(n, r, u) {
      if (Ks(u)) {
        var c = r.lanes;
        c = vd(c, n.pendingLanes);
        var p = At(c, u);
        r.lanes = p, Ii(n, p);
      }
    }
    function fC(n, r, u) {
      e0(n, r);
    }
    var Dg = {
      readContext: co,
      useCallback: Fi,
      useContext: Fi,
      useEffect: Fi,
      useImperativeHandle: Fi,
      useInsertionEffect: Fi,
      useLayoutEffect: Fi,
      useMemo: Fi,
      useReducer: Fi,
      useRef: Fi,
      useState: Fi,
      useDebugValue: Fi,
      useDeferredValue: Fi,
      useTransition: Fi,
      useMutableSource: Fi,
      useSyncExternalStore: Fi,
      useId: Fi,
      unstable_isNewReconciler: ie
    }, dC = null, hC = null, vC = null, pC = null, b0 = null, p1 = null, jg = null;
    {
      var e9 = function() {
        m("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, nn = function() {
        m("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      dC = {
        readContext: function(n) {
          return co(n);
        },
        useCallback: function(n, r) {
          return je = "useCallback", or(), rp(r), G7(n, r);
        },
        useContext: function(n) {
          return je = "useContext", or(), co(n);
        },
        useEffect: function(n, r) {
          return je = "useEffect", or(), rp(r), Cg(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return je = "useImperativeHandle", or(), rp(u), q7(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return je = "useInsertionEffect", or(), rp(r), W7(n, r);
        },
        useLayoutEffect: function(n, r) {
          return je = "useLayoutEffect", or(), rp(r), z7(n, r);
        },
        useMemo: function(n, r) {
          je = "useMemo", or(), rp(r);
          var u = vt.current;
          vt.current = b0;
          try {
            return K7(n, r);
          } finally {
            vt.current = u;
          }
        },
        useReducer: function(n, r, u) {
          je = "useReducer", or();
          var c = vt.current;
          vt.current = b0;
          try {
            return V7(n, r, u);
          } finally {
            vt.current = c;
          }
        },
        useRef: function(n) {
          return je = "useRef", or(), $7(n);
        },
        useState: function(n) {
          je = "useState", or();
          var r = vt.current;
          vt.current = b0;
          try {
            return yg(n);
          } finally {
            vt.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return je = "useDebugValue", or(), void 0;
        },
        useDeferredValue: function(n) {
          return je = "useDeferredValue", or(), Q7(n);
        },
        useTransition: function() {
          return je = "useTransition", or(), X7();
        },
        useMutableSource: function(n, r, u) {
          return je = "useMutableSource", or(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return je = "useSyncExternalStore", or(), F7(n, r, u);
        },
        useId: function() {
          return je = "useId", or(), J7();
        },
        unstable_isNewReconciler: ie
      }, hC = {
        readContext: function(n) {
          return co(n);
        },
        useCallback: function(n, r) {
          return je = "useCallback", nt(), G7(n, r);
        },
        useContext: function(n) {
          return je = "useContext", nt(), co(n);
        },
        useEffect: function(n, r) {
          return je = "useEffect", nt(), Cg(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return je = "useImperativeHandle", nt(), q7(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return je = "useInsertionEffect", nt(), W7(n, r);
        },
        useLayoutEffect: function(n, r) {
          return je = "useLayoutEffect", nt(), z7(n, r);
        },
        useMemo: function(n, r) {
          je = "useMemo", nt();
          var u = vt.current;
          vt.current = b0;
          try {
            return K7(n, r);
          } finally {
            vt.current = u;
          }
        },
        useReducer: function(n, r, u) {
          je = "useReducer", nt();
          var c = vt.current;
          vt.current = b0;
          try {
            return V7(n, r, u);
          } finally {
            vt.current = c;
          }
        },
        useRef: function(n) {
          return je = "useRef", nt(), $7(n);
        },
        useState: function(n) {
          je = "useState", nt();
          var r = vt.current;
          vt.current = b0;
          try {
            return yg(n);
          } finally {
            vt.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return je = "useDebugValue", nt(), void 0;
        },
        useDeferredValue: function(n) {
          return je = "useDeferredValue", nt(), Q7(n);
        },
        useTransition: function() {
          return je = "useTransition", nt(), X7();
        },
        useMutableSource: function(n, r, u) {
          return je = "useMutableSource", nt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return je = "useSyncExternalStore", nt(), F7(n, r, u);
        },
        useId: function() {
          return je = "useId", nt(), J7();
        },
        unstable_isNewReconciler: ie
      }, vC = {
        readContext: function(n) {
          return co(n);
        },
        useCallback: function(n, r) {
          return je = "useCallback", nt(), Mg(n, r);
        },
        useContext: function(n) {
          return je = "useContext", nt(), co(n);
        },
        useEffect: function(n, r) {
          return je = "useEffect", nt(), Xm(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return je = "useImperativeHandle", nt(), Rg(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return je = "useInsertionEffect", nt(), bg(n, r);
        },
        useLayoutEffect: function(n, r) {
          return je = "useLayoutEffect", nt(), _g(n, r);
        },
        useMemo: function(n, r) {
          je = "useMemo", nt();
          var u = vt.current;
          vt.current = p1;
          try {
            return Tg(n, r);
          } finally {
            vt.current = u;
          }
        },
        useReducer: function(n, r, u) {
          je = "useReducer", nt();
          var c = vt.current;
          vt.current = p1;
          try {
            return N7(n);
          } finally {
            vt.current = c;
          }
        },
        useRef: function(n) {
          return je = "useRef", nt(), xg();
        },
        useState: function(n) {
          je = "useState", nt();
          var r = vt.current;
          vt.current = p1;
          try {
            return U7();
          } finally {
            vt.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return je = "useDebugValue", nt(), Eg();
        },
        useDeferredValue: function(n) {
          return je = "useDeferredValue", nt(), nC(n);
        },
        useTransition: function() {
          return je = "useTransition", nt(), oC();
        },
        useMutableSource: function(n, r, u) {
          return je = "useMutableSource", nt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return je = "useSyncExternalStore", nt(), wg(n, r);
        },
        useId: function() {
          return je = "useId", nt(), Og();
        },
        unstable_isNewReconciler: ie
      }, pC = {
        readContext: function(n) {
          return co(n);
        },
        useCallback: function(n, r) {
          return je = "useCallback", nt(), Mg(n, r);
        },
        useContext: function(n) {
          return je = "useContext", nt(), co(n);
        },
        useEffect: function(n, r) {
          return je = "useEffect", nt(), Xm(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return je = "useImperativeHandle", nt(), Rg(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return je = "useInsertionEffect", nt(), bg(n, r);
        },
        useLayoutEffect: function(n, r) {
          return je = "useLayoutEffect", nt(), _g(n, r);
        },
        useMemo: function(n, r) {
          je = "useMemo", nt();
          var u = vt.current;
          vt.current = jg;
          try {
            return Tg(n, r);
          } finally {
            vt.current = u;
          }
        },
        useReducer: function(n, r, u) {
          je = "useReducer", nt();
          var c = vt.current;
          vt.current = jg;
          try {
            return B7(n);
          } finally {
            vt.current = c;
          }
        },
        useRef: function(n) {
          return je = "useRef", nt(), xg();
        },
        useState: function(n) {
          je = "useState", nt();
          var r = vt.current;
          vt.current = jg;
          try {
            return Y7();
          } finally {
            vt.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return je = "useDebugValue", nt(), Eg();
        },
        useDeferredValue: function(n) {
          return je = "useDeferredValue", nt(), rC(n);
        },
        useTransition: function() {
          return je = "useTransition", nt(), iC();
        },
        useMutableSource: function(n, r, u) {
          return je = "useMutableSource", nt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return je = "useSyncExternalStore", nt(), wg(n, r);
        },
        useId: function() {
          return je = "useId", nt(), Og();
        },
        unstable_isNewReconciler: ie
      }, b0 = {
        readContext: function(n) {
          return e9(), co(n);
        },
        useCallback: function(n, r) {
          return je = "useCallback", nn(), or(), G7(n, r);
        },
        useContext: function(n) {
          return je = "useContext", nn(), or(), co(n);
        },
        useEffect: function(n, r) {
          return je = "useEffect", nn(), or(), Cg(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return je = "useImperativeHandle", nn(), or(), q7(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return je = "useInsertionEffect", nn(), or(), W7(n, r);
        },
        useLayoutEffect: function(n, r) {
          return je = "useLayoutEffect", nn(), or(), z7(n, r);
        },
        useMemo: function(n, r) {
          je = "useMemo", nn(), or();
          var u = vt.current;
          vt.current = b0;
          try {
            return K7(n, r);
          } finally {
            vt.current = u;
          }
        },
        useReducer: function(n, r, u) {
          je = "useReducer", nn(), or();
          var c = vt.current;
          vt.current = b0;
          try {
            return V7(n, r, u);
          } finally {
            vt.current = c;
          }
        },
        useRef: function(n) {
          return je = "useRef", nn(), or(), $7(n);
        },
        useState: function(n) {
          je = "useState", nn(), or();
          var r = vt.current;
          vt.current = b0;
          try {
            return yg(n);
          } finally {
            vt.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return je = "useDebugValue", nn(), or(), void 0;
        },
        useDeferredValue: function(n) {
          return je = "useDeferredValue", nn(), or(), Q7(n);
        },
        useTransition: function() {
          return je = "useTransition", nn(), or(), X7();
        },
        useMutableSource: function(n, r, u) {
          return je = "useMutableSource", nn(), or(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return je = "useSyncExternalStore", nn(), or(), F7(n, r, u);
        },
        useId: function() {
          return je = "useId", nn(), or(), J7();
        },
        unstable_isNewReconciler: ie
      }, p1 = {
        readContext: function(n) {
          return e9(), co(n);
        },
        useCallback: function(n, r) {
          return je = "useCallback", nn(), nt(), Mg(n, r);
        },
        useContext: function(n) {
          return je = "useContext", nn(), nt(), co(n);
        },
        useEffect: function(n, r) {
          return je = "useEffect", nn(), nt(), Xm(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return je = "useImperativeHandle", nn(), nt(), Rg(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return je = "useInsertionEffect", nn(), nt(), bg(n, r);
        },
        useLayoutEffect: function(n, r) {
          return je = "useLayoutEffect", nn(), nt(), _g(n, r);
        },
        useMemo: function(n, r) {
          je = "useMemo", nn(), nt();
          var u = vt.current;
          vt.current = p1;
          try {
            return Tg(n, r);
          } finally {
            vt.current = u;
          }
        },
        useReducer: function(n, r, u) {
          je = "useReducer", nn(), nt();
          var c = vt.current;
          vt.current = p1;
          try {
            return N7(n);
          } finally {
            vt.current = c;
          }
        },
        useRef: function(n) {
          return je = "useRef", nn(), nt(), xg();
        },
        useState: function(n) {
          je = "useState", nn(), nt();
          var r = vt.current;
          vt.current = p1;
          try {
            return U7();
          } finally {
            vt.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return je = "useDebugValue", nn(), nt(), Eg();
        },
        useDeferredValue: function(n) {
          return je = "useDeferredValue", nn(), nt(), nC(n);
        },
        useTransition: function() {
          return je = "useTransition", nn(), nt(), oC();
        },
        useMutableSource: function(n, r, u) {
          return je = "useMutableSource", nn(), nt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return je = "useSyncExternalStore", nn(), nt(), wg(n, r);
        },
        useId: function() {
          return je = "useId", nn(), nt(), Og();
        },
        unstable_isNewReconciler: ie
      }, jg = {
        readContext: function(n) {
          return e9(), co(n);
        },
        useCallback: function(n, r) {
          return je = "useCallback", nn(), nt(), Mg(n, r);
        },
        useContext: function(n) {
          return je = "useContext", nn(), nt(), co(n);
        },
        useEffect: function(n, r) {
          return je = "useEffect", nn(), nt(), Xm(n, r);
        },
        useImperativeHandle: function(n, r, u) {
          return je = "useImperativeHandle", nn(), nt(), Rg(n, r, u);
        },
        useInsertionEffect: function(n, r) {
          return je = "useInsertionEffect", nn(), nt(), bg(n, r);
        },
        useLayoutEffect: function(n, r) {
          return je = "useLayoutEffect", nn(), nt(), _g(n, r);
        },
        useMemo: function(n, r) {
          je = "useMemo", nn(), nt();
          var u = vt.current;
          vt.current = p1;
          try {
            return Tg(n, r);
          } finally {
            vt.current = u;
          }
        },
        useReducer: function(n, r, u) {
          je = "useReducer", nn(), nt();
          var c = vt.current;
          vt.current = p1;
          try {
            return B7(n);
          } finally {
            vt.current = c;
          }
        },
        useRef: function(n) {
          return je = "useRef", nn(), nt(), xg();
        },
        useState: function(n) {
          je = "useState", nn(), nt();
          var r = vt.current;
          vt.current = p1;
          try {
            return Y7();
          } finally {
            vt.current = r;
          }
        },
        useDebugValue: function(n, r) {
          return je = "useDebugValue", nn(), nt(), Eg();
        },
        useDeferredValue: function(n) {
          return je = "useDeferredValue", nn(), nt(), rC(n);
        },
        useTransition: function() {
          return je = "useTransition", nn(), nt(), iC();
        },
        useMutableSource: function(n, r, u) {
          return je = "useMutableSource", nn(), nt(), void 0;
        },
        useSyncExternalStore: function(n, r, u) {
          return je = "useSyncExternalStore", nn(), nt(), wg(n, r);
        },
        useId: function() {
          return je = "useId", nn(), nt(), Og();
        },
        unstable_isNewReconciler: ie
      };
    }
    var qd = t.unstable_now, mC = 0, Ag = -1, Jm = -1, kg = -1, t9 = !1, Lg = !1;
    function gC() {
      return t9;
    }
    function VD() {
      Lg = !0;
    }
    function ND() {
      t9 = !1, Lg = !1;
    }
    function BD() {
      t9 = Lg, Lg = !1;
    }
    function wC() {
      return mC;
    }
    function yC() {
      mC = qd();
    }
    function n9(n) {
      Jm = qd(), n.actualStartTime < 0 && (n.actualStartTime = qd());
    }
    function xC(n) {
      Jm = -1;
    }
    function Ig(n, r) {
      if (Jm >= 0) {
        var u = qd() - Jm;
        n.actualDuration += u, r && (n.selfBaseDuration = u), Jm = -1;
      }
    }
    function _0(n) {
      if (Ag >= 0) {
        var r = qd() - Ag;
        Ag = -1;
        for (var u = n.return; u !== null; ) {
          switch (u.tag) {
            case T:
              var c = u.stateNode;
              c.effectDuration += r;
              return;
            case Q:
              var p = u.stateNode;
              p.effectDuration += r;
              return;
          }
          u = u.return;
        }
      }
    }
    function r9(n) {
      if (kg >= 0) {
        var r = qd() - kg;
        kg = -1;
        for (var u = n.return; u !== null; ) {
          switch (u.tag) {
            case T:
              var c = u.stateNode;
              c !== null && (c.passiveEffectDuration += r);
              return;
            case Q:
              var p = u.stateNode;
              p !== null && (p.passiveEffectDuration += r);
              return;
          }
          u = u.return;
        }
      }
    }
    function R0() {
      Ag = qd();
    }
    function a9() {
      kg = qd();
    }
    function o9(n) {
      for (var r = n.child; r; )
        n.actualDuration += r.actualDuration, r = r.sibling;
    }
    function m1(n, r) {
      if (n && n.defaultProps) {
        var u = Gt({}, r), c = n.defaultProps;
        for (var p in c)
          u[p] === void 0 && (u[p] = c[p]);
        return u;
      }
      return r;
    }
    var i9 = {}, l9, u9, s9, c9, f9, SC, Hg, d9, h9, v9, e4;
    {
      l9 = /* @__PURE__ */ new Set(), u9 = /* @__PURE__ */ new Set(), s9 = /* @__PURE__ */ new Set(), c9 = /* @__PURE__ */ new Set(), d9 = /* @__PURE__ */ new Set(), f9 = /* @__PURE__ */ new Set(), h9 = /* @__PURE__ */ new Set(), v9 = /* @__PURE__ */ new Set(), e4 = /* @__PURE__ */ new Set();
      var CC = /* @__PURE__ */ new Set();
      Hg = function(n, r) {
        if (!(n === null || typeof n == "function")) {
          var u = r + "_" + n;
          CC.has(u) || (CC.add(u), m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, n));
        }
      }, SC = function(n, r) {
        if (r === void 0) {
          var u = In(n) || "Component";
          f9.has(u) || (f9.add(u), m("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", u));
        }
      }, Object.defineProperty(i9, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(i9);
    }
    function p9(n, r, u, c) {
      var p = n.memoizedState, x = u(c, p);
      {
        if (n.mode & _r) {
          pr(!0);
          try {
            x = u(c, p);
          } finally {
            pr(!1);
          }
        }
        SC(r, x);
      }
      var _ = x == null ? p : Gt({}, p, x);
      if (n.memoizedState = _, n.lanes === He) {
        var O = n.updateQueue;
        O.baseState = _;
      }
    }
    var m9 = {
      isMounted: Il,
      enqueueSetState: function(n, r, u) {
        var c = Xo(n), p = yl(), x = Xd(c), _ = Qc(p, x);
        _.payload = r, u != null && (Hg(u, "setState"), _.callback = u);
        var O = Yd(c, _, x);
        O !== null && (Oo(O, c, x, p), fg(O, c, x)), e0(c, x);
      },
      enqueueReplaceState: function(n, r, u) {
        var c = Xo(n), p = yl(), x = Xd(c), _ = Qc(p, x);
        _.tag = VS, _.payload = r, u != null && (Hg(u, "replaceState"), _.callback = u);
        var O = Yd(c, _, x);
        O !== null && (Oo(O, c, x, p), fg(O, c, x)), e0(c, x);
      },
      enqueueForceUpdate: function(n, r) {
        var u = Xo(n), c = yl(), p = Xd(u), x = Qc(c, p);
        x.tag = ug, r != null && (Hg(r, "forceUpdate"), x.callback = r);
        var _ = Yd(u, x, p);
        _ !== null && (Oo(_, u, p, c), fg(_, u, p)), Fh(u, p);
      }
    };
    function bC(n, r, u, c, p, x, _) {
      var O = n.stateNode;
      if (typeof O.shouldComponentUpdate == "function") {
        var k = O.shouldComponentUpdate(c, x, _);
        {
          if (n.mode & _r) {
            pr(!0);
            try {
              k = O.shouldComponentUpdate(c, x, _);
            } finally {
              pr(!1);
            }
          }
          k === void 0 && m("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", In(r) || "Component");
        }
        return k;
      }
      return r.prototype && r.prototype.isPureReactComponent ? !ne(u, c) || !ne(p, x) : !0;
    }
    function FD(n, r, u) {
      var c = n.stateNode;
      {
        var p = In(r) || "Component", x = c.render;
        x || (r.prototype && typeof r.prototype.render == "function" ? m("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", p) : m("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", p)), c.getInitialState && !c.getInitialState.isReactClassApproved && !c.state && m("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", p), c.getDefaultProps && !c.getDefaultProps.isReactClassApproved && m("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", p), c.propTypes && m("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", p), c.contextType && m("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", p), r.childContextTypes && !e4.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (n.mode & _r) === tt && (e4.add(r), m(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, p)), r.contextTypes && !e4.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (n.mode & _r) === tt && (e4.add(r), m(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, p)), c.contextTypes && m("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", p), r.contextType && r.contextTypes && !h9.has(r) && (h9.add(r), m("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", p)), typeof c.componentShouldUpdate == "function" && m("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", p), r.prototype && r.prototype.isPureReactComponent && typeof c.shouldComponentUpdate < "u" && m("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", In(r) || "A pure component"), typeof c.componentDidUnmount == "function" && m("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", p), typeof c.componentDidReceiveProps == "function" && m("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", p), typeof c.componentWillRecieveProps == "function" && m("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", p), typeof c.UNSAFE_componentWillRecieveProps == "function" && m("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", p);
        var _ = c.props !== u;
        c.props !== void 0 && _ && m("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", p, p), c.defaultProps && m("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", p, p), typeof c.getSnapshotBeforeUpdate == "function" && typeof c.componentDidUpdate != "function" && !s9.has(r) && (s9.add(r), m("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", In(r))), typeof c.getDerivedStateFromProps == "function" && m("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", p), typeof c.getDerivedStateFromError == "function" && m("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", p), typeof r.getSnapshotBeforeUpdate == "function" && m("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", p);
        var O = c.state;
        O && (typeof O != "object" || ra(O)) && m("%s.state: must be set to an object or null", p), typeof c.getChildContext == "function" && typeof r.childContextTypes != "object" && m("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", p);
      }
    }
    function _C(n, r) {
      r.updater = m9, n.stateNode = r, Xf(r, n), r._reactInternalInstance = i9;
    }
    function RC(n, r, u) {
      var c = !1, p = $n, x = $n, _ = r.contextType;
      if ("contextType" in r) {
        var O = (
          // Allow null for conditional declaration
          _ === null || _ !== void 0 && _.$$typeof === tu && _._context === void 0
        );
        if (!O && !v9.has(r)) {
          v9.add(r);
          var k = "";
          _ === void 0 ? k = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof _ != "object" ? k = " However, it is set to a " + typeof _ + "." : _.$$typeof === js ? k = " Did you accidentally pass the Context.Provider instead?" : _._context !== void 0 ? k = " Did you accidentally pass the Context.Consumer instead?" : k = " However, it is set to an object with keys {" + Object.keys(_).join(", ") + "}.", m("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", In(r) || "Component", k);
        }
      }
      if (typeof _ == "object" && _ !== null)
        x = co(_);
      else {
        p = $v(n, r, !0);
        var N = r.contextTypes;
        c = N != null, x = c ? Wv(n, p) : $n;
      }
      var U = new r(u, x);
      if (n.mode & _r) {
        pr(!0);
        try {
          U = new r(u, x);
        } finally {
          pr(!1);
        }
      }
      var oe = n.memoizedState = U.state !== null && U.state !== void 0 ? U.state : null;
      _C(n, U);
      {
        if (typeof r.getDerivedStateFromProps == "function" && oe === null) {
          var ae = In(r) || "Component";
          u9.has(ae) || (u9.add(ae), m("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", ae, U.state === null ? "null" : "undefined", ae));
        }
        if (typeof r.getDerivedStateFromProps == "function" || typeof U.getSnapshotBeforeUpdate == "function") {
          var we = null, Ce = null, Ee = null;
          if (typeof U.componentWillMount == "function" && U.componentWillMount.__suppressDeprecationWarning !== !0 ? we = "componentWillMount" : typeof U.UNSAFE_componentWillMount == "function" && (we = "UNSAFE_componentWillMount"), typeof U.componentWillReceiveProps == "function" && U.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ce = "componentWillReceiveProps" : typeof U.UNSAFE_componentWillReceiveProps == "function" && (Ce = "UNSAFE_componentWillReceiveProps"), typeof U.componentWillUpdate == "function" && U.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Ee = "componentWillUpdate" : typeof U.UNSAFE_componentWillUpdate == "function" && (Ee = "UNSAFE_componentWillUpdate"), we !== null || Ce !== null || Ee !== null) {
            var it = In(r) || "Component", Ut = typeof r.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            c9.has(it) || (c9.add(it), m(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, it, Ut, we !== null ? `
  ` + we : "", Ce !== null ? `
  ` + Ce : "", Ee !== null ? `
  ` + Ee : ""));
          }
        }
      }
      return c && vS(n, p, x), U;
    }
    function UD(n, r) {
      var u = r.state;
      typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount(), u !== r.state && (m("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", en(n) || "Component"), m9.enqueueReplaceState(r, r.state, null));
    }
    function EC(n, r, u, c) {
      var p = r.state;
      if (typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(u, c), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(u, c), r.state !== p) {
        {
          var x = en(n) || "Component";
          l9.has(x) || (l9.add(x), m("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", x));
        }
        m9.enqueueReplaceState(r, r.state, null);
      }
    }
    function g9(n, r, u, c) {
      FD(n, r, u);
      var p = n.stateNode;
      p.props = u, p.state = n.memoizedState, p.refs = {}, E7(n);
      var x = r.contextType;
      if (typeof x == "object" && x !== null)
        p.context = co(x);
      else {
        var _ = $v(n, r, !0);
        p.context = Wv(n, _);
      }
      {
        if (p.state === u) {
          var O = In(r) || "Component";
          d9.has(O) || (d9.add(O), m("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", O));
        }
        n.mode & _r && h1.recordLegacyContextWarning(n, p), h1.recordUnsafeLifecycleWarnings(n, p);
      }
      p.state = n.memoizedState;
      var k = r.getDerivedStateFromProps;
      if (typeof k == "function" && (p9(n, r, k, u), p.state = n.memoizedState), typeof r.getDerivedStateFromProps != "function" && typeof p.getSnapshotBeforeUpdate != "function" && (typeof p.UNSAFE_componentWillMount == "function" || typeof p.componentWillMount == "function") && (UD(n, p), dg(n, u, p, c), p.state = n.memoizedState), typeof p.componentDidMount == "function") {
        var N = zt;
        N |= qu, (n.mode & Po) !== tt && (N |= el), n.flags |= N;
      }
    }
    function YD(n, r, u, c) {
      var p = n.stateNode, x = n.memoizedProps;
      p.props = x;
      var _ = p.context, O = r.contextType, k = $n;
      if (typeof O == "object" && O !== null)
        k = co(O);
      else {
        var N = $v(n, r, !0);
        k = Wv(n, N);
      }
      var U = r.getDerivedStateFromProps, oe = typeof U == "function" || typeof p.getSnapshotBeforeUpdate == "function";
      !oe && (typeof p.UNSAFE_componentWillReceiveProps == "function" || typeof p.componentWillReceiveProps == "function") && (x !== u || _ !== k) && EC(n, p, u, k), BS();
      var ae = n.memoizedState, we = p.state = ae;
      if (dg(n, u, p, c), we = n.memoizedState, x === u && ae === we && !z3() && !hg()) {
        if (typeof p.componentDidMount == "function") {
          var Ce = zt;
          Ce |= qu, (n.mode & Po) !== tt && (Ce |= el), n.flags |= Ce;
        }
        return !1;
      }
      typeof U == "function" && (p9(n, r, U, u), we = n.memoizedState);
      var Ee = hg() || bC(n, r, x, u, ae, we, k);
      if (Ee) {
        if (!oe && (typeof p.UNSAFE_componentWillMount == "function" || typeof p.componentWillMount == "function") && (typeof p.componentWillMount == "function" && p.componentWillMount(), typeof p.UNSAFE_componentWillMount == "function" && p.UNSAFE_componentWillMount()), typeof p.componentDidMount == "function") {
          var it = zt;
          it |= qu, (n.mode & Po) !== tt && (it |= el), n.flags |= it;
        }
      } else {
        if (typeof p.componentDidMount == "function") {
          var Ut = zt;
          Ut |= qu, (n.mode & Po) !== tt && (Ut |= el), n.flags |= Ut;
        }
        n.memoizedProps = u, n.memoizedState = we;
      }
      return p.props = u, p.state = we, p.context = k, Ee;
    }
    function $D(n, r, u, c, p) {
      var x = r.stateNode;
      NS(n, r);
      var _ = r.memoizedProps, O = r.type === r.elementType ? _ : m1(r.type, _);
      x.props = O;
      var k = r.pendingProps, N = x.context, U = u.contextType, oe = $n;
      if (typeof U == "object" && U !== null)
        oe = co(U);
      else {
        var ae = $v(r, u, !0);
        oe = Wv(r, ae);
      }
      var we = u.getDerivedStateFromProps, Ce = typeof we == "function" || typeof x.getSnapshotBeforeUpdate == "function";
      !Ce && (typeof x.UNSAFE_componentWillReceiveProps == "function" || typeof x.componentWillReceiveProps == "function") && (_ !== k || N !== oe) && EC(r, x, c, oe), BS();
      var Ee = r.memoizedState, it = x.state = Ee;
      if (dg(r, c, x, p), it = r.memoizedState, _ === k && Ee === it && !z3() && !hg())
        return typeof x.componentDidUpdate == "function" && (_ !== n.memoizedProps || Ee !== n.memoizedState) && (r.flags |= zt), typeof x.getSnapshotBeforeUpdate == "function" && (_ !== n.memoizedProps || Ee !== n.memoizedState) && (r.flags |= Yn), !1;
      typeof we == "function" && (p9(r, u, we, c), it = r.memoizedState);
      var Ut = hg() || bC(r, u, O, c, Ee, it, oe) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      _e;
      return Ut ? (!Ce && (typeof x.UNSAFE_componentWillUpdate == "function" || typeof x.componentWillUpdate == "function") && (typeof x.componentWillUpdate == "function" && x.componentWillUpdate(c, it, oe), typeof x.UNSAFE_componentWillUpdate == "function" && x.UNSAFE_componentWillUpdate(c, it, oe)), typeof x.componentDidUpdate == "function" && (r.flags |= zt), typeof x.getSnapshotBeforeUpdate == "function" && (r.flags |= Yn)) : (typeof x.componentDidUpdate == "function" && (_ !== n.memoizedProps || Ee !== n.memoizedState) && (r.flags |= zt), typeof x.getSnapshotBeforeUpdate == "function" && (_ !== n.memoizedProps || Ee !== n.memoizedState) && (r.flags |= Yn), r.memoizedProps = c, r.memoizedState = it), x.props = c, x.state = it, x.context = oe, Ut;
    }
    function C2(n, r) {
      return {
        value: n,
        source: r,
        stack: L1(r),
        digest: null
      };
    }
    function w9(n, r, u) {
      return {
        value: n,
        source: null,
        stack: u ?? null,
        digest: r ?? null
      };
    }
    function WD(n, r) {
      return !0;
    }
    function y9(n, r) {
      try {
        var u = WD();
        if (u === !1)
          return;
        var c = r.value;
        {
          var p = r.source, x = r.stack, _ = x !== null ? x : "";
          if (c != null && c._suppressLogging) {
            if (n.tag === R)
              return;
            console.error(c);
          }
          var O = p ? en(p) : null, k = O ? "The above error occurred in the <" + O + "> component:" : "The above error occurred in one of your React components:", N;
          if (n.tag === T)
            N = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
          else {
            var U = en(n) || "Anonymous";
            N = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + U + ".");
          }
          var oe = k + `
` + _ + `

` + ("" + N);
          console.error(oe);
        }
      } catch (ae) {
        setTimeout(function() {
          throw ae;
        });
      }
    }
    var zD = typeof WeakMap == "function" ? WeakMap : Map;
    function MC(n, r, u) {
      var c = Qc(dr, u);
      c.tag = _7, c.payload = {
        element: null
      };
      var p = r.value;
      return c.callback = function() {
        PA(p), y9(n, r);
      }, c;
    }
    function x9(n, r, u) {
      var c = Qc(dr, u);
      c.tag = _7;
      var p = n.type.getDerivedStateFromError;
      if (typeof p == "function") {
        var x = r.value;
        c.payload = function() {
          return p(x);
        }, c.callback = function() {
          Pb(n), y9(n, r);
        };
      }
      var _ = n.stateNode;
      return _ !== null && typeof _.componentDidCatch == "function" && (c.callback = function() {
        Pb(n), y9(n, r), typeof p != "function" && HA(this);
        var k = r.value, N = r.stack;
        this.componentDidCatch(k, {
          componentStack: N !== null ? N : ""
        }), typeof p != "function" && (oo(n.lanes, It) || m("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", en(n) || "Unknown"));
      }), c;
    }
    function TC(n, r, u) {
      var c = n.pingCache, p;
      if (c === null ? (c = n.pingCache = new zD(), p = /* @__PURE__ */ new Set(), c.set(r, p)) : (p = c.get(r), p === void 0 && (p = /* @__PURE__ */ new Set(), c.set(r, p))), !p.has(u)) {
        p.add(u);
        var x = VA.bind(null, n, r, u);
        Zn && g4(n, u), r.then(x, x);
      }
    }
    function qD(n, r, u, c) {
      var p = n.updateQueue;
      if (p === null) {
        var x = /* @__PURE__ */ new Set();
        x.add(u), n.updateQueue = x;
      } else
        p.add(u);
    }
    function GD(n, r) {
      var u = n.tag;
      if ((n.mode & on) === tt && (u === S || u === W || u === te)) {
        var c = n.alternate;
        c ? (n.updateQueue = c.updateQueue, n.memoizedState = c.memoizedState, n.lanes = c.lanes) : (n.updateQueue = null, n.memoizedState = null);
      }
    }
    function OC(n) {
      var r = n;
      do {
        if (r.tag === $ && OD(r))
          return r;
        r = r.return;
      } while (r !== null);
      return null;
    }
    function DC(n, r, u, c, p) {
      if ((n.mode & on) === tt) {
        if (n === r)
          n.flags |= Io;
        else {
          if (n.flags |= vn, u.flags |= ed, u.flags &= -52805, u.tag === R) {
            var x = u.alternate;
            if (x === null)
              u.tag = re;
            else {
              var _ = Qc(dr, It);
              _.tag = ug, Yd(u, _, It);
            }
          }
          u.lanes = At(u.lanes, It);
        }
        return n;
      }
      return n.flags |= Io, n.lanes = p, n;
    }
    function KD(n, r, u, c, p) {
      if (u.flags |= Ua, Zn && g4(n, p), c !== null && typeof c == "object" && typeof c.then == "function") {
        var x = c;
        GD(u), vi() && u.mode & on && SS();
        var _ = OC(r);
        if (_ !== null) {
          _.flags &= -257, DC(_, r, u, n, p), _.mode & on && TC(n, x, p), qD(_, n, x);
          return;
        } else {
          if (!dd(p)) {
            TC(n, x, p), X9();
            return;
          }
          var O = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          c = O;
        }
      } else if (vi() && u.mode & on) {
        SS();
        var k = OC(r);
        if (k !== null) {
          (k.flags & Io) === H && (k.flags |= ia), DC(k, r, u, n, p), d7(C2(c, u));
          return;
        }
      }
      c = C2(c, u), TA(c);
      var N = r;
      do {
        switch (N.tag) {
          case T: {
            var U = c;
            N.flags |= Io;
            var oe = xu(p);
            N.lanes = At(N.lanes, oe);
            var ae = MC(N, U, oe);
            M7(N, ae);
            return;
          }
          case R:
            var we = c, Ce = N.type, Ee = N.stateNode;
            if ((N.flags & vn) === H && (typeof Ce.getDerivedStateFromError == "function" || Ee !== null && typeof Ee.componentDidCatch == "function" && !Ob(Ee))) {
              N.flags |= Io;
              var it = xu(p);
              N.lanes = At(N.lanes, it);
              var Ut = x9(N, we, it);
              M7(N, Ut);
              return;
            }
            break;
        }
        N = N.return;
      } while (N !== null);
    }
    function QD() {
      return null;
    }
    var t4 = a.ReactCurrentOwner, g1 = !1, S9, n4, C9, b9, _9, b2, R9, Zg, r4;
    S9 = {}, n4 = {}, C9 = {}, b9 = {}, _9 = {}, b2 = !1, R9 = {}, Zg = {}, r4 = {};
    function gl(n, r, u, c) {
      n === null ? r.child = kS(r, null, u, c) : r.child = Kv(r, n.child, u, c);
    }
    function XD(n, r, u, c) {
      r.child = Kv(r, n.child, null, c), r.child = Kv(r, null, u, c);
    }
    function jC(n, r, u, c, p) {
      if (r.type !== r.elementType) {
        var x = u.propTypes;
        x && kt(
          x,
          c,
          // Resolved props
          "prop",
          In(u)
        );
      }
      var _ = u.render, O = r.ref, k, N;
      Xv(r, p), ol(r);
      {
        if (t4.current = r, Pa(!0), k = ap(n, r, _, c, O, p), N = op(), r.mode & _r) {
          pr(!0);
          try {
            k = ap(n, r, _, c, O, p), N = op();
          } finally {
            pr(!1);
          }
        }
        Pa(!1);
      }
      return Xu(), n !== null && !g1 ? (zS(n, r, p), Xc(n, r, p)) : (vi() && N && i7(r), r.flags |= Xi, gl(n, r, k, p), r.child);
    }
    function AC(n, r, u, c, p) {
      if (n === null) {
        var x = u.type;
        if (nk(x) && u.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        u.defaultProps === void 0) {
          var _ = x;
          return _ = hp(x), r.tag = te, r.type = _, T9(r, x), kC(n, r, _, c, p);
        }
        {
          var O = x.propTypes;
          if (O && kt(
            O,
            c,
            // Resolved props
            "prop",
            In(x)
          ), u.defaultProps !== void 0) {
            var k = In(x) || "Unknown";
            r4[k] || (m("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", k), r4[k] = !0);
          }
        }
        var N = s8(u.type, null, c, r, r.mode, p);
        return N.ref = r.ref, N.return = r, r.child = N, N;
      }
      {
        var U = u.type, oe = U.propTypes;
        oe && kt(
          oe,
          c,
          // Resolved props
          "prop",
          In(U)
        );
      }
      var ae = n.child, we = L9(n, p);
      if (!we) {
        var Ce = ae.memoizedProps, Ee = u.compare;
        if (Ee = Ee !== null ? Ee : ne, Ee(Ce, c) && n.ref === r.ref)
          return Xc(n, r, p);
      }
      r.flags |= Xi;
      var it = T2(ae, c);
      return it.ref = r.ref, it.return = r, r.child = it, it;
    }
    function kC(n, r, u, c, p) {
      if (r.type !== r.elementType) {
        var x = r.elementType;
        if (x.$$typeof === Et) {
          var _ = x, O = _._payload, k = _._init;
          try {
            x = k(O);
          } catch {
            x = null;
          }
          var N = x && x.propTypes;
          N && kt(
            N,
            c,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            In(x)
          );
        }
      }
      if (n !== null) {
        var U = n.memoizedProps;
        if (ne(U, c) && n.ref === r.ref && // Prevent bailout if the implementation changed due to hot reload.
        r.type === n.type)
          if (g1 = !1, r.pendingProps = c = U, L9(n, p))
            (n.flags & ed) !== H && (g1 = !0);
          else return r.lanes = n.lanes, Xc(n, r, p);
      }
      return E9(n, r, u, c, p);
    }
    function LC(n, r, u) {
      var c = r.pendingProps, p = c.children, x = n !== null ? n.memoizedState : null;
      if (c.mode === "hidden" || Ze)
        if ((r.mode & on) === tt) {
          var _ = {
            baseLanes: He,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = _, Kg(r, u);
        } else if (oo(u, Vo)) {
          var oe = {
            baseLanes: He,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = oe;
          var ae = x !== null ? x.baseLanes : u;
          Kg(r, ae);
        } else {
          var O = null, k;
          if (x !== null) {
            var N = x.baseLanes;
            k = At(N, u);
          } else
            k = u;
          r.lanes = r.childLanes = Vo;
          var U = {
            baseLanes: k,
            cachePool: O,
            transitions: null
          };
          return r.memoizedState = U, r.updateQueue = null, Kg(r, k), null;
        }
      else {
        var we;
        x !== null ? (we = At(x.baseLanes, u), r.memoizedState = null) : we = u, Kg(r, we);
      }
      return gl(n, r, p, u), r.child;
    }
    function JD(n, r, u) {
      var c = r.pendingProps;
      return gl(n, r, c, u), r.child;
    }
    function ej(n, r, u) {
      var c = r.pendingProps.children;
      return gl(n, r, c, u), r.child;
    }
    function tj(n, r, u) {
      {
        r.flags |= zt;
        {
          var c = r.stateNode;
          c.effectDuration = 0, c.passiveEffectDuration = 0;
        }
      }
      var p = r.pendingProps, x = p.children;
      return gl(n, r, x, u), r.child;
    }
    function IC(n, r) {
      var u = r.ref;
      (n === null && u !== null || n !== null && n.ref !== u) && (r.flags |= Un, r.flags |= Ho);
    }
    function E9(n, r, u, c, p) {
      if (r.type !== r.elementType) {
        var x = u.propTypes;
        x && kt(
          x,
          c,
          // Resolved props
          "prop",
          In(u)
        );
      }
      var _;
      {
        var O = $v(r, u, !0);
        _ = Wv(r, O);
      }
      var k, N;
      Xv(r, p), ol(r);
      {
        if (t4.current = r, Pa(!0), k = ap(n, r, u, c, _, p), N = op(), r.mode & _r) {
          pr(!0);
          try {
            k = ap(n, r, u, c, _, p), N = op();
          } finally {
            pr(!1);
          }
        }
        Pa(!1);
      }
      return Xu(), n !== null && !g1 ? (zS(n, r, p), Xc(n, r, p)) : (vi() && N && i7(r), r.flags |= Xi, gl(n, r, k, p), r.child);
    }
    function HC(n, r, u, c, p) {
      {
        switch (gk(r)) {
          case !1: {
            var x = r.stateNode, _ = r.type, O = new _(r.memoizedProps, x.context), k = O.state;
            x.updater.enqueueSetState(x, k, null);
            break;
          }
          case !0: {
            r.flags |= vn, r.flags |= Io;
            var N = new Error("Simulated error coming from DevTools"), U = xu(p);
            r.lanes = At(r.lanes, U);
            var oe = x9(r, C2(N, r), U);
            M7(r, oe);
            break;
          }
        }
        if (r.type !== r.elementType) {
          var ae = u.propTypes;
          ae && kt(
            ae,
            c,
            // Resolved props
            "prop",
            In(u)
          );
        }
      }
      var we;
      x0(u) ? (we = !0, G3(r)) : we = !1, Xv(r, p);
      var Ce = r.stateNode, Ee;
      Ce === null ? (Vg(n, r), RC(r, u, c), g9(r, u, c, p), Ee = !0) : n === null ? Ee = YD(r, u, c, p) : Ee = $D(n, r, u, c, p);
      var it = M9(n, r, u, Ee, we, p);
      {
        var Ut = r.stateNode;
        Ee && Ut.props !== c && (b2 || m("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", en(r) || "a component"), b2 = !0);
      }
      return it;
    }
    function M9(n, r, u, c, p, x) {
      IC(n, r);
      var _ = (r.flags & vn) !== H;
      if (!c && !_)
        return p && gS(r, u, !1), Xc(n, r, x);
      var O = r.stateNode;
      t4.current = r;
      var k;
      if (_ && typeof u.getDerivedStateFromError != "function")
        k = null, xC();
      else {
        ol(r);
        {
          if (Pa(!0), k = O.render(), r.mode & _r) {
            pr(!0);
            try {
              O.render();
            } finally {
              pr(!1);
            }
          }
          Pa(!1);
        }
        Xu();
      }
      return r.flags |= Xi, n !== null && _ ? XD(n, r, k, x) : gl(n, r, k, x), r.memoizedState = O.state, p && gS(r, u, !0), r.child;
    }
    function ZC(n) {
      var r = n.stateNode;
      r.pendingContext ? pS(n, r.pendingContext, r.pendingContext !== r.context) : r.context && pS(n, r.context, !1), T7(n, r.containerInfo);
    }
    function nj(n, r, u) {
      if (ZC(r), n === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var c = r.pendingProps, p = r.memoizedState, x = p.element;
      NS(n, r), dg(r, c, null, u);
      var _ = r.memoizedState, O = _.element;
      if (p.isDehydrated) {
        var k = {
          element: O,
          isDehydrated: !1,
          cache: _.cache,
          pendingSuspenseBoundaries: _.pendingSuspenseBoundaries,
          transitions: _.transitions
        }, N = r.updateQueue;
        if (N.baseState = k, r.memoizedState = k, r.flags & ia) {
          var U = C2(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), r);
          return PC(n, r, O, u, U);
        } else if (O !== x) {
          var oe = C2(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), r);
          return PC(n, r, O, u, oe);
        } else {
          oD(r);
          var ae = kS(r, null, O, u);
          r.child = ae;
          for (var we = ae; we; )
            we.flags = we.flags & -3 | Zr, we = we.sibling;
        }
      } else {
        if (Gv(), O === x)
          return Xc(n, r, u);
        gl(n, r, O, u);
      }
      return r.child;
    }
    function PC(n, r, u, c, p) {
      return Gv(), d7(p), r.flags |= ia, gl(n, r, u, c), r.child;
    }
    function rj(n, r, u) {
      YS(r), n === null && f7(r);
      var c = r.type, p = r.pendingProps, x = n !== null ? n.memoizedProps : null, _ = p.children, O = _m(c, p);
      return O ? _ = null : x !== null && _m(c, x) && (r.flags |= Fs), IC(n, r), gl(n, r, _, u), r.child;
    }
    function aj(n, r) {
      return n === null && f7(r), null;
    }
    function oj(n, r, u, c) {
      Vg(n, r);
      var p = r.pendingProps, x = u, _ = x._payload, O = x._init, k = O(_);
      r.type = k;
      var N = r.tag = rk(k), U = m1(k, p), oe;
      switch (N) {
        case S:
          return T9(r, k), r.type = k = hp(k), oe = E9(null, r, k, U, c), oe;
        case R:
          return r.type = k = r8(k), oe = HC(null, r, k, U, c), oe;
        case W:
          return r.type = k = a8(k), oe = jC(null, r, k, U, c), oe;
        case le: {
          if (r.type !== r.elementType) {
            var ae = k.propTypes;
            ae && kt(
              ae,
              U,
              // Resolved for outer only
              "prop",
              In(k)
            );
          }
          return oe = AC(
            null,
            r,
            k,
            m1(k.type, U),
            // The inner type can have defaults too
            c
          ), oe;
        }
      }
      var we = "";
      throw k !== null && typeof k == "object" && k.$$typeof === Et && (we = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + k + ". " + ("Lazy element type must resolve to a class or function." + we));
    }
    function ij(n, r, u, c, p) {
      Vg(n, r), r.tag = R;
      var x;
      return x0(u) ? (x = !0, G3(r)) : x = !1, Xv(r, p), RC(r, u, c), g9(r, u, c, p), M9(null, r, u, !0, x, p);
    }
    function lj(n, r, u, c) {
      Vg(n, r);
      var p = r.pendingProps, x;
      {
        var _ = $v(r, u, !1);
        x = Wv(r, _);
      }
      Xv(r, c);
      var O, k;
      ol(r);
      {
        if (u.prototype && typeof u.prototype.render == "function") {
          var N = In(u) || "Unknown";
          S9[N] || (m("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", N, N), S9[N] = !0);
        }
        r.mode & _r && h1.recordLegacyContextWarning(r, null), Pa(!0), t4.current = r, O = ap(null, r, u, p, x, c), k = op(), Pa(!1);
      }
      if (Xu(), r.flags |= Xi, typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0) {
        var U = In(u) || "Unknown";
        n4[U] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", U, U, U), n4[U] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0
      ) {
        {
          var oe = In(u) || "Unknown";
          n4[oe] || (m("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", oe, oe, oe), n4[oe] = !0);
        }
        r.tag = R, r.memoizedState = null, r.updateQueue = null;
        var ae = !1;
        return x0(u) ? (ae = !0, G3(r)) : ae = !1, r.memoizedState = O.state !== null && O.state !== void 0 ? O.state : null, E7(r), _C(r, O), g9(r, u, p, c), M9(null, r, u, !0, ae, c);
      } else {
        if (r.tag = S, r.mode & _r) {
          pr(!0);
          try {
            O = ap(null, r, u, p, x, c), k = op();
          } finally {
            pr(!1);
          }
        }
        return vi() && k && i7(r), gl(null, r, O, c), T9(r, u), r.child;
      }
    }
    function T9(n, r) {
      {
        if (r && r.childContextTypes && m("%s(...): childContextTypes cannot be defined on a function component.", r.displayName || r.name || "Component"), n.ref !== null) {
          var u = "", c = Ls();
          c && (u += `

Check the render method of \`` + c + "`.");
          var p = c || "", x = n._debugSource;
          x && (p = x.fileName + ":" + x.lineNumber), _9[p] || (_9[p] = !0, m("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", u));
        }
        if (r.defaultProps !== void 0) {
          var _ = In(r) || "Unknown";
          r4[_] || (m("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", _), r4[_] = !0);
        }
        if (typeof r.getDerivedStateFromProps == "function") {
          var O = In(r) || "Unknown";
          b9[O] || (m("%s: Function components do not support getDerivedStateFromProps.", O), b9[O] = !0);
        }
        if (typeof r.contextType == "object" && r.contextType !== null) {
          var k = In(r) || "Unknown";
          C9[k] || (m("%s: Function components do not support contextType.", k), C9[k] = !0);
        }
      }
    }
    var O9 = {
      dehydrated: null,
      treeContext: null,
      retryLane: Vr
    };
    function D9(n) {
      return {
        baseLanes: n,
        cachePool: QD(),
        transitions: null
      };
    }
    function uj(n, r) {
      var u = null;
      return {
        baseLanes: At(n.baseLanes, r),
        cachePool: u,
        transitions: n.transitions
      };
    }
    function sj(n, r, u, c) {
      if (r !== null) {
        var p = r.memoizedState;
        if (p === null)
          return !1;
      }
      return j7(n, Wm);
    }
    function cj(n, r) {
      return Oc(n.childLanes, r);
    }
    function VC(n, r, u) {
      var c = r.pendingProps;
      wk(r) && (r.flags |= vn);
      var p = v1.current, x = !1, _ = (r.flags & vn) !== H;
      if (_ || sj(p, n) ? (x = !0, r.flags &= -129) : (n === null || n.memoizedState !== null) && (p = TD(p, WS)), p = ep(p), Wd(r, p), n === null) {
        f7(r);
        var O = r.memoizedState;
        if (O !== null) {
          var k = O.dehydrated;
          if (k !== null)
            return pj(r, k);
        }
        var N = c.children, U = c.fallback;
        if (x) {
          var oe = fj(r, N, U, u), ae = r.child;
          return ae.memoizedState = D9(u), r.memoizedState = O9, oe;
        } else
          return j9(r, N);
      } else {
        var we = n.memoizedState;
        if (we !== null) {
          var Ce = we.dehydrated;
          if (Ce !== null)
            return mj(n, r, _, c, Ce, we, u);
        }
        if (x) {
          var Ee = c.fallback, it = c.children, Ut = hj(n, r, it, Ee, u), Lt = r.child, Dn = n.child.memoizedState;
          return Lt.memoizedState = Dn === null ? D9(u) : uj(Dn, u), Lt.childLanes = cj(n, u), r.memoizedState = O9, Ut;
        } else {
          var xn = c.children, pe = dj(n, r, xn, u);
          return r.memoizedState = null, pe;
        }
      }
    }
    function j9(n, r, u) {
      var c = n.mode, p = {
        mode: "visible",
        children: r
      }, x = A9(p, c);
      return x.return = n, n.child = x, x;
    }
    function fj(n, r, u, c) {
      var p = n.mode, x = n.child, _ = {
        mode: "hidden",
        children: r
      }, O, k;
      return (p & on) === tt && x !== null ? (O = x, O.childLanes = He, O.pendingProps = _, n.mode & Pn && (O.actualDuration = 0, O.actualStartTime = -1, O.selfBaseDuration = 0, O.treeBaseDuration = 0), k = eh(u, p, c, null)) : (O = A9(_, p), k = eh(u, p, c, null)), O.return = n, k.return = n, O.sibling = k, n.child = O, k;
    }
    function A9(n, r, u) {
      return Vb(n, r, He, null);
    }
    function NC(n, r) {
      return T2(n, r);
    }
    function dj(n, r, u, c) {
      var p = n.child, x = p.sibling, _ = NC(p, {
        mode: "visible",
        children: u
      });
      if ((r.mode & on) === tt && (_.lanes = c), _.return = r, _.sibling = null, x !== null) {
        var O = r.deletions;
        O === null ? (r.deletions = [x], r.flags |= Kt) : O.push(x);
      }
      return r.child = _, _;
    }
    function hj(n, r, u, c, p) {
      var x = r.mode, _ = n.child, O = _.sibling, k = {
        mode: "hidden",
        children: u
      }, N;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (x & on) === tt && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        r.child !== _
      ) {
        var U = r.child;
        N = U, N.childLanes = He, N.pendingProps = k, r.mode & Pn && (N.actualDuration = 0, N.actualStartTime = -1, N.selfBaseDuration = _.selfBaseDuration, N.treeBaseDuration = _.treeBaseDuration), r.deletions = null;
      } else
        N = NC(_, k), N.subtreeFlags = _.subtreeFlags & Mr;
      var oe;
      return O !== null ? oe = T2(O, c) : (oe = eh(c, x, p, null), oe.flags |= fr), oe.return = r, N.return = r, N.sibling = oe, r.child = N, oe;
    }
    function Pg(n, r, u, c) {
      c !== null && d7(c), Kv(r, n.child, null, u);
      var p = r.pendingProps, x = p.children, _ = j9(r, x);
      return _.flags |= fr, r.memoizedState = null, _;
    }
    function vj(n, r, u, c, p) {
      var x = r.mode, _ = {
        mode: "visible",
        children: u
      }, O = A9(_, x), k = eh(c, x, p, null);
      return k.flags |= fr, O.return = r, k.return = r, O.sibling = k, r.child = O, (r.mode & on) !== tt && Kv(r, n.child, null, p), k;
    }
    function pj(n, r, u) {
      return (n.mode & on) === tt ? (m("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), n.lanes = It) : jm(r) ? n.lanes = yu : n.lanes = Vo, null;
    }
    function mj(n, r, u, c, p, x, _) {
      if (u)
        if (r.flags & ia) {
          r.flags &= -257;
          var pe = w9(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return Pg(n, r, _, pe);
        } else {
          if (r.memoizedState !== null)
            return r.child = n.child, r.flags |= vn, null;
          var Me = c.children, me = c.fallback, We = vj(n, r, Me, me, _), pt = r.child;
          return pt.memoizedState = D9(_), r.memoizedState = O9, We;
        }
      else {
        if (rD(), (r.mode & on) === tt)
          return Pg(
            n,
            r,
            _,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (jm(p)) {
          var O, k, N;
          {
            var U = L6(p);
            O = U.digest, k = U.message, N = U.stack;
          }
          var oe;
          k ? oe = new Error(k) : oe = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var ae = w9(oe, O, N);
          return Pg(n, r, _, ae);
        }
        var we = oo(_, n.childLanes);
        if (g1 || we) {
          var Ce = Gg();
          if (Ce !== null) {
            var Ee = jc(Ce, _);
            if (Ee !== Vr && Ee !== x.retryLane) {
              x.retryLane = Ee;
              var it = dr;
              $l(n, Ee), Oo(Ce, n, Ee, it);
            }
          }
          X9();
          var Ut = w9(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return Pg(n, r, _, Ut);
        } else if (Y3(p)) {
          r.flags |= vn, r.child = n.child;
          var Lt = NA.bind(null, n);
          return Am(p, Lt), null;
        } else {
          iD(r, p, x.treeContext);
          var Dn = c.children, xn = j9(r, Dn);
          return xn.flags |= Zr, xn;
        }
      }
    }
    function BC(n, r, u) {
      n.lanes = At(n.lanes, r);
      var c = n.alternate;
      c !== null && (c.lanes = At(c.lanes, r)), C7(n.return, r, u);
    }
    function gj(n, r, u) {
      for (var c = r; c !== null; ) {
        if (c.tag === $) {
          var p = c.memoizedState;
          p !== null && BC(c, u, n);
        } else if (c.tag === K)
          BC(c, u, n);
        else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === n)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === n)
            return;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }
    function wj(n) {
      for (var r = n, u = null; r !== null; ) {
        var c = r.alternate;
        c !== null && mg(c) === null && (u = r), r = r.sibling;
      }
      return u;
    }
    function yj(n) {
      if (n !== void 0 && n !== "forwards" && n !== "backwards" && n !== "together" && !R9[n])
        if (R9[n] = !0, typeof n == "string")
          switch (n.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', n, n.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              m('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', n, n.toLowerCase());
              break;
            }
            default:
              m('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
              break;
          }
        else
          m('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
    }
    function xj(n, r) {
      n !== void 0 && !Zg[n] && (n !== "collapsed" && n !== "hidden" ? (Zg[n] = !0, m('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', n)) : r !== "forwards" && r !== "backwards" && (Zg[n] = !0, m('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', n)));
    }
    function FC(n, r) {
      {
        var u = ra(n), c = !u && typeof vo(n) == "function";
        if (u || c) {
          var p = u ? "array" : "iterable";
          return m("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", p, r, p), !1;
        }
      }
      return !0;
    }
    function Sj(n, r) {
      if ((r === "forwards" || r === "backwards") && n !== void 0 && n !== null && n !== !1)
        if (ra(n)) {
          for (var u = 0; u < n.length; u++)
            if (!FC(n[u], u))
              return;
        } else {
          var c = vo(n);
          if (typeof c == "function") {
            var p = c.call(n);
            if (p)
              for (var x = p.next(), _ = 0; !x.done; x = p.next()) {
                if (!FC(x.value, _))
                  return;
                _++;
              }
          } else
            m('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', r);
        }
    }
    function k9(n, r, u, c, p) {
      var x = n.memoizedState;
      x === null ? n.memoizedState = {
        isBackwards: r,
        rendering: null,
        renderingStartTime: 0,
        last: c,
        tail: u,
        tailMode: p
      } : (x.isBackwards = r, x.rendering = null, x.renderingStartTime = 0, x.last = c, x.tail = u, x.tailMode = p);
    }
    function UC(n, r, u) {
      var c = r.pendingProps, p = c.revealOrder, x = c.tail, _ = c.children;
      yj(p), xj(x, p), Sj(_, p), gl(n, r, _, u);
      var O = v1.current, k = j7(O, Wm);
      if (k)
        O = A7(O, Wm), r.flags |= vn;
      else {
        var N = n !== null && (n.flags & vn) !== H;
        N && gj(r, r.child, u), O = ep(O);
      }
      if (Wd(r, O), (r.mode & on) === tt)
        r.memoizedState = null;
      else
        switch (p) {
          case "forwards": {
            var U = wj(r.child), oe;
            U === null ? (oe = r.child, r.child = null) : (oe = U.sibling, U.sibling = null), k9(
              r,
              !1,
              // isBackwards
              oe,
              U,
              x
            );
            break;
          }
          case "backwards": {
            var ae = null, we = r.child;
            for (r.child = null; we !== null; ) {
              var Ce = we.alternate;
              if (Ce !== null && mg(Ce) === null) {
                r.child = we;
                break;
              }
              var Ee = we.sibling;
              we.sibling = ae, ae = we, we = Ee;
            }
            k9(
              r,
              !0,
              // isBackwards
              ae,
              null,
              // last
              x
            );
            break;
          }
          case "together": {
            k9(
              r,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            r.memoizedState = null;
        }
      return r.child;
    }
    function Cj(n, r, u) {
      T7(r, r.stateNode.containerInfo);
      var c = r.pendingProps;
      return n === null ? r.child = Kv(r, null, c, u) : gl(n, r, c, u), r.child;
    }
    var YC = !1;
    function bj(n, r, u) {
      var c = r.type, p = c._context, x = r.pendingProps, _ = r.memoizedProps, O = x.value;
      {
        "value" in x || YC || (YC = !0, m("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var k = r.type.propTypes;
        k && kt(k, x, "prop", "Context.Provider");
      }
      if (HS(r, p, O), _ !== null) {
        var N = _.value;
        if (ce(N, O)) {
          if (_.children === x.children && !z3())
            return Xc(n, r, u);
        } else
          yD(r, p, u);
      }
      var U = x.children;
      return gl(n, r, U, u), r.child;
    }
    var $C = !1;
    function _j(n, r, u) {
      var c = r.type;
      c._context === void 0 ? c !== c.Consumer && ($C || ($C = !0, m("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : c = c._context;
      var p = r.pendingProps, x = p.children;
      typeof x != "function" && m("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Xv(r, u);
      var _ = co(c);
      ol(r);
      var O;
      return t4.current = r, Pa(!0), O = x(_), Pa(!1), Xu(), r.flags |= Xi, gl(n, r, O, u), r.child;
    }
    function a4() {
      g1 = !0;
    }
    function Vg(n, r) {
      (r.mode & on) === tt && n !== null && (n.alternate = null, r.alternate = null, r.flags |= fr);
    }
    function Xc(n, r, u) {
      return n !== null && (r.dependencies = n.dependencies), xC(), m4(r.lanes), oo(u, r.childLanes) ? (gD(n, r), r.child) : null;
    }
    function Rj(n, r, u) {
      {
        var c = r.return;
        if (c === null)
          throw new Error("Cannot swap the root fiber.");
        if (n.alternate = null, r.alternate = null, u.index = r.index, u.sibling = r.sibling, u.return = r.return, u.ref = r.ref, r === c.child)
          c.child = u;
        else {
          var p = c.child;
          if (p === null)
            throw new Error("Expected parent to have a child.");
          for (; p.sibling !== r; )
            if (p = p.sibling, p === null)
              throw new Error("Expected to find the previous sibling.");
          p.sibling = u;
        }
        var x = c.deletions;
        return x === null ? (c.deletions = [n], c.flags |= Kt) : x.push(n), u.flags |= fr, u;
      }
    }
    function L9(n, r) {
      var u = n.lanes;
      return !!oo(u, r);
    }
    function Ej(n, r, u) {
      switch (r.tag) {
        case T:
          ZC(r), Gv();
          break;
        case A:
          YS(r);
          break;
        case R: {
          var c = r.type;
          x0(c) && G3(r);
          break;
        }
        case j:
          T7(r, r.stateNode.containerInfo);
          break;
        case Y: {
          var p = r.memoizedProps.value, x = r.type._context;
          HS(r, x, p);
          break;
        }
        case Q:
          {
            var _ = oo(u, r.childLanes);
            _ && (r.flags |= zt);
            {
              var O = r.stateNode;
              O.effectDuration = 0, O.passiveEffectDuration = 0;
            }
          }
          break;
        case $: {
          var k = r.memoizedState;
          if (k !== null) {
            if (k.dehydrated !== null)
              return Wd(r, ep(v1.current)), r.flags |= vn, null;
            var N = r.child, U = N.childLanes;
            if (oo(u, U))
              return VC(n, r, u);
            Wd(r, ep(v1.current));
            var oe = Xc(n, r, u);
            return oe !== null ? oe.sibling : null;
          } else
            Wd(r, ep(v1.current));
          break;
        }
        case K: {
          var ae = (n.flags & vn) !== H, we = oo(u, r.childLanes);
          if (ae) {
            if (we)
              return UC(n, r, u);
            r.flags |= vn;
          }
          var Ce = r.memoizedState;
          if (Ce !== null && (Ce.rendering = null, Ce.tail = null, Ce.lastEffect = null), Wd(r, v1.current), we)
            break;
          return null;
        }
        case fe:
        case xe:
          return r.lanes = He, LC(n, r, u);
      }
      return Xc(n, r, u);
    }
    function WC(n, r, u) {
      if (r._debugNeedsRemount && n !== null)
        return Rj(n, r, s8(r.type, r.key, r.pendingProps, r._debugOwner || null, r.mode, r.lanes));
      if (n !== null) {
        var c = n.memoizedProps, p = r.pendingProps;
        if (c !== p || z3() || // Force a re-render if the implementation changed due to hot reload:
        r.type !== n.type)
          g1 = !0;
        else {
          var x = L9(n, u);
          if (!x && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (r.flags & vn) === H)
            return g1 = !1, Ej(n, r, u);
          (n.flags & ed) !== H ? g1 = !0 : g1 = !1;
        }
      } else if (g1 = !1, vi() && QO(r)) {
        var _ = r.index, O = XO();
        xS(r, O, _);
      }
      switch (r.lanes = He, r.tag) {
        case D:
          return lj(n, r, r.type, u);
        case Se: {
          var k = r.elementType;
          return oj(n, r, k, u);
        }
        case S: {
          var N = r.type, U = r.pendingProps, oe = r.elementType === N ? U : m1(N, U);
          return E9(n, r, N, oe, u);
        }
        case R: {
          var ae = r.type, we = r.pendingProps, Ce = r.elementType === ae ? we : m1(ae, we);
          return HC(n, r, ae, Ce, u);
        }
        case T:
          return nj(n, r, u);
        case A:
          return rj(n, r, u);
        case L:
          return aj(n, r);
        case $:
          return VC(n, r, u);
        case j:
          return Cj(n, r, u);
        case W: {
          var Ee = r.type, it = r.pendingProps, Ut = r.elementType === Ee ? it : m1(Ee, it);
          return jC(n, r, Ee, Ut, u);
        }
        case P:
          return JD(n, r, u);
        case V:
          return ej(n, r, u);
        case Q:
          return tj(n, r, u);
        case Y:
          return bj(n, r, u);
        case F:
          return _j(n, r, u);
        case le: {
          var Lt = r.type, Dn = r.pendingProps, xn = m1(Lt, Dn);
          if (r.type !== r.elementType) {
            var pe = Lt.propTypes;
            pe && kt(
              pe,
              xn,
              // Resolved for outer only
              "prop",
              In(Lt)
            );
          }
          return xn = m1(Lt.type, xn), AC(n, r, Lt, xn, u);
        }
        case te:
          return kC(n, r, r.type, r.pendingProps, u);
        case re: {
          var Me = r.type, me = r.pendingProps, We = r.elementType === Me ? me : m1(Me, me);
          return ij(n, r, Me, We, u);
        }
        case K:
          return UC(n, r, u);
        case de:
          break;
        case fe:
          return LC(n, r, u);
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function ip(n) {
      n.flags |= zt;
    }
    function zC(n) {
      n.flags |= Un, n.flags |= Ho;
    }
    var qC, I9, GC, KC;
    qC = function(n, r, u, c) {
      for (var p = r.child; p !== null; ) {
        if (p.tag === A || p.tag === L)
          v6(n, p.stateNode);
        else if (p.tag !== j) {
          if (p.child !== null) {
            p.child.return = p, p = p.child;
            continue;
          }
        }
        if (p === r)
          return;
        for (; p.sibling === null; ) {
          if (p.return === null || p.return === r)
            return;
          p = p.return;
        }
        p.sibling.return = p.return, p = p.sibling;
      }
    }, I9 = function(n, r) {
    }, GC = function(n, r, u, c, p) {
      var x = n.memoizedProps;
      if (x !== c) {
        var _ = r.stateNode, O = O7(), k = m6(_, u, x, c, p, O);
        r.updateQueue = k, k && ip(r);
      }
    }, KC = function(n, r, u, c) {
      u !== c && ip(r);
    };
    function o4(n, r) {
      if (!vi())
        switch (n.tailMode) {
          case "hidden": {
            for (var u = n.tail, c = null; u !== null; )
              u.alternate !== null && (c = u), u = u.sibling;
            c === null ? n.tail = null : c.sibling = null;
            break;
          }
          case "collapsed": {
            for (var p = n.tail, x = null; p !== null; )
              p.alternate !== null && (x = p), p = p.sibling;
            x === null ? !r && n.tail !== null ? n.tail.sibling = null : n.tail = null : x.sibling = null;
            break;
          }
        }
    }
    function mi(n) {
      var r = n.alternate !== null && n.alternate.child === n.child, u = He, c = H;
      if (r) {
        if ((n.mode & Pn) !== tt) {
          for (var k = n.selfBaseDuration, N = n.child; N !== null; )
            u = At(u, At(N.lanes, N.childLanes)), c |= N.subtreeFlags & Mr, c |= N.flags & Mr, k += N.treeBaseDuration, N = N.sibling;
          n.treeBaseDuration = k;
        } else
          for (var U = n.child; U !== null; )
            u = At(u, At(U.lanes, U.childLanes)), c |= U.subtreeFlags & Mr, c |= U.flags & Mr, U.return = n, U = U.sibling;
        n.subtreeFlags |= c;
      } else {
        if ((n.mode & Pn) !== tt) {
          for (var p = n.actualDuration, x = n.selfBaseDuration, _ = n.child; _ !== null; )
            u = At(u, At(_.lanes, _.childLanes)), c |= _.subtreeFlags, c |= _.flags, p += _.actualDuration, x += _.treeBaseDuration, _ = _.sibling;
          n.actualDuration = p, n.treeBaseDuration = x;
        } else
          for (var O = n.child; O !== null; )
            u = At(u, At(O.lanes, O.childLanes)), c |= O.subtreeFlags, c |= O.flags, O.return = n, O = O.sibling;
        n.subtreeFlags |= c;
      }
      return n.childLanes = u, r;
    }
    function Mj(n, r, u) {
      if (fD() && (r.mode & on) !== tt && (r.flags & vn) === H)
        return MS(r), Gv(), r.flags |= ia | Ua | Io, !1;
      var c = eg(r);
      if (u !== null && u.dehydrated !== null)
        if (n === null) {
          if (!c)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (sD(r), mi(r), (r.mode & Pn) !== tt) {
            var p = u !== null;
            if (p) {
              var x = r.child;
              x !== null && (r.treeBaseDuration -= x.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Gv(), (r.flags & vn) === H && (r.memoizedState = null), r.flags |= zt, mi(r), (r.mode & Pn) !== tt) {
            var _ = u !== null;
            if (_) {
              var O = r.child;
              O !== null && (r.treeBaseDuration -= O.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return TS(), !0;
    }
    function QC(n, r, u) {
      var c = r.pendingProps;
      switch (l7(r), r.tag) {
        case D:
        case Se:
        case te:
        case S:
        case W:
        case P:
        case V:
        case Q:
        case F:
        case le:
          return mi(r), null;
        case R: {
          var p = r.type;
          return x0(p) && q3(r), mi(r), null;
        }
        case T: {
          var x = r.stateNode;
          if (Jv(r), r7(r), L7(), x.pendingContext && (x.context = x.pendingContext, x.pendingContext = null), n === null || n.child === null) {
            var _ = eg(r);
            if (_)
              ip(r);
            else if (n !== null) {
              var O = n.memoizedState;
              // Check if this is a client root
              (!O.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (r.flags & ia) !== H) && (r.flags |= Yn, TS());
            }
          }
          return I9(n, r), mi(r), null;
        }
        case A: {
          D7(r);
          var k = US(), N = r.type;
          if (n !== null && r.stateNode != null)
            GC(n, r, N, c, k), n.ref !== r.ref && zC(r);
          else {
            if (!c) {
              if (r.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return mi(r), null;
            }
            var U = O7(), oe = eg(r);
            if (oe)
              lD(r, k, U) && ip(r);
            else {
              var ae = h6(N, c, k, U, r);
              qC(ae, r, !1, !1), r.stateNode = ae, p6(ae, N, c, k) && ip(r);
            }
            r.ref !== null && zC(r);
          }
          return mi(r), null;
        }
        case L: {
          var we = c;
          if (n && r.stateNode != null) {
            var Ce = n.memoizedProps;
            KC(n, r, Ce, we);
          } else {
            if (typeof we != "string" && r.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Ee = US(), it = O7(), Ut = eg(r);
            Ut ? uD(r) && ip(r) : r.stateNode = g6(we, Ee, it, r);
          }
          return mi(r), null;
        }
        case $: {
          tp(r);
          var Lt = r.memoizedState;
          if (n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
            var Dn = Mj(n, r, Lt);
            if (!Dn)
              return r.flags & Io ? r : null;
          }
          if ((r.flags & vn) !== H)
            return r.lanes = u, (r.mode & Pn) !== tt && o9(r), r;
          var xn = Lt !== null, pe = n !== null && n.memoizedState !== null;
          if (xn !== pe && xn) {
            var Me = r.child;
            if (Me.flags |= la, (r.mode & on) !== tt) {
              var me = n === null && (r.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              me || j7(v1.current, WS) ? MA() : X9();
            }
          }
          var We = r.updateQueue;
          if (We !== null && (r.flags |= zt), mi(r), (r.mode & Pn) !== tt && xn) {
            var pt = r.child;
            pt !== null && (r.treeBaseDuration -= pt.treeBaseDuration);
          }
          return null;
        }
        case j:
          return Jv(r), I9(n, r), n === null && e7(r.stateNode.containerInfo), mi(r), null;
        case Y:
          var ut = r.type._context;
          return S7(ut, r), mi(r), null;
        case re: {
          var Xt = r.type;
          return x0(Xt) && q3(r), mi(r), null;
        }
        case K: {
          tp(r);
          var an = r.memoizedState;
          if (an === null)
            return mi(r), null;
          var wr = (r.flags & vn) !== H, Kn = an.rendering;
          if (Kn === null)
            if (wr)
              o4(an, !1);
            else {
              var Ka = OA() && (n === null || (n.flags & vn) === H);
              if (!Ka)
                for (var Qn = r.child; Qn !== null; ) {
                  var Da = mg(Qn);
                  if (Da !== null) {
                    wr = !0, r.flags |= vn, o4(an, !1);
                    var Ui = Da.updateQueue;
                    return Ui !== null && (r.updateQueue = Ui, r.flags |= zt), r.subtreeFlags = H, wD(r, u), Wd(r, A7(v1.current, Wm)), r.child;
                  }
                  Qn = Qn.sibling;
                }
              an.tail !== null && Yr() > wb() && (r.flags |= vn, wr = !0, o4(an, !1), r.lanes = a0);
            }
          else {
            if (!wr) {
              var Si = mg(Kn);
              if (Si !== null) {
                r.flags |= vn, wr = !0;
                var ju = Si.updateQueue;
                if (ju !== null && (r.updateQueue = ju, r.flags |= zt), o4(an, !0), an.tail === null && an.tailMode === "hidden" && !Kn.alternate && !vi())
                  return mi(r), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              Yr() * 2 - an.renderingStartTime > wb() && u !== Vo && (r.flags |= vn, wr = !0, o4(an, !1), r.lanes = a0);
            }
            if (an.isBackwards)
              Kn.sibling = r.child, r.child = Kn;
            else {
              var xl = an.last;
              xl !== null ? xl.sibling = Kn : r.child = Kn, an.last = Kn;
            }
          }
          if (an.tail !== null) {
            var Sl = an.tail;
            an.rendering = Sl, an.tail = Sl.sibling, an.renderingStartTime = Yr(), Sl.sibling = null;
            var Yi = v1.current;
            return wr ? Yi = A7(Yi, Wm) : Yi = ep(Yi), Wd(r, Yi), Sl;
          }
          return mi(r), null;
        }
        case de:
          break;
        case fe:
        case xe: {
          Q9(r);
          var rf = r.memoizedState, vp = rf !== null;
          if (n !== null) {
            var S4 = n.memoizedState, T0 = S4 !== null;
            T0 !== vp && (r.flags |= la);
          }
          return !vp || (r.mode & on) === tt ? mi(r) : oo(M0, Vo) && (mi(r), r.subtreeFlags & (fr | zt) && (r.flags |= la)), null;
        }
        case Le:
          return null;
        case be:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Tj(n, r, u) {
      switch (l7(r), r.tag) {
        case R: {
          var c = r.type;
          x0(c) && q3(r);
          var p = r.flags;
          return p & Io ? (r.flags = p & -65537 | vn, (r.mode & Pn) !== tt && o9(r), r) : null;
        }
        case T: {
          Jv(r), r7(r), L7();
          var x = r.flags;
          return (x & Io) !== H && (x & vn) === H ? (r.flags = x & -65537 | vn, r) : null;
        }
        case A:
          return D7(r), null;
        case $: {
          tp(r);
          var _ = r.memoizedState;
          if (_ !== null && _.dehydrated !== null) {
            if (r.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Gv();
          }
          var O = r.flags;
          return O & Io ? (r.flags = O & -65537 | vn, (r.mode & Pn) !== tt && o9(r), r) : null;
        }
        case K:
          return tp(r), null;
        case j:
          return Jv(r), null;
        case Y:
          var k = r.type._context;
          return S7(k, r), null;
        case fe:
        case xe:
          return Q9(r), null;
        case Le:
          return null;
        default:
          return null;
      }
    }
    function XC(n, r, u) {
      switch (l7(r), r.tag) {
        case R: {
          var c = r.type.childContextTypes;
          c != null && q3(r);
          break;
        }
        case T: {
          Jv(r), r7(r), L7();
          break;
        }
        case A: {
          D7(r);
          break;
        }
        case j:
          Jv(r);
          break;
        case $:
          tp(r);
          break;
        case K:
          tp(r);
          break;
        case Y:
          var p = r.type._context;
          S7(p, r);
          break;
        case fe:
        case xe:
          Q9(r);
          break;
      }
    }
    var JC = null;
    JC = /* @__PURE__ */ new Set();
    var Ng = !1, gi = !1, Oj = typeof WeakSet == "function" ? WeakSet : Set, Mt = null, lp = null, up = null;
    function Dj(n) {
      vc(null, function() {
        throw n;
      }), Oi();
    }
    var jj = function(n, r) {
      if (r.props = n.memoizedProps, r.state = n.memoizedState, n.mode & Pn)
        try {
          R0(), r.componentWillUnmount();
        } finally {
          _0(n);
        }
      else
        r.componentWillUnmount();
    };
    function eb(n, r) {
      try {
        Gd(bo, n);
      } catch (u) {
        Nr(n, r, u);
      }
    }
    function H9(n, r, u) {
      try {
        jj(n, u);
      } catch (c) {
        Nr(n, r, c);
      }
    }
    function Aj(n, r, u) {
      try {
        u.componentDidMount();
      } catch (c) {
        Nr(n, r, c);
      }
    }
    function tb(n, r) {
      try {
        rb(n);
      } catch (u) {
        Nr(n, r, u);
      }
    }
    function sp(n, r) {
      var u = n.ref;
      if (u !== null)
        if (typeof u == "function") {
          var c;
          try {
            if (n.mode & Pn)
              try {
                R0(), c = u(null);
              } finally {
                _0(n);
              }
            else
              c = u(null);
          } catch (p) {
            Nr(n, r, p);
          }
          typeof c == "function" && m("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", en(n));
        } else
          u.current = null;
    }
    function Bg(n, r, u) {
      try {
        u();
      } catch (c) {
        Nr(n, r, c);
      }
    }
    var nb = !1;
    function kj(n, r) {
      f6(), Mt = r, Lj();
      var u = nb;
      return nb = !1, u;
    }
    function Lj() {
      for (; Mt !== null; ) {
        var n = Mt, r = n.child;
        (n.subtreeFlags & td) !== H && r !== null ? (r.return = n, Mt = r) : Ij();
      }
    }
    function Ij() {
      for (; Mt !== null; ) {
        var n = Mt;
        tr(n);
        try {
          Hj(n);
        } catch (u) {
          Nr(n, n.return, u);
        }
        va();
        var r = n.sibling;
        if (r !== null) {
          r.return = n.return, Mt = r;
          return;
        }
        Mt = n.return;
      }
    }
    function Hj(n) {
      var r = n.alternate, u = n.flags;
      if ((u & Yn) !== H) {
        switch (tr(n), n.tag) {
          case S:
          case W:
          case te:
            break;
          case R: {
            if (r !== null) {
              var c = r.memoizedProps, p = r.memoizedState, x = n.stateNode;
              n.type === n.elementType && !b2 && (x.props !== n.memoizedProps && m("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(n) || "instance"), x.state !== n.memoizedState && m("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(n) || "instance"));
              var _ = x.getSnapshotBeforeUpdate(n.elementType === n.type ? c : m1(n.type, c), p);
              {
                var O = JC;
                _ === void 0 && !O.has(n.type) && (O.add(n.type), m("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", en(n)));
              }
              x.__reactInternalSnapshotBeforeUpdate = _;
            }
            break;
          }
          case T: {
            {
              var k = n.stateNode;
              A6(k.containerInfo);
            }
            break;
          }
          case A:
          case L:
          case j:
          case re:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        va();
      }
    }
    function w1(n, r, u) {
      var c = r.updateQueue, p = c !== null ? c.lastEffect : null;
      if (p !== null) {
        var x = p.next, _ = x;
        do {
          if ((_.tag & n) === n) {
            var O = _.destroy;
            _.destroy = void 0, O !== void 0 && ((n & pi) !== Wl ? ki(r) : (n & bo) !== Wl && ai(r), (n & S0) !== Wl && w4(!0), Bg(r, u, O), (n & S0) !== Wl && w4(!1), (n & pi) !== Wl ? ld() : (n & bo) !== Wl && gc());
          }
          _ = _.next;
        } while (_ !== x);
      }
    }
    function Gd(n, r) {
      var u = r.updateQueue, c = u !== null ? u.lastEffect : null;
      if (c !== null) {
        var p = c.next, x = p;
        do {
          if ((x.tag & n) === n) {
            (n & pi) !== Wl ? id(r) : (n & bo) !== Wl && dv(r);
            var _ = x.create;
            (n & S0) !== Wl && w4(!0), x.destroy = _(), (n & S0) !== Wl && w4(!1), (n & pi) !== Wl ? mu() : (n & bo) !== Wl && gu();
            {
              var O = x.destroy;
              if (O !== void 0 && typeof O != "function") {
                var k = void 0;
                (x.tag & bo) !== H ? k = "useLayoutEffect" : (x.tag & S0) !== H ? k = "useInsertionEffect" : k = "useEffect";
                var N = void 0;
                O === null ? N = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof O.then == "function" ? N = `

It looks like you wrote ` + k + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + k + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : N = " You returned: " + O, m("%s must not return anything besides a function, which is used for clean-up.%s", k, N);
              }
            }
          }
          x = x.next;
        } while (x !== p);
      }
    }
    function Zj(n, r) {
      if ((r.flags & zt) !== H)
        switch (r.tag) {
          case Q: {
            var u = r.stateNode.passiveEffectDuration, c = r.memoizedProps, p = c.id, x = c.onPostCommit, _ = wC(), O = r.alternate === null ? "mount" : "update";
            gC() && (O = "nested-update"), typeof x == "function" && x(p, O, u, _);
            var k = r.return;
            e: for (; k !== null; ) {
              switch (k.tag) {
                case T:
                  var N = k.stateNode;
                  N.passiveEffectDuration += u;
                  break e;
                case Q:
                  var U = k.stateNode;
                  U.passiveEffectDuration += u;
                  break e;
              }
              k = k.return;
            }
            break;
          }
        }
    }
    function Pj(n, r, u, c) {
      if ((u.flags & Di) !== H)
        switch (u.tag) {
          case S:
          case W:
          case te: {
            if (!gi)
              if (u.mode & Pn)
                try {
                  R0(), Gd(bo | Co, u);
                } finally {
                  _0(u);
                }
              else
                Gd(bo | Co, u);
            break;
          }
          case R: {
            var p = u.stateNode;
            if (u.flags & zt && !gi)
              if (r === null)
                if (u.type === u.elementType && !b2 && (p.props !== u.memoizedProps && m("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(u) || "instance"), p.state !== u.memoizedState && m("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(u) || "instance")), u.mode & Pn)
                  try {
                    R0(), p.componentDidMount();
                  } finally {
                    _0(u);
                  }
                else
                  p.componentDidMount();
              else {
                var x = u.elementType === u.type ? r.memoizedProps : m1(u.type, r.memoizedProps), _ = r.memoizedState;
                if (u.type === u.elementType && !b2 && (p.props !== u.memoizedProps && m("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(u) || "instance"), p.state !== u.memoizedState && m("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(u) || "instance")), u.mode & Pn)
                  try {
                    R0(), p.componentDidUpdate(x, _, p.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    _0(u);
                  }
                else
                  p.componentDidUpdate(x, _, p.__reactInternalSnapshotBeforeUpdate);
              }
            var O = u.updateQueue;
            O !== null && (u.type === u.elementType && !b2 && (p.props !== u.memoizedProps && m("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", en(u) || "instance"), p.state !== u.memoizedState && m("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", en(u) || "instance")), FS(u, O, p));
            break;
          }
          case T: {
            var k = u.updateQueue;
            if (k !== null) {
              var N = null;
              if (u.child !== null)
                switch (u.child.tag) {
                  case A:
                    N = u.child.stateNode;
                    break;
                  case R:
                    N = u.child.stateNode;
                    break;
                }
              FS(u, k, N);
            }
            break;
          }
          case A: {
            var U = u.stateNode;
            if (r === null && u.flags & zt) {
              var oe = u.type, ae = u.memoizedProps;
              C6(U, oe, ae);
            }
            break;
          }
          case L:
            break;
          case j:
            break;
          case Q: {
            {
              var we = u.memoizedProps, Ce = we.onCommit, Ee = we.onRender, it = u.stateNode.effectDuration, Ut = wC(), Lt = r === null ? "mount" : "update";
              gC() && (Lt = "nested-update"), typeof Ee == "function" && Ee(u.memoizedProps.id, Lt, u.actualDuration, u.treeBaseDuration, u.actualStartTime, Ut);
              {
                typeof Ce == "function" && Ce(u.memoizedProps.id, Lt, it, Ut), LA(u);
                var Dn = u.return;
                e: for (; Dn !== null; ) {
                  switch (Dn.tag) {
                    case T:
                      var xn = Dn.stateNode;
                      xn.effectDuration += it;
                      break e;
                    case Q:
                      var pe = Dn.stateNode;
                      pe.effectDuration += it;
                      break e;
                  }
                  Dn = Dn.return;
                }
              }
            }
            break;
          }
          case $: {
            $j(n, u);
            break;
          }
          case K:
          case re:
          case de:
          case fe:
          case xe:
          case be:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      gi || u.flags & Un && rb(u);
    }
    function Vj(n) {
      switch (n.tag) {
        case S:
        case W:
        case te: {
          if (n.mode & Pn)
            try {
              R0(), eb(n, n.return);
            } finally {
              _0(n);
            }
          else
            eb(n, n.return);
          break;
        }
        case R: {
          var r = n.stateNode;
          typeof r.componentDidMount == "function" && Aj(n, n.return, r), tb(n, n.return);
          break;
        }
        case A: {
          tb(n, n.return);
          break;
        }
      }
    }
    function Nj(n, r) {
      for (var u = null, c = n; ; ) {
        if (c.tag === A) {
          if (u === null) {
            u = c;
            try {
              var p = c.stateNode;
              r ? O6(p) : D6(c.stateNode, c.memoizedProps);
            } catch (_) {
              Nr(n, n.return, _);
            }
          }
        } else if (c.tag === L) {
          if (u === null)
            try {
              var x = c.stateNode;
              r ? Om(x) : j6(x, c.memoizedProps);
            } catch (_) {
              Nr(n, n.return, _);
            }
        } else if (!((c.tag === fe || c.tag === xe) && c.memoizedState !== null && c !== n)) {
          if (c.child !== null) {
            c.child.return = c, c = c.child;
            continue;
          }
        }
        if (c === n)
          return;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === n)
            return;
          u === c && (u = null), c = c.return;
        }
        u === c && (u = null), c.sibling.return = c.return, c = c.sibling;
      }
    }
    function rb(n) {
      var r = n.ref;
      if (r !== null) {
        var u = n.stateNode, c;
        switch (n.tag) {
          case A:
            c = u;
            break;
          default:
            c = u;
        }
        if (typeof r == "function") {
          var p;
          if (n.mode & Pn)
            try {
              R0(), p = r(c);
            } finally {
              _0(n);
            }
          else
            p = r(c);
          typeof p == "function" && m("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", en(n));
        } else
          r.hasOwnProperty("current") || m("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", en(n)), r.current = c;
      }
    }
    function Bj(n) {
      var r = n.alternate;
      r !== null && (r.return = null), n.return = null;
    }
    function ab(n) {
      var r = n.alternate;
      r !== null && (n.alternate = null, ab(r));
      {
        if (n.child = null, n.deletions = null, n.sibling = null, n.tag === A) {
          var u = n.stateNode;
          u !== null && s(u);
        }
        n.stateNode = null, n._debugOwner = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
      }
    }
    function Fj(n) {
      for (var r = n.return; r !== null; ) {
        if (ob(r))
          return r;
        r = r.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function ob(n) {
      return n.tag === A || n.tag === T || n.tag === j;
    }
    function ib(n) {
      var r = n;
      e: for (; ; ) {
        for (; r.sibling === null; ) {
          if (r.return === null || ob(r.return))
            return null;
          r = r.return;
        }
        for (r.sibling.return = r.return, r = r.sibling; r.tag !== A && r.tag !== L && r.tag !== ve; ) {
          if (r.flags & fr || r.child === null || r.tag === j)
            continue e;
          r.child.return = r, r = r.child;
        }
        if (!(r.flags & fr))
          return r.stateNode;
      }
    }
    function Uj(n) {
      var r = Fj(n);
      switch (r.tag) {
        case A: {
          var u = r.stateNode;
          r.flags & Fs && (B3(u), r.flags &= -33);
          var c = ib(n);
          P9(n, c, u);
          break;
        }
        case T:
        case j: {
          var p = r.stateNode.containerInfo, x = ib(n);
          Z9(n, x, p);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function Z9(n, r, u) {
      var c = n.tag, p = c === A || c === L;
      if (p) {
        var x = n.stateNode;
        r ? Mm(u, x, r) : E6(u, x);
      } else if (c !== j) {
        var _ = n.child;
        if (_ !== null) {
          Z9(_, r, u);
          for (var O = _.sibling; O !== null; )
            Z9(O, r, u), O = O.sibling;
        }
      }
    }
    function P9(n, r, u) {
      var c = n.tag, p = c === A || c === L;
      if (p) {
        var x = n.stateNode;
        r ? M6(u, x, r) : R6(u, x);
      } else if (c !== j) {
        var _ = n.child;
        if (_ !== null) {
          P9(_, r, u);
          for (var O = _.sibling; O !== null; )
            P9(O, r, u), O = O.sibling;
        }
      }
    }
    var wi = null, y1 = !1;
    function Yj(n, r, u) {
      {
        var c = r;
        e: for (; c !== null; ) {
          switch (c.tag) {
            case A: {
              wi = c.stateNode, y1 = !1;
              break e;
            }
            case T: {
              wi = c.stateNode.containerInfo, y1 = !0;
              break e;
            }
            case j: {
              wi = c.stateNode.containerInfo, y1 = !0;
              break e;
            }
          }
          c = c.return;
        }
        if (wi === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        lb(n, r, u), wi = null, y1 = !1;
      }
      Bj(u);
    }
    function Kd(n, r, u) {
      for (var c = u.child; c !== null; )
        lb(n, r, c), c = c.sibling;
    }
    function lb(n, r, u) {
      switch (X1(u), u.tag) {
        case A:
          gi || sp(u, r);
        case L: {
          {
            var c = wi, p = y1;
            wi = null, Kd(n, r, u), wi = c, y1 = p, wi !== null && (y1 ? U3(wi, u.stateNode) : F3(wi, u.stateNode));
          }
          return;
        }
        case ve: {
          wi !== null && (y1 ? T6(wi, u.stateNode) : Tm(wi, u.stateNode));
          return;
        }
        case j: {
          {
            var x = wi, _ = y1;
            wi = u.stateNode.containerInfo, y1 = !0, Kd(n, r, u), wi = x, y1 = _;
          }
          return;
        }
        case S:
        case W:
        case le:
        case te: {
          if (!gi) {
            var O = u.updateQueue;
            if (O !== null) {
              var k = O.lastEffect;
              if (k !== null) {
                var N = k.next, U = N;
                do {
                  var oe = U, ae = oe.destroy, we = oe.tag;
                  ae !== void 0 && ((we & S0) !== Wl ? Bg(u, r, ae) : (we & bo) !== Wl && (ai(u), u.mode & Pn ? (R0(), Bg(u, r, ae), _0(u)) : Bg(u, r, ae), gc())), U = U.next;
                } while (U !== N);
              }
            }
          }
          Kd(n, r, u);
          return;
        }
        case R: {
          if (!gi) {
            sp(u, r);
            var Ce = u.stateNode;
            typeof Ce.componentWillUnmount == "function" && H9(u, r, Ce);
          }
          Kd(n, r, u);
          return;
        }
        case de: {
          Kd(n, r, u);
          return;
        }
        case fe: {
          if (
            // TODO: Remove this dead flag
            u.mode & on
          ) {
            var Ee = gi;
            gi = Ee || u.memoizedState !== null, Kd(n, r, u), gi = Ee;
          } else
            Kd(n, r, u);
          break;
        }
        default: {
          Kd(n, r, u);
          return;
        }
      }
    }
    function $j(n, r) {
      var u = r.memoizedState;
      if (u === null) {
        var c = r.alternate;
        if (c !== null) {
          var p = c.memoizedState;
          if (p !== null) {
            var x = p.dehydrated;
            x !== null && Lm(x);
          }
        }
      }
    }
    function ub(n) {
      var r = n.updateQueue;
      if (r !== null) {
        n.updateQueue = null;
        var u = n.stateNode;
        u === null && (u = n.stateNode = new Oj()), r.forEach(function(c) {
          var p = BA.bind(null, n, c);
          if (!u.has(c)) {
            if (u.add(c), Zn)
              if (lp !== null && up !== null)
                g4(up, lp);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            c.then(p, p);
          }
        });
      }
    }
    function Wj(n, r, u) {
      lp = u, up = n, tr(r), sb(r, n), tr(r), lp = null, up = null;
    }
    function x1(n, r, u) {
      var c = r.deletions;
      if (c !== null)
        for (var p = 0; p < c.length; p++) {
          var x = c[p];
          try {
            Yj(n, r, x);
          } catch (k) {
            Nr(x, r, k);
          }
        }
      var _ = Nu();
      if (r.subtreeFlags & vu)
        for (var O = r.child; O !== null; )
          tr(O), sb(O, n), O = O.sibling;
      tr(_);
    }
    function sb(n, r, u) {
      var c = n.alternate, p = n.flags;
      switch (n.tag) {
        case S:
        case W:
        case le:
        case te: {
          if (x1(r, n), E0(n), p & zt) {
            try {
              w1(S0 | Co, n, n.return), Gd(S0 | Co, n);
            } catch (Xt) {
              Nr(n, n.return, Xt);
            }
            if (n.mode & Pn) {
              try {
                R0(), w1(bo | Co, n, n.return);
              } catch (Xt) {
                Nr(n, n.return, Xt);
              }
              _0(n);
            } else
              try {
                w1(bo | Co, n, n.return);
              } catch (Xt) {
                Nr(n, n.return, Xt);
              }
          }
          return;
        }
        case R: {
          x1(r, n), E0(n), p & Un && c !== null && sp(c, c.return);
          return;
        }
        case A: {
          x1(r, n), E0(n), p & Un && c !== null && sp(c, c.return);
          {
            if (n.flags & Fs) {
              var x = n.stateNode;
              try {
                B3(x);
              } catch (Xt) {
                Nr(n, n.return, Xt);
              }
            }
            if (p & zt) {
              var _ = n.stateNode;
              if (_ != null) {
                var O = n.memoizedProps, k = c !== null ? c.memoizedProps : O, N = n.type, U = n.updateQueue;
                if (n.updateQueue = null, U !== null)
                  try {
                    b6(_, U, N, k, O);
                  } catch (Xt) {
                    Nr(n, n.return, Xt);
                  }
              }
            }
          }
          return;
        }
        case L: {
          if (x1(r, n), E0(n), p & zt) {
            if (n.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var oe = n.stateNode, ae = n.memoizedProps, we = c !== null ? c.memoizedProps : ae;
            try {
              _6(oe, we, ae);
            } catch (Xt) {
              Nr(n, n.return, Xt);
            }
          }
          return;
        }
        case T: {
          if (x1(r, n), E0(n), p & zt && c !== null) {
            var Ce = c.memoizedState;
            if (Ce.isDehydrated)
              try {
                km(r.containerInfo);
              } catch (Xt) {
                Nr(n, n.return, Xt);
              }
          }
          return;
        }
        case j: {
          x1(r, n), E0(n);
          return;
        }
        case $: {
          x1(r, n), E0(n);
          var Ee = n.child;
          if (Ee.flags & la) {
            var it = Ee.stateNode, Ut = Ee.memoizedState, Lt = Ut !== null;
            if (it.isHidden = Lt, Lt) {
              var Dn = Ee.alternate !== null && Ee.alternate.memoizedState !== null;
              Dn || EA();
            }
          }
          p & zt && ub(n);
          return;
        }
        case fe: {
          var xn = c !== null && c.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            n.mode & on
          ) {
            var pe = gi;
            gi = pe || xn, x1(r, n), gi = pe;
          } else
            x1(r, n);
          if (E0(n), p & la) {
            var Me = n.stateNode, me = n.memoizedState, We = me !== null, pt = n;
            if (Me.isHidden = We, We && !xn && (pt.mode & on) !== tt) {
              Mt = pt;
              for (var ut = pt.child; ut !== null; )
                Mt = ut, qj(ut), ut = ut.sibling;
            }
            Nj(pt, We);
          }
          return;
        }
        case K: {
          x1(r, n), E0(n), p & zt && ub(n);
          return;
        }
        case de:
          return;
        default: {
          x1(r, n), E0(n);
          return;
        }
      }
    }
    function E0(n) {
      var r = n.flags;
      if (r & fr) {
        try {
          Uj(n);
        } catch (u) {
          Nr(n, n.return, u);
        }
        n.flags &= -3;
      }
      r & Zr && (n.flags &= -4097);
    }
    function zj(n, r, u) {
      lp = u, up = r, Mt = n, cb(n, r), lp = null, up = null;
    }
    function cb(n, r, u) {
      for (var c = (n.mode & on) !== tt; Mt !== null; ) {
        var p = Mt, x = p.child;
        if (p.tag === fe && c) {
          var _ = p.memoizedState !== null, O = _ || Ng;
          if (O) {
            V9(n, r);
            continue;
          } else {
            var k = p.alternate, N = k !== null && k.memoizedState !== null, U = N || gi, oe = Ng, ae = gi;
            Ng = O, gi = U, gi && !ae && (Mt = p, Gj(p));
            for (var we = x; we !== null; )
              Mt = we, cb(
                we,
                // New root; bubble back up to here and stop.
                r
              ), we = we.sibling;
            Mt = p, Ng = oe, gi = ae, V9(n, r);
            continue;
          }
        }
        (p.subtreeFlags & Di) !== H && x !== null ? (x.return = p, Mt = x) : V9(n, r);
      }
    }
    function V9(n, r, u) {
      for (; Mt !== null; ) {
        var c = Mt;
        if ((c.flags & Di) !== H) {
          var p = c.alternate;
          tr(c);
          try {
            Pj(r, p, c);
          } catch (_) {
            Nr(c, c.return, _);
          }
          va();
        }
        if (c === n) {
          Mt = null;
          return;
        }
        var x = c.sibling;
        if (x !== null) {
          x.return = c.return, Mt = x;
          return;
        }
        Mt = c.return;
      }
    }
    function qj(n) {
      for (; Mt !== null; ) {
        var r = Mt, u = r.child;
        switch (r.tag) {
          case S:
          case W:
          case le:
          case te: {
            if (r.mode & Pn)
              try {
                R0(), w1(bo, r, r.return);
              } finally {
                _0(r);
              }
            else
              w1(bo, r, r.return);
            break;
          }
          case R: {
            sp(r, r.return);
            var c = r.stateNode;
            typeof c.componentWillUnmount == "function" && H9(r, r.return, c);
            break;
          }
          case A: {
            sp(r, r.return);
            break;
          }
          case fe: {
            var p = r.memoizedState !== null;
            if (p) {
              fb(n);
              continue;
            }
            break;
          }
        }
        u !== null ? (u.return = r, Mt = u) : fb(n);
      }
    }
    function fb(n) {
      for (; Mt !== null; ) {
        var r = Mt;
        if (r === n) {
          Mt = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, Mt = u;
          return;
        }
        Mt = r.return;
      }
    }
    function Gj(n) {
      for (; Mt !== null; ) {
        var r = Mt, u = r.child;
        if (r.tag === fe) {
          var c = r.memoizedState !== null;
          if (c) {
            db(n);
            continue;
          }
        }
        u !== null ? (u.return = r, Mt = u) : db(n);
      }
    }
    function db(n) {
      for (; Mt !== null; ) {
        var r = Mt;
        tr(r);
        try {
          Vj(r);
        } catch (c) {
          Nr(r, r.return, c);
        }
        if (va(), r === n) {
          Mt = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, Mt = u;
          return;
        }
        Mt = r.return;
      }
    }
    function Kj(n, r, u, c) {
      Mt = r, Qj(r, n);
    }
    function Qj(n, r, u, c) {
      for (; Mt !== null; ) {
        var p = Mt, x = p.child;
        (p.subtreeFlags & tl) !== H && x !== null ? (x.return = p, Mt = x) : Xj(n, r);
      }
    }
    function Xj(n, r, u, c) {
      for (; Mt !== null; ) {
        var p = Mt;
        if ((p.flags & mo) !== H) {
          tr(p);
          try {
            Jj(r, p);
          } catch (_) {
            Nr(p, p.return, _);
          }
          va();
        }
        if (p === n) {
          Mt = null;
          return;
        }
        var x = p.sibling;
        if (x !== null) {
          x.return = p.return, Mt = x;
          return;
        }
        Mt = p.return;
      }
    }
    function Jj(n, r, u, c) {
      switch (r.tag) {
        case S:
        case W:
        case te: {
          if (r.mode & Pn) {
            a9();
            try {
              Gd(pi | Co, r);
            } finally {
              r9(r);
            }
          } else
            Gd(pi | Co, r);
          break;
        }
      }
    }
    function eA(n) {
      Mt = n, tA();
    }
    function tA() {
      for (; Mt !== null; ) {
        var n = Mt, r = n.child;
        if ((Mt.flags & Kt) !== H) {
          var u = n.deletions;
          if (u !== null) {
            for (var c = 0; c < u.length; c++) {
              var p = u[c];
              Mt = p, aA(p, n);
            }
            {
              var x = n.alternate;
              if (x !== null) {
                var _ = x.child;
                if (_ !== null) {
                  x.child = null;
                  do {
                    var O = _.sibling;
                    _.sibling = null, _ = O;
                  } while (_ !== null);
                }
              }
            }
            Mt = n;
          }
        }
        (n.subtreeFlags & tl) !== H && r !== null ? (r.return = n, Mt = r) : nA();
      }
    }
    function nA() {
      for (; Mt !== null; ) {
        var n = Mt;
        (n.flags & mo) !== H && (tr(n), rA(n), va());
        var r = n.sibling;
        if (r !== null) {
          r.return = n.return, Mt = r;
          return;
        }
        Mt = n.return;
      }
    }
    function rA(n) {
      switch (n.tag) {
        case S:
        case W:
        case te: {
          n.mode & Pn ? (a9(), w1(pi | Co, n, n.return), r9(n)) : w1(pi | Co, n, n.return);
          break;
        }
      }
    }
    function aA(n, r) {
      for (; Mt !== null; ) {
        var u = Mt;
        tr(u), iA(u, r), va();
        var c = u.child;
        c !== null ? (c.return = u, Mt = c) : oA(n);
      }
    }
    function oA(n) {
      for (; Mt !== null; ) {
        var r = Mt, u = r.sibling, c = r.return;
        if (ab(r), r === n) {
          Mt = null;
          return;
        }
        if (u !== null) {
          u.return = c, Mt = u;
          return;
        }
        Mt = c;
      }
    }
    function iA(n, r) {
      switch (n.tag) {
        case S:
        case W:
        case te: {
          n.mode & Pn ? (a9(), w1(pi, n, r), r9(n)) : w1(pi, n, r);
          break;
        }
      }
    }
    function lA(n) {
      switch (n.tag) {
        case S:
        case W:
        case te: {
          try {
            Gd(bo | Co, n);
          } catch (u) {
            Nr(n, n.return, u);
          }
          break;
        }
        case R: {
          var r = n.stateNode;
          try {
            r.componentDidMount();
          } catch (u) {
            Nr(n, n.return, u);
          }
          break;
        }
      }
    }
    function uA(n) {
      switch (n.tag) {
        case S:
        case W:
        case te: {
          try {
            Gd(pi | Co, n);
          } catch (r) {
            Nr(n, n.return, r);
          }
          break;
        }
      }
    }
    function sA(n) {
      switch (n.tag) {
        case S:
        case W:
        case te: {
          try {
            w1(bo | Co, n, n.return);
          } catch (u) {
            Nr(n, n.return, u);
          }
          break;
        }
        case R: {
          var r = n.stateNode;
          typeof r.componentWillUnmount == "function" && H9(n, n.return, r);
          break;
        }
      }
    }
    function cA(n) {
      switch (n.tag) {
        case S:
        case W:
        case te:
          try {
            w1(pi | Co, n, n.return);
          } catch (r) {
            Nr(n, n.return, r);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var i4 = Symbol.for;
      i4("selector.component"), i4("selector.has_pseudo_class"), i4("selector.role"), i4("selector.test_id"), i4("selector.text");
    }
    var fA = [];
    function dA() {
      fA.forEach(function(n) {
        return n();
      });
    }
    var hA = a.ReactCurrentActQueue;
    function vA(n) {
      {
        var r = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), u = typeof jest < "u";
        return u && r !== !1;
      }
    }
    function hb() {
      {
        var n = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !n && hA.current !== null && m("The current testing environment is not configured to support act(...)"), n;
      }
    }
    var pA = Math.ceil, N9 = a.ReactCurrentDispatcher, B9 = a.ReactCurrentOwner, yi = a.ReactCurrentBatchConfig, S1 = a.ReactCurrentActQueue, Eo = (
      /*             */
      0
    ), vb = (
      /*               */
      1
    ), xi = (
      /*                */
      2
    ), _s = (
      /*                */
      4
    ), Jc = 0, l4 = 1, _2 = 2, Fg = 3, u4 = 4, pb = 5, F9 = 6, On = Eo, wl = null, ya = null, Mo = He, M0 = He, U9 = cn(He), To = Jc, s4 = null, Ug = He, c4 = He, Yg = He, f4 = null, zl = null, Y9 = 0, mb = 500, gb = 1 / 0, mA = 500, ef = null;
    function d4() {
      gb = Yr() + mA;
    }
    function wb() {
      return gb;
    }
    var $g = !1, $9 = null, cp = null, R2 = !1, Qd = null, h4 = He, W9 = [], gA = 50, v4 = 0, z9 = null, q9 = !1, Wg = !1, wA = 50, fp = 0, zg = null, p4 = dr, qg = He, yb = !1;
    function Gg() {
      return wl;
    }
    function yl() {
      return (On & (xi | _s)) !== Eo ? Yr() : (p4 !== dr || (p4 = Yr()), p4);
    }
    function Xd(n) {
      var r = n.mode;
      if ((r & on) === tt)
        return It;
      if ((On & xi) !== Eo && Mo !== He)
        return xu(Mo);
      var u = vD() !== hD;
      if (u) {
        if (yi.transition !== null) {
          var c = yi.transition;
          c._updatedFibers || (c._updatedFibers = /* @__PURE__ */ new Set()), c._updatedFibers.add(n);
        }
        return qg === Vr && (qg = $h()), qg;
      }
      var p = No();
      if (p !== Vr)
        return p;
      var x = w6();
      return x;
    }
    function yA(n) {
      var r = n.mode;
      return (r & on) === tt ? It : Mc();
    }
    function Oo(n, r, u, c) {
      UA(), yb && m("useInsertionEffect must not schedule updates."), q9 && (Wg = !0), Qs(n, u, c), (On & xi) !== He && n === wl ? WA(r) : (Zn && f0(n, r, u), zA(r), n === wl && ((On & xi) === Eo && (c4 = At(c4, u)), To === u4 && Jd(n, Mo)), ql(n, c), u === It && On === Eo && (r.mode & on) === tt && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !S1.isBatchingLegacy && (d4(), yS()));
    }
    function xA(n, r, u) {
      var c = n.current;
      c.lanes = r, Qs(n, r, u), ql(n, u);
    }
    function SA(n) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (On & xi) !== Eo
      );
    }
    function ql(n, r) {
      var u = n.callbackNode;
      u0(n, r);
      var c = Gs(n, n === wl ? Mo : He);
      if (c === He) {
        u !== null && Ib(u), n.callbackNode = null, n.callbackPriority = Vr;
        return;
      }
      var p = Bl(c), x = n.callbackPriority;
      if (x === p && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(S1.current !== null && u !== t8)) {
        u == null && x !== It && m("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      u != null && Ib(u);
      var _;
      if (p === It)
        n.tag === Bd ? (S1.isBatchingLegacy !== null && (S1.didScheduleLegacyUpdate = !0), KO(Cb.bind(null, n))) : wS(Cb.bind(null, n)), S1.current !== null ? S1.current.push(Fd) : x6(function() {
          (On & (xi | _s)) === Eo && Fd();
        }), _ = null;
      else {
        var O;
        switch (gd(c)) {
          case zr:
            O = $a;
            break;
          case jt:
            O = rd;
            break;
          case oi:
            O = al;
            break;
          case us:
            O = ji;
            break;
          default:
            O = al;
            break;
        }
        _ = n8(O, xb.bind(null, n));
      }
      n.callbackPriority = p, n.callbackNode = _;
    }
    function xb(n, r) {
      if (ND(), p4 = dr, qg = He, (On & (xi | _s)) !== Eo)
        throw new Error("Should not already be working.");
      var u = n.callbackNode, c = nf();
      if (c && n.callbackNode !== u)
        return null;
      var p = Gs(n, n === wl ? Mo : He);
      if (p === He)
        return null;
      var x = !Nl(n, p) && !hd(n, p) && !r, _ = x ? jA(n, p) : Qg(n, p);
      if (_ !== Jc) {
        if (_ === _2) {
          var O = s0(n);
          O !== He && (p = O, _ = G9(n, O));
        }
        if (_ === l4) {
          var k = s4;
          throw E2(n, He), Jd(n, p), ql(n, Yr()), k;
        }
        if (_ === F9)
          Jd(n, p);
        else {
          var N = !Nl(n, p), U = n.current.alternate;
          if (N && !bA(U)) {
            if (_ = Qg(n, p), _ === _2) {
              var oe = s0(n);
              oe !== He && (p = oe, _ = G9(n, oe));
            }
            if (_ === l4) {
              var ae = s4;
              throw E2(n, He), Jd(n, p), ql(n, Yr()), ae;
            }
          }
          n.finishedWork = U, n.finishedLanes = p, CA(n, _, p);
        }
      }
      return ql(n, Yr()), n.callbackNode === u ? xb.bind(null, n) : null;
    }
    function G9(n, r) {
      var u = f4;
      if (ss(n)) {
        var c = E2(n, r);
        c.flags |= ia, J6(n.containerInfo);
      }
      var p = Qg(n, r);
      if (p !== _2) {
        var x = zl;
        zl = u, x !== null && Sb(x);
      }
      return p;
    }
    function Sb(n) {
      zl === null ? zl = n : zl.push.apply(zl, n);
    }
    function CA(n, r, u) {
      switch (r) {
        case Jc:
        case l4:
          throw new Error("Root did not complete. This is a bug in React.");
        case _2: {
          M2(n, zl, ef);
          break;
        }
        case Fg: {
          if (Jd(n, u), is(u) && // do not delay if we're inside an act() scope
          !Hb()) {
            var c = Y9 + mb - Yr();
            if (c > 10) {
              var p = Gs(n, He);
              if (p !== He)
                break;
              var x = n.suspendedLanes;
              if (!ua(x, u)) {
                yl(), pd(n, x);
                break;
              }
              n.timeoutHandle = Rm(M2.bind(null, n, zl, ef), c);
              break;
            }
          }
          M2(n, zl, ef);
          break;
        }
        case u4: {
          if (Jd(n, u), Yh(u))
            break;
          if (!Hb()) {
            var _ = Xp(n, u), O = _, k = Yr() - O, N = FA(k) - k;
            if (N > 10) {
              n.timeoutHandle = Rm(M2.bind(null, n, zl, ef), N);
              break;
            }
          }
          M2(n, zl, ef);
          break;
        }
        case pb: {
          M2(n, zl, ef);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function bA(n) {
      for (var r = n; ; ) {
        if (r.flags & Fa) {
          var u = r.updateQueue;
          if (u !== null) {
            var c = u.stores;
            if (c !== null)
              for (var p = 0; p < c.length; p++) {
                var x = c[p], _ = x.getSnapshot, O = x.value;
                try {
                  if (!ce(_(), O))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var k = r.child;
        if (r.subtreeFlags & Fa && k !== null) {
          k.return = r, r = k;
          continue;
        }
        if (r === n)
          return !0;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === n)
            return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return !0;
    }
    function Jd(n, r) {
      r = Oc(r, Yg), r = Oc(r, c4), zh(n, r);
    }
    function Cb(n) {
      if (BD(), (On & (xi | _s)) !== Eo)
        throw new Error("Should not already be working.");
      nf();
      var r = Gs(n, He);
      if (!oo(r, It))
        return ql(n, Yr()), null;
      var u = Qg(n, r);
      if (n.tag !== Bd && u === _2) {
        var c = s0(n);
        c !== He && (r = c, u = G9(n, c));
      }
      if (u === l4) {
        var p = s4;
        throw E2(n, He), Jd(n, r), ql(n, Yr()), p;
      }
      if (u === F9)
        throw new Error("Root did not complete. This is a bug in React.");
      var x = n.current.alternate;
      return n.finishedWork = x, n.finishedLanes = r, M2(n, zl, ef), ql(n, Yr()), null;
    }
    function _A(n, r) {
      r !== He && (Ii(n, At(r, It)), ql(n, Yr()), (On & (xi | _s)) === Eo && (d4(), Fd()));
    }
    function K9(n, r) {
      var u = On;
      On |= vb;
      try {
        return n(r);
      } finally {
        On = u, On === Eo && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !S1.isBatchingLegacy && (d4(), yS());
      }
    }
    function RA(n, r, u, c, p) {
      var x = No(), _ = yi.transition;
      try {
        return yi.transition = null, rr(zr), n(r, u, c, p);
      } finally {
        rr(x), yi.transition = _, On === Eo && d4();
      }
    }
    function tf(n) {
      Qd !== null && Qd.tag === Bd && (On & (xi | _s)) === Eo && nf();
      var r = On;
      On |= vb;
      var u = yi.transition, c = No();
      try {
        return yi.transition = null, rr(zr), n ? n() : void 0;
      } finally {
        rr(c), yi.transition = u, On = r, (On & (xi | _s)) === Eo && Fd();
      }
    }
    function bb() {
      return (On & (xi | _s)) !== Eo;
    }
    function Kg(n, r) {
      ar(U9, M0, n), M0 = At(M0, r);
    }
    function Q9(n) {
      M0 = U9.current, mr(U9, n);
    }
    function E2(n, r) {
      n.finishedWork = null, n.finishedLanes = He;
      var u = n.timeoutHandle;
      if (u !== Em && (n.timeoutHandle = Em, y6(u)), ya !== null)
        for (var c = ya.return; c !== null; ) {
          var p = c.alternate;
          XC(p, c), c = c.return;
        }
      wl = n;
      var x = T2(n.current, null);
      return ya = x, Mo = M0 = r, To = Jc, s4 = null, Ug = He, c4 = He, Yg = He, f4 = null, zl = null, SD(), h1.discardPendingWarnings(), x;
    }
    function _b(n, r) {
      do {
        var u = ya;
        try {
          if (ig(), qS(), va(), B9.current = null, u === null || u.return === null) {
            To = l4, s4 = r, ya = null;
            return;
          }
          if (u.mode & Pn && Ig(u, !0), Xu(), r !== null && typeof r == "object" && typeof r.then == "function") {
            var c = r;
            J1(u, c, Mo);
          } else
            hv(u, r, Mo);
          KD(n, u.return, u, r, Mo), Tb(u);
        } catch (p) {
          r = p, ya === u && u !== null ? (u = u.return, ya = u) : u = ya;
          continue;
        }
        return;
      } while (!0);
    }
    function Rb() {
      var n = N9.current;
      return N9.current = Dg, n === null ? Dg : n;
    }
    function Eb(n) {
      N9.current = n;
    }
    function EA() {
      Y9 = Yr();
    }
    function m4(n) {
      Ug = At(n, Ug);
    }
    function MA() {
      To === Jc && (To = Fg);
    }
    function X9() {
      (To === Jc || To === Fg || To === _2) && (To = u4), wl !== null && (Ec(Ug) || Ec(c4)) && Jd(wl, Mo);
    }
    function TA(n) {
      To !== u4 && (To = _2), f4 === null ? f4 = [n] : f4.push(n);
    }
    function OA() {
      return To === Jc;
    }
    function Qg(n, r) {
      var u = On;
      On |= xi;
      var c = Rb();
      if (wl !== n || Mo !== r) {
        if (Zn) {
          var p = n.memoizedUpdaters;
          p.size > 0 && (g4(n, Mo), p.clear()), Ac(n, r);
        }
        ef = Xs(), E2(n, r);
      }
      $s(r);
      do
        try {
          DA();
          break;
        } catch (x) {
          _b(n, x);
        }
      while (!0);
      if (ig(), On = u, Eb(c), ya !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return ud(), wl = null, Mo = He, To;
    }
    function DA() {
      for (; ya !== null; )
        Mb(ya);
    }
    function jA(n, r) {
      var u = On;
      On |= xi;
      var c = Rb();
      if (wl !== n || Mo !== r) {
        if (Zn) {
          var p = n.memoizedUpdaters;
          p.size > 0 && (g4(n, Mo), p.clear()), Ac(n, r);
        }
        ef = Xs(), d4(), E2(n, r);
      }
      $s(r);
      do
        try {
          AA();
          break;
        } catch (x) {
          _b(n, x);
        }
      while (!0);
      return ig(), Eb(c), On = u, ya !== null ? (wu(), Jc) : (ud(), wl = null, Mo = He, To);
    }
    function AA() {
      for (; ya !== null && !rl(); )
        Mb(ya);
    }
    function Mb(n) {
      var r = n.alternate;
      tr(n);
      var u;
      (n.mode & Pn) !== tt ? (n9(n), u = J9(r, n, M0), Ig(n, !0)) : u = J9(r, n, M0), va(), n.memoizedProps = n.pendingProps, u === null ? Tb(n) : ya = u, B9.current = null;
    }
    function Tb(n) {
      var r = n;
      do {
        var u = r.alternate, c = r.return;
        if ((r.flags & Ua) === H) {
          tr(r);
          var p = void 0;
          if ((r.mode & Pn) === tt ? p = QC(u, r, M0) : (n9(r), p = QC(u, r, M0), Ig(r, !1)), va(), p !== null) {
            ya = p;
            return;
          }
        } else {
          var x = Tj(u, r);
          if (x !== null) {
            x.flags &= K1, ya = x;
            return;
          }
          if ((r.mode & Pn) !== tt) {
            Ig(r, !1);
            for (var _ = r.actualDuration, O = r.child; O !== null; )
              _ += O.actualDuration, O = O.sibling;
            r.actualDuration = _;
          }
          if (c !== null)
            c.flags |= Ua, c.subtreeFlags = H, c.deletions = null;
          else {
            To = F9, ya = null;
            return;
          }
        }
        var k = r.sibling;
        if (k !== null) {
          ya = k;
          return;
        }
        r = c, ya = r;
      } while (r !== null);
      To === Jc && (To = pb);
    }
    function M2(n, r, u) {
      var c = No(), p = yi.transition;
      try {
        yi.transition = null, rr(zr), kA(n, r, u, c);
      } finally {
        yi.transition = p, rr(c);
      }
      return null;
    }
    function kA(n, r, u, c) {
      do
        nf();
      while (Qd !== null);
      if (YA(), (On & (xi | _s)) !== Eo)
        throw new Error("Should not already be working.");
      var p = n.finishedWork, x = n.finishedLanes;
      if (Qu(x), p === null)
        return ri(), null;
      if (x === He && m("root.finishedLanes should not be empty during a commit. This is a bug in React."), n.finishedWork = null, n.finishedLanes = He, p === n.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      n.callbackNode = null, n.callbackPriority = Vr;
      var _ = At(p.lanes, p.childLanes);
      vv(n, _), n === wl && (wl = null, ya = null, Mo = He), ((p.subtreeFlags & tl) !== H || (p.flags & tl) !== H) && (R2 || (R2 = !0, n8(al, function() {
        return nf(), null;
      })));
      var O = (p.subtreeFlags & (td | vu | Di | tl)) !== H, k = (p.flags & (td | vu | Di | tl)) !== H;
      if (O || k) {
        var N = yi.transition;
        yi.transition = null;
        var U = No();
        rr(zr);
        var oe = On;
        On |= _s, B9.current = null, kj(n, p), yC(), Wj(n, p, x), d6(), n.current = p, Bh(x), zj(p, n, x), wc(), Hl(), On = oe, rr(U), yi.transition = N;
      } else
        n.current = p, yC();
      var ae = R2;
      if (R2 ? (R2 = !1, Qd = n, h4 = x) : (fp = 0, zg = null), _ = n.pendingLanes, _ === He && (cp = null), ae || Ab(n.current, !1), ni(p.stateNode, c), Zn && n.memoizedUpdaters.clear(), dA(), ql(n, Yr()), r !== null)
        for (var we = n.onRecoverableError, Ce = 0; Ce < r.length; Ce++) {
          var Ee = r[Ce], it = Ee.stack, Ut = Ee.digest;
          we(Ee.value, {
            componentStack: it,
            digest: Ut
          });
        }
      if ($g) {
        $g = !1;
        var Lt = $9;
        throw $9 = null, Lt;
      }
      return oo(h4, It) && n.tag !== Bd && nf(), _ = n.pendingLanes, oo(_, It) ? (VD(), n === z9 ? v4++ : (v4 = 0, z9 = n)) : v4 = 0, Fd(), ri(), null;
    }
    function nf() {
      if (Qd !== null) {
        var n = gd(h4), r = qh(oi, n), u = yi.transition, c = No();
        try {
          return yi.transition = null, rr(r), IA();
        } finally {
          rr(c), yi.transition = u;
        }
      }
      return !1;
    }
    function LA(n) {
      W9.push(n), R2 || (R2 = !0, n8(al, function() {
        return nf(), null;
      }));
    }
    function IA() {
      if (Qd === null)
        return !1;
      var n = Qd, r = h4;
      if (Qd = null, h4 = He, (On & (xi | _s)) !== Eo)
        throw new Error("Cannot flush passive effects while already rendering.");
      q9 = !0, Wg = !1, Vl(r);
      var u = On;
      On |= _s, eA(n.current), Kj(n, n.current);
      {
        var c = W9;
        W9 = [];
        for (var p = 0; p < c.length; p++) {
          var x = c[p];
          Zj(n, x);
        }
      }
      yc(), Ab(n.current, !0), On = u, Fd(), Wg ? n === zg ? fp++ : (fp = 0, zg = n) : fp = 0, q9 = !1, Wg = !1, Ku(n);
      {
        var _ = n.current.stateNode;
        _.effectDuration = 0, _.passiveEffectDuration = 0;
      }
      return !0;
    }
    function Ob(n) {
      return cp !== null && cp.has(n);
    }
    function HA(n) {
      cp === null ? cp = /* @__PURE__ */ new Set([n]) : cp.add(n);
    }
    function ZA(n) {
      $g || ($g = !0, $9 = n);
    }
    var PA = ZA;
    function Db(n, r, u) {
      var c = C2(u, r), p = MC(n, c, It), x = Yd(n, p, It), _ = yl();
      x !== null && (Qs(x, It, _), ql(x, _));
    }
    function Nr(n, r, u) {
      if (Dj(u), w4(!1), n.tag === T) {
        Db(n, n, u);
        return;
      }
      var c = null;
      for (c = r; c !== null; ) {
        if (c.tag === T) {
          Db(c, n, u);
          return;
        } else if (c.tag === R) {
          var p = c.type, x = c.stateNode;
          if (typeof p.getDerivedStateFromError == "function" || typeof x.componentDidCatch == "function" && !Ob(x)) {
            var _ = C2(u, n), O = x9(c, _, It), k = Yd(c, O, It), N = yl();
            k !== null && (Qs(k, It, N), ql(k, N));
            return;
          }
        }
        c = c.return;
      }
      m(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, u);
    }
    function VA(n, r, u) {
      var c = n.pingCache;
      c !== null && c.delete(r);
      var p = yl();
      pd(n, u), qA(n), wl === n && ua(Mo, u) && (To === u4 || To === Fg && is(Mo) && Yr() - Y9 < mb ? E2(n, He) : Yg = At(Yg, u)), ql(n, p);
    }
    function jb(n, r) {
      r === Vr && (r = yA(n));
      var u = yl(), c = $l(n, r);
      c !== null && (Qs(c, r, u), ql(c, u));
    }
    function NA(n) {
      var r = n.memoizedState, u = Vr;
      r !== null && (u = r.retryLane), jb(n, u);
    }
    function BA(n, r) {
      var u = Vr, c;
      switch (n.tag) {
        case $:
          c = n.stateNode;
          var p = n.memoizedState;
          p !== null && (u = p.retryLane);
          break;
        case K:
          c = n.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      c !== null && c.delete(r), jb(n, u);
    }
    function FA(n) {
      return n < 120 ? 120 : n < 480 ? 480 : n < 1080 ? 1080 : n < 1920 ? 1920 : n < 3e3 ? 3e3 : n < 4320 ? 4320 : pA(n / 1960) * 1960;
    }
    function UA() {
      if (v4 > gA)
        throw v4 = 0, z9 = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      fp > wA && (fp = 0, zg = null, m("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function YA() {
      h1.flushLegacyContextWarning(), h1.flushPendingUnsafeLifecycleWarnings();
    }
    function Ab(n, r) {
      tr(n), Xg(n, el, sA), r && Xg(n, pc, cA), Xg(n, el, lA), r && Xg(n, pc, uA), va();
    }
    function Xg(n, r, u) {
      for (var c = n, p = null; c !== null; ) {
        var x = c.subtreeFlags & r;
        c !== p && c.child !== null && x !== H ? c = c.child : ((c.flags & r) !== H && u(c), c.sibling !== null ? c = c.sibling : c = p = c.return);
      }
    }
    var Jg = null;
    function kb(n) {
      {
        if ((On & xi) !== Eo || !(n.mode & on))
          return;
        var r = n.tag;
        if (r !== D && r !== T && r !== R && r !== S && r !== W && r !== le && r !== te)
          return;
        var u = en(n) || "ReactComponent";
        if (Jg !== null) {
          if (Jg.has(u))
            return;
          Jg.add(u);
        } else
          Jg = /* @__PURE__ */ new Set([u]);
        var c = ko;
        try {
          tr(n), m("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          c ? tr(n) : va();
        }
      }
    }
    var J9;
    {
      var $A = null;
      J9 = function(n, r, u) {
        var c = Nb($A, r);
        try {
          return WC(n, r, u);
        } catch (x) {
          if (aD() || x !== null && typeof x == "object" && typeof x.then == "function")
            throw x;
          if (ig(), qS(), XC(n, r), Nb(r, c), r.mode & Pn && n9(r), vc(null, WC, null, n, r, u), G1()) {
            var p = Oi();
            typeof p == "object" && p !== null && p._suppressLogging && typeof x == "object" && x !== null && !x._suppressLogging && (x._suppressLogging = !0);
          }
          throw x;
        }
      };
    }
    var Lb = !1, e8;
    e8 = /* @__PURE__ */ new Set();
    function WA(n) {
      if (ks && !HD())
        switch (n.tag) {
          case S:
          case W:
          case te: {
            var r = ya && en(ya) || "Unknown", u = r;
            if (!e8.has(u)) {
              e8.add(u);
              var c = en(n) || "Unknown";
              m("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", c, r, r);
            }
            break;
          }
          case R: {
            Lb || (m("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), Lb = !0);
            break;
          }
        }
    }
    function g4(n, r) {
      if (Zn) {
        var u = n.memoizedUpdaters;
        u.forEach(function(c) {
          f0(n, c, r);
        });
      }
    }
    var t8 = {};
    function n8(n, r) {
      {
        var u = S1.current;
        return u !== null ? (u.push(r), t8) : Zo(n, r);
      }
    }
    function Ib(n) {
      if (n !== t8)
        return br(n);
    }
    function Hb() {
      return S1.current !== null;
    }
    function zA(n) {
      {
        if (n.mode & on) {
          if (!hb())
            return;
        } else if (!vA() || On !== Eo || n.tag !== S && n.tag !== W && n.tag !== te)
          return;
        if (S1.current === null) {
          var r = ko;
          try {
            tr(n), m(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, en(n));
          } finally {
            r ? tr(n) : va();
          }
        }
      }
    }
    function qA(n) {
      n.tag !== Bd && hb() && S1.current === null && m(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function w4(n) {
      yb = n;
    }
    var Rs = null, dp = null, GA = function(n) {
      Rs = n;
    };
    function hp(n) {
      {
        if (Rs === null)
          return n;
        var r = Rs(n);
        return r === void 0 ? n : r.current;
      }
    }
    function r8(n) {
      return hp(n);
    }
    function a8(n) {
      {
        if (Rs === null)
          return n;
        var r = Rs(n);
        if (r === void 0) {
          if (n != null && typeof n.render == "function") {
            var u = hp(n.render);
            if (n.render !== u) {
              var c = {
                $$typeof: Gi,
                render: u
              };
              return n.displayName !== void 0 && (c.displayName = n.displayName), c;
            }
          }
          return n;
        }
        return r.current;
      }
    }
    function Zb(n, r) {
      {
        if (Rs === null)
          return !1;
        var u = n.elementType, c = r.type, p = !1, x = typeof c == "object" && c !== null ? c.$$typeof : null;
        switch (n.tag) {
          case R: {
            typeof c == "function" && (p = !0);
            break;
          }
          case S: {
            (typeof c == "function" || x === Et) && (p = !0);
            break;
          }
          case W: {
            (x === Gi || x === Et) && (p = !0);
            break;
          }
          case le:
          case te: {
            (x === dt || x === Et) && (p = !0);
            break;
          }
          default:
            return !1;
        }
        if (p) {
          var _ = Rs(u);
          if (_ !== void 0 && _ === Rs(c))
            return !0;
        }
        return !1;
      }
    }
    function Pb(n) {
      {
        if (Rs === null || typeof WeakSet != "function")
          return;
        dp === null && (dp = /* @__PURE__ */ new WeakSet()), dp.add(n);
      }
    }
    var KA = function(n, r) {
      {
        if (Rs === null)
          return;
        var u = r.staleFamilies, c = r.updatedFamilies;
        nf(), tf(function() {
          o8(n.current, c, u);
        });
      }
    }, QA = function(n, r) {
      {
        if (n.context !== $n)
          return;
        nf(), tf(function() {
          y4(r, n, null, null);
        });
      }
    };
    function o8(n, r, u) {
      {
        var c = n.alternate, p = n.child, x = n.sibling, _ = n.tag, O = n.type, k = null;
        switch (_) {
          case S:
          case te:
          case R:
            k = O;
            break;
          case W:
            k = O.render;
            break;
        }
        if (Rs === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var N = !1, U = !1;
        if (k !== null) {
          var oe = Rs(k);
          oe !== void 0 && (u.has(oe) ? U = !0 : r.has(oe) && (_ === R ? U = !0 : N = !0));
        }
        if (dp !== null && (dp.has(n) || c !== null && dp.has(c)) && (U = !0), U && (n._debugNeedsRemount = !0), U || N) {
          var ae = $l(n, It);
          ae !== null && Oo(ae, n, It, dr);
        }
        p !== null && !U && o8(p, r, u), x !== null && o8(x, r, u);
      }
    }
    var XA = function(n, r) {
      {
        var u = /* @__PURE__ */ new Set(), c = new Set(r.map(function(p) {
          return p.current;
        }));
        return i8(n.current, c, u), u;
      }
    };
    function i8(n, r, u) {
      {
        var c = n.child, p = n.sibling, x = n.tag, _ = n.type, O = null;
        switch (x) {
          case S:
          case te:
          case R:
            O = _;
            break;
          case W:
            O = _.render;
            break;
        }
        var k = !1;
        O !== null && r.has(O) && (k = !0), k ? JA(n, u) : c !== null && i8(c, r, u), p !== null && i8(p, r, u);
      }
    }
    function JA(n, r) {
      {
        var u = ek(n, r);
        if (u)
          return;
        for (var c = n; ; ) {
          switch (c.tag) {
            case A:
              r.add(c.stateNode);
              return;
            case j:
              r.add(c.stateNode.containerInfo);
              return;
            case T:
              r.add(c.stateNode.containerInfo);
              return;
          }
          if (c.return === null)
            throw new Error("Expected to reach root first.");
          c = c.return;
        }
      }
    }
    function ek(n, r) {
      for (var u = n, c = !1; ; ) {
        if (u.tag === A)
          c = !0, r.add(u.stateNode);
        else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === n)
          return c;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === n)
            return c;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return !1;
    }
    var l8;
    {
      l8 = !1;
      try {
        Object.preventExtensions({});
      } catch {
        l8 = !0;
      }
    }
    function tk(n, r, u, c) {
      this.tag = n, this.key = u, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = r, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = c, this.flags = H, this.subtreeFlags = H, this.deletions = null, this.lanes = He, this.childLanes = He, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !l8 && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var Du = function(n, r, u, c) {
      return new tk(n, r, u, c);
    };
    function u8(n) {
      var r = n.prototype;
      return !!(r && r.isReactComponent);
    }
    function nk(n) {
      return typeof n == "function" && !u8(n) && n.defaultProps === void 0;
    }
    function rk(n) {
      if (typeof n == "function")
        return u8(n) ? R : S;
      if (n != null) {
        var r = n.$$typeof;
        if (r === Gi)
          return W;
        if (r === dt)
          return le;
      }
      return D;
    }
    function T2(n, r) {
      var u = n.alternate;
      u === null ? (u = Du(n.tag, r, n.key, n.mode), u.elementType = n.elementType, u.type = n.type, u.stateNode = n.stateNode, u._debugSource = n._debugSource, u._debugOwner = n._debugOwner, u._debugHookTypes = n._debugHookTypes, u.alternate = n, n.alternate = u) : (u.pendingProps = r, u.type = n.type, u.flags = H, u.subtreeFlags = H, u.deletions = null, u.actualDuration = 0, u.actualStartTime = -1), u.flags = n.flags & Mr, u.childLanes = n.childLanes, u.lanes = n.lanes, u.child = n.child, u.memoizedProps = n.memoizedProps, u.memoizedState = n.memoizedState, u.updateQueue = n.updateQueue;
      var c = n.dependencies;
      switch (u.dependencies = c === null ? null : {
        lanes: c.lanes,
        firstContext: c.firstContext
      }, u.sibling = n.sibling, u.index = n.index, u.ref = n.ref, u.selfBaseDuration = n.selfBaseDuration, u.treeBaseDuration = n.treeBaseDuration, u._debugNeedsRemount = n._debugNeedsRemount, u.tag) {
        case D:
        case S:
        case te:
          u.type = hp(n.type);
          break;
        case R:
          u.type = r8(n.type);
          break;
        case W:
          u.type = a8(n.type);
          break;
      }
      return u;
    }
    function ak(n, r) {
      n.flags &= Mr | fr;
      var u = n.alternate;
      if (u === null)
        n.childLanes = He, n.lanes = r, n.child = null, n.subtreeFlags = H, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null, n.selfBaseDuration = 0, n.treeBaseDuration = 0;
      else {
        n.childLanes = u.childLanes, n.lanes = u.lanes, n.child = u.child, n.subtreeFlags = H, n.deletions = null, n.memoizedProps = u.memoizedProps, n.memoizedState = u.memoizedState, n.updateQueue = u.updateQueue, n.type = u.type;
        var c = u.dependencies;
        n.dependencies = c === null ? null : {
          lanes: c.lanes,
          firstContext: c.firstContext
        }, n.selfBaseDuration = u.selfBaseDuration, n.treeBaseDuration = u.treeBaseDuration;
      }
      return n;
    }
    function ok(n, r, u) {
      var c;
      return n === K3 ? (c = on, r === !0 && (c |= _r, c |= Po)) : c = tt, Zn && (c |= Pn), Du(T, null, null, c);
    }
    function s8(n, r, u, c, p, x) {
      var _ = D, O = n;
      if (typeof n == "function")
        u8(n) ? (_ = R, O = r8(O)) : O = hp(O);
      else if (typeof n == "string")
        _ = A;
      else
        e: switch (n) {
          case Wo:
            return eh(u.children, p, x, r);
          case Ol:
            _ = V, p |= _r, (p & on) !== tt && (p |= Po);
            break;
          case eu:
            return ik(u, p, x, r);
          case X:
            return lk(u, p, x, r);
          case $e:
            return uk(u, p, x, r);
          case dn:
            return Vb(u, p, x, r);
          case hn:
          case Nn:
          case Za:
          case Rr:
          case yn:
          default: {
            if (typeof n == "object" && n !== null)
              switch (n.$$typeof) {
                case js:
                  _ = Y;
                  break e;
                case tu:
                  _ = F;
                  break e;
                case Gi:
                  _ = W, O = a8(O);
                  break e;
                case dt:
                  _ = le;
                  break e;
                case Et:
                  _ = Se, O = null;
                  break e;
              }
            var k = "";
            {
              (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var N = c ? en(c) : null;
              N && (k += `

Check the render method of \`` + N + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (n == null ? n : typeof n) + "." + k));
          }
        }
      var U = Du(_, u, r, p);
      return U.elementType = n, U.type = O, U.lanes = x, U._debugOwner = c, U;
    }
    function c8(n, r, u) {
      var c = null;
      c = n._owner;
      var p = n.type, x = n.key, _ = n.props, O = s8(p, x, _, c, r, u);
      return O._debugSource = n._source, O._debugOwner = n._owner, O;
    }
    function eh(n, r, u, c) {
      var p = Du(P, n, c, r);
      return p.lanes = u, p;
    }
    function ik(n, r, u, c) {
      typeof n.id != "string" && m('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof n.id);
      var p = Du(Q, n, c, r | Pn);
      return p.elementType = eu, p.lanes = u, p.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, p;
    }
    function lk(n, r, u, c) {
      var p = Du($, n, c, r);
      return p.elementType = X, p.lanes = u, p;
    }
    function uk(n, r, u, c) {
      var p = Du(K, n, c, r);
      return p.elementType = $e, p.lanes = u, p;
    }
    function Vb(n, r, u, c) {
      var p = Du(fe, n, c, r);
      p.elementType = dn, p.lanes = u;
      var x = {
        isHidden: !1
      };
      return p.stateNode = x, p;
    }
    function f8(n, r, u) {
      var c = Du(L, n, null, r);
      return c.lanes = u, c;
    }
    function sk() {
      var n = Du(A, null, null, tt);
      return n.elementType = "DELETED", n;
    }
    function ck(n) {
      var r = Du(ve, null, null, tt);
      return r.stateNode = n, r;
    }
    function d8(n, r, u) {
      var c = n.children !== null ? n.children : [], p = Du(j, c, n.key, r);
      return p.lanes = u, p.stateNode = {
        containerInfo: n.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: n.implementation
      }, p;
    }
    function Nb(n, r) {
      return n === null && (n = Du(D, null, null, tt)), n.tag = r.tag, n.key = r.key, n.elementType = r.elementType, n.type = r.type, n.stateNode = r.stateNode, n.return = r.return, n.child = r.child, n.sibling = r.sibling, n.index = r.index, n.ref = r.ref, n.pendingProps = r.pendingProps, n.memoizedProps = r.memoizedProps, n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.dependencies = r.dependencies, n.mode = r.mode, n.flags = r.flags, n.subtreeFlags = r.subtreeFlags, n.deletions = r.deletions, n.lanes = r.lanes, n.childLanes = r.childLanes, n.alternate = r.alternate, n.actualDuration = r.actualDuration, n.actualStartTime = r.actualStartTime, n.selfBaseDuration = r.selfBaseDuration, n.treeBaseDuration = r.treeBaseDuration, n._debugSource = r._debugSource, n._debugOwner = r._debugOwner, n._debugNeedsRemount = r._debugNeedsRemount, n._debugHookTypes = r._debugHookTypes, n;
    }
    function fk(n, r, u, c, p) {
      this.tag = r, this.containerInfo = n, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Em, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Vr, this.eventTimes = Dc(He), this.expirationTimes = Dc(dr), this.pendingLanes = He, this.suspendedLanes = He, this.pingedLanes = He, this.expiredLanes = He, this.mutableReadLanes = He, this.finishedLanes = He, this.entangledLanes = He, this.entanglements = Dc(He), this.identifierPrefix = c, this.onRecoverableError = p, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var x = this.pendingUpdatersLaneMap = [], _ = 0; _ < Wr; _++)
          x.push(/* @__PURE__ */ new Set());
      }
      switch (r) {
        case K3:
          this._debugRootType = u ? "hydrateRoot()" : "createRoot()";
          break;
        case Bd:
          this._debugRootType = u ? "hydrate()" : "render()";
          break;
      }
    }
    function Bb(n, r, u, c, p, x, _, O, k, N) {
      var U = new fk(n, r, u, O, k), oe = ok(r, x);
      U.current = oe, oe.stateNode = U;
      {
        var ae = {
          element: c,
          isDehydrated: u,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        oe.memoizedState = ae;
      }
      return E7(oe), U;
    }
    var h8 = "18.3.1";
    function dk(n, r, u) {
      var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return yr(c), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Tl,
        key: c == null ? null : "" + c,
        children: n,
        containerInfo: r,
        implementation: u
      };
    }
    var v8, p8;
    v8 = !1, p8 = {};
    function Fb(n) {
      if (!n)
        return $n;
      var r = Xo(n), u = GO(r);
      if (r.tag === R) {
        var c = r.type;
        if (x0(c))
          return mS(r, c, u);
      }
      return u;
    }
    function hk(n, r) {
      {
        var u = Xo(n);
        if (u === void 0) {
          if (typeof n.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var c = Object.keys(n).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + c);
        }
        var p = Vh(u);
        if (p === null)
          return null;
        if (p.mode & _r) {
          var x = en(u) || "Component";
          if (!p8[x]) {
            p8[x] = !0;
            var _ = ko;
            try {
              tr(p), u.mode & _r ? m("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, x) : m("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, x);
            } finally {
              _ ? tr(_) : va();
            }
          }
        }
        return p.stateNode;
      }
    }
    function Ub(n, r, u, c, p, x, _, O) {
      var k = !1, N = null;
      return Bb(n, r, k, N, u, c, p, x, _);
    }
    function Yb(n, r, u, c, p, x, _, O, k, N) {
      var U = !0, oe = Bb(u, c, U, n, p, x, _, O, k);
      oe.context = Fb(null);
      var ae = oe.current, we = yl(), Ce = Xd(ae), Ee = Qc(we, Ce);
      return Ee.callback = r ?? null, Yd(ae, Ee, Ce), xA(oe, Ce, we), oe;
    }
    function y4(n, r, u, c) {
      mc(r, n);
      var p = r.current, x = yl(), _ = Xd(p);
      Ju(_);
      var O = Fb(u);
      r.context === null ? r.context = O : r.pendingContext = O, ks && ko !== null && !v8 && (v8 = !0, m(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, en(ko) || "Unknown"));
      var k = Qc(x, _);
      k.payload = {
        element: n
      }, c = c === void 0 ? null : c, c !== null && (typeof c != "function" && m("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", c), k.callback = c);
      var N = Yd(p, k, _);
      return N !== null && (Oo(N, p, _, x), fg(N, p, _)), _;
    }
    function e5(n) {
      var r = n.current;
      if (!r.child)
        return null;
      switch (r.child.tag) {
        case A:
          return r.child.stateNode;
        default:
          return r.child.stateNode;
      }
    }
    function vk(n) {
      switch (n.tag) {
        case T: {
          var r = n.stateNode;
          if (ss(r)) {
            var u = Li(r);
            _A(r, u);
          }
          break;
        }
        case $: {
          tf(function() {
            var p = $l(n, It);
            if (p !== null) {
              var x = yl();
              Oo(p, n, It, x);
            }
          });
          var c = It;
          m8(n, c);
          break;
        }
      }
    }
    function $b(n, r) {
      var u = n.memoizedState;
      u !== null && u.dehydrated !== null && (u.retryLane = Wh(u.retryLane, r));
    }
    function m8(n, r) {
      $b(n, r);
      var u = n.alternate;
      u && $b(u, r);
    }
    function pk(n) {
      if (n.tag === $) {
        var r = o0, u = $l(n, r);
        if (u !== null) {
          var c = yl();
          Oo(u, n, r, c);
        }
        m8(n, r);
      }
    }
    function mk(n) {
      if (n.tag === $) {
        var r = Xd(n), u = $l(n, r);
        if (u !== null) {
          var c = yl();
          Oo(u, n, r, c);
        }
        m8(n, r);
      }
    }
    function Wb(n) {
      var r = Ys(n);
      return r === null ? null : r.stateNode;
    }
    var zb = function(n) {
      return null;
    };
    function gk(n) {
      return zb(n);
    }
    var qb = function(n) {
      return !1;
    };
    function wk(n) {
      return qb(n);
    }
    var Gb = null, Kb = null, Qb = null, Xb = null, Jb = null, e_ = null, t_ = null, n_ = null, r_ = null;
    {
      var a_ = function(n, r, u) {
        var c = r[u], p = ra(n) ? n.slice() : Gt({}, n);
        return u + 1 === r.length ? (ra(p) ? p.splice(c, 1) : delete p[c], p) : (p[c] = a_(n[c], r, u + 1), p);
      }, o_ = function(n, r) {
        return a_(n, r, 0);
      }, i_ = function(n, r, u, c) {
        var p = r[c], x = ra(n) ? n.slice() : Gt({}, n);
        if (c + 1 === r.length) {
          var _ = u[c];
          x[_] = x[p], ra(x) ? x.splice(p, 1) : delete x[p];
        } else
          x[p] = i_(
            // $FlowFixMe number or string is fine here
            n[p],
            r,
            u,
            c + 1
          );
        return x;
      }, l_ = function(n, r, u) {
        if (r.length !== u.length) {
          g("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var c = 0; c < u.length - 1; c++)
            if (r[c] !== u[c]) {
              g("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return i_(n, r, u, 0);
      }, u_ = function(n, r, u, c) {
        if (u >= r.length)
          return c;
        var p = r[u], x = ra(n) ? n.slice() : Gt({}, n);
        return x[p] = u_(n[p], r, u + 1, c), x;
      }, s_ = function(n, r, u) {
        return u_(n, r, 0, u);
      }, g8 = function(n, r) {
        for (var u = n.memoizedState; u !== null && r > 0; )
          u = u.next, r--;
        return u;
      };
      Gb = function(n, r, u, c) {
        var p = g8(n, r);
        if (p !== null) {
          var x = s_(p.memoizedState, u, c);
          p.memoizedState = x, p.baseState = x, n.memoizedProps = Gt({}, n.memoizedProps);
          var _ = $l(n, It);
          _ !== null && Oo(_, n, It, dr);
        }
      }, Kb = function(n, r, u) {
        var c = g8(n, r);
        if (c !== null) {
          var p = o_(c.memoizedState, u);
          c.memoizedState = p, c.baseState = p, n.memoizedProps = Gt({}, n.memoizedProps);
          var x = $l(n, It);
          x !== null && Oo(x, n, It, dr);
        }
      }, Qb = function(n, r, u, c) {
        var p = g8(n, r);
        if (p !== null) {
          var x = l_(p.memoizedState, u, c);
          p.memoizedState = x, p.baseState = x, n.memoizedProps = Gt({}, n.memoizedProps);
          var _ = $l(n, It);
          _ !== null && Oo(_, n, It, dr);
        }
      }, Xb = function(n, r, u) {
        n.pendingProps = s_(n.memoizedProps, r, u), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var c = $l(n, It);
        c !== null && Oo(c, n, It, dr);
      }, Jb = function(n, r) {
        n.pendingProps = o_(n.memoizedProps, r), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var u = $l(n, It);
        u !== null && Oo(u, n, It, dr);
      }, e_ = function(n, r, u) {
        n.pendingProps = l_(n.memoizedProps, r, u), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var c = $l(n, It);
        c !== null && Oo(c, n, It, dr);
      }, t_ = function(n) {
        var r = $l(n, It);
        r !== null && Oo(r, n, It, dr);
      }, n_ = function(n) {
        zb = n;
      }, r_ = function(n) {
        qb = n;
      };
    }
    function yk(n) {
      var r = Vh(n);
      return r === null ? null : r.stateNode;
    }
    function xk(n) {
      return null;
    }
    function Sk() {
      return ko;
    }
    function Ck(n) {
      var r = n.findFiberByHostInstance, u = a.ReactCurrentDispatcher;
      return ad({
        bundleType: n.bundleType,
        version: n.version,
        rendererPackageName: n.rendererPackageName,
        rendererConfig: n.rendererConfig,
        overrideHookState: Gb,
        overrideHookStateDeletePath: Kb,
        overrideHookStateRenamePath: Qb,
        overrideProps: Xb,
        overridePropsDeletePath: Jb,
        overridePropsRenamePath: e_,
        setErrorHandler: n_,
        setSuspenseHandler: r_,
        scheduleUpdate: t_,
        currentDispatcherRef: u,
        findHostInstanceByFiber: yk,
        findFiberByHostInstance: r || xk,
        // React Refresh
        findHostInstancesForRefresh: XA,
        scheduleRefresh: KA,
        scheduleRoot: QA,
        setRefreshHandler: GA,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: Sk,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: h8
      });
    }
    var c_ = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(n) {
      console.error(n);
    };
    function w8(n) {
      this._internalRoot = n;
    }
    t5.prototype.render = w8.prototype.render = function(n) {
      var r = this._internalRoot;
      if (r === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? m("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : n5(arguments[1]) ? m("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && m("You passed a second argument to root.render(...) but it only accepts one argument.");
        var u = r.containerInfo;
        if (u.nodeType !== aa) {
          var c = Wb(r.current);
          c && c.parentNode !== u && m("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      y4(n, r, null, null);
    }, t5.prototype.unmount = w8.prototype.unmount = function() {
      typeof arguments[0] == "function" && m("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var n = this._internalRoot;
      if (n !== null) {
        this._internalRoot = null;
        var r = n.containerInfo;
        bb() && m("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), tf(function() {
          y4(null, n, null, null);
        }), M(r);
      }
    };
    function bk(n, r) {
      if (!n5(n))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      f_(n);
      var u = !1, c = !1, p = "", x = c_;
      r != null && (r.hydrate ? g("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof r == "object" && r !== null && r.$$typeof === Ml && m(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), r.unstable_strictMode === !0 && (u = !0), r.identifierPrefix !== void 0 && (p = r.identifierPrefix), r.onRecoverableError !== void 0 && (x = r.onRecoverableError));
      var _ = Ub(n, K3, null, u, c, p, x);
      y(_.current, n);
      var O = n.nodeType === aa ? n.parentNode : n;
      return i2(O), new w8(_);
    }
    function t5(n) {
      this._internalRoot = n;
    }
    function _k(n) {
      n && dl(n);
    }
    t5.prototype.unstable_scheduleHydration = _k;
    function Rk(n, r, u) {
      if (!n5(n))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      f_(n), r === void 0 && m("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var c = u ?? null, p = u != null && u.hydratedSources || null, x = !1, _ = !1, O = "", k = c_;
      u != null && (u.unstable_strictMode === !0 && (x = !0), u.identifierPrefix !== void 0 && (O = u.identifierPrefix), u.onRecoverableError !== void 0 && (k = u.onRecoverableError));
      var N = Yb(r, null, n, K3, c, x, _, O, k);
      if (y(N.current, n), i2(n), p)
        for (var U = 0; U < p.length; U++) {
          var oe = p[U];
          DD(N, oe);
        }
      return new t5(N);
    }
    function n5(n) {
      return !!(n && (n.nodeType === Na || n.nodeType === Ki || n.nodeType === rc));
    }
    function x4(n) {
      return !!(n && (n.nodeType === Na || n.nodeType === Ki || n.nodeType === rc || n.nodeType === aa && n.nodeValue === " react-mount-point-unstable "));
    }
    function f_(n) {
      n.nodeType === Na && n.tagName && n.tagName.toUpperCase() === "BODY" && m("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), I(n) && (n._reactRootContainer ? m("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : m("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var Ek = a.ReactCurrentOwner, d_;
    d_ = function(n) {
      if (n._reactRootContainer && n.nodeType !== aa) {
        var r = Wb(n._reactRootContainer.current);
        r && r.parentNode !== n && m("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var u = !!n._reactRootContainer, c = y8(n), p = !!(c && q(c));
      p && !u && m("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), n.nodeType === Na && n.tagName && n.tagName.toUpperCase() === "BODY" && m("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function y8(n) {
      return n ? n.nodeType === Ki ? n.documentElement : n.firstChild : null;
    }
    function h_() {
    }
    function Mk(n, r, u, c, p) {
      if (p) {
        if (typeof c == "function") {
          var x = c;
          c = function() {
            var ae = e5(_);
            x.call(ae);
          };
        }
        var _ = Yb(
          r,
          c,
          n,
          Bd,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          h_
        );
        n._reactRootContainer = _, y(_.current, n);
        var O = n.nodeType === aa ? n.parentNode : n;
        return i2(O), tf(), _;
      } else {
        for (var k; k = n.lastChild; )
          n.removeChild(k);
        if (typeof c == "function") {
          var N = c;
          c = function() {
            var ae = e5(U);
            N.call(ae);
          };
        }
        var U = Ub(
          n,
          Bd,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          h_
        );
        n._reactRootContainer = U, y(U.current, n);
        var oe = n.nodeType === aa ? n.parentNode : n;
        return i2(oe), tf(function() {
          y4(r, U, u, c);
        }), U;
      }
    }
    function Tk(n, r) {
      n !== null && typeof n != "function" && m("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, n);
    }
    function r5(n, r, u, c, p) {
      d_(u), Tk(p === void 0 ? null : p, "render");
      var x = u._reactRootContainer, _;
      if (!x)
        _ = Mk(u, r, n, p, c);
      else {
        if (_ = x, typeof p == "function") {
          var O = p;
          p = function() {
            var k = e5(_);
            O.call(k);
          };
        }
        y4(r, _, n, p);
      }
      return e5(_);
    }
    var v_ = !1;
    function Ok(n) {
      {
        v_ || (v_ = !0, m("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var r = Ek.current;
        if (r !== null && r.stateNode !== null) {
          var u = r.stateNode._warnedAboutRefsInRender;
          u || m("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", In(r.type) || "A component"), r.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return n == null ? null : n.nodeType === Na ? n : hk(n, "findDOMNode");
    }
    function Dk(n, r, u) {
      if (m("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !x4(r))
        throw new Error("Target container is not a DOM element.");
      {
        var c = I(r) && r._reactRootContainer === void 0;
        c && m("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return r5(null, n, r, !0, u);
    }
    function jk(n, r, u) {
      if (m("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !x4(r))
        throw new Error("Target container is not a DOM element.");
      {
        var c = I(r) && r._reactRootContainer === void 0;
        c && m("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return r5(null, n, r, !1, u);
    }
    function Ak(n, r, u, c) {
      if (m("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !x4(u))
        throw new Error("Target container is not a DOM element.");
      if (n == null || !Jo(n))
        throw new Error("parentComponent must be a valid React Component");
      return r5(n, r, u, !1, c);
    }
    var p_ = !1;
    function kk(n) {
      if (p_ || (p_ = !0, m("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !x4(n))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var r = I(n) && n._reactRootContainer === void 0;
        r && m("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (n._reactRootContainer) {
        {
          var u = y8(n), c = u && !q(u);
          c && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return tf(function() {
          r5(null, null, n, !1, function() {
            n._reactRootContainer = null, M(n);
          });
        }), !0;
      } else {
        {
          var p = y8(n), x = !!(p && q(p)), _ = n.nodeType === Na && x4(n.parentNode) && !!n.parentNode._reactRootContainer;
          x && m("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", _ ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Jp(vk), Or(pk), ht(mk), kc(No), tm(pv), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && m("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), sv(a6), $1(K9, RA, tf);
    function Lk(n, r) {
      var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!n5(r))
        throw new Error("Target container is not a DOM element.");
      return dk(n, r, null, u);
    }
    function Ik(n, r, u, c) {
      return Ak(n, r, u, c);
    }
    var x8 = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [q, J, se, vr, $u, K9]
    };
    function Hk(n, r) {
      return x8.usingClientEntryPoint || m('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), bk(n, r);
    }
    function Zk(n, r, u) {
      return x8.usingClientEntryPoint || m('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), Rk(n, r, u);
    }
    function Pk(n) {
      return bb() && m("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), tf(n);
    }
    var Vk = Ck({
      findFiberByHostInstance: B,
      bundleType: 1,
      version: h8,
      rendererPackageName: "react-dom"
    });
    if (!Vk && St && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var m_ = window.location.protocol;
      /^(https?|file):$/.test(m_) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (m_ === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Kl.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = x8, Kl.createPortal = Lk, Kl.createRoot = Hk, Kl.findDOMNode = Ok, Kl.flushSync = Pk, Kl.hydrate = Dk, Kl.hydrateRoot = Zk, Kl.render = jk, Kl.unmountComponentAtNode = kk, Kl.unstable_batchedUpdates = K9, Kl.unstable_renderSubtreeIntoContainer = Ik, Kl.version = h8, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Kl;
}
function rM() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(rM);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (rM(), ty.exports = JH()) : ty.exports = eZ();
var R5 = ty.exports, tZ = "div";
function B_(e, t) {
  const a = setTimeout(t, e);
  return () => clearTimeout(a);
}
function nZ(e) {
  let t = requestAnimationFrame(() => {
    t = requestAnimationFrame(e);
  });
  return () => cancelAnimationFrame(t);
}
function F_(...e) {
  return e.join(", ").split(", ").reduce((t, a) => {
    const i = a.endsWith("ms") ? 1 : 1e3, h = parseFloat(a || "0s") * i;
    return h > t ? h : t;
  }, 0);
}
function q4(e, t, a) {
  return !a && t !== !1 && (!e || !!t);
}
var Q5 = ke(function(t) {
  var a = t, { store: i, alwaysVisible: h } = a, g = Fe(a, ["store", "alwaysVisible"]);
  const m = nx();
  i = i || m, Zt(
    i,
    process.env.NODE_ENV !== "production" && "DisclosureContent must receive a `store` prop or be wrapped in a DisclosureProvider component."
  );
  const C = Pt(null), S = Ia(g.id), [R, D] = Qt(null), T = i.useState("open"), j = i.useState("mounted"), A = i.useState("animated"), L = i.useState("contentElement"), P = ja(i.disclosure, "contentElement");
  jn(() => {
    C.current && (i == null || i.setContentElement(C.current));
  }, [i]), jn(() => {
    let W;
    return i == null || i.setState("animated", (Q) => (W = Q, !0)), () => {
      W !== void 0 && (i == null || i.setState("animated", W));
    };
  }, [i]), jn(() => {
    if (A) {
      if (!(L != null && L.isConnected)) {
        D(null);
        return;
      }
      return nZ(() => {
        D(T ? "enter" : j ? "leave" : null);
      });
    }
  }, [A, L, T, j]), jn(() => {
    if (!i || !A)
      return;
    const W = () => i == null ? void 0 : i.setState("animating", !1), Q = () => R5.flushSync(W);
    if (!R || !L) {
      W();
      return;
    }
    if (R === "leave" && T || R === "enter" && !T)
      return;
    if (typeof A == "number")
      return B_(A, Q);
    const {
      transitionDuration: $,
      animationDuration: le,
      transitionDelay: te,
      animationDelay: Se
    } = getComputedStyle(L), {
      transitionDuration: re = "0",
      animationDuration: ve = "0",
      transitionDelay: K = "0",
      animationDelay: de = "0"
    } = P ? getComputedStyle(P) : {}, fe = F_(
      te,
      Se,
      K,
      de
    ), xe = F_(
      $,
      le,
      re,
      ve
    ), Le = fe + xe;
    if (!Le) {
      R === "enter" && i.setState("animated", !1), W();
      return;
    }
    const be = 1e3 / 60, Ue = Math.max(Le - be, 0);
    return B_(Ue, Q);
  }, [i, A, L, P, T, R]), g = Vn(
    g,
    (W) => /* @__PURE__ */ f.jsx(rx, { value: i, children: W }),
    [i]
  );
  const V = q4(j, g.hidden, h), F = g.style, Y = Lr(() => V ? Te(G({}, F), { display: "none" }) : F, [V, F]);
  return g = Te(G({
    id: S,
    "data-open": T || void 0,
    "data-enter": R === "enter" || void 0,
    "data-leave": R === "leave" || void 0,
    hidden: V
  }, g), {
    ref: An(S ? i.setContentElement : null, C, g.ref),
    style: Y
  }), La(g);
}), rZ = Oe(function(t) {
  const a = Q5(t);
  return Ae(tZ, a);
}), aZ = Oe(function(t) {
  var a = t, {
    unmountOnHide: i
  } = a, h = Fe(a, [
    "unmountOnHide"
  ]);
  const g = nx(), m = h.store || g;
  return ja(
    m,
    (S) => !i || (S == null ? void 0 : S.mounted)
  ) === !1 ? null : /* @__PURE__ */ f.jsx(rZ, G({}, h));
});
function aM(e = {}) {
  return GE(e);
}
function oM(e, t, a) {
  return KE(e, t, a);
}
function G4(e = {}) {
  const [t, a] = bi(aM, e);
  return oM(t, a, e);
}
function iM(e, ...t) {
  if (!e)
    return !1;
  const a = e.getAttribute("data-backdrop");
  return a == null ? !1 : a === "" || a === "true" || !t.length ? !0 : t.some((i) => a === i);
}
var O8 = /* @__PURE__ */ new WeakMap();
function K4(e, t, a) {
  O8.has(e) || O8.set(e, /* @__PURE__ */ new Map());
  const i = O8.get(e), h = i.get(t);
  if (!h)
    return i.set(t, a()), () => {
      var C;
      (C = i.get(t)) == null || C(), i.delete(t);
    };
  const g = a(), m = () => {
    g(), h(), i.delete(t);
  };
  return i.set(t, m), () => {
    i.get(t) === m && (g(), i.set(t, h));
  };
}
function ax(e, t, a) {
  return K4(e, t, () => {
    const h = e.getAttribute(t);
    return e.setAttribute(t, a), () => {
      h == null ? e.removeAttribute(t) : e.setAttribute(t, h);
    };
  });
}
function Z2(e, t, a) {
  return K4(e, t, () => {
    const h = t in e, g = e[t];
    return e[t] = a, () => {
      h ? e[t] = g : delete e[t];
    };
  });
}
function ny(e, t) {
  return e ? K4(e, "style", () => {
    const i = e.style.cssText;
    return Object.assign(e.style, t), () => {
      e.style.cssText = i;
    };
  }) : () => {
  };
}
function oZ(e, t, a) {
  return e ? K4(e, t, () => {
    const h = e.style.getPropertyValue(t);
    return e.style.setProperty(t, a), () => {
      h ? e.style.setProperty(t, h) : e.style.removeProperty(t);
    };
  }) : () => {
  };
}
var iZ = ["SCRIPT", "STYLE"];
function ry(e) {
  return `__ariakit-dialog-snapshot-${e}`;
}
function lZ(e, t) {
  const a = Qr(t), i = ry(e);
  if (!a.body[i])
    return !0;
  do {
    if (t === a.body)
      return !1;
    if (t[i])
      return !0;
    if (!t.parentElement)
      return !1;
    t = t.parentElement;
  } while (!0);
}
function uZ(e, t, a) {
  return iZ.includes(t.tagName) || !lZ(e, t) ? !1 : !a.some(
    (i) => i && ha(t, i)
  );
}
function ox(e, t, a, i) {
  for (let h of t) {
    if (!(h != null && h.isConnected))
      continue;
    const g = t.some((S) => !S || S === h ? !1 : S.contains(h)), m = Qr(h), C = h;
    for (; h.parentElement && h !== m.body; ) {
      if (i == null || i(h.parentElement, C), !g)
        for (const S of h.parentElement.children)
          uZ(e, S, t) && a(S, C);
      h = h.parentElement;
    }
  }
}
function sZ(e, t) {
  const { body: a } = Qr(t[0]), i = [];
  return ox(e, t, (g) => {
    i.push(Z2(g, ry(e), !0));
  }), _l(
    Z2(a, ry(e), !0),
    () => i.forEach((g) => g())
  );
}
function Op(e = "", t = !1) {
  return `__ariakit-dialog-${t ? "ancestor" : "outside"}${e ? `-${e}` : ""}`;
}
function cZ(e, t = "") {
  return _l(
    Z2(e, Op(), !0),
    Z2(e, Op(t), !0)
  );
}
function lM(e, t = "") {
  return _l(
    Z2(e, Op("", !0), !0),
    Z2(e, Op(t, !0), !0)
  );
}
function ix(e, t) {
  const a = Op(t, !0);
  if (e[a])
    return !0;
  const i = Op(t);
  do {
    if (e[i])
      return !0;
    if (!e.parentElement)
      return !1;
    e = e.parentElement;
  } while (!0);
}
function U_(e, t) {
  const a = [], i = t.map((g) => g == null ? void 0 : g.id);
  return ox(
    e,
    t,
    (g) => {
      iM(g, ...i) || a.unshift(cZ(g, e));
    },
    (g, m) => {
      m.hasAttribute("data-dialog") && m.id !== e || a.unshift(lM(g, e));
    }
  ), () => {
    a.forEach((g) => g());
  };
}
var fZ = "div", dZ = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "summary",
  "textarea",
  "ul",
  "svg"
];
ke(
  function(t) {
    return t;
  }
);
var H4 = Oe(
  // @ts-expect-error
  function(t) {
    return Ae(fZ, t);
  }
);
Object.assign(
  H4,
  dZ.reduce((e, t) => (e[t] = Oe(function(i) {
    return Ae(t, i);
  }), e), {})
);
function hZ({
  store: e,
  backdrop: t,
  alwaysVisible: a,
  hidden: i
}) {
  const h = Pt(null), g = q5({ disclosure: e }), m = e.useState("contentElement");
  jn(() => {
    const R = h.current, D = m;
    R && D && (R.style.zIndex = getComputedStyle(D).zIndex);
  }, [m]), jn(() => {
    const R = m == null ? void 0 : m.id;
    if (!R)
      return;
    const D = h.current;
    if (D)
      return lM(D, R);
  }, [m]);
  const C = Q5({
    ref: h,
    store: g,
    role: "presentation",
    "data-backdrop": (m == null ? void 0 : m.id) || "",
    alwaysVisible: a,
    hidden: i ?? void 0,
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
  if (!t)
    return null;
  if (aE(t))
    return /* @__PURE__ */ f.jsx(H4, Te(G({}, C), { render: t }));
  const S = typeof t != "boolean" ? t : "div";
  return /* @__PURE__ */ f.jsx(H4, Te(G({}, C), { render: /* @__PURE__ */ f.jsx(S, {}) }));
}
var Y_ = ka({});
function vZ(e) {
  const t = Yo(Y_), [a, i] = Qt([]), h = Ir(
    (C) => {
      var S;
      return i((R) => [...R, C]), _l((S = t.add) == null ? void 0 : S.call(t, C), () => {
        i((R) => R.filter((D) => D !== C));
      });
    },
    [t]
  );
  jn(() => xa(e, ["open", "contentElement"], (C) => {
    var S;
    if (C.open && C.contentElement)
      return (S = t.add) == null ? void 0 : S.call(t, e);
  }), [e, t]);
  const g = Lr(() => ({ store: e, add: h }), [e, h]);
  return { wrapElement: Ir(
    (C) => /* @__PURE__ */ f.jsx(Y_.Provider, { value: g, children: C }),
    [g]
  ), nestedDialogs: a };
}
function pZ(e) {
  const t = Pt();
  return gt(() => {
    if (!e) {
      t.current = null;
      return;
    }
    return Uo("mousedown", (i) => {
      t.current = i.target;
    }, !0);
  }, [e]), t;
}
function mZ(e) {
  return e.tagName === "HTML" ? !0 : ha(Qr(e).body, e);
}
function gZ(e, t) {
  if (!e)
    return !1;
  if (ha(e, t))
    return !0;
  const a = t.getAttribute("aria-activedescendant");
  if (a) {
    const i = Qr(e).getElementById(a);
    if (i)
      return ha(e, i);
  }
  return !1;
}
function wZ(e, t) {
  if (!("clientY" in e))
    return !1;
  const a = t.getBoundingClientRect();
  return a.width === 0 || a.height === 0 ? !1 : a.top <= e.clientY && e.clientY <= a.top + a.height && a.left <= e.clientX && e.clientX <= a.left + a.width;
}
function D8({
  store: e,
  type: t,
  listener: a,
  capture: i,
  domReady: h
}) {
  const g = rt(a), m = e.useState("open"), C = Pt(!1);
  jn(() => {
    if (!m || !h)
      return;
    const { contentElement: S } = e.getState();
    if (!S)
      return;
    const R = () => {
      C.current = !0;
    };
    return S.addEventListener("focusin", R, !0), () => S.removeEventListener("focusin", R, !0);
  }, [e, m, h]), gt(() => m ? Uo(t, (R) => {
    const { contentElement: D, disclosureElement: T } = e.getState(), j = R.target;
    !D || !j || !mZ(j) || ha(D, j) || gZ(T, j) || j.hasAttribute("data-focus-trap") || wZ(R, D) || C.current && !ix(j, D.id) || g(R);
  }, i) : void 0, [m, i]);
}
function j8(e, t) {
  return typeof e == "function" ? e(t) : !!e;
}
function yZ(e, t, a) {
  const i = e.useState("open"), h = pZ(i), g = { store: e, domReady: a, capture: !0 };
  D8(Te(G({}, g), {
    type: "click",
    listener: (m) => {
      const { contentElement: C } = e.getState(), S = h.current;
      S && vE(S) && ix(S, C == null ? void 0 : C.id) && j8(t, m) && e.hide();
    }
  })), D8(Te(G({}, g), {
    type: "focusin",
    listener: (m) => {
      const { contentElement: C } = e.getState();
      C && m.target !== Qr(C) && j8(t, m) && e.hide();
    }
  })), D8(Te(G({}, g), {
    type: "contextmenu",
    listener: (m) => {
      j8(t, m) && e.hide();
    }
  }));
}
function xZ(e, t) {
  const i = Qr(e).createElement("button");
  return i.type = "button", i.tabIndex = -1, i.textContent = "Dismiss popup", Object.assign(i.style, {
    border: "0px",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0px",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  }), i.addEventListener("click", t), e.prepend(i), () => {
    i.removeEventListener("click", t), i.remove();
  };
}
function SZ(e) {
  return ax(e, "aria-hidden", "true");
}
function uM() {
  return "inert" in HTMLElement.prototype;
}
function sM(e, t) {
  if (!("style" in e))
    return T4;
  if (uM())
    return Z2(e, "inert", !0);
  const i = Lp(e, !0).map((h) => {
    if (t != null && t.some((m) => m && ha(m, h)))
      return T4;
    const g = K4(h, "focus", () => (h.focus = T4, () => {
      delete h.focus;
    }));
    return _l(ax(h, "tabindex", "-1"), g);
  });
  return _l(
    ...i,
    SZ(e),
    ny(e, {
      pointerEvents: "none",
      userSelect: "none",
      cursor: "default"
    })
  );
}
function CZ(e, t) {
  const a = [], i = t.map((g) => g == null ? void 0 : g.id);
  return ox(
    e,
    t,
    (g) => {
      iM(g, ...i) || a.unshift(sM(g, t));
    },
    (g) => {
      g.hasAttribute("role") && (t.some((m) => m && ha(m, g)) || a.unshift(ax(g, "role", "none")));
    }
  ), () => {
    a.forEach((g) => g());
  };
}
function bZ({
  attribute: e,
  contentId: t,
  contentElement: a,
  enabled: i
}) {
  const [h, g] = P5(), m = Ir(() => {
    if (!i || !a)
      return !1;
    const { body: C } = Qr(a), S = C.getAttribute(e);
    return !S || S === t;
  }, [h, i, a, e, t]);
  return gt(() => {
    if (!i || !t || !a)
      return;
    const { body: C } = Qr(a);
    if (m())
      return C.setAttribute(e, t), () => C.removeAttribute(e);
    const S = new MutationObserver(() => R5.flushSync(g));
    return S.observe(C, { attributeFilter: [e] }), () => S.disconnect();
  }, [h, i, t, a, m, e]), m;
}
function _Z(e) {
  const t = e.getBoundingClientRect().left;
  return Math.round(t) + e.scrollLeft ? "paddingLeft" : "paddingRight";
}
function RZ(e, t, a) {
  const i = bZ({
    attribute: "data-dialog-prevent-body-scroll",
    contentElement: e,
    contentId: t,
    enabled: a
  });
  gt(() => {
    if (!i() || !e)
      return;
    const h = Qr(e), g = hE(e), { documentElement: m, body: C } = h, S = m.style.getPropertyValue("--scrollbar-width"), R = S ? parseInt(S) : g.innerWidth - m.clientWidth, D = () => oZ(
      m,
      "--scrollbar-width",
      `${R}px`
    ), T = _Z(m), j = () => ny(C, {
      overflow: "hidden",
      [T]: `${R}px`
    }), A = () => {
      var P, V;
      const { scrollX: F, scrollY: Y, visualViewport: W } = g, Q = (P = W == null ? void 0 : W.offsetLeft) != null ? P : 0, $ = (V = W == null ? void 0 : W.offsetTop) != null ? V : 0, le = ny(C, {
        position: "fixed",
        overflow: "hidden",
        top: `${-(Y - Math.floor($))}px`,
        left: `${-(F - Math.floor(Q))}px`,
        right: "0",
        [T]: `${R}px`
      });
      return () => {
        le(), process.env.NODE_ENV !== "test" && g.scrollTo(F, Y);
      };
    }, L = Iy() && !vL();
    return _l(
      D(),
      L ? A() : j()
    );
  }, [i, e]);
}
var EZ = "div", cM = ke(function(t) {
  var a = t, { autoFocusOnShow: i = !0 } = a, h = Fe(a, ["autoFocusOnShow"]);
  return h = Vn(
    h,
    (g) => /* @__PURE__ */ f.jsx(DE.Provider, { value: i, children: g }),
    [i]
  ), h;
});
Oe(function(t) {
  const a = cM(t);
  return Ae(EZ, a);
});
var ay = ka(0);
function fM({ level: e, children: t }) {
  const a = Yo(ay), i = Math.max(
    Math.min(e || a + 1, 6),
    1
  );
  return /* @__PURE__ */ f.jsx(ay.Provider, { value: i, children: t });
}
var oy = ka(null), MZ = "div";
function TZ(e) {
  return Qr(e).body;
}
function OZ(e, t) {
  return t ? typeof t == "function" ? t(e) : t : Qr(e).createElement("div");
}
function DZ(e = "id") {
  return `${e ? `${e}-` : ""}${Math.random().toString(36).substr(2, 6)}`;
}
function th(e) {
  queueMicrotask(() => {
    e == null || e.focus();
  });
}
var dM = ke(function(t) {
  var a = t, {
    preserveTabOrder: i,
    preserveTabOrderAnchor: h,
    portalElement: g,
    portalRef: m,
    portal: C = !0
  } = a, S = Fe(a, [
    "preserveTabOrder",
    "preserveTabOrderAnchor",
    "portalElement",
    "portalRef",
    "portal"
  ]);
  const R = Pt(null), D = An(R, S.ref), T = Yo(oy), [j, A] = Qt(null), [L, P] = Qt(
    null
  ), V = Pt(null), F = Pt(null), Y = Pt(null), W = Pt(null);
  return jn(() => {
    const Q = R.current;
    if (!Q || !C) {
      A(null);
      return;
    }
    const $ = OZ(Q, g);
    if (!$) {
      A(null);
      return;
    }
    const le = $.isConnected;
    if (le || (T || TZ(Q)).appendChild($), $.id || ($.id = Q.id ? `portal/${Q.id}` : DZ()), A($), z8(m, $), !le)
      return () => {
        $.remove(), z8(m, null);
      };
  }, [C, g, T, m]), jn(() => {
    if (!C || !i || !h)
      return;
    const $ = Qr(h).createElement("span");
    return $.style.position = "fixed", h.insertAdjacentElement("afterend", $), P($), () => {
      $.remove(), P(null);
    };
  }, [C, i, h]), gt(() => {
    if (!j || !i)
      return;
    let Q = 0;
    const $ = (le) => {
      if (!rh(le))
        return;
      const te = le.type === "focusin";
      if (cancelAnimationFrame(Q), te)
        return _5(j);
      Q = requestAnimationFrame(() => {
        yp(j, !0);
      });
    };
    return j.addEventListener("focusin", $, !0), j.addEventListener("focusout", $, !0), () => {
      cancelAnimationFrame(Q), j.removeEventListener("focusin", $, !0), j.removeEventListener("focusout", $, !0);
    };
  }, [j, i]), S = Vn(
    S,
    (Q) => {
      if (Q = // While the portal node is not in the DOM, we need to pass the
      // current context to the portal context, otherwise it's going to
      // reset to the body element on nested portals.
      /* @__PURE__ */ f.jsx(oy.Provider, { value: j || T, children: Q }), !C)
        return Q;
      if (!j)
        return /* @__PURE__ */ f.jsx(
          "span",
          {
            ref: D,
            id: S.id,
            style: { position: "fixed" },
            hidden: !0
          }
        );
      Q = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        i && j && /* @__PURE__ */ f.jsx(
          xp,
          {
            ref: F,
            className: "__focus-trap-inner-before",
            onFocus: (le) => {
              rh(le, j) ? th(_8()) : th(V.current);
            }
          }
        ),
        Q,
        i && j && /* @__PURE__ */ f.jsx(
          xp,
          {
            ref: Y,
            className: "__focus-trap-inner-after",
            onFocus: (le) => {
              rh(le, j) ? th(T_()) : th(W.current);
            }
          }
        )
      ] }), j && (Q = R5.createPortal(Q, j));
      let $ = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        i && j && /* @__PURE__ */ f.jsx(
          xp,
          {
            ref: V,
            className: "__focus-trap-outer-before",
            onFocus: (le) => {
              !(le.relatedTarget === W.current) && rh(le, j) ? th(F.current) : th(T_());
            }
          }
        ),
        i && // We're using position: fixed here so that the browser doesn't
        // add margin to the element when setting gap on a parent element.
        /* @__PURE__ */ f.jsx("span", { "aria-owns": j == null ? void 0 : j.id, style: { position: "fixed" } }),
        i && j && /* @__PURE__ */ f.jsx(
          xp,
          {
            ref: W,
            className: "__focus-trap-outer-after",
            onFocus: (le) => {
              if (rh(le, j))
                th(Y.current);
              else {
                const te = _8();
                if (te === F.current) {
                  requestAnimationFrame(() => {
                    var Se;
                    return (Se = _8()) == null ? void 0 : Se.focus();
                  });
                  return;
                }
                th(te);
              }
            }
          }
        )
      ] });
      return L && i && ($ = R5.createPortal(
        $,
        L
      )), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        $,
        Q
      ] });
    },
    [j, T, C, S.id, i, L]
  ), S = Te(G({}, S), {
    ref: D
  }), S;
}), jZ = Oe(function(t) {
  const a = dM(t);
  return Ae(MZ, a);
}), AZ = "div", $_ = Hy();
function kZ(e) {
  const t = gf();
  return !t || e && ha(e, t) ? !1 : !!A0(t);
}
function W_(e, t = !1) {
  if (!e)
    return null;
  const a = "current" in e ? e.current : e;
  return a ? t ? A0(a) ? a : null : a : null;
}
var hM = ke(function(t) {
  var a = t, {
    store: i,
    open: h,
    onClose: g,
    focusable: m = !0,
    modal: C = !0,
    portal: S = !!C,
    backdrop: R = !!C,
    hideOnEscape: D = !0,
    hideOnInteractOutside: T = !0,
    getPersistentElements: j,
    preventBodyScroll: A = !!C,
    autoFocusOnShow: L = !0,
    autoFocusOnHide: P = !0,
    initialFocus: V,
    finalFocus: F,
    unstable_treeSnapshotKey: Y
  } = a, W = Fe(a, [
    "store",
    "open",
    "onClose",
    "focusable",
    "modal",
    "portal",
    "backdrop",
    "hideOnEscape",
    "hideOnInteractOutside",
    "getPersistentElements",
    "preventBodyScroll",
    "autoFocusOnShow",
    "autoFocusOnHide",
    "initialFocus",
    "finalFocus",
    "unmountOnHide",
    "unstable_treeSnapshotKey"
  ]);
  const Q = K5(), $ = Pt(null), le = G4({
    store: i || Q,
    open: h,
    setOpen(ft) {
      if (ft)
        return;
      const fn = $.current;
      if (!fn)
        return;
      const Ln = new Event("close", { bubbles: !1, cancelable: !0 });
      g && fn.addEventListener("close", g, { once: !0 }), fn.dispatchEvent(Ln), Ln.defaultPrevented && le.setOpen(!0);
    }
  }), { portalRef: te, domReady: Se } = Ny(S, W.portalRef), re = W.preserveTabOrder, ve = le.useState(
    (ft) => re && !C && ft.mounted
  ), K = Ia(W.id), de = le.useState("open"), fe = le.useState("mounted"), xe = le.useState("contentElement"), Le = q4(fe, W.hidden, W.alwaysVisible);
  RZ(xe, K, A && !Le), yZ(le, T, Se);
  const { wrapElement: be, nestedDialogs: Ue } = vZ(le);
  W = Vn(W, be, [be]), jn(() => {
    if (!de)
      return;
    const ft = $.current, fn = gf(ft, !0);
    fn && fn.tagName !== "BODY" && (ft && ha(ft, fn) || le.setDisclosureElement(fn));
  }, [le, de]), $_ && gt(() => {
    if (!fe)
      return;
    const { disclosureElement: ft } = le.getState();
    if (!ft || !L0(ft))
      return;
    const fn = () => {
      let Ln = !1;
      const Nt = () => {
        Ln = !0;
      }, gn = { capture: !0, once: !0 };
      ft.addEventListener("focusin", Nt, gn), L2(ft, "mouseup", () => {
        ft.removeEventListener("focusin", Nt, !0), !Ln && jE(ft);
      });
    };
    return ft.addEventListener("mousedown", fn), () => {
      ft.removeEventListener("mousedown", fn);
    };
  }, [le, fe]), gt(() => {
    if (!C || !fe || !Se)
      return;
    const ft = $.current;
    if (!(!ft || ft.querySelector("[data-dialog-dismiss]")))
      return xZ(ft, le.hide);
  }, [le, C, fe, Se]), jn(() => {
    if (!uM() || de || !fe || !Se)
      return;
    const ft = $.current;
    if (ft)
      return sM(ft);
  }, [de, fe, Se]);
  const ie = de && Se;
  jn(() => {
    if (!K || !ie)
      return;
    const ft = $.current;
    return sZ(K, [ft]);
  }, [K, ie, Y]);
  const _e = rt(j);
  jn(() => {
    if (!K || !ie)
      return;
    const { disclosureElement: ft } = le.getState(), fn = $.current, Ln = _e() || [], Nt = [
      fn,
      ...Ln,
      ...Ue.map((gn) => gn.getState().contentElement)
    ];
    return C ? _l(
      U_(K, Nt),
      CZ(K, Nt)
    ) : U_(K, [ft, ...Nt]);
  }, [
    K,
    le,
    ie,
    _e,
    Ue,
    C,
    Y
  ]);
  const Ze = !!L, mt = er(L), [Pe, Vt] = Qt(!1);
  gt(() => {
    if (!de || !Ze || !Se || !(xe != null && xe.isConnected))
      return;
    const ft = W_(V, !0) || // If no initial focus is specified, we try to focus the first element
    // with the autofocus attribute. If it's an Ariakit component, the
    // Focusable component will consume the autoFocus prop and add the
    // data-autofocus attribute to the element instead.
    xe.querySelector(
      "[data-autofocus=true],[autofocus]"
    ) || // We have to fallback to the first focusable element otherwise portaled
    // dialogs with preserveTabOrder set to true will not receive focus
    // properly because the elements aren't tabbable until the dialog receives
    // focus.
    F5(xe, !0, S && ve) || // Finally, we fallback to the dialog element itself.
    xe, fn = A0(ft);
    mt(fn ? ft : null) && (Vt(!0), queueMicrotask(() => {
      ft.focus(), $_ && ft.scrollIntoView({ block: "nearest", inline: "nearest" });
    }));
  }, [
    de,
    Ze,
    Se,
    xe,
    V,
    S,
    ve,
    mt
  ]);
  const Dt = !!P, Qe = er(P), [et, wt] = Qt(!1);
  gt(() => {
    if (de)
      return wt(!0), () => wt(!1);
  }, [de]);
  const St = Ir(
    (ft, fn = !0) => {
      const { disclosureElement: Ln } = le.getState();
      if (kZ(ft))
        return;
      let Nt = W_(F) || Ln;
      if (Nt != null && Nt.id) {
        const zn = Qr(Nt), Ur = `[aria-activedescendant="${Nt.id}"]`, Xe = zn.querySelector(Ur);
        Xe && (Nt = Xe);
      }
      if (Nt && !A0(Nt)) {
        const zn = pE(Nt, "[data-dialog]");
        if (zn && zn.id) {
          const Ur = Qr(zn), Xe = `[aria-controls~="${zn.id}"]`, Jt = Ur.querySelector(Xe);
          Jt && (Nt = Jt);
        }
      }
      const gn = Nt && A0(Nt);
      if (!gn && fn) {
        requestAnimationFrame(() => St(ft, !1));
        return;
      }
      Qe(gn ? Nt : null) && gn && (Nt == null || Nt.focus());
    },
    [le, F, Qe]
  ), _n = Pt(!1);
  jn(() => {
    if (de || !et || !Dt)
      return;
    const ft = $.current;
    _n.current = !0, St(ft);
  }, [de, et, Se, Dt, St]), gt(() => {
    if (!et || !Dt)
      return;
    const ft = $.current;
    return () => {
      if (_n.current) {
        _n.current = !1;
        return;
      }
      St(ft);
    };
  }, [et, Dt, St]);
  const Hr = er(D);
  gt(() => !Se || !fe ? void 0 : Uo("keydown", (fn) => {
    if (fn.key !== "Escape" || fn.defaultPrevented)
      return;
    const Ln = $.current;
    if (!Ln || ix(Ln))
      return;
    const Nt = fn.target;
    if (!Nt)
      return;
    const { disclosureElement: gn } = le.getState();
    !!(Nt.tagName === "BODY" || ha(Ln, Nt) || !gn || ha(gn, Nt)) && Hr(fn) && le.hide();
  }, !0), [le, Se, fe, Hr]), W = Vn(
    W,
    (ft) => /* @__PURE__ */ f.jsx(fM, { level: C ? 1 : void 0, children: ft }),
    [C]
  );
  const kn = W.hidden, Wn = W.alwaysVisible;
  W = Vn(
    W,
    (ft) => R ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx(
        hZ,
        {
          store: le,
          backdrop: R,
          hidden: kn,
          alwaysVisible: Wn
        }
      ),
      ft
    ] }) : ft,
    [le, R, kn, Wn]
  );
  const [sr, yr] = Qt(), [ea, Ca] = Qt();
  return W = Vn(
    W,
    (ft) => /* @__PURE__ */ f.jsx(rx, { value: le, children: /* @__PURE__ */ f.jsx(eM.Provider, { value: yr, children: /* @__PURE__ */ f.jsx(tM.Provider, { value: Ca, children: ft }) }) }),
    [le]
  ), W = Te(G({
    id: K,
    "data-dialog": "",
    role: "dialog",
    tabIndex: m ? -1 : void 0,
    "aria-labelledby": sr,
    "aria-describedby": ea
  }, W), {
    ref: An($, W.ref)
  }), W = cM(Te(G({}, W), {
    autoFocusOnShow: Pe
  })), W = Q5(G({ store: le }, W)), W = N2(Te(G({}, W), { focusable: m })), W = dM(Te(G({ portal: S }, W), { portalRef: te, preserveTabOrder: ve })), W;
});
function U2(e, t = K5) {
  return Oe(function(i) {
    const h = t(), g = i.store || h;
    return ja(
      g,
      (C) => !i.unmountOnHide || (C == null ? void 0 : C.mounted) || !!i.open
    ) ? /* @__PURE__ */ f.jsx(e, G({}, i)) : null;
  });
}
var lx = U2(
  Oe(function(t) {
    const a = hM(t);
    return Ae(AZ, a);
  }),
  K5
);
function ux(e = {}) {
  const t = G4(e);
  return /* @__PURE__ */ f.jsx(JE, { value: t, children: e.children });
}
var LZ = "p", vM = ke(function(t) {
  var a = t, i = Fe(a, ["store"]);
  const h = Yo(tM), g = Ia(i.id);
  return jn(() => (h == null || h(g), () => h == null ? void 0 : h(void 0)), [h, g]), i = G({
    id: g
  }, i), La(i);
}), IZ = Oe(function(t) {
  const a = vM(t);
  return Ae(LZ, a);
}), HZ = "button", X5 = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = K5();
    i = i || g, Zt(
      i,
      process.env.NODE_ENV !== "production" && "DialogDisclosure must receive a `store` prop or be wrapped in a DialogProvider component."
    );
    const m = i.useState("contentElement");
    return h = G({
      "aria-haspopup": vh(m, "dialog")
    }, h), h = XE(G({ store: i }, h)), h;
  }
), ZZ = Oe(function(t) {
  const a = X5(t);
  return Ae(HZ, a);
}), PZ = "button", pM = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = KH();
    i = i || g;
    const m = h.onClick, C = rt((R) => {
      m == null || m(R), !R.defaultPrevented && (i == null || i.hide());
    }), S = Lr(
      () => /* @__PURE__ */ f.jsxs(
        "svg",
        {
          "aria-label": "Dismiss popup",
          display: "block",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          viewBox: "0 0 16 16",
          height: "1em",
          width: "1em",
          children: [
            /* @__PURE__ */ f.jsx("line", { x1: "4", y1: "4", x2: "12", y2: "12" }),
            /* @__PURE__ */ f.jsx("line", { x1: "4", y1: "12", x2: "12", y2: "4" })
          ]
        }
      ),
      []
    );
    return h = Te(G({
      "data-dialog-dismiss": "",
      children: S
    }, h), {
      onClick: C
    }), h = wh(h), h;
  }
), VZ = Oe(function(t) {
  const a = pM(t);
  return Ae(PZ, a);
}), NZ = "h1", mM = ke(
  function(t) {
    const a = Pt(null), i = Yo(ay) || 1, h = `h${i}`, g = ph(a, h), m = Lr(
      () => !!g && /^h\d$/.test(g),
      [g]
    );
    return t = Te(G({
      render: /* @__PURE__ */ f.jsx(h, {}),
      role: m ? void 0 : "heading",
      "aria-level": m ? void 0 : i
    }, t), {
      ref: An(a, t.ref)
    }), t;
  }
), BZ = Oe(function(t) {
  const a = mM(t);
  return Ae(NZ, a);
}), FZ = "h1", gM = ke(
  function(t) {
    var a = t, i = Fe(a, ["store"]);
    const h = Yo(eM), g = Ia(i.id);
    return jn(() => (h == null || h(g), () => h == null ? void 0 : h(void 0)), [h, g]), i = G({
      id: g
    }, i), i = mM(i), i;
  }
), UZ = Oe(function(t) {
  const a = gM(t);
  return Ae(FZ, a);
});
function wM(e) {
  return Array.isArray(e) ? e : typeof e < "u" ? [e] : [];
}
function iy(e) {
  const t = [];
  for (const a of e)
    t.push(...a);
  return t;
}
function M4(e) {
  return e.slice().reverse();
}
var YZ = { id: null };
function O0(e, t) {
  return e.find((a) => t ? !a.disabled && a.id !== t : !a.disabled);
}
function $Z(e, t) {
  return e.filter((a) => t ? !a.disabled && a.id !== t : !a.disabled);
}
function WZ(e) {
  if (e === "vertical")
    return "horizontal";
  if (e === "horizontal")
    return "vertical";
}
function z_(e, t) {
  return e.filter((a) => a.rowId === t);
}
function zZ(e, t, a = !1) {
  const i = e.findIndex((h) => h.id === t);
  return [
    ...e.slice(i + 1),
    ...a ? [YZ] : [],
    ...e.slice(0, i)
  ];
}
function ly(e) {
  const t = [];
  for (const a of e) {
    const i = t.find((h) => {
      var g;
      return ((g = h[0]) == null ? void 0 : g.rowId) === a.rowId;
    });
    i ? i.push(a) : t.push([a]);
  }
  return t;
}
function yM(e) {
  let t = 0;
  for (const { length: a } of e)
    a > t && (t = a);
  return t;
}
function qZ(e) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    rowId: e
  };
}
function q_(e, t, a) {
  const i = yM(e);
  for (const h of e)
    for (let g = 0; g < i; g += 1) {
      const m = h[g];
      if (!m || a && m.disabled) {
        const S = g === 0 && a ? O0(h) : h[g - 1];
        h[g] = S && t !== S.id && a ? S : qZ(S == null ? void 0 : S.rowId);
      }
    }
  return e;
}
function G_(e) {
  const t = ly(e), a = yM(t), i = [];
  for (let h = 0; h < a; h += 1)
    for (const g of t) {
      const m = g[h];
      m && i.push(mn(_t({}, m), {
        // If there's no rowId, it means that it's not a grid composite, but
        // a single row instead. So, instead of verticalizing it, that is,
        // assigning a different rowId based on the column index, we keep it
        // undefined so they will be part of the same row. This is useful
        // when using up/down on one-dimensional composites.
        rowId: m.rowId ? `${h}` : void 0
      }));
    }
  return i;
}
function xh(e = {}) {
  var t;
  const a = (t = e.store) == null ? void 0 : t.getState(), i = N5(e), h = st(
    e.activeId,
    a == null ? void 0 : a.activeId,
    e.defaultActiveId
  ), g = mn(_t({}, i.getState()), {
    activeId: h,
    baseElement: st(a == null ? void 0 : a.baseElement, null),
    includesBaseElement: st(
      e.includesBaseElement,
      a == null ? void 0 : a.includesBaseElement,
      h === null
    ),
    moves: st(a == null ? void 0 : a.moves, 0),
    orientation: st(
      e.orientation,
      a == null ? void 0 : a.orientation,
      "both"
    ),
    rtl: st(e.rtl, a == null ? void 0 : a.rtl, !1),
    virtualFocus: st(
      e.virtualFocus,
      a == null ? void 0 : a.virtualFocus,
      !1
    ),
    focusLoop: st(e.focusLoop, a == null ? void 0 : a.focusLoop, !1),
    focusWrap: st(e.focusWrap, a == null ? void 0 : a.focusWrap, !1),
    focusShift: st(e.focusShift, a == null ? void 0 : a.focusShift, !1)
  }), m = fo(g, i, e.store);
  Aa(
    m,
    () => xa(m, ["renderedItems", "activeId"], (S) => {
      m.setState("activeId", (R) => {
        var D;
        return R !== void 0 ? R : (D = O0(S.renderedItems)) == null ? void 0 : D.id;
      });
    })
  );
  const C = (S, R, D, T) => {
    var j, A;
    const { activeId: L, rtl: P, focusLoop: V, focusWrap: F, includesBaseElement: Y } = m.getState(), $ = P && R !== "vertical" ? M4(S) : S;
    if (L == null)
      return (j = O0($)) == null ? void 0 : j.id;
    const le = $.find((Le) => Le.id === L);
    if (!le)
      return (A = O0($)) == null ? void 0 : A.id;
    const te = !!le.rowId, Se = $.indexOf(le), re = $.slice(Se + 1), ve = z_(re, le.rowId);
    if (T !== void 0) {
      const Le = $Z(ve, L), be = Le.slice(T)[0] || // If we can't find an item, just return the last one.
      Le[Le.length - 1];
      return be == null ? void 0 : be.id;
    }
    const K = WZ(
      // If it's a grid and orientation is not set, it's a next/previous call,
      // which is inherently horizontal. up/down will call next with orientation
      // set to vertical by default (see below on up/down methods).
      te ? R || "horizontal" : R
    ), de = V && V !== K, fe = te && F && F !== K;
    if (D = D || !te && de && Y, de) {
      const Le = fe && !D ? $ : z_($, le.rowId), be = zZ(Le, L, D), Ue = O0(be, L);
      return Ue == null ? void 0 : Ue.id;
    }
    if (fe) {
      const Le = O0(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        D ? ve : re,
        L
      );
      return D ? (Le == null ? void 0 : Le.id) || null : Le == null ? void 0 : Le.id;
    }
    const xe = O0(ve, L);
    return !xe && D ? null : xe == null ? void 0 : xe.id;
  };
  return mn(_t(_t({}, i), m), {
    setBaseElement: (S) => m.setState("baseElement", S),
    setActiveId: (S) => m.setState("activeId", S),
    move: (S) => {
      S !== void 0 && (m.setState("activeId", S), m.setState("moves", (R) => R + 1));
    },
    first: () => {
      var S;
      return (S = O0(m.getState().renderedItems)) == null ? void 0 : S.id;
    },
    last: () => {
      var S;
      return (S = O0(M4(m.getState().renderedItems))) == null ? void 0 : S.id;
    },
    next: (S) => {
      const { renderedItems: R, orientation: D } = m.getState();
      return C(R, D, !1, S);
    },
    previous: (S) => {
      var R;
      const { renderedItems: D, orientation: T, includesBaseElement: j } = m.getState(), L = !!!((R = O0(D)) != null && R.rowId) && j;
      return C(
        M4(D),
        T,
        L,
        S
      );
    },
    down: (S) => {
      const {
        activeId: R,
        renderedItems: D,
        focusShift: T,
        focusLoop: j,
        includesBaseElement: A
      } = m.getState(), L = T && !S, P = G_(
        iy(
          q_(ly(D), R, L)
        )
      );
      return C(P, "vertical", j && j !== "horizontal" && A, S);
    },
    up: (S) => {
      const { activeId: R, renderedItems: D, focusShift: T, includesBaseElement: j } = m.getState(), A = T && !S, L = G_(
        M4(
          iy(
            q_(
              ly(D),
              R,
              A
            )
          )
        )
      );
      return C(L, "vertical", j, S);
    }
  });
}
function Sh(e, t, a) {
  return e = Fy(e, t, a), ir(e, a, "activeId", "setActiveId"), ir(e, a, "includesBaseElement"), ir(e, a, "virtualFocus"), ir(e, a, "orientation"), ir(e, a, "rtl"), ir(e, a, "focusLoop"), ir(e, a, "focusWrap"), ir(e, a, "focusShift"), e;
}
function xM(e = {}) {
  const [t, a] = bi(xh, e);
  return Sh(t, a, e);
}
var GZ = "div";
function KZ(e) {
  return e.some((t) => !!t.rowId);
}
function QZ(e) {
  const t = e.target;
  return t && !bl(t) ? !1 : e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
function XZ(e) {
  return e.key === "Shift" || e.key === "Control" || e.key === "Alt" || e.key === "Meta";
}
function K_(e, t, a) {
  return rt((i) => {
    var h;
    if (t == null || t(i), i.defaultPrevented || i.isPropagationStopped() || !Ci(i) || XZ(i) || QZ(i))
      return;
    const g = e.getState(), m = (h = ah(e, g.activeId)) == null ? void 0 : h.element;
    if (!m)
      return;
    const C = i, S = Fe(C, ["view"]), R = a == null ? void 0 : a.current;
    m !== R && m.focus(), mL(m, i.type, S) || i.preventDefault(), i.currentTarget.contains(m) && i.stopPropagation();
  });
}
function JZ(e) {
  return cH(
    iy(M4(fH(e)))
  );
}
function eP(e) {
  const [t, a] = Qt(!1), i = Ir(() => a(!0), []), h = e.useState(
    (g) => ah(e, g.activeId)
  );
  return gt(() => {
    const g = h == null ? void 0 : h.element;
    t && g && (a(!1), g.focus({ preventScroll: !0 }));
  }, [h, t]), i;
}
var Ch = ke(
  function(t) {
    var a = t, {
      store: i,
      composite: h = !0,
      focusOnMove: g = h,
      moveOnKeyPress: m = !0
    } = a, C = Fe(a, [
      "store",
      "composite",
      "focusOnMove",
      "moveOnKeyPress"
    ]);
    const S = rH();
    i = i || S, Zt(
      i,
      process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component."
    );
    const R = Pt(null), D = eP(i), T = i.useState("moves");
    gt(() => {
      var K;
      if (!i || !T || !h || !g)
        return;
      const { activeId: de } = i.getState(), fe = (K = ah(i, de)) == null ? void 0 : K.element;
      fe && WL(fe);
    }, [i, T, h, g]), jn(() => {
      if (!i || !T || !h)
        return;
      const { baseElement: K, activeId: de } = i.getState();
      if (!(de === null) || !K)
        return;
      const xe = R.current;
      R.current = null, xe && pp(xe, { relatedTarget: K }), H2(K) || K.focus();
    }, [i, T, h]);
    const j = i.useState("activeId"), A = i.useState("virtualFocus");
    jn(() => {
      var K;
      if (!i || !h || !A)
        return;
      const de = R.current;
      if (R.current = null, !de)
        return;
      const xe = ((K = ah(i, j)) == null ? void 0 : K.element) || gf(de);
      xe !== de && pp(de, { relatedTarget: xe });
    }, [i, j, A, h]);
    const L = K_(
      i,
      C.onKeyDownCapture,
      R
    ), P = K_(
      i,
      C.onKeyUpCapture,
      R
    ), V = C.onFocusCapture, F = rt((K) => {
      if (V == null || V(K), K.defaultPrevented || !i)
        return;
      const { virtualFocus: de } = i.getState();
      if (!de)
        return;
      const fe = K.relatedTarget, xe = hH(K.currentTarget);
      Ci(K) && xe && (K.stopPropagation(), R.current = fe);
    }), Y = C.onFocus, W = rt((K) => {
      if (Y == null || Y(K), K.defaultPrevented || !h || !i)
        return;
      const { relatedTarget: de } = K, { virtualFocus: fe } = i.getState();
      fe ? Ci(K) && !D4(i, de) && queueMicrotask(D) : Ci(K) && i.setActiveId(null);
    }), Q = C.onBlurCapture, $ = rt((K) => {
      var de;
      if (Q == null || Q(K), K.defaultPrevented || !i)
        return;
      const { virtualFocus: fe, activeId: xe } = i.getState();
      if (!fe)
        return;
      const Le = (de = ah(i, xe)) == null ? void 0 : de.element, be = K.relatedTarget, Ue = D4(i, be), ie = R.current;
      R.current = null, Ci(K) && Ue ? (be === Le ? ie && ie !== be && pp(ie, K) : Le ? pp(Le, K) : ie && pp(ie, K), K.stopPropagation()) : !D4(i, K.target) && Le && pp(Le, K);
    }), le = C.onKeyDown, te = er(m), Se = rt((K) => {
      var de;
      if (le == null || le(K), K.defaultPrevented || !i || !Ci(K))
        return;
      const { orientation: fe, items: xe, renderedItems: Le, activeId: be } = i.getState(), Ue = ah(i, be);
      if ((de = Ue == null ? void 0 : Ue.element) != null && de.isConnected)
        return;
      const ie = fe !== "horizontal", _e = fe !== "vertical", Ze = KZ(Le);
      if ((K.key === "ArrowLeft" || K.key === "ArrowRight" || K.key === "Home" || K.key === "End") && bl(K.currentTarget))
        return;
      const Dt = {
        ArrowUp: (Ze || ie) && (() => {
          if (Ze) {
            const Qe = xe && JZ(xe);
            return Qe == null ? void 0 : Qe.id;
          }
          return i == null ? void 0 : i.last();
        }),
        ArrowRight: (Ze || _e) && i.first,
        ArrowDown: (Ze || ie) && i.first,
        ArrowLeft: (Ze || _e) && i.last,
        Home: i.first,
        End: i.last,
        PageUp: i.first,
        PageDown: i.last
      }[K.key];
      if (Dt) {
        const Qe = Dt();
        if (Qe !== void 0) {
          if (!te(K))
            return;
          K.preventDefault(), i.move(Qe);
        }
      }
    });
    C = Vn(
      C,
      (K) => /* @__PURE__ */ f.jsx(P0, { value: i, children: K }),
      [i]
    );
    const re = i.useState((K) => {
      var de;
      if (i && h && K.virtualFocus)
        return (de = ah(i, K.activeId)) == null ? void 0 : de.id;
    });
    C = Te(G({
      "aria-activedescendant": re
    }, C), {
      ref: An(h ? i.setBaseElement : null, C.ref),
      onKeyDownCapture: L,
      onKeyUpCapture: P,
      onFocusCapture: F,
      onFocus: W,
      onBlurCapture: $,
      onKeyDown: Se
    });
    const ve = i.useState(
      (K) => h && (K.virtualFocus || K.activeId === null)
    );
    return C = N2(G({ focusable: ve }, C)), C;
  }
), tP = Oe(function(t) {
  const a = Ch(t);
  return Ae(GZ, a);
});
function nP(e = {}) {
  const t = xM(e);
  return /* @__PURE__ */ f.jsx(P0, { value: t, children: e.children });
}
var rP = "div", J5 = ke(function(t) {
  var a = t, i = Fe(a, ["store"]);
  return i = Qy(i), i;
}), aP = Oe(function(t) {
  const a = J5(t);
  return Ae(rP, a);
}), oP = "div", ew = ke(
  function(t) {
    var a = t, i = Fe(a, ["store"]);
    return i = Xy(i), i;
  }
), iP = Oe(function(t) {
  const a = ew(t);
  return Ae(oP, a);
}), lP = "div";
function SM(e) {
  const t = e.relatedTarget;
  return (t == null ? void 0 : t.nodeType) === Node.ELEMENT_NODE ? t : null;
}
function uP(e) {
  const t = SM(e);
  return t ? ha(e.currentTarget, t) : !1;
}
var uy = Symbol("composite-hover");
function sP(e) {
  let t = SM(e);
  if (!t)
    return !1;
  do {
    if (hf(t, uy) && t[uy])
      return !0;
    t = t.parentElement;
  } while (t);
  return !1;
}
var tw = ke(
  function(t) {
    var a = t, {
      store: i,
      focusOnHover: h = !0,
      blurOnHoverEnd: g = !!h
    } = a, m = Fe(a, [
      "store",
      "focusOnHover",
      "blurOnHoverEnd"
    ]);
    const C = B2();
    i = i || C, Zt(
      i,
      process.env.NODE_ENV !== "production" && "CompositeHover must be wrapped in a Composite component."
    );
    const S = SE(), R = m.onMouseMove, D = er(h), T = rt((V) => {
      if (R == null || R(V), !V.defaultPrevented && S() && D(V)) {
        if (!uh(V.currentTarget)) {
          const F = i == null ? void 0 : i.getState().baseElement;
          F && !H2(F) && F.focus();
        }
        i == null || i.setActiveId(V.currentTarget.id);
      }
    }), j = m.onMouseLeave, A = er(g), L = rt((V) => {
      var F;
      j == null || j(V), !V.defaultPrevented && S() && (uP(V) || sP(V) || D(V) && A(V) && (i == null || i.setActiveId(null), (F = i == null ? void 0 : i.getState().baseElement) == null || F.focus()));
    }), P = Ir((V) => {
      V && (V[uy] = !0);
    }, []);
    return m = Te(G({}, m), {
      ref: An(P, m.ref),
      onMouseMove: T,
      onMouseLeave: L
    }), La(m);
  }
), cP = Ha(
  Oe(function(t) {
    const a = tw(t);
    return Ae(lP, a);
  })
), fP = "div", sx = ke(
  function(t) {
    var a = t, {
      store: i,
      "aria-setsize": h,
      "aria-posinset": g
    } = a, m = Fe(a, [
      "store",
      "aria-setsize",
      "aria-posinset"
    ]);
    const C = B2();
    i = i || C, Zt(
      i,
      process.env.NODE_ENV !== "production" && "CompositeRow must be wrapped in a Composite component."
    );
    const S = Ia(m.id), R = i.useState(
      (T) => T.baseElement || void 0
    ), D = Lr(
      () => ({ id: S, baseElement: R, ariaSetSize: h, ariaPosInSet: g }),
      [S, R, h, g]
    );
    return m = Vn(
      m,
      (T) => /* @__PURE__ */ f.jsx(UE.Provider, { value: D, children: T }),
      [D]
    ), m = G({ id: S }, m), La(m);
  }
), dP = Oe(function(t) {
  const a = sx(t);
  return Ae(fP, a);
}), hP = "hr", CM = ke(
  function(t) {
    var a = t, { orientation: i = "horizontal" } = a, h = Fe(a, ["orientation"]);
    return h = G({
      role: "separator",
      "aria-orientation": i
    }, h), h;
  }
), vP = Oe(function(t) {
  const a = CM(t);
  return Ae(hP, a);
}), pP = "hr", Q4 = ke(function(t) {
  var a = t, { store: i } = a, h = Fe(a, ["store"]);
  const g = B2();
  i = i || g, Zt(
    i,
    process.env.NODE_ENV !== "production" && "CompositeSeparator must be wrapped in a Composite component."
  );
  const m = i.useState(
    (C) => C.orientation === "horizontal" ? "vertical" : "horizontal"
  );
  return h = CM(Te(G({}, h), { orientation: m })), h;
}), mP = Oe(function(t) {
  const a = Q4(t);
  return Ae(pP, a);
}), gP = "div", uf = "";
function A8() {
  uf = "";
}
function wP(e) {
  const t = e.target;
  return t && bl(t) ? !1 : e.key === " " && uf.length ? !0 : e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey && /^[\p{Letter}\p{Number}]$/u.test(e.key);
}
function yP(e, t) {
  if (Ci(e))
    return !0;
  const a = e.target;
  return a ? t.some((h) => h.element === a) : !1;
}
function xP(e) {
  return e.filter((t) => !t.disabled);
}
function h5(e, t) {
  var a;
  const i = ((a = e.element) == null ? void 0 : a.textContent) || e.children || // The composite item object itself doesn't include a value property, but
  // other components like Select do. Since CompositeTypeahead is a generic
  // component that can be used with those as well, we also consider the value
  // property as a fallback for the typeahead text content.
  "value" in e && e.value;
  return i ? Dy(i).trim().toLowerCase().startsWith(t.toLowerCase()) : !1;
}
function SP(e, t, a) {
  if (!a)
    return e;
  const i = e.find((h) => h.id === a);
  return !i || !h5(i, t) || uf !== t && h5(i, uf) ? e : (uf = t, sH(
    e.filter((h) => h5(h, uf)),
    a
  ).filter((h) => h.id !== a));
}
var X4 = ke(function(t) {
  var a = t, { store: i, typeahead: h = !0 } = a, g = Fe(a, ["store", "typeahead"]);
  const m = B2();
  i = i || m, Zt(
    i,
    process.env.NODE_ENV !== "production" && "CompositeTypeahead must be a Composite component"
  );
  const C = g.onKeyDownCapture, S = Pt(0), R = rt((D) => {
    if (C == null || C(D), D.defaultPrevented || !h || !i)
      return;
    const { renderedItems: T, items: j, activeId: A } = i.getState();
    if (!wP(D))
      return A8();
    let L = xP(
      T.length ? T : j
    );
    if (!yP(D, L))
      return A8();
    D.preventDefault(), window.clearTimeout(S.current), S.current = window.setTimeout(() => {
      uf = "";
    }, 500);
    const P = D.key.toLowerCase();
    uf += P, L = SP(L, P, A);
    const V = L.find((F) => h5(F, uf));
    V ? i.move(V.id) : A8();
  });
  return g = Te(G({}, g), {
    onKeyDownCapture: R
  }), La(g);
}), CP = Oe(function(t) {
  const a = X4(t);
  return Ae(gP, a);
});
ka(null);
ka(
  null
);
var bP = _i(
  [P0],
  [yh]
), _P = bP.useContext;
function nw(e = {}) {
  var t = e, {
    popover: a
  } = t, i = jp(t, [
    "popover"
  ]);
  const h = kp(
    i.store,
    Tp(a, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  mh(i, h);
  const g = h == null ? void 0 : h.getState(), m = aM(mn(_t({}, i), { store: h })), C = st(
    i.placement,
    g == null ? void 0 : g.placement,
    "bottom"
  ), S = mn(_t({}, m.getState()), {
    placement: C,
    currentPlacement: C,
    anchorElement: st(g == null ? void 0 : g.anchorElement, null),
    popoverElement: st(g == null ? void 0 : g.popoverElement, null),
    arrowElement: st(g == null ? void 0 : g.arrowElement, null),
    rendered: Symbol("rendered")
  }), R = fo(S, m, h);
  return mn(_t(_t({}, m), R), {
    setAnchorElement: (D) => R.setState("anchorElement", D),
    setPopoverElement: (D) => R.setState("popoverElement", D),
    setArrowElement: (D) => R.setState("arrowElement", D),
    render: () => R.setState("rendered", Symbol("rendered"))
  });
}
function rw(e, t, a) {
  return _1(t, [a.popover]), ir(e, a, "placement"), oM(e, t, a);
}
function cx(e = {}) {
  const [t, a] = bi(nw, e);
  return rw(t, a, e);
}
var RP = Hy() && matchMedia("(hover:none)").matches;
function EP(e = {}) {
  var t = e, {
    tag: a
  } = t, i = jp(t, [
    "tag"
  ]);
  const h = kp(i.store, bE(a, ["value", "rtl"]));
  mh(i, h);
  const g = a == null ? void 0 : a.getState(), m = h == null ? void 0 : h.getState(), C = st(
    i.activeId,
    m == null ? void 0 : m.activeId,
    i.defaultActiveId,
    null
  ), S = xh(mn(_t({}, i), {
    activeId: C,
    includesBaseElement: st(
      i.includesBaseElement,
      m == null ? void 0 : m.includesBaseElement,
      !0
    ),
    orientation: st(
      i.orientation,
      m == null ? void 0 : m.orientation,
      "vertical"
    ),
    focusLoop: st(i.focusLoop, m == null ? void 0 : m.focusLoop, !0),
    focusWrap: st(i.focusWrap, m == null ? void 0 : m.focusWrap, !0),
    virtualFocus: st(
      i.virtualFocus,
      m == null ? void 0 : m.virtualFocus,
      !RP
    )
  })), R = nw(mn(_t({}, i), {
    placement: st(
      i.placement,
      m == null ? void 0 : m.placement,
      "bottom-start"
    )
  })), D = st(
    i.value,
    m == null ? void 0 : m.value,
    i.defaultValue,
    ""
  ), T = st(
    i.selectedValue,
    m == null ? void 0 : m.selectedValue,
    g == null ? void 0 : g.values,
    i.defaultSelectedValue,
    ""
  ), j = Array.isArray(T), A = mn(_t(_t({}, S.getState()), R.getState()), {
    value: D,
    selectedValue: T,
    resetValueOnSelect: st(
      i.resetValueOnSelect,
      m == null ? void 0 : m.resetValueOnSelect,
      j
    ),
    resetValueOnHide: st(
      i.resetValueOnHide,
      m == null ? void 0 : m.resetValueOnHide,
      j && !a
    ),
    activeValue: m == null ? void 0 : m.activeValue
  }), L = fo(A, S, R, h);
  return Aa(L, () => {
    if (a)
      return _l(
        xa(L, ["selectedValue"], (P) => {
          Array.isArray(P.selectedValue) && a.setValues(P.selectedValue);
        }),
        xa(a, ["values"], (P) => {
          L.setState("selectedValue", P.values);
        })
      );
  }), Aa(
    L,
    () => xa(L, ["resetValueOnHide", "mounted"], (P) => {
      P.resetValueOnHide && (P.mounted || L.setState("value", D));
    })
  ), Aa(
    L,
    () => I2(L, ["mounted"], (P) => {
      P.mounted || (L.setState("activeId", C), L.setState("moves", 0));
    })
  ), Aa(
    L,
    () => xa(L, ["moves", "activeId"], (P, V) => {
      P.moves === V.moves && L.setState("activeValue", void 0);
    })
  ), Aa(
    L,
    () => I2(L, ["moves", "renderedItems"], (P, V) => {
      if (P.moves === V.moves)
        return;
      const { activeId: F } = L.getState(), Y = S.item(F);
      L.setState("activeValue", Y == null ? void 0 : Y.value);
    })
  ), mn(_t(_t(_t({}, R), S), L), {
    tag: a,
    setValue: (P) => L.setState("value", P),
    resetValue: () => L.setState("value", A.value),
    setSelectedValue: (P) => L.setState("selectedValue", P)
  });
}
function MP(e, t, a) {
  return _1(t, [a.tag]), ir(e, a, "value", "setValue"), ir(e, a, "selectedValue", "setSelectedValue"), ir(e, a, "resetValueOnHide"), ir(e, a, "resetValueOnSelect"), Object.assign(
    Sh(
      rw(e, t, a),
      t,
      a
    ),
    { tag: a.tag }
  );
}
function J4(e = {}) {
  const t = _P();
  e = Te(G({}, e), {
    tag: e.tag !== void 0 ? e.tag : t
  });
  const [a, i] = bi(EP, e);
  return MP(a, i, e);
}
var e3 = _i(
  [JE],
  [rx]
), bh = e3.useContext, TP = e3.useScopedContext, aw = e3.useProviderContext, ow = e3.ContextProvider, t3 = e3.ScopedContextProvider, bM = ka(
  void 0
), n3 = _i(
  [ow, P0],
  [t3, yh]
), fx = n3.useContext, Ip = n3.useScopedContext, _h = n3.useProviderContext, OP = n3.ContextProvider, DP = n3.ScopedContextProvider, _M = ka(
  void 0
), RM = ka(!1), jP = "div", dx = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = aw();
    return i = i || g, h = Te(G({}, h), {
      ref: An(i == null ? void 0 : i.setAnchorElement, h.ref)
    }), h;
  }
), AP = Oe(function(t) {
  const a = dx(t);
  return Ae(jP, a);
}), kP = "input";
function Q_(e, t, a) {
  if (!a)
    return !1;
  const i = e.find((h) => !h.disabled && h.value);
  return (i == null ? void 0 : i.value) === t;
}
function X_(e, t) {
  return !t || e == null ? !1 : (e = Dy(e), t.length > e.length && t.toLowerCase().indexOf(e.toLowerCase()) === 0);
}
function LP(e) {
  return e.type === "input";
}
function IP(e) {
  return e === "inline" || e === "list" || e === "both" || e === "none";
}
function HP(e) {
  const t = e.find((a) => {
    var i;
    return a.disabled ? !1 : ((i = a.element) == null ? void 0 : i.getAttribute("role")) !== "tab";
  });
  return t == null ? void 0 : t.id;
}
var ZP = ke(
  function(t) {
    var a = t, {
      store: i,
      focusable: h = !0,
      autoSelect: g = !1,
      getAutoSelectId: m,
      setValueOnChange: C,
      showMinLength: S = 0,
      showOnChange: R,
      showOnMouseDown: D,
      showOnClick: T = D,
      showOnKeyDown: j,
      showOnKeyPress: A = j,
      blurActiveItemOnClick: L,
      setValueOnClick: P = !0,
      moveOnKeyPress: V = !0,
      autoComplete: F = "list"
    } = a, Y = Fe(a, [
      "store",
      "focusable",
      "autoSelect",
      "getAutoSelectId",
      "setValueOnChange",
      "showMinLength",
      "showOnChange",
      "showOnMouseDown",
      "showOnClick",
      "showOnKeyDown",
      "showOnKeyPress",
      "blurActiveItemOnClick",
      "setValueOnClick",
      "moveOnKeyPress",
      "autoComplete"
    ]);
    const W = _h();
    i = i || W, Zt(
      i,
      process.env.NODE_ENV !== "production" && "Combobox must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const Q = Pt(null), [$, le] = P5(), te = Pt(!1), Se = Pt(!1), re = i.useState(
      (Xe) => Xe.virtualFocus && g
    ), ve = F === "inline" || F === "both", [K, de] = Qt(ve);
    gL(() => {
      ve && de(!0);
    }, [ve]);
    const fe = i.useState("value"), xe = Pt();
    gt(() => xa(i, ["selectedValue", "activeId"], (Xe, Jt) => {
      xe.current = Jt.selectedValue;
    }), []);
    const Le = i.useState((Xe) => {
      var Jt;
      if (ve && K && !(Xe.activeValue && Array.isArray(Xe.selectedValue) && (Xe.selectedValue.includes(Xe.activeValue) || (Jt = xe.current) != null && Jt.includes(Xe.activeValue))))
        return Xe.activeValue;
    }), be = i.useState("renderedItems"), Ue = i.useState("open"), ie = i.useState("contentElement"), _e = Lr(() => {
      if (!ve || !K)
        return fe;
      if (Q_(
        be,
        Le,
        re
      )) {
        if (X_(fe, Le)) {
          const Jt = (Le == null ? void 0 : Le.slice(fe.length)) || "";
          return fe + Jt;
        }
        return fe;
      }
      return Le || fe;
    }, [ve, K, be, Le, re, fe]);
    gt(() => {
      const Xe = Q.current;
      if (!Xe)
        return;
      const Jt = () => de(!0);
      return Xe.addEventListener("combobox-item-move", Jt), () => {
        Xe.removeEventListener("combobox-item-move", Jt);
      };
    }, []), gt(() => {
      if (!ve || !K || !Le || !Q_(
        be,
        Le,
        re
      ) || !X_(fe, Le))
        return;
      let Jt = T4;
      return queueMicrotask(() => {
        const qn = Q.current;
        if (!qn)
          return;
        const { start: Sn, end: qe } = G8(qn), yt = fe.length, Ct = Le.length;
        S8(qn, yt, Ct), Jt = () => {
          if (!H2(qn))
            return;
          const { start: ln, end: cr } = G8(qn);
          ln === yt && cr === Ct && S8(qn, Sn, qe);
        };
      }), () => Jt();
    }, [
      $,
      ve,
      K,
      Le,
      be,
      re,
      fe
    ]);
    const Ze = Pt(null), mt = rt(m), Pe = Pt(null);
    gt(() => {
      if (!Ue || !ie)
        return;
      const Xe = Ly(ie);
      if (!Xe)
        return;
      Ze.current = Xe;
      const Jt = () => {
        te.current = !1;
      }, qn = () => {
        if (!i || !te.current)
          return;
        const { activeId: qe } = i.getState();
        qe !== null && qe !== Pe.current && (te.current = !1);
      }, Sn = { passive: !0, capture: !0 };
      return Xe.addEventListener("wheel", Jt, Sn), Xe.addEventListener("scroll", qn, Sn), () => {
        Xe.removeEventListener("wheel", Jt, !0), Xe.removeEventListener("scroll", qn, !0);
      };
    }, [Ue, ie, i]), jn(() => {
      fe && (Se.current || (te.current = !0));
    }, [fe]), jn(() => {
      re !== "always" && Ue || (te.current = Ue);
    }, [re, Ue]);
    const Vt = i.useState("resetValueOnSelect");
    _1(() => {
      var Xe, Jt;
      const qn = te.current;
      if (!i || !Ue || (!re || !qn) && !Vt)
        return;
      const { baseElement: Sn, contentElement: qe, activeId: yt } = i.getState();
      if (!(Sn && !H2(Sn))) {
        if (qe != null && qe.hasAttribute("data-placing")) {
          const Ct = new MutationObserver(le);
          return Ct.observe(qe, { attributeFilter: ["data-placing"] }), () => Ct.disconnect();
        }
        if (re && qn) {
          const Ct = mt(be), ln = Ct !== void 0 ? Ct : (Xe = HP(be)) != null ? Xe : i.first();
          Pe.current = ln, i.move(ln ?? null);
        } else {
          const Ct = (Jt = i.item(yt)) == null ? void 0 : Jt.element;
          Ct && "scrollIntoView" in Ct && Ct.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      }
    }, [
      i,
      Ue,
      $,
      fe,
      re,
      Vt,
      mt,
      be
    ]), gt(() => {
      if (!ve)
        return;
      const Xe = Q.current;
      if (!Xe)
        return;
      const Jt = [Xe, ie].filter(
        (Sn) => !!Sn
      ), qn = (Sn) => {
        Jt.every((qe) => rh(Sn, qe)) && (i == null || i.setValue(_e));
      };
      return Jt.forEach((Sn) => Sn.addEventListener("focusout", qn)), () => {
        Jt.forEach((Sn) => Sn.removeEventListener("focusout", qn));
      };
    }, [ve, ie, i, _e]);
    const Dt = (Xe) => Xe.currentTarget.value.length >= S, Qe = Y.onChange, et = er(R ?? Dt), wt = er(
      // If the combobox is combined with tags, the value will be set by the tag
      // input component.
      C ?? !i.tag
    ), St = rt((Xe) => {
      if (Qe == null || Qe(Xe), Xe.defaultPrevented || !i)
        return;
      const Jt = Xe.currentTarget, { value: qn, selectionStart: Sn, selectionEnd: qe } = Jt, yt = Xe.nativeEvent;
      if (te.current = !0, LP(yt) && (yt.isComposing && (te.current = !1, Se.current = !0), ve)) {
        const Ct = yt.inputType === "insertText" || yt.inputType === "insertCompositionText", ln = Sn === qn.length;
        de(Ct && ln);
      }
      if (wt(Xe)) {
        const Ct = qn === i.getState().value;
        i.setValue(qn), queueMicrotask(() => {
          S8(Jt, Sn, qe);
        }), ve && re && Ct && le();
      }
      et(Xe) && i.show(), (!re || !te.current) && i.setActiveId(null);
    }), _n = Y.onCompositionEnd, Hr = rt((Xe) => {
      te.current = !0, Se.current = !1, _n == null || _n(Xe), !Xe.defaultPrevented && re && le();
    }), kn = Y.onMouseDown, Wn = er(
      L ?? (() => !!(i != null && i.getState().includesBaseElement))
    ), sr = er(P), yr = er(T ?? Dt), ea = rt((Xe) => {
      kn == null || kn(Xe), !Xe.defaultPrevented && (Xe.button || Xe.ctrlKey || i && (Wn(Xe) && i.setActiveId(null), sr(Xe) && i.setValue(_e), yr(Xe) && L2(Xe.currentTarget, "mouseup", i.show)));
    }), Ca = Y.onKeyDown, ft = er(A ?? Dt), fn = rt((Xe) => {
      if (Ca == null || Ca(Xe), Xe.repeat || (te.current = !1), Xe.defaultPrevented || Xe.ctrlKey || Xe.altKey || Xe.shiftKey || Xe.metaKey || !i)
        return;
      const { open: Jt, activeId: qn } = i.getState();
      Jt || qn === null && (Xe.key === "ArrowUp" || Xe.key === "ArrowDown") && ft(Xe) && (Xe.preventDefault(), i.show());
    }), Ln = Y.onBlur, Nt = rt((Xe) => {
      te.current = !1, Ln == null || Ln(Xe), Xe.defaultPrevented;
    }), gn = Ia(Y.id), zn = IP(F) ? F : void 0, Ur = i.useState((Xe) => Xe.activeId === null);
    return Y = Te(G({
      id: gn,
      role: "combobox",
      "aria-autocomplete": zn,
      "aria-haspopup": vh(ie, "listbox"),
      "aria-expanded": Ue,
      "aria-controls": ie == null ? void 0 : ie.id,
      "data-active-item": Ur || void 0,
      value: _e
    }, Y), {
      ref: An(Q, Y.ref),
      onChange: St,
      onCompositionEnd: Hr,
      onMouseDown: ea,
      onKeyDown: fn,
      onBlur: Nt
    }), Y = Ch(Te(G({
      store: i,
      focusable: h
    }, Y), {
      // Enable inline autocomplete when the user moves from the combobox input
      // to an item.
      moveOnKeyPress: (Xe) => k2(V, Xe) ? !1 : (ve && de(!0), !0)
    })), Y = dx(G({ store: i }, Y)), G({ autoComplete: "off" }, Y);
  }
), iw = Oe(function(t) {
  const a = ZP(t);
  return Ae(kP, a);
});
function EM(e = {}) {
  const t = J4(e);
  return /* @__PURE__ */ f.jsx(OP, { value: t, children: e.children });
}
var PP = "button", VP = /* @__PURE__ */ f.jsxs(
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    width: "1em",
    height: "1em",
    pointerEvents: "none",
    children: [
      /* @__PURE__ */ f.jsx("line", { x1: "5", y1: "5", x2: "11", y2: "11" }),
      /* @__PURE__ */ f.jsx("line", { x1: "5", y1: "11", x2: "11", y2: "5" })
    ]
  }
), NP = ke(
  function(t) {
    var a = t, { store: i, hideWhenEmpty: h } = a, g = Fe(a, ["store", "hideWhenEmpty"]);
    const m = _h();
    i = i || m, Zt(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxCancel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const C = g.onClick, S = rt((T) => {
      C == null || C(T), !T.defaultPrevented && (i == null || i.setValue(""), i == null || i.move(null));
    }), R = i.useState((T) => {
      var j;
      return (j = T.baseElement) == null ? void 0 : j.id;
    }), D = i.useState((T) => T.value === "");
    return g = Vn(
      g,
      (T) => h && D ? /* @__PURE__ */ f.jsx(iE, {}) : T,
      [h, D]
    ), g = Te(G({
      children: VP,
      "aria-label": "Clear input",
      // This aria-controls will ensure the combobox popup remains visible when
      // this element gets focused. This logic is done in the ComboboxPopover
      // component.
      "aria-controls": R
    }, g), {
      onClick: S
    }), g = wh(g), g;
  }
), BP = Oe(function(t) {
  const a = NP(t);
  return Ae(PP, a);
}), FP = "button", UP = /* @__PURE__ */ f.jsx(
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    pointerEvents: "none",
    children: /* @__PURE__ */ f.jsx("polyline", { points: "4,6 8,10 12,6" })
  }
), YP = ke(function(t) {
  var a = t, { store: i } = a, h = Fe(a, ["store"]);
  const g = _h();
  i = i || g, Zt(
    i,
    process.env.NODE_ENV !== "production" && "ComboboxDisclosure must receive a `store` prop or be wrapped in a ComboboxProvider component."
  );
  const m = h.onMouseDown, C = rt((T) => {
    m == null || m(T), T.preventDefault(), i == null || i.move(null);
  }), S = h.onClick, R = rt((T) => {
    if (S == null || S(T), T.defaultPrevented || !i)
      return;
    const { baseElement: j } = i.getState();
    i.setDisclosureElement(j);
  }), D = i.useState("open");
  return h = Te(G({
    children: UP,
    tabIndex: -1,
    "aria-label": D ? "Hide popup" : "Show popup",
    "aria-expanded": D
  }, h), {
    onMouseDown: C,
    onClick: R
  }), h = X5(G({ store: i }, h)), h;
}), $P = Oe(function(t) {
  const a = YP(t);
  return Ae(FP, a);
}), WP = "div", zP = ke(function(t) {
  return t = J5(t), t;
}), MM = Oe(function(t) {
  const a = zP(t);
  return Ae(WP, a);
}), qP = "div", GP = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = Ip();
    i = i || g, Zt(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxRow must be wrapped in a ComboboxList or ComboboxPopover component"
    );
    const m = i.useState("contentElement");
    return vh(m) === "grid" && (h = G({ role: "rowgroup" }, h)), h = ew(G({ store: i }, h)), h;
  }
), TM = Oe(function(t) {
  const a = GP(t);
  return Ae(qP, a);
}), KP = "span", QP = ke(function(t) {
  var a = t, { checked: i } = a, h = Fe(a, ["store", "checked"]);
  const g = Yo(RM);
  return i = i ?? g, h = Y5(Te(G({}, h), { checked: i })), h;
}), XP = Oe(function(t) {
  const a = QP(t);
  return Ae(KP, a);
}), JP = "span";
function k8(e) {
  return Dy(e).toLowerCase();
}
function eV(e, t) {
  t = k8(t);
  let a = k8(e).indexOf(t);
  const i = [];
  for (; a !== -1; )
    a !== 0 && i.push(
      /* @__PURE__ */ f.jsx("span", { "data-autocomplete-value": "", children: e.substr(0, a) }, i.length)
    ), i.push(
      /* @__PURE__ */ f.jsx("span", { "data-user-value": "", children: e.substr(a, t.length) }, i.length)
    ), e = e.substr(a + t.length), a = k8(e).indexOf(t);
  return e && i.push(
    /* @__PURE__ */ f.jsx("span", { "data-autocomplete-value": "", children: e }, i.length)
  ), i;
}
var tV = ke(function(t) {
  var a = t, { store: i, value: h } = a, g = Fe(a, ["store", "value"]);
  const m = Ip();
  i = i || m;
  const C = Yo(_M), S = h ?? C;
  Zt(
    i,
    process.env.NODE_ENV !== "production" && "ComboboxItemValue must be wrapped in a ComboboxItem component."
  );
  const R = i.useState(
    (T) => S && T.value ? T.value : void 0
  ), D = Lr(
    () => S && R ? eV(S, R) : S,
    [S, R]
  );
  return g = G({
    children: D
  }, g), La(g);
}), nV = Oe(function(t) {
  const a = tV(t);
  return Ae(JP, a);
}), rV = "div";
function aV(e, t) {
  if (t != null)
    return e == null ? !1 : Array.isArray(e) ? e.includes(t) : e === t;
}
function oV(e) {
  var t;
  return (t = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  }[e]) != null ? t : "option";
}
var iV = ke(
  function(t) {
    var a = t, {
      store: i,
      value: h,
      hideOnClick: g,
      setValueOnClick: m,
      selectValueOnClick: C = !0,
      resetValueOnSelect: S,
      focusOnHover: R = !1,
      moveOnKeyPress: D = !0,
      getItem: T
    } = a, j = Fe(a, [
      "store",
      "value",
      "hideOnClick",
      "setValueOnClick",
      "selectValueOnClick",
      "resetValueOnSelect",
      "focusOnHover",
      "moveOnKeyPress",
      "getItem"
    ]), A;
    const L = Ip();
    i = i || L, Zt(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxItem must be wrapped in a ComboboxList or ComboboxPopover component."
    );
    const P = Ir(
      (fe) => {
        const xe = Te(G({}, fe), { value: h });
        return T ? T(xe) : xe;
      },
      [h, T]
    ), V = i.useState(
      (fe) => Array.isArray(fe.selectedValue)
    ), F = i.useState(
      (fe) => aV(fe.selectedValue, h)
    ), Y = i.useState("resetValueOnSelect");
    m = m ?? !V, g = g ?? (h != null && !V);
    const W = j.onClick, Q = er(m), $ = er(C), le = er(
      (A = S ?? Y) != null ? A : V
    ), te = er(g), Se = rt((fe) => {
      W == null || W(fe), !fe.defaultPrevented && (Py(fe) || Zy(fe) || (h != null && ($(fe) && (le(fe) && (i == null || i.resetValue()), i == null || i.setSelectedValue((xe) => Array.isArray(xe) ? xe.includes(h) ? xe.filter((Le) => Le !== h) : [...xe, h] : h)), Q(fe) && (i == null || i.setValue(h))), te(fe) && (i == null || i.hide())));
    }), re = j.onKeyDown, ve = rt((fe) => {
      if (re == null || re(fe), fe.defaultPrevented)
        return;
      const xe = i == null ? void 0 : i.getState().baseElement;
      if (!xe || H2(xe))
        return;
      (fe.key.length === 1 || fe.key === "Backspace" || fe.key === "Delete") && (queueMicrotask(() => xe.focus()), bl(xe) && (i == null || i.setValue(xe.value)));
    });
    V && F != null && (j = G({
      "aria-selected": F
    }, j)), j = Vn(
      j,
      (fe) => /* @__PURE__ */ f.jsx(_M.Provider, { value: h, children: /* @__PURE__ */ f.jsx(RM.Provider, { value: F ?? !1, children: fe }) }),
      [h, F]
    );
    const K = Yo(bM);
    j = Te(G({
      role: oV(K),
      children: h
    }, j), {
      onClick: Se,
      onKeyDown: ve
    });
    const de = er(D);
    return j = F2(Te(G({
      store: i
    }, j), {
      getItem: P,
      // Dispatch a custom event on the combobox input when moving to an item
      // with the keyboard so the Combobox component can enable inline
      // autocompletion.
      moveOnKeyPress: (fe) => {
        if (!de(fe))
          return !1;
        const xe = new Event("combobox-item-move"), Le = i == null ? void 0 : i.getState().baseElement;
        return Le == null || Le.dispatchEvent(xe), !0;
      }
    })), j = tw(G({ store: i, focusOnHover: R }, j)), j;
  }
), Z4 = Ha(
  Oe(function(t) {
    const a = iV(t);
    return Ae(rV, a);
  })
), lV = "label", uV = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = _h();
    i = i || g, Zt(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxLabel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const m = i.useState((C) => {
      var S;
      return (S = C.baseElement) == null ? void 0 : S.id;
    });
    return h = G({
      htmlFor: m
    }, h), La(h);
  }
), sV = Ha(
  Oe(function(t) {
    const a = uV(t);
    return Ae(lV, a);
  })
), cV = "div", OM = ke(
  function(t) {
    var a = t, { store: i, alwaysVisible: h } = a, g = Fe(a, ["store", "alwaysVisible"]);
    const m = Ip(!0), C = fx();
    i = i || C;
    const S = !!i && i === m;
    Zt(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxList must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const R = Pt(null), D = Ia(g.id), T = i.useState("mounted"), j = q4(T, g.hidden, h), A = j ? Te(G({}, g.style), { display: "none" }) : g.style, L = i.useState(
      (le) => Array.isArray(le.selectedValue)
    ), P = yE(R, "role", g.role), F = (P === "listbox" || P === "tree" || P === "grid") && L || void 0, [Y, W] = Qt(!1), Q = i.useState("contentElement");
    jn(() => {
      if (!T)
        return;
      const le = R.current;
      if (!le || Q !== le)
        return;
      const te = () => {
        W(!!le.querySelector("[role='listbox']"));
      }, Se = new MutationObserver(te);
      return Se.observe(le, {
        subtree: !0,
        childList: !0,
        attributeFilter: ["role"]
      }), te(), () => Se.disconnect();
    }, [T, Q]), Y || (g = G({
      role: "listbox",
      "aria-multiselectable": F
    }, g)), g = Vn(
      g,
      (le) => /* @__PURE__ */ f.jsx(DP, { value: i, children: /* @__PURE__ */ f.jsx(bM.Provider, { value: P, children: le }) }),
      [i, P]
    );
    const $ = D && (!m || !S) ? i.setContentElement : null;
    return g = Te(G({
      id: D,
      hidden: j
    }, g), {
      ref: An($, R, g.ref),
      style: A
    }), La(g);
  }
), hx = Oe(function(t) {
  const a = OM(t);
  return Ae(cV, a);
});
const j0 = Math.min, ku = Math.max, E5 = Math.round, i5 = Math.floor, ch = (e) => ({
  x: e,
  y: e
}), fV = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, dV = {
  start: "end",
  end: "start"
};
function sy(e, t, a) {
  return ku(e, j0(t, a));
}
function fh(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function vf(e) {
  return e.split("-")[0];
}
function Hp(e) {
  return e.split("-")[1];
}
function vx(e) {
  return e === "x" ? "y" : "x";
}
function px(e) {
  return e === "y" ? "height" : "width";
}
function dh(e) {
  return ["top", "bottom"].includes(vf(e)) ? "y" : "x";
}
function mx(e) {
  return vx(dh(e));
}
function hV(e, t, a) {
  a === void 0 && (a = !1);
  const i = Hp(e), h = mx(e), g = px(h);
  let m = h === "x" ? i === (a ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return t.reference[g] > t.floating[g] && (m = M5(m)), [m, M5(m)];
}
function vV(e) {
  const t = M5(e);
  return [cy(e), t, cy(t)];
}
function cy(e) {
  return e.replace(/start|end/g, (t) => dV[t]);
}
function pV(e, t, a) {
  const i = ["left", "right"], h = ["right", "left"], g = ["top", "bottom"], m = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? h : i : t ? i : h;
    case "left":
    case "right":
      return t ? g : m;
    default:
      return [];
  }
}
function mV(e, t, a, i) {
  const h = Hp(e);
  let g = pV(vf(e), a === "start", i);
  return h && (g = g.map((m) => m + "-" + h), t && (g = g.concat(g.map(cy)))), g;
}
function M5(e) {
  return e.replace(/left|right|bottom|top/g, (t) => fV[t]);
}
function gV(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function DM(e) {
  return typeof e != "number" ? gV(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function T5(e) {
  const {
    x: t,
    y: a,
    width: i,
    height: h
  } = e;
  return {
    width: i,
    height: h,
    top: a,
    left: t,
    right: t + i,
    bottom: a + h,
    x: t,
    y: a
  };
}
function J_(e, t, a) {
  let {
    reference: i,
    floating: h
  } = e;
  const g = dh(t), m = mx(t), C = px(m), S = vf(t), R = g === "y", D = i.x + i.width / 2 - h.width / 2, T = i.y + i.height / 2 - h.height / 2, j = i[C] / 2 - h[C] / 2;
  let A;
  switch (S) {
    case "top":
      A = {
        x: D,
        y: i.y - h.height
      };
      break;
    case "bottom":
      A = {
        x: D,
        y: i.y + i.height
      };
      break;
    case "right":
      A = {
        x: i.x + i.width,
        y: T
      };
      break;
    case "left":
      A = {
        x: i.x - h.width,
        y: T
      };
      break;
    default:
      A = {
        x: i.x,
        y: i.y
      };
  }
  switch (Hp(t)) {
    case "start":
      A[m] -= j * (a && R ? -1 : 1);
      break;
    case "end":
      A[m] += j * (a && R ? -1 : 1);
      break;
  }
  return A;
}
const wV = async (e, t, a) => {
  const {
    placement: i = "bottom",
    strategy: h = "absolute",
    middleware: g = [],
    platform: m
  } = a, C = g.filter(Boolean), S = await (m.isRTL == null ? void 0 : m.isRTL(t));
  let R = await m.getElementRects({
    reference: e,
    floating: t,
    strategy: h
  }), {
    x: D,
    y: T
  } = J_(R, i, S), j = i, A = {}, L = 0;
  for (let P = 0; P < C.length; P++) {
    const {
      name: V,
      fn: F
    } = C[P], {
      x: Y,
      y: W,
      data: Q,
      reset: $
    } = await F({
      x: D,
      y: T,
      initialPlacement: i,
      placement: j,
      strategy: h,
      middlewareData: A,
      rects: R,
      platform: m,
      elements: {
        reference: e,
        floating: t
      }
    });
    D = Y ?? D, T = W ?? T, A = {
      ...A,
      [V]: {
        ...A[V],
        ...Q
      }
    }, $ && L <= 50 && (L++, typeof $ == "object" && ($.placement && (j = $.placement), $.rects && (R = $.rects === !0 ? await m.getElementRects({
      reference: e,
      floating: t,
      strategy: h
    }) : $.rects), {
      x: D,
      y: T
    } = J_(R, j, S)), P = -1);
  }
  return {
    x: D,
    y: T,
    placement: j,
    strategy: h,
    middlewareData: A
  };
};
async function gx(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: i,
    y: h,
    platform: g,
    rects: m,
    elements: C,
    strategy: S
  } = e, {
    boundary: R = "clippingAncestors",
    rootBoundary: D = "viewport",
    elementContext: T = "floating",
    altBoundary: j = !1,
    padding: A = 0
  } = fh(t, e), L = DM(A), V = C[j ? T === "floating" ? "reference" : "floating" : T], F = T5(await g.getClippingRect({
    element: (a = await (g.isElement == null ? void 0 : g.isElement(V))) == null || a ? V : V.contextElement || await (g.getDocumentElement == null ? void 0 : g.getDocumentElement(C.floating)),
    boundary: R,
    rootBoundary: D,
    strategy: S
  })), Y = T === "floating" ? {
    x: i,
    y: h,
    width: m.floating.width,
    height: m.floating.height
  } : m.reference, W = await (g.getOffsetParent == null ? void 0 : g.getOffsetParent(C.floating)), Q = await (g.isElement == null ? void 0 : g.isElement(W)) ? await (g.getScale == null ? void 0 : g.getScale(W)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = T5(g.convertOffsetParentRelativeRectToViewportRelativeRect ? await g.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: C,
    rect: Y,
    offsetParent: W,
    strategy: S
  }) : Y);
  return {
    top: (F.top - $.top + L.top) / Q.y,
    bottom: ($.bottom - F.bottom + L.bottom) / Q.y,
    left: (F.left - $.left + L.left) / Q.x,
    right: ($.right - F.right + L.right) / Q.x
  };
}
const yV = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: a,
      y: i,
      placement: h,
      rects: g,
      platform: m,
      elements: C,
      middlewareData: S
    } = t, {
      element: R,
      padding: D = 0
    } = fh(e, t) || {};
    if (R == null)
      return {};
    const T = DM(D), j = {
      x: a,
      y: i
    }, A = mx(h), L = px(A), P = await m.getDimensions(R), V = A === "y", F = V ? "top" : "left", Y = V ? "bottom" : "right", W = V ? "clientHeight" : "clientWidth", Q = g.reference[L] + g.reference[A] - j[A] - g.floating[L], $ = j[A] - g.reference[A], le = await (m.getOffsetParent == null ? void 0 : m.getOffsetParent(R));
    let te = le ? le[W] : 0;
    (!te || !await (m.isElement == null ? void 0 : m.isElement(le))) && (te = C.floating[W] || g.floating[L]);
    const Se = Q / 2 - $ / 2, re = te / 2 - P[L] / 2 - 1, ve = j0(T[F], re), K = j0(T[Y], re), de = ve, fe = te - P[L] - K, xe = te / 2 - P[L] / 2 + Se, Le = sy(de, xe, fe), be = !S.arrow && Hp(h) != null && xe !== Le && g.reference[L] / 2 - (xe < de ? ve : K) - P[L] / 2 < 0, Ue = be ? xe < de ? xe - de : xe - fe : 0;
    return {
      [A]: j[A] + Ue,
      data: {
        [A]: Le,
        centerOffset: xe - Le - Ue,
        ...be && {
          alignmentOffset: Ue
        }
      },
      reset: be
    };
  }
}), xV = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, i;
      const {
        placement: h,
        middlewareData: g,
        rects: m,
        initialPlacement: C,
        platform: S,
        elements: R
      } = t, {
        mainAxis: D = !0,
        crossAxis: T = !0,
        fallbackPlacements: j,
        fallbackStrategy: A = "bestFit",
        fallbackAxisSideDirection: L = "none",
        flipAlignment: P = !0,
        ...V
      } = fh(e, t);
      if ((a = g.arrow) != null && a.alignmentOffset)
        return {};
      const F = vf(h), Y = dh(C), W = vf(C) === C, Q = await (S.isRTL == null ? void 0 : S.isRTL(R.floating)), $ = j || (W || !P ? [M5(C)] : vV(C)), le = L !== "none";
      !j && le && $.push(...mV(C, P, L, Q));
      const te = [C, ...$], Se = await gx(t, V), re = [];
      let ve = ((i = g.flip) == null ? void 0 : i.overflows) || [];
      if (D && re.push(Se[F]), T) {
        const xe = hV(h, m, Q);
        re.push(Se[xe[0]], Se[xe[1]]);
      }
      if (ve = [...ve, {
        placement: h,
        overflows: re
      }], !re.every((xe) => xe <= 0)) {
        var K, de;
        const xe = (((K = g.flip) == null ? void 0 : K.index) || 0) + 1, Le = te[xe];
        if (Le)
          return {
            data: {
              index: xe,
              overflows: ve
            },
            reset: {
              placement: Le
            }
          };
        let be = (de = ve.filter((Ue) => Ue.overflows[0] <= 0).sort((Ue, ie) => Ue.overflows[1] - ie.overflows[1])[0]) == null ? void 0 : de.placement;
        if (!be)
          switch (A) {
            case "bestFit": {
              var fe;
              const Ue = (fe = ve.filter((ie) => {
                if (le) {
                  const _e = dh(ie.placement);
                  return _e === Y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  _e === "y";
                }
                return !0;
              }).map((ie) => [ie.placement, ie.overflows.filter((_e) => _e > 0).reduce((_e, Ze) => _e + Ze, 0)]).sort((ie, _e) => ie[1] - _e[1])[0]) == null ? void 0 : fe[0];
              Ue && (be = Ue);
              break;
            }
            case "initialPlacement":
              be = C;
              break;
          }
        if (h !== be)
          return {
            reset: {
              placement: be
            }
          };
      }
      return {};
    }
  };
};
async function SV(e, t) {
  const {
    placement: a,
    platform: i,
    elements: h
  } = e, g = await (i.isRTL == null ? void 0 : i.isRTL(h.floating)), m = vf(a), C = Hp(a), S = dh(a) === "y", R = ["left", "top"].includes(m) ? -1 : 1, D = g && S ? -1 : 1, T = fh(t, e);
  let {
    mainAxis: j,
    crossAxis: A,
    alignmentAxis: L
  } = typeof T == "number" ? {
    mainAxis: T,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...T
  };
  return C && typeof L == "number" && (A = C === "end" ? L * -1 : L), S ? {
    x: A * D,
    y: j * R
  } : {
    x: j * R,
    y: A * D
  };
}
const CV = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var a, i;
      const {
        x: h,
        y: g,
        placement: m,
        middlewareData: C
      } = t, S = await SV(t, e);
      return m === ((a = C.offset) == null ? void 0 : a.placement) && (i = C.arrow) != null && i.alignmentOffset ? {} : {
        x: h + S.x,
        y: g + S.y,
        data: {
          ...S,
          placement: m
        }
      };
    }
  };
}, bV = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: a,
        y: i,
        placement: h
      } = t, {
        mainAxis: g = !0,
        crossAxis: m = !1,
        limiter: C = {
          fn: (V) => {
            let {
              x: F,
              y: Y
            } = V;
            return {
              x: F,
              y: Y
            };
          }
        },
        ...S
      } = fh(e, t), R = {
        x: a,
        y: i
      }, D = await gx(t, S), T = dh(vf(h)), j = vx(T);
      let A = R[j], L = R[T];
      if (g) {
        const V = j === "y" ? "top" : "left", F = j === "y" ? "bottom" : "right", Y = A + D[V], W = A - D[F];
        A = sy(Y, A, W);
      }
      if (m) {
        const V = T === "y" ? "top" : "left", F = T === "y" ? "bottom" : "right", Y = L + D[V], W = L - D[F];
        L = sy(Y, L, W);
      }
      const P = C.fn({
        ...t,
        [j]: A,
        [T]: L
      });
      return {
        ...P,
        data: {
          x: P.x - a,
          y: P.y - i
        }
      };
    }
  };
}, _V = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: a,
        y: i,
        placement: h,
        rects: g,
        middlewareData: m
      } = t, {
        offset: C = 0,
        mainAxis: S = !0,
        crossAxis: R = !0
      } = fh(e, t), D = {
        x: a,
        y: i
      }, T = dh(h), j = vx(T);
      let A = D[j], L = D[T];
      const P = fh(C, t), V = typeof P == "number" ? {
        mainAxis: P,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...P
      };
      if (S) {
        const W = j === "y" ? "height" : "width", Q = g.reference[j] - g.floating[W] + V.mainAxis, $ = g.reference[j] + g.reference[W] - V.mainAxis;
        A < Q ? A = Q : A > $ && (A = $);
      }
      if (R) {
        var F, Y;
        const W = j === "y" ? "width" : "height", Q = ["top", "left"].includes(vf(h)), $ = g.reference[T] - g.floating[W] + (Q && ((F = m.offset) == null ? void 0 : F[T]) || 0) + (Q ? 0 : V.crossAxis), le = g.reference[T] + g.reference[W] + (Q ? 0 : ((Y = m.offset) == null ? void 0 : Y[T]) || 0) - (Q ? V.crossAxis : 0);
        L < $ ? L = $ : L > le && (L = le);
      }
      return {
        [j]: A,
        [T]: L
      };
    }
  };
}, RV = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: a,
        rects: i,
        platform: h,
        elements: g
      } = t, {
        apply: m = () => {
        },
        ...C
      } = fh(e, t), S = await gx(t, C), R = vf(a), D = Hp(a), T = dh(a) === "y", {
        width: j,
        height: A
      } = i.floating;
      let L, P;
      R === "top" || R === "bottom" ? (L = R, P = D === (await (h.isRTL == null ? void 0 : h.isRTL(g.floating)) ? "start" : "end") ? "left" : "right") : (P = R, L = D === "end" ? "top" : "bottom");
      const V = A - S.top - S.bottom, F = j - S.left - S.right, Y = j0(A - S[L], V), W = j0(j - S[P], F), Q = !t.middlewareData.shift;
      let $ = Y, le = W;
      if (T ? le = D || Q ? j0(W, F) : F : $ = D || Q ? j0(Y, V) : V, Q && !D) {
        const Se = ku(S.left, 0), re = ku(S.right, 0), ve = ku(S.top, 0), K = ku(S.bottom, 0);
        T ? le = j - 2 * (Se !== 0 || re !== 0 ? Se + re : ku(S.left, S.right)) : $ = A - 2 * (ve !== 0 || K !== 0 ? ve + K : ku(S.top, S.bottom));
      }
      await m({
        ...t,
        availableWidth: le,
        availableHeight: $
      });
      const te = await h.getDimensions(g.floating);
      return j !== te.width || A !== te.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function hh(e) {
  return jM(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Iu(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function wf(e) {
  var t;
  return (t = (jM(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function jM(e) {
  return e instanceof Node || e instanceof Iu(e).Node;
}
function I0(e) {
  return e instanceof Element || e instanceof Iu(e).Element;
}
function H0(e) {
  return e instanceof HTMLElement || e instanceof Iu(e).HTMLElement;
}
function eR(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Iu(e).ShadowRoot;
}
function r3(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: i,
    display: h
  } = Ms(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + i + a) && !["inline", "contents"].includes(h);
}
function EV(e) {
  return ["table", "td", "th"].includes(hh(e));
}
function MV(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function wx(e) {
  const t = yx(), a = I0(e) ? Ms(e) : e;
  return a.transform !== "none" || a.perspective !== "none" || (a.containerType ? a.containerType !== "normal" : !1) || !t && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !t && (a.filter ? a.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (a.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (a.contain || "").includes(i));
}
function TV(e) {
  let t = Dp(e);
  for (; H0(t) && !lw(t); ) {
    if (wx(t))
      return t;
    if (MV(t))
      return null;
    t = Dp(t);
  }
  return null;
}
function yx() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function lw(e) {
  return ["html", "body", "#document"].includes(hh(e));
}
function Ms(e) {
  return Iu(e).getComputedStyle(e);
}
function uw(e) {
  return I0(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Dp(e) {
  if (hh(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    eR(e) && e.host || // Fallback.
    wf(e)
  );
  return eR(t) ? t.host : t;
}
function AM(e) {
  const t = Dp(e);
  return lw(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : H0(t) && r3(t) ? t : AM(t);
}
function P4(e, t, a) {
  var i;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const h = AM(e), g = h === ((i = e.ownerDocument) == null ? void 0 : i.body), m = Iu(h);
  if (g) {
    const C = OV(m);
    return t.concat(m, m.visualViewport || [], r3(h) ? h : [], C && a ? P4(C) : []);
  }
  return t.concat(h, P4(h, [], a));
}
function OV(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function kM(e) {
  const t = Ms(e);
  let a = parseFloat(t.width) || 0, i = parseFloat(t.height) || 0;
  const h = H0(e), g = h ? e.offsetWidth : a, m = h ? e.offsetHeight : i, C = E5(a) !== g || E5(i) !== m;
  return C && (a = g, i = m), {
    width: a,
    height: i,
    $: C
  };
}
function xx(e) {
  return I0(e) ? e : e.contextElement;
}
function bp(e) {
  const t = xx(e);
  if (!H0(t))
    return ch(1);
  const a = t.getBoundingClientRect(), {
    width: i,
    height: h,
    $: g
  } = kM(t);
  let m = (g ? E5(a.width) : a.width) / i, C = (g ? E5(a.height) : a.height) / h;
  return (!m || !Number.isFinite(m)) && (m = 1), (!C || !Number.isFinite(C)) && (C = 1), {
    x: m,
    y: C
  };
}
const DV = /* @__PURE__ */ ch(0);
function LM(e) {
  const t = Iu(e);
  return !yx() || !t.visualViewport ? DV : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function jV(e, t, a) {
  return t === void 0 && (t = !1), !a || t && a !== Iu(e) ? !1 : t;
}
function P2(e, t, a, i) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const h = e.getBoundingClientRect(), g = xx(e);
  let m = ch(1);
  t && (i ? I0(i) && (m = bp(i)) : m = bp(e));
  const C = jV(g, a, i) ? LM(g) : ch(0);
  let S = (h.left + C.x) / m.x, R = (h.top + C.y) / m.y, D = h.width / m.x, T = h.height / m.y;
  if (g) {
    const j = Iu(g), A = i && I0(i) ? Iu(i) : i;
    let L = j, P = L.frameElement;
    for (; P && i && A !== L; ) {
      const V = bp(P), F = P.getBoundingClientRect(), Y = Ms(P), W = F.left + (P.clientLeft + parseFloat(Y.paddingLeft)) * V.x, Q = F.top + (P.clientTop + parseFloat(Y.paddingTop)) * V.y;
      S *= V.x, R *= V.y, D *= V.x, T *= V.y, S += W, R += Q, L = Iu(P), P = L.frameElement;
    }
  }
  return T5({
    width: D,
    height: T,
    x: S,
    y: R
  });
}
const AV = [":popover-open", ":modal"];
function IM(e) {
  return AV.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function kV(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: i,
    strategy: h
  } = e;
  const g = h === "fixed", m = wf(i), C = t ? IM(t.floating) : !1;
  if (i === m || C && g)
    return a;
  let S = {
    scrollLeft: 0,
    scrollTop: 0
  }, R = ch(1);
  const D = ch(0), T = H0(i);
  if ((T || !T && !g) && ((hh(i) !== "body" || r3(m)) && (S = uw(i)), H0(i))) {
    const j = P2(i);
    R = bp(i), D.x = j.x + i.clientLeft, D.y = j.y + i.clientTop;
  }
  return {
    width: a.width * R.x,
    height: a.height * R.y,
    x: a.x * R.x - S.scrollLeft * R.x + D.x,
    y: a.y * R.y - S.scrollTop * R.y + D.y
  };
}
function LV(e) {
  return Array.from(e.getClientRects());
}
function HM(e) {
  return P2(wf(e)).left + uw(e).scrollLeft;
}
function IV(e) {
  const t = wf(e), a = uw(e), i = e.ownerDocument.body, h = ku(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth), g = ku(t.scrollHeight, t.clientHeight, i.scrollHeight, i.clientHeight);
  let m = -a.scrollLeft + HM(e);
  const C = -a.scrollTop;
  return Ms(i).direction === "rtl" && (m += ku(t.clientWidth, i.clientWidth) - h), {
    width: h,
    height: g,
    x: m,
    y: C
  };
}
function HV(e, t) {
  const a = Iu(e), i = wf(e), h = a.visualViewport;
  let g = i.clientWidth, m = i.clientHeight, C = 0, S = 0;
  if (h) {
    g = h.width, m = h.height;
    const R = yx();
    (!R || R && t === "fixed") && (C = h.offsetLeft, S = h.offsetTop);
  }
  return {
    width: g,
    height: m,
    x: C,
    y: S
  };
}
function ZV(e, t) {
  const a = P2(e, !0, t === "fixed"), i = a.top + e.clientTop, h = a.left + e.clientLeft, g = H0(e) ? bp(e) : ch(1), m = e.clientWidth * g.x, C = e.clientHeight * g.y, S = h * g.x, R = i * g.y;
  return {
    width: m,
    height: C,
    x: S,
    y: R
  };
}
function tR(e, t, a) {
  let i;
  if (t === "viewport")
    i = HV(e, a);
  else if (t === "document")
    i = IV(wf(e));
  else if (I0(t))
    i = ZV(t, a);
  else {
    const h = LM(e);
    i = {
      ...t,
      x: t.x - h.x,
      y: t.y - h.y
    };
  }
  return T5(i);
}
function ZM(e, t) {
  const a = Dp(e);
  return a === t || !I0(a) || lw(a) ? !1 : Ms(a).position === "fixed" || ZM(a, t);
}
function PV(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let i = P4(e, [], !1).filter((C) => I0(C) && hh(C) !== "body"), h = null;
  const g = Ms(e).position === "fixed";
  let m = g ? Dp(e) : e;
  for (; I0(m) && !lw(m); ) {
    const C = Ms(m), S = wx(m);
    !S && C.position === "fixed" && (h = null), (g ? !S && !h : !S && C.position === "static" && !!h && ["absolute", "fixed"].includes(h.position) || r3(m) && !S && ZM(e, m)) ? i = i.filter((D) => D !== m) : h = C, m = Dp(m);
  }
  return t.set(e, i), i;
}
function VV(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: i,
    strategy: h
  } = e;
  const m = [...a === "clippingAncestors" ? PV(t, this._c) : [].concat(a), i], C = m[0], S = m.reduce((R, D) => {
    const T = tR(t, D, h);
    return R.top = ku(T.top, R.top), R.right = j0(T.right, R.right), R.bottom = j0(T.bottom, R.bottom), R.left = ku(T.left, R.left), R;
  }, tR(t, C, h));
  return {
    width: S.right - S.left,
    height: S.bottom - S.top,
    x: S.left,
    y: S.top
  };
}
function NV(e) {
  const {
    width: t,
    height: a
  } = kM(e);
  return {
    width: t,
    height: a
  };
}
function BV(e, t, a) {
  const i = H0(t), h = wf(t), g = a === "fixed", m = P2(e, !0, g, t);
  let C = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const S = ch(0);
  if (i || !i && !g)
    if ((hh(t) !== "body" || r3(h)) && (C = uw(t)), i) {
      const T = P2(t, !0, g, t);
      S.x = T.x + t.clientLeft, S.y = T.y + t.clientTop;
    } else h && (S.x = HM(h));
  const R = m.left + C.scrollLeft - S.x, D = m.top + C.scrollTop - S.y;
  return {
    x: R,
    y: D,
    width: m.width,
    height: m.height
  };
}
function nR(e, t) {
  return !H0(e) || Ms(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function PM(e, t) {
  const a = Iu(e);
  if (!H0(e) || IM(e))
    return a;
  let i = nR(e, t);
  for (; i && EV(i) && Ms(i).position === "static"; )
    i = nR(i, t);
  return i && (hh(i) === "html" || hh(i) === "body" && Ms(i).position === "static" && !wx(i)) ? a : i || TV(e) || a;
}
const FV = async function(e) {
  const t = this.getOffsetParent || PM, a = this.getDimensions;
  return {
    reference: BV(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await a(e.floating)
    }
  };
};
function UV(e) {
  return Ms(e).direction === "rtl";
}
const YV = {
  convertOffsetParentRelativeRectToViewportRelativeRect: kV,
  getDocumentElement: wf,
  getClippingRect: VV,
  getOffsetParent: PM,
  getElementRects: FV,
  getClientRects: LV,
  getDimensions: NV,
  getScale: bp,
  isElement: I0,
  isRTL: UV
};
function $V(e, t) {
  let a = null, i;
  const h = wf(e);
  function g() {
    var C;
    clearTimeout(i), (C = a) == null || C.disconnect(), a = null;
  }
  function m(C, S) {
    C === void 0 && (C = !1), S === void 0 && (S = 1), g();
    const {
      left: R,
      top: D,
      width: T,
      height: j
    } = e.getBoundingClientRect();
    if (C || t(), !T || !j)
      return;
    const A = i5(D), L = i5(h.clientWidth - (R + T)), P = i5(h.clientHeight - (D + j)), V = i5(R), Y = {
      rootMargin: -A + "px " + -L + "px " + -P + "px " + -V + "px",
      threshold: ku(0, j0(1, S)) || 1
    };
    let W = !0;
    function Q($) {
      const le = $[0].intersectionRatio;
      if (le !== S) {
        if (!W)
          return m();
        le ? m(!1, le) : i = setTimeout(() => {
          m(!1, 1e-7);
        }, 100);
      }
      W = !1;
    }
    try {
      a = new IntersectionObserver(Q, {
        ...Y,
        // Handle <iframe>s
        root: h.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(Q, Y);
    }
    a.observe(e);
  }
  return m(!0), g;
}
function WV(e, t, a, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: h = !0,
    ancestorResize: g = !0,
    elementResize: m = typeof ResizeObserver == "function",
    layoutShift: C = typeof IntersectionObserver == "function",
    animationFrame: S = !1
  } = i, R = xx(e), D = h || g ? [...R ? P4(R) : [], ...P4(t)] : [];
  D.forEach((F) => {
    h && F.addEventListener("scroll", a, {
      passive: !0
    }), g && F.addEventListener("resize", a);
  });
  const T = R && C ? $V(R, a) : null;
  let j = -1, A = null;
  m && (A = new ResizeObserver((F) => {
    let [Y] = F;
    Y && Y.target === R && A && (A.unobserve(t), cancelAnimationFrame(j), j = requestAnimationFrame(() => {
      var W;
      (W = A) == null || W.observe(t);
    })), a();
  }), R && !S && A.observe(R), A.observe(t));
  let L, P = S ? P2(e) : null;
  S && V();
  function V() {
    const F = P2(e);
    P && (F.x !== P.x || F.y !== P.y || F.width !== P.width || F.height !== P.height) && a(), P = F, L = requestAnimationFrame(V);
  }
  return a(), () => {
    var F;
    D.forEach((Y) => {
      h && Y.removeEventListener("scroll", a), g && Y.removeEventListener("resize", a);
    }), T == null || T(), (F = A) == null || F.disconnect(), A = null, S && cancelAnimationFrame(L);
  };
}
const zV = bV, qV = xV, GV = RV, KV = yV, QV = _V, XV = (e, t, a) => {
  const i = /* @__PURE__ */ new Map(), h = {
    platform: YV,
    ...a
  }, g = {
    ...h.platform,
    _c: i
  };
  return wV(e, t, {
    ...h,
    platform: g
  });
};
var JV = "div";
function rR(e = 0, t = 0, a = 0, i = 0) {
  if (typeof DOMRect == "function")
    return new DOMRect(e, t, a, i);
  const h = {
    x: e,
    y: t,
    width: a,
    height: i,
    top: t,
    right: e + a,
    bottom: t + i,
    left: e
  };
  return Te(G({}, h), { toJSON: () => h });
}
function eN(e) {
  if (!e)
    return rR();
  const { x: t, y: a, width: i, height: h } = e;
  return rR(t, a, i, h);
}
function tN(e, t) {
  return {
    contextElement: e || void 0,
    getBoundingClientRect: () => {
      const i = e, h = t == null ? void 0 : t(i);
      return h || !i ? eN(h) : i.getBoundingClientRect();
    }
  };
}
function nN(e) {
  return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(e);
}
function aR(e) {
  const t = window.devicePixelRatio || 1;
  return Math.round(e * t) / t;
}
function rN(e, t) {
  return CV(({ placement: a }) => {
    var i;
    const h = ((e == null ? void 0 : e.clientHeight) || 0) / 2, g = typeof t.gutter == "number" ? t.gutter + h : (i = t.gutter) != null ? i : h;
    return {
      crossAxis: !!a.split("-")[1] ? void 0 : t.shift,
      mainAxis: g,
      alignmentAxis: t.shift
    };
  });
}
function aN(e) {
  if (e.flip === !1)
    return;
  const t = typeof e.flip == "string" ? e.flip.split(" ") : void 0;
  return Zt(
    !t || t.every(nN),
    process.env.NODE_ENV !== "production" && "`flip` expects a spaced-delimited list of placements"
  ), qV({
    padding: e.overflowPadding,
    fallbackPlacements: t
  });
}
function oN(e) {
  if (!(!e.slide && !e.overlap))
    return zV({
      mainAxis: e.slide,
      crossAxis: e.overlap,
      padding: e.overflowPadding,
      limiter: QV()
    });
}
function iN(e) {
  return GV({
    padding: e.overflowPadding,
    apply({ elements: t, availableWidth: a, availableHeight: i, rects: h }) {
      const g = t.floating, m = Math.round(h.reference.width);
      a = Math.floor(a), i = Math.floor(i), g.style.setProperty(
        "--popover-anchor-width",
        `${m}px`
      ), g.style.setProperty(
        "--popover-available-width",
        `${a}px`
      ), g.style.setProperty(
        "--popover-available-height",
        `${i}px`
      ), e.sameWidth && (g.style.width = `${m}px`), e.fitViewport && (g.style.maxWidth = `${a}px`, g.style.maxHeight = `${i}px`);
    }
  });
}
function lN(e, t) {
  if (e)
    return KV({
      element: e,
      padding: t.arrowPadding
    });
}
var sw = ke(
  function(t) {
    var a = t, {
      store: i,
      modal: h = !1,
      portal: g = !!h,
      preserveTabOrder: m = !0,
      autoFocusOnShow: C = !0,
      wrapperProps: S,
      fixed: R = !1,
      flip: D = !0,
      shift: T = 0,
      slide: j = !0,
      overlap: A = !1,
      sameWidth: L = !1,
      fitViewport: P = !1,
      gutter: V,
      arrowPadding: F = 4,
      overflowPadding: Y = 8,
      getAnchorRect: W,
      updatePosition: Q
    } = a, $ = Fe(a, [
      "store",
      "modal",
      "portal",
      "preserveTabOrder",
      "autoFocusOnShow",
      "wrapperProps",
      "fixed",
      "flip",
      "shift",
      "slide",
      "overlap",
      "sameWidth",
      "fitViewport",
      "gutter",
      "arrowPadding",
      "overflowPadding",
      "getAnchorRect",
      "updatePosition"
    ]);
    const le = aw();
    i = i || le, Zt(
      i,
      process.env.NODE_ENV !== "production" && "Popover must receive a `store` prop or be wrapped in a PopoverProvider component."
    );
    const te = i.useState("arrowElement"), Se = i.useState("anchorElement"), re = i.useState("disclosureElement"), ve = i.useState("popoverElement"), K = i.useState("contentElement"), de = i.useState("placement"), fe = i.useState("mounted"), xe = i.useState("rendered"), [Le, be] = Qt(!1), { portalRef: Ue, domReady: ie } = Ny(g, $.portalRef), _e = rt(W), Ze = rt(Q), mt = !!Q;
    jn(() => {
      if (!(ve != null && ve.isConnected))
        return;
      ve.style.setProperty(
        "--popover-overflow-padding",
        `${Y}px`
      );
      const Vt = tN(Se, _e), Dt = async () => {
        if (!fe)
          return;
        const wt = [
          rN(te, { gutter: V, shift: T }),
          aN({ flip: D, overflowPadding: Y }),
          oN({ slide: j, overlap: A, overflowPadding: Y }),
          lN(te, { arrowPadding: F }),
          iN({
            sameWidth: L,
            fitViewport: P,
            overflowPadding: Y
          })
        ], St = await XV(Vt, ve, {
          placement: de,
          strategy: R ? "fixed" : "absolute",
          middleware: wt
        });
        i == null || i.setState("currentPlacement", St.placement), be(!0);
        const _n = aR(St.x), Hr = aR(St.y);
        if (Object.assign(ve.style, {
          top: "0",
          left: "0",
          transform: `translate3d(${_n}px,${Hr}px,0)`
        }), te && St.middlewareData.arrow) {
          const { x: kn, y: Wn } = St.middlewareData.arrow, sr = St.placement.split("-")[0];
          Object.assign(te.style, {
            left: kn != null ? `${kn}px` : "",
            top: Wn != null ? `${Wn}px` : "",
            [sr]: "100%"
          });
        }
      }, et = WV(Vt, ve, async () => {
        mt ? (await Ze({ updatePosition: Dt }), be(!0)) : await Dt();
      }, {
        // JSDOM doesn't support ResizeObserver
        elementResize: typeof ResizeObserver == "function"
      });
      return () => {
        be(!1), et();
      };
    }, [
      i,
      xe,
      ve,
      te,
      Se,
      ve,
      de,
      fe,
      ie,
      R,
      D,
      T,
      j,
      A,
      L,
      P,
      V,
      F,
      Y,
      _e,
      mt,
      Ze
    ]), jn(() => {
      if (!fe || !ie || !(ve != null && ve.isConnected) || !(K != null && K.isConnected))
        return;
      const Vt = () => {
        ve.style.zIndex = getComputedStyle(K).zIndex;
      };
      Vt();
      let Dt = requestAnimationFrame(() => {
        Dt = requestAnimationFrame(Vt);
      });
      return () => cancelAnimationFrame(Dt);
    }, [fe, ie, ve, K]);
    const Pe = R ? "fixed" : "absolute";
    return $ = Vn(
      $,
      (Vt) => /* @__PURE__ */ f.jsx(
        "div",
        Te(G({}, S), {
          style: G({
            // https://floating-ui.com/docs/computeposition#initial-layout
            position: Pe,
            top: 0,
            left: 0,
            width: "max-content"
          }, S == null ? void 0 : S.style),
          ref: i == null ? void 0 : i.setPopoverElement,
          children: Vt
        })
      ),
      [i, Pe, S]
    ), $ = Vn(
      $,
      (Vt) => /* @__PURE__ */ f.jsx(t3, { value: i, children: Vt }),
      [i]
    ), $ = Te(G({
      // data-placing is not part of the public API. We're setting this here so
      // we can wait for the popover to be positioned before other components
      // move focus into it. For example, this attribute is observed by the
      // Combobox component with the autoSelect behavior.
      "data-placing": !Le || void 0
    }, $), {
      style: G({
        position: "relative"
      }, $.style)
    }), $ = hM(Te(G({
      store: i,
      modal: h,
      portal: g,
      preserveTabOrder: m,
      preserveTabOrderAnchor: re || Se,
      autoFocusOnShow: Le && C
    }, $), {
      portalRef: Ue
    })), $;
  }
), VM = U2(
  Oe(function(t) {
    const a = sw(t);
    return Ae(JV, a);
  }),
  aw
), uN = "div";
function sN(e, ...t) {
  if (!e)
    return !1;
  if ("id" in e) {
    const a = t.filter(Boolean).map((i) => `[aria-controls~="${i}"]`).join(", ");
    return a ? Ay(e, a) : !1;
  }
  return !1;
}
var cN = ke(
  function(t) {
    var a = t, {
      store: i,
      modal: h,
      alwaysVisible: g,
      autoFocusOnHide: m = !0,
      hideOnInteractOutside: C = !0
    } = a, S = Fe(a, [
      "store",
      "modal",
      "tabIndex",
      "alwaysVisible",
      "autoFocusOnHide",
      "hideOnInteractOutside"
    ]);
    const R = _h();
    i = i || R, Zt(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxPopover must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const D = i.useState("baseElement"), T = Pt(!1), j = ja(
      i.tag,
      (A) => A == null ? void 0 : A.renderedItems.length
    );
    return S = OM(G({ store: i, alwaysVisible: g }, S)), S = sw(Te(G({
      store: i,
      modal: h,
      alwaysVisible: g,
      backdrop: !1,
      autoFocusOnShow: !1,
      finalFocus: D,
      preserveTabOrderAnchor: null,
      unstable_treeSnapshotKey: j
    }, S), {
      // When the combobox popover is modal, we make sure to include the
      // combobox input and all the combobox controls (cancel, disclosure) in
      // the list of persistent elements so they make part of the modal context,
      // allowing users to tab through them.
      getPersistentElements() {
        var A;
        const L = ((A = S.getPersistentElements) == null ? void 0 : A.call(S)) || [];
        if (!h || !i)
          return L;
        const { contentElement: P, baseElement: V } = i.getState();
        if (!V)
          return L;
        const F = Qr(V), Y = [];
        if (P != null && P.id && Y.push(`[aria-controls~="${P.id}"]`), V != null && V.id && Y.push(`[aria-controls~="${V.id}"]`), !Y.length)
          return [...L, V];
        const W = Y.join(","), Q = F.querySelectorAll(W);
        return [...L, ...Q];
      },
      // The combobox popover should focus on the combobox input when it hides,
      // unless the event was triggered by a click outside the popover, in which
      // case the input shouldn't be re-focused.
      autoFocusOnHide(A) {
        return k2(m, A) ? !1 : T.current ? (T.current = !1, !1) : !0;
      },
      // Make sure we don't hide the popover when the user interacts with the
      // combobox cancel or the combobox disclosure buttons. They will have the
      // aria-controls attribute pointing to either the combobox input or the
      // combobox popover elements.
      hideOnInteractOutside(A) {
        var L, P;
        const V = i == null ? void 0 : i.getState(), F = (L = V == null ? void 0 : V.contentElement) == null ? void 0 : L.id, Y = (P = V == null ? void 0 : V.baseElement) == null ? void 0 : P.id;
        if (sN(A.target, F, Y))
          return !1;
        const W = typeof C == "function" ? C(A) : C;
        return W && (T.current = A.type === "click"), W;
      }
    })), S;
  }
), NM = U2(
  Oe(function(t) {
    const a = cN(t);
    return Ae(uN, a);
  }),
  _h
), fN = "div", dN = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = Ip();
    i = i || g, Zt(
      i,
      process.env.NODE_ENV !== "production" && "ComboboxRow must be wrapped in a ComboboxList or ComboboxPopover component"
    );
    const m = i.useState("contentElement"), S = vh(m) === "grid" ? "row" : "presentation";
    return h = G({ role: S }, h), h = sx(G({ store: i }, h)), h;
  }
), hN = Oe(function(t) {
  const a = dN(t);
  return Ae(fN, a);
}), vN = "hr", pN = ke(function(t) {
  var a = t, { store: i } = a, h = Fe(a, ["store"]);
  const g = Ip();
  return i = i || g, Zt(
    i,
    process.env.NODE_ENV !== "production" && "ComboboxSeparator must be wrapped in a ComboboxList or ComboboxPopover component."
  ), h = Q4(G({ store: i }, h)), h;
}), mN = Oe(function(t) {
  const a = pN(t);
  return Ae(vN, a);
});
function BM(e = {}) {
  const t = cx(e);
  return /* @__PURE__ */ f.jsx(ow, { value: t, children: e.children });
}
var oR = "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z", gN = "div", fy = 30, nh = fy / 2, wN = {
  top: `rotate(180 ${nh} ${nh})`,
  right: `rotate(-90 ${nh} ${nh})`,
  bottom: `rotate(0 ${nh} ${nh})`,
  left: `rotate(90 ${nh} ${nh})`
};
function yN(e) {
  const [t, a] = Qt(), i = e.useState("contentElement");
  return jn(() => {
    if (!i)
      return;
    const g = hE(i).getComputedStyle(i);
    a(g);
  }, [i]), t;
}
var cw = ke(
  function(t) {
    var a = t, { store: i, size: h = fy } = a, g = Fe(a, ["store", "size"]);
    const m = bh();
    i = i || m, Zt(
      i,
      process.env.NODE_ENV !== "production" && "PopoverArrow must be wrapped in a Popover component."
    );
    const C = i.useState(
      (P) => P.currentPlacement.split("-")[0]
    ), S = yN(i), R = (S == null ? void 0 : S.getPropertyValue("background-color")) || "none", D = (S == null ? void 0 : S.getPropertyValue(`border-${C}-color`)) || "none", T = (S == null ? void 0 : S.getPropertyValue(`border-${C}-width`)) || "0px", j = parseInt(T) * 2 * (fy / h), A = wN[C], L = Lr(
      () => /* @__PURE__ */ f.jsx("svg", { display: "block", viewBox: "0 0 30 30", children: /* @__PURE__ */ f.jsxs("g", { transform: A, children: [
        /* @__PURE__ */ f.jsx("path", { fill: "none", d: oR }),
        /* @__PURE__ */ f.jsx("path", { stroke: "none", d: oR })
      ] }) }),
      [A]
    );
    return g = Te(G({
      children: L,
      "aria-hidden": !0
    }, g), {
      ref: An(i.setArrowElement, g.ref),
      style: G({
        // server side rendering
        position: "absolute",
        fontSize: h,
        width: "1em",
        height: "1em",
        pointerEvents: "none",
        fill: R,
        stroke: D,
        strokeWidth: j
      }, g.style)
    }), La(g);
  }
), Zp = Oe(function(t) {
  const a = cw(t);
  return Ae(gN, a);
}), xN = "p", FM = ke(function(t) {
  return t = vM(t), t;
}), SN = Oe(function(t) {
  const a = FM(t);
  return Ae(xN, a);
}), CN = "span", bN = {
  top: "4,10 8,6 12,10",
  right: "6,4 10,8 6,12",
  bottom: "4,6 8,10 12,6",
  left: "10,4 6,8 10,12"
}, Sx = ke(function(t) {
  var a = t, { store: i, placement: h } = a, g = Fe(a, ["store", "placement"]);
  const m = bh();
  i = i || m, Zt(
    i,
    process.env.NODE_ENV !== "production" && "PopoverDisclosureArrow must be wrapped in a PopoverDisclosure component."
  );
  const S = i.useState((T) => h || T.placement).split("-")[0], R = bN[S], D = Lr(
    () => /* @__PURE__ */ f.jsx(
      "svg",
      {
        display: "block",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        children: /* @__PURE__ */ f.jsx("polyline", { points: R })
      }
    ),
    [R]
  );
  return g = Te(G({
    children: D,
    "aria-hidden": !0
  }, g), {
    style: G({
      width: "1em",
      height: "1em",
      pointerEvents: "none"
    }, g.style)
  }), La(g);
}), _N = Oe(
  function(t) {
    const a = Sx(t);
    return Ae(CN, a);
  }
), RN = "button", Cx = ke(function(t) {
  var a = t, { store: i } = a, h = Fe(a, ["store"]);
  const g = aw();
  i = i || g, Zt(
    i,
    process.env.NODE_ENV !== "production" && "PopoverDisclosure must receive a `store` prop or be wrapped in a PopoverProvider component."
  );
  const m = h.onClick, C = rt((S) => {
    i == null || i.setAnchorElement(S.currentTarget), m == null || m(S);
  });
  return h = Vn(
    h,
    (S) => /* @__PURE__ */ f.jsx(t3, { value: i, children: S }),
    [i]
  ), h = Te(G({}, h), {
    onClick: C
  }), h = dx(G({ store: i }, h)), h = X5(G({ store: i }, h)), h;
}), fw = Oe(function(t) {
  const a = Cx(t);
  return Ae(RN, a);
}), EN = "button", UM = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = TP();
    return i = i || g, h = pM(G({ store: i }, h)), h;
  }
), MN = Oe(function(t) {
  const a = UM(t);
  return Ae(EN, a);
}), TN = "h1", YM = ke(
  function(t) {
    return t = gM(t), t;
  }
), ON = Oe(function(t) {
  const a = YM(t);
  return Ae(TN, a);
}), a3 = _i(
  [P0],
  [yh]
), bx = a3.useContext, DN = a3.useScopedContext, jN = a3.useProviderContext, AN = a3.ContextProvider, kN = a3.ScopedContextProvider;
ka(
  void 0
);
function LN(e = {}) {
  var t;
  const a = (t = e.store) == null ? void 0 : t.getState(), i = xh(mn(_t({}, e), {
    orientation: st(
      e.orientation,
      a == null ? void 0 : a.orientation,
      "horizontal"
    ),
    focusLoop: st(e.focusLoop, a == null ? void 0 : a.focusLoop, !0)
  })), h = _t({}, i.getState()), g = fo(h, i, e.store);
  return _t(_t({}, i), g);
}
function IN(e, t, a) {
  return Sh(e, t, a);
}
function dw(e = {}) {
  const [t, a] = bi(LN, e);
  return IN(t, a, e);
}
var HN = "div", $M = ke(
  function(t) {
    var a = t, {
      store: i,
      composite: h = !0,
      orientation: g,
      virtualFocus: m,
      focusLoop: C,
      rtl: S
    } = a, R = Fe(a, [
      "store",
      "composite",
      "orientation",
      "virtualFocus",
      "focusLoop",
      "rtl"
    ]);
    const D = jN();
    i = i || D;
    const T = dw({
      store: i,
      orientation: g,
      virtualFocus: m,
      focusLoop: C,
      rtl: S
    }), j = T.useState(
      (A) => !h || A.orientation === "both" ? void 0 : A.orientation
    );
    return R = Vn(
      R,
      (A) => /* @__PURE__ */ f.jsx(kN, { value: T, children: A }),
      [T]
    ), h && (R = G({
      role: "menubar",
      "aria-orientation": j
    }, R)), R = Ch(G({ store: T, composite: h }, R)), R;
  }
), ZN = Oe(function(t) {
  const a = $M(t);
  return Ae(HN, a);
});
function WM(e = {}) {
  const t = dw(e);
  return /* @__PURE__ */ f.jsx(AN, { value: t, children: e.children });
}
var o3 = _i(
  [ow],
  [t3]
), zM = o3.useContext, PN = o3.useScopedContext, hw = o3.useProviderContext, _x = o3.ContextProvider, Rx = o3.ScopedContextProvider, i3 = _i(
  [P0, _x],
  [yh, Rx]
), yf = i3.useContext, vw = i3.useScopedContext, pw = i3.useProviderContext, qM = i3.ContextProvider, VN = i3.ScopedContextProvider, NN = bx, GM = ka(
  void 0
);
function Ex(e = {}) {
  var t;
  const a = (t = e.store) == null ? void 0 : t.getState(), i = nw(mn(_t({}, e), {
    placement: st(
      e.placement,
      a == null ? void 0 : a.placement,
      "bottom"
    )
  })), h = st(e.timeout, a == null ? void 0 : a.timeout, 500), g = mn(_t({}, i.getState()), {
    timeout: h,
    showTimeout: st(e.showTimeout, a == null ? void 0 : a.showTimeout),
    hideTimeout: st(e.hideTimeout, a == null ? void 0 : a.hideTimeout),
    autoFocusOnShow: st(a == null ? void 0 : a.autoFocusOnShow, !1)
  }), m = fo(g, i, e.store);
  return mn(_t(_t({}, i), m), {
    setAutoFocusOnShow: (C) => m.setState("autoFocusOnShow", C)
  });
}
function Mx(e, t, a) {
  return ir(e, a, "timeout"), ir(e, a, "showTimeout"), ir(e, a, "hideTimeout"), rw(e, t, a);
}
function KM(e = {}) {
  const [t, a] = bi(Ex, e);
  return Mx(t, a, e);
}
function BN(e = {}) {
  var t = e, {
    combobox: a,
    parent: i,
    menubar: h
  } = t, g = jp(t, [
    "combobox",
    "parent",
    "menubar"
  ]);
  const m = !!h && !i, C = kp(
    g.store,
    bE(i, ["values"]),
    Tp(a, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  mh(g, C);
  const S = C.getState(), R = xh(mn(_t({}, g), {
    store: C,
    orientation: st(
      g.orientation,
      S.orientation,
      "vertical"
    )
  })), D = Ex(mn(_t({}, g), {
    store: C,
    placement: st(
      g.placement,
      S.placement,
      "bottom-start"
    ),
    timeout: st(
      g.timeout,
      S.timeout,
      m ? 0 : 150
    ),
    hideTimeout: st(g.hideTimeout, S.hideTimeout, 0)
  })), T = mn(_t(_t({}, R.getState()), D.getState()), {
    initialFocus: st(S.initialFocus, "container"),
    values: st(
      g.values,
      S.values,
      g.defaultValues,
      {}
    )
  }), j = fo(T, R, D, C);
  return Aa(
    j,
    () => xa(j, ["mounted"], (A) => {
      A.mounted || j.setState("activeId", null);
    })
  ), Aa(
    j,
    () => xa(i, ["orientation"], (A) => {
      j.setState(
        "placement",
        A.orientation === "vertical" ? "right-start" : "bottom-start"
      );
    })
  ), mn(_t(_t(_t({}, R), D), j), {
    combobox: a,
    parent: i,
    menubar: h,
    hideAll: () => {
      D.hide(), i == null || i.hideAll();
    },
    setInitialFocus: (A) => j.setState("initialFocus", A),
    setValues: (A) => j.setState("values", A),
    setValue: (A, L) => {
      A !== "__proto__" && A !== "constructor" && (Array.isArray(A) || j.setState("values", (P) => {
        const V = P[A], F = O4(L, V);
        return F === V ? P : mn(_t({}, P), {
          [A]: F !== void 0 && F
        });
      }));
    }
  });
}
function FN(e, t, a) {
  return _1(t, [a.combobox, a.parent, a.menubar]), ir(e, a, "values", "setValues"), Object.assign(
    Mx(
      Sh(e, t, a),
      t,
      a
    ),
    {
      combobox: a.combobox,
      parent: a.parent,
      menubar: a.menubar
    }
  );
}
function Tx(e = {}) {
  const t = yf(), a = bx(), i = _h();
  e = Te(G({}, e), {
    parent: e.parent !== void 0 ? e.parent : t,
    menubar: e.menubar !== void 0 ? e.menubar : a,
    combobox: e.combobox !== void 0 ? e.combobox : i
  });
  const [h, g] = bi(BN, e);
  return FN(h, g, e);
}
function UN(e = {}) {
  return gt(() => {
    process.env.NODE_ENV !== "production" && console.warn(
      "useMenuBarStore is deprecated. Use useMenubarStore instead.",
      "See https://ariakit.org/reference/use-menubar-store"
    );
  }, []), dw(e);
}
var YN = "div";
function $N(e) {
  var t = e, { store: a } = t, i = Fe(t, ["store"]);
  const [h, g] = Qt(void 0), m = i["aria-label"], C = ja(a, "disclosureElement"), S = ja(a, "contentElement");
  return gt(() => {
    const R = C;
    if (!R)
      return;
    const D = S;
    if (!D)
      return;
    m || D.hasAttribute("aria-label") ? g(void 0) : R.id && g(R.id);
  }, [m, C, S]), h;
}
var QM = ke(
  function(t) {
    var a = t, { store: i, alwaysVisible: h, composite: g } = a, m = Fe(a, ["store", "alwaysVisible", "composite"]);
    const C = pw();
    i = i || C, Zt(
      i,
      process.env.NODE_ENV !== "production" && "MenuList must receive a `store` prop or be wrapped in a MenuProvider component."
    );
    const S = i.parent, R = i.menubar, D = !!S, T = Ia(m.id), j = m.onKeyDown, A = i.useState(
      (te) => te.placement.split("-")[0]
    ), L = i.useState(
      (te) => te.orientation === "both" ? void 0 : te.orientation
    ), P = L !== "vertical", V = ja(
      R,
      (te) => !!te && te.orientation !== "vertical"
    ), F = rt((te) => {
      if (j == null || j(te), !te.defaultPrevented) {
        if (D || R && !P) {
          const re = {
            ArrowRight: () => A === "left" && !P,
            ArrowLeft: () => A === "right" && !P,
            ArrowUp: () => A === "bottom" && P,
            ArrowDown: () => A === "top" && P
          }[te.key];
          if (re != null && re())
            return te.stopPropagation(), te.preventDefault(), i == null ? void 0 : i.hide();
        }
        if (R) {
          const re = {
            ArrowRight: () => {
              if (V)
                return R.next();
            },
            ArrowLeft: () => {
              if (V)
                return R.previous();
            },
            ArrowDown: () => {
              if (!V)
                return R.next();
            },
            ArrowUp: () => {
              if (!V)
                return R.previous();
            }
          }[te.key], ve = re == null ? void 0 : re();
          ve !== void 0 && (te.stopPropagation(), te.preventDefault(), R.move(ve));
        }
      }
    });
    m = Vn(
      m,
      (te) => /* @__PURE__ */ f.jsx(VN, { value: i, children: te }),
      [i]
    );
    const Y = $N(G({ store: i }, m)), W = i.useState("mounted"), Q = q4(W, m.hidden, h), $ = Q ? Te(G({}, m.style), { display: "none" }) : m.style;
    m = Te(G({
      id: T,
      "aria-labelledby": Y,
      hidden: Q
    }, m), {
      ref: An(T ? i.setContentElement : null, m.ref),
      style: $,
      onKeyDown: F
    });
    const le = !!i.combobox;
    return g = g ?? !le, g && (m = G({
      role: "menu",
      "aria-orientation": L
    }, m)), m = Ch(G({ store: i, composite: g }, m)), m = X4(G({ store: i, typeahead: !le }, m)), m;
  }
), WN = Oe(function(t) {
  const a = QM(t);
  return Ae(YN, a);
});
function L8(e) {
  return [e.clientX, e.clientY];
}
function iR(e, t) {
  const [a, i] = e;
  let h = !1;
  const g = t.length;
  for (let m = g, C = 0, S = m - 1; C < m; S = C++) {
    const [R, D] = t[C], [T, j] = t[S], [, A] = t[S === 0 ? m - 1 : S - 1] || [0, 0], L = (D - j) * (a - R) - (R - T) * (i - D);
    if (j < D) {
      if (i >= j && i < D) {
        if (L === 0)
          return !0;
        L > 0 && (i === j ? i > A && (h = !h) : h = !h);
      }
    } else if (D < j) {
      if (i > D && i <= j) {
        if (L === 0)
          return !0;
        L < 0 && (i === j ? i < A && (h = !h) : h = !h);
      }
    } else if (i == D && (a >= T && a <= R || a >= R && a <= T))
      return !0;
  }
  return h;
}
function zN(e, t) {
  const { top: a, right: i, bottom: h, left: g } = t, [m, C] = e, S = m < g ? "left" : m > i ? "right" : null, R = C < a ? "top" : C > h ? "bottom" : null;
  return [S, R];
}
function lR(e, t) {
  const a = e.getBoundingClientRect(), { top: i, right: h, bottom: g, left: m } = a, [C, S] = zN(t, a), R = [t];
  return C ? (S !== "top" && R.push([C === "left" ? m : h, i]), R.push([C === "left" ? h : m, i]), R.push([C === "left" ? h : m, g]), S !== "bottom" && R.push([C === "left" ? m : h, g])) : S === "top" ? (R.push([m, i]), R.push([m, g]), R.push([h, g]), R.push([h, i])) : (R.push([m, g]), R.push([m, i]), R.push([h, i]), R.push([h, g])), R;
}
var qN = "div";
function XM(e, t, a, i) {
  return uh(t) ? !0 : e ? !!(ha(t, e) || a && ha(a, e) || i != null && i.some((h) => XM(e, h, a))) : !1;
}
function GN(e) {
  var t = e, {
    store: a
  } = t, i = Fe(t, [
    "store"
  ]);
  const [h, g] = Qt(!1), m = a.useState("mounted");
  gt(() => {
    m || g(!1);
  }, [m]);
  const C = i.onFocus, S = rt((D) => {
    C == null || C(D), !D.defaultPrevented && g(!0);
  }), R = Pt(null);
  return gt(() => xa(a, ["anchorElement"], (D) => {
    R.current = D.anchorElement;
  }), []), i = Te(G({
    autoFocusOnHide: h,
    finalFocus: R
  }, i), {
    onFocus: S
  }), i;
}
var uR = ka(null), Ox = ke(
  function(t) {
    var a = t, {
      store: i,
      modal: h = !1,
      portal: g = !!h,
      hideOnEscape: m = !0,
      hideOnHoverOutside: C = !0,
      disablePointerEventsOnApproach: S = !!C
    } = a, R = Fe(a, [
      "store",
      "modal",
      "portal",
      "hideOnEscape",
      "hideOnHoverOutside",
      "disablePointerEventsOnApproach"
    ]);
    const D = hw();
    i = i || D, Zt(
      i,
      process.env.NODE_ENV !== "production" && "Hovercard must receive a `store` prop or be wrapped in a HovercardProvider component."
    );
    const T = Pt(null), [j, A] = Qt([]), L = Pt(0), P = Pt(null), { portalRef: V, domReady: F } = Ny(g, R.portalRef), Y = !!C, W = er(C), Q = !!S, $ = er(
      S
    ), le = i.useState("open"), te = i.useState("mounted");
    gt(() => {
      if (!F || !te || !Y && !Q)
        return;
      const de = T.current;
      return de ? _l(
        Uo("mousemove", (xe) => {
          if (!i)
            return;
          const { anchorElement: Le, hideTimeout: be, timeout: Ue } = i.getState(), ie = P.current, [_e] = xe.composedPath(), Ze = Le;
          if (XM(_e, de, Ze, j)) {
            P.current = _e && Ze && ha(Ze, _e) ? L8(xe) : null, window.clearTimeout(L.current), L.current = 0;
            return;
          }
          if (!L.current) {
            if (ie) {
              const mt = L8(xe), Pe = lR(de, ie);
              if (iR(mt, Pe)) {
                if (P.current = mt, !$(xe))
                  return;
                xe.preventDefault(), xe.stopPropagation();
                return;
              }
            }
            W(xe) && (L.current = window.setTimeout(() => {
              L.current = 0, i == null || i.hide();
            }, be ?? Ue));
          }
        }, !0),
        () => clearTimeout(L.current)
      ) : void 0;
    }, [
      i,
      F,
      te,
      Y,
      Q,
      j,
      $,
      W
    ]), gt(() => {
      if (!F || !te || !Q)
        return;
      const de = (fe) => {
        const xe = T.current;
        if (!xe)
          return;
        const Le = P.current;
        if (!Le)
          return;
        const be = lR(xe, Le);
        if (iR(L8(fe), be)) {
          if (!$(fe))
            return;
          fe.preventDefault(), fe.stopPropagation();
        }
      };
      return _l(
        // Note: we may need to add pointer events here in the future.
        Uo("mouseenter", de, !0),
        Uo("mouseover", de, !0),
        Uo("mouseout", de, !0),
        Uo("mouseleave", de, !0)
      );
    }, [F, te, Q, $]), gt(() => {
      F && (le || i == null || i.setAutoFocusOnShow(!1));
    }, [i, F, le]);
    const Se = wE(le);
    gt(() => {
      if (F)
        return () => {
          Se.current || i == null || i.setAutoFocusOnShow(!1);
        };
    }, [i, F]);
    const re = Yo(uR);
    jn(() => {
      if (h || !g || !te || !F)
        return;
      const de = T.current;
      if (de)
        return re == null ? void 0 : re(de);
    }, [h, g, te, F]);
    const ve = Ir(
      (de) => {
        A((xe) => [...xe, de]);
        const fe = re == null ? void 0 : re(de);
        return () => {
          A(
            (xe) => xe.filter((Le) => Le !== de)
          ), fe == null || fe();
        };
      },
      [re]
    );
    R = Vn(
      R,
      (de) => /* @__PURE__ */ f.jsx(Rx, { value: i, children: /* @__PURE__ */ f.jsx(uR.Provider, { value: ve, children: de }) }),
      [i, ve]
    ), R = Te(G({}, R), {
      ref: An(T, R.ref)
    }), R = GN(G({ store: i }, R));
    const K = i.useState(
      (de) => h || de.autoFocusOnShow
    );
    return R = sw(Te(G({
      store: i,
      modal: h,
      portal: g,
      autoFocusOnShow: K
    }, R), {
      portalRef: V,
      hideOnEscape(de) {
        return k2(m, de) ? !1 : (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            i == null || i.hide();
          });
        }), !0);
      }
    })), R;
  }
), KN = U2(
  Oe(function(t) {
    const a = Ox(t);
    return Ae(qN, a);
  }),
  hw
), QN = "div", XN = ke(function(t) {
  var a = t, {
    store: i,
    modal: h = !1,
    portal: g = !!h,
    hideOnEscape: m = !0,
    autoFocusOnShow: C = !0,
    hideOnHoverOutside: S,
    alwaysVisible: R
  } = a, D = Fe(a, [
    "store",
    "modal",
    "portal",
    "hideOnEscape",
    "autoFocusOnShow",
    "hideOnHoverOutside",
    "alwaysVisible"
  ]);
  const T = pw();
  i = i || T, Zt(
    i,
    process.env.NODE_ENV !== "production" && "Menu must receive a `store` prop or be wrapped in a MenuProvider component."
  );
  const j = Pt(null), A = i.parent, L = i.menubar, P = !!A, V = !!L && !P;
  D = Te(G({}, D), {
    ref: An(j, D.ref)
  });
  const F = QM(G({
    store: i,
    alwaysVisible: R
  }, D)), { "aria-labelledby": Y } = F;
  D = Fe(F, ["aria-labelledby"]);
  const [Q, $] = Qt(), le = i.useState("autoFocusOnShow"), te = i.useState("initialFocus"), Se = i.useState("baseElement"), re = i.useState("renderedItems");
  gt(() => {
    let be = !1;
    return $((Ue) => {
      var ie, _e, Ze;
      if (be || !le)
        return;
      if ((ie = Ue == null ? void 0 : Ue.current) != null && ie.isConnected)
        return Ue;
      const mt = Uk();
      switch (te) {
        case "first":
          mt.current = ((_e = re.find((Pe) => !Pe.disabled && Pe.element)) == null ? void 0 : _e.element) || null;
          break;
        case "last":
          mt.current = ((Ze = [...re].reverse().find((Pe) => !Pe.disabled && Pe.element)) == null ? void 0 : Ze.element) || null;
          break;
        default:
          mt.current = Se;
      }
      return mt;
    }), () => {
      be = !0;
    };
  }, [i, le, te, re, Se]);
  const ve = P ? !1 : h, K = !!C, de = !!Q || !!D.initialFocus || !!ve, fe = ja(
    i.combobox || i,
    "contentElement"
  ), xe = ja(
    (A == null ? void 0 : A.combobox) || A,
    "contentElement"
  ), Le = Lr(() => {
    if (!xe || !fe)
      return;
    const be = fe.getAttribute("role"), Ue = xe.getAttribute("role");
    if (!((Ue === "menu" || Ue === "menubar") && be === "menu"))
      return xe;
  }, [fe, xe]);
  return Le !== void 0 && (D = G({
    preserveTabOrderAnchor: Le
  }, D)), D = Ox(Te(G({
    store: i,
    alwaysVisible: R,
    initialFocus: Q,
    autoFocusOnShow: K ? de && C : le || !!ve
  }, D), {
    hideOnEscape(be) {
      return k2(m, be) ? !1 : (i == null || i.hideAll(), !0);
    },
    hideOnHoverOutside(be) {
      const Ue = i == null ? void 0 : i.getState().disclosureElement;
      return (typeof S == "function" ? S(be) : S ?? (P ? !0 : V ? Ue ? !uh(Ue) : !0 : !1)) ? be.defaultPrevented || !P || !Ue || (pL(Ue, "mouseout", be), !uh(Ue)) ? !0 : (requestAnimationFrame(() => {
        uh(Ue) || i == null || i.hide();
      }), !1) : !1;
    },
    modal: ve,
    portal: g,
    backdrop: P ? !1 : D.backdrop
  })), D = G({
    "aria-labelledby": Y
  }, D), D;
}), JM = U2(
  Oe(function(t) {
    const a = XN(t);
    return Ae(QN, a);
  }),
  pw
);
function eT(e = {}) {
  const t = Tx(e);
  return /* @__PURE__ */ f.jsx(qM, { value: t, children: e.children });
}
var JN = "div", eB = ke(
  function(t) {
    return gt(() => {
      process.env.NODE_ENV !== "production" && console.warn(
        "MenuBar is deprecated. Use Menubar instead.",
        "See https://ariakit.org/reference/menubar"
      );
    }, []), $M(t);
  }
), tB = Oe(function(t) {
  const a = eB(t);
  return Ae(JN, a);
});
function nB(e = {}) {
  return gt(() => {
    process.env.NODE_ENV !== "production" && console.warn(
      "MenuBarProvider is deprecated. Use MenubarProvider instead.",
      "See https://ariakit.org/reference/menubar-provider"
    );
  }, []), /* @__PURE__ */ f.jsx(WM, G({}, e));
}
var rB = "div", aB = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = yf();
    return i = i || g, cw(G({ store: i }, h));
  }
), tT = Oe(function(t) {
  const a = aB(t);
  return Ae(rB, a);
}), oB = "span", iB = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = yf();
    return i = i || g, h = Sx(G({ store: i }, h)), h;
  }
), lB = Oe(function(t) {
  const a = iB(t);
  return Ae(oB, a);
}), uB = "a", Dx = ke(
  function(t) {
    var a = t, { store: i, showOnHover: h = !0 } = a, g = Fe(a, ["store", "showOnHover"]);
    const m = hw();
    i = i || m, Zt(
      i,
      process.env.NODE_ENV !== "production" && "HovercardAnchor must receive a `store` prop or be wrapped in a HovercardProvider component."
    );
    const C = mf(g), S = Pt(0);
    gt(() => () => window.clearTimeout(S.current), []), gt(() => Uo("mouseleave", (F) => {
      if (!i)
        return;
      const { anchorElement: Y } = i.getState();
      Y && F.target === Y && (window.clearTimeout(S.current), S.current = 0);
    }, !0), [i]);
    const R = g.onMouseMove, D = er(h), T = SE(), j = rt((V) => {
      if (R == null || R(V), C || !i || V.defaultPrevented || S.current || !T() || !D(V))
        return;
      const F = V.currentTarget;
      i.setAnchorElement(F), i.setDisclosureElement(F);
      const { showTimeout: Y, timeout: W } = i.getState(), Q = () => {
        S.current = 0, T() && (i == null || i.setAnchorElement(F), i == null || i.show(), queueMicrotask(() => {
          i == null || i.setDisclosureElement(F);
        }));
      }, $ = Y ?? W;
      $ === 0 ? Q() : S.current = window.setTimeout(Q, $);
    }), A = g.onClick, L = rt((V) => {
      A == null || A(V), i && (window.clearTimeout(S.current), S.current = 0);
    }), P = Ir(
      (V) => {
        if (!i)
          return;
        const { anchorElement: F } = i.getState();
        F != null && F.isConnected || i.setAnchorElement(V);
      },
      [i]
    );
    return g = Te(G({}, g), {
      ref: An(P, g.ref),
      onMouseMove: j,
      onClick: L
    }), g = N2(g), g;
  }
), sB = Oe(function(t) {
  const a = Dx(t);
  return Ae(uB, a);
}), cB = "button";
function fB(e, t) {
  return {
    ArrowDown: t === "bottom" || t === "top" ? "first" : !1,
    ArrowUp: t === "bottom" || t === "top" ? "last" : !1,
    ArrowRight: t === "right" ? "first" : !1,
    ArrowLeft: t === "left" ? "first" : !1
  }[e.key];
}
function sR(e, t) {
  return !!(e != null && e.some((a) => !a.element || a.element === t ? !1 : a.element.getAttribute("aria-expanded") === "true"));
}
var dB = ke(
  function(t) {
    var a = t, {
      store: i,
      focusable: h,
      accessibleWhenDisabled: g,
      showOnHover: m
    } = a, C = Fe(a, [
      "store",
      "focusable",
      "accessibleWhenDisabled",
      "showOnHover"
    ]);
    const S = pw();
    i = i || S, Zt(
      i,
      process.env.NODE_ENV !== "production" && "MenuButton must receive a `store` prop or be wrapped in a MenuProvider component."
    );
    const R = Pt(null), D = i.parent, T = i.menubar, j = !!D, A = !!T && !j, L = mf(C), P = () => {
      const K = R.current;
      K && (i == null || i.setDisclosureElement(K), i == null || i.setAnchorElement(K), i == null || i.show());
    }, V = C.onFocus, F = rt((K) => {
      if (V == null || V(K), L || K.defaultPrevented || (i == null || i.setAutoFocusOnShow(!1), i == null || i.setActiveId(null), !T) || !A)
        return;
      const { items: de } = T.getState();
      sR(de, K.currentTarget) && P();
    }), Y = i.useState(
      (K) => K.placement.split("-")[0]
    ), W = C.onKeyDown, Q = rt((K) => {
      if (W == null || W(K), L || K.defaultPrevented)
        return;
      const de = fB(K, Y);
      de && (K.preventDefault(), P(), i == null || i.setAutoFocusOnShow(!0), i == null || i.setInitialFocus(de));
    }), $ = C.onClick, le = rt((K) => {
      if ($ == null || $(K), K.defaultPrevented || !i)
        return;
      const de = !K.detail, { open: fe } = i.getState();
      (!fe || de) && ((!j || de) && i.setAutoFocusOnShow(!0), i.setInitialFocus(de ? "first" : "container")), j && P();
    });
    C = Vn(
      C,
      (K) => /* @__PURE__ */ f.jsx(qM, { value: i, children: K }),
      [i]
    ), j && (C = Te(G({}, C), {
      render: /* @__PURE__ */ f.jsx(H4.div, { render: C.render })
    }));
    const te = Ia(C.id), Se = ja(
      (D == null ? void 0 : D.combobox) || D,
      "contentElement"
    ), re = j || A ? ky(Se, "menuitem") : void 0, ve = i.useState("contentElement");
    return C = Te(G({
      id: te,
      role: re,
      "aria-haspopup": vh(ve, "menu")
    }, C), {
      ref: An(R, C.ref),
      onFocus: F,
      onKeyDown: Q,
      onClick: le
    }), C = Dx(Te(G({
      store: i,
      focusable: h,
      accessibleWhenDisabled: g
    }, C), {
      showOnHover: (K) => {
        if (!(() => {
          if (typeof m == "function")
            return m(K);
          if (m != null)
            return m;
          if (j)
            return !0;
          if (!T)
            return !1;
          const { items: Le } = T.getState();
          return A && sR(Le);
        })())
          return !1;
        const xe = A ? T : D;
        return xe && xe.setActiveId(K.currentTarget.id), !0;
      }
    })), C = Cx(G({
      store: i,
      toggleOnClick: !j,
      focusable: h,
      accessibleWhenDisabled: g
    }, C)), C = X4(G({
      store: i,
      typeahead: A
    }, C)), C;
  }
), nT = Oe(function(t) {
  const a = dB(t);
  return Ae(cB, a);
}), hB = "p", rT = ke(function(t) {
  return t = FM(t), t;
}), vB = Oe(function(t) {
  const a = rT(t);
  return Ae(hB, a);
}), pB = "p", mB = ke(
  function(t) {
    return t = rT(t), t;
  }
), gB = Oe(function(t) {
  const a = mB(t);
  return Ae(pB, a);
}), wB = "button", aT = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = PN();
    return i = i || g, h = UM(G({ store: i }, h)), h;
  }
), yB = Oe(function(t) {
  const a = aT(t);
  return Ae(wB, a);
}), xB = "button", SB = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = vw();
    return i = i || g, h = aT(G({ store: i }, h)), h;
  }
), CB = Oe(function(t) {
  const a = SB(t);
  return Ae(xB, a);
}), bB = "div", _B = ke(
  function(t) {
    return t = J5(t), t;
  }
), RB = Oe(function(t) {
  const a = _B(t);
  return Ae(bB, a);
}), EB = "div", MB = ke(
  function(t) {
    return t = ew(t), t;
  }
), TB = Oe(function(t) {
  const a = MB(t);
  return Ae(EB, a);
}), OB = "h1", oT = ke(
  function(t) {
    return t = YM(t), t;
  }
), DB = Oe(function(t) {
  const a = oT(t);
  return Ae(OB, a);
}), jB = "h1", AB = ke(
  function(t) {
    return t = oT(t), t;
  }
), iT = Oe(function(t) {
  const a = AB(t);
  return Ae(jB, a);
}), kB = "span", LB = ke(
  function(t) {
    var a = t, { checked: i } = a, h = Fe(a, ["store", "checked"]);
    const g = Yo(GM);
    return i = i ?? g, h = Y5(Te(G({}, h), { checked: i })), h;
  }
), IB = Oe(function(t) {
  const a = LB(t);
  return Ae(kB, a);
}), HB = "div";
function ZB(e, t, a) {
  var i;
  if (!e)
    return !1;
  if (uh(e))
    return !0;
  const h = t == null ? void 0 : t.find((S) => {
    var R;
    return S.element === a ? !1 : ((R = S.element) == null ? void 0 : R.getAttribute("aria-expanded")) === "true";
  }), g = (i = h == null ? void 0 : h.element) == null ? void 0 : i.getAttribute("aria-controls");
  if (!g)
    return !1;
  const C = Qr(e).getElementById(g);
  return C ? uh(C) ? !0 : !!C.querySelector("[role=menuitem][aria-expanded=true]") : !1;
}
var jx = ke(
  function(t) {
    var a = t, {
      store: i,
      hideOnClick: h = !0,
      preventScrollOnKeyDown: g = !0,
      focusOnHover: m,
      blurOnHoverEnd: C
    } = a, S = Fe(a, [
      "store",
      "hideOnClick",
      "preventScrollOnKeyDown",
      "focusOnHover",
      "blurOnHoverEnd"
    ]);
    const R = vw(!0), D = DN();
    i = i || R || D, Zt(
      i,
      process.env.NODE_ENV !== "production" && "MenuItem must be wrapped in a MenuList, Menu or Menubar component"
    );
    const T = S.onClick, j = er(h), A = "hideAll" in i ? i.hideAll : void 0, L = !!A, P = rt((Y) => {
      T == null || T(Y), !(Y.defaultPrevented || Py(Y) || Zy(Y) || !A || Y.currentTarget.getAttribute("aria-haspopup") === "menu") && j(Y) && A();
    }), V = ja(
      i,
      (Y) => "contentElement" in Y ? Y.contentElement : null
    ), F = ky(V, "menuitem");
    return S = Te(G({
      role: F
    }, S), {
      onClick: P
    }), S = F2(G({
      store: i,
      preventScrollOnKeyDown: g
    }, S)), S = tw(Te(G({
      store: i
    }, S), {
      focusOnHover(Y) {
        const W = () => typeof m == "function" ? m(Y) : m ?? !0;
        if (!i || !W())
          return !1;
        const { baseElement: Q, items: $ } = i.getState();
        return L ? (Y.currentTarget.hasAttribute("aria-expanded") && Y.currentTarget.focus(), !0) : ZB(Q, $, Y.currentTarget) ? (Y.currentTarget.focus(), !0) : !1;
      },
      blurOnHoverEnd(Y) {
        return typeof C == "function" ? C(Y) : C ?? L;
      }
    })), S;
  }
), lT = Ha(
  Oe(function(t) {
    const a = jx(t);
    return Ae(HB, a);
  })
), PB = "div";
function VB(e) {
  return Array.isArray(e) ? e.toString() : e;
}
function I8(e, t, a) {
  if (t === void 0)
    return Array.isArray(e) ? e : !!a;
  const i = VB(t);
  return Array.isArray(e) ? a ? e.includes(i) ? e : [...e, i] : e.filter((h) => h !== i) : a ? i : e === i ? !1 : e;
}
var NB = ke(
  function(t) {
    var a = t, {
      store: i,
      name: h,
      value: g,
      checked: m,
      defaultChecked: C,
      hideOnClick: S = !1
    } = a, R = Fe(a, [
      "store",
      "name",
      "value",
      "checked",
      "defaultChecked",
      "hideOnClick"
    ]);
    const D = vw();
    i = i || D, Zt(
      i,
      process.env.NODE_ENV !== "production" && "MenuItemCheckbox must be wrapped in a MenuList or Menu component"
    );
    const T = Vy(C);
    gt(() => {
      i == null || i.setValue(h, (A = []) => T ? I8(A, g, !0) : A);
    }, [i, h, g, T]), gt(() => {
      m !== void 0 && (i == null || i.setValue(h, (A) => I8(A, g, m)));
    }, [i, h, g, m]);
    const j = Y4({
      value: i.useState((A) => A.values[h]),
      setValue(A) {
        i == null || i.setValue(h, () => {
          if (m === void 0)
            return A;
          const L = I8(A, g, m);
          return !Array.isArray(L) || !Array.isArray(A) ? L : Xk(A, L) ? A : L;
        });
      }
    });
    return R = G({
      role: "menuitemcheckbox"
    }, R), R = qy(G({
      store: j,
      name: h,
      value: g,
      checked: m
    }, R)), R = jx(G({ store: i, hideOnClick: S }, R)), R;
  }
), BB = Ha(
  Oe(function(t) {
    const a = NB(t);
    return Ae(PB, a);
  })
), FB = "div";
function H8(e, t, a) {
  return a === void 0 ? e : a ? t : e;
}
var UB = ke(
  function(t) {
    var a = t, {
      store: i,
      name: h,
      value: g,
      checked: m,
      onChange: C,
      hideOnClick: S = !1
    } = a, R = Fe(a, [
      "store",
      "name",
      "value",
      "checked",
      "onChange",
      "hideOnClick"
    ]);
    const D = vw();
    i = i || D, Zt(
      i,
      process.env.NODE_ENV !== "production" && "MenuItemRadio must be wrapped in a MenuList or Menu component"
    );
    const T = Vy(R.defaultChecked);
    gt(() => {
      i == null || i.setValue(h, (A = !1) => H8(A, g, T));
    }, [i, h, g, T]), gt(() => {
      m !== void 0 && (i == null || i.setValue(h, (A) => H8(A, g, m)));
    }, [i, h, g, m]);
    const j = i.useState((A) => A.values[h] === g);
    return R = Vn(
      R,
      (A) => /* @__PURE__ */ f.jsx(GM.Provider, { value: !!j, children: A }),
      [j]
    ), R = G({
      role: "menuitemradio"
    }, R), R = ex(G({
      name: h,
      value: g,
      checked: j,
      onChange(A) {
        if (C == null || C(A), A.defaultPrevented)
          return;
        const L = A.currentTarget;
        i == null || i.setValue(h, (P) => H8(P, g, m ?? L.checked));
      }
    }, R)), R = jx(G({ store: i, hideOnClick: S }, R)), R;
  }
), YB = Ha(
  Oe(function(t) {
    const a = UB(t);
    return Ae(FB, a);
  })
), $B = "hr", WB = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = yf();
    return i = i || g, h = Q4(G({ store: i }, h)), h;
  }
), uT = Oe(function(t) {
  const a = WB(t);
  return Ae($B, a);
});
function zB(e = {}) {
  const t = KM(e);
  return /* @__PURE__ */ f.jsx(_x, { value: t, children: e.children });
}
var qB = "div", GB = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = zM();
    return i = i || g, h = cw(G({ store: i }, h)), h;
  }
), KB = Oe(function(t) {
  const a = GB(t);
  return Ae(qB, a);
}), QB = "button", XB = ke(function(t) {
  var a = t, { store: i } = a, h = Fe(a, ["store"]);
  const g = hw();
  i = i || g, Zt(
    i,
    process.env.NODE_ENV !== "production" && "HovercardDisclosure must receive a `store` prop or be wrapped in a HovercardProvider component."
  );
  const [m, C] = Qt(!1);
  gt(() => m ? Uo("focusout", (P) => {
    if (!i)
      return;
    const V = P.relatedTarget;
    if (V) {
      const {
        anchorElement: F,
        popoverElement: Y,
        disclosureElement: W
      } = i.getState();
      if (F && ha(F, V) || Y && ha(Y, V) || W && ha(W, V) || V.hasAttribute("data-focus-trap"))
        return;
    }
    C(!1);
  }, !0) : void 0, [m, i]), gt(() => xa(i, ["anchorElement"], (L) => {
    const P = L.anchorElement;
    if (!P)
      return;
    const V = new MutationObserver(() => {
      P.hasAttribute("data-focus-visible") && C(!0);
    });
    return V.observe(P, { attributeFilter: ["data-focus-visible"] }), () => V.disconnect();
  }), [i]);
  const S = h.onClick, R = rt((L) => {
    S == null || S(L), !L.defaultPrevented && (i == null || i.setAutoFocusOnShow(!0));
  }), D = h.onFocus, T = rt((L) => {
    D == null || D(L), !L.defaultPrevented && C(!0);
  }), { style: j } = tx();
  return m || (h = Te(G({}, h), {
    style: G(G({}, j), h.style)
  })), h = Te(G({
    children: /* @__PURE__ */ f.jsx(
      "svg",
      {
        display: "block",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        children: /* @__PURE__ */ f.jsx("polyline", { points: "4,6 8,10 12,6" })
      }
    )
  }, h), {
    ref: An(i.setDisclosureElement, h.ref),
    onClick: R,
    onFocus: T
  }), h = X5(G({ store: i }, h)), h;
}), JB = Oe(function(t) {
  const a = XB(t);
  return Ae(QB, a);
});
function eF(e = {}) {
  var t;
  process.env.NODE_ENV !== "production" && e.type === "label" && console.warn(
    "The `type` option on the tooltip store is deprecated.",
    "Render a visually hidden label or use the `aria-label` or `aria-labelledby` attributes on the anchor element instead.",
    "See https://ariakit.org/components/tooltip#tooltip-anchors-must-have-accessible-names"
  );
  const a = (t = e.store) == null ? void 0 : t.getState(), i = Ex(mn(_t({}, e), {
    placement: st(
      e.placement,
      a == null ? void 0 : a.placement,
      "top"
    ),
    hideTimeout: st(e.hideTimeout, a == null ? void 0 : a.hideTimeout, 0)
  })), h = mn(_t({}, i.getState()), {
    type: st(e.type, a == null ? void 0 : a.type, "description"),
    skipTimeout: st(e.skipTimeout, a == null ? void 0 : a.skipTimeout, 300)
  }), g = fo(h, i, e.store);
  return _t(_t({}, i), g);
}
function tF(e, t, a) {
  return ir(e, a, "type"), ir(e, a, "skipTimeout"), Mx(e, t, a);
}
function Ax(e = {}) {
  const [t, a] = bi(eF, e);
  return tF(t, a, e);
}
var mw = _i(
  [_x],
  [Rx]
), sT = mw.useContext, kx = mw.useProviderContext, nF = mw.ContextProvider, rF = mw.ScopedContextProvider, aF = "div", oF = ke(
  function(t) {
    var a = t, {
      store: i,
      portal: h = !0,
      gutter: g = 8,
      preserveTabOrder: m = !1,
      hideOnHoverOutside: C = !0,
      hideOnInteractOutside: S = !0
    } = a, R = Fe(a, [
      "store",
      "portal",
      "gutter",
      "preserveTabOrder",
      "hideOnHoverOutside",
      "hideOnInteractOutside"
    ]);
    const D = kx();
    i = i || D, Zt(
      i,
      process.env.NODE_ENV !== "production" && "Tooltip must receive a `store` prop or be wrapped in a TooltipProvider component."
    ), R = Vn(
      R,
      (j) => /* @__PURE__ */ f.jsx(rF, { value: i, children: j }),
      [i]
    );
    const T = i.useState(
      (j) => j.type === "description" ? "tooltip" : "none"
    );
    return R = G({ role: T }, R), R = Ox(Te(G({}, R), {
      store: i,
      portal: h,
      gutter: g,
      preserveTabOrder: m,
      hideOnHoverOutside(j) {
        if (k2(C, j))
          return !1;
        const A = i == null ? void 0 : i.getState().anchorElement;
        return A ? !("focusVisible" in A.dataset) : !0;
      },
      hideOnInteractOutside: (j) => {
        if (k2(S, j))
          return !1;
        const A = i == null ? void 0 : i.getState().anchorElement;
        return A ? !ha(A, j.target) : !0;
      }
    })), R;
  }
), cT = U2(
  Oe(function(t) {
    const a = oF(t);
    return Ae(aF, a);
  }),
  kx
);
function iF(e = {}) {
  const t = Ax(e);
  return /* @__PURE__ */ f.jsx(nF, { value: t, children: e.children });
}
var lF = "div", D2 = fo({
  activeStore: null
});
function cR(e) {
  return () => {
    const { activeStore: t } = D2.getState();
    t === e && D2.setState("activeStore", null);
  };
}
var uF = ke(
  function(t) {
    var a = t, { store: i, showOnHover: h = !0 } = a, g = Fe(a, ["store", "showOnHover"]);
    const m = kx();
    i = i || m, Zt(
      i,
      process.env.NODE_ENV !== "production" && "TooltipAnchor must receive a `store` prop or be wrapped in a TooltipProvider component."
    );
    const C = Pt(!1);
    gt(() => xa(i, ["mounted"], (V) => {
      V.mounted || (C.current = !1);
    }), [i]), gt(() => {
      if (i)
        return _l(
          // Immediately remove the current store from the global store when
          // the component unmounts. This is useful, for example, to avoid
          // showing tooltips immediately on serial tests.
          cR(i),
          xa(i, ["mounted", "skipTimeout"], (V) => {
            if (!i)
              return;
            if (V.mounted) {
              const { activeStore: Y } = D2.getState();
              return Y !== i && (Y == null || Y.hide()), D2.setState("activeStore", i);
            }
            const F = setTimeout(
              cR(i),
              V.skipTimeout
            );
            return () => clearTimeout(F);
          })
        );
    }, [i]);
    const S = g.onMouseEnter, R = rt((V) => {
      S == null || S(V), C.current = !0;
    }), D = g.onFocusVisible, T = rt((V) => {
      D == null || D(V), !V.defaultPrevented && (i == null || i.setAnchorElement(V.currentTarget), i == null || i.show());
    }), j = g.onBlur, A = rt((V) => {
      if (j == null || j(V), V.defaultPrevented)
        return;
      const { activeStore: F } = D2.getState();
      C.current = !1, F === i && D2.setState("activeStore", null);
    }), L = i.useState("type"), P = i.useState((V) => {
      var F;
      return (F = V.contentElement) == null ? void 0 : F.id;
    });
    return g = Te(G({
      "aria-labelledby": L === "label" ? P : void 0
    }, g), {
      onMouseEnter: R,
      onFocusVisible: T,
      onBlur: A
    }), g = Dx(G({
      store: i,
      showOnHover(V) {
        if (!C.current || k2(h, V))
          return !1;
        const { activeStore: F } = D2.getState();
        return F ? (i == null || i.show(), !1) : !0;
      }
    }, g)), g;
  }
), fT = Oe(function(t) {
  const a = uF(t);
  return Ae(lF, a);
}), sF = "div", cF = ke(
  function(t) {
    var a = t, { store: i, size: h = 16 } = a, g = Fe(a, ["store", "size"]);
    const m = sT();
    return i = i || m, Zt(
      i,
      process.env.NODE_ENV !== "production" && "TooltipArrow must be wrapped in a Tooltip component."
    ), g = cw(G({ store: i, size: h }, g)), g;
  }
), dT = Oe(function(t) {
  const a = cF(t);
  return Ae(sF, a);
});
function fF(e = {}) {
  var t;
  const a = (t = e.store) == null ? void 0 : t.getState();
  return xh(mn(_t({}, e), {
    orientation: st(
      e.orientation,
      a == null ? void 0 : a.orientation,
      "horizontal"
    ),
    focusLoop: st(e.focusLoop, a == null ? void 0 : a.focusLoop, !0)
  }));
}
function dF(e, t, a) {
  return Sh(e, t, a);
}
function Lx(e = {}) {
  const [t, a] = bi(fF, e);
  return dF(t, a, e);
}
var gw = _i(
  [P0],
  [yh]
), l3 = gw.useContext, hF = gw.useProviderContext, vF = gw.ContextProvider, pF = gw.ScopedContextProvider, mF = "div", gF = ke(
  function(t) {
    var a = t, {
      store: i,
      orientation: h,
      virtualFocus: g,
      focusLoop: m,
      rtl: C
    } = a, S = Fe(a, [
      "store",
      "orientation",
      "virtualFocus",
      "focusLoop",
      "rtl"
    ]);
    const R = hF();
    i = i || R;
    const D = Lx({
      store: i,
      orientation: h,
      virtualFocus: g,
      focusLoop: m,
      rtl: C
    }), T = D.useState(
      (j) => j.orientation === "both" ? void 0 : j.orientation
    );
    return S = Vn(
      S,
      (j) => /* @__PURE__ */ f.jsx(pF, { value: D, children: j }),
      [D]
    ), S = G({
      role: "toolbar",
      "aria-orientation": T
    }, S), S = Ch(G({ store: D }, S)), S;
  }
), wF = Oe(function(t) {
  const a = gF(t);
  return Ae(mF, a);
});
function yF(e = {}) {
  const t = Lx(e);
  return /* @__PURE__ */ f.jsx(vF, { value: t, children: e.children });
}
var xF = "div";
function fR(e) {
  _5(e);
  const t = F5(e);
  return yp(e), t;
}
var hT = ke(function(t) {
  var a = t, { store: i } = a, h = Fe(a, ["store"]);
  const g = B2();
  i = i || g;
  const m = Pt(null), C = Pt(!1), S = (W = !1) => {
    const Q = m.current;
    if (!Q)
      return;
    _5(Q);
    const $ = F5(Q);
    if (!$) {
      yp(Q);
      return;
    }
    C.current = !0, queueMicrotask(() => {
      $.focus(), (bl($) || $.isContentEditable) && $E($, W);
    });
  }, R = () => {
    const W = m.current;
    W && (C.current = !1, yp(W));
  }, D = ja(i, "renderedItems");
  gt(() => {
    const W = m.current;
    if (!W)
      return;
    !C.current && (D != null && D.length) && yp(W);
  }, [D]);
  const T = h.onFocus, j = rt((W) => {
    if (T == null || T(W), W.defaultPrevented || !i)
      return;
    const Q = C.current;
    if (Ci(W)) {
      C.current = !1;
      const { baseElement: $ } = i.getState(), le = $, Se = le == null ? void 0 : le.querySelectorAll("[data-composite-container]");
      Se == null || Se.forEach((re) => yp(re));
    } else Q || (C.current = !0, _5(W.currentTarget), i == null || i.setState("moves", 0));
  }), A = h.onBlur, L = rt((W) => {
    A == null || A(W), !W.defaultPrevented && rh(W) && R();
  }), P = h.onKeyDown, V = rt((W) => {
    if (P == null || P(W), W.defaultPrevented || W.altKey || W.ctrlKey || W.metaKey || W.shiftKey)
      return;
    const Q = W.currentTarget;
    if (Ci(W)) {
      if (W.key.length === 1 && W.key !== " ") {
        const $ = fR(Q);
        if (!$)
          return;
        (bl($) || $.isContentEditable) && (W.stopPropagation(), S());
      } else if (W.key === "Delete" || W.key === "Backspace") {
        const $ = fR(Q);
        if (!$)
          return;
        if (bl($) || $.isContentEditable) {
          S();
          const le = () => queueMicrotask(() => Q.focus());
          Q.addEventListener("input", le, { once: !0 });
        }
      }
    } else if (W.key === "Escape")
      queueMicrotask(() => Q.focus());
    else if (W.key === "Enter") {
      const $ = W.target;
      ($.tagName === "INPUT" && !L0($) || $.tagName === "TEXTAREA" || $.isContentEditable) && (W.preventDefault(), queueMicrotask(() => Q.focus()));
    }
  }), F = h.onClick, Y = rt((W) => {
    F == null || F(W), !W.defaultPrevented && Ci(W) && !W.detail && S(!0);
  });
  return h = Te(G({
    "data-composite-container": ""
  }, h), {
    ref: An(m, h.ref),
    onFocus: j,
    onBlur: L,
    onKeyDown: V,
    onClick: Y
  }), La(h);
});
Oe(function(t) {
  const a = hT(t);
  return Ae(xF, a);
});
var SF = "button", Ix = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = l3();
    return i = i || g, h = F2(G({ store: i }, h)), h;
  }
), CF = Ha(
  Oe(function(t) {
    const a = Ix(t);
    return Ae(SF, a);
  })
), bF = "div", _F = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = l3();
    return i = i || g, h = hT(G({ store: i }, h)), h = Ix(G({ store: i }, h)), h;
  }
), RF = Ha(
  Oe(function(t) {
    const a = _F(t);
    return Ae(bF, a);
  })
), EF = "input", MF = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = l3();
    return i = i || g, h = Ix(G({ store: i }, h)), h;
  }
), TF = Ha(
  Oe(function(t) {
    const a = MF(t);
    return Ae(EF, a);
  })
), OF = "hr", DF = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = l3();
    return i = i || g, h = Q4(G({ store: i }, h)), h;
  }
), jF = Oe(function(t) {
  const a = DF(t);
  return Ae(OF, a);
}), u3 = _i(
  [ow, P0],
  [t3, yh]
), xf = u3.useContext, AF = u3.useScopedContext, s3 = u3.useProviderContext, kF = u3.ContextProvider, vT = u3.ScopedContextProvider, pT = ka(!1);
function mT(e = {}) {
  var t = e, {
    composite: a,
    combobox: i
  } = t, h = jp(t, [
    "composite",
    "combobox"
  ]);
  const g = [
    "items",
    "renderedItems",
    "moves",
    "orientation",
    "baseElement",
    "focusLoop",
    "focusShift",
    "focusWrap"
  ], m = kp(
    h.store,
    Tp(a, g),
    Tp(i, g)
  ), C = m == null ? void 0 : m.getState(), S = xh(mn(_t({}, h), {
    orientation: st(
      h.orientation,
      C == null ? void 0 : C.orientation,
      "horizontal"
    ),
    focusLoop: st(h.focusLoop, C == null ? void 0 : C.focusLoop, !0)
  })), R = N5(), D = mn(_t({}, S.getState()), {
    selectedId: st(
      h.selectedId,
      C == null ? void 0 : C.selectedId,
      h.defaultSelectedId,
      void 0
    ),
    selectOnMove: st(
      h.selectOnMove,
      C == null ? void 0 : C.selectOnMove,
      !0
    )
  }), T = fo(D, S, m);
  return Aa(
    T,
    () => xa(T, ["moves"], () => {
      const { activeId: j, selectOnMove: A } = T.getState();
      if (!A || !j)
        return;
      const L = S.item(j);
      L && (L.dimmed || L.disabled || T.setState("selectedId", L.id));
    })
  ), Aa(
    T,
    () => I2(
      T,
      ["selectedId"],
      (j) => T.setState("activeId", j.selectedId)
    )
  ), Aa(
    T,
    () => xa(T, ["selectedId", "renderedItems"], (j) => {
      if (j.selectedId !== void 0)
        return;
      const { activeId: A, renderedItems: L } = T.getState(), P = S.item(A);
      if (P && !P.disabled && !P.dimmed)
        T.setState("selectedId", P.id);
      else {
        const V = L.find(
          (F) => !F.disabled && !F.dimmed
        );
        T.setState("selectedId", V == null ? void 0 : V.id);
      }
    })
  ), Aa(
    T,
    () => xa(T, ["renderedItems"], (j) => {
      const A = j.renderedItems;
      if (A.length)
        return xa(R, ["renderedItems"], (L) => {
          const P = L.renderedItems;
          P.some((F) => !F.tabId) && P.forEach((F, Y) => {
            if (F.tabId)
              return;
            const W = A[Y];
            W && R.renderItem(mn(_t({}, F), { tabId: W.id }));
          });
        });
    })
  ), mn(_t(_t({}, S), T), {
    panels: R,
    setSelectedId: (j) => T.setState("selectedId", j),
    select: (j) => {
      T.setState("selectedId", j), S.move(j);
    }
  });
}
function LF(e, t, a) {
  _1(t, [a.composite, a.combobox]), e = Sh(e, t, a), ir(e, a, "selectedId", "setSelectedId"), ir(e, a, "selectOnMove");
  const [i, h] = bi(() => e.panels, {});
  return _1(h, [e, h]), Object.assign(
    Lr(() => Te(G({}, e), { panels: i }), [e, i]),
    { composite: a.composite, combobox: a.combobox }
  );
}
function ww(e = {}) {
  const t = fx(), a = xf() || t;
  e = Te(G({}, e), {
    composite: e.composite !== void 0 ? e.composite : a,
    combobox: e.combobox !== void 0 ? e.combobox : t
  });
  const [i, h] = bi(mT, e);
  return LF(i, h, e);
}
var c3 = _i(
  [P0],
  [yh]
), Hx = c3.useContext, IF = c3.useScopedContext, gT = c3.useProviderContext, HF = c3.ContextProvider, wT = c3.ScopedContextProvider, ZF = "button", PF = ke(function(t) {
  var a = t, {
    store: i,
    accessibleWhenDisabled: h = !0,
    getItem: g
  } = a, m = Fe(a, [
    "store",
    "accessibleWhenDisabled",
    "getItem"
  ]);
  const C = IF();
  i = i || C, Zt(
    i,
    process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component."
  );
  const S = Ia(), R = m.id || S, D = mf(m), T = Ir(
    (F) => {
      const Y = Te(G({}, F), { dimmed: D });
      return g ? g(Y) : Y;
    },
    [D, g]
  ), j = m.onClick, A = rt((F) => {
    j == null || j(F), !F.defaultPrevented && (i == null || i.setSelectedId(R));
  }), L = i.panels.useState(
    (F) => {
      var Y;
      return (Y = F.items.find((W) => W.tabId === R)) == null ? void 0 : Y.id;
    }
  ), P = i.useState((F) => !!R && F.selectedId === R), V = S ? m.shouldRegisterItem : !1;
  return m = Vn(
    m,
    (F) => {
      if (!(i != null && i.composite))
        return F;
      const Y = {
        id: R,
        store: i.composite,
        shouldRegisterItem: P && V,
        render: F
      };
      return /* @__PURE__ */ f.jsx(
        ey,
        Te(G({}, Y), {
          render: i.combobox && i.composite !== i.combobox ? /* @__PURE__ */ f.jsx(ey, Te(G({}, Y), { store: i.combobox })) : F
        })
      );
    },
    [i, R, P, V]
  ), m = Te(G({
    id: R,
    role: "tab",
    "aria-selected": P,
    "aria-controls": L || void 0
  }, m), {
    onClick: A
  }), m = F2(Te(G({
    store: i
  }, m), {
    accessibleWhenDisabled: h,
    getItem: T,
    shouldRegisterItem: V
  })), m;
}), yT = Ha(
  Oe(function(t) {
    const a = PF(t);
    return Ae(ZF, a);
  })
);
function xT(e = {}) {
  const t = ww(e);
  return /* @__PURE__ */ f.jsx(HF, { value: t, children: e.children });
}
var VF = "div", NF = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = gT();
    i = i || g, Zt(
      i,
      process.env.NODE_ENV !== "production" && "TabList must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const m = i.useState(
      (C) => C.orientation === "both" ? void 0 : C.orientation
    );
    return h = Vn(
      h,
      (C) => /* @__PURE__ */ f.jsx(wT, { value: i, children: C }),
      [i]
    ), i.composite && (h = G({
      focusable: !1
    }, h)), h = G({
      role: "tablist",
      "aria-orientation": m
    }, h), h = Ch(G({ store: i }, h)), h;
  }
), ST = Oe(function(t) {
  const a = NF(t);
  return Ae(VF, a);
}), BF = "div", FF = ke(
  function(t) {
    var a = t, {
      store: i,
      unmountOnHide: h,
      tabId: g,
      getItem: m
    } = a, C = Fe(a, [
      "store",
      "unmountOnHide",
      "tabId",
      "getItem"
    ]);
    const S = gT();
    i = i || S, Zt(
      i,
      process.env.NODE_ENV !== "production" && "TabPanel must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const R = Pt(null), D = Ia(C.id), [T, j] = Qt(!1);
    gt(() => {
      const Q = R.current;
      if (!Q)
        return;
      const $ = Lp(Q);
      j(!!$.length);
    }, []);
    const A = Ir(
      (Q) => {
        const $ = Te(G({}, Q), { id: D || Q.id, tabId: g });
        return m ? m($) : $;
      },
      [D, g, m]
    ), L = C.onKeyDown, P = rt((Q) => {
      if (L == null || L(Q), Q.defaultPrevented || !(i != null && i.composite))
        return;
      const { items: $, renderedItems: le, selectedId: te } = i.getState(), Se = mT({ items: $, activeId: te });
      Se.setState("renderedItems", le);
      const ve = {
        ArrowLeft: Se.previous,
        ArrowRight: Se.next,
        Home: Se.first,
        End: Se.last
      }[Q.key];
      if (!ve)
        return;
      const K = ve();
      K && (Q.preventDefault(), i.select(K));
    });
    C = Vn(
      C,
      (Q) => /* @__PURE__ */ f.jsx(wT, { value: i, children: Q }),
      [i]
    );
    const V = i.panels.useState(
      () => {
        var Q;
        return g || ((Q = i == null ? void 0 : i.panels.item(D)) == null ? void 0 : Q.tabId);
      }
    ), F = i.useState(
      (Q) => !!V && Q.selectedId === V
    ), Y = q5({ open: F }), W = Y.useState("mounted");
    return C = Te(G({
      id: D,
      role: "tabpanel",
      "aria-labelledby": V || void 0
    }, C), {
      children: h && !W ? null : C.children,
      ref: An(R, C.ref),
      onKeyDown: P
    }), C = N2(G({
      // If the tab panel is rendered as part of another composite widget such
      // as combobox, it should not be focusable.
      focusable: !i.composite && !T
    }, C)), C = Q5(G({ store: Y }, C)), C = gh(Te(G({ store: i.panels }, C), { getItem: A })), C;
  }
), CT = Oe(function(t) {
  const a = FF(t);
  return Ae(BF, a);
});
function UF(e = {}) {
  var t = e, {
    combobox: a
  } = t, i = jp(t, [
    "combobox"
  ]);
  const h = kp(
    i.store,
    Tp(a, [
      "value",
      "items",
      "renderedItems",
      "baseElement",
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  mh(i, h);
  const g = h.getState(), m = xh(mn(_t({}, i), {
    store: h,
    virtualFocus: st(
      i.virtualFocus,
      g.virtualFocus,
      !0
    ),
    includesBaseElement: st(
      i.includesBaseElement,
      g.includesBaseElement,
      !1
    ),
    activeId: st(
      i.activeId,
      g.activeId,
      i.defaultActiveId,
      null
    ),
    orientation: st(
      i.orientation,
      g.orientation,
      "vertical"
    )
  })), C = nw(mn(_t({}, i), {
    store: h,
    placement: st(
      i.placement,
      g.placement,
      "bottom-start"
    )
  })), S = new String(""), R = mn(_t(_t({}, m.getState()), C.getState()), {
    value: st(
      i.value,
      g.value,
      i.defaultValue,
      S
    ),
    setValueOnMove: st(
      i.setValueOnMove,
      g.setValueOnMove,
      !1
    ),
    selectElement: st(g.selectElement, null),
    labelElement: st(g.labelElement, null)
  }), D = fo(R, m, C, h);
  return Aa(
    D,
    () => xa(D, ["value", "items"], (T) => {
      if (T.value !== S || !T.items.length)
        return;
      const j = T.items.find(
        (A) => !A.disabled && A.value != null
      );
      (j == null ? void 0 : j.value) != null && D.setState("value", j.value);
    })
  ), Aa(
    D,
    () => xa(D, ["mounted", "items", "value"], (T) => {
      if (a || T.mounted)
        return;
      const j = wM(T.value), A = j[j.length - 1];
      if (A == null)
        return;
      const L = T.items.find(
        (P) => !P.disabled && P.value === A
      );
      L && D.setState("activeId", L.id);
    })
  ), Aa(
    D,
    () => I2(D, ["setValueOnMove", "moves"], (T) => {
      const { mounted: j, value: A, activeId: L } = D.getState();
      if (!T.setValueOnMove && j || Array.isArray(A) || !T.moves || !L)
        return;
      const P = m.item(L);
      !P || P.disabled || P.value == null || D.setState("value", P.value);
    })
  ), mn(_t(_t(_t({}, m), C), D), {
    combobox: a,
    setValue: (T) => D.setState("value", T),
    setSelectElement: (T) => D.setState("selectElement", T),
    setLabelElement: (T) => D.setState("labelElement", T)
  });
}
function YF(e, t, a) {
  return _1(t, [a.combobox]), ir(e, a, "value", "setValue"), ir(e, a, "setValueOnMove"), Object.assign(
    rw(
      Sh(e, t, a),
      t,
      a
    ),
    { combobox: a.combobox }
  );
}
function Pp(e = {}) {
  const t = _h();
  e = Te(G({}, e), {
    combobox: e.combobox !== void 0 ? e.combobox : t
  });
  const [a, i] = bi(UF, e);
  return YF(a, i, e);
}
var $F = "span", WF = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = xf();
    return i = i || g, h = Sx(G({ store: i }, h)), h;
  }
), yw = Oe(function(t) {
  const a = WF(t);
  return Ae($F, a);
}), zF = "button";
function qF(e) {
  return Array.from(e.selectedOptions).map((t) => t.value);
}
function l5(e, t) {
  return () => {
    const a = t();
    if (!a)
      return;
    let i = 0, h = e.item(a);
    const g = h;
    for (; h && h.value == null; ) {
      const m = t(++i);
      if (!m)
        return;
      if (h = e.item(m), h === g)
        break;
    }
    return h == null ? void 0 : h.id;
  };
}
var GF = ke(function(t) {
  var a = t, {
    store: i,
    name: h,
    form: g,
    required: m,
    showOnKeyDown: C = !0,
    moveOnKeyDown: S = !0,
    toggleOnClick: R = !1,
    toggleOnPress: D = !R
  } = a, T = Fe(a, [
    "store",
    "name",
    "form",
    "required",
    "showOnKeyDown",
    "moveOnKeyDown",
    "toggleOnClick",
    "toggleOnPress"
  ]);
  const j = s3();
  i = i || j, Zt(
    i,
    process.env.NODE_ENV !== "production" && "Select must receive a `store` prop or be wrapped in a SelectProvider component."
  ), D = R ? !1 : D;
  const A = T.onKeyDown, L = er(C), P = er(S), V = er(D), Y = i.useState("placement").split("-")[0], W = i.useState("value"), Q = Array.isArray(W), $ = rt((ie) => {
    var _e;
    if (A == null || A(ie), ie.defaultPrevented || !i)
      return;
    const { orientation: Ze, items: mt, activeId: Pe } = i.getState();
    (ie.key === " " || ie.key === "Enter") && V(ie) && (ie.preventDefault(), i.toggle());
    const Vt = Ze !== "horizontal", Dt = Ze !== "vertical", Qe = !!((_e = mt.find((sr) => !sr.disabled && sr.value != null)) != null && _e.rowId), wt = {
      ArrowUp: (Qe || Vt) && l5(i, i.up),
      ArrowRight: (Qe || Dt) && l5(i, i.next),
      ArrowDown: (Qe || Vt) && l5(i, i.down),
      ArrowLeft: (Qe || Dt) && l5(i, i.previous)
    }[ie.key];
    wt && P(ie) && (ie.preventDefault(), i.move(wt()));
    const St = Y === "top" || Y === "bottom";
    ({
      ArrowDown: St,
      ArrowUp: St,
      ArrowLeft: Y === "left",
      ArrowRight: Y === "right"
    })[ie.key] && L(ie) && (ie.preventDefault(), i.move(Pe), L2(ie.currentTarget, "keyup", i.show));
  }), le = T.onMouseDown, te = rt((ie) => {
    if (le == null || le(ie), ie.defaultPrevented || ie.button || ie.ctrlKey || !V(ie))
      return;
    const _e = ie.currentTarget;
    L2(_e, "focusin", () => {
      i == null || i.setDisclosureElement(_e), i == null || i.toggle();
    });
  });
  T = Vn(
    T,
    (ie) => /* @__PURE__ */ f.jsx(vT, { value: i, children: ie }),
    [i]
  );
  const [Se, re] = Qt(!1), ve = Pt(!1);
  gt(() => {
    const ie = ve.current;
    ve.current = !1, !ie && re(!1);
  }, [W]);
  const K = i.useState((ie) => {
    var _e;
    return (_e = ie.labelElement) == null ? void 0 : _e.id;
  }), de = T["aria-label"], fe = T["aria-labelledby"] || K, xe = i.useState((ie) => {
    if (h)
      return ie.items;
  }), Le = Lr(() => [...new Set(xe == null ? void 0 : xe.map((ie) => ie.value).filter((ie) => ie != null))], [xe]);
  T = Vn(
    T,
    (ie) => h ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsxs(
        "select",
        {
          style: {
            border: 0,
            clip: "rect(0 0 0 0)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            whiteSpace: "nowrap",
            width: "1px"
          },
          tabIndex: -1,
          "aria-hidden": !0,
          "aria-label": de,
          "aria-labelledby": fe,
          name: h,
          form: g,
          required: m,
          value: W,
          multiple: Q,
          onFocus: () => {
            var _e;
            return (_e = i == null ? void 0 : i.getState().selectElement) == null ? void 0 : _e.focus();
          },
          onChange: (_e) => {
            ve.current = !0, re(!0), i == null || i.setValue(
              Q ? qF(_e.target) : _e.target.value
            );
          },
          children: [
            wM(W).map((_e) => _e == null || Le.includes(_e) ? null : /* @__PURE__ */ f.jsx("option", { value: _e, children: _e }, _e)),
            Le.map((_e) => /* @__PURE__ */ f.jsx("option", { value: _e, children: _e }, _e))
          ]
        }
      ),
      ie
    ] }) : ie,
    [
      i,
      de,
      fe,
      h,
      g,
      m,
      W,
      Q,
      Le
    ]
  );
  const be = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    W,
    /* @__PURE__ */ f.jsx(yw, {})
  ] }), Ue = i.useState("contentElement");
  return T = Te(G({
    role: "combobox",
    "aria-autocomplete": "none",
    "aria-labelledby": K,
    "aria-haspopup": vh(Ue, "listbox"),
    "data-autofill": Se || void 0,
    "data-name": h,
    children: be
  }, T), {
    ref: An(i.setSelectElement, T.ref),
    onKeyDown: $,
    onMouseDown: te
  }), T = Cx(G({ store: i, toggleOnClick: R }, T)), T = X4(G({ store: i }, T)), T;
}), f3 = Oe(function(t) {
  const a = GF(t);
  return Ae(zF, a);
});
function bT(e = {}) {
  const t = Pp(e);
  return /* @__PURE__ */ f.jsx(kF, { value: t, children: e.children });
}
var KF = "div", QF = ke(
  function(t) {
    return t = J5(t), t;
  }
), _T = Oe(function(t) {
  const a = QF(t);
  return Ae(KF, a);
}), XF = "div", JF = ke(
  function(t) {
    return t = ew(t), t;
  }
), RT = Oe(function(t) {
  const a = JF(t);
  return Ae(XF, a);
}), eU = "span", tU = ke(
  function(t) {
    var a = t, { checked: i } = a, h = Fe(a, ["store", "checked"]);
    const g = Yo(pT);
    return i = i ?? g, h = Y5(Te(G({}, h), { checked: i })), h;
  }
), ET = Oe(function(t) {
  const a = tU(t);
  return Ae(eU, a);
}), nU = "div";
function rU(e, t) {
  if (t != null)
    return e == null ? !1 : Array.isArray(e) ? e.includes(t) : e === t;
}
var aU = ke(
  function(t) {
    var a = t, {
      store: i,
      value: h,
      getItem: g,
      hideOnClick: m,
      setValueOnClick: C = h != null,
      preventScrollOnKeyDown: S = !0,
      focusOnHover: R = !0
    } = a, D = Fe(a, [
      "store",
      "value",
      "getItem",
      "hideOnClick",
      "setValueOnClick",
      "preventScrollOnKeyDown",
      "focusOnHover"
    ]), T;
    const j = AF();
    i = i || j, Zt(
      i,
      process.env.NODE_ENV !== "production" && "SelectItem must be wrapped in a SelectList or SelectPopover component."
    );
    const A = Ia(D.id), L = mf(D), P = Ir(
      (re) => {
        const ve = Te(G({}, re), {
          value: L ? void 0 : h,
          children: h
        });
        return g ? g(ve) : ve;
      },
      [L, h, g]
    ), V = i.useState(
      (re) => Array.isArray(re.value)
    );
    m = m ?? (h != null && !V);
    const F = D.onClick, Y = er(C), W = er(m), Q = rt((re) => {
      F == null || F(re), !re.defaultPrevented && (Py(re) || Zy(re) || (Y(re) && h != null && (i == null || i.setValue((ve) => Array.isArray(ve) ? ve.includes(h) ? ve.filter((K) => K !== h) : [...ve, h] : h)), W(re) && (i == null || i.hide())));
    }), $ = i.useState((re) => rU(re.value, h));
    D = Vn(
      D,
      (re) => /* @__PURE__ */ f.jsx(pT.Provider, { value: $ ?? !1, children: re }),
      [$]
    );
    const le = i.useState("contentElement"), te = i.useState((re) => re.activeId !== A && (i != null && i.item(re.activeId)) || re.value == null || h == null ? !1 : Array.isArray(re.value) ? re.value[re.value.length - 1] === h : re.value === h);
    D = Te(G({
      id: A,
      role: ky(le),
      "aria-selected": $,
      children: h
    }, D), {
      autoFocus: (T = D.autoFocus) != null ? T : te,
      onClick: Q
    }), D = F2(G({
      store: i,
      getItem: P,
      preventScrollOnKeyDown: S
    }, D));
    const Se = er(R);
    return D = tw(Te(G({
      store: i
    }, D), {
      // We have to disable focusOnHover when the popup is closed, otherwise
      // the active item will change to null (the container) when the popup is
      // closed by clicking on an item.
      focusOnHover(re) {
        if (!Se(re))
          return !1;
        const ve = i == null ? void 0 : i.getState();
        return !!(ve != null && ve.open);
      }
    })), D;
  }
), xw = Ha(
  Oe(function(t) {
    const a = aU(t);
    return Ae(nU, a);
  })
), oU = "div", iU = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = s3();
    i = i || g, Zt(
      i,
      process.env.NODE_ENV !== "production" && "SelectLabel must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const m = Ia(h.id), C = h.onClick, S = rt((R) => {
      C == null || C(R), !R.defaultPrevented && queueMicrotask(() => {
        const D = i == null ? void 0 : i.getState().selectElement;
        D == null || D.focus(), D == null || D.click();
      });
    });
    return h = Te(G({
      id: m
    }, h), {
      ref: An(i.setLabelElement, h.ref),
      onClick: S,
      style: G({
        cursor: "default"
      }, h.style)
    }), La(h);
  }
), Sw = Ha(
  Oe(function(t) {
    const a = iU(t);
    return Ae(oU, a);
  })
), lU = "div", MT = ke(
  function(t) {
    var a = t, {
      store: i,
      resetOnEscape: h = !0,
      hideOnEnter: g = !0,
      composite: m,
      alwaysVisible: C
    } = a, S = Fe(a, [
      "store",
      "resetOnEscape",
      "hideOnEnter",
      "focusOnMove",
      "composite",
      "alwaysVisible"
    ]);
    const R = s3();
    i = i || R, Zt(
      i,
      process.env.NODE_ENV !== "production" && "SelectList must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const D = Pt(null), T = Ia(S.id), j = i.useState("value"), A = Array.isArray(j), [L, P] = Qt(j), V = i.useState("mounted");
    gt(() => {
      V || P(j);
    }, [V, j]), h = h && !A;
    const F = S.onKeyDown, Y = er(h), W = er(g), Q = rt((de) => {
      F == null || F(de), !de.defaultPrevented && (de.key === "Escape" && Y(de) && (i == null || i.setValue(L)), (de.key === " " || de.key === "Enter") && Ci(de) && W(de) && (de.preventDefault(), i == null || i.hide()));
    });
    S = Vn(
      S,
      (de) => /* @__PURE__ */ f.jsx(vT, { value: i, children: de }),
      [i]
    );
    const $ = i.useState((de) => {
      var fe;
      return (fe = de.labelElement) == null ? void 0 : fe.id;
    }), le = !!i.combobox;
    m = m ?? !le, m && (S = G({ role: "listbox" }, S));
    const te = yE(D, "role", S.role), re = (m || (te === "listbox" || te === "menu" || te === "tree" || te === "grid")) && A || void 0, ve = q4(V, S.hidden, C), K = ve ? Te(G({}, S.style), { display: "none" }) : S.style;
    return S = Te(G({
      id: T,
      "aria-labelledby": $,
      "aria-multiselectable": re,
      hidden: ve
    }, S), {
      ref: An(T ? i.setContentElement : null, D, S.ref),
      style: K,
      onKeyDown: Q
    }), S = Ch(Te(G({ store: i }, S), { composite: m })), S = X4(G({ store: i, typeahead: !le }, S)), S;
  }
), uU = Oe(function(t) {
  const a = MT(t);
  return Ae(lU, a);
}), sU = "div", cU = ke(
  function(t) {
    var a = t, { store: i, alwaysVisible: h } = a, g = Fe(a, ["store", "alwaysVisible"]);
    const m = s3();
    return i = i || m, g = MT(G({ store: i, alwaysVisible: h }, g)), g = sw(G({ store: i, alwaysVisible: h }, g)), g;
  }
), Cw = U2(
  Oe(function(t) {
    const a = cU(t);
    return Ae(sU, a);
  }),
  s3
), fU = "div", dU = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = xf();
    i = i || g, Zt(
      i,
      process.env.NODE_ENV !== "production" && "SelectRow must be wrapped in a SelectList or SelectPopover component"
    );
    const m = i.useState("contentElement"), S = vh(m) === "grid" ? "row" : "presentation";
    return h = G({ role: S }, h), h = sx(G({ store: i }, h)), h;
  }
), hU = Oe(function(t) {
  const a = dU(t);
  return Ae(fU, a);
}), vU = "hr", pU = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = xf();
    return i = i || g, h = Q4(G({ store: i }, h)), h;
  }
), mU = Oe(function(t) {
  const a = pU(t);
  return Ae(vU, a);
});
function gU(e = {}) {
  var t = jp(e, []), a;
  const i = (a = t.store) == null ? void 0 : a.getState(), h = xh(mn(_t({}, t), {
    focusLoop: st(t.focusLoop, i == null ? void 0 : i.focusLoop, !0)
  })), g = mn(_t({}, h.getState()), {
    value: st(
      t.value,
      i == null ? void 0 : i.value,
      t.defaultValue,
      null
    )
  }), m = fo(g, h, t.store);
  return mn(_t(_t({}, h), m), {
    setValue: (C) => m.setState("value", C)
  });
}
function wU(e, t, a) {
  return e = Sh(e, t, a), ir(e, a, "value", "setValue"), e;
}
function TT(e = {}) {
  const [t, a] = bi(gU, e);
  return wU(t, a, e);
}
function OT(e = {}) {
  const t = TT(e);
  return /* @__PURE__ */ f.jsx(iH, { value: t, children: e.children });
}
var yU = "div", xU = ke(
  function(t) {
    var a = t, { store: i } = a, h = Fe(a, ["store"]);
    const g = oH();
    return i = i || g, Zt(
      i,
      process.env.NODE_ENV !== "production" && "RadioGroup must receive a `store` prop or be wrapped in a RadioProvider component."
    ), h = Vn(
      h,
      (m) => /* @__PURE__ */ f.jsx(lH, { value: i, children: m }),
      [i]
    ), h = G({
      role: "radiogroup"
    }, h), h = Ch(G({ store: i }, h)), h;
  }
), DT = Oe(function(t) {
  const a = xU(t);
  return Ae(yU, a);
});
const FQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: $5,
  Checkbox: kE,
  CheckboxCheck: dI,
  CheckboxProvider: uI,
  Collection: IL,
  CollectionItem: PL,
  CollectionProvider: HL,
  Combobox: iw,
  ComboboxCancel: BP,
  ComboboxDisclosure: $P,
  ComboboxGroup: TM,
  ComboboxGroupLabel: MM,
  ComboboxItem: Z4,
  ComboboxItemCheck: XP,
  ComboboxItemValue: nV,
  ComboboxLabel: sV,
  ComboboxList: hx,
  ComboboxPopover: NM,
  ComboboxProvider: EM,
  ComboboxRow: hN,
  ComboboxSeparator: mN,
  Command: iI,
  Composite: tP,
  CompositeGroup: iP,
  CompositeGroupLabel: aP,
  CompositeHover: cP,
  CompositeItem: ey,
  CompositeProvider: nP,
  CompositeRow: dP,
  CompositeSeparator: mP,
  CompositeTypeahead: CP,
  Dialog: lx,
  DialogDescription: IZ,
  DialogDisclosure: ZZ,
  DialogDismiss: VZ,
  DialogHeading: UZ,
  DialogProvider: ux,
  Disclosure: qH,
  DisclosureContent: aZ,
  DisclosureProvider: GH,
  FocusTrap: xp,
  FocusTrapRegion: UH,
  Focusable: rI,
  Form: ZE,
  FormCheckbox: MI,
  FormControl: _I,
  FormDescription: DI,
  FormError: VE,
  FormField: II,
  FormGroup: YI,
  FormGroupLabel: NI,
  FormInput: Jy,
  FormLabel: FE,
  FormProvider: PE,
  FormPush: JI,
  FormRadio: EH,
  FormRadioGroup: nH,
  FormRemove: jH,
  FormReset: LH,
  FormSubmit: qE,
  Group: FI,
  GroupLabel: ZI,
  Heading: BZ,
  HeadingLevel: fM,
  Hovercard: KN,
  HovercardAnchor: sB,
  HovercardArrow: KB,
  HovercardDescription: vB,
  HovercardDisclosure: JB,
  HovercardDismiss: yB,
  HovercardHeading: DB,
  HovercardProvider: zB,
  Menu: JM,
  MenuArrow: tT,
  MenuBar: tB,
  MenuBarProvider: nB,
  MenuButton: nT,
  MenuButtonArrow: lB,
  MenuDescription: gB,
  MenuDismiss: CB,
  MenuGroup: TB,
  MenuGroupLabel: RB,
  MenuHeading: iT,
  MenuItem: lT,
  MenuItemCheck: IB,
  MenuItemCheckbox: BB,
  MenuItemRadio: YB,
  MenuList: WN,
  MenuProvider: eT,
  MenuSeparator: uT,
  Menubar: ZN,
  MenubarProvider: WM,
  Popover: VM,
  PopoverAnchor: AP,
  PopoverArrow: Zp,
  PopoverDescription: SN,
  PopoverDisclosure: fw,
  PopoverDisclosureArrow: _N,
  PopoverDismiss: MN,
  PopoverHeading: ON,
  PopoverProvider: BM,
  Portal: jZ,
  PortalContext: oy,
  Radio: zE,
  RadioGroup: DT,
  RadioProvider: OT,
  Role: H4,
  Select: f3,
  SelectArrow: yw,
  SelectGroup: RT,
  SelectGroupLabel: _T,
  SelectItem: xw,
  SelectItemCheck: ET,
  SelectLabel: Sw,
  SelectList: uU,
  SelectPopover: Cw,
  SelectProvider: bT,
  SelectRow: hU,
  SelectSeparator: mU,
  Separator: vP,
  Tab: yT,
  TabList: ST,
  TabPanel: CT,
  TabProvider: xT,
  Toolbar: wF,
  ToolbarContainer: RF,
  ToolbarInput: TF,
  ToolbarItem: CF,
  ToolbarProvider: yF,
  ToolbarSeparator: jF,
  Tooltip: cT,
  TooltipAnchor: fT,
  TooltipArrow: dT,
  TooltipProvider: iF,
  VisuallyHidden: PH,
  useCheckboxContext: TE,
  useCheckboxStore: Y4,
  useCollectionContext: EE,
  useCollectionStore: RE,
  useComboboxContext: fx,
  useComboboxStore: J4,
  useCompositeContext: B2,
  useCompositeStore: xM,
  useDialogContext: z4,
  useDialogStore: G4,
  useDisclosureContext: YH,
  useDisclosureStore: q5,
  useFormContext: Rl,
  useFormStore: Gy,
  useHovercardContext: zM,
  useHovercardStore: KM,
  useMenuBarContext: NN,
  useMenuBarStore: UN,
  useMenuContext: yf,
  useMenuStore: Tx,
  useMenubarContext: bx,
  useMenubarStore: dw,
  usePopoverContext: bh,
  usePopoverStore: cx,
  useRadioContext: YE,
  useRadioStore: TT,
  useSelectContext: xf,
  useSelectStore: Pp,
  useTabContext: Hx,
  useTabStore: ww,
  useToolbarContext: l3,
  useToolbarStore: Lx,
  useTooltipContext: sT,
  useTooltipStore: Ax
}, Symbol.toStringTag, { value: "Module" }));
function jT(e) {
  var t, a, i = "";
  if (typeof e == "string" || typeof e == "number") i += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (a = jT(e[t])) && (i && (i += " "), i += a);
  else for (t in e) e[t] && (i && (i += " "), i += t);
  return i;
}
function Br() {
  for (var e, t, a = 0, i = ""; a < arguments.length; ) (e = arguments[a++]) && (t = jT(e)) && (i && (i += " "), i += t);
  return i;
}
var SU = "f08kno0";
const ct = Sa.forwardRef(
  ({ as: e = "div", cssClass: t, hiddenScroll: a, ...i }, h) => {
    const g = {}, m = {}, C = Br(t);
    for (const S in i)
      W8.properties.has(S) ? g[S] = i[S] : m[S] = i[S];
    return Sa.createElement(e, {
      className: Br([
        W8(g),
        C,
        { [SU]: a }
      ]),
      ref: h,
      ...m
    });
  }
);
ct.displayName = "Box";
function CU(e, t) {
  if (typeof e != "object" || !e) return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var i = a.call(e, t);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function bU(e) {
  var t = CU(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function _U(e, t, a) {
  return t = bU(t), t in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}
function dR(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(h) {
      return Object.getOwnPropertyDescriptor(e, h).enumerable;
    })), a.push.apply(a, i);
  }
  return a;
}
function hR(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dR(Object(a), !0).forEach(function(i) {
      _U(e, i, a[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : dR(Object(a)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(a, i));
    });
  }
  return e;
}
function vR(e, t) {
  var a = {};
  for (var i in e)
    a[i] = t(e[i], i);
  return a;
}
var RU = (e, t, a) => {
  for (var i of Object.keys(e)) {
    var h;
    if (e[i] !== ((h = t[i]) !== null && h !== void 0 ? h : a[i]))
      return !1;
  }
  return !0;
}, $o = (e) => {
  var t = (a) => {
    var i = e.defaultClassName, h = hR(hR({}, e.defaultVariants), a);
    for (var g in h) {
      var m, C = (m = h[g]) !== null && m !== void 0 ? m : e.defaultVariants[g];
      if (C != null) {
        var S = C;
        typeof S == "boolean" && (S = S === !0 ? "true" : "false");
        var R = (
          // @ts-expect-error
          e.variantClassNames[g][S]
        );
        R && (i += " " + R);
      }
    }
    for (var [D, T] of e.compoundVariants)
      RU(D, h, e.defaultVariants) && (i += " " + T);
    return i;
  };
  return t.variants = () => Object.keys(e.variantClassNames), t.classNames = {
    get base() {
      return e.defaultClassName.split(" ")[0];
    },
    get variants() {
      return vR(e.variantClassNames, (a) => vR(a, (i) => i.split(" ")[0]));
    }
  }, t;
}, EU = $o({ defaultClassName: "_1x3701w0", variantClassNames: { lines: { 1: "_1x3701w1", 2: "_1x3701w2", 3: "_1x3701w3", 4: "_1x3701w4" } }, defaultVariants: {}, compoundVariants: [] });
const Zx = Sa.forwardRef(
  ({ children: e, lines: t }, a) => /* @__PURE__ */ f.jsx(ct, { as: "span", ref: a, cssClass: EU({ lines: t }), children: e })
);
Zx.displayName = "Truncate";
var MU = { fontSize: "11px", lineHeight: "12px", "::before": { content: "''", marginBottom: "-0.1818em", display: "table" }, "::after": { content: "''", marginTop: "-0.1818em", display: "table" } }, TU = { fontSize: "12px", lineHeight: "16px", "::before": { content: "''", marginBottom: "-0.303em", display: "table" }, "::after": { content: "''", marginTop: "-0.303em", display: "table" } }, OU = { fontSize: "13px", lineHeight: "20px", "::before": { content: "''", marginBottom: "-0.4056em", display: "table" }, "::after": { content: "''", marginTop: "-0.4056em", display: "table" } }, DU = { fontSize: "14px", lineHeight: "20px", "::before": { content: "''", marginBottom: "-0.3506em", display: "table" }, "::after": { content: "''", marginTop: "-0.3506em", display: "table" } }, jU = { fontSize: "16px", lineHeight: "24px", "::before": { content: "''", marginBottom: "-0.3864em", display: "table" }, "::after": { content: "''", marginTop: "-0.3864em", display: "table" } }, UQ = { fontSize: "13px", lineHeight: "20px", "::before": { content: "''", marginBottom: "-0.4462em", display: "table" }, "::after": { content: "''", marginTop: "-0.3942em", display: "table" } }, AU = { body: { fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol" }, heading: { fontFamily: "Inter, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif" }, monospace: { fontFamily: "IBM Plex Mono, Menlo, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier, monospace" } }, YQ = { family: AU, size: { xxSmall: MU, xSmall: TU, small: OU, medium: DU, large: jU }, weight: { regular: { fontWeight: "400" }, medium: { fontWeight: "500" }, bold: { fontWeight: "600" } } }, kU = $o({ defaultClassName: "_1j32j980", variantClassNames: { align: { center: "_1j32j981", left: "_1j32j982", right: "_1j32j983" }, family: { body: "_1j32j984", heading: "_1j32j985", monospace: "_1j32j986" }, size: { xxSmall: "_1j32j987", xSmall: "_1j32j988", small: "_1j32j989", medium: "_1j32j98a", large: "_1j32j98b" }, weight: { regular: "_1j32j98c", medium: "_1j32j98d", bold: "_1j32j98e" }, case: { capital: "_1j32j98f", upper: "_1j32j98g", lower: "_1j32j98h" }, break: { all: "_1j32j98i", word: "_1j32j98j", normal: "_1j32j98k", none: "_1j32j98l" } }, defaultVariants: { family: "body", size: "small", weight: "medium" }, compoundVariants: [[{ family: "monospace", size: "small" }, "_1j32j98m"], [{ family: "monospace", size: "xSmall" }, "_1j32j98n"], [{ family: "monospace", size: "xxSmall" }, "_1j32j98o"]] });
const Fr = Sa.forwardRef(
  ({
    as: e,
    children: t,
    color: a,
    decoration: i,
    display: h,
    lines: g,
    transform: m,
    userSelect: C,
    cssClass: S,
    title: R,
    whiteSpace: D,
    wrap: T,
    ...j
  }, A) => {
    const L = g ? /* @__PURE__ */ f.jsx(Zx, { ref: A, lines: g, children: t }) : t;
    return /* @__PURE__ */ f.jsx(
      ct,
      {
        as: e,
        color: a,
        cssClass: Br(kU({ ...j }), S),
        display: h,
        overflowWrap: T,
        ref: g ? void 0 : A,
        textDecoration: i,
        textTransform: m,
        title: R,
        userSelect: C,
        whiteSpace: D,
        children: L
      }
    );
  }
);
Fr.displayName = "Text";
var LU = $o({ defaultClassName: "_989awr4", variantClassNames: { size: { small: "_989awr5 _989awr0 _1faqfmv4a _1faqfmv4u", medium: "_989awr6 _989awr1 _1faqfmv4b _1faqfmv4v", large: "_989awr7 _989awr2 _1faqfmv4c _1faqfmv4w" }, shape: { rounded: "_989awr8", basic: "_989awr9" }, variant: { white: "_989awra", gray: "_989awrb", outlineGray: "_989awrc", green: "_989awrd", blue: "_989awre _989awr3 _1faqfmvcz", red: "_989awrf", yellow: "_989awrg", purple: "_989awrh", outlinePurple: "_989awri" } }, defaultVariants: { size: "small", shape: "basic", variant: "white" }, compoundVariants: [[{ size: "small", shape: "basic" }, "_989awrj"], [{ size: "medium", shape: "basic" }, "_989awrk"], [{ size: "large", shape: "basic" }, "_989awrl"], [{ size: "small", shape: "rounded" }, "_989awrm"], [{ size: "medium", shape: "rounded" }, "_989awrn"], [{ size: "large", shape: "rounded" }, "_989awro"]] });
const Vp = ({
  iconStart: e,
  iconEnd: t,
  label: a,
  lines: i,
  cssClass: h,
  size: g,
  shape: m,
  variant: C,
  ...S
}) => {
  let R;
  switch (g) {
    case "large":
      R = "small";
      break;
    default:
      R = "xSmall";
  }
  let D;
  switch (C) {
    case "red":
      D = "r11";
      break;
    case "blue":
      D = "lb700";
      break;
    case "yellow":
      D = "y11";
      break;
    case "green":
      D = "good";
      break;
    case "gray":
      D = "default";
      break;
    case "outlineGray":
      D = "default";
      break;
    case "outlinePurple":
      D = "p6";
      break;
    case "white":
      D = "moderate";
      break;
    case "purple":
      D = "informative";
      break;
    default:
      D = "moderate";
  }
  return /* @__PURE__ */ f.jsxs(
    ct,
    {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "2",
      cssClass: [LU({ size: g, shape: m, variant: C }), h],
      ...S,
      children: [
        e,
        a && /* @__PURE__ */ f.jsx(Fr, { size: R, color: D, as: "span", lines: i, children: a }),
        t
      ]
    }
  );
};
var IU = { grey: "inset 0px -1px 0px rgba(0, 0, 0, 0.1)", primary: "inset 0px -1px 0px rgba(0, 0, 0, 0.32)", neutral: "0 0 0 1px #f9f8f9 inset", n5: "0 0 0 1px #e9e8ea inset" }, Px = "small", dy = $o({ defaultClassName: "_6syg4r0", variantClassNames: { size: { xSmall: "_6syg4r1", small: "_6syg4r2", medium: "_6syg4r3", large: "_6syg4r4", xLarge: "_6syg4r5" }, emphasis: { high: "_6syg4r6", medium: "_6syg4r7", low: "_6syg4r8" }, kind: { primary: "_6syg4r9", secondary: "_6syg4ra", danger: "_6syg4rb" } }, defaultVariants: { size: "small" }, compoundVariants: [[{ kind: "primary", emphasis: "high" }, "_6syg4rc"]] }), AT = $o({ defaultClassName: "_6syg4rh _6syg4rd _1faqfmvsz _1faqfmvex _1faqfmv21 _1faqfmvwf", variantClassNames: { emphasis: { high: "_6syg4ri", medium: "_6syg4rj", low: "_6syg4rk" }, kind: { primary: "_6syg4rl", secondary: "_6syg4rm", danger: "_6syg4rn" }, size: { xSmall: "_6syg4ro _6syg4re _1faqfmv4c _1faqfmv4w _1faqfmv3 _1faqfmvuf", small: "_6syg4rp _6syg4rf _1faqfmv4c _1faqfmv4w _1faqfmv5 _1faqfmvuj", medium: "_6syg4rq _6syg4rg _1faqfmv4e _1faqfmv4y _1faqfmv5 _1faqfmvuj" } }, defaultVariants: { kind: "primary", emphasis: "high", size: "small" }, compoundVariants: [[{ kind: "primary", emphasis: "high" }, "_6syg4rr"], [{ kind: "primary", emphasis: "medium" }, "_6syg4rs"], [{ kind: "primary", emphasis: "low" }, "_6syg4rt"], [{ kind: "secondary", emphasis: "high" }, "_6syg4ru"], [{ kind: "secondary", emphasis: "medium" }, "_6syg4rv"], [{ kind: "secondary", emphasis: "low" }, "_6syg4rw"]] });
const $Q = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  defaultSize: Px,
  iconVariants: dy,
  shadows: IU,
  variants: AT
}, Symbol.toStringTag, { value: "Module" })), HU = {
  xSmall: "xSmall",
  small: "small",
  medium: "small",
  large: "small",
  xLarge: "large"
}, d3 = Sa.forwardRef(
  ({
    children: e,
    iconLeft: t,
    iconRight: a,
    size: i = Px,
    kind: h,
    emphasis: g,
    className: m,
    cssClass: C,
    disabled: S,
    ...R
  }, D) => /* @__PURE__ */ f.jsx(
    $5,
    {
      disabled: S,
      className: Br(
        AT({
          kind: h,
          size: i,
          emphasis: g
        }),
        m,
        C
      ),
      ref: D,
      type: "button",
      ...R,
      children: /* @__PURE__ */ f.jsx(
        ZU,
        {
          iconLeft: t,
          iconRight: a,
          size: i,
          kind: h,
          emphasis: g,
          disabled: S,
          children: e
        }
      )
    }
  )
), ZU = ({
  children: e,
  disabled: t,
  emphasis: a,
  iconLeft: i,
  iconRight: h,
  kind: g,
  size: m = Px
}) => {
  const C = HU[m];
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    i && /* @__PURE__ */ f.jsx(
      ct,
      {
        as: "span",
        display: "inline-flex",
        disabled: t,
        cssClass: dy({
          size: m,
          emphasis: a,
          kind: g
        }),
        children: i
      }
    ),
    e && /* @__PURE__ */ f.jsx(
      Fr,
      {
        userSelect: "none",
        size: C,
        align: "center",
        display: "inline-flex",
        children: e
      }
    ),
    h && /* @__PURE__ */ f.jsx(
      ct,
      {
        as: "span",
        display: "inline-flex",
        disabled: t,
        cssClass: dy({
          size: m,
          emphasis: a,
          kind: g
        }),
        children: h
      }
    )
  ] });
};
var PU = $o({ defaultClassName: "oor2ha0", variantClassNames: { shape: { thin: "oor2ha1", square: "oor2ha2" }, emphasis: { low: "oor2ha3", medium: "oor2ha4", high: "oor2ha5", none: "oor2ha6" }, size: { xSmall: "oor2ha7", small: "oor2ha8", medium: "oor2ha9", minimal: "oor2haa" }, kind: { primary: "oor2hab", secondary: "oor2hac" } }, defaultVariants: { kind: "primary", emphasis: "medium", shape: "square", size: "small" }, compoundVariants: [[{ size: "xSmall", shape: "thin" }, "oor2had"], [{ size: "small", shape: "thin" }, "oor2hae"], [{ size: "medium", shape: "thin" }, "oor2haf"], [{ emphasis: "high", kind: "primary" }, "oor2hag"], [{ emphasis: "medium", kind: "primary" }, "oor2hah"], [{ emphasis: "low", kind: "primary" }, "oor2hai"], [{ emphasis: "high", kind: "secondary" }, "oor2haj"], [{ emphasis: "medium", kind: "secondary" }, "oor2hak"], [{ emphasis: "low", kind: "secondary" }, "oor2hal"]] });
const h3 = Oy(
  ({
    icon: e,
    kind: t,
    shape: a,
    emphasis: i,
    size: h,
    onClick: g,
    disabled: m,
    cssClass: C,
    className: S,
    type: R = "button"
  }, D) => /* @__PURE__ */ f.jsx(
    ct,
    {
      as: "button",
      display: "inline-flex",
      cssClass: Br(
        PU({ kind: t, shape: a, emphasis: i, size: h }),
        S,
        C
      ),
      onClick: g,
      disabled: m,
      type: R,
      ref: D,
      children: e
    }
  )
);
var VU = "_88y39m0", NU = $o({ defaultClassName: "_88y39m1", variantClassNames: { kind: { primary: "_88y39m2", secondary: "_88y39m3", light: "_88y39m4" } }, defaultVariants: { kind: "primary" }, compoundVariants: [] });
const WQ = ({
  children: e,
  kind: t,
  ...a
}) => /* @__PURE__ */ f.jsx(
  $5,
  {
    render: /* @__PURE__ */ f.jsx("button", {}),
    className: Br(VU, NU({ kind: t })),
    type: "button",
    ...a,
    children: /* @__PURE__ */ f.jsx(Fr, { children: e })
  }
), zQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12 14 9-5-9-5-9 5 9 5Zm0 0 6.16-3.422a12.083 12.083 0 0 1 .665 6.479A11.952 11.952 0 0 0 12 20.055a11.952 11.952 0 0 0-6.824-2.998 12.078 12.078 0 0 1 .665-6.479L12 14Zm-4 6v-7.5l4-2.222"
      }
    )
  }
), qQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 3a1 1 0 0 1 1 1v9.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-1.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v1.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-9.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v9.17a3.001 3.001 0 0 1 0 5.66V20a1 1 0 1 1-2 0v-1.17a3.001 3.001 0 0 1 0-5.66V4a1 1 0 0 1 1-1Zm-6 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-6 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), GQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2.586l-3.707 3.707a1 1 0 0 1-1.414 0L7.586 17H5a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3a1 1 0 0 1 .707.293L12 18.586l3.293-3.293A1 1 0 0 1 16 15h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm1 3a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), KQ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 1 5.83V18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8.83A3.001 3.001 0 0 1 2 6Zm4 3v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9H6ZM5 5a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5Zm4 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), QQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v5.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 13.586V8a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), XQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.707-3.707a1 1 0 0 1 0 1.414L10.414 11H16a1 1 0 1 1 0 2h-5.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), JQ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10.293-3.707a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L13.586 13H8a1 1 0 1 1 0-2h5.586l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), eX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9-1.586-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 10.414V16a1 1 0 1 1-2 0v-5.586Z",
        clipRule: "evenodd"
      }
    )
  }
), tX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v15.586l5.293-5.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 1 1 1.414-1.414L11 18.586V3a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), nX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.707 4.293a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l5.293 5.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), rX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v15.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 18.586V3a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), aX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.707 7.293a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), oX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.293 7.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), iX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 1 1-2 0V5.414L8.707 7.707a1 1 0 0 1-1.414-1.414l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), lX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.293 4.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-5.293-5.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), uX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H6.414l3.293 3.293a1 1 0 0 1-1.414 1.414L5 6.414V8a1 1 0 0 1-2 0V4Zm13-1h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L17.586 5H16a1 1 0 1 1 0-2ZM9.707 14.293a1 1 0 0 1 0 1.414L6.414 19H8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1v-4a1 1 0 1 1 2 0v1.586l3.293-3.293a1 1 0 0 1 1.414 0Zm4.586 0a1 1 0 0 1 1.414 0L19 17.586V16a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.586l-3.293-3.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), sX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a1 1 0 0 1 1 1v9.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L11 15.586V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), cX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.707 6.293a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.293 3.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), fX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L15.586 13H6a1 1 0 1 1 0-2h9.586l-3.293-3.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), dX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 5.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L13 8.414V18a1 1 0 1 1-2 0V8.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l5-5Z",
        clipRule: "evenodd"
      }
    )
  }
), hX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 1 1-2 0V5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l7-7Z",
        clipRule: "evenodd"
      }
    )
  }
), vX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 4 14.928 1 1 0 1 1 1 1.732A9.96 9.96 0 0 1 11.942 22C6.446 21.968 2 17.503 2 12 2 6.477 6.477 2 12 2s10 4.477 10 10v1.5a3.5 3.5 0 0 1-6.396 1.966A5 5 0 1 1 17 12v1.5a1.5 1.5 0 0 0 3 0V12a8 8 0 0 0-8-8Zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), pX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.707 4.879A3 3 0 0 1 10.828 4H19a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-8.172a3 3 0 0 1-2.12-.879l-6.415-6.414a1 1 0 0 1 0-1.414l6.414-6.414ZM10.828 6a1 1 0 0 0-.707.293L4.414 12l5.707 5.707a1 1 0 0 0 .707.293H19a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-8.172Zm.465 3.293a1 1 0 0 1 1.414 0L14 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L15.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L14 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L12.586 12l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), mX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.133 3.13a4.42 4.42 0 0 1 5.734 0c.388.33.87.53 1.378.57A4.42 4.42 0 0 1 20.3 7.755c.04.508.24.99.57 1.378a4.42 4.42 0 0 1 0 5.734c-.33.388-.53.87-.57 1.378a4.42 4.42 0 0 1-4.055 4.055c-.508.04-.99.24-1.378.57a4.42 4.42 0 0 1-5.734 0 2.42 2.42 0 0 0-1.378-.57A4.42 4.42 0 0 1 3.7 16.245a2.42 2.42 0 0 0-.57-1.378 4.42 4.42 0 0 1 0-5.734c.33-.388.53-.87.57-1.378A4.42 4.42 0 0 1 7.755 3.7c.508-.04.99-.24 1.378-.57Zm4.437 1.522a2.42 2.42 0 0 0-3.14 0 4.42 4.42 0 0 1-2.516 1.042 2.42 2.42 0 0 0-2.22 2.22 4.42 4.42 0 0 1-1.042 2.516 2.42 2.42 0 0 0 0 3.14 4.42 4.42 0 0 1 1.042 2.516 2.42 2.42 0 0 0 2.22 2.22 4.42 4.42 0 0 1 2.516 1.042 2.42 2.42 0 0 0 3.14 0 4.42 4.42 0 0 1 2.516-1.042 2.42 2.42 0 0 0 2.22-2.22 4.42 4.42 0 0 1 1.042-2.516 2.42 2.42 0 0 0 0-3.14 4.42 4.42 0 0 1-1.042-2.516 2.42 2.42 0 0 0-2.22-2.22 4.42 4.42 0 0 1-2.516-1.042Zm2.137 4.64a1 1 0 0 1 0 1.415l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), gX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.094 5.68 18.32 16.906A8.001 8.001 0 0 0 7.094 5.68Zm9.812 12.64L5.68 7.094A8.002 8.002 0 0 0 16.906 18.32ZM4.929 4.93c3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142Z",
        clipRule: "evenodd"
      }
    )
  }
), wX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.076 3.617A1 1 0 0 1 8 3h8a1 1 0 0 1 .707 1.707L16 5.414v4.758a1 1 0 0 0 .293.707l3.84 3.84.002.002.001.001 1.157 1.157c1.89 1.89.551 5.121-2.122 5.121H4.828c-2.673 0-4.011-3.231-2.121-5.121l.828-.829h.001l4.17-4.171A1 1 0 0 0 8 10.172V5.414l-.707-.707a1 1 0 0 1-.217-1.09ZM10 5v5.172a3 3 0 0 1-.879 2.12l-2.093 2.094 1.15.23a5 5 0 0 0 3.216-.431l.317-.159a7 7 0 0 1 4.252-.648l-1.084-1.085a3 3 0 0 1-.88-2.121V5h-4Zm8.72 11.134a1 1 0 0 0-.51-.272l-2.388-.478a5 5 0 0 0-3.216.431l-.318.159a7 7 0 0 1-4.503.603l-1.932-.387a1 1 0 0 0-.903.274l-.829.829c-.63.63-.184 1.707.707 1.707h14.343c.891 0 1.337-1.077.707-1.707l-1.157-1.158h-.001Z",
        clipRule: "evenodd"
      }
    )
  }
), yX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.018 4.665a3 3 0 0 1 5.963 0A7 7 0 0 1 19 11v3.159c0 .273.109.535.302.729l1.405 1.405A1 1 0 0 1 20 18h-4a4 4 0 0 1-8 0H4a1 1 0 0 1-.707-1.707l1.405-1.405c.193-.194.302-.456.302-.73V11a7 7 0 0 1 4.018-6.335ZM10 18a2 2 0 1 0 4 0h-4Zm2-14a1 1 0 0 0-1 1v.341a1 1 0 0 1-.667.943A5.003 5.003 0 0 0 7 11v3.159c0 .669-.221 1.315-.623 1.841h11.246A3.032 3.032 0 0 1 17 14.159V11a5.002 5.002 0 0 0-3.333-4.716A1 1 0 0 1 13 5.341V5a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), xX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.447.894L12 18.618l-6.553 3.276A1 1 0 0 1 4 21V5Zm3-1a1 1 0 0 0-1 1v14.382l5.553-2.776a1 1 0 0 1 .894 0L18 19.382V5a1 1 0 0 0-1-1H7Z",
        clipRule: "evenodd"
      }
    )
  }
), SX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm12-1H9v9.382l2.553-1.276a1 1 0 0 1 .894 0L15 14.382V5ZM7 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1v11a1 1 0 0 1-1.447.894L12 15.118l-3.553 1.776A1 1 0 0 1 7 16V5Z",
        clipRule: "evenodd"
      }
    )
  }
), CX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 6.82v10.806A9.823 9.823 0 0 1 7.5 17c1.252 0 2.446.222 3.5.626V6.819C10.06 6.317 8.848 6 7.5 6c-1.348 0-2.56.317-3.5.82Zm9 0v10.806A9.823 9.823 0 0 1 16.5 17c1.252 0 2.446.222 3.5.626V6.819C19.06 6.317 17.848 6 16.5 6c-1.348 0-2.56.317-3.5.82Zm-1-1.734C10.733 4.395 9.168 4 7.5 4c-1.92 0-3.703.523-5.053 1.42A1 1 0 0 0 2 6.253v13a1 1 0 0 0 1.553.833C4.54 19.43 5.927 19 7.5 19s2.961.431 3.947 1.086a1 1 0 0 0 1.106 0C13.54 19.43 14.927 19 16.5 19s2.961.431 3.947 1.086A1 1 0 0 0 22 19.253v-13a1 1 0 0 0-.447-.833C20.203 4.523 18.42 4 16.5 4c-1.668 0-3.233.395-4.5 1.086Z",
        clipRule: "evenodd"
      }
    )
  }
), bX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h2V4ZM5 7a1 1 0 0 0-1 1v4.57A22.95 22.95 0 0 0 12 14c2.815 0 5.51-.505 8-1.43V8a1 1 0 0 0-1-1H5Zm10-2H9V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1Zm5 9.692A24.971 24.971 0 0 1 12 16a24.98 24.98 0 0 1-8-1.308V18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3.308ZM11 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), _X = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 3a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1ZM9 5a1 1 0 0 1 1 1v1h1V6a1 1 0 1 1 2 0v1h1V6a1 1 0 1 1 2 0v1a3 3 0 0 1 3 3v1a3 3 0 0 1 3 3v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a3 3 0 0 1 3-3v-1a3 3 0 0 1 3-3V6a1 1 0 0 1 1-1ZM8 9a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1H8Zm-3 4a1 1 0 0 0-1 1v.683c.369.104.725.265 1.055.485a1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0c.33-.22.686-.381 1.055-.485V14a1 1 0 0 0-1-1H5Zm15 3.868a3.704 3.704 0 0 1-4.055-.036 1.704 1.704 0 0 0-1.89 0 3.704 3.704 0 0 1-4.11 0 1.704 1.704 0 0 0-1.89 0A3.704 3.704 0 0 1 4 16.868V20h16v-3.132Z",
        clipRule: "evenodd"
      }
    )
  }
), RX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7Zm1 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm-6 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4-1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-7 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), EX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h2V3a1 1 0 0 1 1-1ZM7 6H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0V6Zm-1 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), MX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.07 5a1 1 0 0 0-.832.445l-.812 1.22A3 3 0 0 1 5.93 8H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-.93a3 3 0 0 1-2.496-1.336l-.812-1.219A1 1 0 0 0 13.93 5h-3.86Zm-2.496-.664A3 3 0 0 1 10.07 3h3.86a3 3 0 0 1 2.496 1.336l.812 1.219A1 1 0 0 0 18.07 6H19a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h.93a1 1 0 0 0 .832-.445l.812-1.22ZM12 11a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), TX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-1H5a3 3 0 0 1-3-3V7Zm6 10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6Zm8-9H9a3 3 0 0 0-3 3v3H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1Zm-2 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), OX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 13 22h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 7 22H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h2c.35 0 .687.06 1 .17V9a3 3 0 0 1 3-3h2c.35 0 .687.06 1 .17V5Zm2 14a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v14ZM14 9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9Zm-6 4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6Z",
        clipRule: "evenodd"
      }
    )
  }
), DX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.667 2.31a1 1 0 0 1 .333.745V12h8.945a1 1 0 0 1 .994 1.11C21.386 18.11 17.148 22 12 22 6.477 22 2 17.523 2 12c0-5.148 3.89-9.386 8.89-9.939a1 1 0 0 1 .777.249ZM10 4.252A8 8 0 1 0 19.748 14H11a1 1 0 0 1-1-1V4.252Zm4.423-1.556a1 1 0 0 1 .91-.127 10.025 10.025 0 0 1 6.098 6.098A1 1 0 0 1 20.488 10H15a1 1 0 0 1-1-1V3.512a1 1 0 0 1 .423-.816ZM16 5.07V8h2.93A8.044 8.044 0 0 0 16 5.07Z",
        clipRule: "evenodd"
      }
    )
  }
), jX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm10 2a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-4 3a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm-4 3a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), AX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5c-4.532 0-8 3.241-8 7 0 1.352.438 2.619 1.209 3.7a1 1 0 0 1 .122.931l-.763 2.036 2.98-.597a1 1 0 0 1 .628.079A8.862 8.862 0 0 0 12 19c4.532 0 8-3.242 8-7 0-3.759-3.468-7-8-7ZM2 12c0-5.078 4.591-9 10-9s10 3.922 10 9c0 5.078-4.591 9-10 9-1.565 0-3.051-.324-4.377-.905l-4.427.886a1 1 0 0 1-1.132-1.332l1.215-3.24A8.283 8.283 0 0 1 2 12Zm5 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), kX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-4.586l-4.707 4.707A1 1 0 0 1 8 21v-4H5a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 1 1 1v2.586l3.293-3.293A1 1 0 0 1 14 15h5a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm2 5a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), LX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v3a1 1 0 0 1-1.707.707L12.586 19H9a2.99 2.99 0 0 1-1.293-.293A1 1 0 0 1 6 18v-3H5a3 3 0 0 1-3-3V6Zm7.414 11H13a1 1 0 0 1 .707.293L16 19.586V18a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-1v3a3 3 0 0 1-3 3h-3.586l-2 2ZM16 6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v1.586l2.293-2.293A1 1 0 0 1 11 13h4a1 1 0 0 0 1-1V6Z",
        clipRule: "evenodd"
      }
    )
  }
), IX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 15.586l9.293-9.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), HX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-2.707a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ZX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), PX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 4.293a1 1 0 0 1 0 1.414L9.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), VX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.293 19.707a1 1 0 0 1 0-1.414L14.586 12 8.293 5.707a1 1 0 0 1 1.414-1.414l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), NX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.707 15.707a1 1 0 0 1-1.414 0L12 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414l7-7a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), BX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 0 1 1.414 0L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Zm0 8a1 1 0 0 1 1.414 0L12 18.586l6.293-6.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), FX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.707 4.293a1 1 0 0 1 0 1.414L5.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Zm8 0a1 1 0 0 1 0 1.414L13.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), UX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 0 1 0-1.414Zm8 0a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L18.586 12l-6.293-6.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), YX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 3.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1-1.414 1.414L12 5.414l-6.293 6.293a1 1 0 0 1-1.414-1.414l7-7ZM12 13.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 1 0 1.414 1.414L12 13.414Z",
        clipRule: "evenodd"
      }
    )
  }
), $X = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a1 1 0 0 1 1 1v1h4V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v1h1a1 1 0 1 1 0 2h-1v4h1a1 1 0 1 1 0 2h-1v1a3 3 0 0 1-3 3h-1v1a1 1 0 1 1-2 0v-1h-4v1a1 1 0 1 1-2 0v-1H7a3 3 0 0 1-3-3v-1H3a1 1 0 1 1 0-2h1v-4H3a1 1 0 0 1 0-2h1V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1ZM7 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Zm1 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9Zm2 1v4h4v-4h-4Z",
        clipRule: "evenodd"
      }
    )
  }
), WX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17Zm0 2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 13 8h-2a3.001 3.001 0 0 1-2.83-2ZM11 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z",
        clipRule: "evenodd"
      }
    )
  }
), zX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17Zm0 2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 13 8h-2a3.001 3.001 0 0 1-2.83-2ZM11 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm4.707 7.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 14.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), qX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.17 4A3.001 3.001 0 0 1 10 2h2c1.306 0 2.418.835 2.83 2H16a3 3 0 0 1 3 3v3a1 1 0 1 1-2 0V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 12 8h-2a3.001 3.001 0 0 1-2.83-2H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 1 1 2 0v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17ZM10 4a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2h-2Zm3.707 6.293a1 1 0 0 1 0 1.414L12.414 13H20a1 1 0 1 1 0 2h-7.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), GX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.17 4A3.001 3.001 0 0 1 11 2h2c1.306 0 2.418.835 2.83 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.17Zm0 2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17A3.001 3.001 0 0 1 13 8h-2a3.001 3.001 0 0 1-2.83-2ZM11 4a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-3 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm-3 4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), KX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v3.586l2.707 2.707a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 11 12V8a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), QX = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 6a4 4 0 0 0-3.903 4.879 1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 18h9a4 4 0 1 0-.08-8 1 1 0 0 1-1-.8A4.002 4.002 0 0 0 11 6Zm-6 4a6 6 0 0 1 11.671-1.963A6 6 0 0 1 16 20H7a5 5 0 0 1-1.986-9.59A6.071 6.071 0 0 1 5 10Z",
        clipRule: "evenodd"
      }
    )
  }
), XX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 3a4 4 0 0 0-3.903 4.879 1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 15a1 1 0 1 1 0 2 5 5 0 0 1-1.986-9.59A6 6 0 0 1 16.67 5.037a6 6 0 0 1 .53 11.843 1 1 0 1 1-.398-1.96A4.002 4.002 0 0 0 15.92 7a1 1 0 0 1-1-.8A4.002 4.002 0 0 0 11 3Zm1 6a1 1 0 0 1 1 1v9.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 19.586V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), JX = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 3a4 4 0 0 0-3.903 4.879 1 1 0 0 1-.757 1.194A3.002 3.002 0 0 0 7 15a1 1 0 1 1 0 2 5 5 0 0 1-1.986-9.59A6 6 0 0 1 16.67 5.037a6 6 0 0 1 .53 11.843 1 1 0 1 1-.398-1.96A4.002 4.002 0 0 0 15.92 7a1 1 0 0 1-1-.8A4.002 4.002 0 0 0 11 3Zm.293 6.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L13 12.414V22a1 1 0 1 1-2 0v-9.586l-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), eJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.242 3.03a1 1 0 0 1 .728 1.213l-4 16a1 1 0 1 1-1.94-.485l4-16a1 1 0 0 1 1.213-.728ZM6.707 7.293a1 1 0 0 1 0 1.414L3.414 12l3.293 3.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Zm10.586 0a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L20.586 12l-3.293-3.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), tJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.353 4.081c.674-2.775 4.62-2.775 5.294 0a.724.724 0 0 0 1.08.448c2.44-1.486 5.23 1.305 3.744 3.744a.724.724 0 0 0 .448 1.08c2.775.674 2.775 4.62 0 5.294a.724.724 0 0 0-.448 1.08c1.486 2.44-1.305 5.23-3.744 3.744a.724.724 0 0 0-1.08.448c-.674 2.775-4.62 2.775-5.294 0a.724.724 0 0 0-1.08-.448c-2.44 1.486-5.23-1.305-3.744-3.744a.724.724 0 0 0-.448-1.08c-2.775-.674-2.775-4.62 0-5.294a.724.724 0 0 0 .448-1.08c-1.486-2.44 1.305-5.23 3.744-3.744a.724.724 0 0 0 1.08-.448Zm3.35.472c-.178-.737-1.227-.737-1.407 0a2.724 2.724 0 0 1-4.064 1.684c-.648-.395-1.39.347-.995.995a2.723 2.723 0 0 1-1.684 4.064c-.737.18-.737 1.229 0 1.408a2.724 2.724 0 0 1 1.684 4.064c-.395.648.347 1.39.995.995a2.724 2.724 0 0 1 4.064 1.684c.18.737 1.229.737 1.408 0a2.724 2.724 0 0 1 4.064-1.684c.648.395 1.39-.347.995-.995a2.724 2.724 0 0 1 1.684-4.064c.737-.18.737-1.229 0-1.408a2.724 2.724 0 0 1-1.684-4.064c.395-.648-.347-1.39-.995-.995a2.723 2.723 0 0 1-4.064-1.684ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), nJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1.17c1.165.413 2 1.524 2 2.83v1.17c1.165.412 2 1.524 2 2.83v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-6c0-1.306.835-2.418 2-2.83V9c0-1.306.835-2.417 2-2.83V5Zm2 1h8V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1Zm-2 4h12V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1Zm-1 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H5Z",
        clipRule: "evenodd"
      }
    )
  }
), rJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 2.93 3 3 0 0 1 4.192.05l2.829 2.828A3 3 0 0 1 19.069 12 3 3 0 0 1 22 15v4a3 3 0 0 1-3 3H7a5 5 0 0 1-5-5V5Zm9.071 15H19a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.929l-6 6Zm4.878-7.707h.001l1.657-1.657a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 0 0-1.414 0L12 7.757v8.486l3.95-3.95ZM9.123 19.12A2.99 2.99 0 0 0 10 17V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a3 3 0 0 0 5.123 2.12ZM6 17a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), aJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8Zm2 3v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5H4Zm16-2H4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1ZM6 15a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), oJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.553 2.106a1 1 0 0 1 .894 0l8 4A1 1 0 0 1 21 7v10a1 1 0 0 1-.553.894l-8 4a1 1 0 0 1-.894 0l-8-4A1 1 0 0 1 3 17V7a1 1 0 0 1 .553-.894l8-4ZM5 8.618l6 3v7.764l-6-3V8.618Zm8 10.764 6-3V8.618l-6 3v7.764Zm-1-9.5L17.764 7 12 4.118 6.236 7 12 9.882Z",
        clipRule: "evenodd"
      }
    )
  }
), iJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.553 2.106a1 1 0 0 1 .894 0l2 1a1 1 0 1 1-.894 1.788L12 4.118l-1.553.776a1 1 0 1 1-.894-1.788l2-1ZM6.894 5.553a1 1 0 0 1-.447 1.341L6.237 7l.21.106a1 1 0 0 1-.894 1.788L5 8.618V9.5a1 1 0 1 1-2 0V7a1 1 0 0 1 .553-.894l2-1a1 1 0 0 1 1.341.447Zm10.212 0a1 1 0 0 1 1.341-.447l2 1A1 1 0 0 1 21 7v2.5a1 1 0 1 1-2 0v-.882l-.553.276a1 1 0 1 1-.894-1.788l.21-.106-.21-.106a1 1 0 0 1-.447-1.341Zm-8 4a1 1 0 0 1 1.341-.447L12 9.882l1.553-.776a1 1 0 1 1 .894 1.788L13 11.618V13.5a1 1 0 1 1-2 0v-1.882l-1.447-.724a1 1 0 0 1-.447-1.341ZM4 13.5a1 1 0 0 1 1 1v1.882l1.447.724a1 1 0 1 1-.894 1.788l-2-1A1 1 0 0 1 3 17v-2.5a1 1 0 0 1 1-1Zm16 0a1 1 0 0 1 1 1V17a1 1 0 0 1-.553.894l-2 1a1 1 0 1 1-.894-1.788L19 16.382V14.5a1 1 0 0 1 1-1Zm-8 4a1 1 0 0 1 1 1v.882l.553-.276a1 1 0 1 1 .894 1.788l-2 1a1 1 0 0 1-.894 0l-2-1a1 1 0 1 1 .894-1.788l.553.276V18.5a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), lJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-5a1 1 0 0 1 1-1 3 3 0 0 1 3 3v1h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 0 2 0v-1a1 1 0 1 1 2 0v1a3 3 0 1 1-6 0v-3H9a1 1 0 1 1 0-2h1V9a1 1 0 0 0-1-1 1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), uJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-6a1 1 0 0 1 1 1v.092c.94.177 1.791.604 2.354 1.253a1 1 0 0 1-1.51 1.31c-.163-.187-.453-.377-.844-.504v1.941a4.535 4.535 0 0 1 1.676.662C15.398 12.234 16 13.009 16 14c0 .99-.602 1.765-1.324 2.246-.48.32-1.054.545-1.676.662V17a1 1 0 1 1-2 0v-.092c-.94-.177-1.791-.604-2.354-1.253a1 1 0 0 1 1.51-1.31c.163.187.453.377.844.504v-1.941a4.535 4.535 0 0 1-1.676-.662C8.602 11.766 8 10.991 8 10c0-.99.602-1.765 1.324-2.246A4.535 4.535 0 0 1 11 7.092V7a1 1 0 0 1 1-1Zm-1 3.151c-.22.071-.412.164-.567.267C10.07 9.66 10 9.886 10 10c0 .114.07.34.433.582.155.103.346.196.567.267V9.151Zm2 4v1.698c.22-.071.412-.164.567-.267.364-.243.433-.468.433-.582 0-.114-.07-.34-.433-.582A2.305 2.305 0 0 0 13 13.15Z",
        clipRule: "evenodd"
      }
    )
  }
), sJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4c-.304 0-.792.193-1.264.979a4.259 4.259 0 0 0-.264.521H12a1 1 0 1 1 0 2h-1.983a7.321 7.321 0 0 0 0 1H12a1 1 0 1 1 0 2h-1.528c.08.185.167.36.264.521.472.786.96.979 1.264.979.304 0 .792-.193 1.264-.979a1 1 0 0 1 1.715 1.029C14.279 17.216 13.232 18 12 18s-2.279-.784-2.979-1.95c-.285-.475-.507-1-.67-1.55H8a1 1 0 1 1 0-2h.013a9.358 9.358 0 0 1 0-1H8a1 1 0 1 1 0-2h.351c.163-.55.385-1.075.67-1.55C9.721 6.784 10.768 6 12 6s2.279.784 2.979 1.95a1 1 0 1 1-1.715 1.029C12.792 8.193 12.304 8 12 8Z",
        clipRule: "evenodd"
      }
    )
  }
), cJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm8-3a3 3 0 1 1 6 0 1 1 0 1 1-2 0 1 1 0 1 0-2 0v2h1a1 1 0 1 1 0 2h-1v1c0 .35-.06.687-.17 1H15a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2 1 1 0 0 0 1-1v-1H9a1 1 0 1 1 0-2h1V9Z",
        clipRule: "evenodd"
      }
    )
  }
), fJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-1.535c.179.31.318.645.409 1H15a1 1 0 1 1 0 2h-1.126a4.008 4.008 0 0 1-2.65 2.81l1.483 1.483a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 9 13h1a2 2 0 0 0 1.732-1H9a1 1 0 1 1 0-2h2.732A2 2 0 0 0 10 9H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), dJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6.486-4.857a1 1 0 0 1 1.371.343L11.967 11h.067l2.108-3.514a1 1 0 0 1 1.716 1.029L14.366 11H15a1 1 0 1 1 0 2h-1.834l-.166.277V14h2a1 1 0 1 1 0 2h-2v1a1 1 0 1 1-2 0v-1H9a1 1 0 1 1 0-2h2v-.723L10.834 13H9a1 1 0 1 1 0-2h.634L8.143 8.514a1 1 0 0 1 .342-1.371Z",
        clipRule: "evenodd"
      }
    )
  }
), hJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.93 1.273a1 1 0 0 1 1.224.707l.777 2.897a1 1 0 0 1-1.932.518l-.777-2.898a1 1 0 0 1 .707-1.224Zm7.727 2.07a1 1 0 0 1 0 1.414L12.535 6.88a1 1 0 1 1-1.414-1.414l2.122-2.122a1 1 0 0 1 1.414 0ZM1.272 6.93a1 1 0 0 1 1.225-.707L5.395 7a1 1 0 0 1-.518 1.932L1.98 8.154a1 1 0 0 1-.708-1.225Zm7.02 1.364a1 1 0 0 1 1.05-.233l11 4a1 1 0 0 1 .03 1.868l-3.593 1.437 3.928 3.928a1 1 0 0 1-1.414 1.414l-3.928-3.928-1.437 3.592a1 1 0 0 1-1.868-.03l-4-11a1 1 0 0 1 .233-1.048Zm2.38 2.38 2.372 6.523 1.027-2.567a1 1 0 0 1 .558-.557l2.567-1.027-6.524-2.373Zm-3.793.448a1 1 0 0 1 0 1.415l-2.122 2.12a1 1 0 0 1-1.414-1.413l2.121-2.122a1 1 0 0 1 1.415 0Z",
        clipRule: "evenodd"
      }
    )
  }
), vJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.79 5.066C5.45 5.736 5 6.478 5 7s.449 1.263 1.79 1.934C8.072 9.574 9.912 10 12 10s3.928-.425 5.21-1.066C18.55 8.264 19 7.522 19 7s-.449-1.263-1.79-1.934C15.928 4.426 14.088 4 12 4s-3.928.425-5.21 1.066ZM19 10.201a7.846 7.846 0 0 1-.896.522C16.49 11.53 14.331 12 12 12c-2.33 0-4.49-.47-6.104-1.277A7.842 7.842 0 0 1 5 10.2V12c0 .522.449 1.263 1.79 1.934C8.072 14.574 9.912 15 12 15s3.928-.425 5.21-1.066C18.55 13.264 19 12.522 19 12v-1.8ZM21 7c0-1.687-1.342-2.946-2.896-3.723C16.49 2.47 14.331 2 12 2c-2.33 0-4.49.47-6.104 1.277C4.342 4.054 3 5.313 3 7v10c0 1.687 1.342 2.946 2.896 3.723C7.51 21.53 9.669 22 12 22c2.33 0 4.49-.47 6.104-1.277C19.658 19.946 21 18.687 21 17V7Zm-2 8.2a7.846 7.846 0 0 1-.896.523C16.49 16.53 14.331 17 12 17c-2.33 0-4.49-.47-6.104-1.277A7.842 7.842 0 0 1 5 15.2V17c0 .522.449 1.263 1.79 1.934C8.072 19.574 9.912 20 12 20s3.928-.425 5.21-1.066C18.55 18.264 19 17.522 19 17v-1.8Z",
        clipRule: "evenodd"
      }
    )
  }
), pJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-3.47l.373 1.489.804.804A1 1 0 0 1 16 22H8a1 1 0 0 1-.707-1.707l.804-.804L8.469 18H5a3 3 0 0 1-3-3V5Zm2 9v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1H4Zm16-2H4V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7Zm-6.53 6h-2.94l-.5 2h3.94l-.5-2Z",
        clipRule: "evenodd"
      }
    )
  }
), mJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8Zm3 14a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), gJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7Zm4 14a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), wJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Z",
        clipRule: "evenodd"
      }
    )
  }
), yJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm8 4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), xJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm8 4a1 1 0 0 1 1 1v3.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 13.586V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), SJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8.414L14.586 4H10ZM7 5a3 3 0 0 1 3-3h4.586A2 2 0 0 1 16 2.586L20.414 7A2 2 0 0 1 21 8.414V15a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1V5Zm0 3H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h-5a3 3 0 0 1-3-3V8Z",
        clipRule: "evenodd"
      }
    )
  }
), CJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm4 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), bJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm11 5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm-3 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm-3 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), _J = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v11a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3h-7a1 1 0 1 1 0-2h7a1 1 0 0 0 1-1V9.414L12.586 4H7Zm5 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 1.968 3.446l-4.26 4.261a1 1 0 0 1-1.415-1.414l4.261-4.261A3.984 3.984 0 0 1 8 14Z",
        clipRule: "evenodd"
      }
    )
  }
), RJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.414L12.586 4H7ZM4 5a3 3 0 0 1 3-3h5.586A2 2 0 0 1 14 2.586L19.414 8A2 2 0 0 1 20 9.414V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm4 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), EJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm5 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), MJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), TJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
        clipRule: "evenodd"
      }
    )
  }
), OJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 17a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-1a1 1 0 1 1 2 0v1Zm2.293-5.707a1 1 0 0 1 1.414 0L11 13.586V4a1 1 0 1 1 2 0v9.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), DJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-1H6a3 3 0 0 1-3-3V6Zm6 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v8Zm6-11h-5a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1Z",
        clipRule: "evenodd"
      }
    )
  }
), jJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-2a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1Zm6 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm-5.536 4.121a1 1 0 0 1 1.415 0 3 3 0 0 0 4.242 0 1 1 0 0 1 1.415 1.415 5 5 0 0 1-7.072 0 1 1 0 0 1 0-1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), AJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-2a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1Zm6 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm.121 6.879a3 3 0 0 0-4.242 0 1 1 0 1 1-1.414-1.415 5 5 0 0 1 7.07 0 1 1 0 0 1-1.414 1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), kJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.402 3.5c1.155-2 4.041-2 5.196 0l6.928 12c1.155 2-.288 4.5-2.598 4.5H5.072c-2.31 0-3.753-2.5-2.598-4.5l6.928-12Zm3.464 1a1 1 0 0 0-1.732 0l-6.928 12a1 1 0 0 0 .866 1.5h13.856a1 1 0 0 0 .866-1.5l-6.928-12ZM12 8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm-1 7a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), LJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-1 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), IJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2H6Zm10.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 13H7a1 1 0 1 1 0-2h11.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), HJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 5a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V6.414l-8.293 8.293a1 1 0 0 1-1.414-1.414L17.586 5H14ZM6 7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h4a1 1 0 1 1 0 2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), ZJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.512 12a9.004 9.004 0 0 0 16.977 0 9.004 9.004 0 0 0-16.977 0Zm-2.008-.3C2.906 7.238 7.074 4 12 4c4.927 0 9.095 3.238 10.497 7.7a1 1 0 0 1 0 .6C21.095 16.762 16.927 20 12 20s-9.095-3.238-10.497-7.7a1 1 0 0 1 0-.6ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), PJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 2.293a1 1 0 0 1 1.414 0l3.04 3.04A10.955 10.955 0 0 1 12 4c4.927 0 9.095 3.238 10.497 7.7a1 1 0 0 1 0 .6 11.014 11.014 0 0 1-3.552 5.231l2.762 2.762a1 1 0 0 1-1.414 1.414l-18-18a1 1 0 0 1 0-1.414Zm5.943 4.53 1.732 1.731a4 4 0 0 1 5.478 5.478l2.076 2.076A9.022 9.022 0 0 0 20.489 12 9.004 9.004 0 0 0 8.236 6.822Zm5.696 5.695a2 2 0 0 0-2.45-2.45l2.45 2.45ZM4.625 8.174a1 1 0 0 1 .194 1.4A8.975 8.975 0 0 0 3.512 12a9.004 9.004 0 0 0 10.177 5.842 1 1 0 0 1 .372 1.965c-.668.127-1.357.193-2.06.193-4.927 0-9.095-3.238-10.497-7.7a1 1 0 0 1 0-.6 10.97 10.97 0 0 1 1.72-3.332 1 1 0 0 1 1.4-.194Z",
        clipRule: "evenodd"
      }
    )
  }
), VJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 8c0-1.648 1.882-2.589 3.2-1.6L12 10V8c0-1.648 1.882-2.589 3.2-1.6l5.333 4a2 2 0 0 1 0 3.2l-5.333 4c-1.318.989-3.2.048-3.2-1.6v-2l-4.8 3.6c-1.318.989-3.2.048-3.2-1.6V8Zm7.333 4L6 8v8l5.333-4Zm8 0L14 8v8l5.333-4Z",
        clipRule: "evenodd"
      }
    )
  }
), NJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm4 0H4v2h2V5Zm2 0v6h8V5H8Zm10 0v2h2V5h-2Zm2 4h-2v2h2V9Zm0 4h-2v2h2v-2Zm0 4h-2v2h2v-2Zm-4 2v-6H8v6h8ZM6 19v-2H4v2h2Zm-2-4h2v-2H4v2Zm0-4h2V9H4v2Z",
        clipRule: "evenodd"
      }
    )
  }
), BJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2.586A2 2 0 0 1 21.414 8L15 14.414V17a1 1 0 0 1-.293.707l-4 4A1 1 0 0 1 9 21v-6.586L2.586 8A2 2 0 0 1 2 6.586V4Zm18 0H4v2.586L10.414 13A2 2 0 0 1 11 14.414v4.172l2-2v-2.172A2 2 0 0 1 13.586 13L20 6.586V4Z",
        clipRule: "evenodd"
      }
    )
  }
), FJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 3.205A9 9 0 0 1 21 11c0 2.567-.358 5.051-1.029 7.406a1 1 0 0 1-1.923-.548C18.668 15.68 19 13.38 19 11A7 7 0 0 0 8.5 4.936a1 1 0 1 1-1-1.731Zm-1.93 2.93A1 1 0 0 1 5.936 7.5 6.963 6.963 0 0 0 5 11c0 1.72-.395 3.35-1.1 4.801a1 1 0 0 1-1.8-.874A8.96 8.96 0 0 0 3 11c0-1.638.438-3.176 1.205-4.5a1 1 0 0 1 1.366-.366ZM7 11a5 5 0 0 1 10 0 23 23 0 0 1-.213 3.135 1 1 0 0 1-1.981-.27c.128-.937.194-1.893.194-2.865a3 3 0 1 0-6 0 14.916 14.916 0 0 1-2.333 8.041 1 1 0 1 1-1.72-1.021l.068-.111.846.532-.846-.532A12.916 12.916 0 0 0 7 11Zm5-1a1 1 0 0 1 1 1 18.92 18.92 0 0 1-2.906 10.104A1 1 0 1 1 8.4 20.039 16.915 16.915 0 0 0 11 11a1 1 0 0 1 1-1Zm3.443 6.038a1 1 0 0 1 .69 1.234 22.876 22.876 0 0 1-1.56 4.02 1 1 0 1 1-1.788-.896 20.882 20.882 0 0 0 1.424-3.668 1 1 0 0 1 1.234-.69Z",
        clipRule: "evenodd"
      }
    )
  }
), UJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.359 2.22a1 1 0 0 1 1.332.07c.93.925 1.884 1.573 2.85 2.21l.185.122c.89.586 1.825 1.201 2.638 2.014A8.975 8.975 0 0 1 21 13 9 9 0 1 1 5.636 6.636a1 1 0 0 1 1.634.331v.003l.002.002m-.002-.005v.001l.013.028a4.197 4.197 0 0 0 .432.691c.114.15.253.312.418.476A12.62 12.62 0 0 0 8 10h1l.447-.894a5.051 5.051 0 0 1-1.314-.943C8.42 6.222 9.25 3.917 11.36 2.221m.623 2.14C10.379 6.05 10 8.32 10 10a1 1 0 0 1-1.447.894 6.998 6.998 0 0 1-2.323-1.86A6.98 6.98 0 0 0 5 13a7 7 0 1 0 11.95-4.95c-.664-.663-1.438-1.173-2.371-1.789l-.14-.092c-.765-.504-1.607-1.07-2.457-1.809Zm-4.71 2.613Zm3.795 3.706a1 1 0 0 1 .952-.68 3.99 3.99 0 0 1 2.81 1.171A3.99 3.99 0 0 1 16 14a4 4 0 1 1-8 0 1 1 0 0 1 1-1h1.283l.784-2.32Zm1.624 1.442-.744 2.198A1 1 0 0 1 11 15h-.733a2 2 0 1 0 2.424-2.878Z",
        clipRule: "evenodd"
      }
    )
  }
), YJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a1 1 0 0 0-1 1v9.17c.313-.11.65-.17 1-.17h6.5a1 1 0 0 1 .707.293l.707.707h6.468l-2.276-4.553a1 1 0 0 1 0-.894L19.382 5H13v4a1 1 0 1 1-2 0V4H5Zm7.914-1H21a1 1 0 0 1 .894 1.447L19.118 10l2.776 5.553A1 1 0 0 1 21 17h-8.5a1 1 0 0 1-.707-.293L11.086 16H5a1 1 0 0 0-1 1v4a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h6.5a1 1 0 0 1 .707.293l.5.5.207.207Z",
        clipRule: "evenodd"
      }
    )
  }
), $J = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Z",
        clipRule: "evenodd"
      }
    )
  }
), WJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm10 2a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), zJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm10 2a1 1 0 0 1 1 1v3.586l1.293-1.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 13.586V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), qJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0v-5a3 3 0 0 1 3-3h7a1 1 0 0 0-1-1h-4.414l-2-2H5Zm4 5a1 1 0 0 0-1 1v5c0 .35-.06.687-.17 1H19a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H9Zm-4 9a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4.414l2 2H15a3 3 0 0 1 3 3h1a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H5Z",
        clipRule: "evenodd"
      }
    )
  }
), GJ = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6a1 1 0 0 1-.707-.293L10.586 6H5ZM2 7a3 3 0 0 1 3-3h6a1 1 0 0 1 .707.293L13.414 6H19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm6 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), KJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.5 4a1.5 1.5 0 1 0 0 3H11V5.5A1.5 1.5 0 0 0 9.5 4Zm2.863-.514A3.5 3.5 0 0 0 6.337 7H5a3 3 0 0 0-1 5.83V19a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-6.17A3.001 3.001 0 0 0 19 7h-2.17a3 3 0 0 0-4.467-3.514ZM13 6v1h1a1 1 0 1 0-1-1Zm-2 3H5a1 1 0 0 0 0 2h6V9Zm0 4H6v6a1 1 0 0 0 1 1h4v-7Zm2 7v-7h5v6a1 1 0 0 1-1 1h-4Zm0-9V9h6a1 1 0 1 1 0 2h-6Z",
        clipRule: "evenodd"
      }
    )
  }
), QJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.252 10H5a3 3 0 0 1 3 3v1a1 1 0 0 0 1 1 3 3 0 0 1 3 3v2a8 8 0 0 0 2-.252V18a3 3 0 0 1 3-3h2.419c.375-.926.581-1.94.581-3s-.206-2.074-.581-3H19a1 1 0 0 0-1 1 3 3 0 1 1-6 0 1 1 0 0 0-1-1h-.5a3.5 3.5 0 0 1-3.491-3.252A8.004 8.004 0 0 0 4.252 10Zm3.304-6.96A10 10 0 0 0 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10a9.958 9.958 0 0 0-1.039-4.444v-.001A10 10 0 0 0 12 2a9.959 9.959 0 0 0-4.444 1.04ZM9 4.581V5.5A1.5 1.5 0 0 0 10.5 7h.5a3 3 0 0 1 3 3 1 1 0 1 0 2 0 3 3 0 0 1 2.309-2.92A7.986 7.986 0 0 0 12 4a7.98 7.98 0 0 0-3 .582ZM18.245 17H17a1 1 0 0 0-1 1v.93A8.038 8.038 0 0 0 18.245 17ZM10 19.748C6.55 18.86 4 15.728 4 12h1a1 1 0 0 1 1 1v1a3 3 0 0 0 3 3 1 1 0 0 1 1 1v1.748Z",
        clipRule: "evenodd"
      }
    )
  }
), XJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 0 1 9-9"
      }
    )
  }
), JJ = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5 4a.5.5 0 0 0-.5.5V11a1 1 0 1 1-2 0V5.5a.5.5 0 0 0-1 0V14a1 1 0 1 1-2 0v-2.5a.5.5 0 0 0-1 0v2a6.5 6.5 0 1 0 13 0v-5a.5.5 0 0 0-1 0V11a1 1 0 1 1-2 0V5.5a.5.5 0 0 0-1 0V11a1 1 0 1 1-2 0V4.5a.5.5 0 0 0-.5-.5Zm2.112-.838A2.5 2.5 0 0 1 17 5.5v.55a2.5 2.5 0 0 1 3 2.45v5a8.5 8.5 0 0 1-17 0v-2a2.5 2.5 0 0 1 3-2.45V5.5a2.5 2.5 0 0 1 3.388-2.338 2.498 2.498 0 0 1 4.224 0Z",
        clipRule: "evenodd"
      }
    )
  }
), eee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.242 3.03a1 1 0 0 1 .728 1.213L11.03 8h3.94l1.06-4.243a1 1 0 1 1 1.94.486L17.03 8H20a1 1 0 1 1 0 2h-3.47l-1 4H18a1 1 0 1 1 0 2h-2.97l-1.06 4.242a1 1 0 1 1-1.94-.485L12.97 16H9.03l-1.06 4.242a1 1 0 1 1-1.94-.485L6.97 16H4a1 1 0 1 1 0-2h3.47l1-4H6a1 1 0 0 1 0-2h2.97l1.06-4.243a1 1 0 0 1 1.213-.727ZM10.531 10l-1 4h3.938l1-4h-3.938Z",
        clipRule: "evenodd"
      }
    )
  }
), tee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m14.025 7.025-1.318 1.318a1 1 0 0 1-1.414 0L9.975 7.025a3.5 3.5 0 1 0-4.95 4.95L12 18.95l6.975-6.975.707.707-.707-.707a3.5 3.5 0 0 0-4.95-4.95Zm-1.414-1.414a5.5 5.5 0 0 1 7.778 7.778l-7.682 7.682a1 1 0 0 1-1.414 0L3.61 13.39a5.5 5.5 0 0 1 7.778-7.778l.611.61.61-.61Z",
        clipRule: "evenodd"
      }
    )
  }
), nee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 2.293a1 1 0 0 1 1.414 0l9 9a1 1 0 0 1-1.414 1.414L20 12.414V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.586l-.293.293a1 1 0 0 1-1.414-1.414l9-9ZM6 10.414V20h3v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h3v-9.586l-6-6-6 6ZM13 20v-4h-2v4h2Z",
        clipRule: "evenodd"
      }
    )
  }
), ree = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7Zm10 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm-5 3a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm-7 5a7 7 0 1 1 14 0v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1Z",
        clipRule: "evenodd"
      }
    )
  }
), aee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 5a3 3 0 1 1 6 0h4a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h4Zm.17 2H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4.17a3.001 3.001 0 0 1-5.66 0ZM12 4a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1Zm-3 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2.4 2.8a3 3 0 1 0-4.8 0 4.01 4.01 0 0 0-1.372 1.867 1 1 0 1 0 1.885.666 2.001 2.001 0 0 1 3.773 0 1 1 0 1 0 1.886-.666A4.01 4.01 0 0 0 11.4 13.8ZM14 11a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), oee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v6h1.586A2 2 0 0 1 8 12.586L10.414 15h3.172L16 12.586A2 2 0 0 1 17.414 12H19V6a1 1 0 0 0-1-1H6Zm13 9h-1.586L15 16.414a2 2 0 0 1-1.414.586h-3.172A2 2 0 0 1 9 16.414L6.586 14H5v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), iee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v5.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 1.414-1.414L11 8.586V3a1 1 0 0 1 1-1ZM6 5a1 1 0 0 0-1 1v6h1.586A2 2 0 0 1 8 12.586L10.414 15h3.172L16 12.586A2 2 0 0 1 17.414 12H19V6a1 1 0 0 0-1-1h-2a1 1 0 1 1 0-2h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2a1 1 0 0 1 0 2H6Zm-1 9v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4h-1.586L15 16.414a2 2 0 0 1-1.414.586h-3.172A2 2 0 0 1 9 16.414L6.586 14H5Z",
        clipRule: "evenodd"
      }
    )
  }
), lee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9-4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Zm-1 4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), uee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 4a5 5 0 0 0-4.786 6.453 1 1 0 0 1-.25.997L4 17.414V20h2v-1a1 1 0 0 1 1-1h1v-1a1 1 0 0 1 1-1h1.586l1.964-1.964a1 1 0 0 1 .997-.25A5 5 0 1 0 15 4ZM8 20v1a1 1 0 0 1-1 1H4a2 2 0 0 1-2-2v-2.586A2 2 0 0 1 2.586 16l5.562-5.562a7 7 0 1 1 5.414 5.414l-1.855 1.855A1 1 0 0 1 11 18h-1v1a1 1 0 0 1-1 1H8Zm6-13a1 1 0 0 1 1-1 3 3 0 0 1 3 3 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), see = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.594 2.086a1 1 0 0 1 .812 0l9 4a1 1 0 0 1-.812 1.828L12 4.094l-8.594 3.82a1 1 0 1 1-.812-1.828l9-4ZM2 10a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v9a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2v-9a1 1 0 0 1-1-1Zm3 1v9h14v-9H5Zm3 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), cee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1ZM4.929 4.929a1 1 0 0 1 1.414 0l.707.707A1 1 0 1 1 5.636 7.05l-.707-.707a1 1 0 0 1 0-1.414Zm14.142 0a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0Zm-9.9 4.243a4 4 0 0 0 0 5.656l.548.548c.193.193.366.402.518.624h3.526a4.38 4.38 0 0 1 .518-.624l.547-.547a4 4 0 0 0-5.656-5.657Zm6.074 8.247c.114-.231.265-.444.45-.63l.548-.546a6 6 0 1 0-8.486 0l.547.547A2.374 2.374 0 0 1 9 18.469V19a3 3 0 1 0 6 0v-.531a2.374 2.374 0 0 1 .245-1.05Zm-2.22.581h-2.05c.017.155.025.312.025.469V19a1 1 0 1 0 2 0v-.531c0-.157.008-.314.025-.469ZM2 12a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Zm17 0a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2h-1a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), fee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.336 2.058A1 1 0 0 1 14 3v6h6a1 1 0 0 1 .774 1.633l-9 11A1 1 0 0 1 10 21v-6H4a1 1 0 0 1-.774-1.633l9-11a1 1 0 0 1 1.11-.309ZM6.11 13H11a1 1 0 0 1 1 1v4.199L17.89 11H13a1 1 0 0 1-1-1V5.801L6.11 13Z",
        clipRule: "evenodd"
      }
    )
  }
), dee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.121 4.879a3 3 0 0 0-4.242 0l-1.1 1.1a1 1 0 1 1-1.414-1.415l1.1-1.1a5 5 0 1 1 7.07 7.072l-4 4a5 5 0 0 1-7.07 0 1 1 0 1 1 1.414-1.415 3 3 0 0 0 4.242 0l4-4a3 3 0 0 0 0-4.242Zm-6 6a3 3 0 0 0-4.242 0l-4 4A3 3 0 1 0 9.12 19.12l1.102-1.101a1 1 0 1 1 1.414 1.414l-1.101 1.101a5 5 0 1 1-7.072-7.07l4-4a5 5 0 0 1 7.072 0 1 1 0 1 1-1.415 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), hee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.95 6.05a7 7 0 1 0-9.9 9.9l4.244 4.243a.998.998 0 0 0 1.413 0l4.243-4.243a7 7 0 0 0 0-9.9ZM5.636 4.636a9 9 0 0 1 12.728 12.728l-3.502 3.502-.018.018-.723.723a2.998 2.998 0 0 1-4.241 0l-4.244-4.243a9 9 0 0 1 0-12.728ZM12 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), vee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7a5 5 0 0 1 10 0v3h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h1V7Zm2 3h6V7a3 3 0 1 0-6 0v3Zm-3 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6Zm6 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), pee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7a5 5 0 0 1 10 0 1 1 0 1 1-2 0 3 3 0 1 0-6 0v3h9a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h1V7Zm-1 5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6Zm6 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), mee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h7a4 4 0 0 1 4 4v1a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2H6Zm5.707 2.293a1 1 0 0 1 0 1.414L9.414 11H21a1 1 0 1 1 0 2H9.414l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), gee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm2 2.869V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.869l-6.336 4.223a3 3 0 0 1-3.328 0L4 9.87Zm16-2.404-7.445 4.963a1 1 0 0 1-1.11 0L4 7.465V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v.465Z",
        clipRule: "evenodd"
      }
    )
  }
), wee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.555 4.572a1 1 0 0 0-1.11 0l-7 4.666a1 1 0 0 0-.304.32l7.304 4.87a1 1 0 0 0 1.11 0l7.304-4.87a1 1 0 0 0-.304-.32l-7-4.666Zm9.44 5.328a3 3 0 0 0-1.33-2.326l-7-4.666a3 3 0 0 0-3.33 0l-7 4.666A3 3 0 0 0 2 10.07V19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8.93a3.028 3.028 0 0 0-.005-.17ZM20 11.868 16.053 14.5 20 17.131v-5.263Zm-.112 7.592-5.638-3.758-.586.39a3 3 0 0 1-3.328 0l-.586-.39-5.638 3.758A1 1 0 0 0 5 20h14a1 1 0 0 0 .888-.54ZM4 17.131 7.947 14.5 4 11.868v5.263Z",
        clipRule: "evenodd"
      }
    )
  }
), yee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.553 3.106a1 1 0 0 1 .894 0l5.447 2.723A2 2 0 0 1 22 7.618v10.764a2 2 0 0 1-2.894 1.789L15 18.118l-5.553 2.776a1 1 0 0 1-.894 0l-5.447-2.723A2 2 0 0 1 2 16.382V5.618a2 2 0 0 1 2.894-1.789L9 5.882l5.553-2.776ZM8 7.618l-4-2v10.764l4 2V7.618Zm2 10.764 4-2V5.618l-4 2v10.764Zm6-12.764v10.764l4 2V7.618l-4-2Z",
        clipRule: "evenodd"
      }
    )
  }
), xee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), See = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Cee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), bee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm9 6a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), _ee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Ree = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 5a4 4 0 1 1 8 0v6a4 4 0 0 1-8 0V5Zm4-2a2 2 0 0 0-2 2v6a2 2 0 1 0 4 0V5a2 2 0 0 0-2-2Zm-7 7a1 1 0 0 1 1 1 6 6 0 0 0 12 0 1 1 0 1 1 2 0 8.001 8.001 0 0 1-7 7.938V21h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-2.062A8.001 8.001 0 0 1 4 11a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Eee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 12a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Mee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6 0a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Tee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Oee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.353 2.939a1 1 0 0 1 .22 1.08 8 8 0 0 0 10.408 10.408 1 1 0 0 1 1.301 1.3A10.003 10.003 0 0 1 12 22C6.477 22 2 17.523 2 12c0-4.207 2.598-7.805 6.273-9.282a1 1 0 0 1 1.08.22ZM7.086 5.687a8 8 0 1 0 11.228 11.228c-.43.056-.87.085-1.314.085-5.523 0-10-4.477-10-10 0-.445.03-.883.086-1.313Z",
        clipRule: "evenodd"
      }
    )
  }
), Dee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.615 2.212A1 1 0 0 1 22 3v13c0 .99-.602 1.765-1.324 2.246-.729.486-1.678.754-2.676.754-.998 0-1.947-.268-2.676-.754C14.602 17.766 14 16.991 14 16c0-.99.602-1.765 1.324-2.246C16.053 13.268 17.002 13 18 13c.712 0 1.4.136 2 .391v-5.11l-10 2.5V19c0 .99-.602 1.765-1.324 2.246C7.947 21.732 6.998 22 6 22c-.998 0-1.947-.268-2.676-.754C2.602 20.766 2 19.991 2 19c0-.99.602-1.765 1.324-2.246C4.053 16.268 5.002 16 6 16c.713 0 1.4.137 2 .391V6a1 1 0 0 1 .757-.97l12-3a1 1 0 0 1 .858.182ZM10 8.719l10-2.5V4.281l-10 2.5v1.938ZM8 19c0-.114-.07-.34-.433-.582C7.21 18.18 6.659 18 6 18c-.659 0-1.21.18-1.567.418C4.07 18.66 4 18.886 4 19c0 .114.07.34.433.582C4.79 19.82 5.341 20 6 20c.659 0 1.21-.18 1.567-.418C7.93 19.34 8 19.114 8 19Zm12-3c0-.114-.07-.34-.433-.582C19.209 15.18 18.658 15 18 15c-.659 0-1.21.18-1.567.418-.364.243-.433.468-.433.582 0 .114.07.34.433.582.358.238.909.418 1.567.418.659 0 1.21-.18 1.567-.418.364-.243.433-.468.433-.582Z",
        clipRule: "evenodd"
      }
    )
  }
), jee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3h1a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm14.17 13H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12c0 .35.06.687.17 1ZM18 8v10a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1h-1ZM6 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8Zm2 1v2h4V9H8Zm-2 7a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Aee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v15h1a1 1 0 1 1 0 2H3a1 1 0 0 1 0-2h1V5Zm2 15h3v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4h3V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v15Zm7 0v-4h-2v4h2ZM8 7a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Zm-5 4a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), kee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 .894.553l9 18a1 1 0 0 1-1.11 1.423L12 20.024l-8.783 1.952a1 1 0 0 1-1.111-1.423l9-18A1 1 0 0 1 12 2Zm1 16.198 6.166 1.37L12 5.236 4.834 19.568 11 18.198V11a1 1 0 1 1 2 0v7.198Z",
        clipRule: "evenodd"
      }
    )
  }
), Lee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.883 4.874-6.418 6.59a5 5 0 1 0 7.07 7.071h.001l6.258-6.243a1 1 0 1 1 1.412 1.416L14.95 19.95a7 7 0 0 1-9.905-9.895l6.42-6.59a5 5 0 0 1 7.075 7.066l-6.419 6.59A3 3 0 0 1 7.88 12.88l6.585-6.586a1 1 0 1 1 1.415 1.414l-6.586 6.586a1 1 0 0 0 1.41 1.418l6.418-6.59a3 3 0 0 0-4.238-4.247Z",
        clipRule: "evenodd"
      }
    )
  }
), Iee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm8-4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Hee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.56 4.44a1.5 1.5 0 0 0-2.12 0l-.794.792 2.122 2.122.793-.793a1.5 1.5 0 0 0 0-2.122Zm1.415 3.535a3.5 3.5 0 0 0-4.95-4.95l-1.5 1.5L2.293 16.757a1 1 0 0 0-.293.707v3.572a1 1 0 0 0 1 1h3.5a1 1 0 0 0 .707-.293L20.975 7.975Zm-3.621.793-2.122-2.122L4 17.88v2.156h2.086L17.354 8.768Z",
        clipRule: "evenodd"
      }
    )
  }
), Zee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.707 4.293a1 1 0 0 0-1.414 0L10 12.586V14h1.414l8.293-8.293a1 1 0 0 0 0-1.414ZM16.88 2.879a3 3 0 1 1 4.24 4.241l-8.585 8.586a1 1 0 0 1-.708.293H9a1 1 0 0 1-1-1v-2.828a1 1 0 0 1 .293-.708l8.586-8.585ZM6 6a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-5a1 1 0 1 1 2 0v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h5a1 1 0 1 1 0 2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), Pee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Z",
        clipRule: "evenodd"
      }
    )
  }
), Vee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Zm15.293-1.707a1 1 0 1 1 1.414 1.414L17.414 8H20a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v2.586l4.293-4.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Nee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Zm10.293-.707a1 1 0 0 1 1.414 0L18 4.586l1.293-1.293a1 1 0 1 1 1.414 1.414L19.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L18 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L16.586 6l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Bee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h3.28a2 2 0 0 1 1.897 1.368l1.497 4.493a2 2 0 0 1-1.002 2.421l-1.357.679a10.055 10.055 0 0 0 3.724 3.724l.679-1.357a2 2 0 0 1 2.421-1.002l4.494 1.497A2 2 0 0 1 22 15.721V19a3 3 0 0 1-3 3h-1C9.163 22 2 14.837 2 6V5Zm3-1a1 1 0 0 0-1 1v1c0 7.732 6.268 14 14 14h1a1 1 0 0 0 1-1v-3.28l-4.493-1.497-1.13 2.257a1 1 0 0 1-1.305.465 12.042 12.042 0 0 1-6.017-6.018 1 1 0 0 1 .465-1.305l2.257-1.129L8.28 4H5Zm11 0a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V5.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L18.586 4H16Z",
        clipRule: "evenodd"
      }
    )
  }
), Fee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm2 10.414V18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.586l-1.293-1.293a1 1 0 0 0-1.414 0l-.879.879 1.293 1.293a1 1 0 0 1-1.414 1.414l-2-2-2.586-2.586a1 1 0 0 0-1.414 0L5 16.414Zm9-3.828-1.879-1.879a3 3 0 0 0-4.242 0L5 13.586V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5.592a3 3 0 0 0-4.121.115l-.879.879ZM13 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H14a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Uee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7-2.131c0-1.598 1.78-2.55 3.11-1.665l3.197 2.132a2 2 0 0 1 0 3.328l-3.198 2.132C10.78 16.682 9 15.729 9 14.132V9.869ZM14.197 12 11 9.869v4.263L14.197 12Z",
        clipRule: "evenodd"
      }
    )
  }
), Yee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a1 1 0 0 1 1 1v7h7a1 1 0 1 1 0 2h-7v7a1 1 0 1 1-2 0v-7H4a1 1 0 1 1 0-2h7V4a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), $ee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2V9a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Wee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0v-5H6a1 1 0 1 1 0-2h5V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), zee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v11a2 2 0 0 1-2 2h-4.586l2.293 2.293a1 1 0 0 1-1.414 1.414L12 18.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L9.586 18H5a2 2 0 0 1-2-2V5a1 1 0 0 1-1-1Zm3 1v11h14V5H5Zm11 2a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-4 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-4 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), qee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2v11a2 2 0 0 1-2 2h-4.586l2.293 2.293a1 1 0 0 1-1.414 1.414L12 18.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L9.586 18H5a2 2 0 0 1-2-2V5a1 1 0 0 1-1-1Zm3 1v11h14V5H5Zm12.707 2.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0L10 10.414l-2.293 2.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0L13 10.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Gee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v3h1a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-1H5a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1V5Zm2 3h8V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3Zm-3 2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v-1a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H5Zm11 5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Kee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a3 3 0 1 1 6 0v1h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1a1 1 0 1 0 0 2h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-1a1 1 0 1 0-2 0v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H4a3 3 0 1 1 0-6h1V7a2 2 0 0 1 2-2h3V4Zm3-1a1 1 0 0 0-1 1v1a2 2 0 0 1-2 2H7v3a2 2 0 0 1-2 2H4a1 1 0 1 0 0 2h1a2 2 0 0 1 2 2v3h3v-1a3 3 0 1 1 6 0v1h3v-3h-1a3 3 0 1 1 0-6h1V7h-3a2 2 0 0 1-2-2V4a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Qee = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm4 0H5v2h2V5Zm5-2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm3 2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm4 0h-2v2h2V5Zm-7 3a1 1 0 0 1 1 1v2h3.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Zm-9 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm16 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H20a1 1 0 0 1-1-1ZM3 17a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2Zm4 0H5v2h2v-2Zm4-1a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-1v3a1 1 0 1 1-2 0v-4Zm6 0a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm-2 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Xee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-4c-1.472 0-2.528.706-2.868 1.426a1 1 0 0 1-1.809-.852C8.082 6.964 9.99 6 12 6c1.3 0 2.515.394 3.428 1.079C16.343 7.764 17 8.786 17 10c0 2.07-1.834 3.508-3.817 3.889a.31.31 0 0 0-.162.083A.107.107 0 0 0 13 14a1 1 0 0 1-2 0c0-1.142.909-1.904 1.805-2.075C14.279 11.642 15 10.729 15 10c0-.443-.237-.92-.771-1.321C13.694 8.278 12.909 8 12 8Zm-1 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Jee = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v16a1 1 0 0 1-1.447.894L16 20.118l-3.553 1.776a1 1 0 0 1-.894 0L8 20.118l-3.553 1.776A1 1 0 0 1 3 21V5Zm3-1a1 1 0 0 0-1 1v14.382l2.553-1.276a1 1 0 0 1 .894 0L12 19.882l3.553-1.776a1 1 0 0 1 .894 0L19 19.382V5a1 1 0 0 0-1-1H6Zm5.707 2.293a1 1 0 0 1 0 1.414L10.414 9H12a5 5 0 0 1 5 5v1a1 1 0 1 1-2 0v-1a3 3 0 0 0-3-3h-1.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ete = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.496.868L15.5 20.152l-3.004 1.716a1 1 0 0 1-.992 0L8.5 20.152l-3.004 1.716A1 1 0 0 1 4 21V5Zm3-1a1 1 0 0 0-1 1v14.277l2.004-1.145a1 1 0 0 1 .992 0L12 19.848l3.004-1.716a1 1 0 0 1 .992 0L18 19.277V5a1 1 0 0 0-1-1H7Zm1 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6.293-1.207a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414-1.414l6-6ZM13 13.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
        clipRule: "evenodd"
      }
    )
  }
), tte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a1 1 0 0 1 1 1v2.343A8.982 8.982 0 0 1 12 3a9.001 9.001 0 0 1 8.93 7.876 1 1 0 1 1-1.984.248A7.001 7.001 0 0 0 6.254 8H9a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm-.062 9.008a1 1 0 0 1 1.116.868A7.001 7.001 0 0 0 17.746 16H15a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-2.343A8.982 8.982 0 0 1 12 21a9.001 9.001 0 0 1-8.93-7.876 1 1 0 0 1 .868-1.116Z",
        clipRule: "evenodd"
      }
    )
  }
), nte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 3.293a1 1 0 0 1 0 1.414L5.414 9H13a9 9 0 0 1 9 9v2a1 1 0 1 1-2 0v-2a7 7 0 0 0-7-7H5.414l4.293 4.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), rte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.8 6.4C10.118 5.411 12 6.352 12 8v2l4.8-3.6C18.119 5.411 20 6.352 20 8v8c0 1.648-1.881 2.589-3.2 1.6L12 14v2c0 1.648-1.882 2.589-3.2 1.6l-5.333-4a2 2 0 0 1 0-3.2l5.333-4ZM10 8l-5.333 4L10 16V8Zm8 0-5.333 4L18 16V8Z",
        clipRule: "evenodd"
      }
    )
  }
), ate = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5a1 1 0 0 1 1-1c7.732 0 14 6.268 14 14a1 1 0 1 1-2 0c0-6.627-5.373-12-12-12a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1 8 8 0 0 1 8 8 1 1 0 1 1-2 0 6 6 0 0 0-6-6 1 1 0 0 1-1-1Zm-1 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ote = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2,
        d: "M4 12c11 0 5 6 16 6M4 18C15 18 9 6 20 6M4 6c11 0 5 6 16 6"
      }
    )
  }
), ite = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a1 1 0 0 1 1 1v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 11.586V4a1 1 0 0 1 1-1ZM2 9a3 3 0 0 1 3-3h3a1 1 0 0 1 0 2H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-3a1 1 0 1 1 0-2h3a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9Z",
        clipRule: "evenodd"
      }
    )
  }
), lte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 2a1 1 0 0 1 1 1v6.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L13 9.586V3a1 1 0 0 1 1-1ZM6 7a3 3 0 0 1 3-3h1a1 1 0 1 1 0 2H9a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1a1 1 0 1 1 0-2h1a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h1V7Zm0 3H5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H9a3 3 0 0 1-3-3v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), ute = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1.28l5 1.666 2.684-.895a1 1 0 0 1 .632 1.898l-2.051.683 2.668 8.003a1 1 0 0 1-.33 1.164 6.002 6.002 0 0 1-7.204 0 1 1 0 0 1-.348-1.115l2.684-8.052L13 6.387V20h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V6.387L7.265 7.632l2.668 8.003a1 1 0 0 1-.33 1.164 6.002 6.002 0 0 1-7.204 0 1 1 0 0 1-.348-1.115l2.684-8.052-2.051-.683a1 1 0 0 1 .632-1.898L6 5.946l5-1.667V3a1 1 0 0 1 1-1Zm-6 8.162-1.803 5.41a4.01 4.01 0 0 0 3.606 0L6 10.162Zm12 0-1.803 5.41a4.01 4.01 0 0 0 3.606 0L18 10.162Z",
        clipRule: "evenodd"
      }
    )
  }
), ste = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM3 7a4 4 0 1 1 7.446 2.032L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414l-9.261 9.261a4 4 0 1 1-1.414-1.414L10.586 12l-1.554-1.554A4 4 0 0 1 3 7Zm4 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6.414-1.586a1 1 0 0 1 1.414 0l4.88 4.879a1 1 0 0 1-1.415 1.414l-4.879-4.879a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), cte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Z",
        clipRule: "evenodd"
      }
    )
  }
), fte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-3a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 1.968 3.446l-2.26 2.261a1 1 0 0 1-1.415-1.414l2.261-2.261A3.984 3.984 0 0 1 9 11Z",
        clipRule: "evenodd"
      }
    )
  }
), dte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a1 1 0 0 1 .707.293l4 4a1 1 0 0 1-1.414 1.414L12 6.414 8.707 9.707a1 1 0 0 1-1.414-1.414l4-4A1 1 0 0 1 12 4ZM7.293 14.293a1 1 0 0 1 1.414 0L12 17.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), hte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v4c0 .768-.289 1.47-.764 2 .475.53.764 1.232.764 2v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4c0-.768.289-1.47.764-2A2.989 2.989 0 0 1 2 10V6Zm3 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H5Zm14-2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14Zm-3-3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Zm0 8a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), vte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 .983 2.626l-5.071 2.536a4.012 4.012 0 0 1 0 1.676l5.071 2.536a4 4 0 1 1-.895 1.788l-5.071-2.536a4 4 0 1 1 0-5.253l5.071-2.535A4.015 4.015 0 0 1 14 6Zm-8 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 6a2 2 0 1 0-.001 4A2 2 0 0 0 18 16Z",
        clipRule: "evenodd"
      }
    )
  }
), pte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.333 2.2a1 1 0 0 1 1.334 0 10.955 10.955 0 0 0 7.9 2.786 1 1 0 0 1 1.019.748C21.856 6.778 22 7.874 22 9c0 6.059-4.144 11.147-9.75 12.59a1 1 0 0 1-.5 0C6.145 20.147 2 15.06 2 9c0-1.127.144-2.222.414-3.266a1 1 0 0 1 1.019-.748 10.955 10.955 0 0 0 7.9-2.786ZM4.181 6.998A11.092 11.092 0 0 0 4 9c0 5.034 3.382 9.28 8 10.586 4.618-1.305 8-5.552 8-10.586 0-.684-.062-1.353-.181-2.001a12.946 12.946 0 0 1-7.82-2.751 12.946 12.946 0 0 1-7.818 2.75Zm11.526 2.294a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), mte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.333 2.2a1 1 0 0 1 1.334 0 10.955 10.955 0 0 0 7.9 2.786 1 1 0 0 1 1.019.748C21.856 6.778 22 7.874 22 9c0 6.059-4.144 11.147-9.75 12.59a1 1 0 0 1-.5 0C6.145 20.147 2 15.06 2 9c0-1.127.144-2.222.414-3.266a1 1 0 0 1 1.019-.748 10.955 10.955 0 0 0 7.9-2.786ZM4.181 6.998A11.092 11.092 0 0 0 4 9c0 5.034 3.382 9.28 8 10.586 4.618-1.305 8-5.552 8-10.586 0-.684-.062-1.353-.181-2.001a12.946 12.946 0 0 1-7.82-2.751 12.946 12.946 0 0 1-7.818 2.75ZM12 8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm-1 7a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), gte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 7a5 5 0 0 1 10 0v1h2a1 1 0 0 1 .997.917l1 12A1 1 0 0 1 20 22H4a1 1 0 0 1-.997-1.083l1-12A1 1 0 0 1 5 8h2V7Zm0 3v1a1 1 0 1 0 2 0v-1h6v1a1 1 0 1 0 2 0v-1h1.08l.833 10H5.087l.833-10H7Zm8-2H9V7a3 3 0 1 1 6 0v1Z",
        clipRule: "evenodd"
      }
    )
  }
), wte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3a1 1 0 0 1 1-1h2a1 1 0 0 1 .98.804L6.22 4H21a1 1 0 0 1 .894 1.447l-4 8A1 1 0 0 1 17 14H7.414l-2 2H17a3 3 0 1 1-2.83 2H9.83a3 3 0 1 1-5.521-.326c-.98-.65-1.268-2.129-.309-3.088l1.914-1.915L4.18 4H3a1 1 0 0 1-1-1Zm5.82 9h8.562l3-6H6.62l1.2 6ZM7 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), yte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM19 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), xte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm7 1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2ZM3 16a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6Zm11-2a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Ste = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm14 2.414-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L18 10.414V20a1 1 0 1 1-2 0v-9.586ZM2 12a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Cte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm15-1a1 1 0 0 1 1 1v9.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 17.586V8a1 1 0 0 1 1-1ZM2 12a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), bte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0V6H3a1 1 0 0 1 0-2h1V3a1 1 0 0 1 1-1Zm8 0a1 1 0 0 1 .949.684l2.135 6.404 5.267 1.976a1 1 0 0 1 0 1.872l-5.267 1.976-2.135 6.404a1 1 0 0 1-1.898 0l-2.135-6.404-5.267-1.976a1 1 0 0 1 0-1.872l5.267-1.976 2.135-6.404A1 1 0 0 1 13 2Zm0 4.162-1.337 4.011a1 1 0 0 1-.598.62L7.848 12l3.217 1.207a1 1 0 0 1 .598.62L13 17.837l1.337-4.01a1 1 0 0 1 .598-.62L18.152 12l-3.217-1.207a1 1 0 0 1-.598-.62L13 6.163ZM6 16a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H7v1a1 1 0 1 1-2 0v-1H4a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), _te = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.351 2.064A1 1 0 0 1 19 3v3.126a4.002 4.002 0 0 1 0 7.748V17a1 1 0 0 1-1.753.658c-.613-.702-1.699-1.375-3.188-1.872A14.547 14.547 0 0 0 12 15.271v3.97a2.76 2.76 0 0 1-5.359.927l-.002-.006-2.01-5.76A5 5 0 0 1 7 5h1.832a18.768 18.768 0 0 0 2.07-.112 15.426 15.426 0 0 0 3.157-.673c1.49-.497 2.575-1.17 3.188-1.872a1 1 0 0 1 1.104-.278ZM10 6.968A21.14 21.14 0 0 1 8.832 7H7a3 3 0 0 0 0 6h1.832c.394 0 .784.01 1.168.032V6.968Zm2 6.275V6.757a16.89 16.89 0 0 0 2.692-.646c.84-.28 1.62-.626 2.308-1.035v9.848a11.903 11.903 0 0 0-2.308-1.035A16.807 16.807 0 0 0 12 13.243Zm7-1.51a2 2 0 0 0 0-3.465v3.464Zm-9 3.303A19.108 19.108 0 0 0 8.832 15H6.955l1.57 4.496v.002A.76.76 0 0 0 10 19.24v-4.204Z",
        clipRule: "evenodd"
      }
    )
  }
), Rte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17 2a3 3 0 0 0-3 3v1.17c-.313-.11-.65-.17-1-.17h-2a3 3 0 0 0-3 3v1.17c-.313-.11-.65-.17-1-.17H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h2c.768 0 1.47-.289 2-.764.53.475 1.232.764 2 .764h2c.768 0 1.47-.289 2-.764.53.475 1.232.764 2 .764h2a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3h-2Zm-7 17v-5h4v5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1Zm4-7h-4V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3Zm-7 0a1 1 0 0 1 1 1v2H4v-2a1 1 0 0 1 1-1h2Zm-3 7v-2h4v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm12 0a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9h-4v9Zm0-11V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Ete = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.098 2.618c.599-1.843 3.205-1.843 3.804 0l1.519 4.673h4.914c1.938 0 2.743 2.48 1.176 3.619l-3.976 2.889 1.519 4.674c.598 1.842-1.51 3.374-3.078 2.236L12 17.82l-3.976 2.889c-1.567 1.138-3.676-.394-3.078-2.236l1.519-4.674-3.976-2.89C.922 9.772 1.727 7.293 3.665 7.293h4.914l1.519-4.674ZM12 3.236 10.481 7.91A2 2 0 0 1 8.58 9.29H3.665l3.975 2.89a2 2 0 0 1 .727 2.235L6.848 19.09l3.977-2.888a2 2 0 0 1 2.35 0l3.976 2.888-1.518-4.674a2 2 0 0 1 .727-2.236l3.975-2.888h-4.914a2 2 0 0 1-1.902-1.382L12 3.236Z",
        clipRule: "evenodd"
      }
    )
  }
), Mte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 2.293a1 1 0 0 1 1.414 0l7.775 7.775a2.002 2.002 0 0 1 2.45 2.45l1.514 1.514a4.001 4.001 0 0 0-.618-4.86 1 1 0 0 1 1.415-1.415 6.002 6.002 0 0 1 .648 7.72l1.43 1.429a8.001 8.001 0 0 0-.664-10.563A1 1 0 1 1 19.07 4.93c3.667 3.667 3.89 9.472.672 13.4l1.964 1.964a1 1 0 0 1-1.414 1.414l-18-18a1 1 0 0 1 0-1.414Zm1.495 5.885a1 1 0 0 1 .629 1.267 8 8 0 0 0 1.926 8.212A1 1 0 1 1 4.93 19.07 10 10 0 0 1 2.52 8.807a1 1 0 0 1 1.267-.629Zm3.121 3.539a1 1 0 0 1 1.131.85 3.978 3.978 0 0 0 1.132 2.261 1 1 0 0 1-1.415 1.415 5.978 5.978 0 0 1-1.697-3.396 1 1 0 0 1 .85-1.13Z",
        clipRule: "evenodd"
      }
    )
  }
), Tte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.343 4.929a1 1 0 0 1 0 1.414 8 8 0 0 0 0 11.314A1 1 0 1 1 4.93 19.07c-3.905-3.905-3.905-10.237 0-14.142a1 1 0 0 1 1.414 0Zm11.314 0a1 1 0 0 1 1.414 0c3.905 3.905 3.905 10.237 0 14.142a1 1 0 0 1-1.414-1.414 8 8 0 0 0 0-11.314 1 1 0 0 1 0-1.414ZM9.172 7.757a1 1 0 0 1 0 1.415 4 4 0 0 0 0 5.656 1 1 0 1 1-1.415 1.415 6 6 0 0 1 0-8.486 1 1 0 0 1 1.415 0Zm5.656 0a1 1 0 0 1 1.415 0 6 6 0 0 1 0 8.486 1 1 0 1 1-1.415-1.415 4 4 0 0 0 0-5.656 1 1 0 0 1 0-1.415ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Ote = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm6-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4Zm6 0h-4v4h4v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Dte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1ZM4.929 4.929a1 1 0 0 1 1.414 0l.707.707A1 1 0 1 1 5.636 7.05l-.707-.707a1 1 0 0 1 0-1.414Zm14.142 0a1 1 0 0 1 0 1.414l-.707.707a1 1 0 1 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm-5 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm17 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Zm-2.05 4.95a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1-1.414 1.414l-.707-.707a1 1 0 0 1 0-1.414Zm-11.314 0a1 1 0 0 1 1.414 1.414l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707ZM12 19a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), jte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.01 4.061a8.001 8.001 0 0 0-6.79 9.813l2.992-1.141a4.874 4.874 0 0 1 3.803-5.463l-.004-3.209Zm-3.112 10.55-2.97 1.133A7.999 7.999 0 0 0 12 20a7.999 7.999 0 0 0 7.067-4.248l-2.907-1.123a4.869 4.869 0 0 1-4.125 2.28 4.87 4.87 0 0 1-4.137-2.297ZM20 12.002c0 .647-.077 1.278-.222 1.881l-2.922-1.128a4.874 4.874 0 0 0-3.84-5.491l-.004-3.2A8.001 8.001 0 0 1 19.999 12ZM2 12C2 6.476 6.477 2 12 2c5.522 0 10 4.476 10 10 0 5.522-4.479 10-10 10-5.523 0-10-4.477-10-10Zm10.035-2.837a2.872 2.872 0 1 0 0 5.744 2.872 2.872 0 0 0 0-5.744Z",
        clipRule: "evenodd"
      }
    )
  }
), Ate = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.68 7.094A7.965 7.965 0 0 0 4 12c0 1.849.627 3.551 1.68 4.906l2.148-2.149A4.977 4.977 0 0 1 7 12c0-1.02.305-1.967.828-2.757L5.68 7.094ZM7.094 5.68l2.149 2.148A4.977 4.977 0 0 1 12 7c1.02 0 1.967.305 2.757.828l2.149-2.148A7.965 7.965 0 0 0 12 4a7.965 7.965 0 0 0-4.906 1.68ZM18.32 7.094l-2.148 2.149c.523.79.828 1.738.828 2.757 0 1.02-.305 1.967-.828 2.757l2.148 2.149A7.965 7.965 0 0 0 20 12a7.966 7.966 0 0 0-1.68-4.906ZM16.906 18.32l-2.149-2.148A4.977 4.977 0 0 1 12 17a4.977 4.977 0 0 1-2.757-.828L7.094 18.32A7.966 7.966 0 0 0 12 20a7.965 7.965 0 0 0 4.906-1.68ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), kte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.707 6.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L17.586 8H8a1 1 0 1 1 0-2h9.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4ZM6.414 16H16a1 1 0 1 1 0 2H6.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L6.414 16Z",
        clipRule: "evenodd"
      }
    )
  }
), Lte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.293 3.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L8 6.414V16a1 1 0 1 1-2 0V6.414L3.707 8.707a1 1 0 0 1-1.414-1.414l4-4ZM16 17.586V8a1 1 0 1 1 2 0v9.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L16 17.586Z",
        clipRule: "evenodd"
      }
    )
  }
), Ite = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8Zm3-1a1 1 0 0 0-1 1v1h16V8a1 1 0 0 0-1-1H5Zm15 4h-7v2h7v-2Zm0 4h-7v2h6a1 1 0 0 0 1-1v-1Zm-9 2v-2H4v1a1 1 0 0 0 1 1h6Zm-7-4h7v-2H4v2Z",
        clipRule: "evenodd"
      }
    )
  }
), Hte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a3 3 0 0 0-3 3v5c0 .299.13.566.339.75l.023.02 6.996 6.997A.992.992 0 0 0 12 20a.992.992 0 0 0 .642-.233l6.974-6.974a.96.96 0 0 1 .045-.043.996.996 0 0 0 .106-1.392l-6.974-6.974a.965.965 0 0 1-.043-.045A.995.995 0 0 0 12 4H7ZM2 7a5 5 0 0 1 5-5h5c.884 0 1.68.383 2.227.99l6.98 6.98.043.045c.466.529.75 1.225.75 1.985 0 .884-.383 1.68-.99 2.227l-6.98 6.98A2.992 2.992 0 0 1 12 22a2.992 2.992 0 0 1-2.03-.793l-6.98-6.98A2.995 2.995 0 0 1 2 12V7Zm4 0a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Zte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm16 0H5v2h14V5ZM3 13a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6Zm8 0H5v6h6v-6Zm4 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-6Zm4 0h-2v6h2v-6Z",
        clipRule: "evenodd"
      }
    )
  }
), Pte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5Zm2.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L9.586 12 7.293 9.707a1 1 0 0 1 0-1.414ZM12 15a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Vte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.736 4a1 1 0 0 0-.894.553l-3.5 7A1 1 0 0 0 5.236 13H12a1 1 0 1 1 0 2h-1v4a1 1 0 0 0 1 1 4.62 4.62 0 0 1 .776-2.466L16 12.697V4.781l-3.004-.751a1 1 0 0 0-.242-.03H8.736ZM18 5v8h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1Zm-1.131 10-2.43 3.643c-.286.43-.439.936-.439 1.453A1.905 1.905 0 0 1 12.095 22H12a3 3 0 0 1-3-3v-4H5.236c-2.23 0-3.68-2.347-2.683-4.342l3.5-7A3 3 0 0 1 8.736 2h4.018a3 3 0 0 1 .727.09l3.642.91H19a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-2.131Z",
        clipRule: "evenodd"
      }
    )
  }
), Nte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3.905C10 2.853 10.853 2 11.905 2H12a3 3 0 0 1 3 3v4h3.764c2.23 0 3.68 2.347 2.683 4.342l-3.5 7A3 3 0 0 1 15.264 22h-4.018a3 3 0 0 1-.727-.09L6.877 21H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h2.131l2.43-3.643c.286-.43.439-.936.439-1.452ZM6 11H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1v-8Zm2 8.22v-7.917l3.224-4.837A4.617 4.617 0 0 0 12 4a1 1 0 0 1 1 1v4h-1a1 1 0 1 0 0 2h6.764a1 1 0 0 1 .894 1.447l-3.5 7a1 1 0 0 1-.894.553h-4.018a.996.996 0 0 1-.242-.03L8 19.22Z",
        clipRule: "evenodd"
      }
    )
  }
), Bte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1 1 1 0 1 0 0 2 1 1 0 0 1 1 1v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-3a1 1 0 0 1 1-1 1 1 0 1 0 0-2 1 1 0 0 1-1-1V7Zm14 11v-1a1 1 0 1 0-2 0v1H5a1 1 0 0 1-1-1v-2.17a3.001 3.001 0 0 0 0-5.66V7a1 1 0 0 1 1-1h9v1a1 1 0 1 0 2 0V6h3a1 1 0 0 1 1 1v2.17a3.001 3.001 0 0 0 0 5.66V17a1 1 0 0 1-1 1h-3Zm-1-8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Fte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a1 1 0 0 1 1 1v1h5a1 1 0 1 1 0 2h-1.422a18.914 18.914 0 0 1-3.292 7.286c.157.176.318.35.482.52a1 1 0 0 1-1.44 1.389 19.02 19.02 0 0 1-.328-.35 19.06 19.06 0 0 1-5.555 4.18 1 1 0 1 1-.89-1.792 17.062 17.062 0 0 0 5.159-3.947A18.978 18.978 0 0 1 5.49 9.389a1 1 0 1 1 1.842-.778A16.963 16.963 0 0 0 9 11.646 16.915 16.915 0 0 0 11.527 6H3a1 1 0 1 1 0-2h5V3a1 1 0 0 1 1-1Zm7 8a1 1 0 0 1 .894.553l3.491 6.982.02.037 1.49 2.98a1 1 0 1 1-1.79.895L18.883 19h-5.764l-1.224 2.447a1 1 0 1 1-1.788-.894l1.49-2.98.019-.038 3.49-6.982A1 1 0 0 1 16 10Zm-1.882 7h3.764L16 13.236 14.118 17Z",
        clipRule: "evenodd"
      }
    )
  }
), Ute = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2h4a1 1 0 1 1 0 2h-.069l-.8 11.214A3 3 0 0 1 16.137 22H7.862a3 3 0 0 1-2.992-2.786L4.069 8H4a1 1 0 0 1 0-2h4V4ZM6.074 8l.79 11.071a1 1 0 0 0 .998.929h8.276a1 1 0 0 0 .997-.929L17.926 8H6.074ZM14 6h-4V4h4v2Zm-4 4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Yte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.293 6.293a1 1 0 0 1 1.414 0L9 11.586l3.293-3.293a1 1 0 0 1 1.414 0L20 14.586V9a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1h-8a1 1 0 1 1 0-2h5.586L13 10.414l-3.293 3.293a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), $te = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V9.414l-6.293 6.293a1 1 0 0 1-1.414 0L9 12.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0L13 13.586 18.586 8H13Z",
        clipRule: "evenodd"
      }
    )
  }
), Wte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2h2.586A2 2 0 0 1 18 6.586l-.707.707.707-.707L21.414 10A2 2 0 0 1 22 11.414V16a2 2 0 0 1-2 2h-.17a3.001 3.001 0 0 1-5.66 0H14a1.99 1.99 0 0 1-1-.268A1.99 1.99 0 0 1 12 18H9.83a3.001 3.001 0 0 1-5.66 0H4a2 2 0 0 1-2-2V6Zm2.17 10a3.001 3.001 0 0 1 5.66 0H12V7.997 8m0-.003V6H4v10h.17M14 16h.17a3.001 3.001 0 0 1 5.66 0H20v-4.586L16.586 8H14v8Zm-7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), zte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 17a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 1 1 2 0v1a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-1a1 1 0 1 1 2 0v1Zm2.293-8.293a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 6.414V16a1 1 0 1 1-2 0V6.414L8.707 8.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), qte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7Zm-.917 13h11.834a6.002 6.002 0 0 0-11.834 0ZM4 21a8 8 0 1 1 16 0 1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Gte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7Zm14 1a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V9a1 1 0 0 1 1-1Zm-9 7a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm-7 5a7 7 0 1 1 14 0v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Kte = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 0 0-6.598 12.526A14.943 14.943 0 0 1 12 15c2.366 0 4.606.548 6.598 1.526A8 8 0 0 0 12 4Zm7.654 14.436A9.96 9.96 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.96 9.96 0 0 0 2.37 6.464A9.978 9.978 0 0 0 12 22a9.978 9.978 0 0 0 7.654-3.564ZM17.2 18.08A12.954 12.954 0 0 0 12 17c-1.85 0-3.607.386-5.199 1.08A7.968 7.968 0 0 0 12 20c1.985 0 3.8-.723 5.199-1.92ZM12 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Qte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM8 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM5 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm17-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-4 4a4.002 4.002 0 0 0-4 4v1h8v-1a4.002 4.002 0 0 0-4-4Zm6 5h3v-1a2 2 0 0 0-3.213-1.59c.139.507.213 1.04.213 1.59v1Zm-1.071-4.422A5.992 5.992 0 0 0 12 12a5.993 5.993 0 0 0-4.929 2.578A4 4 0 0 0 1 18v2a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-2a4 4 0 0 0-6.071-3.422ZM6.213 16.41A2 2 0 0 0 3 18v1h3v-1c0-.55.074-1.083.213-1.59Z",
        clipRule: "evenodd"
      }
    )
  }
), Xte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm3-1a5 5 0 1 0 0 8 5 5 0 1 0 0-8Zm1.334 1.505C13.758 5.239 14 6.09 14 7s-.242 1.76-.666 2.495a3 3 0 1 0 0-4.99ZM9 15a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm7 5h4a5 5 0 0 0-6.001-4.9A6.977 6.977 0 0 1 16 20Zm-4-6.326A7 7 0 0 0 2 20v1a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-1a7 7 0 0 0-10-6.326Z",
        clipRule: "evenodd"
      }
    )
  }
), Jte = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.555 3.104a1 1 0 0 1 1.34.451A18.926 18.926 0 0 1 21.872 12c0 3.031-.71 5.9-1.975 8.445a1 1 0 0 1-1.791-.89A16.926 16.926 0 0 0 19.87 12c0-2.716-.636-5.28-1.766-7.555a1 1 0 0 1 .45-1.34Zm-13.239 0a1 1 0 0 1 .45 1.341A16.926 16.926 0 0 0 4 12c0 2.716.636 5.28 1.767 7.555a1 1 0 1 1-1.791.89A18.926 18.926 0 0 1 2 12c0-3.032.71-5.9 1.976-8.445a1 1 0 0 1 1.34-.45ZM8 9a1 1 0 0 1 1-1h1.246a2 2 0 0 1 1.923 1.45l.282.988 1.191-1.39A3 3 0 0 1 15.92 8H16a1 1 0 1 1 0 2h-.08a1 1 0 0 0-.76.35l-2.05 2.392.644 2.258H15a1 1 0 1 1 0 2h-1.246a2 2 0 0 1-1.923-1.45l-.282-.988-1.191 1.39A3 3 0 0 1 8.08 17H8a1 1 0 1 1 0-2h.08a1 1 0 0 0 .76-.35l2.05-2.392L10.247 10H9a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ene = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v.382l3.106-1.553A2 2 0 0 1 22 8.618v6.764a2 2 0 0 1-2.894 1.789L16 15.618V16a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8Zm12 5.978a.97.97 0 0 0 0 .042V16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.978Zm2-.596 4 2V8.618l-4 2v2.764Z",
        clipRule: "evenodd"
      }
    )
  }
), tne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 7a3 3 0 0 1 3-3h2c.768 0 1.47.289 2 .764A2.989 2.989 0 0 1 11 4h2c.768 0 1.47.289 2 .764A2.989 2.989 0 0 1 17 4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 13 20h-2c-.768 0-1.47-.289-2-.764A2.989 2.989 0 0 1 7 20H5a3 3 0 0 1-3-3V7Zm8 10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v10ZM8 7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7Zm8 0v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1Z",
        clipRule: "evenodd"
      }
    )
  }
), nne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Zm7 1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2ZM3 16a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6Zm7 1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Z",
        clipRule: "evenodd"
      }
    )
  }
), rne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), ane = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.586 3.586C10.846 2.326 13 3.218 13 5v14c0 1.782-2.154 2.674-3.414 1.414L5.172 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.172l4.414-4.414ZM11 5 6.293 9.707a1 1 0 0 1-.707.293H4v4h1.586a1 1 0 0 1 .707.293L11 19V5Zm5.293 4.293a1 1 0 0 1 1.414 0L19 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L20.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L19 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L17.586 12l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), one = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.586 3.586C10.846 2.326 13 3.218 13 5v14c0 1.782-2.154 2.674-3.414 1.414L5.172 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.172l4.414-4.414ZM11 5 6.293 9.707a1 1 0 0 1-.707.293H4v4h1.586a1 1 0 0 1 .707.293L11 19V5Zm6.657-.071a1 1 0 0 1 1.414 0c3.905 3.905 3.905 10.237 0 14.142a1 1 0 0 1-1.414-1.414 8 8 0 0 0 0-11.314 1 1 0 0 1 0-1.414Zm-2.829 2.828a1 1 0 0 1 1.415 0 6 6 0 0 1 0 8.486 1 1 0 1 1-1.415-1.415 4 4 0 0 0 0-5.656 1 1 0 0 1 0-1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), ine = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.9 10.1c-5.468-5.467-14.332-5.467-19.8 0A1 1 0 0 1 .687 8.687c6.249-6.248 16.38-6.248 22.628 0a1 1 0 0 1-1.414 1.415Zm-3.536 3.536a9 9 0 0 0-12.728 0 1 1 0 0 1-1.414-1.414c4.296-4.296 11.26-4.296 15.556 0a1 1 0 0 1-1.414 1.414Zm-3.182 3.475a4.5 4.5 0 0 0-6.364 0 1 1 0 0 1-1.414-1.414 6.5 6.5 0 0 1 9.192 0 1 1 0 1 1-1.414 1.414ZM11 20a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H12a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), lne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), une = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.293-2.707a1 1 0 0 1 1.414 0L12 10.586l1.293-1.293a1 1 0 1 1 1.414 1.414L13.414 12l1.293 1.293a1 1 0 0 1-1.414 1.414L12 13.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L10.586 12l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), sne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Zm8-4a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H7a1 1 0 1 1 0-2h2V7a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), cne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 24 24",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A8 8 0 0 1 2 10Zm4 0a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), fne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.394 2.08a1 1 0 0 0-.788 0l-7 3a1 1 0 0 0 0 1.84L5.25 8.051a.999.999 0 0 1 .356-.257l4-1.714a1 1 0 1 1 .788 1.838l-2.727 1.17 1.94.831a1 1 0 0 0 .787 0l7-3a1 1 0 0 0 0-1.838l-7-3ZM3.31 9.397 5 10.12v4.102a8.969 8.969 0 0 0-1.05-.174 1 1 0 0 1-.89-.89 11.115 11.115 0 0 1 .25-3.762Zm5.99 7.176A9.026 9.026 0 0 0 7 14.935v-3.957l1.818.78a3 3 0 0 0 2.364 0l5.508-2.361a11.026 11.026 0 0 1 .25 3.762 1 1 0 0 1-.89.89 8.968 8.968 0 0 0-5.35 2.524 1 1 0 0 1-1.4 0ZM6 18a1 1 0 0 0 1-1v-2.065a8.935 8.935 0 0 0-2-.712V17a1 1 0 0 0 1 1Z"
      }
    )
  }
), dne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 4a1 1 0 0 0-2 0v7.268a2 2 0 0 0 0 3.464V16a1 1 0 1 0 2 0v-1.268a2 2 0 0 0 0-3.464V4Zm6 0a1 1 0 1 0-2 0v1.268a2 2 0 0 0 0 3.464V16a1 1 0 1 0 2 0V8.732a2 2 0 0 0 0-3.464V4Zm5-1a1 1 0 0 1 1 1v7.268a2 2 0 0 1 0 3.464V16a1 1 0 1 1-2 0v-1.268a2 2 0 0 1 0-3.464V4a1 1 0 0 1 1-1Z"
      }
    )
  }
), hne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 13V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3l3 3 3-3h3a2 2 0 0 0 2-2ZM5 7a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), vne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 3a2 2 0 1 0 0 4h12a2 2 0 1 0 0-4H4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 8h14v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Zm5 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), pne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-11a1 1 0 1 0-2 0v3.586L7.707 9.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 10.586V7Z",
        clipRule: "evenodd"
      }
    )
  }
), mne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.707-10.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L9.414 11H13a1 1 0 1 0 0-2H9.414l1.293-1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), gne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.707-8.707-3-3a1 1 0 0 0-1.414 1.414L10.586 9H7a1 1 0 1 0 0 2h3.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), wne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.707-8.707-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L9 9.414V13a1 1 0 1 0 2 0V9.414l1.293 1.293a1 1 0 0 0 1.414-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), yne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.707 10.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L9 14.586V3a1 1 0 0 1 2 0v11.586l4.293-4.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), xne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 16.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 1 1 0 2H5.414l4.293 4.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Sne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 12.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 14.586V3a1 1 0 0 1 2 0v11.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Cne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.707 14.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 1 1 0 2H5.414l2.293 2.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), bne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), _ne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 7.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L11 5.414V17a1 1 0 1 1-2 0V5.414L6.707 7.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Rne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.293 3.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Ene = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H6.414l2.293 2.293a1 1 0 0 1-1.414 1.414L5 6.414V8a1 1 0 0 1-2 0V4Zm9 1a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V6.414l-2.293 2.293a1 1 0 1 1-1.414-1.414L13.586 5H12Zm-9 7a1 1 0 1 1 2 0v1.586l2.293-2.293a1 1 0 0 1 1.414 1.414L6.414 15H8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1v-4Zm13-1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h1.586l-2.293-2.293a1 1 0 0 1 1.414-1.414L15 13.586V12a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Mne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 10.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 12.586V5a1 1 0 0 1 2 0v7.586l2.293-2.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Tne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.707 14.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L7.414 9H15a1 1 0 1 1 0 2H7.414l2.293 2.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), One = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L12.586 11H5a1 1 0 1 1 0-2h7.586l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Dne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 9.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L11 7.414V15a1 1 0 1 1-2 0V7.414L6.707 9.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), jne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.293 9.707a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L11 5.414V17a1 1 0 1 1-2 0V5.414L4.707 9.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Ane = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.243 5.757a6 6 0 1 0-.986 9.284 1 1 0 1 1 1.087 1.678A8 8 0 1 1 18 10a3 3 0 0 1-4.8 2.401A4 4 0 1 1 14 10a1 1 0 1 0 2 0c0-1.537-.586-3.07-1.757-4.243ZM12 10a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), kne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_3957_11497)", children: [
        /* @__PURE__ */ f.jsx(
          "rect",
          {
            width: "42",
            height: "42",
            rx: "21",
            fill: "#161618",
            fillOpacity: "0.1"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M33.8 21C33.8 28.0692 28.0692 33.8 21 33.8C13.9308 33.8 8.2 28.0692 8.2 21C8.2 13.9308 13.9308 8.2 21 8.2C28.0692 8.2 33.8 13.9308 33.8 21ZM24.2 16.2C24.2 17.9673 22.7673 19.4 21 19.4C19.2327 19.4 17.8 17.9673 17.8 16.2C17.8 14.4327 19.2327 13 21 13C22.7673 13 24.2 14.4327 24.2 16.2ZM20.9999 22.6C17.7718 22.6 14.9903 24.5119 13.726 27.2651C15.4864 29.3072 18.0922 30.6 21 30.6C23.9076 30.6 26.5134 29.3073 28.2739 27.2653C27.0096 24.512 24.228 22.6 20.9999 22.6Z",
            fill: "#C8C7CB"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_3957_11497", children: /* @__PURE__ */ f.jsx("rect", { width: "42", height: "42", fill: "white" }) }) })
    ]
  }
), Lne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.707 4.879A3 3 0 0 1 8.828 4H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H8.828a3 3 0 0 1-2.12-.879l-4.415-4.414a1 1 0 0 1 0-1.414l4.414-4.414Zm4 2.414a1 1 0 0 0-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L12 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L13.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L12 8.586l-1.293-1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Ine = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.267 3.455a3.066 3.066 0 0 0 1.745-.723 3.066 3.066 0 0 1 3.976 0 3.066 3.066 0 0 0 1.745.723 3.066 3.066 0 0 1 2.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 0 1 0 3.976 3.066 3.066 0 0 0-.723 1.745 3.066 3.066 0 0 1-2.812 2.812 3.066 3.066 0 0 0-1.745.723 3.066 3.066 0 0 1-3.976 0 3.066 3.066 0 0 0-1.745-.723 3.066 3.066 0 0 1-2.812-2.812 3.066 3.066 0 0 0-.723-1.745 3.066 3.066 0 0 1 0-3.976 3.066 3.066 0 0 0 .723-1.745 3.066 3.066 0 0 1 2.812-2.812Zm7.44 5.252a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Hne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-4.523 4.89A6 6 0 0 1 5.11 6.524l8.367 8.368Zm1.414-1.414L6.524 5.11a6 6 0 0 1 8.367 8.367Z",
        clipRule: "evenodd"
      }
    )
  }
), Zne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a1 1 0 0 0-.707 1.707L7 4.414v3.758a1 1 0 0 1-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0 1 13 8.172V4.414l.707-.707A1 1 0 0 0 13 2H7Zm2 6.172V4h2v4.172a3 3 0 0 0 .879 2.12l1.027 1.028a4 4 0 0 0-2.171.102l-.47.156a4 4 0 0 1-2.53 0l-.563-.187a1.993 1.993 0 0 0-.114-.035l1.063-1.063A3 3 0 0 0 9 8.172Z",
        clipRule: "evenodd"
      }
    )
  }
), Pne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a6 6 0 0 0-6 6v3.586l-.707.707A1 1 0 0 0 4 14h12a1 1 0 0 0 .707-1.707L16 11.586V8a6 6 0 0 0-6-6Zm0 16a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3Z"
      }
    )
  }
), Vne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14l-5-2.5L5 18V4Z"
      }
    )
  }
), Nne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm11 1H6v8l4-2 4 2V6Z",
        clipRule: "evenodd"
      }
    )
  }
), Bne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 4.804A7.968 7.968 0 0 0 5.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 0 1 5.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0 1 14.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0 0 14.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 1 1-2 0V4.804Z"
      }
    )
  }
), Fne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 6V5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2a2 2 0 0 1 2 2v3.57A22.952 22.952 0 0 1 10 13a22.95 22.95 0 0 1-8-1.43V8a2 2 0 0 1 2-2h2Zm2-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H8V5Zm1 5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 13.692V16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.308A24.974 24.974 0 0 1 10 15a24.98 24.98 0 0 1-8-1.308Z"
        }
      )
    ]
  }
), Une = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 3a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Zm2 3a1 1 0 0 0-2 0v1a2 2 0 0 0-2 2v1a2 2 0 0 0-2 2v.683a3.7 3.7 0 0 1 1.055.485 1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0 3.704 3.704 0 0 1 4.11 0 1.704 1.704 0 0 0 1.89 0A3.7 3.7 0 0 1 18 12.683V12a2 2 0 0 0-2-2V9a2 2 0 0 0-2-2V6a1 1 0 1 0-2 0v1h-1V6a1 1 0 1 0-2 0v1H8V6Zm10 8.868a3.704 3.704 0 0 1-4.055-.036 1.704 1.704 0 0 0-1.89 0 3.704 3.704 0 0 1-4.11 0 1.704 1.704 0 0 0-1.89 0A3.704 3.704 0 0 1 2 14.868V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2.132ZM9 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Zm3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Z"
      }
    )
  }
), Yne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm1 2a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Zm6 7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-3 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H10Zm-4 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H7Zm2 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Zm4-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H13ZM9 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1ZM7 8a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), $ne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a1 1 0 0 0-1 1v1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1V3a1 1 0 1 0-2 0v1H7V3a1 1 0 0 0-1-1Zm0 5a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H6Z",
        clipRule: "evenodd"
      }
    )
  }
), Wne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1.586a1 1 0 0 1-.707-.293l-1.121-1.121A2 2 0 0 0 11.172 3H8.828a2 2 0 0 0-1.414.586L6.293 4.707A1 1 0 0 1 5.586 5H4Zm6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        clipRule: "evenodd"
      }
    )
  }
), zne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 1a1 1 0 0 0 0 2h1.22l.305 1.222a.997.997 0 0 0 .01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 0 0 0-2H6.414l1-1H14a1 1 0 0 0 .894-.553l3-6A1 1 0 0 0 17 3H6.28l-.31-1.243A1 1 0 0 0 5 1H3Zm13 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM6.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      }
    )
  }
), qne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2V9a3 3 0 0 1 3-3h7a2 2 0 0 0-2-2H4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6 10a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-4Zm6 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Gne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5Zm6-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V7Zm6-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z"
      }
    )
  }
), Kne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 10a8 8 0 0 1 8-8v8h8a8 8 0 1 1-16 0Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 2.252A8.014 8.014 0 0 1 17.748 8H12V2.252Z"
        }
      )
    ]
  }
), Qne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm9 4a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V7Zm-3 2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V9Zm-3 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0v-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Xne = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 16 16",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        id: "icon",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.40039 3.9999C2.40039 3.11625 3.11674 2.3999 4.00039 2.3999H12.0004C12.884 2.3999 13.6004 3.11625 13.6004 3.9999V11.9999C13.6004 12.8836 12.884 13.5999 12.0004 13.5999H4.00039C3.11674 13.5999 2.40039 12.8836 2.40039 11.9999V3.9999ZM11.7661 5.76559C12.0785 6.07801 12.0785 6.58454 11.7661 6.89696L8.56608 10.097C8.25366 10.4094 7.74712 10.4094 7.43471 10.097L6.40039 9.06264L5.36608 10.097C5.05366 10.4094 4.54712 10.4094 4.23471 10.097C3.92229 9.78454 3.92229 9.27801 4.23471 8.96559L5.83471 7.36559C6.14712 7.05317 6.65366 7.05317 6.96608 7.36559L8.00039 8.3999L10.6347 5.76559C10.9471 5.45317 11.4537 5.45317 11.7661 5.76559Z",
        fill: "currentColor"
      }
    )
  }
), Jne = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 0 1-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7ZM7 9H5v2h2V9Zm8 0h-2v2h2V9ZM9 9h2v2H9V9Z",
        clipRule: "evenodd"
      }
    )
  }
), ere = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 5v8a2 2 0 0 1-2 2h-5l-5 4v-4H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2ZM7 8H5v2h2V8Zm2 0h2v2H9V8Zm6 0h-2v2h2V8Z",
        clipRule: "evenodd"
      }
    )
  }
), tre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9l-3 3v-3H4a2 2 0 0 1-2-2V5Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 7v2a4 4 0 0 1-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1Z"
        }
      )
    ]
  }
), kT = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.707 5.293a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8 12.586l7.293-7.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Vx = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.707-9.293a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Nx = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), BU = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.707 5.293a1 1 0 0 1 0 1.414L9.414 10l3.293 3.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), hy = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.293 14.707a1 1 0 0 1 0-1.414L10.586 10 7.293 6.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), FU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 12.707a1 1 0 0 1-1.414 0L10 9.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), nre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 4.293a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L10 8.586l4.293-4.293a1 1 0 0 1 1.414 0Zm0 6a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L10 14.586l4.293-4.293a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), rre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.707 15.707a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1 0 1.414Zm-6 0a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 1.414L5.414 10l4.293 4.293a1 1 0 0 1 0 1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), are = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.293 15.707a1 1 0 0 1 0-1.414L14.586 10l-4.293-4.293a1 1 0 1 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.293 15.707a1 1 0 0 1 0-1.414L8.586 10 4.293 5.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ore = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 15.707a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 0 1-1.414 0Zm0-6a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L10 5.414 5.707 9.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), ire = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M13 7H7v6h6V7Z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 2a1 1 0 0 1 2 0v1h2V2a1 1 0 1 1 2 0v1h2a2 2 0 0 1 2 2v2h1a1 1 0 1 1 0 2h-1v2h1a1 1 0 1 1 0 2h-1v2a2 2 0 0 1-2 2h-2v1a1 1 0 1 1-2 0v-1H9v1a1 1 0 1 1-2 0v-1H5a2 2 0 0 1-2-2v-2H2a1 1 0 1 1 0-2h1V9H2a1 1 0 0 1 0-2h1V5a2 2 0 0 1 2-2h2V2ZM5 5h10v10H5V5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), lre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "#fff",
          stroke: "#DCDBDD",
          strokeWidth: 0.6,
          d: "M5.32 1.3h9.36c2.22 0 4.02 1.8 4.02 4.02v9.36c0 2.22-1.8 4.02-4.02 4.02H5.32a4.02 4.02 0 0 1-4.02-4.02V5.32C1.3 3.1 3.1 1.3 5.32 1.3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#paint0_linear_590_7245)",
          fillRule: "evenodd",
          d: "m4.727 13.343 1.946-1.491c1.034 1.35 2.132 1.971 3.355 1.971 1.217 0 2.284-.614 3.272-1.953l1.973 1.455c-1.424 1.93-3.195 2.95-5.245 2.95-2.043 0-3.831-1.012-5.301-2.932Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "url(#paint1_linear_590_7245)",
          fillRule: "evenodd",
          d: "M10.021 6.862 6.557 9.847 4.956 7.99l5.072-4.37 5.033 4.373-1.608 1.851-3.431-2.982Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsxs("defs", { children: [
        /* @__PURE__ */ f.jsxs(
          "linearGradient",
          {
            id: "paint0_linear_590_7245",
            x1: 4.727,
            x2: 15.273,
            y1: 14.86,
            y2: 14.86,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ f.jsx("stop", { stopColor: "#8930FD" }),
              /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#49CCF9" })
            ]
          }
        ),
        /* @__PURE__ */ f.jsxs(
          "linearGradient",
          {
            id: "paint1_linear_590_7245",
            x1: 4.956,
            x2: 15.061,
            y1: 7.855,
            y2: 7.855,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ f.jsx("stop", { stopColor: "#FF02F0" }),
              /* @__PURE__ */ f.jsx("stop", { offset: 1, stopColor: "#FFC800" })
            ]
          }
        )
      ] })
    ]
  }
), ure = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6 3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 3 3 0 0 1-3 3H9a3 3 0 0 1-3-3Z"
        }
      )
    ]
  }
), sre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H9Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm9.707 5.707a1 1 0 0 0-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), cre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H8Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v6h-4.586l1.293-1.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L10.414 13H15v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm12 6h2a1 1 0 1 1 0 2h-2v-2Z"
        }
      )
    ]
  }
), fre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H9Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm3 4a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2H7Zm3 0a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2h-3Zm-3 4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H7Zm3 0a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), UU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-12a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2.828 2.829a1 1 0 1 0 1.415-1.415L11 9.586V6Z",
        clipRule: "evenodd"
      }
    )
  }
), dre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M14.0657 8.0657C14.3781 7.75328 14.3781 7.24675 14.0657 6.93433C13.7533 6.62191 13.2467 6.62191 12.9343 6.93433L10.4343 9.43433C10.1219 9.74675 10.1219 10.2533 10.4343 10.5657L12.9343 13.0657C13.2467 13.3781 13.7533 13.3781 14.0657 13.0657C14.3781 12.7533 14.3781 12.2467 14.0657 11.9343L12.1314 10L14.0657 8.0657Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M5.20001 6.20001C5.20001 5.64773 5.64773 5.20001 6.20001 5.20001H8.80001C8.91047 5.20001 9.00001 5.28956 9.00001 5.40001V14.6C9.00001 14.7105 8.91047 14.8 8.80001 14.8H6.20001C5.64773 14.8 5.20001 14.3523 5.20001 13.8V6.20001Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 6C2 3.79086 3.79086 2 6 2H14C16.2091 2 18 3.79086 18 6V14C18 16.2091 16.2091 18 14 18H6C3.79086 18 2 16.2091 2 14V6ZM6 4H14C15.1046 4 16 4.89543 16 6V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4Z",
          fill: "#322444"
        }
      )
    ]
  }
), hre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5.5 16a3.5 3.5 0 0 1-.369-6.98 4 4 0 1 1 7.753-1.977A4.5 4.5 0 1 1 13.5 16h-8Z"
      }
    )
  }
), vre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 9.5A3.5 3.5 0 0 0 5.5 13H9v2.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 1 0-.616-8.958 4.002 4.002 0 1 0-7.753 1.977A3.5 3.5 0 0 0 2 9.5Zm9 3.5H9V8a1 1 0 0 1 2 0v5Z",
        clipRule: "evenodd"
      }
    )
  }
), pre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5.5 13a3.5 3.5 0 0 1-.369-6.98 4 4 0 1 1 7.753-1.977A4.5 4.5 0 1 1 13.5 13H11V9.413l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L9 9.414V13H5.5Z"
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M9 13h2v5a1 1 0 1 1-2 0v-5Z" })
    ]
  }
), mre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.316 3.051a1 1 0 0 1 .633 1.265l-4 12a1 1 0 1 1-1.898-.632l4-12a1 1 0 0 1 1.265-.633ZM5.707 6.293a1 1 0 0 1 0 1.414L3.414 10l2.293 2.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Zm8.586 0a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), gre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 0 1-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 0 1 .947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 0 1 2.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 0 1 2.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 0 1 .947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 0 1-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 0 1-2.287-.947ZM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
        clipRule: "evenodd"
      }
    )
  }
), wre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7ZM4 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm-2 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4Z"
      }
    )
  }
), yre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 2a2 2 0 0 0-2 2v11a3 3 0 1 0 6 0V4a2 2 0 0 0-2-2H4Zm1 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m10 14.243 4.9-4.9a2 2 0 0 0 0-2.828L13.485 5.1a2 2 0 0 0-2.828 0L10 5.757v8.486ZM16 18H9.071l6-6H16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2Z"
        }
      )
    ]
  }
), xre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 4a2 2 0 0 0-2 2v1h16V6a2 2 0 0 0-2-2H4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 9H2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9ZM4 13a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm5-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H9Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Sre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 17a1 1 0 0 0 1.447.894l4-2A1 1 0 0 0 17 15V9.236a1 1 0 0 0-1.447-.894l-4 2a1 1 0 0 0-.553.894V17Zm4.211-10.724a1 1 0 0 0 0-1.788l-4.764-2.382a1 1 0 0 0-.894 0L4.789 4.488a1 1 0 0 0 0 1.788l4.764 2.382a1 1 0 0 0 .894 0l4.764-2.382ZM4.447 8.342A1 1 0 0 0 3 9.236V15a1 1 0 0 0 .553.894l4 2A1 1 0 0 0 9 17v-5.764a1 1 0 0 0-.553-.894l-4-2Z"
      }
    )
  }
), Cre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.504 1.132a1 1 0 0 1 .992 0l1.75 1a1 1 0 1 1-.992 1.736L10 3.152l-1.254.716a1 1 0 1 1-.992-1.736l1.75-1ZM5.618 4.504a1 1 0 0 1-.372 1.364L5.016 6l.23.132a1 1 0 1 1-.992 1.736L4 7.723V8a1 1 0 0 1-2 0V6a.996.996 0 0 1 .52-.878l1.734-.99a1 1 0 0 1 1.364.372Zm8.764 0a1 1 0 0 1 1.364-.372l1.733.99A1.002 1.002 0 0 1 18 6v2a1 1 0 1 1-2 0v-.277l-.254.145a1 1 0 1 1-.992-1.736l.23-.132-.23-.132a1 1 0 0 1-.372-1.364Zm-7 4a1 1 0 0 1 1.364-.372L10 8.848l1.254-.716a1 1 0 1 1 .992 1.736L11 10.58V12a1 1 0 1 1-2 0v-1.42l-1.246-.712a1 1 0 0 1-.372-1.364ZM3 11a1 1 0 0 1 1 1v1.42l1.246.712a1 1 0 1 1-.992 1.736l-1.75-1A1 1 0 0 1 2 14v-2a1 1 0 0 1 1-1Zm14 0a1 1 0 0 1 1 1v2a1 1 0 0 1-.504.868l-1.75 1a1 1 0 1 1-.992-1.736L16 13.42V12a1 1 0 0 1 1-1Zm-9.618 5.504a1 1 0 0 1 1.364-.372l.254.145V16a1 1 0 1 1 2 0v.277l.254-.145a1 1 0 1 1 .992 1.736l-1.735.992a.995.995 0 0 1-1.022 0l-1.735-.992a1 1 0 0 1-.372-1.364Z"
      }
    )
  }
), bre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 4a1 1 0 0 0 0 2 1 1 0 0 1 1 1v1H7a1 1 0 0 0 0 2h1v3a3 3 0 1 0 6 0v-1a1 1 0 1 0-2 0v1a1 1 0 1 1-2 0v-3h3a1 1 0 1 0 0-2h-3V7a3 3 0 0 0-3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), _re = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 0 1-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582ZM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 0 1-.567.267Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-13a1 1 0 1 0-2 0v.092a4.535 4.535 0 0 0-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 1 0-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 1 0 2 0v-.092a4.535 4.535 0 0 0 1.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0 0 11 9.092V7.151c.391.127.68.317.843.504a1 1 0 1 0 1.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Rre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.736 6.979C9.208 6.193 9.696 6 10 6c.304 0 .792.193 1.264.979a1 1 0 0 0 1.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 0 0 0 2h.013a9.358 9.358 0 0 0 0 1H6a1 1 0 1 0 0 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 1 0-1.715-1.029c-.472.786-.96.979-1.264.979-.304 0-.792-.193-1.264-.979a4.265 4.265 0 0 1-.264-.521H10a1 1 0 1 0 0-2H8.017a7.36 7.36 0 0 1 0-1H10a1 1 0 1 0 0-2H8.472c.08-.185.167-.36.264-.521Z",
        clipRule: "evenodd"
      }
    )
  }
), Ere = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-14a3 3 0 0 0-3 3v2H7a1 1 0 0 0 0 2h1v1a1 1 0 0 1-1 1 1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9.83c.11-.313.17-.65.17-1v-1h1a1 1 0 1 0 0-2h-1V7a1 1 0 1 1 2 0 1 1 0 1 0 2 0 3 3 0 0 0-3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), Mre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 5a1 1 0 1 0 0 2h1a2 2 0 0 1 1.732 1H7a1 1 0 1 0 0 2h2.732A2 2 0 0 1 8 11H7a1 1 0 0 0-.707 1.707l3 3a1 1 0 0 0 1.414-1.414l-1.483-1.484A4.008 4.008 0 0 0 11.874 10H13a1 1 0 1 0 0-2h-1.126a3.976 3.976 0 0 0-.41-1H13a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Tre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7.858 5.485a1 1 0 0 0-1.715 1.03L7.633 9H7a1 1 0 1 0 0 2h1.834l.166.277V12H7a1 1 0 1 0 0 2h2v1a1 1 0 1 0 2 0v-1h2a1 1 0 1 0 0-2h-2v-.723l.166-.277H13a1 1 0 1 0 0-2h-.634l1.492-2.486a1 1 0 1 0-1.716-1.029L10.034 9h-.068L7.858 5.485Z",
        clipRule: "evenodd"
      }
    )
  }
), Ore = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.672 1.912a1 1 0 0 0-1.932.517l.259.966a1 1 0 0 0 1.932-.518l-.26-.965ZM2.43 4.74a1 1 0 0 0-.519 1.932l.966.259a1 1 0 0 0 .518-1.932l-.966-.26Zm8.813-.568a1 1 0 0 0-1.415-1.415l-.707.707a1 1 0 1 0 1.415 1.415l.707-.707Zm-7.072 7.071.708-.707A1 1 0 0 0 3.464 9.12l-.707.707a1 1 0 0 0 1.414 1.415Zm3.2-5.171a1 1 0 0 0-1.3 1.3l4 10a1 1 0 0 0 1.824.075l1.379-2.759 3.019 3.02a1 1 0 1 0 1.414-1.415l-3.019-3.019 2.76-1.38a1 1 0 0 0-.077-1.822l-10-4Z"
      }
    )
  }
), Dre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3Z"
        }
      )
    ]
  }
), jre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.22l.123.489.804.804A1 1 0 0 1 13 18H7a1 1 0 0 1-.707-1.707l.804-.804L7.22 15H5a2 2 0 0 1-2-2V5Zm5.771 7H5V5h10v7H8.771Z",
        clipRule: "evenodd"
      }
    )
  }
), Are = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7Zm3 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), kre = ({
  size: e = "1em",
  fill: t = "#5865F2",
  ...a
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 71 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a,
    children: [
      /* @__PURE__ */ f.jsx("g", { clipPath: "url(#clip0)", children: /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z",
          fill: t
        }
      ) }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ f.jsx("rect", { width: "71", height: "55", fill: "white" }) }) })
    ]
  }
), Lre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Z",
        clipRule: "evenodd"
      }
    )
  }
), Ire = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm5 6a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V8Z",
        clipRule: "evenodd"
      }
    )
  }
), Hre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm5 6a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 11.586V8Z",
        clipRule: "evenodd"
      }
    )
  }
), Zre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6.414A2 2 0 0 0 16.414 5L14 2.586A2 2 0 0 0 12.586 2H9Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 8a2 2 0 0 1 2-2v7a3 3 0 0 0 3 3h5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8Z"
        }
      )
    ]
  }
), Pre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm1 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Vre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2H6Zm2 10a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Zm2-3a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm4-1a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0V8Z",
        clipRule: "evenodd"
      }
    )
  }
), Nre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2h-1.528A6 6 0 0 0 4 9.528V4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 10a4 4 0 0 0-3.446 6.032l-1.261 1.26a1 1 0 1 0 1.414 1.415l1.261-1.261A4 4 0 1 0 8 10Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Bre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), Fre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9H5v2h2V9Zm8 0h-2v2h2V9ZM9 9h2v2H9V9Z",
        clipRule: "evenodd"
      }
    )
  }
), Ure = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      }
    )
  }
), Yre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
      }
    )
  }
), $re = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm3.293-7.707a1 1 0 0 1 1.414 0L9 10.586V3a1 1 0 1 1 2 0v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Wre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M4 4.5C2.89543 4.5 2 5.39543 2 6.5C2 7.60457 2.89543 8.5 4 8.5C5.10457 8.5 6 7.60457 6 6.5C6 5.39543 5.10457 4.5 4 4.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M4 11.5C2.89543 11.5 2 12.3954 2 13.5C2 14.6046 2.89543 15.5 4 15.5C5.10457 15.5 6 14.6046 6 13.5C6 12.3954 5.10457 11.5 4 11.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M8 6.5C8 5.39543 8.89543 4.5 10 4.5C11.1046 4.5 12 5.39543 12 6.5C12 7.60457 11.1046 8.5 10 8.5C8.89543 8.5 8 7.60457 8 6.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M10 11.5C8.89543 11.5 8 12.3954 8 13.5C8 14.6046 8.89543 15.5 10 15.5C11.1046 15.5 12 14.6046 12 13.5C12 12.3954 11.1046 11.5 10 11.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M14 6.5C14 5.39543 14.8954 4.5 16 4.5C17.1046 4.5 18 5.39543 18 6.5C18 7.60457 17.1046 8.5 16 8.5C14.8954 8.5 14 7.60457 14 6.5Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M16 11.5C14.8954 11.5 14 12.3954 14 13.5C14 14.6046 14.8954 15.5 16 15.5C17.1046 15.5 18 14.6046 18 13.5C18 12.3954 17.1046 11.5 16 11.5Z",
          fill: "#322444"
        }
      )
    ]
  }
), zre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7 9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2V8a3 3 0 0 1 3-3h5a2 2 0 0 0-2-2H5Z"
        }
      )
    ]
  }
), qre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.464 5.535a1 1 0 1 0-1.415-1.414 3 3 0 0 1-4.242 0 1 1 0 0 0-1.415 1.414 5 5 0 0 0 7.072 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Gre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-7.536 5.879a1 1 0 0 0 1.415 0 3 3 0 0 1 4.242 0 1 1 0 0 0 1.415-1.415 5 5 0 0 0-7.072 0 1 1 0 0 0 0 1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), YU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.743 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92ZM11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-8a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Kre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-9a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Qre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3a1 1 0 0 0-1 1v12a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1Zm10.293 9.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L14.586 9H7a1 1 0 1 0 0 2h7.586l-1.293 1.293Z"
      }
    )
  }
), Xre = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 3a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 1 0 1.414 1.414L15 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1h-5Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v3H5V7h3a1 1 0 0 0 0-2H5Z"
        }
      )
    ]
  }
), Jre = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), eae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l14 14a1 1 0 0 0 1.414-1.414l-1.473-1.473A10.014 10.014 0 0 0 19.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 0 0-4.512 1.074l-1.78-1.781Zm4.261 4.26 1.514 1.515a2.003 2.003 0 0 1 2.45 2.45l1.514 1.514a4 4 0 0 0-5.478-5.478Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.454 16.697 9.75 13.992a4 4 0 0 1-3.742-3.741L2.335 6.578A9.98 9.98 0 0 0 .458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303Z"
        }
      )
    ]
  }
), tae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.555 5.168A1 1 0 0 0 3 6v8a1 1 0 0 0 1.555.832L10 11.202V14a1 1 0 0 0 1.555.832l6-4a1 1 0 0 0 0-1.664l-6-4A1 1 0 0 0 10 6v2.798l-5.445-3.63Z"
      }
    )
  }
), nae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm3 2h6v4H7V5Zm8 8v2h1v-2h-1Zm-2-2H7v4h6v-4Zm2 0h1V9h-1v2Zm1-4V5h-1v2h1ZM5 5v2H4V5h1Zm0 4H4v2h1V9Zm-1 4h1v2H4v-2Z",
        clipRule: "evenodd"
      }
    )
  }
), rae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-.293.707L12 11.414V15a1 1 0 0 1-.293.707l-2 2A1 1 0 0 1 8 17v-5.586L3.293 6.707A1 1 0 0 1 3 6V3Z",
        clipRule: "evenodd"
      }
    )
  }
), aae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.625 2.655A9 9 0 0 1 19 11a1 1 0 1 1-2 0 7 7 0 0 0-9.625-6.492 1 1 0 1 1-.75-1.853ZM4.662 4.959A1 1 0 0 1 4.75 6.37 6.97 6.97 0 0 0 3 11a1 1 0 1 1-2 0 8.97 8.97 0 0 1 2.25-5.953 1 1 0 0 1 1.412-.088Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 11a5 5 0 0 1 10 0 1 1 0 1 1-2 0 3 3 0 1 0-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 1 1-1.838-.789A9.964 9.964 0 0 0 5 11Zm8.921 2.012a1 1 0 0 1 .831 1.145 19.86 19.86 0 0 1-.545 2.436 1 1 0 1 1-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 0 1 1.144-.83Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 10a1 1 0 0 1 1 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 0 1-1.838-.789A13.952 13.952 0 0 0 9 11a1 1 0 0 1 1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), oae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.757 2.034a1 1 0 0 1 .638.519c.483.967.844 1.554 1.207 2.03.368.482.756.876 1.348 1.467A6.981 6.981 0 0 1 17 11 7 7 0 1 1 5.05 6.05a1 1 0 0 1 1.707.707c0 1.12.07 1.973.398 2.654.18.374.46.74.945 1.067.116-1.061.328-2.354.614-3.58.225-.966.505-1.93.839-2.734.167-.403.356-.785.57-1.116.208-.322.477-.65.822-.88a1 1 0 0 1 .812-.134Zm.364 13.087A3 3 0 0 1 7 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0 1 13 13a2.99 2.99 0 0 1-.879 2.121Z",
        clipRule: "evenodd"
      }
    )
  }
), iae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 6a3 3 0 0 1 3-3h10a1 1 0 0 1 .8 1.6L14.25 8l2.55 3.4A1 1 0 0 1 16 13H6a1 1 0 0 0-1 1v3a1 1 0 1 1-2 0V6Z",
        clipRule: "evenodd"
      }
    )
  }
), lae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 6a2 2 0 0 1 2-2h5l2 2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Z"
      }
    )
  }
), uae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm7 5a1 1 0 1 0-2 0v1H8a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V9Z",
        clipRule: "evenodd"
      }
    )
  }
), sae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm7 5a1 1 0 1 0-2 0v1.586l-.293-.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l2-2a1 1 0 0 0-1.414-1.414l-.293.293V9Z",
        clipRule: "evenodd"
      }
    )
  }
), cae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h4l2 2h4a2 2 0 0 1 2 2v1H8a3 3 0 0 0-3 3v1.5a1.5 1.5 0 0 1-3 0V6Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6 12a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2h2a2 2 0 0 0 2-2v-2Z"
        }
      )
    ]
  }
), fae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5L9 4H4Zm4 6a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H8Z",
        clipRule: "evenodd"
      }
    )
  }
), dae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 5a3 3 0 0 1 5-2.236A3 3 0 0 1 14.83 6H16a2 2 0 1 1 0 4h-5V9a1 1 0 1 0-2 0v1H4a2 2 0 1 1 0-4h1.17C5.06 5.687 5 5.35 5 5Zm4 1V5a1 1 0 1 0-1 1h1Zm3 0a1 1 0 1 0-1-1v1h1Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9 11H3v5a2 2 0 0 0 2 2h4v-7Zm2 7h4a2 2 0 0 0 2-2v-5h-6v7Z"
        }
      )
    ]
  }
), hae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 1.95c-4.42 0-8 3.58-8 8 0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 18 9.95c0-4.42-3.58-8-8-8Z",
        clipRule: "evenodd"
      }
    )
  }
), vae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: e,
    height: e,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    className: "feather feather-gitlab",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
      }
    )
  }
), pae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM4.332 8.027a6.012 6.012 0 0 1 1.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 0 1 9 7.5V8a2 2 0 0 0 4 0 2 2 0 0 1 1.523-1.943A5.977 5.977 0 0 1 16 10c0 .34-.028.675-.083 1H15a2 2 0 0 0-2 2v2.197A5.973 5.973 0 0 1 10 16v-2a2 2 0 0 0-2-2 2 2 0 0 1-2-2 2 2 0 0 0-1.668-1.973Z",
        clipRule: "evenodd"
      }
    )
  }
), mae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 0 0 4.083 9ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4Zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0 1 15.917 9h-1.946Zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556Zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 0 1-2.783 4.118Zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 0 0 2.783 4.118Z",
        clipRule: "evenodd"
      }
    )
  }
), gae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_1603_12998)", children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#4285F4",
            d: "M18.215 10.368a7.05 7.05 0 0 0-.172-1.669h-7.665v3.03h4.5c-.092.753-.581 1.886-1.67 2.648l-.015.101 2.423 1.878.168.017c1.542-1.424 2.431-3.52 2.431-6.005Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#34A853",
            d: "M10.378 18.35c2.204 0 4.055-.726 5.406-1.977l-2.576-1.996c-.69.48-1.614.816-2.83.816-2.158 0-3.99-1.424-4.644-3.392l-.096.008-2.52 1.95-.032.092a8.157 8.157 0 0 0 7.292 4.499Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#FBBC05",
            d: "M5.734 11.801a5.025 5.025 0 0 1-.272-1.614c0-.563.1-1.107.263-1.615l-.004-.108-2.552-1.981-.083.04a8.17 8.17 0 0 0-.871 3.664 8.17 8.17 0 0 0 .87 3.664l2.65-2.05Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#EB4335",
            d: "M10.378 5.18c1.533 0 2.567.662 3.157 1.215l2.303-2.25c-1.414-1.314-3.256-2.122-5.46-2.122a8.157 8.157 0 0 0-7.292 4.5l2.64 2.05c.661-1.97 2.494-3.393 4.652-3.393Z"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_1603_12998", children: /* @__PURE__ */ f.jsx("path", { fill: "#fff", d: "M2.215 2h16v16.373h-16z" }) }) })
    ]
  }
), wae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        d: "M17.1997 9.0611C17.1733 8.79223 17.1292 8.48369 17.041 8.13988C16.9529 7.80049 16.8207 7.42583 16.6267 7.03796C16.4328 6.65008 16.1815 6.24897 15.8554 5.85669C15.7275 5.70242 15.5865 5.55256 15.4366 5.4071C15.6614 4.51234 15.1634 3.73658 15.1634 3.73658C14.3039 3.68369 13.7573 4.00545 13.5545 4.1509C13.5193 4.13768 13.4884 4.12005 13.4532 4.10683C13.3077 4.04953 13.1579 3.99223 12.9992 3.94374C12.8449 3.89526 12.6862 3.85118 12.5231 3.81151C12.3601 3.77184 12.197 3.74099 12.0295 3.71454C11.9986 3.71013 11.9722 3.70572 11.9413 3.70132C11.5667 2.50242 10.4912 1.99994 10.4912 1.99994C9.28788 2.76247 9.06308 3.82914 9.06308 3.82914C9.06308 3.82914 9.05868 3.85118 9.04986 3.89085C8.98375 3.90848 8.91763 3.93052 8.85151 3.94815C8.75895 3.97459 8.66639 4.00986 8.57824 4.04512C8.48567 4.08038 8.39752 4.11564 8.30496 4.15531C8.12424 4.23465 7.94353 4.3228 7.76722 4.41977C7.59532 4.51674 7.42782 4.62253 7.26474 4.73272L7.22066 4.71509C5.55455 4.08038 4.07796 4.84291 4.07796 4.84291C3.94132 6.61481 4.74353 7.72997 4.9022 7.93272C4.86253 8.04291 4.82727 8.15311 4.79201 8.2633C4.66859 8.6644 4.57603 9.07432 4.51873 9.50187C4.50992 9.56358 4.5011 9.62528 4.49669 9.68699C2.95399 10.4495 2.5 12.0054 2.5 12.0054C3.78264 13.482 5.28127 13.5746 5.28127 13.5746L5.28567 13.5702C5.47521 13.9096 5.69559 14.2313 5.94242 14.5355C6.04821 14.6633 6.15399 14.7823 6.26859 14.9013C5.80138 16.2413 6.33471 17.352 6.33471 17.352C7.76281 17.4049 8.70165 16.7261 8.9 16.5718C9.04105 16.6203 9.1865 16.6644 9.33196 16.6997C9.77273 16.8143 10.2223 16.8804 10.6719 16.898C10.7821 16.9024 10.8967 16.9068 11.0069 16.9024H11.1656L11.2361 16.898V16.9024C11.9105 17.8633 13.0917 17.9999 13.0917 17.9999C13.9336 17.114 13.9821 16.2324 13.9821 16.0429V15.9636C14.1584 15.8402 14.3259 15.7079 14.4846 15.5625C14.8196 15.2583 15.1149 14.9101 15.3617 14.5355L15.4278 14.4297C16.3799 14.4826 17.0543 13.8391 17.0543 13.8391C16.8956 12.8473 16.3314 12.3625 16.2124 12.2699C16.0934 12.1774 16.208 12.2655 16.1992 12.2611C16.1904 12.2567 16.1904 12.2523 16.1904 12.2523C16.1859 12.2479 16.1771 12.2435 16.1683 12.2391C16.1727 12.1773 16.1771 12.12 16.1815 12.0583C16.1904 11.9526 16.1904 11.8424 16.1904 11.7366V11.5691L16.1859 11.503L16.1815 11.4148C16.1815 11.384 16.1771 11.3575 16.1727 11.3311C16.1683 11.3046 16.1683 11.2738 16.1639 11.2473L16.1551 11.1636L16.1419 11.0798C16.1242 10.9696 16.1066 10.8639 16.0802 10.7537C15.9788 10.3261 15.8113 9.9206 15.5953 9.55476C15.3749 9.18892 15.1017 8.86716 14.7887 8.59388C14.4802 8.3206 14.132 8.10021 13.7705 7.93713C13.4047 7.77404 13.0256 7.66826 12.6466 7.61977C12.457 7.59333 12.2675 7.58451 12.078 7.58892H11.9369L11.8664 7.59333C11.8399 7.59333 11.8135 7.59774 11.7915 7.59774C11.6945 7.60655 11.5975 7.61977 11.505 7.6374C11.1259 7.70793 10.7689 7.84457 10.4559 8.0341C10.143 8.22363 9.8697 8.45724 9.64931 8.7217C9.42893 8.98617 9.25702 9.28148 9.13802 9.58561C9.01901 9.88975 8.95289 10.2071 8.93526 10.5112C8.93085 10.5862 8.93085 10.6655 8.93085 10.7404V10.7977L8.93526 10.8594C8.93967 10.8947 8.93967 10.9344 8.94408 10.9696C8.9573 11.1239 8.98815 11.2738 9.02782 11.4148C9.11157 11.7013 9.2438 11.9614 9.40689 12.1818C9.56997 12.4021 9.76832 12.5829 9.97548 12.7283C10.1826 12.8694 10.4074 12.9707 10.6278 13.0369C10.8482 13.103 11.0686 13.1294 11.2758 13.1294H11.3904C11.4036 13.1294 11.4168 13.1294 11.43 13.125C11.4521 13.125 11.4741 13.1206 11.4961 13.1206C11.5006 13.1206 11.5094 13.1206 11.5138 13.1162L11.5358 13.1118C11.549 13.1118 11.5623 13.1074 11.5755 13.1074C11.6019 13.103 11.624 13.0986 11.6504 13.0942C11.6769 13.0897 11.6989 13.0853 11.7209 13.0765C11.7694 13.0677 11.8135 13.0501 11.8576 13.0369C11.9457 13.006 12.0339 12.9707 12.1088 12.9311C12.1882 12.8914 12.2587 12.8429 12.3292 12.7988C12.3468 12.7856 12.3689 12.7724 12.3865 12.7548C12.457 12.6975 12.4702 12.5917 12.4129 12.5212C12.3645 12.4594 12.2763 12.4418 12.2058 12.4815L12.1529 12.5079C12.0912 12.5388 12.0295 12.5652 11.9634 12.5873C11.8972 12.6093 11.8267 12.6269 11.7562 12.6402C11.7209 12.6446 11.6857 12.649 11.646 12.6534C11.6284 12.6534 11.6107 12.6578 11.5887 12.6578H11.4829C11.4609 12.6578 11.4388 12.6578 11.4168 12.6534H11.3904C11.3815 12.6534 11.3683 12.6534 11.3595 12.649C11.3375 12.6446 11.3198 12.6446 11.2978 12.6402C11.1347 12.6181 10.9716 12.5696 10.8174 12.4991C10.6587 12.4286 10.5088 12.3316 10.3722 12.2082C10.2355 12.0848 10.1165 11.9393 10.024 11.7718C9.9314 11.6043 9.86529 11.4192 9.83443 11.2253C9.82121 11.1283 9.8124 11.0269 9.8168 10.93C9.8168 10.9035 9.82121 10.8771 9.82121 10.8506V10.8154C9.82121 10.8021 9.82562 10.7889 9.82562 10.7757C9.83003 10.7228 9.83884 10.6699 9.84766 10.617C9.92259 10.1939 10.1342 9.77955 10.4603 9.46661C10.5441 9.38727 10.6322 9.31674 10.7248 9.25063C10.8174 9.18451 10.9187 9.12721 11.0245 9.07873C11.1303 9.03024 11.2361 8.99057 11.3507 8.95972C11.4609 8.92886 11.5755 8.91123 11.6945 8.89801C11.7518 8.8936 11.8091 8.8892 11.8708 8.8892H12.0074L12.0559 8.8936C12.1837 8.90242 12.3072 8.92005 12.4306 8.9509C12.6774 9.0038 12.9198 9.09636 13.1446 9.21977C13.5942 9.47101 13.9777 9.85889 14.2113 10.3261C14.3303 10.5597 14.4141 10.811 14.4537 11.071C14.4625 11.1371 14.4713 11.2032 14.4758 11.2694L14.4846 11.3663V11.5559C14.4846 11.5867 14.4802 11.6396 14.4802 11.6705C14.4758 11.741 14.4669 11.8159 14.4581 11.8864C14.4493 11.957 14.4361 12.0275 14.4229 12.098C14.4096 12.1685 14.392 12.2391 14.3744 12.3052C14.3391 12.4418 14.295 12.5785 14.2421 12.7151C14.1364 12.9796 13.9953 13.2352 13.8278 13.4688C13.4884 13.936 13.0256 14.3151 12.4967 14.5575C12.2322 14.6765 11.9545 14.7647 11.668 14.8088C11.527 14.8352 11.3815 14.8484 11.2361 14.8528H11.0157C10.9364 14.8528 10.8614 14.8484 10.7821 14.8396C10.4736 14.8176 10.1694 14.7603 9.8697 14.6765C9.57438 14.5928 9.28788 14.4738 9.0146 14.3327C8.47245 14.0418 7.9832 13.6451 7.60413 13.1647C7.4146 12.9267 7.24711 12.6666 7.11047 12.3977C6.97383 12.1289 6.86364 11.8424 6.7843 11.5559C6.70496 11.265 6.65647 10.9696 6.63444 10.6699L6.63003 10.6126V10.2203C6.63443 10.0749 6.64766 9.9206 6.66529 9.77074C6.68292 9.62088 6.70937 9.46661 6.74022 9.31674C6.77107 9.16688 6.80634 9.01702 6.85041 8.86716C6.93416 8.57184 7.03994 8.28534 7.16336 8.01647C7.4146 7.47873 7.74077 6.99829 8.13306 6.61481C8.23003 6.51785 8.3314 6.42969 8.43719 6.34154C8.54297 6.25779 8.65317 6.17845 8.76777 6.10352C8.87796 6.02859 8.99697 5.96247 9.11598 5.90077C9.17328 5.86991 9.23499 5.83906 9.29669 5.81261L9.48182 5.73327C9.60523 5.68038 9.73306 5.6363 9.86529 5.59663C9.89614 5.58782 9.9314 5.579 9.96226 5.56578C9.99311 5.55696 10.0284 5.54815 10.0592 5.53933C10.1253 5.5217 10.1915 5.50407 10.2576 5.49085C10.2884 5.48203 10.3237 5.47762 10.359 5.46881C10.3942 5.45999 10.4251 5.45559 10.4603 5.44677C10.4956 5.44236 10.5264 5.43355 10.5617 5.42914L10.6102 5.42032L10.6631 5.41151C10.6983 5.4071 10.7292 5.40269 10.7645 5.39829C10.8041 5.39388 10.8394 5.38947 10.8791 5.38506C10.9099 5.38066 10.9628 5.37625 10.9937 5.37184C11.0157 5.36743 11.0421 5.36743 11.0642 5.36302L11.1127 5.35862L11.1347 5.35421H11.1612C11.2008 5.3498 11.2361 5.3498 11.2758 5.34539L11.3331 5.34099H11.3771C11.408 5.34099 11.4432 5.33658 11.4741 5.33658C11.6019 5.33217 11.7342 5.33217 11.862 5.33658C12.1176 5.34539 12.3689 5.37625 12.6113 5.42032C13.1005 5.51289 13.559 5.66716 13.9777 5.87432C14.3964 6.07707 14.7667 6.32831 15.0928 6.60159C15.1149 6.61922 15.1325 6.63685 15.1545 6.65448C15.1722 6.67212 15.1942 6.68975 15.2118 6.70738C15.2515 6.74264 15.2868 6.7779 15.3264 6.81316C15.3661 6.84842 15.4014 6.88369 15.4366 6.91895C15.4719 6.95421 15.5072 6.98947 15.5424 7.02914C15.6791 7.17459 15.8069 7.32005 15.9215 7.46991C16.1507 7.76523 16.3358 8.06495 16.4813 8.34705L16.5342 8.45283C16.5518 8.48809 16.5694 8.52336 16.5826 8.55862C16.6003 8.59388 16.6135 8.62473 16.6311 8.65999C16.6444 8.69526 16.662 8.72611 16.6752 8.76137C16.7281 8.8936 16.781 9.02143 16.8207 9.14043C16.8868 9.33437 16.9353 9.50628 16.9749 9.65614C16.9882 9.71785 17.0455 9.75751 17.1072 9.7487C17.1733 9.74429 17.2218 9.6914 17.2218 9.62528C17.2262 9.46661 17.2218 9.27707 17.1997 9.0611Z",
        fill: "#322444"
      }
    )
  }
), yae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 3a1 1 0 0 1 2 0v5.5a.5.5 0 0 0 1 0V4a1 1 0 1 1 2 0v4.5a.5.5 0 0 0 1 0V6a1 1 0 1 1 2 0v5a7 7 0 1 1-14 0V9a1 1 0 0 1 2 0v2.5a.5.5 0 0 0 1 0V4a1 1 0 0 1 2 0v4.5a.5.5 0 0 0 1 0V3Z"
      }
    )
  }
), xae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.243 3.03a1 1 0 0 1 .727 1.213L9.53 6h2.94l.56-2.243a1 1 0 1 1 1.94.486L14.53 6H17a1 1 0 1 1 0 2h-2.97l-1 4H15a1 1 0 1 1 0 2h-2.47l-.56 2.242a1 1 0 1 1-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 1 1-1.94-.485L5.47 14H3a1 1 0 1 1 0-2h2.97l1-4H5a1 1 0 0 1 0-2h2.47l.56-2.243a1 1 0 0 1 1.213-.727ZM9.03 8l-1 4h2.938l1-4H9.031Z",
        clipRule: "evenodd"
      }
    )
  }
), Sae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.172 5.172a4 4 0 0 1 5.656 0L10 6.343l1.172-1.171a4 4 0 1 1 5.656 5.656L10 17.657l-6.828-6.829a4 4 0 0 1 0-5.656Z",
        clipRule: "evenodd"
      }
    )
  }
), Cae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsxs("g", { clipPath: "url(#clip0_590_7243)", children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#7957FF",
            d: "m8.922 12.62.129-.107 6.473-.056.04.164a.409.409 0 0 1-.04.1c-.056.098-.177.168-.419.308l-6.25 3.616c-.622.36-.933.54-1.125.497a.505.505 0 0 1-.363-.315c-.07-.184.065-.518.335-1.185l1.22-3.021Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#18B6AA",
            d: "M15.564 12.62H8.922l-.039-.274 2.01-4.915.165-.092 4.208 4.675.02.022c.173.193.26.294.282.4a.413.413 0 0 1-.004.185Z"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            fill: "#F845C6",
            d: "m11.108 3.35-6.22 3.582c-.242.139-.364.209-.42.307a.413.413 0 0 0-.045.285c.023.11.116.215.303.423l4.196 4.674 2.136-5.282 1.203-2.985c.268-.665.402-.997.333-1.181a.505.505 0 0 0-.363-.315c-.192-.043-.502.135-1.123.493Z"
          }
        )
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_590_7243", children: /* @__PURE__ */ f.jsx("path", { fill: "#fff", d: "M0 0h20v20H0z" }) }) })
    ]
  }
), bae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 12 12",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsxs("g", { id: "Own color", children: [
      /* @__PURE__ */ f.jsx(
        "circle",
        {
          id: "Ellipse 132",
          cx: "5.99999",
          cy: "6",
          r: "5.6",
          fill: "#744ED4"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          id: "Subtract",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.54999 3.55C3.9977 3.55 3.54999 3.99772 3.54999 4.55V7.45C3.54999 8.00229 3.9977 8.45 4.54999 8.45H6.34999L4.59999 3.55H4.54999ZM5.64999 3.55L7.39999 8.45H7.44999C8.00227 8.45 8.44999 8.00229 8.44999 7.45V4.55C8.44999 3.99772 8.00227 3.55 7.44999 3.55H5.64999Z",
          fill: "white"
        }
      )
    ] })
  }
), _ae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.707 2.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L4 10.414V17a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6.586l.293.293a1 1 0 0 0 1.414-1.414l-7-7Z"
      }
    )
  }
), Rae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10 2a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 4h3a3 3 0 0 0 6 0h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm2.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm2.45 4a2.5 2.5 0 1 0-4.9 0h4.9ZM12 9a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Zm-1 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Eae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm12 0H5v10h10V5Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M4 12h3l1 2h4l1-2h3v4H4v-4Z" })
    ]
  }
), Mae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h1a1 1 0 0 1 0 2H5v10h10V5h-1a1 1 0 1 1 0-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 12h3l1 2h4l1-2h3v4H4v-4Zm3.293-4.707a1 1 0 0 1 1.414 0L9 7.586V3a1 1 0 1 1 2 0v4.586l.293-.293a1 1 0 1 1 1.414 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414Z"
        }
      )
    ]
  }
), $U = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a1 1 0 0 0 0 2v3a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2v-3a1 1 0 0 0-1-1H9Z",
        clipRule: "evenodd"
      }
    )
  }
), Tae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 4H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v1.5a1 1 0 1 1-2 0V5a1 1 0 0 0-1-1Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.269 7.269a.913.913 0 0 1 .988-.203l9.167 3.666a.917.917 0 0 1 .07 1.671L14 14l-1.597 3.493a.917.917 0 0 1-1.67-.07L7.065 8.258a.917.917 0 0 1 .203-.988Z"
        }
      )
    ]
  }
), Oae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M32 0H0V32H32V0Z", fill: "#0052CC" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M23.7199 7.64001H15.6399C15.6399 9.64001 17.2799 11.28 19.2799 11.28H20.7599V12.72C20.7599 14.72 22.3999 16.36 24.3999 16.36V8.32001C24.4399 7.96001 24.1199 7.64001 23.7199 7.64001Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M19.7199 11.64H11.6399C11.6399 13.64 13.2799 15.28 15.2799 15.28H16.7599V16.72C16.7599 18.72 18.3999 20.36 20.3999 20.36V12.36C20.4399 11.96 20.1199 11.64 19.7199 11.64Z",
          fill: "url(#paint0_linear)"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M15.7199 15.6801H7.63989C7.63989 17.6801 9.27988 19.3201 11.2799 19.3201H12.7599V20.7601C12.7599 22.7601 14.3999 24.4001 16.3999 24.4001V16.4001C16.4399 16.0001 16.1199 15.6801 15.7199 15.6801Z",
          fill: "url(#paint1_linear)"
        }
      ),
      /* @__PURE__ */ f.jsxs("defs", { children: [
        /* @__PURE__ */ f.jsxs(
          "linearGradient",
          {
            id: "paint0_linear",
            x1: "20.2597",
            y1: "11.6708",
            x2: "16.8183",
            y2: "15.2196",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ f.jsx("stop", { offset: "0.176", stopColor: "white", stopOpacity: "0.4" }),
              /* @__PURE__ */ f.jsx("stop", { offset: "1", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ f.jsxs(
          "linearGradient",
          {
            id: "paint1_linear",
            x1: "16.4844",
            y1: "15.7246",
            x2: "12.5054",
            y2: "19.596",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ f.jsx("stop", { offset: "0.176", stopColor: "white", stopOpacity: "0.4" }),
              /* @__PURE__ */ f.jsx("stop", { offset: "1", stopColor: "white" })
            ]
          }
        )
      ] })
    ]
  }
), Dae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 8a6 6 0 0 1-7.743 5.743L8 16H6v2H2v-4l4.257-4.257A6 6 0 1 1 18 8Zm-6-4a1 1 0 1 0 0 2 2 2 0 0 1 2 2 1 1 0 1 0 2 0 4 4 0 0 0-4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), jae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0V3Zm4.657 2.757a1 1 0 0 0-1.414-1.414l-.707.707a1 1 0 0 0 1.414 1.414l.707-.707ZM18 10a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1ZM5.05 6.464A1 1 0 1 0 6.464 5.05l-.707-.707a1 1 0 0 0-1.414 1.414l.707.707ZM5 10a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1Zm3 6v-1h4v1a2 2 0 1 1-4 0Zm4-2c.015-.34.208-.646.477-.859a4 4 0 1 0-4.954 0c.27.213.462.519.476.859h4.002Z"
      }
    )
  }
), Aae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.3 1.046A1 1 0 0 1 12 2v5h4a1 1 0 0 1 .82 1.573l-7 10A1 1 0 0 1 8 18v-5H4a1 1 0 0 1-.82-1.573l7-10a1 1 0 0 1 1.12-.38Z",
        clipRule: "evenodd"
      }
    )
  }
), kae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "#5E6AD2",
        d: "m2.1 11.35 6.55 6.55a8.013 8.013 0 0 1-6.55-6.55ZM2 9.572 10.428 18a8.01 8.01 0 0 0 1.463-.214L2.214 8.109A8 8 0 0 0 2 9.572Zm.634-2.72 10.515 10.514a7.988 7.988 0 0 0 1.1-.577L3.21 5.75c-.22.351-.413.719-.577 1.1Zm1.29-2.066a8.006 8.006 0 1 1 11.29 11.29L3.924 4.786Z"
      }
    )
  }
), Lae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.586 4.586a2 2 0 1 1 2.828 2.828l-3 3a2 2 0 0 1-2.828 0 1 1 0 0 0-1.414 1.414 4 4 0 0 0 5.656 0l3-3a4 4 0 0 0-5.656-5.656l-1.5 1.5a1 1 0 1 0 1.414 1.414l1.5-1.5Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7.586 9.586a2 2 0 0 1 2.828 0 1 1 0 1 0 1.414-1.414 4 4 0 0 0-5.656 0l-3 3a4 4 0 1 0 5.656 5.656l1.5-1.5a1 1 0 1 0-1.414-1.414l-1.5 1.5a2 2 0 1 1-2.828-2.828l3-3Z"
        }
      )
    ]
  }
), WU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 3c0-.552.45-1.006.997-.938a8 8 0 0 1 .987 15.688c-.535.137-1.037-.257-1.107-.805-.069-.548.323-1.04.852-1.2a6 6 0 0 0-.734-11.662C10.451 3.991 10 3.553 10 3Z"
      }
    )
  }
), Iae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 114 39",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6a6.4 6.4 0 1 1 0-12.8 6.4 6.4 0 0 1 0 12.8Zm3.423-10.045A5 5 0 0 0 18 15v5l3.423-3.645ZM74 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6a6.4 6.4 0 1 1 0-12.8 6.4 6.4 0 0 1 0 12.8Zm2.409-10.781A5 5 0 0 0 74 15v5l-3.853 3.187a5 5 0 1 0 6.262-7.569ZM97 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6a6.4 6.4 0 1 1 0-12.8 6.4 6.4 0 0 1 0 12.8Zm0-1.4a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "rect",
        {
          width: 113,
          height: 38,
          x: 0.5,
          y: 0.5,
          stroke: "currentColor",
          strokeDasharray: "10 5",
          rx: 4.5
        }
      )
    ]
  }
), Hae = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.05 4.05a7 7 0 1 1 9.9 9.9L10 18.9l-4.95-4.95a7 7 0 0 1 0-9.9ZM10 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        clipRule: "evenodd"
      }
    )
  }
), Zae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 9V7a5 5 0 0 1 10 0v2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2Zm8-2v2H7V7a3 3 0 0 1 6 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Pae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a5 5 0 0 0-5 5v2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H7V7a3 3 0 0 1 5.905-.75 1 1 0 0 0 1.937-.5A5.002 5.002 0 0 0 10 2Z"
      }
    )
  }
), Vae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm7.707 3.293a1 1 0 0 1 0 1.414L9.414 9H17a1 1 0 1 1 0 2H9.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Nae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 16 14",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M0 3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Zm3 1.752c0-.69.56-1.25 1.25-1.25h7.5a1.25 1.25 0 1 1 0 2.5h-7.5c-.69 0-1.25-.56-1.25-1.25Zm1.25 3.246a1.25 1.25 0 1 0 0 2.5h4.5a1.25 1.25 0 1 0 0-2.5h-4.5Z",
        clipRule: "evenodd"
      }
    )
  }
), Bae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2.003 5.884 10 9.882l7.997-3.998A2 2 0 0 0 16 4H4a2 2 0 0 0-1.997 1.884Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m18 8.118-8 4-8-4V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.118Z"
        }
      )
    ]
  }
), Fae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.94 6.412A2 2 0 0 0 2 8.108V16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.108a2 2 0 0 0-.94-1.696l-6-3.75a2 2 0 0 0-2.12 0l-6 3.75Zm2.615 2.423a1 1 0 1 0-1.11 1.664l5 3.333a1 1 0 0 0 1.11 0l5-3.333a1 1 0 0 0-1.11-1.664L10 11.798 5.555 8.835Z",
        clipRule: "evenodd"
      }
    )
  }
), Uae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12 1.586-4 4v12.828l4-4V1.586ZM3.707 3.293A1 1 0 0 0 2 4v10a1 1 0 0 0 .293.707L6 18.414V5.586L3.707 3.293Zm14 2L14 1.586v12.828l2.293 2.293A1 1 0 0 0 18 16V6a1 1 0 0 0-.293-.707Z",
        clipRule: "evenodd"
      }
    )
  }
), Yae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.496 2.132a1 1 0 0 0-.992 0l-7 4A1 1 0 0 0 3 8v7a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2V8a1 1 0 0 0 .496-1.868l-7-4ZM6 9a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1Zm3 1a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0v-3Zm5-1a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), $ae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Wae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), zae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), qae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm6 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Gae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 7a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Kae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M9.97571 5.41622C6.82771 5.41622 4.31717 7.9012 4.31717 10.9162C4.31717 12.5499 5.04907 14.0212 6.22415 15.0337C6.71326 15.4551 6.76695 16.1918 6.34406 16.6793C5.92117 17.1667 5.18185 17.2202 4.69274 16.7987C3.03224 15.3681 1.97571 13.2648 1.97571 10.9162C1.97571 6.56745 5.58031 3.08289 9.97571 3.08289C10.3614 3.08289 10.7415 3.10969 11.1138 3.16172C11.7541 3.2511 12.2004 3.84087 12.1107 4.47898C12.021 5.11708 11.4292 5.56187 10.7889 5.47243C10.5239 5.43544 10.2524 5.41622 9.97571 5.41622Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M16.5433 8.74081C17.182 8.6407 17.7812 9.0756 17.8816 9.71213C17.9436 10.1053 17.9757 10.5075 17.9757 10.9162C17.9757 13.2648 16.9192 15.3681 15.2587 16.7987C14.7696 17.2202 14.0302 17.1667 13.6074 16.6793C13.1845 16.1918 13.2382 15.4551 13.7273 15.0337C14.9023 14.0212 15.6342 12.5499 15.6342 10.9162C15.6342 10.6293 15.6117 10.3482 15.5686 10.0744C15.4682 9.43798 15.9046 8.84087 16.5433 8.74081Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M14.4775 4.83705C14.9447 4.37147 15.7022 4.37147 16.1694 4.83705C16.6366 5.30264 16.6366 6.05753 16.1694 6.52312L12.7775 9.9032C12.8998 10.2285 12.9666 10.5808 12.9666 10.9486C12.9666 12.5947 11.6275 13.9292 9.97571 13.9292C8.32387 13.9292 6.98479 12.5947 6.98479 10.9486C6.98479 9.30251 8.32387 7.96809 9.97571 7.96809C10.378 7.96809 10.7617 8.04722 11.1121 8.19076L14.4775 4.83705Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Qae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7 4a3 3 0 0 1 6 0v4a3 3 0 1 1-6 0V4Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 14.93A7.001 7.001 0 0 0 17 8a1 1 0 1 0-2 0A5 5 0 0 1 5 8a1 1 0 0 0-2 0 7.001 7.001 0 0 0 6 6.93V17H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-2.07Z"
        }
      )
    ]
  }
), Xae = ({
  size: e = "1em",
  fill: t = "#5865F2"
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    fill: t,
    width: e,
    height: e,
    xmlns: "http://www.w3.org/2000/svg",
    className: "bi bi-microsoft-teams",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ f.jsx("path", { d: "M9.186 4.797a2.42 2.42 0 1 0-2.86-2.448h1.178c.929 0 1.682.753 1.682 1.682v.766Zm-4.295 7.738h2.613c.929 0 1.682-.753 1.682-1.682V5.58h2.783a.7.7 0 0 1 .682.716v4.294a4.197 4.197 0 0 1-4.093 4.293c-1.618-.04-3-.99-3.667-2.35Zm10.737-9.372a1.674 1.674 0 1 1-3.349 0 1.674 1.674 0 0 1 3.349 0Zm-2.238 9.488c-.04 0-.08 0-.12-.002a5.19 5.19 0 0 0 .381-2.07V6.306a1.692 1.692 0 0 0-.15-.725h1.792c.39 0 .707.317.707.707v3.765a2.598 2.598 0 0 1-2.598 2.598h-.013Z" }),
      /* @__PURE__ */ f.jsx("path", { d: "M.682 3.349h6.822c.377 0 .682.305.682.682v6.822a.682.682 0 0 1-.682.682H.682A.682.682 0 0 1 0 10.853V4.03c0-.377.305-.682.682-.682Zm5.206 2.596v-.72h-3.59v.72h1.357V9.66h.87V5.945h1.363Z" })
    ]
  }
), zU = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 10a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Jae = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7 9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Z",
        clipRule: "evenodd"
      }
    )
  }
), eoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 10a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), toe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M17.293 13.293A8 8 0 0 1 6.707 2.707a8.002 8.002 0 1 0 10.586 10.586Z"
      }
    )
  }
), noe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M18 3a1 1 0 0 0-1.196-.98l-10 2A1 1 0 0 0 6 5v9.114A4.369 4.369 0 0 0 5 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0 0 15 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3Z"
      }
    )
  }
), roe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2H4a2 2 0 0 1-2-2V5Zm3 1h6v4H5V6Zm6 6H5v2h6v-2Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M15 7h1a2 2 0 0 1 2 2v5.5a1.5 1.5 0 0 1-3 0V7Z"
        }
      )
    ]
  }
), aoe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2V4Zm3 1h2v2H7V5Zm2 4H7v2h2V9Zm2-4h2v2h-2V5Zm2 4h-2v2h2V9Z",
        clipRule: "evenodd"
      }
    )
  }
), ooe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M12.0657 6.93433C11.7533 6.62191 11.2467 6.62191 10.9343 6.93433C10.6219 7.24675 10.6219 7.75328 10.9343 8.0657L12.8686 10L10.9343 11.9343C10.6219 12.2467 10.6219 12.7533 10.9343 13.0657C11.2467 13.3781 11.7533 13.3781 12.0657 13.0657L14.5657 10.5657C14.8781 10.2533 14.8781 9.74675 14.5657 9.43433L12.0657 6.93433Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          d: "M5.20001 6.20001C5.20001 5.64773 5.64773 5.20001 6.20001 5.20001H8.80001C8.91047 5.20001 9.00001 5.28956 9.00001 5.40001V14.6C9.00001 14.7105 8.91047 14.8 8.80001 14.8H6.20001C5.64773 14.8 5.20001 14.3523 5.20001 13.8V6.20001Z",
          fill: "#322444"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 6C2 3.79086 3.79086 2 6 2H14C16.2091 2 18 3.79086 18 6V14C18 16.2091 16.2091 18 14 18H6C3.79086 18 2 16.2091 2 14V6ZM6 4H14C15.1046 4 16 4.89543 16 6V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4Z",
          fill: "#322444"
        }
      )
    ]
  }
), ioe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M17.447 10.894a1 1 0 0 0 0-1.788l-14-7a1 1 0 0 0-1.409 1.169l1.429 5A1 1 0 0 0 4.429 9H9a1 1 0 1 1 0 2H4.429a1 1 0 0 0-.962.725l-1.429 5a1 1 0 0 0 1.41 1.17l14-7Z"
      }
    )
  }
), loe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a3 3 0 0 0-3 3v4a5 5 0 0 0 10 0V7a1 1 0 1 1 2 0v4a7 7 0 1 1-14 0V7a5 5 0 0 1 10 0v4a3 3 0 1 1-6 0V7a1 1 0 0 1 2 0v4a1 1 0 1 0 2 0V7a3 3 0 0 0-3-3Z",
        clipRule: "evenodd"
      }
    )
  }
), uoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H5Zm8 0a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2Z"
      }
    )
  }
), soe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM7 8a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0V8Zm5-1a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), coe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13.586 3.586a2 2 0 1 1 2.828 2.828l-.793.793-2.828-2.828.793-.793Zm-2.207 2.207L3 14.172V17h2.828l8.38-8.379-2.83-2.828Z"
      }
    )
  }
), foe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17.414 2.586a2 2 0 0 0-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 0 0 0-2.828Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h4a1 1 0 0 1 0 2H4v10h10v-4a1 1 0 1 1 2 0v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), doe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
      }
    )
  }
), hoe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m14.414 7 3.293-3.293a1 1 0 0 0-1.414-1.414L13 5.586V4a1 1 0 1 0-2 0v4.003a.996.996 0 0 0 .617.921A.997.997 0 0 0 12 9h4a1 1 0 1 0 0-2h-1.586Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
        }
      )
    ]
  }
), voe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M16.707 3.293a1 1 0 0 1 0 1.414L15.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L14 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L12.586 6l-1.293-1.293a1 1 0 0 1 1.414-1.414L14 4.586l1.293-1.293a1 1 0 0 1 1.414 0Z"
        }
      )
    ]
  }
), poe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17.924 2.617a.997.997 0 0 0-.215-.322l-.004-.004A.997.997 0 0 0 17 2h-4a1 1 0 1 0 0 2h1.586l-3.293 3.293a1 1 0 0 0 1.414 1.414L16 5.414V7a1 1 0 1 0 2 0V3a.997.997 0 0 0-.076-.383Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
        }
      )
    ]
  }
), moe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm12 12H4l4-8 3 6 2-4 3 6Z",
        clipRule: "evenodd"
      }
    )
  }
), goe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M16.14 11.572c1.311-.706 1.311-2.588 0-3.294L6.756 3.226C5.511 2.556 4 3.458 4 4.873v10.104c0 1.415 1.511 2.318 2.757 1.647l9.382-5.052Z"
      }
    )
  }
), woe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM9.555 7.168A1 1 0 0 0 8 8v4a1 1 0 0 0 1.555.832l3-2a1 1 0 0 0 0-1.664l-3-2Z",
        clipRule: "evenodd"
      }
    )
  }
), yoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0v-5H4a1 1 0 1 1 0-2h5V4a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), xoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-11a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V7Z",
        clipRule: "evenodd"
      }
    )
  }
), Soe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 1 1 0-2h3V6a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Coe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 0 0 2v8a2 2 0 0 0 2 2h2.586l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 15.414l2.293 2.293a1 1 0 0 0 1.414-1.414L12.414 15H15a2 2 0 0 0 2-2V5a1 1 0 1 0 0-2H3Zm11 4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V7Zm-3 1a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0V8ZM8 9a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0V9Z",
        clipRule: "evenodd"
      }
    )
  }
), boe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3a1 1 0 0 0 0 2v8a2 2 0 0 0 2 2h2.586l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 15.414l2.293 2.293a1 1 0 0 0 1.414-1.414L12.414 15H15a2 2 0 0 0 2-2V5a1 1 0 1 0 0-2H3Zm11.707 4.707a1 1 0 0 0-1.414-1.414L10 9.586 8.707 8.293a1 1 0 0 0-1.414 0l-2 2a1 1 0 1 0 1.414 1.414L8 10.414l1.293 1.293a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), _oe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4v3H4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2h1a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2Zm8 0H7v3h6V4Zm0 8H7v4h6v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Roe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 3.5a1.5 1.5 0 0 1 3 0V4a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.5a1.5 1.5 0 0 0 0 3h.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-.5a1.5 1.5 0 0 0-3 0v.5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1h-.5a1.5 1.5 0 0 1 0-3H4a1 1 0 0 0 1-1V6a1 1 0 0 1 1-1h3a1 1 0 0 0 1-1v-.5Z"
      }
    )
  }
), Eoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm2 2V5h1v1H5Zm-2 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3Zm2 2v-1h1v1H5Zm8-12a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-3Zm1 2v1h1V5h-1Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11 4a1 1 0 1 0-2 0v1a1 1 0 0 0 2 0V4Zm-1 3a1 1 0 0 1 1 1v1h2a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm6 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-7 4a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2v2a1 1 0 1 1-2 0v-3Zm-2-2a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2h3Zm10 2a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1Zm-1 4a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2h3Z"
        }
      )
    ]
  }
), Moe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-3a1 1 0 0 0-.867.5 1 1 0 1 1-1.731-1A3 3 0 0 1 13 8a3.001 3.001 0 0 1-2 2.83V11a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1 1 1 0 1 0 0-2Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), Toe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2a2 2 0 0 0-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 0 0-2-2H5Zm4.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L8.414 9H10a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0v-1a5 5 0 0 0-5-5H8.414l1.293-1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Ooe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: t.color,
        fillRule: "evenodd",
        d: "M5 2a2 2 0 0 0-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 0 0-2-2H5Zm2.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm6.207.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414ZM12.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        clipRule: "evenodd"
      }
    )
  }
), Doe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 2a1 1 0 0 1 1 1v2.101a7.002 7.002 0 0 1 11.601 2.566 1 1 0 1 1-1.885.666A5.002 5.002 0 0 0 5.999 7H9a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm.008 9.057a1 1 0 0 1 1.276.61A5.002 5.002 0 0 0 14.001 13H11a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-2.101a7.002 7.002 0 0 1-11.601-2.566 1 1 0 0 1 .61-1.276Z",
        clipRule: "evenodd"
      }
    )
  }
), joe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.707 3.293a1 1 0 0 1 0 1.414L5.414 7H11a7 7 0 0 1 7 7v2a1 1 0 1 1-2 0v-2a5 5 0 0 0-5-5H5.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Aoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8.445 14.832A1 1 0 0 0 10 14v-2.798l5.445 3.63A1 1 0 0 0 17 14V6a1 1 0 0 0-1.555-.832L10 8.798V6a1 1 0 0 0-1.555-.832l-6 4a1 1 0 0 0 0 1.664l6 4Z"
      }
    )
  }
), koe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 3a1 1 0 0 0 0 2c5.523 0 10 4.477 10 10a1 1 0 1 0 2 0C17 8.373 11.627 3 5 3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 9a1 1 0 0 1 1-1 7 7 0 0 1 7 7 1 1 0 1 1-2 0 5 5 0 0 0-5-5 1 1 0 0 1-1-1Zm-1 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
        }
      )
    ]
  }
), Loe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.707 10.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 11.586V6h5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5v5.586l-1.293-1.293ZM9 4a1 1 0 0 1 2 0v2H9V4Z"
      }
    )
  }
), Ioe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.707 7.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 8.586V5h3a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3v3.586L9.707 7.293ZM11 3a1 1 0 1 1 2 0v2h-2V3Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 9a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2H7a3 3 0 0 1-3-3V9Z"
        }
      )
    ]
  }
), Hoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2a1 1 0 0 1 1 1v1.323l3.954 1.582 1.599-.8a1 1 0 1 1 .894 1.79l-1.233.616 1.738 5.42a1 1 0 0 1-.285 1.05A3.989 3.989 0 0 1 15 15a3.989 3.989 0 0 1-2.667-1.019 1 1 0 0 1-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 0 1-.285 1.05A3.989 3.989 0 0 1 5 15a3.989 3.989 0 0 1-2.667-1.019 1 1 0 0 1-.285-1.05l1.738-5.42-1.233-.617a1 1 0 0 1 .894-1.788l1.599.799L9 4.323V3a1 1 0 0 1 1-1Zm-5 8.274-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L5 10.274Zm10 0-.818 2.552c.25.112.526.174.818.174.292 0 .569-.062.818-.174L15 10.274Z",
        clipRule: "evenodd"
      }
    )
  }
), Zoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.5 2a3.5 3.5 0 1 0 1.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 1 0 1.414 1.414l8.128-8.127a1 1 0 0 0-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 0 0 5.5 2ZM4 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12.828 11.414a1 1 0 0 0-1.414 1.414l3.879 3.88a1 1 0 0 0 1.414-1.415l-3.879-3.879Z"
        }
      )
    ]
  }
), LT = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Z",
        clipRule: "evenodd"
      }
    )
  }
), Poe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx("path", { fill: "currentColor", d: "M9 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-13a4 4 0 0 0-3.446 6.032l-2.261 2.26a1 1 0 1 0 1.414 1.415l2.261-2.261A4 4 0 1 0 11 5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Voe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.27 2.164c.47-.219.99-.219 1.46 0l6.885 3.203c.513.239.513 1.108 0 1.347L10.73 9.917c-.47.218-.99.218-1.46 0L2.385 6.714c-.513-.24-.513-1.108 0-1.347L9.27 2.164Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m3.527 8.87-1.142.53c-.513.24-.513 1.108 0 1.348L9.27 13.95c.47.219.99.219 1.46 0l6.885-3.202c.513-.24.513-1.109 0-1.348l-1.142-.53-5.743 2.671c-.47.218-.99.218-1.46 0L3.527 8.87Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "m2.385 13.286 1.142-.53 5.743 2.671c.47.219.99.219 1.46 0l5.743-2.672 1.142.531c.513.24.513 1.109 0 1.347l-6.885 3.203c-.47.219-.99.219-1.46 0l-6.885-3.203c-.513-.238-.513-1.108 0-1.347Z"
        }
      )
    ]
  }
), IT = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3a1 1 0 0 1 .707.293l3 3a1 1 0 0 1-1.414 1.414L10 5.414 7.707 7.707a1 1 0 0 1-1.414-1.414l3-3A1 1 0 0 1 10 3Zm-3.707 9.293a1 1 0 0 1 1.414 0L10 14.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Noe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm14 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 13a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2Zm14 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Boe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M15 8a3 3 0 1 0-2.977-2.63l-4.94 2.47a3 3 0 1 0 0 4.319l4.94 2.47a3 3 0 1 0 .895-1.789l-4.94-2.47a3.027 3.027 0 0 0 0-.74l4.94-2.47C13.456 7.68 14.19 8 15 8Z"
      }
    )
  }
), Foe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.166 4.999A11.954 11.954 0 0 0 10 1.944 11.954 11.954 0 0 0 17.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001Zm11.541 3.708a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Uoe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 1.944A11.954 11.954 0 0 1 2.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0 1 10 1.944ZM11 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-7a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0V7Z",
        clipRule: "evenodd"
      }
    )
  }
), Yoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2a4 4 0 0 0-4 4v1H5a1 1 0 0 0-.994.89l-1 9A1 1 0 0 0 4 18h12a1 1 0 0 0 .994-1.11l-1-9A1 1 0 0 0 15 7h-1V6a4 4 0 0 0-4-4Zm2 5V6a2 2 0 1 0-4 0v1h4Zm-6 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), $oe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M15.833 3c-.644 0-1.166.522-1.166 1.167v11.666a1.167 1.167 0 1 0 2.333 0V4.167C17 3.522 16.478 3 15.833 3Zm-3.351 5.47a1.867 1.867 0 0 1 0 3.06l-6.545 4.58C4.7 16.978 3 16.093 3 14.582V5.42c0-1.51 1.7-2.396 2.937-1.53l6.545 4.582Z"
      }
    )
  }
), Woe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.167 17c.644 0 1.166-.522 1.166-1.167V4.167a1.167 1.167 0 1 0-2.333 0v11.666C3 16.478 3.522 17 4.167 17Zm3.351-5.47a1.867 1.867 0 0 1 0-3.06l6.545-4.58C15.3 3.022 17 3.907 17 5.418v9.162c0 1.51-1.7 2.396-2.937 1.53l-6.545-4.582Z"
      }
    )
  }
), zoe = ({ size: e = "1em", fill: t, ...a }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 16 16",
    fill: "none",
    ...a,
    children: [
      /* @__PURE__ */ f.jsxs("g", { id: "Slack logo", clipPath: "url(#clip0_10939_406962)", children: [
        /* @__PURE__ */ f.jsx(
          "path",
          {
            id: "path2",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.44434 10.0775C4.44434 9.14544 5.14913 8.39508 6.02458 8.39508C6.90004 8.39508 7.60483 9.14544 7.60483 10.0775V14.2188C7.60483 15.1509 6.90004 15.9013 6.02458 15.9013C5.14913 15.9013 4.44434 15.1509 4.44434 14.2188V10.0775Z",
            fill: t ?? "#E01E5A",
            stroke: "#E01E5A",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            id: "path4",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0774 11.5556C9.14538 11.5556 8.39502 10.8508 8.39502 9.97533C8.39502 9.09987 9.14538 8.39508 10.0774 8.39508H14.2188C15.1508 8.39508 15.9012 9.09987 15.9012 9.97533C15.9012 10.8508 15.1508 11.5556 14.2188 11.5556H10.0774Z",
            fill: t ?? "#ECB22D",
            stroke: "#ECB22D",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            id: "path6",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.39502 1.78116C8.39502 0.849115 9.09981 0.0987549 9.97527 0.0987549C10.8507 0.0987549 11.5555 0.849115 11.5555 1.78116V5.9225C11.5555 6.85457 10.8507 7.60493 9.97527 7.60493C9.09981 7.60493 8.39502 6.85457 8.39502 5.9225V1.78116Z",
            fill: t ?? "#2FB67C",
            stroke: "#2FB67C",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsx(
          "path",
          {
            id: "path8",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.78104 7.60495C0.848993 7.60495 0.0986328 6.90016 0.0986328 6.0247C0.0986328 5.14925 0.848993 4.44446 1.78104 4.44446H5.92237C6.85444 4.44446 7.6048 5.14925 7.6048 6.0247C7.6048 6.90016 6.85444 7.60495 5.92237 7.60495H1.78104Z",
            fill: t ?? "#36C5F1",
            stroke: "#36C5F1",
            strokeWidth: "0.197531",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ f.jsxs("g", { id: "g18", children: [
          /* @__PURE__ */ f.jsx(
            "path",
            {
              id: "path10",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.39502 14.321C8.39458 14.5286 8.43515 14.7343 8.51441 14.9262C8.59367 15.1182 8.71005 15.2925 8.85688 15.4394C9.00371 15.5862 9.17809 15.7026 9.37001 15.7818C9.56194 15.8611 9.76762 15.9017 9.97527 15.9012C10.8507 15.9012 11.5555 15.1964 11.5555 14.321C11.556 14.1133 11.5154 13.9076 11.4361 13.7157C11.3569 13.5238 11.2405 13.3494 11.0937 13.2026C10.9468 13.0558 10.7725 12.9394 10.5805 12.8601C10.3886 12.7809 10.1829 12.7403 9.97527 12.7407H8.39502V14.321Z",
              fill: t ?? "#ECB22D",
              stroke: "#ECB22D",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              id: "path12",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14.321 7.60495H12.7407V6.0247C12.7407 5.14925 13.4455 4.44446 14.321 4.44446C15.1964 4.44446 15.9012 5.14925 15.9012 6.0247C15.9012 6.90016 15.1964 7.60495 14.321 7.60495Z",
              fill: t ?? "#2FB67C",
              stroke: "#2FB67C",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              id: "path14",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.67888 8.39508H3.25913V9.97533C3.25913 10.8508 2.55434 11.5556 1.67888 11.5556C1.47124 11.556 1.26555 11.5154 1.07363 11.4362C0.881701 11.3569 0.70732 11.2405 0.560493 11.0937C0.413665 10.9469 0.297282 10.7725 0.218024 10.5806C0.138766 10.3887 0.0981937 10.183 0.0986364 9.97533C0.0986364 9.09987 0.803426 8.39508 1.67888 8.39508Z",
              fill: t ?? "#E01E5A",
              stroke: "#E01E5A",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ f.jsx(
            "path",
            {
              id: "path16",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.60483 1.67901V3.25925H6.02459C5.81694 3.25969 5.61125 3.21912 5.41933 3.13986C5.2274 3.06061 5.05302 2.94422 4.9062 2.7974C4.75937 2.65057 4.64298 2.47619 4.56373 2.28426C4.48447 2.09234 4.4439 1.88665 4.44434 1.67901C4.44434 0.803548 5.14913 0.0987585 6.02459 0.0987585C6.23223 0.0983158 6.43792 0.138888 6.62984 0.218146C6.82177 0.297404 6.99615 0.413787 7.14298 0.560615C7.2898 0.707442 7.40619 0.881823 7.48544 1.07375C7.5647 1.26567 7.60528 1.47136 7.60483 1.67901Z",
              fill: t ?? "#36C5F1",
              stroke: "#36C5F1",
              strokeWidth: "0.197531",
              strokeLinecap: "round"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ f.jsx("defs", { children: /* @__PURE__ */ f.jsx("clipPath", { id: "clip0_10939_406962", children: /* @__PURE__ */ f.jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), qoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm4 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), Goe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2H3Zm0 4a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2H3Zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H3Zm10 5a1 1 0 1 0 2 0v-5.586l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L13 10.414V16Z"
      }
    )
  }
), Koe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2H3Zm0 4a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2H3Zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H3Zm12-3a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586V8Z"
      }
    )
  }
), Qoe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 2a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0V6H3a1 1 0 0 1 0-2h1V3a1 1 0 0 1 1-1Zm0 10a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H6v1a1 1 0 1 1-2 0v-1H3a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Zm7-10a1 1 0 0 1 .967.744L14.146 7.2 17.5 9.134a1 1 0 0 1 0 1.732l-3.354 1.935-1.18 4.455a1 1 0 0 1-1.933 0L9.854 12.8 6.5 10.866a1 1 0 0 1 0-1.732l3.354-1.935 1.18-4.455A1 1 0 0 1 12 2Z",
        clipRule: "evenodd"
      }
    )
  }
), Xoe = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M18 3a1 1 0 0 0-1.447-.894L8.763 6H5a3 3 0 0 0 0 6h.28l1.771 5.316A1 1 0 0 0 8 18h1a1 1 0 0 0 1-1v-4.382l6.553 3.276A1 1 0 0 0 18 15V3Z"
      }
    )
  }
), Joe = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.049 3.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 0 0 .95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 0 0-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.539 1.118l-2.8-2.034a1 1 0 0 0-1.176 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 0 0-.364-1.118L2.98 9.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 0 0 .951-.69l1.07-3.292Z"
      }
    )
  }
), eie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l6.921 6.922c.05.062.105.118.168.167l6.91 6.911a1 1 0 0 0 1.415-1.414l-.675-.675a9.001 9.001 0 0 0-.668-11.982A1 1 0 1 0 14.95 5.05a7.002 7.002 0 0 1 .657 9.143l-1.435-1.435a5.002 5.002 0 0 0-.636-6.294A1 1 0 0 0 12.12 7.88a3 3 0 0 1 .587 3.415l-1.992-1.992a.922.922 0 0 0-.018-.018l-6.99-6.991Zm-.469 5.894a1 1 0 0 0-1.933-.516 9 9 0 0 0 2.331 8.693 1 1 0 0 0 1.414-1.415 6.997 6.997 0 0 1-1.812-6.762ZM7.4 11.5a1 1 0 1 0-1.73 1c.214.371.48.72.795 1.035a1 1 0 0 0 1.414-1.414c-.191-.191-.35-.4-.478-.622Z"
      }
    )
  }
), tie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.05 3.636a1 1 0 0 1 0 1.414 7 7 0 0 0 0 9.9 1 1 0 1 1-1.414 1.414 9 9 0 0 1 0-12.728 1 1 0 0 1 1.414 0Zm9.9 0a1 1 0 0 1 1.414 0 9 9 0 0 1 0 12.728 1 1 0 1 1-1.414-1.414 7 7 0 0 0 0-9.9 1 1 0 0 1 0-1.414ZM7.879 6.464a1 1 0 0 1 0 1.414 3 3 0 0 0 0 4.243 1 1 0 1 1-1.414 1.414 5 5 0 0 1 0-7.07 1 1 0 0 1 1.414 0Zm4.242 0a1 1 0 0 1 1.415 0 5 5 0 0 1 0 7.072 1 1 0 0 1-1.415-1.415 3 3 0 0 0 0-4.242 1 1 0 0 1 0-1.415ZM10.001 9a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), nie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H8Z",
        clipRule: "evenodd"
      }
    )
  }
), rie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm4 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.464 4.95.707.707a1 1 0 0 0 1.414-1.414l-.707-.707a1 1 0 0 0-1.414 1.414Zm2.121-10.607a1 1 0 0 1 0 1.414l-.707.707a1 1 0 1 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0ZM17 11a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2h1Zm-7 4a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1ZM5.05 6.464A1 1 0 1 0 6.465 5.05l-.708-.707a1 1 0 0 0-1.414 1.414l.707.707Zm1.414 8.486-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 1.414ZM4 11a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2h1Z"
      }
    )
  }
), aie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 0 0 .078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10Zm-5.165 3.913 1.58 1.58A5.98 5.98 0 0 1 10 16a5.978 5.978 0 0 1-2.516-.552l1.562-1.562a4.007 4.007 0 0 0 1.789.027Zm-4.677-2.796a4.002 4.002 0 0 1-.041-2.08l-.08.079-1.53-1.532A5.98 5.98 0 0 0 4 10c0 .954.223 1.856.619 2.656l1.54-1.539Zm1.088-6.45A5.974 5.974 0 0 1 10 4c.954 0 1.856.223 2.656.619l-1.539 1.54a4.002 4.002 0 0 0-2.346.033L7.246 4.668ZM12 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
        clipRule: "evenodd"
      }
    )
  }
), oie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 5a1 1 0 1 0 0 2h5.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L13.586 5H8Zm4 10a1 1 0 1 0 0-2H6.414l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L6.414 15H12Z"
      }
    )
  }
), iie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 12a1 1 0 1 0 2 0V6.414l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L5 6.414V12Zm10-4a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586V8Z"
      }
    )
  }
), lie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Zm-1 9v-1h5v2H5a1 1 0 0 1-1-1Zm7 1h4a1 1 0 0 0 1-1v-1h-5v2Zm0-4h5V8h-5v2ZM9 8H4v2h5V8Z",
        clipRule: "evenodd"
      }
    )
  }
), uie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.707 9.293a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7A.997.997 0 0 1 2 10V5a3 3 0 0 1 3-3h5c.256 0 .512.098.707.293l7 7ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
      }
    )
  }
), sie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm0 6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6Zm11-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-2Z"
      }
    )
  }
), cie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm3.293 1.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L7.586 10 5.293 7.707a1 1 0 0 1 0-1.414ZM11 12a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z",
        clipRule: "evenodd"
      }
    )
  }
), fie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M18 9.5a1.5 1.5 0 1 1-3 0v-6a1.5 1.5 0 0 1 3 0v6Zm-4 .167v-5.43a2 2 0 0 0-1.105-1.79l-.05-.025A4 4 0 0 0 11.055 2H5.64a2 2 0 0 0-1.962 1.608l-1.2 6A2 2 0 0 0 4.44 12H8v4a2 2 0 0 0 2 2 1 1 0 0 0 1-1v-.667a4 4 0 0 1 .8-2.4l1.4-1.866a4 4 0 0 0 .8-2.4Z"
      }
    )
  }
), die = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 10.5a1.5 1.5 0 1 1 3 0v6a1.5 1.5 0 0 1-3 0v-6Zm4-.167v5.43a2 2 0 0 0 1.106 1.79l.05.025A4 4 0 0 0 8.943 18h5.416a2 2 0 0 0 1.962-1.608l1.2-6A2 2 0 0 0 15.56 8H12V4a2 2 0 0 0-2-2 1 1 0 0 0-1 1v.667a4 4 0 0 1-.8 2.4L6.8 7.933a4 4 0 0 0-.8 2.4Z"
      }
    )
  }
), hie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 1 0 0 4v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2a2 2 0 1 0 0-4V6Z"
      }
    )
  }
), vie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 14 14",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.3999 3.49998C1.3999 2.72678 2.0267 2.09998 2.7999 2.09998H11.1999C11.9731 2.09998 12.5999 2.72678 12.5999 3.49998C12.5999 4.27317 11.9731 4.89998 11.1999 4.89998H2.7999C2.0267 4.89998 1.3999 4.27317 1.3999 3.49998Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.3999 6.99998C1.3999 6.22678 2.0267 5.59998 2.7999 5.59998H4.1999C4.9731 5.59998 5.5999 6.22678 5.5999 6.99998C5.5999 7.77317 4.9731 8.39997 4.1999 8.39997H2.7999C2.0267 8.39997 1.3999 7.77317 1.3999 6.99998Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.2999 6.99998C6.2999 6.22678 6.9267 5.59998 7.6999 5.59998C8.4731 5.59998 9.0999 6.22678 9.0999 6.99998C9.0999 7.77317 8.4731 8.39997 7.6999 8.39997C6.9267 8.39997 6.2999 7.77317 6.2999 6.99998Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.7999 6.29998C9.7999 5.91338 10.1133 5.59998 10.4999 5.59998C10.8865 5.59998 11.1999 5.91338 11.1999 6.29998V7.69998C11.1999 8.08657 10.8865 8.39997 10.4999 8.39997C10.1133 8.39997 9.7999 8.08657 9.7999 7.69998V6.29998Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.1499 10.5C3.1499 9.72678 3.7767 9.09997 4.5499 9.09997H9.4499C10.2231 9.09997 10.8499 9.72678 10.8499 10.5C10.8499 11.2732 10.2231 11.9 9.4499 11.9H4.5499C3.7767 11.9 3.1499 11.2732 3.1499 10.5Z"
        }
      )
    ]
  }
), pie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a1 1 0 0 1 1 1v1h3a1 1 0 1 1 0 2H9.578a18.87 18.87 0 0 1-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 1 1-1.44 1.389 21.034 21.034 0 0 1-.554-.6 19.098 19.098 0 0 1-3.107 3.567 1 1 0 0 1-1.334-1.49 17.087 17.087 0 0 0 3.13-3.733 18.992 18.992 0 0 1-1.487-2.494 1 1 0 1 1 1.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 1 1 0-2h3V3a1 1 0 0 1 1-1Zm6 6a1 1 0 0 1 .894.553l2.991 5.982a.869.869 0 0 1 .02.037l.99 1.98a1 1 0 1 1-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 1 1-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0 1 13 8Zm-1.382 6h2.764L13 11.236 11.618 14Z",
        clipRule: "evenodd"
      }
    )
  }
), mie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2a1 1 0 0 0-.894.553L7.382 4H4a1 1 0 0 0 0 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a1 1 0 1 0 0-2h-3.382l-.724-1.447A1 1 0 0 0 11 2H9ZM7 8a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0V8Zm5-1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), gie = ({
  size: e = "1em",
  ...t
}) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 13a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v2.586l-4.293-4.293a1 1 0 0 0-1.414 0L8 9.586 3.707 5.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0L11 9.414 14.586 13H12Z",
        clipRule: "evenodd"
      }
    )
  }
), wie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 7a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8.414l-4.293 4.293a1 1 0 0 1-1.414 0L8 10.414l-4.293 4.293a1 1 0 0 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0L11 10.586 14.586 7H12Z",
        clipRule: "evenodd"
      }
    )
  }
), yie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M8 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M3 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.05a2.5 2.5 0 0 1 4.9 0H10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3Zm11 3a1 1 0 0 0-1 1v6.05A2.5 2.5 0 0 1 15.95 16H17a1 1 0 0 0 1-1v-5a1 1 0 0 0-.293-.707l-2-2A1 1 0 0 0 15 7h-1Z"
        }
      )
    ]
  }
), xie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM6.293 6.707a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L11 5.414V13a1 1 0 1 1-2 0V5.414L7.707 6.707a1 1 0 0 1-1.414 0Z",
        clipRule: "evenodd"
      }
    )
  }
), Sie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-7 9a7 7 0 1 1 14 0H3Z"
      }
    )
  }
), Cie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 1 6 6H2a6 6 0 0 1 6-6Zm8-4a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V7Z"
      }
    )
  }
), bie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-6-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 4a5 5 0 0 0-4.546 2.916A5.986 5.986 0 0 0 10 16a5.986 5.986 0 0 0 4.546-2.084A5 5 0 0 0 10 11Z",
        clipRule: "evenodd"
      }
    )
  }
), _ie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M13 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-4 7a4 4 0 0 0-8 0v3h8v-3ZM6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm10 10v-3a5.972 5.972 0 0 0-.75-2.906A3.005 3.005 0 0 1 19 15v3h-3ZM4.75 12.094A5.973 5.973 0 0 0 4 15v3H1v-3a3 3 0 0 1 3.75-2.906Z"
      }
    )
  }
), Rie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 11a6 6 0 0 0-12 0h12Zm-1-9a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
      }
    )
  }
), Eie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm8 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-4.07 11c.046-.327.07-.66.07-1a6.97 6.97 0 0 0-1.5-4.33A5 5 0 0 1 19 16v1h-6.07ZM6 11a5 5 0 0 1 5 5v1H1v-1a5 5 0 0 1 5-5Z"
      }
    )
  }
), Mie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.649 3.084A1 1 0 0 1 5.163 4.4 13.95 13.95 0 0 0 4 10c0 1.993.416 3.886 1.164 5.6a1 1 0 0 1-1.832.8A15.95 15.95 0 0 1 2 10c0-2.274.475-4.44 1.332-6.4a1 1 0 0 1 1.317-.516ZM12.961 7a3 3 0 0 0-2.342 1.126l-.328.41-.111-.279A2 2 0 0 0 8.323 7H8a1 1 0 0 0 0 2h.323l.532 1.33-1.035 1.295a1 1 0 0 1-.781.375H7a1 1 0 1 0 0 2h.039a3 3 0 0 0 2.342-1.126l.328-.41.111.279A2 2 0 0 0 11.677 14H12a1 1 0 1 0 0-2h-.323l-.532-1.33 1.035-1.295A1 1 0 0 1 12.961 9H13a1 1 0 1 0 0-2h-.039Zm1.874-2.6a1 1 0 0 1 1.833-.8A15.95 15.95 0 0 1 18 10c0 2.274-.475 4.44-1.332 6.4a1 1 0 1 1-1.832-.8A13.949 13.949 0 0 0 16 10c0-1.993-.416-3.886-1.165-5.6Z"
      }
    )
  }
), Tie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm12.553 1.106A1 1 0 0 0 14 8v4a1 1 0 0 0 .553.894l2 1A1 1 0 0 0 18 13V7a1 1 0 0 0-1.447-.894l-2 1Z"
      }
    )
  }
), Oie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4Zm6 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4Zm7-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2Z"
      }
    )
  }
), Die = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H5Zm6-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm0 8a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2Z"
      }
    )
  }
), jie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H5Zm6-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5Zm3 6a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
      }
    )
  }
), Aie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), kie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.383 3.076A1 1 0 0 1 10 4v12a1 1 0 0 1-1.707.707L4.586 13H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.586l3.707-3.707a1 1 0 0 1 1.09-.217Zm2.91 4.217a1 1 0 0 1 1.414 0L15 8.586l1.293-1.293a1 1 0 1 1 1.414 1.414L16.414 10l1.293 1.293a1 1 0 0 1-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Lie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.383 3.076A1 1 0 0 1 10 4v12a1 1 0 0 1-1.707.707L4.586 13H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.586l3.707-3.707a1 1 0 0 1 1.09-.217Zm5.274-.147a1 1 0 0 1 1.414 0A9.972 9.972 0 0 1 19 10a9.972 9.972 0 0 1-2.929 7.071 1 1 0 0 1-1.414-1.414A7.971 7.971 0 0 0 17 10a7.97 7.97 0 0 0-2.343-5.657 1 1 0 0 1 0-1.414Zm-2.829 2.828a1 1 0 0 1 1.415 0A5.983 5.983 0 0 1 15 10a5.984 5.984 0 0 1-1.757 4.243 1 1 0 0 1-1.415-1.415A3.984 3.984 0 0 0 13 10a3.983 3.983 0 0 0-1.172-2.828 1 1 0 0 1 0-1.415Z",
        clipRule: "evenodd"
      }
    )
  }
), Iie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 0 1 .808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 0 1-1.414 1.414ZM14.95 11.05a7 7 0 0 0-9.9 0 1 1 0 0 1-1.414-1.414 9 9 0 0 1 12.728 0 1 1 0 0 1-1.414 1.414Zm-2.83 2.83a3 3 0 0 0-4.242 0 1 1 0 0 1-1.415-1.415 5 5 0 0 1 7.072 0 1 1 0 0 1-1.415 1.415ZM9 16a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1Z",
        clipRule: "evenodd"
      }
    )
  }
), Bx = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 0 1 1.414 0L10 8.586l4.293-4.293a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L8.586 10 4.293 5.707a1 1 0 0 1 0-1.414Z",
        clipRule: "evenodd"
      }
    )
  }
), Fx = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: /* @__PURE__ */ f.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.707 7.293a1 1 0 0 0-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L11.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L10 8.586 8.707 7.293Z",
        clipRule: "evenodd"
      }
    )
  }
), Hie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M5 8a1 1 0 0 1 1-1h1V6a1 1 0 0 1 2 0v1h1a1 1 0 1 1 0 2H9v1a1 1 0 1 1-2 0V9H6a1 1 0 0 1-1-1Z"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Zm6-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Zie = ({ size: e = "1em", ...t }) => /* @__PURE__ */ f.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    fill: "none",
    viewBox: "0 0 20 20",
    focusable: "false",
    ...t,
    children: [
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ f.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 8a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
var qU = $o({ defaultClassName: "_1gg22ys2", variantClassNames: { kind: { info: "_1gg22ys3", error: "_1gg22ys4", warning: "_1gg22ys5" }, border: { true: "_1gg22ys6 _1gg22ys0 _1faqfmvf9 _1faqfmv6", false: "_1gg22ys7 _1gg22ys1" } }, defaultVariants: { kind: "info", border: !0 }, compoundVariants: [] });
const GU = {
  error: lh.theme.static.surface.sentiment.bad,
  info: lh.theme.static.surface.sentiment.neutral,
  warning: lh.theme.static.surface.sentiment.caution
}, KU = {
  error: lh.theme.static.content.sentiment.bad,
  info: lh.theme.static.content.weak,
  warning: lh.theme.static.content.sentiment.caution
}, Pie = ({
  children: e,
  kind: t = "info",
  title: a,
  icon: i,
  border: h,
  style: g = {},
  width: m,
  handleCloseClick: C
}) => {
  const S = i || QU[t];
  return /* @__PURE__ */ f.jsxs(
    ct,
    {
      p: "8",
      gap: "8",
      display: "flex",
      alignItems: "flex-start",
      borderRadius: "8",
      border: "secondary",
      cssClass: qU({ kind: t, border: h }),
      justifyContent: "space-between",
      style: {
        ...g,
        width: m || "auto"
      },
      children: [
        i !== !1 && /* @__PURE__ */ f.jsx(
          ct,
          {
            alignItems: "center",
            alignSelf: "flex-start",
            borderRadius: "5",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            style: {
              backgroundColor: GU[t],
              height: 22,
              width: 22
            },
            children: /* @__PURE__ */ f.jsx(S, { size: 14, color: KU[t] })
          }
        ),
        /* @__PURE__ */ f.jsxs(ct, { gap: "16", display: "flex", flexDirection: "column", width: "full", children: [
          a && /* @__PURE__ */ f.jsxs(ct, { display: "flex", position: "relative", children: [
            /* @__PURE__ */ f.jsx(ct, { mt: "6", children: /* @__PURE__ */ f.jsx(Fr, { color: "strong", weight: "bold", size: "small", children: a }) }),
            C && /* @__PURE__ */ f.jsx(
              ct,
              {
                flexShrink: 0,
                style: { position: "absolute", right: "0" },
                children: /* @__PURE__ */ f.jsx(
                  h3,
                  {
                    kind: "secondary",
                    emphasis: "low",
                    shape: "square",
                    size: "minimal",
                    icon: /* @__PURE__ */ f.jsx(Bx, { size: 16 }),
                    onClick: C
                  }
                )
              }
            )
          ] }),
          e
        ] })
      ]
    }
  );
}, QU = {
  error: Fx,
  info: $U,
  warning: YU
};
var XU = $o({ defaultClassName: "_1kudzuf6", variantClassNames: { size: { small: "_1kudzuf7 _1kudzuf0 _1faqfmv2o", medium: "_1kudzuf8 _1kudzuf1 _1faqfmv2t", large: "_1kudzuf9 _1kudzuf2 _1faqfmv2u" }, border: { none: "_1kudzufa", primary: "_1kudzufb _1kudzuf3 _1faqfmvez", secondary: "_1kudzufc _1kudzuf4 _1faqfmvf9" }, rounded: { true: "_1kudzufd _1kudzuf5 _1faqfmv5", false: "_1kudzufe" } }, defaultVariants: { border: "secondary", rounded: !0, size: "medium" }, compoundVariants: [] });
const Vie = ({ children: e, cssClass: t, ...a }) => /* @__PURE__ */ f.jsx(ct, { cssClass: [XU({ ...a }), t], children: e });
var JU = "_45t5730", eY = "_45t5731", tY = Yk({ conditions: { defaultCondition: "mobile", conditionNames: ["mobile", "tablet", "desktop", "wide"], responsiveArray: void 0 }, styles: { flex: { values: { 1: { conditions: { mobile: "_45t5732", tablet: "_45t5733", desktop: "_45t5734", wide: "_45t5735" }, defaultClass: "_45t5732" }, 2: { conditions: { mobile: "_45t5736", tablet: "_45t5737", desktop: "_45t5738", wide: "_45t5739" }, defaultClass: "_45t5736" }, 3: { conditions: { mobile: "_45t573a", tablet: "_45t573b", desktop: "_45t573c", wide: "_45t573d" }, defaultClass: "_45t573a" }, 4: { conditions: { mobile: "_45t573e", tablet: "_45t573f", desktop: "_45t573g", wide: "_45t573h" }, defaultClass: "_45t573e" }, 5: { conditions: { mobile: "_45t573i", tablet: "_45t573j", desktop: "_45t573k", wide: "_45t573l" }, defaultClass: "_45t573i" }, 6: { conditions: { mobile: "_45t573m", tablet: "_45t573n", desktop: "_45t573o", wide: "_45t573p" }, defaultClass: "_45t573m" }, 7: { conditions: { mobile: "_45t573q", tablet: "_45t573r", desktop: "_45t573s", wide: "_45t573t" }, defaultClass: "_45t573q" }, 8: { conditions: { mobile: "_45t573u", tablet: "_45t573v", desktop: "_45t573w", wide: "_45t573x" }, defaultClass: "_45t573u" }, 9: { conditions: { mobile: "_45t573y", tablet: "_45t573z", desktop: "_45t57310", wide: "_45t57311" }, defaultClass: "_45t573y" }, 10: { conditions: { mobile: "_45t57312", tablet: "_45t57313", desktop: "_45t57314", wide: "_45t57315" }, defaultClass: "_45t57312" }, 11: { conditions: { mobile: "_45t57316", tablet: "_45t57317", desktop: "_45t57318", wide: "_45t57319" }, defaultClass: "_45t57316" }, 12: { conditions: { mobile: "_45t5731a", tablet: "_45t5731b", desktop: "_45t5731c", wide: "_45t5731d" }, defaultClass: "_45t5731a" }, auto: { conditions: { mobile: "_45t5731e", tablet: "_45t5731f", desktop: "_45t5731g", wide: "_45t5731h" }, defaultClass: "_45t5731e" } } } } }), pR = { mobile: { 0: "_45t5731i", 1: "_45t5731j", 2: "_45t5731k", 3: "_45t5731l", 4: "_45t5731m", 6: "_45t5731n", 7: "_45t5731o", 8: "_45t5731p", 9: "_45t5731q", 10: "_45t5731r", 12: "_45t5731s", 16: "_45t5731t", 20: "_45t5731u", 24: "_45t5731v", 28: "_45t5731w", 32: "_45t5731x", 36: "_45t5731y", 40: "_45t5731z", 44: "_45t57320", 48: "_45t57321" }, tablet: { 0: "_45t57322", 1: "_45t57323", 2: "_45t57324", 3: "_45t57325", 4: "_45t57326", 6: "_45t57327", 7: "_45t57328", 8: "_45t57329", 9: "_45t5732a", 10: "_45t5732b", 12: "_45t5732c", 16: "_45t5732d", 20: "_45t5732e", 24: "_45t5732f", 28: "_45t5732g", 32: "_45t5732h", 36: "_45t5732i", 40: "_45t5732j", 44: "_45t5732k", 48: "_45t5732l" }, desktop: { 0: "_45t5732m", 1: "_45t5732n", 2: "_45t5732o", 3: "_45t5732p", 4: "_45t5732q", 6: "_45t5732r", 7: "_45t5732s", 8: "_45t5732t", 9: "_45t5732u", 10: "_45t5732v", 12: "_45t5732w", 16: "_45t5732x", 20: "_45t5732y", 24: "_45t5732z", 28: "_45t57330", 32: "_45t57331", 36: "_45t57332", 40: "_45t57333", 44: "_45t57334", 48: "_45t57335" }, wide: { 0: "_45t57336", 1: "_45t57337", 2: "_45t57338", 3: "_45t57339", 4: "_45t5733a", 6: "_45t5733b", 7: "_45t5733c", 8: "_45t5733d", 9: "_45t5733e", 10: "_45t5733f", 12: "_45t5733g", 16: "_45t5733h", 20: "_45t5733i", 24: "_45t5733j", 28: "_45t5733k", 32: "_45t5733l", 36: "_45t5733m", 40: "_45t5733n", 44: "_45t5733o", 48: "_45t5733p" } };
const nY = (e) => {
  switch (typeof e) {
    case "object":
      return $k.map(
        (t) => pR[t][e[t]]
      ).join(" ");
    case "string":
      return pR.mobile[e];
    default:
      return "";
  }
}, HT = Sa.createContext({
  gap: "0"
}), rY = ({ children: e, gap: t }) => /* @__PURE__ */ f.jsx(HT.Provider, { value: { gap: t ?? "0" }, children: /* @__PURE__ */ f.jsx(ct, { cssClass: Br(JU, nY(t)), children: e }) }), aY = ({
  children: e,
  span: t = "auto"
}) => {
  const { gap: a } = Sa.useContext(HT);
  return /* @__PURE__ */ f.jsx(
    ct,
    {
      cssClass: Br(
        eY,
        tY({ flex: t }),
        W8({ pl: a, pt: a })
      ),
      children: e
    }
  );
};
aY.Container = rY;
const Nie = J4, v3 = Sa.forwardRef(({ children: e, ...t }, a) => /* @__PURE__ */ f.jsx(iw, { ref: a, ...t, children: e })), oY = ({ children: e, ...t }) => (t.gutter = t.gutter ?? 4, /* @__PURE__ */ f.jsxs(NM, { ...t, children: [
  /* @__PURE__ */ f.jsx(Zp, { size: 0 }),
  e
] })), iY = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(Z4, { ...t, children: e }), lY = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(TM, { ...t, children: e }), uY = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(MM, { ...t, children: e });
v3.Popover = oY;
v3.Item = iY;
v3.Group = lY;
v3.GroupLabel = uY;
const Do = Sa.forwardRef(
  ({
    align: e,
    children: t,
    flex: a,
    justify: i,
    wrap: h,
    width: g,
    as: m = "div",
    gap: C = "16",
    direction: S = "column",
    ...R
  }, D) => (typeof h == "boolean" && (h = h ? "wrap" : void 0), /* @__PURE__ */ f.jsx(
    ct,
    {
      as: m,
      alignItems: e,
      display: "flex",
      flexDirection: S,
      flex: a,
      justifyContent: i,
      gap: C,
      flexWrap: h,
      width: g,
      ref: D,
      ...R,
      children: t
    }
  ))
);
var sY = "_1lamavh0", cY = "_1lamavh1", fY = "_1lamavh2", dY = "_1lamavh3", hY = "_1lamavh4", vY = "_1lamavh5", pY = "_1lamavh6", mY = "_1lamavh7", Z8 = "_1lamavh8", mR = "_1lamavh9", gY = "_1lamavha";
const Bie = ({
  label: e,
  icon: t,
  value: a,
  valueRender: i,
  options: h,
  onChange: g,
  onChangeQuery: m,
  onClose: C,
  queryPlaceholder: S,
  cssClass: R,
  wrapperCssClass: D,
  popoverCssClass: T,
  creatableRender: j,
  defaultOpen: A,
  disabled: L,
  loadingRender: P,
  emptyStateRender: V,
  clearable: F
}) => {
  const Y = typeof a == "object", W = J4({
    setValue: (re) => {
      m == null || m(re);
    },
    resetValueOnHide: !0,
    defaultOpen: A
  }), Q = Pp({
    combobox: W,
    setValue: (re) => {
      g(re), Y && A && W.setOpen(!1);
    },
    value: a
  }), $ = new Set(a), le = W.useState("value"), te = h === void 0, Se = Lr(() => {
    const re = /* @__PURE__ */ new Map();
    return le !== void 0 && le !== "" && j !== void 0 && re.set(le, { key: le, render: j(le) }), Y && j && (a == null || a.forEach((ve) => {
      ve !== le && re.set(ve, { key: ve, render: j(ve) });
    })), h == null || h.forEach((ve) => re.set(ve.key, ve)), Array.from(re.values());
  }, [le, a, h, j, Y]);
  return /* @__PURE__ */ f.jsxs("div", { className: Br(D), children: [
    /* @__PURE__ */ f.jsx(Sw, { store: Q, className: sY, children: e }),
    /* @__PURE__ */ f.jsx(
      f3,
      {
        store: Q,
        className: Br([
          cY,
          R,
          {
            [fY]: L
          }
        ]),
        disabled: L,
        children: /* @__PURE__ */ f.jsxs(
          Do,
          {
            direction: "row",
            align: "center",
            justify: "space-between",
            width: "full",
            gap: "2",
            children: [
              /* @__PURE__ */ f.jsxs(ct, { children: [
                t,
                i && /* @__PURE__ */ f.jsx(
                  Fr,
                  {
                    size: "xSmall",
                    color: "secondaryContentText",
                    lines: "1",
                    children: i
                  }
                )
              ] }),
              F && !!a && /* @__PURE__ */ f.jsx(
                h3,
                {
                  icon: /* @__PURE__ */ f.jsx(Fx, {}),
                  onClick: () => g(void 0),
                  size: "xSmall",
                  emphasis: "none",
                  kind: "secondary"
                }
              )
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ f.jsxs(
      Cw,
      {
        store: Q,
        className: Br([mY, T]),
        gutter: 4,
        autoFocusOnHide: !1,
        onClose: C,
        children: [
          /* @__PURE__ */ f.jsx(Zp, { size: 0 }),
          m !== void 0 && /* @__PURE__ */ f.jsxs(
            "div",
            {
              className: Br(hY, {
                [vY]: Se.length > 0 || te || !!V
              }),
              children: [
                /* @__PURE__ */ f.jsx(LT, {}),
                /* @__PURE__ */ f.jsx(
                  iw,
                  {
                    store: W,
                    type: "text",
                    autoSelect: !0,
                    autoComplete: "none",
                    placeholder: S,
                    className: dY
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ f.jsxs(
            hx,
            {
              store: W,
              className: Br([pY, "hide-scrollbar"]),
              children: [
                te && /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: Br([
                      Z8,
                      mR
                    ]),
                    children: P
                  }
                ),
                V && !te && Se.length === 0 && /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: Br([
                      Z8,
                      mR
                    ]),
                    children: V
                  }
                ),
                Q.useState("open") && Se.map((re) => /* @__PURE__ */ f.jsx(
                  Z4,
                  {
                    focusOnHover: !0,
                    className: Z8,
                    render: /* @__PURE__ */ f.jsxs(xw, { value: re.key, children: [
                      Y && /* @__PURE__ */ f.jsx(
                        "div",
                        {
                          className: gY,
                          style: {
                            backgroundColor: $.has(re.key) ? lh.theme.interactive.fill.primary.enabled : "white"
                          },
                          children: /* @__PURE__ */ f.jsx(Vx, { color: "white" })
                        }
                      ),
                      re.render
                    ] })
                  },
                  re.key
                ))
              ]
            }
          )
        ]
      }
    )
  ] });
};
var wY = "_821rm91", yY = "_821rm92";
const Fie = ({
  children: e,
  centered: t = !0,
  padded: a = !0,
  ...i
}) => /* @__PURE__ */ f.jsx(ct, { cssClass: wY, children: /* @__PURE__ */ f.jsx(
  ct,
  {
    cssClass: yY,
    px: a ? "20" : void 0,
    mx: t ? "auto" : void 0,
    ...i,
    children: e
  }
) }), k0 = (e, t, ...a) => !e || t == null ? /* @__PURE__ */ new Date() : new Date(e, t, ...a), b1 = (e) => ({
  D: e.getDate(),
  M: e.getMonth(),
  Y: e.getFullYear()
}), xY = (e) => e.getDay(), Fo = (e) => k0(b1(e).Y, b1(e).M, b1(e).D), vy = (e) => k0(b1(e).Y, b1(e).M + 1, 0).getDate(), _p = (e, t, a) => {
  const { Y: i, M: h, D: g } = b1(e), m = a === "date" ? g + t : a === "month" && g > vy(k0(i, h + t, 1)) ? vy(k0(i, h + t, 1)) : g;
  return k0(i + (a === "year" ? t : 0), h + (a === "month" ? t : 0), m);
}, gR = (e, t, a) => _p(e, 0 - t, a), ZT = (e, t) => +e - +t, O5 = (e, t, a) => e.toLocaleDateString(t, a), SY = (e, { locale: t, monthName: a }) => O5(e, t, { month: a }), wR = (e, t) => e.concat(t).sort(ZT), yR = (e, t, a) => {
  let [i, h] = [e, t];
  return e && t && ([i, h] = [e, t].sort(a)), [i, h];
}, CY = (e, t) => t ? t.includes(e) : !1, bY = (e, t = []) => {
  const { M: a, D: i } = b1(e);
  return t.some((h) => {
    const { M: g, D: m } = b1(h);
    return a === g && i === m;
  });
}, _Y = (e, { day: t, date: a } = {}) => CY(e.getDay(), t) || bY(e, a);
var RY = 42;
function xR(e, t) {
  return (xY(e) + 7 - t) % 7;
}
function EY(e, t, { mode: a, startDay: i }) {
  const h = k0(t, e, 1), g = vy(h), m = xR(h, i), C = a === "static" ? RY : m + g + 6 - xR(k0(t, e, g), i);
  return {
    start: m,
    length: C
  };
}
const Au = (e, t) => +e == +t, D5 = (e, t) => e < t, py = (e, t) => e > t, SR = (e, t, a) => py(t, e) && D5(t, a) || D5(t, e) && py(t, a), V4 = (e, t) => !!e && py(t, e), N4 = (e, t) => !!e && D5(t, e), bw = (e, t) => e.some((a) => Au(Fo(a), Fo(t)));
var CR = {
  mode: "static",
  offsets: [0],
  startDay: 0
}, MY = {
  mode: "decade",
  /*
   * The default value for the numberOfYears is 12
   * it consists of 10 years + 1 year before + 1 year after
   */
  numberOfYears: 12,
  step: 10
}, TY = {
  mode: "single",
  toggle: !1,
  selectSameDate: !1
}, OY = {
  interval: 30,
  useLocales: !1
}, DY = {
  locale: "en-GB",
  day: "2-digit",
  year: "numeric",
  weekday: "short",
  monthName: "long",
  hour: "2-digit",
  minute: "2-digit",
  hour12: void 0,
  second: void 0
};
function jY({ selectedDates: e = [], onDatesChange: t, focusDate: a, offsetDate: i, onOffsetChange: h, calendar: g = {}, dates: m = {}, locale: C, time: S = {}, exclude: R = {}, years: D }) {
  const { minDate: T, maxDate: j, ...A } = m, { offsets: L = [], ...P } = g, { minTime: V, maxTime: F, ...Y } = S, [W, Q] = yR(T, j, ZT), [$, le] = yR(V, F, (Se, re) => Se.h - re.h), te = a && bw(e, a) ? a : void 0;
  return {
    selectedDates: e,
    onDatesChange: t,
    offsetDate: i,
    onOffsetChange: h,
    focusDate: te,
    calendar: {
      ...CR,
      ...P,
      offsets: CR.offsets.concat(L)
    },
    years: { ...MY, ...D },
    dates: {
      ...TY,
      ...A,
      minDate: W && Fo(W),
      maxDate: Q && Fo(Q)
    },
    locale: {
      ...DY,
      ...C
    },
    time: {
      ...OY,
      minTime: $,
      maxTime: le,
      ...Y
    },
    exclude: R
  };
}
function j4(e) {
  return e === "range";
}
const bR = "range-start", _R = "range-end", RR = "will-be-range-start", ER = "will-be-range-end", AY = (e, t, a, i) => {
  if (!j4(i) || a.length === 0)
    return "";
  const [h, g] = a;
  return h && g ? Au(e, Fo(h)) ? Au(Fo(h), Fo(g)) ? `${bR} ${_R}` : bR : Au(e, Fo(g)) ? _R : SR(Fo(h), e, Fo(g)) ? "in-range" : "" : !g && t ? SR(Fo(h), e, t) ? "will-be-in-range" : D5(t, Fo(h)) ? Au(e, t) ? RR : Au(e, Fo(h)) ? ER : "" : Au(e, Fo(h)) ? RR : Au(e, t) ? ER : "" : "";
}, kY = (e, t, a, { rangeEnd: i }, h) => {
  const { dates: { mode: g, minDate: m, maxDate: C }, locale: S, calendar: R, exclude: D } = h, { locale: T, day: j, year: A } = S, { M: L, Y: P } = b1(t), { start: V, length: F } = EY(L, P, R), Y = Array(F).fill(0).map((W, Q) => {
    const $ = k0(P, L, Q + 1 - V);
    return {
      $date: $,
      active: Au(e, $),
      day: O5($, T, { day: j }),
      now: Au(Fo(k0()), $),
      range: AY($, i, a, g),
      disabled: N4(m, $) || V4(C, $) || _Y($, D),
      selected: bw(a, $),
      inCurrentMonth: b1($).M === L
    };
  });
  return {
    year: O5(t, T, { year: A }),
    month: SY(t, S),
    days: Y
  };
}, LY = ({ selectedDates: e, state: t, config: a, offsetDate: i }) => a.calendar.offsets.map((h) => kY(i, _p(i, h, "month"), e, t, a));
var IY = ({ days: e }, { locale: { locale: t, weekday: a } }) => [0, 1, 2, 3, 4, 5, 6].map((i) => O5(e[i].$date, t, { weekday: a }));
const HY = (e) => {
  const t = LY(e);
  return Lr(() => ({
    calendars: t,
    weekDays: IY(t[0], e.config)
  }), [t, e.config]);
}, v5 = (...e) => (...t) => e.forEach((a) => a == null ? void 0 : a(...t)), p5 = (e) => (t, a) => e(a), m5 = (e, t, a = {}, i = !1) => ({
  role: "button",
  tabIndex: 0,
  ...e ? {
    disabled: !0,
    "aria-disabled": !0
  } : {
    onClick(h) {
      t(h);
    }
  },
  ...i ? { "aria-selected": !0 } : {},
  ...a
});
var PT = "SET_FOCUS_DATE", VT = "SET_OFFSET_DATE", NT = "SET_RANGE_END", ZY = "SET_YEAR", PY = (e, t) => {
  switch (t.type) {
    case PT:
      return {
        ...e,
        focusDate: t.date
      };
    case VT:
      return {
        ...e,
        offsetDate: t.date
      };
    case NT:
      return {
        ...e,
        rangeEnd: t.date
      };
    case ZY:
      return {
        ...e,
        offsetYear: t.year
      };
    default:
      return e;
  }
}, MR = (e, t) => {
  e({ type: PT, date: t });
}, VY = (e, t) => {
  e({ type: VT, date: t });
}, TR = (e, t) => {
  e({ type: NT, date: t });
};
const P8 = ({ dispatch: e, config: { onOffsetChange: t, offsetDate: a } }) => (i) => {
  !t && !a && VY(e, i), t && t(i);
}, OR = (e, { days: t, months: a, years: i }) => {
  let h = e;
  return t && t !== 0 && (h = _p(h, t, "date")), a && a !== 0 && (h = _p(h, a, "month")), i && i !== 0 && (h = _p(h, i, "year")), h;
}, DR = (e, { days: t = 0, months: a = 0, years: i = 0 }, h) => !h || Au(e, h) ? e : t !== 0 ? V8(e, h, t, "date") : a !== 0 ? V8(e, h, a, "month") : i !== 0 ? V8(e, h, i, "year") : e, V8 = (e, t, a, i) => {
  const h = _p(e, a, i);
  return a > 0 ? V4(t, h) ? gR(t, a, i) : e : N4(t, h) ? gR(t, a, i) : e;
}, NY = (e) => {
  const { config: { dates: t } } = e, { minDate: a, maxDate: i } = t, h = Ir((C, { disabled: S, onClick: R, ...D } = {}) => {
    const T = DR(e.offsetDate, C, i), j = OR(T, C), A = !!S || V4(i, j);
    return m5(A, (L) => v5(R, p5(P8(e)))(L, j), D);
  }, [i, e]), g = Ir(({ days: C = 0, months: S = 0, years: R = 0 }, { disabled: D, onClick: T, ...j } = {}) => {
    const A = {
      days: -C,
      months: -S,
      years: -R
    }, L = DR(e.offsetDate, A, a), P = OR(L, A), V = !!D || N4(a, P);
    return m5(V, (F) => v5(T, p5(P8(e)))(F, P), j);
  }, [a, e]), m = Ir((C, { disabled: S, onClick: R, ...D } = {}) => {
    const T = !!S || N4(a, C) || V4(i, C);
    return m5(T, (j) => v5(R, p5(P8(e)))(j, C), D);
  }, [e, i, a]);
  return {
    addOffset: h,
    setOffset: m,
    subtractOffset: g
  };
}, BY = (e, t, a) => V4(t, a) ? t : N4(e, a) ? e : a, FY = (e) => e - e % 10 - 1, UY = (e, t) => e - (t / 2 - (t % 2 === 0 ? 1 : 0)), YY = (e, t) => e - t + 1, $Y = (e) => e === "exact", WY = (e, { mode: t, numberOfYears: a }) => $Y(t) ? YY(e, a) : t === "decade" ? FY(e) : UY(e, a), zY = (e) => {
  const { selectedDates: t, offsetDate: a, focusDate: i, dates: { minDate: h, maxDate: g }, years: m } = e, C = a || (t.length > 0 ? t[t.length - 1] : BY(h, g, Fo(k0())));
  return {
    focusDate: i,
    rangeEnd: null,
    offsetDate: C,
    offsetYear: WY(b1(C).Y, m)
  };
}, qY = (e) => {
  const t = jY(e), [a, i] = oE(PY, zY(t));
  return {
    dispatch: i,
    selectedDates: t.selectedDates,
    offsetDate: t.offsetDate || a.offsetDate,
    state: a,
    config: t
  };
}, GY = (e, t, { mode: a, toggle: i, limit: h }) => i && bw(e, t) ? e.filter((g) => !Au(Fo(g), t)) : a === "multiple" ? !h || e.length < h ? wR(e, t) : e : j4(a) ? e.length === 2 ? [t] : wR(e, t) : [t], KY = ({ config: e, selectedDates: t, dispatch: a }) => {
  const { onDatesChange: i, dates: { mode: h, toggle: g, selectSameDate: m } } = e;
  return { dayButton: Ir(({ $date: S, selected: R, disabled: D, active: T }, { onClick: j, disabled: A, ...L } = {}) => m5(D || !!A, (P) => {
    R && !g && (t.forEach((V) => {
      Au(Fo(V), S) && MR(a, V);
    }), !j4(h) || !m) || (j4(h) && t.length === 1 && TR(a, null), v5(j, p5((V) => {
      const F = GY(t, V, e.dates);
      MR(a, bw(F, V) ? V : void 0), i(F);
    }))(P, S));
  }, {
    ...L,
    ...j4(h) && t.length === 1 && {
      onMouseEnter() {
        TR(a, S);
      }
    },
    tabIndex: T ? 0 : -1
  }, R), [
    h,
    g,
    e.dates,
    i,
    t,
    a,
    m
  ]) };
};
ka({});
var BT = ka({}), Ux = () => Yo(BT), QY = ({ children: e, config: t }) => Sa.createElement(BT.Provider, { value: qY(t) }, e);
const FT = () => HY(Ux()), XY = () => KY(Ux()), JY = () => NY(Ux());
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var UT;
function Ke() {
  return UT.apply(null, arguments);
}
function e$(e) {
  UT = e;
}
function R1(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function A2(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function lr(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Yx(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (lr(e, t))
      return !1;
  return !0;
}
function Ql(e) {
  return e === void 0;
}
function pf(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function p3(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function YT(e, t) {
  var a = [], i, h = e.length;
  for (i = 0; i < h; ++i)
    a.push(t(e[i], i));
  return a;
}
function oh(e, t) {
  for (var a in t)
    lr(t, a) && (e[a] = t[a]);
  return lr(t, "toString") && (e.toString = t.toString), lr(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function V0(e, t, a, i) {
  return vO(e, t, a, i, !0).utc();
}
function t$() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function pn(e) {
  return e._pf == null && (e._pf = t$()), e._pf;
}
var my;
Array.prototype.some ? my = Array.prototype.some : my = function(e) {
  var t = Object(this), a = t.length >>> 0, i;
  for (i = 0; i < a; i++)
    if (i in t && e.call(this, t[i], i, t))
      return !0;
  return !1;
};
function $x(e) {
  if (e._isValid == null) {
    var t = pn(e), a = my.call(t.parsedDateParts, function(h) {
      return h != null;
    }), i = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && a);
    if (e._strict && (i = i && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = i;
    else
      return i;
  }
  return e._isValid;
}
function _w(e) {
  var t = V0(NaN);
  return e != null ? oh(pn(t), e) : pn(t).userInvalidated = !0, t;
}
var jR = Ke.momentProperties = [], N8 = !1;
function Wx(e, t) {
  var a, i, h, g = jR.length;
  if (Ql(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), Ql(t._i) || (e._i = t._i), Ql(t._f) || (e._f = t._f), Ql(t._l) || (e._l = t._l), Ql(t._strict) || (e._strict = t._strict), Ql(t._tzm) || (e._tzm = t._tzm), Ql(t._isUTC) || (e._isUTC = t._isUTC), Ql(t._offset) || (e._offset = t._offset), Ql(t._pf) || (e._pf = pn(t)), Ql(t._locale) || (e._locale = t._locale), g > 0)
    for (a = 0; a < g; a++)
      i = jR[a], h = t[i], Ql(h) || (e[i] = h);
  return e;
}
function m3(e) {
  Wx(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), N8 === !1 && (N8 = !0, Ke.updateOffset(this), N8 = !1);
}
function E1(e) {
  return e instanceof m3 || e != null && e._isAMomentObject != null;
}
function $T(e) {
  Ke.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Ts(e, t) {
  var a = !0;
  return oh(function() {
    if (Ke.deprecationHandler != null && Ke.deprecationHandler(null, e), a) {
      var i = [], h, g, m, C = arguments.length;
      for (g = 0; g < C; g++) {
        if (h = "", typeof arguments[g] == "object") {
          h += `
[` + g + "] ";
          for (m in arguments[0])
            lr(arguments[0], m) && (h += m + ": " + arguments[0][m] + ", ");
          h = h.slice(0, -2);
        } else
          h = arguments[g];
        i.push(h);
      }
      $T(
        e + `
Arguments: ` + Array.prototype.slice.call(i).join("") + `
` + new Error().stack
      ), a = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var AR = {};
function WT(e, t) {
  Ke.deprecationHandler != null && Ke.deprecationHandler(e, t), AR[e] || ($T(t), AR[e] = !0);
}
Ke.suppressDeprecationWarnings = !1;
Ke.deprecationHandler = null;
function N0(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function n$(e) {
  var t, a;
  for (a in e)
    lr(e, a) && (t = e[a], N0(t) ? this[a] = t : this["_" + a] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function gy(e, t) {
  var a = oh({}, e), i;
  for (i in t)
    lr(t, i) && (A2(e[i]) && A2(t[i]) ? (a[i] = {}, oh(a[i], e[i]), oh(a[i], t[i])) : t[i] != null ? a[i] = t[i] : delete a[i]);
  for (i in e)
    lr(e, i) && !lr(t, i) && A2(e[i]) && (a[i] = oh({}, a[i]));
  return a;
}
function zx(e) {
  e != null && this.set(e);
}
var wy;
Object.keys ? wy = Object.keys : wy = function(e) {
  var t, a = [];
  for (t in e)
    lr(e, t) && a.push(t);
  return a;
};
var r$ = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function a$(e, t, a) {
  var i = this._calendar[e] || this._calendar.sameElse;
  return N0(i) ? i.call(t, a) : i;
}
function Z0(e, t, a) {
  var i = "" + Math.abs(e), h = t - i.length, g = e >= 0;
  return (g ? a ? "+" : "" : "-") + Math.pow(10, Math.max(0, h)).toString().substr(1) + i;
}
var qx = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, u5 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, B8 = {}, Rp = {};
function $t(e, t, a, i) {
  var h = i;
  typeof i == "string" && (h = function() {
    return this[i]();
  }), e && (Rp[e] = h), t && (Rp[t[0]] = function() {
    return Z0(h.apply(this, arguments), t[1], t[2]);
  }), a && (Rp[a] = function() {
    return this.localeData().ordinal(
      h.apply(this, arguments),
      e
    );
  });
}
function o$(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function i$(e) {
  var t = e.match(qx), a, i;
  for (a = 0, i = t.length; a < i; a++)
    Rp[t[a]] ? t[a] = Rp[t[a]] : t[a] = o$(t[a]);
  return function(h) {
    var g = "", m;
    for (m = 0; m < i; m++)
      g += N0(t[m]) ? t[m].call(h, e) : t[m];
    return g;
  };
}
function g5(e, t) {
  return e.isValid() ? (t = zT(t, e.localeData()), B8[t] = B8[t] || i$(t), B8[t](e)) : e.localeData().invalidDate();
}
function zT(e, t) {
  var a = 5;
  function i(h) {
    return t.longDateFormat(h) || h;
  }
  for (u5.lastIndex = 0; a >= 0 && u5.test(e); )
    e = e.replace(
      u5,
      i
    ), u5.lastIndex = 0, a -= 1;
  return e;
}
var l$ = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function u$(e) {
  var t = this._longDateFormat[e], a = this._longDateFormat[e.toUpperCase()];
  return t || !a ? t : (this._longDateFormat[e] = a.match(qx).map(function(i) {
    return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd" ? i.slice(1) : i;
  }).join(""), this._longDateFormat[e]);
}
var s$ = "Invalid date";
function c$() {
  return this._invalidDate;
}
var f$ = "%d", d$ = /\d{1,2}/;
function h$(e) {
  return this._ordinal.replace("%d", e);
}
var v$ = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function p$(e, t, a, i) {
  var h = this._relativeTime[a];
  return N0(h) ? h(e, t, a, i) : h.replace(/%d/i, e);
}
function m$(e, t) {
  var a = this._relativeTime[e > 0 ? "future" : "past"];
  return N0(a) ? a(t) : a.replace(/%s/i, t);
}
var A4 = {};
function Wi(e, t) {
  var a = e.toLowerCase();
  A4[a] = A4[a + "s"] = A4[t] = e;
}
function Os(e) {
  return typeof e == "string" ? A4[e] || A4[e.toLowerCase()] : void 0;
}
function Gx(e) {
  var t = {}, a, i;
  for (i in e)
    lr(e, i) && (a = Os(i), a && (t[a] = e[i]));
  return t;
}
var qT = {};
function zi(e, t) {
  qT[e] = t;
}
function g$(e) {
  var t = [], a;
  for (a in e)
    lr(e, a) && t.push({ unit: a, priority: qT[a] });
  return t.sort(function(i, h) {
    return i.priority - h.priority;
  }), t;
}
function Rw(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Es(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function bn(e) {
  var t = +e, a = 0;
  return t !== 0 && isFinite(t) && (a = Es(t)), a;
}
function Np(e, t) {
  return function(a) {
    return a != null ? (GT(this, e, a), Ke.updateOffset(this, t), this) : j5(this, e);
  };
}
function j5(e, t) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
}
function GT(e, t, a) {
  e.isValid() && !isNaN(a) && (t === "FullYear" && Rw(e.year()) && e.month() === 1 && e.date() === 29 ? (a = bn(a), e._d["set" + (e._isUTC ? "UTC" : "") + t](
    a,
    e.month(),
    jw(a, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + t](a));
}
function w$(e) {
  return e = Os(e), N0(this[e]) ? this[e]() : this;
}
function y$(e, t) {
  if (typeof e == "object") {
    e = Gx(e);
    var a = g$(e), i, h = a.length;
    for (i = 0; i < h; i++)
      this[a[i].unit](e[a[i].unit]);
  } else if (e = Os(e), N0(this[e]))
    return this[e](t);
  return this;
}
var KT = /\d/, Hu = /\d\d/, QT = /\d{3}/, Kx = /\d{4}/, Ew = /[+-]?\d{6}/, Jr = /\d\d?/, XT = /\d\d\d\d?/, JT = /\d\d\d\d\d\d?/, Mw = /\d{1,3}/, Qx = /\d{1,4}/, Tw = /[+-]?\d{1,6}/, Bp = /\d+/, Ow = /[+-]?\d+/, x$ = /Z|[+-]\d\d:?\d\d/gi, Dw = /Z|[+-]\d\d(?::?\d\d)?/gi, S$ = /[+-]?\d+(\.\d{1,3})?/, g3 = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, A5;
A5 = {};
function Rt(e, t, a) {
  A5[e] = N0(t) ? t : function(i, h) {
    return i && a ? a : t;
  };
}
function C$(e, t) {
  return lr(A5, e) ? A5[e](t._strict, t._locale) : new RegExp(b$(e));
}
function b$(e) {
  return Lu(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, a, i, h, g) {
        return a || i || h || g;
      }
    )
  );
}
function Lu(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var yy = {};
function jr(e, t) {
  var a, i = t, h;
  for (typeof e == "string" && (e = [e]), pf(t) && (i = function(g, m) {
    m[t] = bn(g);
  }), h = e.length, a = 0; a < h; a++)
    yy[e[a]] = i;
}
function w3(e, t) {
  jr(e, function(a, i, h, g) {
    h._w = h._w || {}, t(a, h._w, h, g);
  });
}
function _$(e, t, a) {
  t != null && lr(yy, e) && yy[e](t, a._a, a, e);
}
var $i = 0, sf = 1, D0 = 2, jo = 3, C1 = 4, cf = 5, j2 = 6, R$ = 7, E$ = 8;
function M$(e, t) {
  return (e % t + t) % t;
}
var Qa;
Array.prototype.indexOf ? Qa = Array.prototype.indexOf : Qa = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function jw(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var a = M$(t, 12);
  return e += (t - a) / 12, a === 1 ? Rw(e) ? 29 : 28 : 31 - a % 7 % 2;
}
$t("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
$t("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
$t("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
Wi("month", "M");
zi("month", 8);
Rt("M", Jr);
Rt("MM", Jr, Hu);
Rt("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
Rt("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
jr(["M", "MM"], function(e, t) {
  t[sf] = bn(e) - 1;
});
jr(["MMM", "MMMM"], function(e, t, a, i) {
  var h = a._locale.monthsParse(e, i, a._strict);
  h != null ? t[sf] = h : pn(a).invalidMonth = e;
});
var T$ = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), eO = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), tO = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, O$ = g3, D$ = g3;
function j$(e, t) {
  return e ? R1(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || tO).test(t) ? "format" : "standalone"][e.month()] : R1(this._months) ? this._months : this._months.standalone;
}
function A$(e, t) {
  return e ? R1(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[tO.test(t) ? "format" : "standalone"][e.month()] : R1(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function k$(e, t, a) {
  var i, h, g, m = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], i = 0; i < 12; ++i)
      g = V0([2e3, i]), this._shortMonthsParse[i] = this.monthsShort(
        g,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[i] = this.months(g, "").toLocaleLowerCase();
  return a ? t === "MMM" ? (h = Qa.call(this._shortMonthsParse, m), h !== -1 ? h : null) : (h = Qa.call(this._longMonthsParse, m), h !== -1 ? h : null) : t === "MMM" ? (h = Qa.call(this._shortMonthsParse, m), h !== -1 ? h : (h = Qa.call(this._longMonthsParse, m), h !== -1 ? h : null)) : (h = Qa.call(this._longMonthsParse, m), h !== -1 ? h : (h = Qa.call(this._shortMonthsParse, m), h !== -1 ? h : null));
}
function L$(e, t, a) {
  var i, h, g;
  if (this._monthsParseExact)
    return k$.call(this, e, t, a);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), i = 0; i < 12; i++) {
    if (h = V0([2e3, i]), a && !this._longMonthsParse[i] && (this._longMonthsParse[i] = new RegExp(
      "^" + this.months(h, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[i] = new RegExp(
      "^" + this.monthsShort(h, "").replace(".", "") + "$",
      "i"
    )), !a && !this._monthsParse[i] && (g = "^" + this.months(h, "") + "|^" + this.monthsShort(h, ""), this._monthsParse[i] = new RegExp(g.replace(".", ""), "i")), a && t === "MMMM" && this._longMonthsParse[i].test(e))
      return i;
    if (a && t === "MMM" && this._shortMonthsParse[i].test(e))
      return i;
    if (!a && this._monthsParse[i].test(e))
      return i;
  }
}
function nO(e, t) {
  var a;
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = bn(t);
    else if (t = e.localeData().monthsParse(t), !pf(t))
      return e;
  }
  return a = Math.min(e.date(), jw(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, a), e;
}
function rO(e) {
  return e != null ? (nO(this, e), Ke.updateOffset(this, !0), this) : j5(this, "Month");
}
function I$() {
  return jw(this.year(), this.month());
}
function H$(e) {
  return this._monthsParseExact ? (lr(this, "_monthsRegex") || aO.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (lr(this, "_monthsShortRegex") || (this._monthsShortRegex = O$), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function Z$(e) {
  return this._monthsParseExact ? (lr(this, "_monthsRegex") || aO.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (lr(this, "_monthsRegex") || (this._monthsRegex = D$), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function aO() {
  function e(m, C) {
    return C.length - m.length;
  }
  var t = [], a = [], i = [], h, g;
  for (h = 0; h < 12; h++)
    g = V0([2e3, h]), t.push(this.monthsShort(g, "")), a.push(this.months(g, "")), i.push(this.months(g, "")), i.push(this.monthsShort(g, ""));
  for (t.sort(e), a.sort(e), i.sort(e), h = 0; h < 12; h++)
    t[h] = Lu(t[h]), a[h] = Lu(a[h]);
  for (h = 0; h < 24; h++)
    i[h] = Lu(i[h]);
  this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
$t("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Z0(e, 4) : "+" + e;
});
$t(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
$t(0, ["YYYY", 4], 0, "year");
$t(0, ["YYYYY", 5], 0, "year");
$t(0, ["YYYYYY", 6, !0], 0, "year");
Wi("year", "y");
zi("year", 1);
Rt("Y", Ow);
Rt("YY", Jr, Hu);
Rt("YYYY", Qx, Kx);
Rt("YYYYY", Tw, Ew);
Rt("YYYYYY", Tw, Ew);
jr(["YYYYY", "YYYYYY"], $i);
jr("YYYY", function(e, t) {
  t[$i] = e.length === 2 ? Ke.parseTwoDigitYear(e) : bn(e);
});
jr("YY", function(e, t) {
  t[$i] = Ke.parseTwoDigitYear(e);
});
jr("Y", function(e, t) {
  t[$i] = parseInt(e, 10);
});
function k4(e) {
  return Rw(e) ? 366 : 365;
}
Ke.parseTwoDigitYear = function(e) {
  return bn(e) + (bn(e) > 68 ? 1900 : 2e3);
};
var oO = Np("FullYear", !0);
function P$() {
  return Rw(this.year());
}
function V$(e, t, a, i, h, g, m) {
  var C;
  return e < 100 && e >= 0 ? (C = new Date(e + 400, t, a, i, h, g, m), isFinite(C.getFullYear()) && C.setFullYear(e)) : C = new Date(e, t, a, i, h, g, m), C;
}
function B4(e) {
  var t, a;
  return e < 100 && e >= 0 ? (a = Array.prototype.slice.call(arguments), a[0] = e + 400, t = new Date(Date.UTC.apply(null, a)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function k5(e, t, a) {
  var i = 7 + t - a, h = (7 + B4(e, 0, i).getUTCDay() - t) % 7;
  return -h + i - 1;
}
function iO(e, t, a, i, h) {
  var g = (7 + a - i) % 7, m = k5(e, i, h), C = 1 + 7 * (t - 1) + g + m, S, R;
  return C <= 0 ? (S = e - 1, R = k4(S) + C) : C > k4(e) ? (S = e + 1, R = C - k4(e)) : (S = e, R = C), {
    year: S,
    dayOfYear: R
  };
}
function F4(e, t, a) {
  var i = k5(e.year(), t, a), h = Math.floor((e.dayOfYear() - i - 1) / 7) + 1, g, m;
  return h < 1 ? (m = e.year() - 1, g = h + df(m, t, a)) : h > df(e.year(), t, a) ? (g = h - df(e.year(), t, a), m = e.year() + 1) : (m = e.year(), g = h), {
    week: g,
    year: m
  };
}
function df(e, t, a) {
  var i = k5(e, t, a), h = k5(e + 1, t, a);
  return (k4(e) - i + h) / 7;
}
$t("w", ["ww", 2], "wo", "week");
$t("W", ["WW", 2], "Wo", "isoWeek");
Wi("week", "w");
Wi("isoWeek", "W");
zi("week", 5);
zi("isoWeek", 5);
Rt("w", Jr);
Rt("ww", Jr, Hu);
Rt("W", Jr);
Rt("WW", Jr, Hu);
w3(
  ["w", "ww", "W", "WW"],
  function(e, t, a, i) {
    t[i.substr(0, 1)] = bn(e);
  }
);
function N$(e) {
  return F4(e, this._week.dow, this._week.doy).week;
}
var B$ = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function F$() {
  return this._week.dow;
}
function U$() {
  return this._week.doy;
}
function Y$(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function $$(e) {
  var t = F4(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
$t("d", 0, "do", "day");
$t("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
$t("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
$t("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
$t("e", 0, 0, "weekday");
$t("E", 0, 0, "isoWeekday");
Wi("day", "d");
Wi("weekday", "e");
Wi("isoWeekday", "E");
zi("day", 11);
zi("weekday", 11);
zi("isoWeekday", 11);
Rt("d", Jr);
Rt("e", Jr);
Rt("E", Jr);
Rt("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
Rt("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
Rt("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
w3(["dd", "ddd", "dddd"], function(e, t, a, i) {
  var h = a._locale.weekdaysParse(e, i, a._strict);
  h != null ? t.d = h : pn(a).invalidWeekday = e;
});
w3(["d", "e", "E"], function(e, t, a, i) {
  t[i] = bn(e);
});
function W$(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function z$(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Xx(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var q$ = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), lO = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), G$ = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), K$ = g3, Q$ = g3, X$ = g3;
function J$(e, t) {
  var a = R1(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? Xx(a, this._week.dow) : e ? a[e.day()] : a;
}
function eW(e) {
  return e === !0 ? Xx(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function tW(e) {
  return e === !0 ? Xx(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function nW(e, t, a) {
  var i, h, g, m = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], i = 0; i < 7; ++i)
      g = V0([2e3, 1]).day(i), this._minWeekdaysParse[i] = this.weekdaysMin(
        g,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[i] = this.weekdaysShort(
        g,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[i] = this.weekdays(g, "").toLocaleLowerCase();
  return a ? t === "dddd" ? (h = Qa.call(this._weekdaysParse, m), h !== -1 ? h : null) : t === "ddd" ? (h = Qa.call(this._shortWeekdaysParse, m), h !== -1 ? h : null) : (h = Qa.call(this._minWeekdaysParse, m), h !== -1 ? h : null) : t === "dddd" ? (h = Qa.call(this._weekdaysParse, m), h !== -1 || (h = Qa.call(this._shortWeekdaysParse, m), h !== -1) ? h : (h = Qa.call(this._minWeekdaysParse, m), h !== -1 ? h : null)) : t === "ddd" ? (h = Qa.call(this._shortWeekdaysParse, m), h !== -1 || (h = Qa.call(this._weekdaysParse, m), h !== -1) ? h : (h = Qa.call(this._minWeekdaysParse, m), h !== -1 ? h : null)) : (h = Qa.call(this._minWeekdaysParse, m), h !== -1 || (h = Qa.call(this._weekdaysParse, m), h !== -1) ? h : (h = Qa.call(this._shortWeekdaysParse, m), h !== -1 ? h : null));
}
function rW(e, t, a) {
  var i, h, g;
  if (this._weekdaysParseExact)
    return nW.call(this, e, t, a);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), i = 0; i < 7; i++) {
    if (h = V0([2e3, 1]).day(i), a && !this._fullWeekdaysParse[i] && (this._fullWeekdaysParse[i] = new RegExp(
      "^" + this.weekdays(h, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysShort(h, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[i] = new RegExp(
      "^" + this.weekdaysMin(h, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[i] || (g = "^" + this.weekdays(h, "") + "|^" + this.weekdaysShort(h, "") + "|^" + this.weekdaysMin(h, ""), this._weekdaysParse[i] = new RegExp(g.replace(".", ""), "i")), a && t === "dddd" && this._fullWeekdaysParse[i].test(e))
      return i;
    if (a && t === "ddd" && this._shortWeekdaysParse[i].test(e))
      return i;
    if (a && t === "dd" && this._minWeekdaysParse[i].test(e))
      return i;
    if (!a && this._weekdaysParse[i].test(e))
      return i;
  }
}
function aW(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = W$(e, this.localeData()), this.add(e - t, "d")) : t;
}
function oW(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function iW(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = z$(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function lW(e) {
  return this._weekdaysParseExact ? (lr(this, "_weekdaysRegex") || Jx.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (lr(this, "_weekdaysRegex") || (this._weekdaysRegex = K$), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function uW(e) {
  return this._weekdaysParseExact ? (lr(this, "_weekdaysRegex") || Jx.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (lr(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Q$), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function sW(e) {
  return this._weekdaysParseExact ? (lr(this, "_weekdaysRegex") || Jx.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (lr(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = X$), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Jx() {
  function e(D, T) {
    return T.length - D.length;
  }
  var t = [], a = [], i = [], h = [], g, m, C, S, R;
  for (g = 0; g < 7; g++)
    m = V0([2e3, 1]).day(g), C = Lu(this.weekdaysMin(m, "")), S = Lu(this.weekdaysShort(m, "")), R = Lu(this.weekdays(m, "")), t.push(C), a.push(S), i.push(R), h.push(C), h.push(S), h.push(R);
  t.sort(e), a.sort(e), i.sort(e), h.sort(e), this._weekdaysRegex = new RegExp("^(" + h.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function eS() {
  return this.hours() % 12 || 12;
}
function cW() {
  return this.hours() || 24;
}
$t("H", ["HH", 2], 0, "hour");
$t("h", ["hh", 2], 0, eS);
$t("k", ["kk", 2], 0, cW);
$t("hmm", 0, 0, function() {
  return "" + eS.apply(this) + Z0(this.minutes(), 2);
});
$t("hmmss", 0, 0, function() {
  return "" + eS.apply(this) + Z0(this.minutes(), 2) + Z0(this.seconds(), 2);
});
$t("Hmm", 0, 0, function() {
  return "" + this.hours() + Z0(this.minutes(), 2);
});
$t("Hmmss", 0, 0, function() {
  return "" + this.hours() + Z0(this.minutes(), 2) + Z0(this.seconds(), 2);
});
function uO(e, t) {
  $t(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
uO("a", !0);
uO("A", !1);
Wi("hour", "h");
zi("hour", 13);
function sO(e, t) {
  return t._meridiemParse;
}
Rt("a", sO);
Rt("A", sO);
Rt("H", Jr);
Rt("h", Jr);
Rt("k", Jr);
Rt("HH", Jr, Hu);
Rt("hh", Jr, Hu);
Rt("kk", Jr, Hu);
Rt("hmm", XT);
Rt("hmmss", JT);
Rt("Hmm", XT);
Rt("Hmmss", JT);
jr(["H", "HH"], jo);
jr(["k", "kk"], function(e, t, a) {
  var i = bn(e);
  t[jo] = i === 24 ? 0 : i;
});
jr(["a", "A"], function(e, t, a) {
  a._isPm = a._locale.isPM(e), a._meridiem = e;
});
jr(["h", "hh"], function(e, t, a) {
  t[jo] = bn(e), pn(a).bigHour = !0;
});
jr("hmm", function(e, t, a) {
  var i = e.length - 2;
  t[jo] = bn(e.substr(0, i)), t[C1] = bn(e.substr(i)), pn(a).bigHour = !0;
});
jr("hmmss", function(e, t, a) {
  var i = e.length - 4, h = e.length - 2;
  t[jo] = bn(e.substr(0, i)), t[C1] = bn(e.substr(i, 2)), t[cf] = bn(e.substr(h)), pn(a).bigHour = !0;
});
jr("Hmm", function(e, t, a) {
  var i = e.length - 2;
  t[jo] = bn(e.substr(0, i)), t[C1] = bn(e.substr(i));
});
jr("Hmmss", function(e, t, a) {
  var i = e.length - 4, h = e.length - 2;
  t[jo] = bn(e.substr(0, i)), t[C1] = bn(e.substr(i, 2)), t[cf] = bn(e.substr(h));
});
function fW(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var dW = /[ap]\.?m?\.?/i, hW = Np("Hours", !0);
function vW(e, t, a) {
  return e > 11 ? a ? "pm" : "PM" : a ? "am" : "AM";
}
var cO = {
  calendar: r$,
  longDateFormat: l$,
  invalidDate: s$,
  ordinal: f$,
  dayOfMonthOrdinalParse: d$,
  relativeTime: v$,
  months: T$,
  monthsShort: eO,
  week: B$,
  weekdays: q$,
  weekdaysMin: G$,
  weekdaysShort: lO,
  meridiemParse: dW
}, fa = {}, R4 = {}, U4;
function pW(e, t) {
  var a, i = Math.min(e.length, t.length);
  for (a = 0; a < i; a += 1)
    if (e[a] !== t[a])
      return a;
  return i;
}
function kR(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function mW(e) {
  for (var t = 0, a, i, h, g; t < e.length; ) {
    for (g = kR(e[t]).split("-"), a = g.length, i = kR(e[t + 1]), i = i ? i.split("-") : null; a > 0; ) {
      if (h = Aw(g.slice(0, a).join("-")), h)
        return h;
      if (i && i.length >= a && pW(g, i) >= a - 1)
        break;
      a--;
    }
    t++;
  }
  return U4;
}
function gW(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function Aw(e) {
  var t = null, a;
  if (fa[e] === void 0 && typeof module < "u" && module && module.exports && gW(e))
    try {
      t = U4._abbr, a = require, a("./locale/" + e), sh(t);
    } catch {
      fa[e] = null;
    }
  return fa[e];
}
function sh(e, t) {
  var a;
  return e && (Ql(t) ? a = Sf(e) : a = tS(e, t), a ? U4 = a : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), U4._abbr;
}
function tS(e, t) {
  if (t !== null) {
    var a, i = cO;
    if (t.abbr = e, fa[e] != null)
      WT(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), i = fa[e]._config;
    else if (t.parentLocale != null)
      if (fa[t.parentLocale] != null)
        i = fa[t.parentLocale]._config;
      else if (a = Aw(t.parentLocale), a != null)
        i = a._config;
      else
        return R4[t.parentLocale] || (R4[t.parentLocale] = []), R4[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return fa[e] = new zx(gy(i, t)), R4[e] && R4[e].forEach(function(h) {
      tS(h.name, h.config);
    }), sh(e), fa[e];
  } else
    return delete fa[e], null;
}
function wW(e, t) {
  if (t != null) {
    var a, i, h = cO;
    fa[e] != null && fa[e].parentLocale != null ? fa[e].set(gy(fa[e]._config, t)) : (i = Aw(e), i != null && (h = i._config), t = gy(h, t), i == null && (t.abbr = e), a = new zx(t), a.parentLocale = fa[e], fa[e] = a), sh(e);
  } else
    fa[e] != null && (fa[e].parentLocale != null ? (fa[e] = fa[e].parentLocale, e === sh() && sh(e)) : fa[e] != null && delete fa[e]);
  return fa[e];
}
function Sf(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return U4;
  if (!R1(e)) {
    if (t = Aw(e), t)
      return t;
    e = [e];
  }
  return mW(e);
}
function yW() {
  return wy(fa);
}
function nS(e) {
  var t, a = e._a;
  return a && pn(e).overflow === -2 && (t = a[sf] < 0 || a[sf] > 11 ? sf : a[D0] < 1 || a[D0] > jw(a[$i], a[sf]) ? D0 : a[jo] < 0 || a[jo] > 24 || a[jo] === 24 && (a[C1] !== 0 || a[cf] !== 0 || a[j2] !== 0) ? jo : a[C1] < 0 || a[C1] > 59 ? C1 : a[cf] < 0 || a[cf] > 59 ? cf : a[j2] < 0 || a[j2] > 999 ? j2 : -1, pn(e)._overflowDayOfYear && (t < $i || t > D0) && (t = D0), pn(e)._overflowWeeks && t === -1 && (t = R$), pn(e)._overflowWeekday && t === -1 && (t = E$), pn(e).overflow = t), e;
}
var xW = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, SW = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, CW = /Z|[+-]\d\d(?::?\d\d)?/, s5 = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], F8 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], bW = /^\/?Date\((-?\d+)/i, _W = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, RW = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fO(e) {
  var t, a, i = e._i, h = xW.exec(i) || SW.exec(i), g, m, C, S, R = s5.length, D = F8.length;
  if (h) {
    for (pn(e).iso = !0, t = 0, a = R; t < a; t++)
      if (s5[t][1].exec(h[1])) {
        m = s5[t][0], g = s5[t][2] !== !1;
        break;
      }
    if (m == null) {
      e._isValid = !1;
      return;
    }
    if (h[3]) {
      for (t = 0, a = D; t < a; t++)
        if (F8[t][1].exec(h[3])) {
          C = (h[2] || " ") + F8[t][0];
          break;
        }
      if (C == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!g && C != null) {
      e._isValid = !1;
      return;
    }
    if (h[4])
      if (CW.exec(h[4]))
        S = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = m + (C || "") + (S || ""), aS(e);
  } else
    e._isValid = !1;
}
function EW(e, t, a, i, h, g) {
  var m = [
    MW(e),
    eO.indexOf(t),
    parseInt(a, 10),
    parseInt(i, 10),
    parseInt(h, 10)
  ];
  return g && m.push(parseInt(g, 10)), m;
}
function MW(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function TW(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function OW(e, t, a) {
  if (e) {
    var i = lO.indexOf(e), h = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (i !== h)
      return pn(a).weekdayMismatch = !0, a._isValid = !1, !1;
  }
  return !0;
}
function DW(e, t, a) {
  if (e)
    return RW[e];
  if (t)
    return 0;
  var i = parseInt(a, 10), h = i % 100, g = (i - h) / 100;
  return g * 60 + h;
}
function dO(e) {
  var t = _W.exec(TW(e._i)), a;
  if (t) {
    if (a = EW(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !OW(t[1], a, e))
      return;
    e._a = a, e._tzm = DW(t[8], t[9], t[10]), e._d = B4.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), pn(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function jW(e) {
  var t = bW.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (fO(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (dO(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Ke.createFromInputFallback(e);
}
Ke.createFromInputFallback = Ts(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function wp(e, t, a) {
  return e ?? t ?? a;
}
function AW(e) {
  var t = new Date(Ke.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function rS(e) {
  var t, a, i = [], h, g, m;
  if (!e._d) {
    for (h = AW(e), e._w && e._a[D0] == null && e._a[sf] == null && kW(e), e._dayOfYear != null && (m = wp(e._a[$i], h[$i]), (e._dayOfYear > k4(m) || e._dayOfYear === 0) && (pn(e)._overflowDayOfYear = !0), a = B4(m, 0, e._dayOfYear), e._a[sf] = a.getUTCMonth(), e._a[D0] = a.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = i[t] = h[t];
    for (; t < 7; t++)
      e._a[t] = i[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[jo] === 24 && e._a[C1] === 0 && e._a[cf] === 0 && e._a[j2] === 0 && (e._nextDay = !0, e._a[jo] = 0), e._d = (e._useUTC ? B4 : V$).apply(
      null,
      i
    ), g = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[jo] = 24), e._w && typeof e._w.d < "u" && e._w.d !== g && (pn(e).weekdayMismatch = !0);
  }
}
function kW(e) {
  var t, a, i, h, g, m, C, S, R;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (g = 1, m = 4, a = wp(
    t.GG,
    e._a[$i],
    F4(Xr(), 1, 4).year
  ), i = wp(t.W, 1), h = wp(t.E, 1), (h < 1 || h > 7) && (S = !0)) : (g = e._locale._week.dow, m = e._locale._week.doy, R = F4(Xr(), g, m), a = wp(t.gg, e._a[$i], R.year), i = wp(t.w, R.week), t.d != null ? (h = t.d, (h < 0 || h > 6) && (S = !0)) : t.e != null ? (h = t.e + g, (t.e < 0 || t.e > 6) && (S = !0)) : h = g), i < 1 || i > df(a, g, m) ? pn(e)._overflowWeeks = !0 : S != null ? pn(e)._overflowWeekday = !0 : (C = iO(a, i, h, g, m), e._a[$i] = C.year, e._dayOfYear = C.dayOfYear);
}
Ke.ISO_8601 = function() {
};
Ke.RFC_2822 = function() {
};
function aS(e) {
  if (e._f === Ke.ISO_8601) {
    fO(e);
    return;
  }
  if (e._f === Ke.RFC_2822) {
    dO(e);
    return;
  }
  e._a = [], pn(e).empty = !0;
  var t = "" + e._i, a, i, h, g, m, C = t.length, S = 0, R, D;
  for (h = zT(e._f, e._locale).match(qx) || [], D = h.length, a = 0; a < D; a++)
    g = h[a], i = (t.match(C$(g, e)) || [])[0], i && (m = t.substr(0, t.indexOf(i)), m.length > 0 && pn(e).unusedInput.push(m), t = t.slice(
      t.indexOf(i) + i.length
    ), S += i.length), Rp[g] ? (i ? pn(e).empty = !1 : pn(e).unusedTokens.push(g), _$(g, i, e)) : e._strict && !i && pn(e).unusedTokens.push(g);
  pn(e).charsLeftOver = C - S, t.length > 0 && pn(e).unusedInput.push(t), e._a[jo] <= 12 && pn(e).bigHour === !0 && e._a[jo] > 0 && (pn(e).bigHour = void 0), pn(e).parsedDateParts = e._a.slice(0), pn(e).meridiem = e._meridiem, e._a[jo] = LW(
    e._locale,
    e._a[jo],
    e._meridiem
  ), R = pn(e).era, R !== null && (e._a[$i] = e._locale.erasConvertYear(R, e._a[$i])), rS(e), nS(e);
}
function LW(e, t, a) {
  var i;
  return a == null ? t : e.meridiemHour != null ? e.meridiemHour(t, a) : (e.isPM != null && (i = e.isPM(a), i && t < 12 && (t += 12), !i && t === 12 && (t = 0)), t);
}
function IW(e) {
  var t, a, i, h, g, m, C = !1, S = e._f.length;
  if (S === 0) {
    pn(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (h = 0; h < S; h++)
    g = 0, m = !1, t = Wx({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[h], aS(t), $x(t) && (m = !0), g += pn(t).charsLeftOver, g += pn(t).unusedTokens.length * 10, pn(t).score = g, C ? g < i && (i = g, a = t) : (i == null || g < i || m) && (i = g, a = t, m && (C = !0));
  oh(e, a || t);
}
function HW(e) {
  if (!e._d) {
    var t = Gx(e._i), a = t.day === void 0 ? t.date : t.day;
    e._a = YT(
      [t.year, t.month, a, t.hour, t.minute, t.second, t.millisecond],
      function(i) {
        return i && parseInt(i, 10);
      }
    ), rS(e);
  }
}
function ZW(e) {
  var t = new m3(nS(hO(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function hO(e) {
  var t = e._i, a = e._f;
  return e._locale = e._locale || Sf(e._l), t === null || a === void 0 && t === "" ? _w({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), E1(t) ? new m3(nS(t)) : (p3(t) ? e._d = t : R1(a) ? IW(e) : a ? aS(e) : PW(e), $x(e) || (e._d = null), e));
}
function PW(e) {
  var t = e._i;
  Ql(t) ? e._d = new Date(Ke.now()) : p3(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? jW(e) : R1(t) ? (e._a = YT(t.slice(0), function(a) {
    return parseInt(a, 10);
  }), rS(e)) : A2(t) ? HW(e) : pf(t) ? e._d = new Date(t) : Ke.createFromInputFallback(e);
}
function vO(e, t, a, i, h) {
  var g = {};
  return (t === !0 || t === !1) && (i = t, t = void 0), (a === !0 || a === !1) && (i = a, a = void 0), (A2(e) && Yx(e) || R1(e) && e.length === 0) && (e = void 0), g._isAMomentObject = !0, g._useUTC = g._isUTC = h, g._l = a, g._i = e, g._f = t, g._strict = i, ZW(g);
}
function Xr(e, t, a, i) {
  return vO(e, t, a, i, !1);
}
var VW = Ts(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Xr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : _w();
  }
), NW = Ts(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Xr.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : _w();
  }
);
function pO(e, t) {
  var a, i;
  if (t.length === 1 && R1(t[0]) && (t = t[0]), !t.length)
    return Xr();
  for (a = t[0], i = 1; i < t.length; ++i)
    (!t[i].isValid() || t[i][e](a)) && (a = t[i]);
  return a;
}
function BW() {
  var e = [].slice.call(arguments, 0);
  return pO("isBefore", e);
}
function FW() {
  var e = [].slice.call(arguments, 0);
  return pO("isAfter", e);
}
var UW = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, E4 = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function YW(e) {
  var t, a = !1, i, h = E4.length;
  for (t in e)
    if (lr(e, t) && !(Qa.call(E4, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (i = 0; i < h; ++i)
    if (e[E4[i]]) {
      if (a)
        return !1;
      parseFloat(e[E4[i]]) !== bn(e[E4[i]]) && (a = !0);
    }
  return !0;
}
function $W() {
  return this._isValid;
}
function WW() {
  return M1(NaN);
}
function kw(e) {
  var t = Gx(e), a = t.year || 0, i = t.quarter || 0, h = t.month || 0, g = t.week || t.isoWeek || 0, m = t.day || 0, C = t.hour || 0, S = t.minute || 0, R = t.second || 0, D = t.millisecond || 0;
  this._isValid = YW(t), this._milliseconds = +D + R * 1e3 + // 1000
  S * 6e4 + // 1000 * 60
  C * 1e3 * 60 * 60, this._days = +m + g * 7, this._months = +h + i * 3 + a * 12, this._data = {}, this._locale = Sf(), this._bubble();
}
function w5(e) {
  return e instanceof kw;
}
function xy(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function zW(e, t, a) {
  var i = Math.min(e.length, t.length), h = Math.abs(e.length - t.length), g = 0, m;
  for (m = 0; m < i; m++)
    bn(e[m]) !== bn(t[m]) && g++;
  return g + h;
}
function mO(e, t) {
  $t(e, 0, 0, function() {
    var a = this.utcOffset(), i = "+";
    return a < 0 && (a = -a, i = "-"), i + Z0(~~(a / 60), 2) + t + Z0(~~a % 60, 2);
  });
}
mO("Z", ":");
mO("ZZ", "");
Rt("Z", Dw);
Rt("ZZ", Dw);
jr(["Z", "ZZ"], function(e, t, a) {
  a._useUTC = !0, a._tzm = oS(Dw, e);
});
var qW = /([\+\-]|\d\d)/gi;
function oS(e, t) {
  var a = (t || "").match(e), i, h, g;
  return a === null ? null : (i = a[a.length - 1] || [], h = (i + "").match(qW) || ["-", 0, 0], g = +(h[1] * 60) + bn(h[2]), g === 0 ? 0 : h[0] === "+" ? g : -g);
}
function iS(e, t) {
  var a, i;
  return t._isUTC ? (a = t.clone(), i = (E1(e) || p3(e) ? e.valueOf() : Xr(e).valueOf()) - a.valueOf(), a._d.setTime(a._d.valueOf() + i), Ke.updateOffset(a, !1), a) : Xr(e).local();
}
function Sy(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Ke.updateOffset = function() {
};
function GW(e, t, a) {
  var i = this._offset || 0, h;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = oS(Dw, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !a && (e = e * 60);
    return !this._isUTC && t && (h = Sy(this)), this._offset = e, this._isUTC = !0, h != null && this.add(h, "m"), i !== e && (!t || this._changeInProgress ? yO(
      this,
      M1(e - i, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Ke.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? i : Sy(this);
}
function KW(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function QW(e) {
  return this.utcOffset(0, e);
}
function XW(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Sy(this), "m")), this;
}
function JW() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = oS(x$, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function ez(e) {
  return this.isValid() ? (e = e ? Xr(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function tz() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function nz() {
  if (!Ql(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return Wx(e, this), e = hO(e), e._a ? (t = e._isUTC ? V0(e._a) : Xr(e._a), this._isDSTShifted = this.isValid() && zW(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function rz() {
  return this.isValid() ? !this._isUTC : !1;
}
function az() {
  return this.isValid() ? this._isUTC : !1;
}
function gO() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var oz = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, iz = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function M1(e, t) {
  var a = e, i = null, h, g, m;
  return w5(e) ? a = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : pf(e) || !isNaN(+e) ? (a = {}, t ? a[t] = +e : a.milliseconds = +e) : (i = oz.exec(e)) ? (h = i[1] === "-" ? -1 : 1, a = {
    y: 0,
    d: bn(i[D0]) * h,
    h: bn(i[jo]) * h,
    m: bn(i[C1]) * h,
    s: bn(i[cf]) * h,
    ms: bn(xy(i[j2] * 1e3)) * h
    // the millisecond decimal point is included in the match
  }) : (i = iz.exec(e)) ? (h = i[1] === "-" ? -1 : 1, a = {
    y: O2(i[2], h),
    M: O2(i[3], h),
    w: O2(i[4], h),
    d: O2(i[5], h),
    h: O2(i[6], h),
    m: O2(i[7], h),
    s: O2(i[8], h)
  }) : a == null ? a = {} : typeof a == "object" && ("from" in a || "to" in a) && (m = lz(
    Xr(a.from),
    Xr(a.to)
  ), a = {}, a.ms = m.milliseconds, a.M = m.months), g = new kw(a), w5(e) && lr(e, "_locale") && (g._locale = e._locale), w5(e) && lr(e, "_isValid") && (g._isValid = e._isValid), g;
}
M1.fn = kw.prototype;
M1.invalid = WW;
function O2(e, t) {
  var a = e && parseFloat(e.replace(",", "."));
  return (isNaN(a) ? 0 : a) * t;
}
function LR(e, t) {
  var a = {};
  return a.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(a.months, "M").isAfter(t) && --a.months, a.milliseconds = +t - +e.clone().add(a.months, "M"), a;
}
function lz(e, t) {
  var a;
  return e.isValid() && t.isValid() ? (t = iS(t, e), e.isBefore(t) ? a = LR(e, t) : (a = LR(t, e), a.milliseconds = -a.milliseconds, a.months = -a.months), a) : { milliseconds: 0, months: 0 };
}
function wO(e, t) {
  return function(a, i) {
    var h, g;
    return i !== null && !isNaN(+i) && (WT(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), g = a, a = i, i = g), h = M1(a, i), yO(this, h, e), this;
  };
}
function yO(e, t, a, i) {
  var h = t._milliseconds, g = xy(t._days), m = xy(t._months);
  e.isValid() && (i = i ?? !0, m && nO(e, j5(e, "Month") + m * a), g && GT(e, "Date", j5(e, "Date") + g * a), h && e._d.setTime(e._d.valueOf() + h * a), i && Ke.updateOffset(e, g || m));
}
var uz = wO(1, "add"), sz = wO(-1, "subtract");
function xO(e) {
  return typeof e == "string" || e instanceof String;
}
function cz(e) {
  return E1(e) || p3(e) || xO(e) || pf(e) || dz(e) || fz(e) || e === null || e === void 0;
}
function fz(e) {
  var t = A2(e) && !Yx(e), a = !1, i = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], h, g, m = i.length;
  for (h = 0; h < m; h += 1)
    g = i[h], a = a || lr(e, g);
  return t && a;
}
function dz(e) {
  var t = R1(e), a = !1;
  return t && (a = e.filter(function(i) {
    return !pf(i) && xO(e);
  }).length === 0), t && a;
}
function hz(e) {
  var t = A2(e) && !Yx(e), a = !1, i = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], h, g;
  for (h = 0; h < i.length; h += 1)
    g = i[h], a = a || lr(e, g);
  return t && a;
}
function vz(e, t) {
  var a = e.diff(t, "days", !0);
  return a < -6 ? "sameElse" : a < -1 ? "lastWeek" : a < 0 ? "lastDay" : a < 1 ? "sameDay" : a < 2 ? "nextDay" : a < 7 ? "nextWeek" : "sameElse";
}
function pz(e, t) {
  arguments.length === 1 && (arguments[0] ? cz(arguments[0]) ? (e = arguments[0], t = void 0) : hz(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var a = e || Xr(), i = iS(a, this).startOf("day"), h = Ke.calendarFormat(this, i) || "sameElse", g = t && (N0(t[h]) ? t[h].call(this, a) : t[h]);
  return this.format(
    g || this.localeData().calendar(h, this, Xr(a))
  );
}
function mz() {
  return new m3(this);
}
function gz(e, t) {
  var a = E1(e) ? e : Xr(e);
  return this.isValid() && a.isValid() ? (t = Os(t) || "millisecond", t === "millisecond" ? this.valueOf() > a.valueOf() : a.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function wz(e, t) {
  var a = E1(e) ? e : Xr(e);
  return this.isValid() && a.isValid() ? (t = Os(t) || "millisecond", t === "millisecond" ? this.valueOf() < a.valueOf() : this.clone().endOf(t).valueOf() < a.valueOf()) : !1;
}
function yz(e, t, a, i) {
  var h = E1(e) ? e : Xr(e), g = E1(t) ? t : Xr(t);
  return this.isValid() && h.isValid() && g.isValid() ? (i = i || "()", (i[0] === "(" ? this.isAfter(h, a) : !this.isBefore(h, a)) && (i[1] === ")" ? this.isBefore(g, a) : !this.isAfter(g, a))) : !1;
}
function xz(e, t) {
  var a = E1(e) ? e : Xr(e), i;
  return this.isValid() && a.isValid() ? (t = Os(t) || "millisecond", t === "millisecond" ? this.valueOf() === a.valueOf() : (i = a.valueOf(), this.clone().startOf(t).valueOf() <= i && i <= this.clone().endOf(t).valueOf())) : !1;
}
function Sz(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Cz(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function bz(e, t, a) {
  var i, h, g;
  if (!this.isValid())
    return NaN;
  if (i = iS(e, this), !i.isValid())
    return NaN;
  switch (h = (i.utcOffset() - this.utcOffset()) * 6e4, t = Os(t), t) {
    case "year":
      g = y5(this, i) / 12;
      break;
    case "month":
      g = y5(this, i);
      break;
    case "quarter":
      g = y5(this, i) / 3;
      break;
    case "second":
      g = (this - i) / 1e3;
      break;
    case "minute":
      g = (this - i) / 6e4;
      break;
    case "hour":
      g = (this - i) / 36e5;
      break;
    case "day":
      g = (this - i - h) / 864e5;
      break;
    case "week":
      g = (this - i - h) / 6048e5;
      break;
    default:
      g = this - i;
  }
  return a ? g : Es(g);
}
function y5(e, t) {
  if (e.date() < t.date())
    return -y5(t, e);
  var a = (t.year() - e.year()) * 12 + (t.month() - e.month()), i = e.clone().add(a, "months"), h, g;
  return t - i < 0 ? (h = e.clone().add(a - 1, "months"), g = (t - i) / (i - h)) : (h = e.clone().add(a + 1, "months"), g = (t - i) / (h - i)), -(a + g) || 0;
}
Ke.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Ke.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function _z() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function Rz(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, a = t ? this.clone().utc() : this;
  return a.year() < 0 || a.year() > 9999 ? g5(
    a,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : N0(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", g5(a, "Z")) : g5(
    a,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Ez() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", a, i, h, g;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), a = "[" + e + '("]', i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", h = "-MM-DD[T]HH:mm:ss.SSS", g = t + '[")]', this.format(a + i + h + g);
}
function Mz(e) {
  e || (e = this.isUtc() ? Ke.defaultFormatUtc : Ke.defaultFormat);
  var t = g5(this, e);
  return this.localeData().postformat(t);
}
function Tz(e, t) {
  return this.isValid() && (E1(e) && e.isValid() || Xr(e).isValid()) ? M1({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Oz(e) {
  return this.from(Xr(), e);
}
function Dz(e, t) {
  return this.isValid() && (E1(e) && e.isValid() || Xr(e).isValid()) ? M1({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function jz(e) {
  return this.to(Xr(), e);
}
function SO(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = Sf(e), t != null && (this._locale = t), this);
}
var CO = Ts(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function bO() {
  return this._locale;
}
var L5 = 1e3, Ep = 60 * L5, I5 = 60 * Ep, _O = (365 * 400 + 97) * 24 * I5;
function Mp(e, t) {
  return (e % t + t) % t;
}
function RO(e, t, a) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, a) - _O : new Date(e, t, a).valueOf();
}
function EO(e, t, a) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, a) - _O : Date.UTC(e, t, a);
}
function Az(e) {
  var t, a;
  if (e = Os(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (a = this._isUTC ? EO : RO, e) {
    case "year":
      t = a(this.year(), 0, 1);
      break;
    case "quarter":
      t = a(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = a(this.year(), this.month(), 1);
      break;
    case "week":
      t = a(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = a(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = a(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Mp(
        t + (this._isUTC ? 0 : this.utcOffset() * Ep),
        I5
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Mp(t, Ep);
      break;
    case "second":
      t = this._d.valueOf(), t -= Mp(t, L5);
      break;
  }
  return this._d.setTime(t), Ke.updateOffset(this, !0), this;
}
function kz(e) {
  var t, a;
  if (e = Os(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (a = this._isUTC ? EO : RO, e) {
    case "year":
      t = a(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = a(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = a(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = a(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = a(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = a(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += I5 - Mp(
        t + (this._isUTC ? 0 : this.utcOffset() * Ep),
        I5
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Ep - Mp(t, Ep) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += L5 - Mp(t, L5) - 1;
      break;
  }
  return this._d.setTime(t), Ke.updateOffset(this, !0), this;
}
function Lz() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function Iz() {
  return Math.floor(this.valueOf() / 1e3);
}
function Hz() {
  return new Date(this.valueOf());
}
function Zz() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function Pz() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function Vz() {
  return this.isValid() ? this.toISOString() : null;
}
function Nz() {
  return $x(this);
}
function Bz() {
  return oh({}, pn(this));
}
function Fz() {
  return pn(this).overflow;
}
function Uz() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
$t("N", 0, 0, "eraAbbr");
$t("NN", 0, 0, "eraAbbr");
$t("NNN", 0, 0, "eraAbbr");
$t("NNNN", 0, 0, "eraName");
$t("NNNNN", 0, 0, "eraNarrow");
$t("y", ["y", 1], "yo", "eraYear");
$t("y", ["yy", 2], 0, "eraYear");
$t("y", ["yyy", 3], 0, "eraYear");
$t("y", ["yyyy", 4], 0, "eraYear");
Rt("N", lS);
Rt("NN", lS);
Rt("NNN", lS);
Rt("NNNN", eq);
Rt("NNNNN", tq);
jr(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, a, i) {
    var h = a._locale.erasParse(e, i, a._strict);
    h ? pn(a).era = h : pn(a).invalidEra = e;
  }
);
Rt("y", Bp);
Rt("yy", Bp);
Rt("yyy", Bp);
Rt("yyyy", Bp);
Rt("yo", nq);
jr(["y", "yy", "yyy", "yyyy"], $i);
jr(["yo"], function(e, t, a, i) {
  var h;
  a._locale._eraYearOrdinalRegex && (h = e.match(a._locale._eraYearOrdinalRegex)), a._locale.eraYearOrdinalParse ? t[$i] = a._locale.eraYearOrdinalParse(e, h) : t[$i] = parseInt(e, 10);
});
function Yz(e, t) {
  var a, i, h, g = this._eras || Sf("en")._eras;
  for (a = 0, i = g.length; a < i; ++a) {
    switch (typeof g[a].since) {
      case "string":
        h = Ke(g[a].since).startOf("day"), g[a].since = h.valueOf();
        break;
    }
    switch (typeof g[a].until) {
      case "undefined":
        g[a].until = 1 / 0;
        break;
      case "string":
        h = Ke(g[a].until).startOf("day").valueOf(), g[a].until = h.valueOf();
        break;
    }
  }
  return g;
}
function $z(e, t, a) {
  var i, h, g = this.eras(), m, C, S;
  for (e = e.toUpperCase(), i = 0, h = g.length; i < h; ++i)
    if (m = g[i].name.toUpperCase(), C = g[i].abbr.toUpperCase(), S = g[i].narrow.toUpperCase(), a)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (C === e)
            return g[i];
          break;
        case "NNNN":
          if (m === e)
            return g[i];
          break;
        case "NNNNN":
          if (S === e)
            return g[i];
          break;
      }
    else if ([m, C, S].indexOf(e) >= 0)
      return g[i];
}
function Wz(e, t) {
  var a = e.since <= e.until ? 1 : -1;
  return t === void 0 ? Ke(e.since).year() : Ke(e.since).year() + (t - e.offset) * a;
}
function zz() {
  var e, t, a, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (a = this.clone().startOf("day").valueOf(), i[e].since <= a && a <= i[e].until || i[e].until <= a && a <= i[e].since)
      return i[e].name;
  return "";
}
function qz() {
  var e, t, a, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (a = this.clone().startOf("day").valueOf(), i[e].since <= a && a <= i[e].until || i[e].until <= a && a <= i[e].since)
      return i[e].narrow;
  return "";
}
function Gz() {
  var e, t, a, i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (a = this.clone().startOf("day").valueOf(), i[e].since <= a && a <= i[e].until || i[e].until <= a && a <= i[e].since)
      return i[e].abbr;
  return "";
}
function Kz() {
  var e, t, a, i, h = this.localeData().eras();
  for (e = 0, t = h.length; e < t; ++e)
    if (a = h[e].since <= h[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), h[e].since <= i && i <= h[e].until || h[e].until <= i && i <= h[e].since)
      return (this.year() - Ke(h[e].since).year()) * a + h[e].offset;
  return this.year();
}
function Qz(e) {
  return lr(this, "_erasNameRegex") || uS.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Xz(e) {
  return lr(this, "_erasAbbrRegex") || uS.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Jz(e) {
  return lr(this, "_erasNarrowRegex") || uS.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function lS(e, t) {
  return t.erasAbbrRegex(e);
}
function eq(e, t) {
  return t.erasNameRegex(e);
}
function tq(e, t) {
  return t.erasNarrowRegex(e);
}
function nq(e, t) {
  return t._eraYearOrdinalRegex || Bp;
}
function uS() {
  var e = [], t = [], a = [], i = [], h, g, m = this.eras();
  for (h = 0, g = m.length; h < g; ++h)
    t.push(Lu(m[h].name)), e.push(Lu(m[h].abbr)), a.push(Lu(m[h].narrow)), i.push(Lu(m[h].name)), i.push(Lu(m[h].abbr)), i.push(Lu(m[h].narrow));
  this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  );
}
$t(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
$t(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Lw(e, t) {
  $t(0, [e, e.length], 0, t);
}
Lw("gggg", "weekYear");
Lw("ggggg", "weekYear");
Lw("GGGG", "isoWeekYear");
Lw("GGGGG", "isoWeekYear");
Wi("weekYear", "gg");
Wi("isoWeekYear", "GG");
zi("weekYear", 1);
zi("isoWeekYear", 1);
Rt("G", Ow);
Rt("g", Ow);
Rt("GG", Jr, Hu);
Rt("gg", Jr, Hu);
Rt("GGGG", Qx, Kx);
Rt("gggg", Qx, Kx);
Rt("GGGGG", Tw, Ew);
Rt("ggggg", Tw, Ew);
w3(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, a, i) {
    t[i.substr(0, 2)] = bn(e);
  }
);
w3(["gg", "GG"], function(e, t, a, i) {
  t[i] = Ke.parseTwoDigitYear(e);
});
function rq(e) {
  return MO.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function aq(e) {
  return MO.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function oq() {
  return df(this.year(), 1, 4);
}
function iq() {
  return df(this.isoWeekYear(), 1, 4);
}
function lq() {
  var e = this.localeData()._week;
  return df(this.year(), e.dow, e.doy);
}
function uq() {
  var e = this.localeData()._week;
  return df(this.weekYear(), e.dow, e.doy);
}
function MO(e, t, a, i, h) {
  var g;
  return e == null ? F4(this, i, h).year : (g = df(e, i, h), t > g && (t = g), sq.call(this, e, t, a, i, h));
}
function sq(e, t, a, i, h) {
  var g = iO(e, t, a, i, h), m = B4(g.year, 0, g.dayOfYear);
  return this.year(m.getUTCFullYear()), this.month(m.getUTCMonth()), this.date(m.getUTCDate()), this;
}
$t("Q", 0, "Qo", "quarter");
Wi("quarter", "Q");
zi("quarter", 7);
Rt("Q", KT);
jr("Q", function(e, t) {
  t[sf] = (bn(e) - 1) * 3;
});
function cq(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
$t("D", ["DD", 2], "Do", "date");
Wi("date", "D");
zi("date", 9);
Rt("D", Jr);
Rt("DD", Jr, Hu);
Rt("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
jr(["D", "DD"], D0);
jr("Do", function(e, t) {
  t[D0] = bn(e.match(Jr)[0]);
});
var TO = Np("Date", !0);
$t("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
Wi("dayOfYear", "DDD");
zi("dayOfYear", 4);
Rt("DDD", Mw);
Rt("DDDD", QT);
jr(["DDD", "DDDD"], function(e, t, a) {
  a._dayOfYear = bn(e);
});
function fq(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
$t("m", ["mm", 2], 0, "minute");
Wi("minute", "m");
zi("minute", 14);
Rt("m", Jr);
Rt("mm", Jr, Hu);
jr(["m", "mm"], C1);
var dq = Np("Minutes", !1);
$t("s", ["ss", 2], 0, "second");
Wi("second", "s");
zi("second", 15);
Rt("s", Jr);
Rt("ss", Jr, Hu);
jr(["s", "ss"], cf);
var hq = Np("Seconds", !1);
$t("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
$t(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
$t(0, ["SSS", 3], 0, "millisecond");
$t(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
$t(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
$t(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
$t(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
$t(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
$t(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
Wi("millisecond", "ms");
zi("millisecond", 16);
Rt("S", Mw, KT);
Rt("SS", Mw, Hu);
Rt("SSS", Mw, QT);
var ih, OO;
for (ih = "SSSS"; ih.length <= 9; ih += "S")
  Rt(ih, Bp);
function vq(e, t) {
  t[j2] = bn(("0." + e) * 1e3);
}
for (ih = "S"; ih.length <= 9; ih += "S")
  jr(ih, vq);
OO = Np("Milliseconds", !1);
$t("z", 0, 0, "zoneAbbr");
$t("zz", 0, 0, "zoneName");
function pq() {
  return this._isUTC ? "UTC" : "";
}
function mq() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Ge = m3.prototype;
Ge.add = uz;
Ge.calendar = pz;
Ge.clone = mz;
Ge.diff = bz;
Ge.endOf = kz;
Ge.format = Mz;
Ge.from = Tz;
Ge.fromNow = Oz;
Ge.to = Dz;
Ge.toNow = jz;
Ge.get = w$;
Ge.invalidAt = Fz;
Ge.isAfter = gz;
Ge.isBefore = wz;
Ge.isBetween = yz;
Ge.isSame = xz;
Ge.isSameOrAfter = Sz;
Ge.isSameOrBefore = Cz;
Ge.isValid = Nz;
Ge.lang = CO;
Ge.locale = SO;
Ge.localeData = bO;
Ge.max = NW;
Ge.min = VW;
Ge.parsingFlags = Bz;
Ge.set = y$;
Ge.startOf = Az;
Ge.subtract = sz;
Ge.toArray = Zz;
Ge.toObject = Pz;
Ge.toDate = Hz;
Ge.toISOString = Rz;
Ge.inspect = Ez;
typeof Symbol < "u" && Symbol.for != null && (Ge[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Ge.toJSON = Vz;
Ge.toString = _z;
Ge.unix = Iz;
Ge.valueOf = Lz;
Ge.creationData = Uz;
Ge.eraName = zz;
Ge.eraNarrow = qz;
Ge.eraAbbr = Gz;
Ge.eraYear = Kz;
Ge.year = oO;
Ge.isLeapYear = P$;
Ge.weekYear = rq;
Ge.isoWeekYear = aq;
Ge.quarter = Ge.quarters = cq;
Ge.month = rO;
Ge.daysInMonth = I$;
Ge.week = Ge.weeks = Y$;
Ge.isoWeek = Ge.isoWeeks = $$;
Ge.weeksInYear = lq;
Ge.weeksInWeekYear = uq;
Ge.isoWeeksInYear = oq;
Ge.isoWeeksInISOWeekYear = iq;
Ge.date = TO;
Ge.day = Ge.days = aW;
Ge.weekday = oW;
Ge.isoWeekday = iW;
Ge.dayOfYear = fq;
Ge.hour = Ge.hours = hW;
Ge.minute = Ge.minutes = dq;
Ge.second = Ge.seconds = hq;
Ge.millisecond = Ge.milliseconds = OO;
Ge.utcOffset = GW;
Ge.utc = QW;
Ge.local = XW;
Ge.parseZone = JW;
Ge.hasAlignedHourOffset = ez;
Ge.isDST = tz;
Ge.isLocal = rz;
Ge.isUtcOffset = az;
Ge.isUtc = gO;
Ge.isUTC = gO;
Ge.zoneAbbr = pq;
Ge.zoneName = mq;
Ge.dates = Ts(
  "dates accessor is deprecated. Use date instead.",
  TO
);
Ge.months = Ts(
  "months accessor is deprecated. Use month instead",
  rO
);
Ge.years = Ts(
  "years accessor is deprecated. Use year instead",
  oO
);
Ge.zone = Ts(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  KW
);
Ge.isDSTShifted = Ts(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  nz
);
function gq(e) {
  return Xr(e * 1e3);
}
function wq() {
  return Xr.apply(null, arguments).parseZone();
}
function DO(e) {
  return e;
}
var ur = zx.prototype;
ur.calendar = a$;
ur.longDateFormat = u$;
ur.invalidDate = c$;
ur.ordinal = h$;
ur.preparse = DO;
ur.postformat = DO;
ur.relativeTime = p$;
ur.pastFuture = m$;
ur.set = n$;
ur.eras = Yz;
ur.erasParse = $z;
ur.erasConvertYear = Wz;
ur.erasAbbrRegex = Xz;
ur.erasNameRegex = Qz;
ur.erasNarrowRegex = Jz;
ur.months = j$;
ur.monthsShort = A$;
ur.monthsParse = L$;
ur.monthsRegex = Z$;
ur.monthsShortRegex = H$;
ur.week = N$;
ur.firstDayOfYear = U$;
ur.firstDayOfWeek = F$;
ur.weekdays = J$;
ur.weekdaysMin = tW;
ur.weekdaysShort = eW;
ur.weekdaysParse = rW;
ur.weekdaysRegex = lW;
ur.weekdaysShortRegex = uW;
ur.weekdaysMinRegex = sW;
ur.isPM = fW;
ur.meridiem = vW;
function H5(e, t, a, i) {
  var h = Sf(), g = V0().set(i, t);
  return h[a](g, e);
}
function jO(e, t, a) {
  if (pf(e) && (t = e, e = void 0), e = e || "", t != null)
    return H5(e, t, a, "month");
  var i, h = [];
  for (i = 0; i < 12; i++)
    h[i] = H5(e, i, a, "month");
  return h;
}
function sS(e, t, a, i) {
  typeof e == "boolean" ? (pf(t) && (a = t, t = void 0), t = t || "") : (t = e, a = t, e = !1, pf(t) && (a = t, t = void 0), t = t || "");
  var h = Sf(), g = e ? h._week.dow : 0, m, C = [];
  if (a != null)
    return H5(t, (a + g) % 7, i, "day");
  for (m = 0; m < 7; m++)
    C[m] = H5(t, (m + g) % 7, i, "day");
  return C;
}
function yq(e, t) {
  return jO(e, t, "months");
}
function xq(e, t) {
  return jO(e, t, "monthsShort");
}
function Sq(e, t, a) {
  return sS(e, t, a, "weekdays");
}
function Cq(e, t, a) {
  return sS(e, t, a, "weekdaysShort");
}
function bq(e, t, a) {
  return sS(e, t, a, "weekdaysMin");
}
sh("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, a = bn(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + a;
  }
});
Ke.lang = Ts(
  "moment.lang is deprecated. Use moment.locale instead.",
  sh
);
Ke.langData = Ts(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Sf
);
var af = Math.abs;
function _q() {
  var e = this._data;
  return this._milliseconds = af(this._milliseconds), this._days = af(this._days), this._months = af(this._months), e.milliseconds = af(e.milliseconds), e.seconds = af(e.seconds), e.minutes = af(e.minutes), e.hours = af(e.hours), e.months = af(e.months), e.years = af(e.years), this;
}
function AO(e, t, a, i) {
  var h = M1(t, a);
  return e._milliseconds += i * h._milliseconds, e._days += i * h._days, e._months += i * h._months, e._bubble();
}
function Rq(e, t) {
  return AO(this, e, t, 1);
}
function Eq(e, t) {
  return AO(this, e, t, -1);
}
function IR(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Mq() {
  var e = this._milliseconds, t = this._days, a = this._months, i = this._data, h, g, m, C, S;
  return e >= 0 && t >= 0 && a >= 0 || e <= 0 && t <= 0 && a <= 0 || (e += IR(Cy(a) + t) * 864e5, t = 0, a = 0), i.milliseconds = e % 1e3, h = Es(e / 1e3), i.seconds = h % 60, g = Es(h / 60), i.minutes = g % 60, m = Es(g / 60), i.hours = m % 24, t += Es(m / 24), S = Es(kO(t)), a += S, t -= IR(Cy(S)), C = Es(a / 12), a %= 12, i.days = t, i.months = a, i.years = C, this;
}
function kO(e) {
  return e * 4800 / 146097;
}
function Cy(e) {
  return e * 146097 / 4800;
}
function Tq(e) {
  if (!this.isValid())
    return NaN;
  var t, a, i = this._milliseconds;
  if (e = Os(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + i / 864e5, a = this._months + kO(t), e) {
      case "month":
        return a;
      case "quarter":
        return a / 3;
      case "year":
        return a / 12;
    }
  else
    switch (t = this._days + Math.round(Cy(this._months)), e) {
      case "week":
        return t / 7 + i / 6048e5;
      case "day":
        return t + i / 864e5;
      case "hour":
        return t * 24 + i / 36e5;
      case "minute":
        return t * 1440 + i / 6e4;
      case "second":
        return t * 86400 + i / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + i;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Oq() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + bn(this._months / 12) * 31536e6 : NaN;
}
function Cf(e) {
  return function() {
    return this.as(e);
  };
}
var Dq = Cf("ms"), jq = Cf("s"), Aq = Cf("m"), kq = Cf("h"), Lq = Cf("d"), Iq = Cf("w"), Hq = Cf("M"), Zq = Cf("Q"), Pq = Cf("y");
function Vq() {
  return M1(this);
}
function Nq(e) {
  return e = Os(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Y2(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var Bq = Y2("milliseconds"), Fq = Y2("seconds"), Uq = Y2("minutes"), Yq = Y2("hours"), $q = Y2("days"), Wq = Y2("months"), zq = Y2("years");
function qq() {
  return Es(this.days() / 7);
}
var lf = Math.round, Sp = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Gq(e, t, a, i, h) {
  return h.relativeTime(t || 1, !!a, e, i);
}
function Kq(e, t, a, i) {
  var h = M1(e).abs(), g = lf(h.as("s")), m = lf(h.as("m")), C = lf(h.as("h")), S = lf(h.as("d")), R = lf(h.as("M")), D = lf(h.as("w")), T = lf(h.as("y")), j = g <= a.ss && ["s", g] || g < a.s && ["ss", g] || m <= 1 && ["m"] || m < a.m && ["mm", m] || C <= 1 && ["h"] || C < a.h && ["hh", C] || S <= 1 && ["d"] || S < a.d && ["dd", S];
  return a.w != null && (j = j || D <= 1 && ["w"] || D < a.w && ["ww", D]), j = j || R <= 1 && ["M"] || R < a.M && ["MM", R] || T <= 1 && ["y"] || ["yy", T], j[2] = t, j[3] = +e > 0, j[4] = i, Gq.apply(null, j);
}
function Qq(e) {
  return e === void 0 ? lf : typeof e == "function" ? (lf = e, !0) : !1;
}
function Xq(e, t) {
  return Sp[e] === void 0 ? !1 : t === void 0 ? Sp[e] : (Sp[e] = t, e === "s" && (Sp.ss = t - 1), !0);
}
function Jq(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var a = !1, i = Sp, h, g;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (a = e), typeof t == "object" && (i = Object.assign({}, Sp, t), t.s != null && t.ss == null && (i.ss = t.s - 1)), h = this.localeData(), g = Kq(this, !a, i, h), a && (g = h.pastFuture(+this, g)), h.postformat(g);
}
var U8 = Math.abs;
function mp(e) {
  return (e > 0) - (e < 0) || +e;
}
function Iw() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = U8(this._milliseconds) / 1e3, t = U8(this._days), a = U8(this._months), i, h, g, m, C = this.asSeconds(), S, R, D, T;
  return C ? (i = Es(e / 60), h = Es(i / 60), e %= 60, i %= 60, g = Es(a / 12), a %= 12, m = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", S = C < 0 ? "-" : "", R = mp(this._months) !== mp(C) ? "-" : "", D = mp(this._days) !== mp(C) ? "-" : "", T = mp(this._milliseconds) !== mp(C) ? "-" : "", S + "P" + (g ? R + g + "Y" : "") + (a ? R + a + "M" : "") + (t ? D + t + "D" : "") + (h || i || e ? "T" : "") + (h ? T + h + "H" : "") + (i ? T + i + "M" : "") + (e ? T + m + "S" : "")) : "P0D";
}
var Xn = kw.prototype;
Xn.isValid = $W;
Xn.abs = _q;
Xn.add = Rq;
Xn.subtract = Eq;
Xn.as = Tq;
Xn.asMilliseconds = Dq;
Xn.asSeconds = jq;
Xn.asMinutes = Aq;
Xn.asHours = kq;
Xn.asDays = Lq;
Xn.asWeeks = Iq;
Xn.asMonths = Hq;
Xn.asQuarters = Zq;
Xn.asYears = Pq;
Xn.valueOf = Oq;
Xn._bubble = Mq;
Xn.clone = Vq;
Xn.get = Nq;
Xn.milliseconds = Bq;
Xn.seconds = Fq;
Xn.minutes = Uq;
Xn.hours = Yq;
Xn.days = $q;
Xn.weeks = qq;
Xn.months = Wq;
Xn.years = zq;
Xn.humanize = Jq;
Xn.toISOString = Iw;
Xn.toString = Iw;
Xn.toJSON = Iw;
Xn.locale = SO;
Xn.localeData = bO;
Xn.toIsoString = Ts(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Iw
);
Xn.lang = CO;
$t("X", 0, 0, "unix");
$t("x", 0, 0, "valueOf");
Rt("x", Ow);
Rt("X", S$);
jr("X", function(e, t, a) {
  a._d = new Date(parseFloat(e) * 1e3);
});
jr("x", function(e, t, a) {
  a._d = new Date(bn(e));
});
//! moment.js
Ke.version = "2.29.4";
e$(Xr);
Ke.fn = Ge;
Ke.min = BW;
Ke.max = FW;
Ke.now = UW;
Ke.utc = V0;
Ke.unix = gq;
Ke.months = yq;
Ke.isDate = p3;
Ke.locale = sh;
Ke.invalid = _w;
Ke.duration = M1;
Ke.isMoment = E1;
Ke.weekdays = Sq;
Ke.parseZone = wq;
Ke.localeData = Sf;
Ke.isDuration = w5;
Ke.monthsShort = xq;
Ke.weekdaysMin = bq;
Ke.defineLocale = tS;
Ke.updateLocale = wW;
Ke.locales = yW;
Ke.weekdaysShort = Cq;
Ke.normalizeUnits = Os;
Ke.relativeTimeRounding = Qq;
Ke.relativeTimeThreshold = Xq;
Ke.calendarFormat = vz;
Ke.prototype = Ge;
Ke.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
var by = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(e, t) {
  (function() {
    var a, i = "4.17.21", h = 200, g = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", m = "Expected a function", C = "Invalid `variable` option passed into `_.template`", S = "__lodash_hash_undefined__", R = 500, D = "__lodash_placeholder__", T = 1, j = 2, A = 4, L = 1, P = 2, V = 1, F = 2, Y = 4, W = 8, Q = 16, $ = 32, le = 64, te = 128, Se = 256, re = 512, ve = 30, K = "...", de = 800, fe = 16, xe = 1, Le = 2, be = 3, Ue = 1 / 0, ie = 9007199254740991, _e = 17976931348623157e292, Ze = NaN, mt = 4294967295, Pe = mt - 1, Vt = mt >>> 1, Dt = [
      ["ary", te],
      ["bind", V],
      ["bindKey", F],
      ["curry", W],
      ["curryRight", Q],
      ["flip", re],
      ["partial", $],
      ["partialRight", le],
      ["rearg", Se]
    ], Qe = "[object Arguments]", et = "[object Array]", wt = "[object AsyncFunction]", St = "[object Boolean]", _n = "[object Date]", Hr = "[object DOMException]", kn = "[object Error]", Wn = "[object Function]", sr = "[object GeneratorFunction]", yr = "[object Map]", ea = "[object Number]", Ca = "[object Null]", ft = "[object Object]", fn = "[object Promise]", Ln = "[object Proxy]", Nt = "[object RegExp]", gn = "[object Set]", zn = "[object String]", Ur = "[object Symbol]", Xe = "[object Undefined]", Jt = "[object WeakMap]", qn = "[object WeakSet]", Sn = "[object ArrayBuffer]", qe = "[object DataView]", yt = "[object Float32Array]", Ct = "[object Float64Array]", ln = "[object Int8Array]", cr = "[object Int16Array]", ta = "[object Int32Array]", xr = "[object Uint8Array]", Ao = "[object Uint8ClampedArray]", wn = "[object Uint16Array]", Gn = "[object Uint32Array]", T1 = /\b__p \+= '';/g, Ri = /\b(__p \+=) '' \+/g, Jl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, qi = /&(?:amp|lt|gt|quot|#39);/g, El = /[&<>"']/g, F0 = RegExp(qi.source), O1 = RegExp(El.source), bf = /<%-([\s\S]+?)%>/g, D1 = /<%([\s\S]+?)%>/g, Zu = /<%=([\s\S]+?)%>/g, Ml = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Tl = /^\w*$/, Wo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ol = /[\\^$.*+?()[\]{}|]/g, eu = RegExp(Ol.source), js = /^\s+/, tu = /\s/, Gi = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, X = /\{\n\/\* \[wrapped with (.+)\] \*/, $e = /,? & /, dt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Et = /[()=,{}\[\]\/\s]/, Nn = /\\(\\)?/g, yn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, dn = /\w*$/, hn = /^[-+]0x[0-9a-f]+$/i, Za = /^0b[01]+$/i, Rr = /^\[object .+?Constructor\]$/, Er = /^0o[0-7]+$/i, ho = /^(?:0|[1-9]\d*)$/, vo = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Gt = /($^)/, na = /['\n\r\u2028\u2029\\]/g, Jn = "\\ud800-\\udfff", _f = "\\u0300-\\u036f", j1 = "\\ufe20-\\ufe2f", Eh = "\\u20d0-\\u20ff", A1 = _f + j1 + Eh, Mh = "\\u2700-\\u27bf", Rf = "a-z\\xdf-\\xf6\\xf8-\\xff", U0 = "\\xac\\xb1\\xd7\\xf7", Dl = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Yp = "\\u2000-\\u206f", zo = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ef = "A-Z\\xc0-\\xd6\\xd8-\\xde", nu = "\\ufe0e\\ufe0f", Mf = U0 + Dl + Yp + zo, ru = "['’]", Tf = "[" + Jn + "]", Pu = "[" + Mf + "]", As = "[" + A1 + "]", Of = "\\d+", $p = "[" + Mh + "]", k1 = "[" + Rf + "]", Th = "[^" + Jn + Mf + Of + Mh + Rf + Ef + "]", L1 = "\\ud83c[\\udffb-\\udfff]", Y0 = "(?:" + As + "|" + L1 + ")", Oh = "[^" + Jn + "]", In = "(?:\\ud83c[\\udde6-\\uddff]){2}", Bn = "[\\ud800-\\udbff][\\udc00-\\udfff]", Vu = "[" + Ef + "]", en = "\\u200d", $0 = "(?:" + k1 + "|" + Th + ")", ko = "(?:" + Vu + "|" + Th + ")", ks = "(?:" + ru + "(?:d|ll|m|re|s|t|ve))?", Ls = "(?:" + ru + "(?:D|LL|M|RE|S|T|VE))?", Df = Y0 + "?", va = "[" + nu + "]?", tr = "(?:" + en + "(?:" + [Oh, In, Bn].join("|") + ")" + va + Df + ")*", Nu = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Pa = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Va = va + Df + tr, Ei = "(?:" + [$p, In, Bn].join("|") + ")" + Va, Bu = "(?:" + [Oh + As + "?", As, In, Bn, Tf].join("|") + ")", Dh = RegExp(ru, "g"), jh = RegExp(As, "g"), Fu = RegExp(L1 + "(?=" + L1 + ")|" + Bu + Va, "g"), Wp = RegExp([
      Vu + "?" + k1 + "+" + ks + "(?=" + [Pu, Vu, "$"].join("|") + ")",
      ko + "+" + Ls + "(?=" + [Pu, Vu + $0, "$"].join("|") + ")",
      Vu + "?" + $0 + "+" + ks,
      Vu + "+" + Ls,
      Pa,
      Nu,
      Of,
      Ei
    ].join("|"), "g"), $2 = RegExp("[" + en + Jn + A1 + nu + "]"), jf = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, W0 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], W2 = -1, Hn = {};
    Hn[yt] = Hn[Ct] = Hn[ln] = Hn[cr] = Hn[ta] = Hn[xr] = Hn[Ao] = Hn[wn] = Hn[Gn] = !0, Hn[Qe] = Hn[et] = Hn[Sn] = Hn[St] = Hn[qe] = Hn[_n] = Hn[kn] = Hn[Wn] = Hn[yr] = Hn[ea] = Hn[ft] = Hn[Nt] = Hn[gn] = Hn[zn] = Hn[Jt] = !1;
    var Fn = {};
    Fn[Qe] = Fn[et] = Fn[Sn] = Fn[qe] = Fn[St] = Fn[_n] = Fn[yt] = Fn[Ct] = Fn[ln] = Fn[cr] = Fn[ta] = Fn[yr] = Fn[ea] = Fn[ft] = Fn[Nt] = Fn[gn] = Fn[zn] = Fn[Ur] = Fn[xr] = Fn[Ao] = Fn[wn] = Fn[Gn] = !0, Fn[kn] = Fn[Wn] = Fn[Jt] = !1;
    var Is = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, z0 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, z2 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, q2 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, q0 = parseFloat, G0 = parseInt, K0 = typeof C4 == "object" && C4 && C4.Object === Object && C4, Af = typeof self == "object" && self && self.Object === Object && self, Sr = K0 || Af || Function("return this")(), Q0 = t && !t.nodeType && t, jl = Q0 && !0 && e && !e.nodeType && e, X0 = jl && jl.exports === Q0, Hs = X0 && K0.process, Xa = function() {
      try {
        var ue = jl && jl.require && jl.require("util").types;
        return ue || Hs && Hs.binding && Hs.binding("util");
      } catch {
      }
    }(), kf = Xa && Xa.isArrayBuffer, po = Xa && Xa.isDate, Zs = Xa && Xa.isMap, Lf = Xa && Xa.isRegExp, ra = Xa && Xa.isSet, If = Xa && Xa.isTypedArray;
    function Ja(ue, Re, ge) {
      switch (ge.length) {
        case 0:
          return ue.call(Re);
        case 1:
          return ue.call(Re, ge[0]);
        case 2:
          return ue.call(Re, ge[0], ge[1]);
        case 3:
          return ue.call(Re, ge[0], ge[1], ge[2]);
      }
      return ue.apply(Re, ge);
    }
    function Hf(ue, Re, ge, Je) {
      for (var Wt = -1, Rn = ue == null ? 0 : ue.length; ++Wt < Rn; ) {
        var Cr = ue[Wt];
        Re(Je, Cr, ge(Cr), ue);
      }
      return Je;
    }
    function eo(ue, Re) {
      for (var ge = -1, Je = ue == null ? 0 : ue.length; ++ge < Je && Re(ue[ge], ge, ue) !== !1; )
        ;
      return ue;
    }
    function au(ue, Re) {
      for (var ge = ue == null ? 0 : ue.length; ge-- && Re(ue[ge], ge, ue) !== !1; )
        ;
      return ue;
    }
    function J0(ue, Re) {
      for (var ge = -1, Je = ue == null ? 0 : ue.length; ++ge < Je; )
        if (!Re(ue[ge], ge, ue))
          return !1;
      return !0;
    }
    function ou(ue, Re) {
      for (var ge = -1, Je = ue == null ? 0 : ue.length, Wt = 0, Rn = []; ++ge < Je; ) {
        var Cr = ue[ge];
        Re(Cr, ge, ue) && (Rn[Wt++] = Cr);
      }
      return Rn;
    }
    function Zf(ue, Re) {
      var ge = ue == null ? 0 : ue.length;
      return !!ge && Uu(ue, Re, 0) > -1;
    }
    function Ah(ue, Re, ge) {
      for (var Je = -1, Wt = ue == null ? 0 : ue.length; ++Je < Wt; )
        if (ge(Re, ue[Je]))
          return !0;
      return !1;
    }
    function hr(ue, Re) {
      for (var ge = -1, Je = ue == null ? 0 : ue.length, Wt = Array(Je); ++ge < Je; )
        Wt[ge] = Re(ue[ge], ge, ue);
      return Wt;
    }
    function iu(ue, Re) {
      for (var ge = -1, Je = Re.length, Wt = ue.length; ++ge < Je; )
        ue[Wt + ge] = Re[ge];
      return ue;
    }
    function ec(ue, Re, ge, Je) {
      var Wt = -1, Rn = ue == null ? 0 : ue.length;
      for (Je && Rn && (ge = ue[++Wt]); ++Wt < Rn; )
        ge = Re(ge, ue[Wt], Wt, ue);
      return ge;
    }
    function G2(ue, Re, ge, Je) {
      var Wt = ue == null ? 0 : ue.length;
      for (Je && Wt && (ge = ue[--Wt]); Wt--; )
        ge = Re(ge, ue[Wt], Wt, ue);
      return ge;
    }
    function Pf(ue, Re) {
      for (var ge = -1, Je = ue == null ? 0 : ue.length; ++ge < Je; )
        if (Re(ue[ge], ge, ue))
          return !0;
      return !1;
    }
    var K2 = Vf("length");
    function Q2(ue) {
      return ue.split("");
    }
    function lu(ue) {
      return ue.match(dt) || [];
    }
    function X2(ue, Re, ge) {
      var Je;
      return ge(ue, function(Wt, Rn, Cr) {
        if (Re(Wt, Rn, Cr))
          return Je = Rn, !1;
      }), Je;
    }
    function I1(ue, Re, ge, Je) {
      for (var Wt = ue.length, Rn = ge + (Je ? 1 : -1); Je ? Rn-- : ++Rn < Wt; )
        if (Re(ue[Rn], Rn, ue))
          return Rn;
      return -1;
    }
    function Uu(ue, Re, ge) {
      return Re === Re ? Uf(ue, Re, ge) : I1(ue, J2, ge);
    }
    function tc(ue, Re, ge, Je) {
      for (var Wt = ge - 1, Rn = ue.length; ++Wt < Rn; )
        if (Je(ue[Wt], Re))
          return Wt;
      return -1;
    }
    function J2(ue) {
      return ue !== ue;
    }
    function nc(ue, Re) {
      var ge = ue == null ? 0 : ue.length;
      return ge ? Ki(ue, Re) / ge : Ze;
    }
    function Vf(ue) {
      return function(Re) {
        return Re == null ? a : Re[ue];
      };
    }
    function Na(ue) {
      return function(Re) {
        return ue == null ? a : ue[Re];
      };
    }
    function Al(ue, Re, ge, Je, Wt) {
      return Wt(ue, function(Rn, Cr, nr) {
        ge = Je ? (Je = !1, Rn) : Re(ge, Rn, Cr, nr);
      }), ge;
    }
    function aa(ue, Re) {
      var ge = ue.length;
      for (ue.sort(Re); ge--; )
        ue[ge] = ue[ge].value;
      return ue;
    }
    function Ki(ue, Re) {
      for (var ge, Je = -1, Wt = ue.length; ++Je < Wt; ) {
        var Rn = Re(ue[Je]);
        Rn !== a && (ge = ge === a ? Rn : ge + Rn);
      }
      return ge;
    }
    function rc(ue, Re) {
      for (var ge = -1, Je = Array(ue); ++ge < ue; )
        Je[ge] = Re(ge);
      return Je;
    }
    function Nf(ue, Re) {
      return hr(Re, function(ge) {
        return [ge, ue[ge]];
      });
    }
    function ev(ue) {
      return ue && ue.slice(0, Yf(ue) + 1).replace(js, "");
    }
    function Ba(ue) {
      return function(Re) {
        return ue(Re);
      };
    }
    function ac(ue, Re) {
      return hr(Re, function(ge) {
        return ue[ge];
      });
    }
    function uu(ue, Re) {
      return ue.has(Re);
    }
    function Bf(ue, Re) {
      for (var ge = -1, Je = ue.length; ++ge < Je && Uu(Re, ue[ge], 0) > -1; )
        ;
      return ge;
    }
    function kh(ue, Re) {
      for (var ge = ue.length; ge-- && Uu(Re, ue[ge], 0) > -1; )
        ;
      return ge;
    }
    function tv(ue, Re) {
      for (var ge = ue.length, Je = 0; ge--; )
        ue[ge] === Re && ++Je;
      return Je;
    }
    var nv = Na(Is), Lh = Na(z0);
    function rv(ue) {
      return "\\" + q2[ue];
    }
    function H1(ue, Re) {
      return ue == null ? a : ue[Re];
    }
    function Z1(ue) {
      return $2.test(ue);
    }
    function av(ue) {
      return jf.test(ue);
    }
    function P1(ue) {
      for (var Re, ge = []; !(Re = ue.next()).done; )
        ge.push(Re.value);
      return ge;
    }
    function V1(ue) {
      var Re = -1, ge = Array(ue.size);
      return ue.forEach(function(Je, Wt) {
        ge[++Re] = [Wt, Je];
      }), ge;
    }
    function Ff(ue, Re) {
      return function(ge) {
        return ue(Re(ge));
      };
    }
    function qo(ue, Re) {
      for (var ge = -1, Je = ue.length, Wt = 0, Rn = []; ++ge < Je; ) {
        var Cr = ue[ge];
        (Cr === Re || Cr === D) && (ue[ge] = D, Rn[Wt++] = ge);
      }
      return Rn;
    }
    function Yu(ue) {
      var Re = -1, ge = Array(ue.size);
      return ue.forEach(function(Je) {
        ge[++Re] = Je;
      }), ge;
    }
    function zp(ue) {
      var Re = -1, ge = Array(ue.size);
      return ue.forEach(function(Je) {
        ge[++Re] = [Je, Je];
      }), ge;
    }
    function Uf(ue, Re, ge) {
      for (var Je = ge - 1, Wt = ue.length; ++Je < Wt; )
        if (ue[Je] === Re)
          return Je;
      return -1;
    }
    function qp(ue, Re, ge) {
      for (var Je = ge + 1; Je--; )
        if (ue[Je] === Re)
          return Je;
      return Je;
    }
    function Ps(ue) {
      return Z1(ue) ? Ih(ue) : K2(ue);
    }
    function Go(ue) {
      return Z1(ue) ? iv(ue) : Q2(ue);
    }
    function Yf(ue) {
      for (var Re = ue.length; Re-- && tu.test(ue.charAt(Re)); )
        ;
      return Re;
    }
    var ov = Na(z2);
    function Ih(ue) {
      for (var Re = Fu.lastIndex = 0; Fu.test(ue); )
        ++Re;
      return Re;
    }
    function iv(ue) {
      return ue.match(Fu) || [];
    }
    function lv(ue) {
      return ue.match(Wp) || [];
    }
    var Gp = function ue(Re) {
      Re = Re == null ? Sr : N1.defaults(Sr.Object(), Re, N1.pick(Sr, W0));
      var ge = Re.Array, Je = Re.Date, Wt = Re.Error, Rn = Re.Function, Cr = Re.Math, nr = Re.Object, oc = Re.RegExp, Kp = Re.String, Mi = Re.TypeError, su = ge.prototype, $f = Rn.prototype, kl = nr.prototype, Vs = Re["__core-js_shared__"], pa = $f.toString, En = kl.hasOwnProperty, B1 = 0, Wf = function() {
        var s = /[^.]+$/.exec(Vs && Vs.keys && Vs.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), ic = kl.toString, zf = pa.call(nr), uv = Sr._, Hh = oc(
        "^" + pa.call(En).replace(Ol, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Ns = X0 ? Re.Buffer : a, Ko = Re.Symbol, lc = Re.Uint8Array, Bs = Ns ? Ns.allocUnsafe : a, Qi = Ff(nr.getPrototypeOf, nr), qf = nr.create, Gf = kl.propertyIsEnumerable, F1 = su.splice, Kf = Ko ? Ko.isConcatSpreadable : a, Lo = Ko ? Ko.iterator : a, Ti = Ko ? Ko.toStringTag : a, U1 = function() {
        try {
          var s = Hi(nr, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), sv = Re.clearTimeout !== Sr.clearTimeout && Re.clearTimeout, vr = Je && Je.now !== Sr.Date.now && Je.now, Zh = Re.setTimeout !== Sr.setTimeout && Re.setTimeout, $u = Cr.ceil, cu = Cr.floor, uc = nr.getOwnPropertySymbols, sc = Ns ? Ns.isBuffer : a, Y1 = Re.isFinite, cc = su.join, $1 = Ff(nr.keys, nr), oa = Cr.max, to = Cr.min, fc = Je.now, Qf = Re.parseInt, fu = Cr.random, dc = su.reverse, W1 = Hi(Re, "DataView"), du = Hi(Re, "Map"), hc = Hi(Re, "Promise"), Qo = Hi(Re, "Set"), Wu = Hi(Re, "WeakMap"), hu = Hi(nr, "create"), z1 = Wu && new Wu(), q1 = {}, vc = Zi(W1), zu = Zi(du), cv = Zi(hc), G1 = Zi(Qo), Oi = Zi(Wu), Xo = Ko ? Ko.prototype : a, Jo = Xo ? Xo.valueOf : a, Xf = Xo ? Xo.toString : a;
      function H(s) {
        if (ca(s) && !un(s) && !(s instanceof Kt)) {
          if (s instanceof zt)
            return s;
          if (En.call(s, "__wrapped__"))
            return n1(s);
        }
        return new zt(s);
      }
      var Xi = /* @__PURE__ */ function() {
        function s() {
        }
        return function(d) {
          if (!Kr(d))
            return {};
          if (qf)
            return qf(d);
          s.prototype = d;
          var y = new s();
          return s.prototype = a, y;
        };
      }();
      function fr() {
      }
      function zt(s, d) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!d, this.__index__ = 0, this.__values__ = a;
      }
      H.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: bf,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: D1,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Zu,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: H
        }
      }, H.prototype = fr.prototype, H.prototype.constructor = H, zt.prototype = Xi(fr.prototype), zt.prototype.constructor = zt;
      function Kt(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = mt, this.__views__ = [];
      }
      function Fs() {
        var s = new Kt(this.__wrapped__);
        return s.__actions__ = _a(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = _a(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = _a(this.__views__), s;
      }
      function Jf() {
        if (this.__filtered__) {
          var s = new Kt(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function vn() {
        var s = this.__wrapped__.value(), d = this.__dir__, y = un(s), M = d < 0, I = y ? s.length : 0, B = qh(0, I, this.__views__), q = B.start, J = B.end, se = J - q, De = M ? J : q - 1, Ie = this.__iteratees__, Be = Ie.length, ot = 0, Ot = to(se, this.__takeCount__);
        if (!y || !M && I == se && Ot == se)
          return rs(s, this.__actions__);
        var kt = [];
        e:
          for (; se-- && ot < Ot; ) {
            De += d;
            for (var sn = -1, Yt = s[De]; ++sn < Be; ) {
              var rn = Ie[sn], cn = rn.iteratee, mr = rn.type, ar = cn(Yt);
              if (mr == Le)
                Yt = ar;
              else if (!ar) {
                if (mr == xe)
                  continue e;
                break e;
              }
            }
            kt[ot++] = Yt;
          }
        return kt;
      }
      Kt.prototype = Xi(fr.prototype), Kt.prototype.constructor = Kt;
      function ia(s) {
        var d = -1, y = s == null ? 0 : s.length;
        for (this.clear(); ++d < y; ) {
          var M = s[d];
          this.set(M[0], M[1]);
        }
      }
      function Un() {
        this.__data__ = hu ? hu(null) : {}, this.size = 0;
      }
      function Yn(s) {
        var d = this.has(s) && delete this.__data__[s];
        return this.size -= d ? 1 : 0, d;
      }
      function mo(s) {
        var d = this.__data__;
        if (hu) {
          var y = d[s];
          return y === S ? a : y;
        }
        return En.call(d, s) ? d[s] : a;
      }
      function Zr(s) {
        var d = this.__data__;
        return hu ? d[s] !== a : En.call(d, s);
      }
      function la(s, d) {
        var y = this.__data__;
        return this.size += this.has(s) ? 0 : 1, y[s] = hu && d === a ? S : d, this;
      }
      ia.prototype.clear = Un, ia.prototype.delete = Yn, ia.prototype.get = mo, ia.prototype.has = Zr, ia.prototype.set = la;
      function Fa(s) {
        var d = -1, y = s == null ? 0 : s.length;
        for (this.clear(); ++d < y; ) {
          var M = s[d];
          this.set(M[0], M[1]);
        }
      }
      function K1() {
        this.__data__ = [], this.size = 0;
      }
      function Ua(s) {
        var d = this.__data__, y = Ya(d, s);
        if (y < 0)
          return !1;
        var M = d.length - 1;
        return y == M ? d.pop() : F1.call(d, y, 1), --this.size, !0;
      }
      function Io(s) {
        var d = this.__data__, y = Ya(d, s);
        return y < 0 ? a : d[y][1];
      }
      function ed(s) {
        return Ya(this.__data__, s) > -1;
      }
      function Ph(s, d) {
        var y = this.__data__, M = Ya(y, s);
        return M < 0 ? (++this.size, y.push([s, d])) : y[M][1] = d, this;
      }
      Fa.prototype.clear = K1, Fa.prototype.delete = Ua, Fa.prototype.get = Io, Fa.prototype.has = ed, Fa.prototype.set = Ph;
      function Ho(s) {
        var d = -1, y = s == null ? 0 : s.length;
        for (this.clear(); ++d < y; ) {
          var M = s[d];
          this.set(M[0], M[1]);
        }
      }
      function qu() {
        this.size = 0, this.__data__ = {
          hash: new ia(),
          map: new (du || Fa)(),
          string: new ia()
        };
      }
      function Ji(s) {
        var d = oi(this, s).delete(s);
        return this.size -= d ? 1 : 0, d;
      }
      function el(s) {
        return oi(this, s).get(s);
      }
      function pc(s) {
        return oi(this, s).has(s);
      }
      function td(s, d) {
        var y = oi(this, s), M = y.size;
        return y.set(s, d), this.size += y.size == M ? 0 : 1, this;
      }
      Ho.prototype.clear = qu, Ho.prototype.delete = Ji, Ho.prototype.get = el, Ho.prototype.has = pc, Ho.prototype.set = td;
      function vu(s) {
        var d = -1, y = s == null ? 0 : s.length;
        for (this.__data__ = new Ho(); ++d < y; )
          this.add(s[d]);
      }
      function Di(s) {
        return this.__data__.set(s, S), this;
      }
      function tl(s) {
        return this.__data__.has(s);
      }
      vu.prototype.add = vu.prototype.push = Di, vu.prototype.has = tl;
      function Mr(s) {
        var d = this.__data__ = new Fa(s);
        this.size = d.size;
      }
      function nd() {
        this.__data__ = new Fa(), this.size = 0;
      }
      function Ll(s) {
        var d = this.__data__, y = d.delete(s);
        return this.size = d.size, y;
      }
      function ei(s) {
        return this.__data__.get(s);
      }
      function ti(s) {
        return this.__data__.has(s);
      }
      function Us(s, d) {
        var y = this.__data__;
        if (y instanceof Fa) {
          var M = y.__data__;
          if (!du || M.length < h - 1)
            return M.push([s, d]), this.size = ++y.size, this;
          y = this.__data__ = new Ho(M);
        }
        return y.set(s, d), this.size = y.size, this;
      }
      Mr.prototype.clear = nd, Mr.prototype.delete = Ll, Mr.prototype.get = ei, Mr.prototype.has = ti, Mr.prototype.set = Us;
      function Il(s, d) {
        var y = un(s), M = !y && u1(s), I = !y && !M && ml(s), B = !y && !M && !I && ws(s), q = y || M || I || B, J = q ? rc(s.length, Kp) : [], se = J.length;
        for (var De in s)
          (d || En.call(s, De)) && !(q && // Safari 9 has enumerable `arguments.length` in strict mode.
          (De == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          I && (De == "offset" || De == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          B && (De == "buffer" || De == "byteLength" || De == "byteOffset") || // Skip index properties.
          Or(De, se))) && J.push(De);
        return J;
      }
      function nl(s) {
        var d = s.length;
        return d ? s[He(0, d - 1)] : a;
      }
      function Gu(s, d) {
        return t1(_a(s), pu(d, 0, s.length));
      }
      function Vh(s) {
        return t1(_a(s));
      }
      function Q1(s, d, y) {
        (y !== a && !Bo(s[d], y) || y === a && !(d in s)) && Hl(s, d, y);
      }
      function Ys(s, d, y) {
        var M = s[d];
        (!(En.call(s, d) && Bo(M, y)) || y === a && !(d in s)) && Hl(s, d, y);
      }
      function Ya(s, d) {
        for (var y = s.length; y--; )
          if (Bo(s[y][0], d))
            return y;
        return -1;
      }
      function Zo(s, d, y, M) {
        return Zl(s, function(I, B, q) {
          d(M, I, y(I), q);
        }), M;
      }
      function br(s, d) {
        return s && yo(d, uo(d), s);
      }
      function rl(s, d) {
        return s && yo(d, Ni(d), s);
      }
      function Hl(s, d, y) {
        d == "__proto__" && U1 ? U1(s, d, {
          configurable: !0,
          enumerable: !0,
          value: y,
          writable: !0
        }) : s[d] = y;
      }
      function Yr(s, d) {
        for (var y = -1, M = d.length, I = ge(M), B = s == null; ++y < M; )
          I[y] = B ? a : ym(s, d[y]);
        return I;
      }
      function pu(s, d, y) {
        return s === s && (y !== a && (s = s <= y ? s : y), d !== a && (s = s >= d ? s : d)), s;
      }
      function $a(s, d, y, M, I, B) {
        var q, J = d & T, se = d & j, De = d & A;
        if (y && (q = I ? y(s, M, I, B) : y(s)), q !== a)
          return q;
        if (!Kr(s))
          return s;
        var Ie = un(s);
        if (Ie) {
          if (q = ss(s), !J)
            return _a(s, q);
        } else {
          var Be = za(s), ot = Be == Wn || Be == sr;
          if (ml(s))
            return Rc(s, J);
          if (Be == ft || Be == Qe || ot && !I) {
            if (q = se || ot ? {} : Ra(s), !J)
              return se ? Xp(s, rl(q, s)) : Gs(s, br(q, s));
          } else {
            if (!Fn[Be])
              return I ? s : {};
            q = Jp(s, Be, J);
          }
        }
        B || (B = new Mr());
        var Ot = B.get(s);
        if (Ot)
          return Ot;
        B.set(s, q), wm(s) ? s.forEach(function(Yt) {
          q.add($a(Yt, d, y, Yt, s, B));
        }) : R3(s) && s.forEach(function(Yt, rn) {
          q.set(rn, $a(Yt, d, y, rn, s, B));
        });
        var kt = De ? se ? f0 : jc : se ? Ni : uo, sn = Ie ? a : kt(s);
        return eo(sn || s, function(Yt, rn) {
          sn && (rn = Yt, Yt = s[rn]), Ys(q, rn, $a(Yt, d, y, rn, s, B));
        }), q;
      }
      function rd(s) {
        var d = uo(s);
        return function(y) {
          return al(y, s, d);
        };
      }
      function al(s, d, y) {
        var M = y.length;
        if (s == null)
          return !M;
        for (s = nr(s); M--; ) {
          var I = y[M], B = d[I], q = s[I];
          if (q === a && !(I in s) || !B(q))
            return !1;
        }
        return !0;
      }
      function Nh(s, d, y) {
        if (typeof s != "function")
          throw new Mi(m);
        return Ul(function() {
          s.apply(a, y);
        }, d);
      }
      function ji(s, d, y, M) {
        var I = -1, B = Zf, q = !0, J = s.length, se = [], De = d.length;
        if (!J)
          return se;
        y && (d = hr(d, Ba(y))), M ? (B = Ah, q = !1) : d.length >= h && (B = uu, q = !1, d = new vu(d));
        e:
          for (; ++I < J; ) {
            var Ie = s[I], Be = y == null ? Ie : y(Ie);
            if (Ie = M || Ie !== 0 ? Ie : 0, q && Be === Be) {
              for (var ot = De; ot--; )
                if (d[ot] === Be)
                  continue e;
              se.push(Ie);
            } else B(d, Be, M) || se.push(Ie);
          }
        return se;
      }
      var Zl = Li(ni), fv = Li(Ku, !0);
      function Pl(s, d) {
        var y = !0;
        return Zl(s, function(M, I, B) {
          return y = !!d(M, I, B), y;
        }), y;
      }
      function Pr(s, d, y) {
        for (var M = -1, I = s.length; ++M < I; ) {
          var B = s[M], q = d(B);
          if (q != null && (J === a ? q === q && !ci(q) : y(q, J)))
            var J = q, se = B;
        }
        return se;
      }
      function at(s, d, y, M) {
        var I = s.length;
        for (y = Ft(y), y < 0 && (y = -y > I ? 0 : I + y), M = M === a || M > I ? I : Ft(M), M < 0 && (M += I), M = y > M ? 0 : Hd(M); y < M; )
          s[y++] = d;
        return s;
      }
      function Ai(s, d) {
        var y = [];
        return Zl(s, function(M, I, B) {
          d(M, I, B) && y.push(M);
        }), y;
      }
      function Zn(s, d, y, M, I) {
        var B = -1, q = s.length;
        for (y || (y = d0), I || (I = []); ++B < q; ) {
          var J = s[B];
          d > 0 && y(J) ? d > 1 ? Zn(J, d - 1, y, M, I) : iu(I, J) : M || (I[I.length] = J);
        }
        return I;
      }
      var ad = s0(), mc = s0(!0);
      function ni(s, d) {
        return s && ad(s, d, uo);
      }
      function Ku(s, d) {
        return s && mc(s, d, uo);
      }
      function X1(s, d) {
        return ou(d, function(y) {
          return gs(s[y]);
        });
      }
      function pr(s, d) {
        d = wo(d, s);
        for (var y = 0, M = d.length; s != null && y < M; )
          s = s[hl(d[y++])];
        return y && y == M ? s : a;
      }
      function od(s, d, y) {
        var M = d(s);
        return un(s) ? M : iu(M, y(s));
      }
      function Wa(s) {
        return s == null ? s === a ? Xe : Ca : Ti && Ti in nr(s) ? No(s) : e1(s);
      }
      function Qu(s, d) {
        return s > d;
      }
      function ri(s, d) {
        return s != null && En.call(s, d);
      }
      function ol(s, d) {
        return s != null && d in nr(s);
      }
      function Xu(s, d, y) {
        return s >= to(d, y) && s < oa(d, y);
      }
      function id(s, d, y) {
        for (var M = y ? Ah : Zf, I = s[0].length, B = s.length, q = B, J = ge(B), se = 1 / 0, De = []; q--; ) {
          var Ie = s[q];
          q && d && (Ie = hr(Ie, Ba(d))), se = to(Ie.length, se), J[q] = !y && (d || I >= 120 && Ie.length >= 120) ? new vu(q && Ie) : a;
        }
        Ie = s[0];
        var Be = -1, ot = J[0];
        e:
          for (; ++Be < I && De.length < se; ) {
            var Ot = Ie[Be], kt = d ? d(Ot) : Ot;
            if (Ot = y || Ot !== 0 ? Ot : 0, !(ot ? uu(ot, kt) : M(De, kt, y))) {
              for (q = B; --q; ) {
                var sn = J[q];
                if (!(sn ? uu(sn, kt) : M(s[q], kt, y)))
                  continue e;
              }
              ot && ot.push(kt), De.push(Ot);
            }
          }
        return De;
      }
      function mu(s, d, y, M) {
        return ni(s, function(I, B, q) {
          d(M, y(I), B, q);
        }), M;
      }
      function ki(s, d, y) {
        d = wo(d, s), s = Ea(s, d);
        var M = s == null ? s : s[hl(lo(d))];
        return M == null ? a : Ja(M, s, y);
      }
      function ld(s) {
        return ca(s) && Wa(s) == Qe;
      }
      function dv(s) {
        return ca(s) && Wa(s) == Sn;
      }
      function gu(s) {
        return ca(s) && Wa(s) == _n;
      }
      function ai(s, d, y, M, I) {
        return s === d ? !0 : s == null || d == null || !ca(s) && !ca(d) ? s !== s && d !== d : gc(s, d, y, M, ai, I);
      }
      function gc(s, d, y, M, I, B) {
        var q = un(s), J = un(d), se = q ? et : za(s), De = J ? et : za(d);
        se = se == Qe ? ft : se, De = De == Qe ? ft : De;
        var Ie = se == ft, Be = De == ft, ot = se == De;
        if (ot && ml(s)) {
          if (!ml(d))
            return !1;
          q = !0, Ie = !1;
        }
        if (ot && !Ie)
          return B || (B = new Mr()), q || ws(s) ? zh(s, d, y, M, I, B) : pd(s, d, se, y, M, I, B);
        if (!(y & L)) {
          var Ot = Ie && En.call(s, "__wrapped__"), kt = Be && En.call(d, "__wrapped__");
          if (Ot || kt) {
            var sn = Ot ? s.value() : s, Yt = kt ? d.value() : d;
            return B || (B = new Mr()), I(sn, Yt, y, M, B);
          }
        }
        return ot ? (B || (B = new Mr()), vv(s, d, y, M, I, B)) : !1;
      }
      function hv(s) {
        return ca(s) && za(s) == yr;
      }
      function J1(s, d, y, M) {
        var I = y.length, B = I, q = !M;
        if (s == null)
          return !B;
        for (s = nr(s); I--; ) {
          var J = y[I];
          if (q && J[2] ? J[1] !== s[J[0]] : !(J[0] in s))
            return !1;
        }
        for (; ++I < B; ) {
          J = y[I];
          var se = J[0], De = s[se], Ie = J[1];
          if (q && J[2]) {
            if (De === a && !(se in s))
              return !1;
          } else {
            var Be = new Mr();
            if (M)
              var ot = M(De, Ie, se, s, d, Be);
            if (!(ot === a ? ai(Ie, De, L | P, M, Be) : ot))
              return !1;
          }
        }
        return !0;
      }
      function Bh(s) {
        if (!Kr(s) || Gh(s))
          return !1;
        var d = gs(s) ? Hh : Rr;
        return d.test(Zi(s));
      }
      function wc(s) {
        return ca(s) && Wa(s) == Nt;
      }
      function Vl(s) {
        return ca(s) && za(s) == gn;
      }
      function yc(s) {
        return ca(s) && Ou(s.length) && !!Hn[Wa(s)];
      }
      function $s(s) {
        return typeof s == "function" ? s : s == null ? Bi : typeof s == "object" ? un(s) ? tt(s[0], s[1]) : e0(s) : $3(s);
      }
      function wu(s) {
        if (!ul(s))
          return $1(s);
        var d = [];
        for (var y in nr(s))
          En.call(s, y) && y != "constructor" && d.push(y);
        return d;
      }
      function ud(s) {
        if (!Kr(s))
          return h0(s);
        var d = ul(s), y = [];
        for (var M in s)
          M == "constructor" && (d || !En.call(s, M)) || y.push(M);
        return y;
      }
      function Ju(s, d) {
        return s < d;
      }
      function Fh(s, d) {
        var y = -1, M = si(s) ? ge(s.length) : [];
        return Zl(s, function(I, B, q) {
          M[++y] = d(I, B, q);
        }), M;
      }
      function e0(s) {
        var d = us(s);
        return d.length == 1 && d[0][2] ? sl(d[0][0], d[0][1]) : function(y) {
          return y === s || J1(y, s, d);
        };
      }
      function tt(s, d) {
        return ht(s) && cs(d) ? sl(hl(s), d) : function(y) {
          var M = ym(y, s);
          return M === a && M === d ? xm(y, s) : ai(d, M, L | P);
        };
      }
      function on(s, d, y, M, I) {
        s !== d && ad(d, function(B, q) {
          if (I || (I = new Mr()), Kr(B))
            Pn(s, d, q, y, on, M, I);
          else {
            var J = M ? M(Fl(s, q), B, q + "", s, d, I) : a;
            J === a && (J = B), Q1(s, q, J);
          }
        }, Ni);
      }
      function Pn(s, d, y, M, I, B, q) {
        var J = Fl(s, y), se = Fl(d, y), De = q.get(se);
        if (De) {
          Q1(s, y, De);
          return;
        }
        var Ie = B ? B(J, se, y + "", s, d, q) : a, Be = Ie === a;
        if (Be) {
          var ot = un(se), Ot = !ot && ml(se), kt = !ot && !Ot && ws(se);
          Ie = se, ot || Ot || kt ? un(J) ? Ie = J : wa(J) ? Ie = _a(J) : Ot ? (Be = !1, Ie = Rc(se, !0)) : kt ? (Be = !1, Ie = os(se, !0)) : Ie = [] : $c(se) || u1(se) ? (Ie = J, u1(J) ? Ie = c1(J) : (!Kr(J) || gs(J)) && (Ie = Ra(se))) : Be = !1;
        }
        Be && (q.set(se, Ie), I(Ie, se, M, B, q), q.delete(se)), Q1(s, y, Ie);
      }
      function _r(s, d) {
        var y = s.length;
        if (y)
          return d += d < 0 ? y : 0, Or(d, y) ? s[d] : a;
      }
      function Po(s, d, y) {
        d.length ? d = hr(d, function(B) {
          return un(B) ? function(q) {
            return pr(q, B.length === 1 ? B[0] : B);
          } : B;
        }) : d = [Bi];
        var M = -1;
        d = hr(d, Ba(jt()));
        var I = Fh(s, function(B, q, J) {
          var se = hr(d, function(De) {
            return De(B);
          });
          return { criteria: se, index: ++M, value: B };
        });
        return aa(I, function(B, q) {
          return Qp(B, q, y);
        });
      }
      function sd(s, d) {
        return es(s, d, function(y, M) {
          return xm(s, M);
        });
      }
      function es(s, d, y) {
        for (var M = -1, I = d.length, B = {}; ++M < I; ) {
          var q = d[M], J = pr(s, q);
          y(J, q) && no(B, wo(q, s), J);
        }
        return B;
      }
      function Ar(s) {
        return function(d) {
          return pr(d, s);
        };
      }
      function $r(s, d, y, M) {
        var I = M ? tc : Uu, B = -1, q = d.length, J = s;
        for (s === d && (d = _a(d)), y && (J = hr(s, Ba(y))); ++B < q; )
          for (var se = 0, De = d[B], Ie = y ? y(De) : De; (se = I(J, Ie, se, M)) > -1; )
            J !== s && F1.call(J, se, 1), F1.call(s, se, 1);
        return s;
      }
      function Wr(s, d) {
        for (var y = s ? d.length : 0, M = y - 1; y--; ) {
          var I = d[y];
          if (y == M || I !== B) {
            var B = I;
            Or(I) ? F1.call(s, I, 1) : n0(s, I);
          }
        }
        return s;
      }
      function He(s, d) {
        return s + cu(fu() * (d - s + 1));
      }
      function Vr(s, d, y, M) {
        for (var I = -1, B = oa($u((d - s) / (y || 1)), 0), q = ge(B); B--; )
          q[M ? B : ++I] = s, s += y;
        return q;
      }
      function It(s, d) {
        var y = "";
        if (!s || d < 1 || d > ie)
          return y;
        do
          d % 2 && (y += s), d = cu(d / 2), d && (s += s);
        while (d);
        return y;
      }
      function tn(s, d) {
        return ii(cl(s, d, Bi), s + "");
      }
      function Tr(s) {
        return nl(f1(s));
      }
      function yu(s, d) {
        var y = f1(s);
        return t1(y, pu(d, 0, y.length));
      }
      function no(s, d, y, M) {
        if (!Kr(s))
          return s;
        d = wo(d, s);
        for (var I = -1, B = d.length, q = B - 1, J = s; J != null && ++I < B; ) {
          var se = hl(d[I]), De = y;
          if (se === "__proto__" || se === "constructor" || se === "prototype")
            return s;
          if (I != q) {
            var Ie = J[se];
            De = M ? M(Ie, se, J) : a, De === a && (De = Kr(Ie) ? Ie : Or(d[I + 1]) ? [] : {});
          }
          Ys(J, se, De), J = J[se];
        }
        return s;
      }
      var ts = z1 ? function(s, d) {
        return z1.set(s, d), s;
      } : Bi, go = U1 ? function(s, d) {
        return U1(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Om(d),
          writable: !0
        });
      } : Bi;
      function ro(s) {
        return t1(f1(s));
      }
      function ba(s, d, y) {
        var M = -1, I = s.length;
        d < 0 && (d = -d > I ? 0 : I + d), y = y > I ? I : y, y < 0 && (y += I), I = d > y ? 0 : y - d >>> 0, d >>>= 0;
        for (var B = ge(I); ++M < I; )
          B[M] = s[M + d];
        return B;
      }
      function xc(s, d) {
        var y;
        return Zl(s, function(M, I, B) {
          return y = d(M, I, B), !y;
        }), !!y;
      }
      function ns(s, d, y) {
        var M = 0, I = s == null ? M : s.length;
        if (typeof d == "number" && d === d && I <= Vt) {
          for (; M < I; ) {
            var B = M + I >>> 1, q = s[B];
            q !== null && !ci(q) && (y ? q <= d : q < d) ? M = B + 1 : I = B;
          }
          return I;
        }
        return t0(s, d, Bi, y);
      }
      function t0(s, d, y, M) {
        var I = 0, B = s == null ? 0 : s.length;
        if (B === 0)
          return 0;
        d = y(d);
        for (var q = d !== d, J = d === null, se = ci(d), De = d === a; I < B; ) {
          var Ie = cu((I + B) / 2), Be = y(s[Ie]), ot = Be !== a, Ot = Be === null, kt = Be === Be, sn = ci(Be);
          if (q)
            var Yt = M || kt;
          else De ? Yt = kt && (M || ot) : J ? Yt = kt && ot && (M || !Ot) : se ? Yt = kt && ot && !Ot && (M || !sn) : Ot || sn ? Yt = !1 : Yt = M ? Be <= d : Be < d;
          Yt ? I = Ie + 1 : B = Ie;
        }
        return to(B, Pe);
      }
      function Sc(s, d) {
        for (var y = -1, M = s.length, I = 0, B = []; ++y < M; ) {
          var q = s[y], J = d ? d(q) : q;
          if (!y || !Bo(J, se)) {
            var se = J;
            B[I++] = q === 0 ? 0 : q;
          }
        }
        return B;
      }
      function Cc(s) {
        return typeof s == "number" ? s : ci(s) ? Ze : +s;
      }
      function ao(s) {
        if (typeof s == "string")
          return s;
        if (un(s))
          return hr(s, ao) + "";
        if (ci(s))
          return Xf ? Xf.call(s) : "";
        var d = s + "";
        return d == "0" && 1 / s == -1 / 0 ? "-0" : d;
      }
      function il(s, d, y) {
        var M = -1, I = Zf, B = s.length, q = !0, J = [], se = J;
        if (y)
          q = !1, I = Ah;
        else if (B >= h) {
          var De = d ? null : Oc(s);
          if (De)
            return Yu(De);
          q = !1, I = uu, se = new vu();
        } else
          se = d ? [] : J;
        e:
          for (; ++M < B; ) {
            var Ie = s[M], Be = d ? d(Ie) : Ie;
            if (Ie = y || Ie !== 0 ? Ie : 0, q && Be === Be) {
              for (var ot = se.length; ot--; )
                if (se[ot] === Be)
                  continue e;
              d && se.push(Be), J.push(Ie);
            } else I(se, Be, y) || (se !== J && se.push(Be), J.push(Ie));
          }
        return J;
      }
      function n0(s, d) {
        return d = wo(d, s), s = Ea(s, d), s == null || delete s[hl(lo(d))];
      }
      function bc(s, d, y, M) {
        return no(s, d, y(pr(s, d)), M);
      }
      function Ws(s, d, y, M) {
        for (var I = s.length, B = M ? I : -1; (M ? B-- : ++B < I) && d(s[B], B, s); )
          ;
        return y ? ba(s, M ? 0 : B, M ? B + 1 : I) : ba(s, M ? B + 1 : 0, M ? I : B);
      }
      function rs(s, d) {
        var y = s;
        return y instanceof Kt && (y = y.value()), ec(d, function(M, I) {
          return I.func.apply(I.thisArg, iu([M], I.args));
        }, y);
      }
      function r0(s, d, y) {
        var M = s.length;
        if (M < 2)
          return M ? il(s[0]) : [];
        for (var I = -1, B = ge(M); ++I < M; )
          for (var q = s[I], J = -1; ++J < M; )
            J != I && (B[I] = ji(B[I] || q, s[J], d, y));
        return il(Zn(B, 1), d, y);
      }
      function zs(s, d, y) {
        for (var M = -1, I = s.length, B = d.length, q = {}; ++M < I; ) {
          var J = M < B ? d[M] : a;
          y(q, s[M], J);
        }
        return q;
      }
      function as(s) {
        return wa(s) ? s : [];
      }
      function qs(s) {
        return typeof s == "function" ? s : Bi;
      }
      function wo(s, d) {
        return un(s) ? s : ht(s, d) ? [s] : xd(Cn(s));
      }
      var cd = tn;
      function ll(s, d, y) {
        var M = s.length;
        return y = y === a ? M : y, !d && y >= M ? s : ba(s, d, y);
      }
      var _c = sv || function(s) {
        return Sr.clearTimeout(s);
      };
      function Rc(s, d) {
        if (d)
          return s.slice();
        var y = s.length, M = Bs ? Bs(y) : new s.constructor(y);
        return s.copy(M), M;
      }
      function a0(s) {
        var d = new s.constructor(s.byteLength);
        return new lc(d).set(new lc(s)), d;
      }
      function o0(s, d) {
        var y = d ? a0(s.buffer) : s.buffer;
        return new s.constructor(y, s.byteOffset, s.byteLength);
      }
      function Uh(s) {
        var d = new s.constructor(s.source, dn.exec(s));
        return d.lastIndex = s.lastIndex, d;
      }
      function i0(s) {
        return Jo ? nr(Jo.call(s)) : {};
      }
      function os(s, d) {
        var y = d ? a0(s.buffer) : s.buffer;
        return new s.constructor(y, s.byteOffset, s.length);
      }
      function Vo(s, d) {
        if (s !== d) {
          var y = s !== a, M = s === null, I = s === s, B = ci(s), q = d !== a, J = d === null, se = d === d, De = ci(d);
          if (!J && !De && !B && s > d || B && q && se && !J && !De || M && q && se || !y && se || !I)
            return 1;
          if (!M && !B && !De && s < d || De && y && I && !M && !B || J && y && I || !q && I || !se)
            return -1;
        }
        return 0;
      }
      function Qp(s, d, y) {
        for (var M = -1, I = s.criteria, B = d.criteria, q = I.length, J = y.length; ++M < q; ) {
          var se = Vo(I[M], B[M]);
          if (se) {
            if (M >= J)
              return se;
            var De = y[M];
            return se * (De == "desc" ? -1 : 1);
          }
        }
        return s.index - d.index;
      }
      function dr(s, d, y, M) {
        for (var I = -1, B = s.length, q = y.length, J = -1, se = d.length, De = oa(B - q, 0), Ie = ge(se + De), Be = !M; ++J < se; )
          Ie[J] = d[J];
        for (; ++I < q; )
          (Be || I < B) && (Ie[y[I]] = s[I]);
        for (; De--; )
          Ie[J++] = s[I++];
        return Ie;
      }
      function l0(s, d, y, M) {
        for (var I = -1, B = s.length, q = -1, J = y.length, se = -1, De = d.length, Ie = oa(B - J, 0), Be = ge(Ie + De), ot = !M; ++I < Ie; )
          Be[I] = s[I];
        for (var Ot = I; ++se < De; )
          Be[Ot + se] = d[se];
        for (; ++q < J; )
          (ot || I < B) && (Be[Ot + y[q]] = s[I++]);
        return Be;
      }
      function _a(s, d) {
        var y = -1, M = s.length;
        for (d || (d = ge(M)); ++y < M; )
          d[y] = s[y];
        return d;
      }
      function yo(s, d, y, M) {
        var I = !y;
        y || (y = {});
        for (var B = -1, q = d.length; ++B < q; ) {
          var J = d[B], se = M ? M(y[J], s[J], J, y, s) : a;
          se === a && (se = s[J]), I ? Hl(y, J, se) : Ys(y, J, se);
        }
        return y;
      }
      function Gs(s, d) {
        return yo(s, rr(s), d);
      }
      function Xp(s, d) {
        return yo(s, pv(s), d);
      }
      function fd(s, d) {
        return function(y, M) {
          var I = un(y) ? Hf : Zo, B = d ? d() : {};
          return I(y, s, jt(M, 2), B);
        };
      }
      function u0(s) {
        return tn(function(d, y) {
          var M = -1, I = y.length, B = I > 1 ? y[I - 1] : a, q = I > 2 ? y[2] : a;
          for (B = s.length > 3 && typeof B == "function" ? (I--, B) : a, q && io(y[0], y[1], q) && (B = I < 3 ? a : B, I = 1), d = nr(d); ++M < I; ) {
            var J = y[M];
            J && s(d, J, M, B);
          }
          return d;
        });
      }
      function Li(s, d) {
        return function(y, M) {
          if (y == null)
            return y;
          if (!si(y))
            return s(y, M);
          for (var I = y.length, B = d ? I : -1, q = nr(y); (d ? B-- : ++B < I) && M(q[B], B, q) !== !1; )
            ;
          return y;
        };
      }
      function s0(s) {
        return function(d, y, M) {
          for (var I = -1, B = nr(d), q = M(d), J = q.length; J--; ) {
            var se = q[s ? J : ++I];
            if (y(B[se], se, B) === !1)
              break;
          }
          return d;
        };
      }
      function dd(s, d, y) {
        var M = d & V, I = c0(s);
        function B() {
          var q = this && this !== Sr && this instanceof B ? I : s;
          return q.apply(M ? y : this, arguments);
        }
        return B;
      }
      function Ec(s) {
        return function(d) {
          d = Cn(d);
          var y = Z1(d) ? Go(d) : a, M = y ? y[0] : d.charAt(0), I = y ? ll(y, 1).join("") : d.slice(1);
          return M[s]() + I;
        };
      }
      function is(s) {
        return function(d) {
          return ec(F3(Fv(d).replace(Dh, "")), s, "");
        };
      }
      function c0(s) {
        return function() {
          var d = arguments;
          switch (d.length) {
            case 0:
              return new s();
            case 1:
              return new s(d[0]);
            case 2:
              return new s(d[0], d[1]);
            case 3:
              return new s(d[0], d[1], d[2]);
            case 4:
              return new s(d[0], d[1], d[2], d[3]);
            case 5:
              return new s(d[0], d[1], d[2], d[3], d[4]);
            case 6:
              return new s(d[0], d[1], d[2], d[3], d[4], d[5]);
            case 7:
              return new s(d[0], d[1], d[2], d[3], d[4], d[5], d[6]);
          }
          var y = Xi(s.prototype), M = s.apply(y, d);
          return Kr(M) ? M : y;
        };
      }
      function Yh(s, d, y) {
        var M = c0(s);
        function I() {
          for (var B = arguments.length, q = ge(B), J = B, se = zr(I); J--; )
            q[J] = arguments[J];
          var De = B < 3 && q[0] !== se && q[B - 1] !== se ? [] : qo(q, se);
          if (B -= De.length, B < y)
            return ua(
              s,
              d,
              Ks,
              I.placeholder,
              a,
              q,
              De,
              a,
              a,
              y - B
            );
          var Ie = this && this !== Sr && this instanceof I ? M : s;
          return Ja(Ie, this, q);
        }
        return I;
      }
      function Nl(s) {
        return function(d, y, M) {
          var I = nr(d);
          if (!si(d)) {
            var B = jt(y, 3);
            d = uo(d), y = function(J) {
              return B(I[J], J, I);
            };
          }
          var q = s(d, y, M);
          return q > -1 ? I[B ? d[q] : q] : a;
        };
      }
      function hd(s) {
        return Ii(function(d) {
          var y = d.length, M = y, I = zt.prototype.thru;
          for (s && d.reverse(); M--; ) {
            var B = d[M];
            if (typeof B != "function")
              throw new Mi(m);
            if (I && !q && Xs(B) == "wrapper")
              var q = new zt([], !0);
          }
          for (M = q ? M : y; ++M < y; ) {
            B = d[M];
            var J = Xs(B), se = J == "wrapper" ? Ac(B) : a;
            se && kc(se[0]) && se[1] == (te | W | $ | Se) && !se[4].length && se[9] == 1 ? q = q[Xs(se[0])].apply(q, se[3]) : q = B.length == 1 && kc(B) ? q[J]() : q.thru(B);
          }
          return function() {
            var De = arguments, Ie = De[0];
            if (q && De.length == 1 && un(Ie))
              return q.plant(Ie).value();
            for (var Be = 0, ot = y ? d[Be].apply(this, De) : Ie; ++Be < y; )
              ot = d[Be].call(this, ot);
            return ot;
          };
        });
      }
      function Ks(s, d, y, M, I, B, q, J, se, De) {
        var Ie = d & te, Be = d & V, ot = d & F, Ot = d & (W | Q), kt = d & re, sn = ot ? a : c0(s);
        function Yt() {
          for (var rn = arguments.length, cn = ge(rn), mr = rn; mr--; )
            cn[mr] = arguments[mr];
          if (Ot)
            var ar = zr(Yt), di = tv(cn, ar);
          if (M && (cn = dr(cn, M, I, Ot)), B && (cn = l0(cn, B, q, Ot)), rn -= di, Ot && rn < De) {
            var $n = qo(cn, ar);
            return ua(
              s,
              d,
              Ks,
              Yt.placeholder,
              y,
              cn,
              $n,
              J,
              se,
              De - rn
            );
          }
          var Ga = Be ? y : this, so = ot ? Ga[s] : s;
          return rn = cn.length, J ? cn = fl(cn, J) : kt && rn > 1 && cn.reverse(), Ie && se < rn && (cn.length = se), this && this !== Sr && this instanceof Yt && (so = sn || c0(so)), so.apply(Ga, cn);
        }
        return Yt;
      }
      function $h(s, d) {
        return function(y, M) {
          return mu(y, s, d(M), {});
        };
      }
      function Mc(s, d) {
        return function(y, M) {
          var I;
          if (y === a && M === a)
            return d;
          if (y !== a && (I = y), M !== a) {
            if (I === a)
              return M;
            typeof y == "string" || typeof M == "string" ? (y = ao(y), M = ao(M)) : (y = Cc(y), M = Cc(M)), I = s(y, M);
          }
          return I;
        };
      }
      function Bl(s) {
        return Ii(function(d) {
          return d = hr(d, Ba(jt())), tn(function(y) {
            var M = this;
            return s(d, function(I) {
              return Ja(I, M, y);
            });
          });
        });
      }
      function xu(s, d) {
        d = d === a ? " " : ao(d);
        var y = d.length;
        if (y < 2)
          return y ? It(d, s) : d;
        var M = It(d, $u(s / Ps(d)));
        return Z1(d) ? ll(Go(M), 0, s).join("") : M.slice(0, s);
      }
      function ls(s, d, y, M) {
        var I = d & V, B = c0(s);
        function q() {
          for (var J = -1, se = arguments.length, De = -1, Ie = M.length, Be = ge(Ie + se), ot = this && this !== Sr && this instanceof q ? B : s; ++De < Ie; )
            Be[De] = M[De];
          for (; se--; )
            Be[De++] = arguments[++J];
          return Ja(ot, I ? y : this, Be);
        }
        return q;
      }
      function Tc(s) {
        return function(d, y, M) {
          return M && typeof M != "number" && io(d, y, M) && (y = M = a), d = s1(d), y === a ? (y = d, d = 0) : y = s1(y), M = M === a ? d < y ? 1 : -1 : s1(M), Vr(d, y, M, s);
        };
      }
      function oo(s) {
        return function(d, y) {
          return typeof d == "string" && typeof y == "string" || (d = fi(d), y = fi(y)), s(d, y);
        };
      }
      function ua(s, d, y, M, I, B, q, J, se, De) {
        var Ie = d & W, Be = Ie ? q : a, ot = Ie ? a : q, Ot = Ie ? B : a, kt = Ie ? a : B;
        d |= Ie ? $ : le, d &= ~(Ie ? le : $), d & Y || (d &= -4);
        var sn = [
          s,
          d,
          I,
          Ot,
          Be,
          kt,
          ot,
          J,
          se,
          De
        ], Yt = y.apply(a, sn);
        return kc(s) && wd(Yt, sn), Yt.placeholder = M, yd(Yt, s, d);
      }
      function At(s) {
        var d = Cr[s];
        return function(y, M) {
          if (y = fi(y), M = M == null ? 0 : to(Ft(M), 292), M && Y1(y)) {
            var I = (Cn(y) + "e").split("e"), B = d(I[0] + "e" + (+I[1] + M));
            return I = (Cn(B) + "e").split("e"), +(I[0] + "e" + (+I[1] - M));
          }
          return d(y);
        };
      }
      var Oc = Qo && 1 / Yu(new Qo([, -0]))[1] == Ue ? function(s) {
        return new Qo(s);
      } : zc;
      function vd(s) {
        return function(d) {
          var y = za(d);
          return y == yr ? V1(d) : y == gn ? zp(d) : Nf(d, s(d));
        };
      }
      function Su(s, d, y, M, I, B, q, J) {
        var se = d & F;
        if (!se && typeof s != "function")
          throw new Mi(m);
        var De = M ? M.length : 0;
        if (De || (d &= -97, M = I = a), q = q === a ? q : oa(Ft(q), 0), J = J === a ? J : Ft(J), De -= I ? I.length : 0, d & le) {
          var Ie = M, Be = I;
          M = I = a;
        }
        var ot = se ? a : Ac(s), Ot = [
          s,
          d,
          y,
          M,
          I,
          Ie,
          Be,
          B,
          q,
          J
        ];
        if (ot && bu(Ot, ot), s = Ot[0], d = Ot[1], y = Ot[2], M = Ot[3], I = Ot[4], J = Ot[9] = Ot[9] === a ? se ? 0 : s.length : oa(Ot[9] - De, 0), !J && d & (W | Q) && (d &= -25), !d || d == V)
          var kt = dd(s, d, y);
        else d == W || d == Q ? kt = Yh(s, d, J) : (d == $ || d == (V | $)) && !I.length ? kt = ls(s, d, y, M) : kt = Ks.apply(a, Ot);
        var sn = ot ? ts : wd;
        return yd(sn(kt, Ot), s, d);
      }
      function Wh(s, d, y, M) {
        return s === a || Bo(s, kl[y]) && !En.call(M, y) ? d : s;
      }
      function Dc(s, d, y, M, I, B) {
        return Kr(s) && Kr(d) && (B.set(d, s), on(s, d, a, Dc, B), B.delete(d)), s;
      }
      function Qs(s) {
        return $c(s) ? a : s;
      }
      function zh(s, d, y, M, I, B) {
        var q = y & L, J = s.length, se = d.length;
        if (J != se && !(q && se > J))
          return !1;
        var De = B.get(s), Ie = B.get(d);
        if (De && Ie)
          return De == d && Ie == s;
        var Be = -1, ot = !0, Ot = y & P ? new vu() : a;
        for (B.set(s, d), B.set(d, s); ++Be < J; ) {
          var kt = s[Be], sn = d[Be];
          if (M)
            var Yt = q ? M(sn, kt, Be, d, s, B) : M(kt, sn, Be, s, d, B);
          if (Yt !== a) {
            if (Yt)
              continue;
            ot = !1;
            break;
          }
          if (Ot) {
            if (!Pf(d, function(rn, cn) {
              if (!uu(Ot, cn) && (kt === rn || I(kt, rn, y, M, B)))
                return Ot.push(cn);
            })) {
              ot = !1;
              break;
            }
          } else if (!(kt === sn || I(kt, sn, y, M, B))) {
            ot = !1;
            break;
          }
        }
        return B.delete(s), B.delete(d), ot;
      }
      function pd(s, d, y, M, I, B, q) {
        switch (y) {
          case qe:
            if (s.byteLength != d.byteLength || s.byteOffset != d.byteOffset)
              return !1;
            s = s.buffer, d = d.buffer;
          case Sn:
            return !(s.byteLength != d.byteLength || !B(new lc(s), new lc(d)));
          case St:
          case _n:
          case ea:
            return Bo(+s, +d);
          case kn:
            return s.name == d.name && s.message == d.message;
          case Nt:
          case zn:
            return s == d + "";
          case yr:
            var J = V1;
          case gn:
            var se = M & L;
            if (J || (J = Yu), s.size != d.size && !se)
              return !1;
            var De = q.get(s);
            if (De)
              return De == d;
            M |= P, q.set(s, d);
            var Ie = zh(J(s), J(d), M, I, B, q);
            return q.delete(s), Ie;
          case Ur:
            if (Jo)
              return Jo.call(s) == Jo.call(d);
        }
        return !1;
      }
      function vv(s, d, y, M, I, B) {
        var q = y & L, J = jc(s), se = J.length, De = jc(d), Ie = De.length;
        if (se != Ie && !q)
          return !1;
        for (var Be = se; Be--; ) {
          var ot = J[Be];
          if (!(q ? ot in d : En.call(d, ot)))
            return !1;
        }
        var Ot = B.get(s), kt = B.get(d);
        if (Ot && kt)
          return Ot == d && kt == s;
        var sn = !0;
        B.set(s, d), B.set(d, s);
        for (var Yt = q; ++Be < se; ) {
          ot = J[Be];
          var rn = s[ot], cn = d[ot];
          if (M)
            var mr = q ? M(cn, rn, ot, d, s, B) : M(rn, cn, ot, s, d, B);
          if (!(mr === a ? rn === cn || I(rn, cn, y, M, B) : mr)) {
            sn = !1;
            break;
          }
          Yt || (Yt = ot == "constructor");
        }
        if (sn && !Yt) {
          var ar = s.constructor, di = d.constructor;
          ar != di && "constructor" in s && "constructor" in d && !(typeof ar == "function" && ar instanceof ar && typeof di == "function" && di instanceof di) && (sn = !1);
        }
        return B.delete(s), B.delete(d), sn;
      }
      function Ii(s) {
        return ii(cl(s, a, Cd), s + "");
      }
      function jc(s) {
        return od(s, uo, rr);
      }
      function f0(s) {
        return od(s, Ni, pv);
      }
      var Ac = z1 ? function(s) {
        return z1.get(s);
      } : zc;
      function Xs(s) {
        for (var d = s.name + "", y = q1[d], M = En.call(q1, d) ? y.length : 0; M--; ) {
          var I = y[M], B = I.func;
          if (B == null || B == s)
            return I.name;
        }
        return d;
      }
      function zr(s) {
        var d = En.call(H, "placeholder") ? H : s;
        return d.placeholder;
      }
      function jt() {
        var s = H.iteratee || Dm;
        return s = s === Dm ? $s : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function oi(s, d) {
        var y = s.__data__;
        return Js(d) ? y[typeof d == "string" ? "string" : "hash"] : y.map;
      }
      function us(s) {
        for (var d = uo(s), y = d.length; y--; ) {
          var M = d[y], I = s[M];
          d[y] = [M, I, cs(I)];
        }
        return d;
      }
      function Hi(s, d) {
        var y = H1(s, d);
        return Bh(y) ? y : a;
      }
      function No(s) {
        var d = En.call(s, Ti), y = s[Ti];
        try {
          s[Ti] = a;
          var M = !0;
        } catch {
        }
        var I = ic.call(s);
        return M && (d ? s[Ti] = y : delete s[Ti]), I;
      }
      var rr = uc ? function(s) {
        return s == null ? [] : (s = nr(s), ou(uc(s), function(d) {
          return Gf.call(s, d);
        }));
      } : km, pv = uc ? function(s) {
        for (var d = []; s; )
          iu(d, rr(s)), s = Qi(s);
        return d;
      } : km, za = Wa;
      (W1 && za(new W1(new ArrayBuffer(1))) != qe || du && za(new du()) != yr || hc && za(hc.resolve()) != fn || Qo && za(new Qo()) != gn || Wu && za(new Wu()) != Jt) && (za = function(s) {
        var d = Wa(s), y = d == ft ? s.constructor : a, M = y ? Zi(y) : "";
        if (M)
          switch (M) {
            case vc:
              return qe;
            case zu:
              return yr;
            case cv:
              return fn;
            case G1:
              return gn;
            case Oi:
              return Jt;
          }
        return d;
      });
      function qh(s, d, y) {
        for (var M = -1, I = y.length; ++M < I; ) {
          var B = y[M], q = B.size;
          switch (B.type) {
            case "drop":
              s += q;
              break;
            case "dropRight":
              d -= q;
              break;
            case "take":
              d = to(d, s + q);
              break;
            case "takeRight":
              s = oa(s, d - q);
              break;
          }
        }
        return { start: s, end: d };
      }
      function md(s) {
        var d = s.match(X);
        return d ? d[1].split($e) : [];
      }
      function gd(s, d, y) {
        d = wo(d, s);
        for (var M = -1, I = d.length, B = !1; ++M < I; ) {
          var q = hl(d[M]);
          if (!(B = s != null && y(s, q)))
            break;
          s = s[q];
        }
        return B || ++M != I ? B : (I = s == null ? 0 : s.length, !!I && Ou(I) && Or(q, I) && (un(s) || u1(s)));
      }
      function ss(s) {
        var d = s.length, y = new s.constructor(d);
        return d && typeof s[0] == "string" && En.call(s, "index") && (y.index = s.index, y.input = s.input), y;
      }
      function Ra(s) {
        return typeof s.constructor == "function" && !ul(s) ? Xi(Qi(s)) : {};
      }
      function Jp(s, d, y) {
        var M = s.constructor;
        switch (d) {
          case Sn:
            return a0(s);
          case St:
          case _n:
            return new M(+s);
          case qe:
            return o0(s, y);
          case yt:
          case Ct:
          case ln:
          case cr:
          case ta:
          case xr:
          case Ao:
          case wn:
          case Gn:
            return os(s, y);
          case yr:
            return new M();
          case ea:
          case zn:
            return new M(s);
          case Nt:
            return Uh(s);
          case gn:
            return new M();
          case Ur:
            return i0(s);
        }
      }
      function em(s, d) {
        var y = d.length;
        if (!y)
          return s;
        var M = y - 1;
        return d[M] = (y > 1 ? "& " : "") + d[M], d = d.join(y > 2 ? ", " : " "), s.replace(Gi, `{
/* [wrapped with ` + d + `] */
`);
      }
      function d0(s) {
        return un(s) || u1(s) || !!(Kf && s && s[Kf]);
      }
      function Or(s, d) {
        var y = typeof s;
        return d = d ?? ie, !!d && (y == "number" || y != "symbol" && ho.test(s)) && s > -1 && s % 1 == 0 && s < d;
      }
      function io(s, d, y) {
        if (!Kr(y))
          return !1;
        var M = typeof d;
        return (M == "number" ? si(y) && Or(d, y.length) : M == "string" && d in y) ? Bo(y[d], s) : !1;
      }
      function ht(s, d) {
        if (un(s))
          return !1;
        var y = typeof s;
        return y == "number" || y == "symbol" || y == "boolean" || s == null || ci(s) ? !0 : Tl.test(s) || !Ml.test(s) || d != null && s in nr(d);
      }
      function Js(s) {
        var d = typeof s;
        return d == "string" || d == "number" || d == "symbol" || d == "boolean" ? s !== "__proto__" : s === null;
      }
      function kc(s) {
        var d = Xs(s), y = H[d];
        if (typeof y != "function" || !(d in Kt.prototype))
          return !1;
        if (s === y)
          return !0;
        var M = Ac(y);
        return !!M && s === M[0];
      }
      function Gh(s) {
        return !!Wf && Wf in s;
      }
      var tm = Vs ? gs : Lm;
      function ul(s) {
        var d = s && s.constructor, y = typeof d == "function" && d.prototype || kl;
        return s === y;
      }
      function cs(s) {
        return s === s && !Kr(s);
      }
      function sl(s, d) {
        return function(y) {
          return y == null ? !1 : y[s] === d && (d !== a || s in nr(y));
        };
      }
      function Cu(s) {
        var d = he(s, function(M) {
          return y.size === R && y.clear(), M;
        }), y = d.cache;
        return d;
      }
      function bu(s, d) {
        var y = s[1], M = d[1], I = y | M, B = I < (V | F | te), q = M == te && y == W || M == te && y == Se && s[7].length <= d[8] || M == (te | Se) && d[7].length <= d[8] && y == W;
        if (!(B || q))
          return s;
        M & V && (s[2] = d[2], I |= y & V ? 0 : Y);
        var J = d[3];
        if (J) {
          var se = s[3];
          s[3] = se ? dr(se, J, d[4]) : J, s[4] = se ? qo(s[3], D) : d[4];
        }
        return J = d[5], J && (se = s[5], s[5] = se ? l0(se, J, d[6]) : J, s[6] = se ? qo(s[5], D) : d[6]), J = d[7], J && (s[7] = J), M & te && (s[8] = s[8] == null ? d[8] : to(s[8], d[8])), s[9] == null && (s[9] = d[9]), s[0] = d[0], s[1] = I, s;
      }
      function h0(s) {
        var d = [];
        if (s != null)
          for (var y in nr(s))
            d.push(y);
        return d;
      }
      function e1(s) {
        return ic.call(s);
      }
      function cl(s, d, y) {
        return d = oa(d === a ? s.length - 1 : d, 0), function() {
          for (var M = arguments, I = -1, B = oa(M.length - d, 0), q = ge(B); ++I < B; )
            q[I] = M[d + I];
          I = -1;
          for (var J = ge(d + 1); ++I < d; )
            J[I] = M[I];
          return J[d] = y(q), Ja(s, this, J);
        };
      }
      function Ea(s, d) {
        return d.length < 2 ? s : pr(s, ba(d, 0, -1));
      }
      function fl(s, d) {
        for (var y = s.length, M = to(d.length, y), I = _a(s); M--; ) {
          var B = d[M];
          s[M] = Or(B, y) ? I[B] : a;
        }
        return s;
      }
      function Fl(s, d) {
        if (!(d === "constructor" && typeof s[d] == "function") && d != "__proto__")
          return s[d];
      }
      var wd = dl(ts), Ul = Zh || function(s, d) {
        return Sr.setTimeout(s, d);
      }, ii = dl(go);
      function yd(s, d, y) {
        var M = d + "";
        return ii(s, em(M, v0(md(M), y)));
      }
      function dl(s) {
        var d = 0, y = 0;
        return function() {
          var M = fc(), I = fe - (M - y);
          if (y = M, I > 0) {
            if (++d >= de)
              return arguments[0];
          } else
            d = 0;
          return s.apply(a, arguments);
        };
      }
      function t1(s, d) {
        var y = -1, M = s.length, I = M - 1;
        for (d = d === a ? M : d; ++y < d; ) {
          var B = He(y, I), q = s[B];
          s[B] = s[y], s[y] = q;
        }
        return s.length = d, s;
      }
      var xd = Cu(function(s) {
        var d = [];
        return s.charCodeAt(0) === 46 && d.push(""), s.replace(Wo, function(y, M, I, B) {
          d.push(I ? B.replace(Nn, "$1") : M || y);
        }), d;
      });
      function hl(s) {
        if (typeof s == "string" || ci(s))
          return s;
        var d = s + "";
        return d == "0" && 1 / s == -1 / 0 ? "-0" : d;
      }
      function Zi(s) {
        if (s != null) {
          try {
            return pa.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function v0(s, d) {
        return eo(Dt, function(y) {
          var M = "_." + y[0];
          d & y[1] && !Zf(s, M) && s.push(M);
        }), s.sort();
      }
      function n1(s) {
        if (s instanceof Kt)
          return s.clone();
        var d = new zt(s.__wrapped__, s.__chain__);
        return d.__actions__ = _a(s.__actions__), d.__index__ = s.__index__, d.__values__ = s.__values__, d;
      }
      function p0(s, d, y) {
        (y ? io(s, d, y) : d === a) ? d = 1 : d = oa(Ft(d), 0);
        var M = s == null ? 0 : s.length;
        if (!M || d < 1)
          return [];
        for (var I = 0, B = 0, q = ge($u(M / d)); I < M; )
          q[B++] = ba(s, I, I += d);
        return q;
      }
      function Sd(s) {
        for (var d = -1, y = s == null ? 0 : s.length, M = 0, I = []; ++d < y; ) {
          var B = s[d];
          B && (I[M++] = B);
        }
        return I;
      }
      function Pi() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var d = ge(s - 1), y = arguments[0], M = s; M--; )
          d[M - 1] = arguments[M];
        return iu(un(y) ? _a(y) : [y], Zn(d, 1));
      }
      var Mn = tn(function(s, d) {
        return wa(s) ? ji(s, Zn(d, 1, wa, !0)) : [];
      }), Ma = tn(function(s, d) {
        var y = lo(d);
        return wa(y) && (y = a), wa(s) ? ji(s, Zn(d, 1, wa, !0), jt(y, 2)) : [];
      }), sa = tn(function(s, d) {
        var y = lo(d);
        return wa(y) && (y = a), wa(s) ? ji(s, Zn(d, 1, wa, !0), a, y) : [];
      });
      function ma(s, d, y) {
        var M = s == null ? 0 : s.length;
        return M ? (d = y || d === a ? 1 : Ft(d), ba(s, d < 0 ? 0 : d, M)) : [];
      }
      function li(s, d, y) {
        var M = s == null ? 0 : s.length;
        return M ? (d = y || d === a ? 1 : Ft(d), d = M - d, ba(s, 0, d < 0 ? 0 : d)) : [];
      }
      function _u(s, d) {
        return s && s.length ? Ws(s, jt(d, 3), !0, !0) : [];
      }
      function qr(s, d) {
        return s && s.length ? Ws(s, jt(d, 3), !0) : [];
      }
      function m0(s, d, y, M) {
        var I = s == null ? 0 : s.length;
        return I ? (y && typeof y != "number" && io(s, d, y) && (y = 0, M = I), at(s, d, y, M)) : [];
      }
      function fs(s, d, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var I = y == null ? 0 : Ft(y);
        return I < 0 && (I = oa(M + I, 0)), I1(s, jt(d, 3), I);
      }
      function Lc(s, d, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var I = M - 1;
        return y !== a && (I = Ft(y), I = y < 0 ? oa(M + I, 0) : to(I, M - 1)), I1(s, jt(d, 3), I, !0);
      }
      function Cd(s) {
        var d = s == null ? 0 : s.length;
        return d ? Zn(s, 1) : [];
      }
      function Ic(s) {
        var d = s == null ? 0 : s.length;
        return d ? Zn(s, Ue) : [];
      }
      function Ta(s, d) {
        var y = s == null ? 0 : s.length;
        return y ? (d = d === a ? 1 : Ft(d), Zn(s, d)) : [];
      }
      function Hc(s) {
        for (var d = -1, y = s == null ? 0 : s.length, M = {}; ++d < y; ) {
          var I = s[d];
          M[I[0]] = I[1];
        }
        return M;
      }
      function vl(s) {
        return s && s.length ? s[0] : a;
      }
      function Ru(s, d, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var I = y == null ? 0 : Ft(y);
        return I < 0 && (I = oa(M + I, 0)), Uu(s, d, I);
      }
      function bd(s) {
        var d = s == null ? 0 : s.length;
        return d ? ba(s, 0, -1) : [];
      }
      var _d = tn(function(s) {
        var d = hr(s, as);
        return d.length && d[0] === s[0] ? id(d) : [];
      }), Eu = tn(function(s) {
        var d = lo(s), y = hr(s, as);
        return d === lo(y) ? d = a : y.pop(), y.length && y[0] === s[0] ? id(y, jt(d, 2)) : [];
      }), r1 = tn(function(s) {
        var d = lo(s), y = hr(s, as);
        return d = typeof d == "function" ? d : a, d && y.pop(), y.length && y[0] === s[0] ? id(y, a, d) : [];
      });
      function pl(s, d) {
        return s == null ? "" : cc.call(s, d);
      }
      function lo(s) {
        var d = s == null ? 0 : s.length;
        return d ? s[d - 1] : a;
      }
      function qa(s, d, y) {
        var M = s == null ? 0 : s.length;
        if (!M)
          return -1;
        var I = M;
        return y !== a && (I = Ft(y), I = I < 0 ? oa(M + I, 0) : to(I, M - 1)), d === d ? qp(s, d, I) : I1(s, J2, I, !0);
      }
      function ds(s, d) {
        return s && s.length ? _r(s, Ft(d)) : a;
      }
      var g0 = tn(Mu);
      function Mu(s, d) {
        return s && s.length && d && d.length ? $r(s, d) : s;
      }
      function xo(s, d, y) {
        return s && s.length && d && d.length ? $r(s, d, jt(y, 2)) : s;
      }
      function Yl(s, d, y) {
        return s && s.length && d && d.length ? $r(s, d, a, y) : s;
      }
      var ui = Ii(function(s, d) {
        var y = s == null ? 0 : s.length, M = Yr(s, d);
        return Wr(s, hr(d, function(I) {
          return Or(I, y) ? +I : I;
        }).sort(Vo)), M;
      });
      function Oa(s, d) {
        var y = [];
        if (!(s && s.length))
          return y;
        var M = -1, I = [], B = s.length;
        for (d = jt(d, 3); ++M < B; ) {
          var q = s[M];
          d(q, M, s) && (y.push(q), I.push(M));
        }
        return Wr(s, I), y;
      }
      function Rd(s) {
        return s == null ? s : dc.call(s);
      }
      function w0(s, d, y) {
        var M = s == null ? 0 : s.length;
        return M ? (y && typeof y != "number" && io(s, d, y) ? (d = 0, y = M) : (d = d == null ? 0 : Ft(d), y = y === a ? M : Ft(y)), ba(s, d, y)) : [];
      }
      function Ed(s, d) {
        return ns(s, d);
      }
      function nm(s, d, y) {
        return t0(s, d, jt(y, 2));
      }
      function hs(s, d) {
        var y = s == null ? 0 : s.length;
        if (y) {
          var M = ns(s, d);
          if (M < y && Bo(s[M], d))
            return M;
        }
        return -1;
      }
      function mv(s, d) {
        return ns(s, d, !0);
      }
      function Zc(s, d, y) {
        return t0(s, d, jt(y, 2), !0);
      }
      function a1(s, d) {
        var y = s == null ? 0 : s.length;
        if (y) {
          var M = ns(s, d, !0) - 1;
          if (Bo(s[M], d))
            return M;
        }
        return -1;
      }
      function Kh(s) {
        return s && s.length ? Sc(s) : [];
      }
      function o1(s, d) {
        return s && s.length ? Sc(s, jt(d, 2)) : [];
      }
      function gv(s) {
        var d = s == null ? 0 : s.length;
        return d ? ba(s, 1, d) : [];
      }
      function wv(s, d, y) {
        return s && s.length ? (d = y || d === a ? 1 : Ft(d), ba(s, 0, d < 0 ? 0 : d)) : [];
      }
      function Md(s, d, y) {
        var M = s == null ? 0 : s.length;
        return M ? (d = y || d === a ? 1 : Ft(d), d = M - d, ba(s, d < 0 ? 0 : d, M)) : [];
      }
      function Td(s, d) {
        return s && s.length ? Ws(s, jt(d, 3), !1, !0) : [];
      }
      function rm(s, d) {
        return s && s.length ? Ws(s, jt(d, 3)) : [];
      }
      var am = tn(function(s) {
        return il(Zn(s, 1, wa, !0));
      }), yv = tn(function(s) {
        var d = lo(s);
        return wa(d) && (d = a), il(Zn(s, 1, wa, !0), jt(d, 2));
      }), xv = tn(function(s) {
        var d = lo(s);
        return d = typeof d == "function" ? d : a, il(Zn(s, 1, wa, !0), a, d);
      });
      function i1(s) {
        return s && s.length ? il(s) : [];
      }
      function Qh(s, d) {
        return s && s.length ? il(s, jt(d, 2)) : [];
      }
      function y0(s, d) {
        return d = typeof d == "function" ? d : a, s && s.length ? il(s, a, d) : [];
      }
      function Od(s) {
        if (!(s && s.length))
          return [];
        var d = 0;
        return s = ou(s, function(y) {
          if (wa(y))
            return d = oa(y.length, d), !0;
        }), rc(d, function(y) {
          return hr(s, Vf(y));
        });
      }
      function kr(s, d) {
        if (!(s && s.length))
          return [];
        var y = Od(s);
        return d == null ? y : hr(y, function(M) {
          return Ja(d, a, M);
        });
      }
      var Sv = tn(function(s, d) {
        return wa(s) ? ji(s, d) : [];
      }), Cv = tn(function(s) {
        return r0(ou(s, wa));
      }), om = tn(function(s) {
        var d = lo(s);
        return wa(d) && (d = a), r0(ou(s, wa), jt(d, 2));
      }), im = tn(function(s) {
        var d = lo(s);
        return d = typeof d == "function" ? d : a, r0(ou(s, wa), a, d);
      }), bv = tn(Od);
      function _v(s, d) {
        return zs(s || [], d || [], Ys);
      }
      function lm(s, d) {
        return zs(s || [], d || [], no);
      }
      var Vi = tn(function(s) {
        var d = s.length, y = d > 1 ? s[d - 1] : a;
        return y = typeof y == "function" ? (s.pop(), y) : a, kr(s, y);
      });
      function Pc(s) {
        var d = H(s);
        return d.__chain__ = !0, d;
      }
      function Xh(s, d) {
        return d(s), s;
      }
      function So(s, d) {
        return d(s);
      }
      var Dd = Ii(function(s) {
        var d = s.length, y = d ? s[0] : 0, M = this.__wrapped__, I = function(B) {
          return Yr(B, s);
        };
        return d > 1 || this.__actions__.length || !(M instanceof Kt) || !Or(y) ? this.thru(I) : (M = M.slice(y, +y + (d ? 1 : 0)), M.__actions__.push({
          func: So,
          args: [I],
          thisArg: a
        }), new zt(M, this.__chain__).thru(function(B) {
          return d && !B.length && B.push(a), B;
        }));
      });
      function vs() {
        return Pc(this);
      }
      function Vc() {
        return new zt(this.value(), this.__chain__);
      }
      function jd() {
        this.__values__ === a && (this.__values__ = O3(this.value()));
        var s = this.__index__ >= this.__values__.length, d = s ? a : this.__values__[this.__index__++];
        return { done: s, value: d };
      }
      function Jh() {
        return this;
      }
      function Rv(s) {
        for (var d, y = this; y instanceof fr; ) {
          var M = n1(y);
          M.__index__ = 0, M.__values__ = a, d ? I.__wrapped__ = M : d = M;
          var I = M;
          y = y.__wrapped__;
        }
        return I.__wrapped__ = s, d;
      }
      function e2() {
        var s = this.__wrapped__;
        if (s instanceof Kt) {
          var d = s;
          return this.__actions__.length && (d = new Kt(this)), d = d.reverse(), d.__actions__.push({
            func: So,
            args: [Rd],
            thisArg: a
          }), new zt(d, this.__chain__);
        }
        return this.thru(Rd);
      }
      function um() {
        return rs(this.__wrapped__, this.__actions__);
      }
      var Ev = fd(function(s, d, y) {
        En.call(s, y) ? ++s[y] : Hl(s, y, 1);
      });
      function t2(s, d, y) {
        var M = un(s) ? J0 : Pl;
        return y && io(s, d, y) && (d = a), M(s, jt(d, 3));
      }
      function Nc(s, d) {
        var y = un(s) ? ou : Ai;
        return y(s, jt(d, 3));
      }
      var Bc = Nl(fs), l1 = Nl(Lc);
      function n2(s, d) {
        return Zn(ps(s, d), 1);
      }
      function sm(s, d) {
        return Zn(ps(s, d), Ue);
      }
      function Mv(s, d, y) {
        return y = y === a ? 1 : Ft(y), Zn(ps(s, d), y);
      }
      function Ad(s, d) {
        var y = un(s) ? eo : Zl;
        return y(s, jt(d, 3));
      }
      function Fc(s, d) {
        var y = un(s) ? au : fv;
        return y(s, jt(d, 3));
      }
      var r2 = fd(function(s, d, y) {
        En.call(s, y) ? s[y].push(d) : Hl(s, y, [d]);
      });
      function Uc(s, d, y, M) {
        s = si(s) ? s : f1(s), y = y && !M ? Ft(y) : 0;
        var I = s.length;
        return y < 0 && (y = oa(I + y, 0)), l2(s) ? y <= I && s.indexOf(d, y) > -1 : !!I && Uu(s, d, y) > -1;
      }
      var Tv = tn(function(s, d, y) {
        var M = -1, I = typeof d == "function", B = si(s) ? ge(s.length) : [];
        return Zl(s, function(q) {
          B[++M] = I ? Ja(d, q, y) : ki(q, d, y);
        }), B;
      }), cm = fd(function(s, d, y) {
        Hl(s, y, d);
      });
      function ps(s, d) {
        var y = un(s) ? hr : Fh;
        return y(s, jt(d, 3));
      }
      function Yc(s, d, y, M) {
        return s == null ? [] : (un(d) || (d = d == null ? [] : [d]), y = M ? a : y, un(y) || (y = y == null ? [] : [y]), Po(s, d, y));
      }
      var Tu = fd(function(s, d, y) {
        s[y ? 0 : 1].push(d);
      }, function() {
        return [[], []];
      });
      function fm(s, d, y) {
        var M = un(s) ? ec : Al, I = arguments.length < 3;
        return M(s, jt(d, 4), y, I, Zl);
      }
      function kd(s, d, y) {
        var M = un(s) ? G2 : Al, I = arguments.length < 3;
        return M(s, jt(d, 4), y, I, fv);
      }
      function o(s, d) {
        var y = un(s) ? ou : Ai;
        return y(s, ze(jt(d, 3)));
      }
      function l(s) {
        var d = un(s) ? nl : Tr;
        return d(s);
      }
      function v(s, d, y) {
        (y ? io(s, d, y) : d === a) ? d = 1 : d = Ft(d);
        var M = un(s) ? Gu : yu;
        return M(s, d);
      }
      function w(s) {
        var d = un(s) ? Vh : ro;
        return d(s);
      }
      function b(s) {
        if (s == null)
          return 0;
        if (si(s))
          return l2(s) ? Ps(s) : s.length;
        var d = za(s);
        return d == yr || d == gn ? s.size : wu(s).length;
      }
      function E(s, d, y) {
        var M = un(s) ? Pf : xc;
        return y && io(s, d, y) && (d = a), M(s, jt(d, 3));
      }
      var Z = tn(function(s, d) {
        if (s == null)
          return [];
        var y = d.length;
        return y > 1 && io(s, d[0], d[1]) ? d = [] : y > 2 && io(d[0], d[1], d[2]) && (d = [d[0]]), Po(s, Zn(d, 1), []);
      }), z = vr || function() {
        return Sr.Date.now();
      };
      function ee(s, d) {
        if (typeof d != "function")
          throw new Mi(m);
        return s = Ft(s), function() {
          if (--s < 1)
            return d.apply(this, arguments);
        };
      }
      function ye(s, d, y) {
        return d = y ? a : d, d = s && d == null ? s.length : d, Su(s, te, a, a, a, a, d);
      }
      function Ne(s, d) {
        var y;
        if (typeof d != "function")
          throw new Mi(m);
        return s = Ft(s), function() {
          return --s > 0 && (y = d.apply(this, arguments)), s <= 1 && (d = a), y;
        };
      }
      var Ye = tn(function(s, d, y) {
        var M = V;
        if (y.length) {
          var I = qo(y, zr(Ye));
          M |= $;
        }
        return Su(s, M, d, y, I);
      }), Ve = tn(function(s, d, y) {
        var M = V | F;
        if (y.length) {
          var I = qo(y, zr(Ve));
          M |= $;
        }
        return Su(d, M, s, y, I);
      });
      function lt(s, d, y) {
        d = y ? a : d;
        var M = Su(s, W, a, a, a, a, a, d);
        return M.placeholder = lt.placeholder, M;
      }
      function xt(s, d, y) {
        d = y ? a : d;
        var M = Su(s, Q, a, a, a, a, a, d);
        return M.placeholder = xt.placeholder, M;
      }
      function bt(s, d, y) {
        var M, I, B, q, J, se, De = 0, Ie = !1, Be = !1, ot = !0;
        if (typeof s != "function")
          throw new Mi(m);
        d = fi(d) || 0, Kr(y) && (Ie = !!y.leading, Be = "maxWait" in y, B = Be ? oa(fi(y.maxWait) || 0, d) : B, ot = "trailing" in y ? !!y.trailing : ot);
        function Ot($n) {
          var Ga = M, so = I;
          return M = I = a, De = $n, q = s.apply(so, Ga), q;
        }
        function kt($n) {
          return De = $n, J = Ul(rn, d), Ie ? Ot($n) : q;
        }
        function sn($n) {
          var Ga = $n - se, so = $n - De, Yv = d - Ga;
          return Be ? to(Yv, B - so) : Yv;
        }
        function Yt($n) {
          var Ga = $n - se, so = $n - De;
          return se === a || Ga >= d || Ga < 0 || Be && so >= B;
        }
        function rn() {
          var $n = z();
          if (Yt($n))
            return cn($n);
          J = Ul(rn, sn($n));
        }
        function cn($n) {
          return J = a, ot && M ? Ot($n) : (M = I = a, q);
        }
        function mr() {
          J !== a && _c(J), De = 0, M = se = I = J = a;
        }
        function ar() {
          return J === a ? q : cn(z());
        }
        function di() {
          var $n = z(), Ga = Yt($n);
          if (M = arguments, I = this, se = $n, Ga) {
            if (J === a)
              return kt(se);
            if (Be)
              return _c(J), J = Ul(rn, d), Ot(se);
          }
          return J === a && (J = Ul(rn, d)), q;
        }
        return di.cancel = mr, di.flush = ar, di;
      }
      var Gr = tn(function(s, d) {
        return Nh(s, 1, d);
      }), ce = tn(function(s, d, y) {
        return Nh(s, fi(d) || 0, y);
      });
      function ne(s) {
        return Su(s, re);
      }
      function he(s, d) {
        if (typeof s != "function" || d != null && typeof d != "function")
          throw new Mi(m);
        var y = function() {
          var M = arguments, I = d ? d.apply(this, M) : M[0], B = y.cache;
          if (B.has(I))
            return B.get(I);
          var q = s.apply(this, M);
          return y.cache = B.set(I, q) || B, q;
        };
        return y.cache = new (he.Cache || Ho)(), y;
      }
      he.Cache = Ho;
      function ze(s) {
        if (typeof s != "function")
          throw new Mi(m);
        return function() {
          var d = arguments;
          switch (d.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, d[0]);
            case 2:
              return !s.call(this, d[0], d[1]);
            case 3:
              return !s.call(this, d[0], d[1], d[2]);
          }
          return !s.apply(this, d);
        };
      }
      function Tt(s) {
        return Ne(2, s);
      }
      var Bt = cd(function(s, d) {
        d = d.length == 1 && un(d[0]) ? hr(d[0], Ba(jt())) : hr(Zn(d, 1), Ba(jt()));
        var y = d.length;
        return tn(function(M) {
          for (var I = -1, B = to(M.length, y); ++I < B; )
            M[I] = d[I].call(this, M[I]);
          return Ja(s, this, M);
        });
      }), Ht = tn(function(s, d) {
        var y = qo(d, zr(Ht));
        return Su(s, $, a, d, y);
      }), qt = tn(function(s, d) {
        var y = qo(d, zr(qt));
        return Su(s, le, a, d, y);
      }), ga = Ii(function(s, d) {
        return Su(s, Se, a, a, a, d);
      });
      function Tn(s, d) {
        if (typeof s != "function")
          throw new Mi(m);
        return d = d === a ? d : Ft(d), tn(s, d);
      }
      function ms(s, d) {
        if (typeof s != "function")
          throw new Mi(m);
        return d = d == null ? 0 : oa(Ft(d), 0), tn(function(y) {
          var M = y[d], I = ll(y, 0, d);
          return M && iu(I, M), Ja(s, this, I);
        });
      }
      function dm(s, d, y) {
        var M = !0, I = !0;
        if (typeof s != "function")
          throw new Mi(m);
        return Kr(y) && (M = "leading" in y ? !!y.leading : M, I = "trailing" in y ? !!y.trailing : I), bt(s, d, {
          leading: M,
          maxWait: d,
          trailing: I
        });
      }
      function x3(s) {
        return ye(s, 1);
      }
      function hm(s, d) {
        return Ht(qs(d), s);
      }
      function Pw() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return un(s) ? s : [s];
      }
      function Vw(s) {
        return $a(s, A);
      }
      function Nw(s, d) {
        return d = typeof d == "function" ? d : a, $a(s, A, d);
      }
      function Bw(s) {
        return $a(s, T | A);
      }
      function Fw(s, d) {
        return d = typeof d == "function" ? d : a, $a(s, T | A, d);
      }
      function Uw(s, d) {
        return d == null || al(s, d, uo(d));
      }
      function Bo(s, d) {
        return s === d || s !== s && d !== d;
      }
      var vm = oo(Qu), a2 = oo(function(s, d) {
        return s >= d;
      }), u1 = ld(/* @__PURE__ */ function() {
        return arguments;
      }()) ? ld : function(s) {
        return ca(s) && En.call(s, "callee") && !Gf.call(s, "callee");
      }, un = ge.isArray, Yw = kf ? Ba(kf) : dv;
      function si(s) {
        return s != null && Ou(s.length) && !gs(s);
      }
      function wa(s) {
        return ca(s) && si(s);
      }
      function Ov(s) {
        return s === !0 || s === !1 || ca(s) && Wa(s) == St;
      }
      var ml = sc || Lm, pm = po ? Ba(po) : gu;
      function S3(s) {
        return ca(s) && s.nodeType === 1 && !$c(s);
      }
      function Dv(s) {
        if (s == null)
          return !0;
        if (si(s) && (un(s) || typeof s == "string" || typeof s.splice == "function" || ml(s) || ws(s) || u1(s)))
          return !s.length;
        var d = za(s);
        if (d == yr || d == gn)
          return !s.size;
        if (ul(s))
          return !wu(s).length;
        for (var y in s)
          if (En.call(s, y))
            return !1;
        return !0;
      }
      function C3(s, d) {
        return ai(s, d);
      }
      function b3(s, d, y) {
        y = typeof y == "function" ? y : a;
        var M = y ? y(s, d) : a;
        return M === a ? ai(s, d, a, y) : !!M;
      }
      function jv(s) {
        if (!ca(s))
          return !1;
        var d = Wa(s);
        return d == kn || d == Hr || typeof s.message == "string" && typeof s.name == "string" && !$c(s);
      }
      function _3(s) {
        return typeof s == "number" && Y1(s);
      }
      function gs(s) {
        if (!Kr(s))
          return !1;
        var d = Wa(s);
        return d == Wn || d == sr || d == wt || d == Ln;
      }
      function mm(s) {
        return typeof s == "number" && s == Ft(s);
      }
      function Ou(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= ie;
      }
      function Kr(s) {
        var d = typeof s;
        return s != null && (d == "object" || d == "function");
      }
      function ca(s) {
        return s != null && typeof s == "object";
      }
      var R3 = Zs ? Ba(Zs) : hv;
      function o2(s, d) {
        return s === d || J1(s, d, us(d));
      }
      function gm(s, d, y) {
        return y = typeof y == "function" ? y : a, J1(s, d, us(d), y);
      }
      function E3(s) {
        return Dr(s) && s != +s;
      }
      function $w(s) {
        if (tm(s))
          throw new Wt(g);
        return Bh(s);
      }
      function M3(s) {
        return s === null;
      }
      function Ww(s) {
        return s == null;
      }
      function Dr(s) {
        return typeof s == "number" || ca(s) && Wa(s) == ea;
      }
      function $c(s) {
        if (!ca(s) || Wa(s) != ft)
          return !1;
        var d = Qi(s);
        if (d === null)
          return !0;
        var y = En.call(d, "constructor") && d.constructor;
        return typeof y == "function" && y instanceof y && pa.call(y) == zf;
      }
      var Ld = Lf ? Ba(Lf) : wc;
      function i2(s) {
        return mm(s) && s >= -9007199254740991 && s <= ie;
      }
      var wm = ra ? Ba(ra) : Vl;
      function l2(s) {
        return typeof s == "string" || !un(s) && ca(s) && Wa(s) == zn;
      }
      function ci(s) {
        return typeof s == "symbol" || ca(s) && Wa(s) == Ur;
      }
      var ws = If ? Ba(If) : yc;
      function zw(s) {
        return s === a;
      }
      function Av(s) {
        return ca(s) && za(s) == Jt;
      }
      function Id(s) {
        return ca(s) && Wa(s) == qn;
      }
      var qw = oo(Ju), T3 = oo(function(s, d) {
        return s <= d;
      });
      function O3(s) {
        if (!s)
          return [];
        if (si(s))
          return l2(s) ? Go(s) : _a(s);
        if (Lo && s[Lo])
          return P1(s[Lo]());
        var d = za(s), y = d == yr ? V1 : d == gn ? Yu : f1;
        return y(s);
      }
      function s1(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = fi(s), s === Ue || s === -1 / 0) {
          var d = s < 0 ? -1 : 1;
          return d * _e;
        }
        return s === s ? s : 0;
      }
      function Ft(s) {
        var d = s1(s), y = d % 1;
        return d === d ? y ? d - y : d : 0;
      }
      function Hd(s) {
        return s ? pu(Ft(s), 0, mt) : 0;
      }
      function fi(s) {
        if (typeof s == "number")
          return s;
        if (ci(s))
          return Ze;
        if (Kr(s)) {
          var d = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = Kr(d) ? d + "" : d;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = ev(s);
        var y = Za.test(s);
        return y || Er.test(s) ? G0(s.slice(2), y ? 2 : 8) : hn.test(s) ? Ze : +s;
      }
      function c1(s) {
        return yo(s, Ni(s));
      }
      function D3(s) {
        return s ? pu(Ft(s), -9007199254740991, ie) : s === 0 ? s : 0;
      }
      function Cn(s) {
        return s == null ? "" : ao(s);
      }
      var Wc = u0(function(s, d) {
        if (ul(d) || si(d)) {
          yo(d, uo(d), s);
          return;
        }
        for (var y in d)
          En.call(d, y) && Ys(s, y, d[y]);
      }), u2 = u0(function(s, d) {
        yo(d, Ni(d), s);
      }), Zd = u0(function(s, d, y, M) {
        yo(d, Ni(d), s, M);
      }), kv = u0(function(s, d, y, M) {
        yo(d, uo(d), s, M);
      }), s2 = Ii(Yr);
      function j3(s, d) {
        var y = Xi(s);
        return d == null ? y : br(y, d);
      }
      var Lv = tn(function(s, d) {
        s = nr(s);
        var y = -1, M = d.length, I = M > 2 ? d[2] : a;
        for (I && io(d[0], d[1], I) && (M = 1); ++y < M; )
          for (var B = d[y], q = Ni(B), J = -1, se = q.length; ++J < se; ) {
            var De = q[J], Ie = s[De];
            (Ie === a || Bo(Ie, kl[De]) && !En.call(s, De)) && (s[De] = B[De]);
          }
        return s;
      }), A3 = tn(function(s) {
        return s.push(a, Dc), Ja(Pv, a, s);
      });
      function k3(s, d) {
        return X2(s, jt(d, 3), ni);
      }
      function Gw(s, d) {
        return X2(s, jt(d, 3), Ku);
      }
      function Kw(s, d) {
        return s == null ? s : ad(s, jt(d, 3), Ni);
      }
      function Iv(s, d) {
        return s == null ? s : mc(s, jt(d, 3), Ni);
      }
      function Hv(s, d) {
        return s && ni(s, jt(d, 3));
      }
      function L3(s, d) {
        return s && Ku(s, jt(d, 3));
      }
      function Qw(s) {
        return s == null ? [] : X1(s, uo(s));
      }
      function Zv(s) {
        return s == null ? [] : X1(s, Ni(s));
      }
      function ym(s, d, y) {
        var M = s == null ? a : pr(s, d);
        return M === a ? y : M;
      }
      function Xw(s, d) {
        return s != null && gd(s, d, ri);
      }
      function xm(s, d) {
        return s != null && gd(s, d, ol);
      }
      var Jw = $h(function(s, d, y) {
        d != null && typeof d.toString != "function" && (d = ic.call(d)), s[d] = y;
      }, Om(Bi)), e6 = $h(function(s, d, y) {
        d != null && typeof d.toString != "function" && (d = ic.call(d)), En.call(s, d) ? s[d].push(y) : s[d] = [y];
      }, jt), t6 = tn(ki);
      function uo(s) {
        return si(s) ? Il(s) : wu(s);
      }
      function Ni(s) {
        return si(s) ? Il(s, !0) : ud(s);
      }
      function n6(s, d) {
        var y = {};
        return d = jt(d, 3), ni(s, function(M, I, B) {
          Hl(y, d(M, I, B), M);
        }), y;
      }
      function r6(s, d) {
        var y = {};
        return d = jt(d, 3), ni(s, function(M, I, B) {
          Hl(y, I, d(M, I, B));
        }), y;
      }
      var Sm = u0(function(s, d, y) {
        on(s, d, y);
      }), Pv = u0(function(s, d, y, M) {
        on(s, d, y, M);
      }), Cm = Ii(function(s, d) {
        var y = {};
        if (s == null)
          return y;
        var M = !1;
        d = hr(d, function(B) {
          return B = wo(B, s), M || (M = B.length > 1), B;
        }), yo(s, f0(s), y), M && (y = $a(y, T | j | A, Qs));
        for (var I = d.length; I--; )
          n0(y, d[I]);
        return y;
      });
      function bm(s, d) {
        return Pd(s, ze(jt(d)));
      }
      var a6 = Ii(function(s, d) {
        return s == null ? {} : sd(s, d);
      });
      function Pd(s, d) {
        if (s == null)
          return {};
        var y = hr(f0(s), function(M) {
          return [M];
        });
        return d = jt(d), es(s, y, function(M, I) {
          return d(M, I[0]);
        });
      }
      function c2(s, d, y) {
        d = wo(d, s);
        var M = -1, I = d.length;
        for (I || (I = 1, s = a); ++M < I; ) {
          var B = s == null ? a : s[hl(d[M])];
          B === a && (M = I, B = y), s = gs(B) ? B.call(s) : B;
        }
        return s;
      }
      function o6(s, d, y) {
        return s == null ? s : no(s, d, y);
      }
      function I3(s, d, y, M) {
        return M = typeof M == "function" ? M : a, s == null ? s : no(s, d, y, M);
      }
      var H3 = vd(uo), Z3 = vd(Ni);
      function P3(s, d, y) {
        var M = un(s), I = M || ml(s) || ws(s);
        if (d = jt(d, 4), y == null) {
          var B = s && s.constructor;
          I ? y = M ? new B() : [] : Kr(s) ? y = gs(B) ? Xi(Qi(s)) : {} : y = {};
        }
        return (I ? eo : ni)(s, function(q, J, se) {
          return d(y, q, J, se);
        }), y;
      }
      function i6(s, d) {
        return s == null ? !0 : n0(s, d);
      }
      function l6(s, d, y) {
        return s == null ? s : bc(s, d, qs(y));
      }
      function V3(s, d, y, M) {
        return M = typeof M == "function" ? M : a, s == null ? s : bc(s, d, qs(y), M);
      }
      function f1(s) {
        return s == null ? [] : ac(s, uo(s));
      }
      function Vv(s) {
        return s == null ? [] : ac(s, Ni(s));
      }
      function Nv(s, d, y) {
        return y === a && (y = d, d = a), y !== a && (y = fi(y), y = y === y ? y : 0), d !== a && (d = fi(d), d = d === d ? d : 0), pu(fi(s), d, y);
      }
      function f2(s, d, y) {
        return d = s1(d), y === a ? (y = d, d = 0) : y = s1(y), s = fi(s), Xu(s, d, y);
      }
      function d2(s, d, y) {
        if (y && typeof y != "boolean" && io(s, d, y) && (d = y = a), y === a && (typeof d == "boolean" ? (y = d, d = a) : typeof s == "boolean" && (y = s, s = a)), s === a && d === a ? (s = 0, d = 1) : (s = s1(s), d === a ? (d = s, s = 0) : d = s1(d)), s > d) {
          var M = s;
          s = d, d = M;
        }
        if (y || s % 1 || d % 1) {
          var I = fu();
          return to(s + I * (d - s + q0("1e-" + ((I + "").length - 1))), d);
        }
        return He(s, d);
      }
      var u6 = is(function(s, d, y) {
        return d = d.toLowerCase(), s + (y ? Bv(d) : d);
      });
      function Bv(s) {
        return Mm(Cn(s).toLowerCase());
      }
      function Fv(s) {
        return s = Cn(s), s && s.replace(vo, nv).replace(jh, "");
      }
      function s6(s, d, y) {
        s = Cn(s), d = ao(d);
        var M = s.length;
        y = y === a ? M : pu(Ft(y), 0, M);
        var I = y;
        return y -= d.length, y >= 0 && s.slice(y, I) == d;
      }
      function c6(s) {
        return s = Cn(s), s && O1.test(s) ? s.replace(El, Lh) : s;
      }
      function hS(s) {
        return s = Cn(s), s && eu.test(s) ? s.replace(Ol, "\\$&") : s;
      }
      var f6 = is(function(s, d, y) {
        return s + (y ? "-" : "") + d.toLowerCase();
      }), d6 = is(function(s, d, y) {
        return s + (y ? " " : "") + d.toLowerCase();
      }), h6 = Ec("toLowerCase");
      function v6(s, d, y) {
        s = Cn(s), d = Ft(d);
        var M = d ? Ps(s) : 0;
        if (!d || M >= d)
          return s;
        var I = (d - M) / 2;
        return xu(cu(I), y) + s + xu($u(I), y);
      }
      function p6(s, d, y) {
        s = Cn(s), d = Ft(d);
        var M = d ? Ps(s) : 0;
        return d && M < d ? s + xu(d - M, y) : s;
      }
      function m6(s, d, y) {
        s = Cn(s), d = Ft(d);
        var M = d ? Ps(s) : 0;
        return d && M < d ? xu(d - M, y) + s : s;
      }
      function _m(s, d, y) {
        return y || d == null ? d = 0 : d && (d = +d), Qf(Cn(s).replace(js, ""), d || 0);
      }
      function g6(s, d, y) {
        return (y ? io(s, d, y) : d === a) ? d = 1 : d = Ft(d), It(Cn(s), d);
      }
      function w6() {
        var s = arguments, d = Cn(s[0]);
        return s.length < 3 ? d : d.replace(s[1], s[2]);
      }
      var Rm = is(function(s, d, y) {
        return s + (y ? "_" : "") + d.toLowerCase();
      });
      function y6(s, d, y) {
        return y && typeof y != "number" && io(s, d, y) && (d = y = a), y = y === a ? mt : y >>> 0, y ? (s = Cn(s), s && (typeof d == "string" || d != null && !Ld(d)) && (d = ao(d), !d && Z1(s)) ? ll(Go(s), 0, y) : s.split(d, y)) : [];
      }
      var Em = is(function(s, d, y) {
        return s + (y ? " " : "") + Mm(d);
      });
      function N3(s, d, y) {
        return s = Cn(s), y = y == null ? 0 : pu(Ft(y), 0, s.length), d = ao(d), s.slice(y, y + d.length) == d;
      }
      function x6(s, d, y) {
        var M = H.templateSettings;
        y && io(s, d, y) && (d = a), s = Cn(s), d = Zd({}, d, M, Wh);
        var I = Zd({}, d.imports, M.imports, Wh), B = uo(I), q = ac(I, B), J, se, De = 0, Ie = d.interpolate || Gt, Be = "__p += '", ot = oc(
          (d.escape || Gt).source + "|" + Ie.source + "|" + (Ie === Zu ? yn : Gt).source + "|" + (d.evaluate || Gt).source + "|$",
          "g"
        ), Ot = "//# sourceURL=" + (En.call(d, "sourceURL") ? (d.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++W2 + "]") + `
`;
        s.replace(ot, function(Yt, rn, cn, mr, ar, di) {
          return cn || (cn = mr), Be += s.slice(De, di).replace(na, rv), rn && (J = !0, Be += `' +
__e(` + rn + `) +
'`), ar && (se = !0, Be += `';
` + ar + `;
__p += '`), cn && (Be += `' +
((__t = (` + cn + `)) == null ? '' : __t) +
'`), De = di + Yt.length, Yt;
        }), Be += `';
`;
        var kt = En.call(d, "variable") && d.variable;
        if (!kt)
          Be = `with (obj) {
` + Be + `
}
`;
        else if (Et.test(kt))
          throw new Wt(C);
        Be = (se ? Be.replace(T1, "") : Be).replace(Ri, "$1").replace(Jl, "$1;"), Be = "function(" + (kt || "obj") + `) {
` + (kt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (J ? ", __e = _.escape" : "") + (se ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Be + `return __p
}`;
        var sn = U3(function() {
          return Rn(B, Ot + "return " + Be).apply(a, q);
        });
        if (sn.source = Be, jv(sn))
          throw sn;
        return sn;
      }
      function S6(s) {
        return Cn(s).toLowerCase();
      }
      function C6(s) {
        return Cn(s).toUpperCase();
      }
      function b6(s, d, y) {
        if (s = Cn(s), s && (y || d === a))
          return ev(s);
        if (!s || !(d = ao(d)))
          return s;
        var M = Go(s), I = Go(d), B = Bf(M, I), q = kh(M, I) + 1;
        return ll(M, B, q).join("");
      }
      function B3(s, d, y) {
        if (s = Cn(s), s && (y || d === a))
          return s.slice(0, Yf(s) + 1);
        if (!s || !(d = ao(d)))
          return s;
        var M = Go(s), I = kh(M, Go(d)) + 1;
        return ll(M, 0, I).join("");
      }
      function _6(s, d, y) {
        if (s = Cn(s), s && (y || d === a))
          return s.replace(js, "");
        if (!s || !(d = ao(d)))
          return s;
        var M = Go(s), I = Bf(M, Go(d));
        return ll(M, I).join("");
      }
      function R6(s, d) {
        var y = ve, M = K;
        if (Kr(d)) {
          var I = "separator" in d ? d.separator : I;
          y = "length" in d ? Ft(d.length) : y, M = "omission" in d ? ao(d.omission) : M;
        }
        s = Cn(s);
        var B = s.length;
        if (Z1(s)) {
          var q = Go(s);
          B = q.length;
        }
        if (y >= B)
          return s;
        var J = y - Ps(M);
        if (J < 1)
          return M;
        var se = q ? ll(q, 0, J).join("") : s.slice(0, J);
        if (I === a)
          return se + M;
        if (q && (J += se.length - J), Ld(I)) {
          if (s.slice(J).search(I)) {
            var De, Ie = se;
            for (I.global || (I = oc(I.source, Cn(dn.exec(I)) + "g")), I.lastIndex = 0; De = I.exec(Ie); )
              var Be = De.index;
            se = se.slice(0, Be === a ? J : Be);
          }
        } else if (s.indexOf(ao(I), J) != J) {
          var ot = se.lastIndexOf(I);
          ot > -1 && (se = se.slice(0, ot));
        }
        return se + M;
      }
      function E6(s) {
        return s = Cn(s), s && F0.test(s) ? s.replace(qi, ov) : s;
      }
      var M6 = is(function(s, d, y) {
        return s + (y ? " " : "") + d.toUpperCase();
      }), Mm = Ec("toUpperCase");
      function F3(s, d, y) {
        return s = Cn(s), d = y ? a : d, d === a ? av(s) ? lv(s) : lu(s) : s.match(d) || [];
      }
      var U3 = tn(function(s, d) {
        try {
          return Ja(s, a, d);
        } catch (y) {
          return jv(y) ? y : new Wt(y);
        }
      }), Tm = Ii(function(s, d) {
        return eo(d, function(y) {
          y = hl(y), Hl(s, y, Ye(s[y], s));
        }), s;
      });
      function T6(s) {
        var d = s == null ? 0 : s.length, y = jt();
        return s = d ? hr(s, function(M) {
          if (typeof M[1] != "function")
            throw new Mi(m);
          return [y(M[0]), M[1]];
        }) : [], tn(function(M) {
          for (var I = -1; ++I < d; ) {
            var B = s[I];
            if (Ja(B[0], this, M))
              return Ja(B[1], this, M);
          }
        });
      }
      function O6(s) {
        return rd($a(s, T));
      }
      function Om(s) {
        return function() {
          return s;
        };
      }
      function D6(s, d) {
        return s == null || s !== s ? d : s;
      }
      var j6 = hd(), A6 = hd(!0);
      function Bi(s) {
        return s;
      }
      function Dm(s) {
        return $s(typeof s == "function" ? s : $a(s, T));
      }
      function k6(s) {
        return e0($a(s, T));
      }
      function Y3(s, d) {
        return tt(s, $a(d, T));
      }
      var jm = tn(function(s, d) {
        return function(y) {
          return ki(y, s, d);
        };
      }), L6 = tn(function(s, d) {
        return function(y) {
          return ki(s, y, d);
        };
      });
      function Am(s, d, y) {
        var M = uo(d), I = X1(d, M);
        y == null && !(Kr(d) && (I.length || !M.length)) && (y = d, d = s, s = this, I = X1(d, uo(d)));
        var B = !(Kr(y) && "chain" in y) || !!y.chain, q = gs(s);
        return eo(I, function(J) {
          var se = d[J];
          s[J] = se, q && (s.prototype[J] = function() {
            var De = this.__chain__;
            if (B || De) {
              var Ie = s(this.__wrapped__), Be = Ie.__actions__ = _a(this.__actions__);
              return Be.push({ func: se, args: arguments, thisArg: s }), Ie.__chain__ = De, Ie;
            }
            return se.apply(s, iu([this.value()], arguments));
          });
        }), s;
      }
      function Uv() {
        return Sr._ === this && (Sr._ = uv), this;
      }
      function zc() {
      }
      function I6(s) {
        return s = Ft(s), tn(function(d) {
          return _r(d, s);
        });
      }
      var H6 = Bl(hr), Z6 = Bl(J0), P6 = Bl(Pf);
      function $3(s) {
        return ht(s) ? Vf(hl(s)) : Ar(s);
      }
      function V6(s) {
        return function(d) {
          return s == null ? a : pr(s, d);
        };
      }
      var N6 = Tc(), W3 = Tc(!0);
      function km() {
        return [];
      }
      function Lm() {
        return !1;
      }
      function B6() {
        return {};
      }
      function F6() {
        return "";
      }
      function U6() {
        return !0;
      }
      function Y6(s, d) {
        if (s = Ft(s), s < 1 || s > ie)
          return [];
        var y = mt, M = to(s, mt);
        d = jt(d), s -= mt;
        for (var I = rc(M, d); ++y < s; )
          d(y);
        return I;
      }
      function $6(s) {
        return un(s) ? hr(s, hl) : ci(s) ? [s] : _a(xd(Cn(s)));
      }
      function W6(s) {
        var d = ++B1;
        return Cn(s) + d;
      }
      var z6 = Mc(function(s, d) {
        return s + d;
      }, 0), q6 = At("ceil"), G6 = Mc(function(s, d) {
        return s / d;
      }, 1), K6 = At("floor");
      function Q6(s) {
        return s && s.length ? Pr(s, Bi, Qu) : a;
      }
      function X6(s, d) {
        return s && s.length ? Pr(s, jt(d, 2), Qu) : a;
      }
      function J6(s) {
        return nc(s, Bi);
      }
      function e7(s, d) {
        return nc(s, jt(d, 2));
      }
      function Vd(s) {
        return s && s.length ? Pr(s, Bi, Ju) : a;
      }
      function Nd(s, d) {
        return s && s.length ? Pr(s, jt(d, 2), Ju) : a;
      }
      var Im = Mc(function(s, d) {
        return s * d;
      }, 1), h2 = At("round"), Hm = Mc(function(s, d) {
        return s - d;
      }, 0);
      function t7(s) {
        return s && s.length ? Ki(s, Bi) : 0;
      }
      function n7(s, d) {
        return s && s.length ? Ki(s, jt(d, 2)) : 0;
      }
      return H.after = ee, H.ary = ye, H.assign = Wc, H.assignIn = u2, H.assignInWith = Zd, H.assignWith = kv, H.at = s2, H.before = Ne, H.bind = Ye, H.bindAll = Tm, H.bindKey = Ve, H.castArray = Pw, H.chain = Pc, H.chunk = p0, H.compact = Sd, H.concat = Pi, H.cond = T6, H.conforms = O6, H.constant = Om, H.countBy = Ev, H.create = j3, H.curry = lt, H.curryRight = xt, H.debounce = bt, H.defaults = Lv, H.defaultsDeep = A3, H.defer = Gr, H.delay = ce, H.difference = Mn, H.differenceBy = Ma, H.differenceWith = sa, H.drop = ma, H.dropRight = li, H.dropRightWhile = _u, H.dropWhile = qr, H.fill = m0, H.filter = Nc, H.flatMap = n2, H.flatMapDeep = sm, H.flatMapDepth = Mv, H.flatten = Cd, H.flattenDeep = Ic, H.flattenDepth = Ta, H.flip = ne, H.flow = j6, H.flowRight = A6, H.fromPairs = Hc, H.functions = Qw, H.functionsIn = Zv, H.groupBy = r2, H.initial = bd, H.intersection = _d, H.intersectionBy = Eu, H.intersectionWith = r1, H.invert = Jw, H.invertBy = e6, H.invokeMap = Tv, H.iteratee = Dm, H.keyBy = cm, H.keys = uo, H.keysIn = Ni, H.map = ps, H.mapKeys = n6, H.mapValues = r6, H.matches = k6, H.matchesProperty = Y3, H.memoize = he, H.merge = Sm, H.mergeWith = Pv, H.method = jm, H.methodOf = L6, H.mixin = Am, H.negate = ze, H.nthArg = I6, H.omit = Cm, H.omitBy = bm, H.once = Tt, H.orderBy = Yc, H.over = H6, H.overArgs = Bt, H.overEvery = Z6, H.overSome = P6, H.partial = Ht, H.partialRight = qt, H.partition = Tu, H.pick = a6, H.pickBy = Pd, H.property = $3, H.propertyOf = V6, H.pull = g0, H.pullAll = Mu, H.pullAllBy = xo, H.pullAllWith = Yl, H.pullAt = ui, H.range = N6, H.rangeRight = W3, H.rearg = ga, H.reject = o, H.remove = Oa, H.rest = Tn, H.reverse = Rd, H.sampleSize = v, H.set = o6, H.setWith = I3, H.shuffle = w, H.slice = w0, H.sortBy = Z, H.sortedUniq = Kh, H.sortedUniqBy = o1, H.split = y6, H.spread = ms, H.tail = gv, H.take = wv, H.takeRight = Md, H.takeRightWhile = Td, H.takeWhile = rm, H.tap = Xh, H.throttle = dm, H.thru = So, H.toArray = O3, H.toPairs = H3, H.toPairsIn = Z3, H.toPath = $6, H.toPlainObject = c1, H.transform = P3, H.unary = x3, H.union = am, H.unionBy = yv, H.unionWith = xv, H.uniq = i1, H.uniqBy = Qh, H.uniqWith = y0, H.unset = i6, H.unzip = Od, H.unzipWith = kr, H.update = l6, H.updateWith = V3, H.values = f1, H.valuesIn = Vv, H.without = Sv, H.words = F3, H.wrap = hm, H.xor = Cv, H.xorBy = om, H.xorWith = im, H.zip = bv, H.zipObject = _v, H.zipObjectDeep = lm, H.zipWith = Vi, H.entries = H3, H.entriesIn = Z3, H.extend = u2, H.extendWith = Zd, Am(H, H), H.add = z6, H.attempt = U3, H.camelCase = u6, H.capitalize = Bv, H.ceil = q6, H.clamp = Nv, H.clone = Vw, H.cloneDeep = Bw, H.cloneDeepWith = Fw, H.cloneWith = Nw, H.conformsTo = Uw, H.deburr = Fv, H.defaultTo = D6, H.divide = G6, H.endsWith = s6, H.eq = Bo, H.escape = c6, H.escapeRegExp = hS, H.every = t2, H.find = Bc, H.findIndex = fs, H.findKey = k3, H.findLast = l1, H.findLastIndex = Lc, H.findLastKey = Gw, H.floor = K6, H.forEach = Ad, H.forEachRight = Fc, H.forIn = Kw, H.forInRight = Iv, H.forOwn = Hv, H.forOwnRight = L3, H.get = ym, H.gt = vm, H.gte = a2, H.has = Xw, H.hasIn = xm, H.head = vl, H.identity = Bi, H.includes = Uc, H.indexOf = Ru, H.inRange = f2, H.invoke = t6, H.isArguments = u1, H.isArray = un, H.isArrayBuffer = Yw, H.isArrayLike = si, H.isArrayLikeObject = wa, H.isBoolean = Ov, H.isBuffer = ml, H.isDate = pm, H.isElement = S3, H.isEmpty = Dv, H.isEqual = C3, H.isEqualWith = b3, H.isError = jv, H.isFinite = _3, H.isFunction = gs, H.isInteger = mm, H.isLength = Ou, H.isMap = R3, H.isMatch = o2, H.isMatchWith = gm, H.isNaN = E3, H.isNative = $w, H.isNil = Ww, H.isNull = M3, H.isNumber = Dr, H.isObject = Kr, H.isObjectLike = ca, H.isPlainObject = $c, H.isRegExp = Ld, H.isSafeInteger = i2, H.isSet = wm, H.isString = l2, H.isSymbol = ci, H.isTypedArray = ws, H.isUndefined = zw, H.isWeakMap = Av, H.isWeakSet = Id, H.join = pl, H.kebabCase = f6, H.last = lo, H.lastIndexOf = qa, H.lowerCase = d6, H.lowerFirst = h6, H.lt = qw, H.lte = T3, H.max = Q6, H.maxBy = X6, H.mean = J6, H.meanBy = e7, H.min = Vd, H.minBy = Nd, H.stubArray = km, H.stubFalse = Lm, H.stubObject = B6, H.stubString = F6, H.stubTrue = U6, H.multiply = Im, H.nth = ds, H.noConflict = Uv, H.noop = zc, H.now = z, H.pad = v6, H.padEnd = p6, H.padStart = m6, H.parseInt = _m, H.random = d2, H.reduce = fm, H.reduceRight = kd, H.repeat = g6, H.replace = w6, H.result = c2, H.round = h2, H.runInContext = ue, H.sample = l, H.size = b, H.snakeCase = Rm, H.some = E, H.sortedIndex = Ed, H.sortedIndexBy = nm, H.sortedIndexOf = hs, H.sortedLastIndex = mv, H.sortedLastIndexBy = Zc, H.sortedLastIndexOf = a1, H.startCase = Em, H.startsWith = N3, H.subtract = Hm, H.sum = t7, H.sumBy = n7, H.template = x6, H.times = Y6, H.toFinite = s1, H.toInteger = Ft, H.toLength = Hd, H.toLower = S6, H.toNumber = fi, H.toSafeInteger = D3, H.toString = Cn, H.toUpper = C6, H.trim = b6, H.trimEnd = B3, H.trimStart = _6, H.truncate = R6, H.unescape = E6, H.uniqueId = W6, H.upperCase = M6, H.upperFirst = Mm, H.each = Ad, H.eachRight = Fc, H.first = vl, Am(H, function() {
        var s = {};
        return ni(H, function(d, y) {
          En.call(H.prototype, y) || (s[y] = d);
        }), s;
      }(), { chain: !1 }), H.VERSION = i, eo(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        H[s].placeholder = H;
      }), eo(["drop", "take"], function(s, d) {
        Kt.prototype[s] = function(y) {
          y = y === a ? 1 : oa(Ft(y), 0);
          var M = this.__filtered__ && !d ? new Kt(this) : this.clone();
          return M.__filtered__ ? M.__takeCount__ = to(y, M.__takeCount__) : M.__views__.push({
            size: to(y, mt),
            type: s + (M.__dir__ < 0 ? "Right" : "")
          }), M;
        }, Kt.prototype[s + "Right"] = function(y) {
          return this.reverse()[s](y).reverse();
        };
      }), eo(["filter", "map", "takeWhile"], function(s, d) {
        var y = d + 1, M = y == xe || y == be;
        Kt.prototype[s] = function(I) {
          var B = this.clone();
          return B.__iteratees__.push({
            iteratee: jt(I, 3),
            type: y
          }), B.__filtered__ = B.__filtered__ || M, B;
        };
      }), eo(["head", "last"], function(s, d) {
        var y = "take" + (d ? "Right" : "");
        Kt.prototype[s] = function() {
          return this[y](1).value()[0];
        };
      }), eo(["initial", "tail"], function(s, d) {
        var y = "drop" + (d ? "" : "Right");
        Kt.prototype[s] = function() {
          return this.__filtered__ ? new Kt(this) : this[y](1);
        };
      }), Kt.prototype.compact = function() {
        return this.filter(Bi);
      }, Kt.prototype.find = function(s) {
        return this.filter(s).head();
      }, Kt.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, Kt.prototype.invokeMap = tn(function(s, d) {
        return typeof s == "function" ? new Kt(this) : this.map(function(y) {
          return ki(y, s, d);
        });
      }), Kt.prototype.reject = function(s) {
        return this.filter(ze(jt(s)));
      }, Kt.prototype.slice = function(s, d) {
        s = Ft(s);
        var y = this;
        return y.__filtered__ && (s > 0 || d < 0) ? new Kt(y) : (s < 0 ? y = y.takeRight(-s) : s && (y = y.drop(s)), d !== a && (d = Ft(d), y = d < 0 ? y.dropRight(-d) : y.take(d - s)), y);
      }, Kt.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, Kt.prototype.toArray = function() {
        return this.take(mt);
      }, ni(Kt.prototype, function(s, d) {
        var y = /^(?:filter|find|map|reject)|While$/.test(d), M = /^(?:head|last)$/.test(d), I = H[M ? "take" + (d == "last" ? "Right" : "") : d], B = M || /^find/.test(d);
        I && (H.prototype[d] = function() {
          var q = this.__wrapped__, J = M ? [1] : arguments, se = q instanceof Kt, De = J[0], Ie = se || un(q), Be = function(rn) {
            var cn = I.apply(H, iu([rn], J));
            return M && ot ? cn[0] : cn;
          };
          Ie && y && typeof De == "function" && De.length != 1 && (se = Ie = !1);
          var ot = this.__chain__, Ot = !!this.__actions__.length, kt = B && !ot, sn = se && !Ot;
          if (!B && Ie) {
            q = sn ? q : new Kt(this);
            var Yt = s.apply(q, J);
            return Yt.__actions__.push({ func: So, args: [Be], thisArg: a }), new zt(Yt, ot);
          }
          return kt && sn ? s.apply(this, J) : (Yt = this.thru(Be), kt ? M ? Yt.value()[0] : Yt.value() : Yt);
        });
      }), eo(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var d = su[s], y = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", M = /^(?:pop|shift)$/.test(s);
        H.prototype[s] = function() {
          var I = arguments;
          if (M && !this.__chain__) {
            var B = this.value();
            return d.apply(un(B) ? B : [], I);
          }
          return this[y](function(q) {
            return d.apply(un(q) ? q : [], I);
          });
        };
      }), ni(Kt.prototype, function(s, d) {
        var y = H[d];
        if (y) {
          var M = y.name + "";
          En.call(q1, M) || (q1[M] = []), q1[M].push({ name: d, func: y });
        }
      }), q1[Ks(a, F).name] = [{
        name: "wrapper",
        func: a
      }], Kt.prototype.clone = Fs, Kt.prototype.reverse = Jf, Kt.prototype.value = vn, H.prototype.at = Dd, H.prototype.chain = vs, H.prototype.commit = Vc, H.prototype.next = jd, H.prototype.plant = Rv, H.prototype.reverse = e2, H.prototype.toJSON = H.prototype.valueOf = H.prototype.value = um, H.prototype.first = H.prototype.head, Lo && (H.prototype[Lo] = Jh), H;
    }, N1 = Gp();
    jl ? ((jl.exports = N1)._ = N1, Q0._ = N1) : Sr._ = N1;
  }).call(C4);
})(by, by.exports);
var eG = by.exports, Hw = { exports: {} }, LO = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ả: "A",
  Ạ: "A",
  Ẩ: "A",
  Ẫ: "A",
  Ậ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ẻ: "E",
  Ẽ: "E",
  Ẹ: "E",
  Ể: "E",
  Ễ: "E",
  Ệ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ỉ: "I",
  Ị: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ỏ: "O",
  Ọ: "O",
  Ổ: "O",
  Ỗ: "O",
  Ộ: "O",
  Ờ: "O",
  Ở: "O",
  Ỡ: "O",
  Ớ: "O",
  Ợ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ủ: "U",
  Ụ: "U",
  Ử: "U",
  Ữ: "U",
  Ự: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ả: "a",
  ạ: "a",
  ẩ: "a",
  ẫ: "a",
  ậ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ẻ: "e",
  ẽ: "e",
  ẹ: "e",
  ể: "e",
  ễ: "e",
  ệ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ỉ: "i",
  ị: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ỏ: "o",
  ọ: "o",
  ổ: "o",
  ỗ: "o",
  ộ: "o",
  ờ: "o",
  ở: "o",
  ỡ: "o",
  ớ: "o",
  ợ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ủ: "u",
  ụ: "u",
  ử: "u",
  ữ: "u",
  ự: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z",
  й: "и",
  Й: "И",
  ё: "е",
  Ё: "Е"
}, IO = Object.keys(LO).join("|"), tG = new RegExp(IO, "g"), nG = new RegExp(IO, "");
function rG(e) {
  return LO[e];
}
var HO = function(e) {
  return e.replace(tG, rG);
}, aG = function(e) {
  return !!e.match(nG);
};
Hw.exports = HO;
Hw.exports.has = aG;
Hw.exports.remove = HO;
var oG = Hw.exports;
const iG = /* @__PURE__ */ _E(oG);
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2020 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const Cl = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
}, lG = (e, t) => String(e.rankedValue).localeCompare(String(t.rankedValue));
function x5(e, t, a) {
  a === void 0 && (a = {});
  const {
    keys: i,
    threshold: h = Cl.MATCHES,
    baseSort: g = lG,
    sorter: m = (R) => R.sort((D, T) => fG(D, T, g))
  } = a, C = e.reduce(S, []);
  return m(C).map((R) => {
    let {
      item: D
    } = R;
    return D;
  });
  function S(R, D, T) {
    const j = uG(D, i, t, a), {
      rank: A,
      keyThreshold: L = h
    } = j;
    return A >= L && R.push({
      ...j,
      item: D,
      index: T
    }), R;
  }
}
x5.rankings = Cl;
function uG(e, t, a, i) {
  if (!t) {
    const g = e;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: g,
      rank: HR(g, a, i),
      keyIndex: -1,
      keyThreshold: i.threshold
    };
  }
  return vG(e, t).reduce((g, m, C) => {
    let {
      rank: S,
      rankedValue: R,
      keyIndex: D,
      keyThreshold: T
    } = g, {
      itemValue: j,
      attributes: A
    } = m, L = HR(j, a, i), P = R;
    const {
      minRanking: V,
      maxRanking: F,
      threshold: Y
    } = A;
    return L < V && L >= Cl.MATCHES ? L = V : L > F && (L = F), L > S && (S = L, D = C, T = Y, P = j), {
      rankedValue: P,
      rank: S,
      keyIndex: D,
      keyThreshold: T
    };
  }, {
    rankedValue: e,
    rank: Cl.NO_MATCH,
    keyIndex: -1,
    keyThreshold: i.threshold
  });
}
function HR(e, t, a) {
  return e = ZR(e, a), t = ZR(t, a), t.length > e.length ? Cl.NO_MATCH : e === t ? Cl.CASE_SENSITIVE_EQUAL : (e = e.toLowerCase(), t = t.toLowerCase(), e === t ? Cl.EQUAL : e.startsWith(t) ? Cl.STARTS_WITH : e.includes(` ${t}`) ? Cl.WORD_STARTS_WITH : e.includes(t) ? Cl.CONTAINS : t.length === 1 ? Cl.NO_MATCH : sG(e).includes(t) ? Cl.ACRONYM : cG(e, t));
}
function sG(e) {
  let t = "";
  return e.split(" ").forEach((i) => {
    i.split("-").forEach((g) => {
      t += g.substr(0, 1);
    });
  }), t;
}
function cG(e, t) {
  let a = 0, i = 0;
  function h(S, R, D) {
    for (let T = D, j = R.length; T < j; T++)
      if (R[T] === S)
        return a += 1, T + 1;
    return -1;
  }
  function g(S) {
    const R = 1 / S, D = a / t.length;
    return Cl.MATCHES + D * R;
  }
  const m = h(t[0], e, 0);
  if (m < 0)
    return Cl.NO_MATCH;
  i = m;
  for (let S = 1, R = t.length; S < R; S++) {
    const D = t[S];
    if (i = h(D, e, i), !(i > -1))
      return Cl.NO_MATCH;
  }
  const C = i - m;
  return g(C);
}
function fG(e, t, a) {
  const {
    rank: g,
    keyIndex: m
  } = e, {
    rank: C,
    keyIndex: S
  } = t;
  return g === C ? m === S ? a(e, t) : m < S ? -1 : 1 : g > C ? -1 : 1;
}
function ZR(e, t) {
  let {
    keepDiacritics: a
  } = t;
  return e = `${e}`, a || (e = iG(e)), e;
}
function dG(e, t) {
  typeof t == "object" && (t = t.key);
  let a;
  if (typeof t == "function")
    a = t(e);
  else if (e == null)
    a = null;
  else if (Object.hasOwnProperty.call(e, t))
    a = e[t];
  else {
    if (t.includes("."))
      return hG(t, e);
    a = null;
  }
  return a == null ? [] : Array.isArray(a) ? a : [String(a)];
}
function hG(e, t) {
  const a = e.split(".");
  let i = [t];
  for (let h = 0, g = a.length; h < g; h++) {
    const m = a[h];
    let C = [];
    for (let S = 0, R = i.length; S < R; S++) {
      const D = i[S];
      if (D != null)
        if (Object.hasOwnProperty.call(D, m)) {
          const T = D[m];
          T != null && C.push(T);
        } else m === "*" && (C = C.concat(D));
    }
    i = C;
  }
  return Array.isArray(i[0]) ? [].concat(...i) : i;
}
function vG(e, t) {
  const a = [];
  for (let i = 0, h = t.length; i < h; i++) {
    const g = t[i], m = pG(g), C = dG(e, g);
    for (let S = 0, R = C.length; S < R; S++)
      a.push({
        itemValue: C[S],
        attributes: m
      });
  }
  return a;
}
const PR = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function pG(e) {
  return typeof e == "string" ? PR : {
    ...PR,
    ...e
  };
}
var mG = "_1fw0vff1 _1fw0vff0 _1faqfmv35 _1faqfmv3p _1faqfmvsz _1faqfmv9j _1faqfmvf9 _1faqfmv5 _1faqfmv1x _1faqfmv8a", ZO = "_1fw0vff3 _1fw0vff2 _1faqfmv4e _1faqfmv4y _1faqfmv38 _1faqfmv3s _1faqfmvsz _1faqfmv1u _1faqfmv1x _1faqfmvuf", gG = "_1fw0vff5 _1fw0vff4 _1faqfmv37 _1faqfmv3r _1faqfmv9j _1faqfmvf9 _1faqfmv3 _1faqfmv24 _1faqfmvn5", wG = "_1fw0vff7 _1fw0vff6 _1faqfmv4e _1faqfmv4y _1faqfmv38 _1faqfmv3s _1faqfmv5w _1faqfmv6h _1faqfmv72 _1faqfmv7n _1faqfmvfl _1faqfmv3 _1faqfmv8a", yG = "_1fw0vff9 _1fw0vff8 _1faqfmvsz _1faqfmvf9 _1faqfmv3 _1faqfmv1x _1faqfmvwf", xG = "_1fw0vffa", SG = "_1fw0vffc";
const PO = Sa.createContext({
  checkType: "checkmark",
  displayMode: "normal",
  loading: !1
}), Zw = () => {
  const e = Sa.useContext(PO);
  if (!e)
    throw new Error(
      "Select components must be used within a SelectProvider"
    );
  return e;
}, VR = ({
  children: e,
  options: t,
  value: a,
  onValueChange: i,
  ...h
}) => {
  const g = (t ?? []).map(Ey), [m, C] = Qt(a), S = (R) => {
    const D = Array.isArray(m) ? m.length === 0 : !m, T = !g.length && D || h.loading;
    let j;
    g.length ? Array.isArray(R) && Array.isArray(m) ? (j = [...m], R.forEach((A) => {
      const L = g.find(
        (V) => ff(V, A)
      ), P = j.some(
        (V) => ff(V, L)
      );
      L && !P && j.push(L);
    }), j = j.filter(
      (A) => R.some((L) => ff(L, A))
    )) : j = g.find(
      (A) => ff(A, R)
    ) : j = Array.isArray(R) ? R.map(L4) : L4(R), C(j), i && !T && i(j);
  };
  return /* @__PURE__ */ f.jsx(
    PO.Provider,
    {
      value: {
        options: g,
        value: m,
        setValue: S,
        ...h
      },
      children: e
    }
  );
}, B0 = ({
  checkType: e,
  children: t,
  clearable: a,
  creatable: i,
  displayMode: h,
  filterable: g,
  customFilterable: m,
  loading: C,
  resultsLoading: S,
  store: R,
  value: D,
  options: T,
  onValueChange: j,
  onSearchValueChange: A,
  onCreate: L,
  ...P
}) => {
  const [V, F] = Qt(""), Y = (K) => {
    F(K), A && A(K);
  }, W = D ?? P.defaultValue, [Q, $] = Qt(
    Y8(T)
  );
  i = i || !!L, R = R ?? Pp({
    defaultValue: P.defaultValue ? My(P.defaultValue) : void 0
  });
  const le = {
    checkType: e,
    clearable: a,
    defaultValue: P.defaultValue,
    displayMode: h,
    loading: C,
    options: Q,
    value: Y8(W),
    // eslint-disable-line @typescript-eslint/no-explicit-any
    onValueChange: j,
    setOptions: $
  }, te = async (K) => {
    R == null || R.setValue(K);
  }, Se = (K) => {
    $([
      ...Q,
      { name: K, value: K }
    ]);
    const de = R == null ? void 0 : R.getState().value, fe = Array.isArray(de);
    setTimeout(() => {
      te(fe ? [...de, K] : K);
    }), L && L(K);
  };
  gt(() => {
    if (R && D) {
      const K = R.getState().value, de = My(D);
      eG.isEqual(de, K) || te(de);
    }
  }, [D]), gt(() => {
    if (R && T) {
      const { value: K } = R.getState();
      let de = Y8(T);
      if (Array.isArray(de)) {
        if (Array.isArray(K)) {
          const fe = K.filter(
            (xe) => !de.some(
              (Le) => ff(Le, xe)
            )
          ).map((xe) => ({ name: xe, value: xe }));
          fe.length && (de = [...de, ...fe]);
        } else K && !de.some((fe) => ff(fe, K)) && (de = [...de, { name: K, value: K }]);
        $(de);
      }
    }
  }, [T]);
  const re = Lr(
    () => g ? x5(Q, V, { keys: ["name", "value"] }) : Q,
    [Q, V]
  ), ve = Lr(
    () => g ? x5(re, V, {
      keys: ["name", "value"],
      threshold: x5.rankings.CASE_SENSITIVE_EQUAL
    }).length > 0 : !1,
    [re, V]
  );
  return g || m ? /* @__PURE__ */ f.jsx(
    EM,
    {
      resetValueOnHide: !0,
      setValue: (K) => Y(K),
      children: /* @__PURE__ */ f.jsx(VR, { ...le, children: /* @__PURE__ */ f.jsxs(BR, { store: R, options: Q, children: [
        /* @__PURE__ */ f.jsx(NR, { ...P }),
        /* @__PURE__ */ f.jsxs(Ry, { children: [
          /* @__PURE__ */ f.jsxs(ct, { px: "4", pb: "4", display: "flex", alignItems: "center", children: [
            /* @__PURE__ */ f.jsx(
              iw,
              {
                autoSelect: !0,
                placeholder: "Search...",
                className: wG,
                value: V,
                onChange: (K) => Y(K.target.value)
              }
            ),
            S && /* @__PURE__ */ f.jsx(
              WU,
              {
                className: SG,
                color: lE.static.content.weak
              }
            )
          ] }),
          /* @__PURE__ */ f.jsxs(hx, { children: [
            V && !ve && i && /* @__PURE__ */ f.jsxs(
              Z4,
              {
                className: ZO,
                value: V,
                onClick: () => {
                  Se(V), Y("");
                },
                children: [
                  /* @__PURE__ */ f.jsx(VO, {}),
                  /* @__PURE__ */ f.jsx(
                    Fr,
                    {
                      size: "small",
                      weight: "medium",
                      color: "secondaryContentOnEnabled",
                      children: V
                    }
                  )
                ]
              }
            ),
            re.map((K) => /* @__PURE__ */ f.jsx(
              _y,
              {
                value: String(K.value),
                render: /* @__PURE__ */ f.jsx(Z4, {}),
                onClick: () => Y(""),
                children: K.name
              },
              K.value
            ))
          ] })
        ] })
      ] }) })
    }
  ) : /* @__PURE__ */ f.jsx(VR, { ...le, children: /* @__PURE__ */ f.jsxs(BR, { store: R, options: Q, children: [
    /* @__PURE__ */ f.jsx(NR, { ...P }),
    /* @__PURE__ */ f.jsx(Ry, { children: Array.isArray(T) ? Q.map((K) => /* @__PURE__ */ f.jsx(
      _y,
      {
        value: String(K.value),
        children: K.name
      },
      K.value
    )) : t })
  ] }) });
}, NR = ({
  renderValue: e,
  trigger: t,
  ...a
}) => {
  const i = t ?? CG, h = xf(), g = h.useState("value"), { displayMode: m, loading: C, options: S } = Zw();
  C && (a.disabled = !0);
  const R = (T) => {
    const j = h.getState().items;
    if (!(S != null && S.length) && !j.length)
      return Array.isArray(T) ? T.map(L4) : L4(T);
    if (!(S != null && S.length)) {
      const L = Array.isArray(T) ? T : [T], P = j.filter(
        (V) => L.some((F) => ff(V.value, F))
      );
      return Array.isArray(T) ? NO(P) : BO(P[0]);
    }
    const A = (L) => (S ?? []).map(
      (V) => typeof V == "string" ? {
        name: V,
        value: V
      } : V
    ).find((V) => ff(V, L)) ?? L4(L);
    return Array.isArray(T) ? T.map(A) : A(T);
  }, D = (T) => {
    if (e)
      return e(T) ?? a.placeholder ?? "Select...";
    const j = R(T);
    return m === "tags" ? !j || Array.isArray(j) && !j.length ? a.placeholder ?? "Select..." : /* @__PURE__ */ f.jsx(
      Do,
      {
        direction: "row",
        align: "center",
        gap: "6",
        flexWrap: "wrap",
        whiteSpace: "normal",
        width: "full",
        children: Array.isArray(j) ? j.map((A) => /* @__PURE__ */ f.jsx(UR, { value: A.value, children: A.name }, A.value)) : /* @__PURE__ */ f.jsx(UR, { value: j.value, children: j.name })
      }
    ) : Array.isArray(j) ? j.length ? j.map((A) => A.name).join(", ") : a.placeholder ?? "Select..." : j.name;
  };
  return /* @__PURE__ */ f.jsx(i, { style: { opacity: a.disabled ? 0.7 : 1 }, ...a, children: g ? D(g) : /* @__PURE__ */ f.jsx(Fr, { color: "secondaryContentOnEnabled", children: a.placeholder ?? "Select..." }) });
}, BR = ({ children: e, ...t }) => {
  const { value: a, setOptions: i, setValue: h } = Zw(), g = t.store.useState("items");
  return gt(() => {
    i && !t.options && g.length && i(NO(g));
  }, [g]), /* @__PURE__ */ f.jsx(
    bT,
    {
      value: My(a),
      setValue: h,
      ...t,
      children: e
    }
  );
}, CG = ({
  children: e,
  hideArrow: t,
  ...a
}) => {
  const { clearable: i, value: h, setValue: g } = Zw(), m = Array.isArray(h), C = Pt(null);
  return /* @__PURE__ */ f.jsx(
    f3,
    {
      className: mG,
      ...a,
      toggleOnPress: (S) => {
        var R;
        return !((R = C.current) != null && R.contains(S.target) || C.current === S.target);
      },
      children: /* @__PURE__ */ f.jsxs(
        Do,
        {
          direction: "row",
          align: "center",
          justify: "space-between",
          width: "full",
          children: [
            typeof e == "string" ? /* @__PURE__ */ f.jsx(
              Fr,
              {
                color: "secondaryContentOnEnabled",
                lines: "1",
                align: "left",
                children: e
              }
            ) : e,
            /* @__PURE__ */ f.jsxs(Do, { direction: "row", align: "center", gap: "6", children: [
              i && (m ? h.length > 0 : !!h) && /* @__PURE__ */ f.jsx(
                h3,
                {
                  ref: C,
                  icon: /* @__PURE__ */ f.jsx(Fx, {}),
                  onClick: (S) => {
                    S.preventDefault(), S.stopPropagation(), Array.isArray(h) ? g([]) : g(void 0);
                  },
                  size: "xSmall",
                  emphasis: "none",
                  kind: "secondary"
                }
              ),
              !t && /* @__PURE__ */ f.jsx(
                yw,
                {
                  render: /* @__PURE__ */ f.jsx(
                    IT,
                    {
                      color: lE.static.content.moderate
                    }
                  )
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, bG = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f.jsx(f3, { ...t, render: /* @__PURE__ */ f.jsx(d3, {}), children: /* @__PURE__ */ f.jsxs(Do, { direction: "row", gap: "4", align: "center", children: [
  e,
  /* @__PURE__ */ f.jsx(yw, { render: /* @__PURE__ */ f.jsx(IT, {}) })
] }) }), _G = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(Sw, { ...t, children: e }), _y = ({
  children: e,
  value: t,
  ...a
}) => {
  const i = [t];
  typeof e == "string" && (i.push(e), t === void 0 && (t = e));
  const h = xf().useState("value"), g = Array.isArray(h) ? i.some((m) => h.includes(m)) : i.includes(h);
  return /* @__PURE__ */ f.jsxs(
    xw,
    {
      focusOnHover: !0,
      value: t,
      className: ZO,
      ...a,
      children: [
        /* @__PURE__ */ f.jsx(VO, { checked: g, style: { flexShrink: 0 } }),
        e ? typeof e == "string" ? /* @__PURE__ */ f.jsx(
          Fr,
          {
            size: "small",
            weight: "medium",
            color: "secondaryContentOnEnabled",
            lines: "1",
            children: e
          }
        ) : e : /* @__PURE__ */ f.jsx(
          Fr,
          {
            size: "small",
            weight: "medium",
            color: "secondaryContentOnEnabled",
            lines: "1",
            children: t
          }
        )
      ]
    }
  );
}, VO = ({
  children: e,
  ...t
}) => {
  const { checkType: a } = Zw();
  return a === "checkbox" ? /* @__PURE__ */ f.jsx(ct, { cssClass: yG, children: t.checked && /* @__PURE__ */ f.jsx(Vx, { color: "white", size: "13" }) }) : /* @__PURE__ */ f.jsx(ET, { ...t, className: xG, children: e ?? /* @__PURE__ */ f.jsx(kT, { size: "16" }) });
}, Ry = ({ children: e, ...t }) => /* @__PURE__ */ f.jsxs(Cw, { gutter: 4, className: gG, ...t, children: [
  /* @__PURE__ */ f.jsx(Zp, { size: 0 }),
  e
] }), RG = ({ children: e }) => /* @__PURE__ */ f.jsx(RT, { children: e }), EG = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f.jsx(_T, { ...t, children: e }), Cp = (e) => e !== null && typeof e == "object", Ey = (e) => Cp(e) ? e : {
  name: String(e),
  value: String(e)
}, Y8 = (e) => {
  if (e !== void 0)
    return Array.isArray(e) ? e.map(Ey) : Ey(e);
}, FR = (e) => e === void 0 ? "" : Cp(e) ? String(e.value) : String(e), NO = (e) => e.map(BO), BO = (e) => {
  var t;
  return {
    name: String(((t = e.element) == null ? void 0 : t.innerText) ?? e.value),
    value: e.value
  };
}, L4 = (e) => ({
  name: String(e),
  value: e
}), My = (e) => Array.isArray(e) ? e.map(FR) : FR(e), ff = (e, t) => {
  if (t === void 0)
    return !1;
  if (Cp(e) && Cp(t)) {
    const a = [e.value, e.name].map(String), i = [t.value, t.name].map(String);
    return a.some((h) => i.includes(h));
  } else {
    if (Cp(e))
      return [e.value, e.name].map(String).includes(String(t));
    if (Cp(t))
      return [t.value, t.name].map(String).includes(String(e));
  }
  return String(e) === String(t);
}, UR = ({
  children: e,
  value: t
}) => {
  const a = xf(), i = a.useState("value"), h = e;
  return /* @__PURE__ */ f.jsx(
    Vp,
    {
      cursor: "pointer",
      shape: "basic",
      variant: "white",
      size: "medium",
      label: h,
      iconEnd: /* @__PURE__ */ f.jsx(Bx, {}),
      onMouseDown: (g) => {
        g.preventDefault(), g.stopPropagation();
        const m = Array.isArray(i) ? i.filter(
          (C) => !ff(C, { name: h, value: t })
        ) : "";
        a.setValue(m);
      }
    }
  );
};
B0.Label = _G;
B0.Group = RG;
B0.GroupLabel = EG;
B0.Option = _y;
B0.Popover = Ry;
B0.SelectTriggerButton = bG;
B0.useContext = xf;
B0.useStore = Pp;
var MG = $o({ defaultClassName: "_33k3h10", variantClassNames: { truncate: { true: "_33k3h11", false: "_33k3h12" }, size: { xSmall: "_33k3h13", small: "_33k3h14" }, collapsed: { true: "_33k3h15", false: "_33k3h16" }, outline: { true: "_33k3h17", false: "_33k3h18" }, rounded: { first: "_33k3h19", middle: "_33k3h1a", last: "_33k3h1b", true: "_33k3h1c" } }, defaultVariants: { size: "small", outline: !0, truncate: !1 }, compoundVariants: [] }), TG = "_33k3h1e", OG = "_33k3h1f", YR = "_33k3h1g", $R = "_33k3h1h";
const cS = ({
  label: e,
  name: t,
  tag: a,
  optional: i,
  disabled: h
}) => /* @__PURE__ */ f.jsxs(ct, { display: "flex", flexDirection: "row", gap: "6", children: [
  e && /* @__PURE__ */ f.jsxs(
    ct,
    {
      display: "flex",
      alignItems: "center",
      gap: "6",
      style: { height: 16 },
      children: [
        /* @__PURE__ */ f.jsx(FE, { name: t, children: /* @__PURE__ */ f.jsx(
          Fr,
          {
            userSelect: "none",
            size: "xSmall",
            weight: "medium",
            color: h ? "secondaryContentOnDisabled" : "weak",
            children: e
          }
        ) }),
        a
      ]
    }
  ),
  i && /* @__PURE__ */ f.jsx(Vp, { shape: "basic", size: "small", label: "Optional" })
] }), FO = ({
  children: e,
  label: t,
  disabled: a,
  name: i,
  tag: h,
  icon: g,
  optional: m = !1
}) => t ? /* @__PURE__ */ f.jsxs(ct, { display: "flex", flexDirection: "column", width: "full", gap: "4", children: [
  /* @__PURE__ */ f.jsxs(ct, { display: "flex", flexDirection: "row", gap: "6", alignItems: "center", children: [
    t && /* @__PURE__ */ f.jsx(
      cS,
      {
        label: t,
        name: i,
        tag: h,
        disabled: a
      }
    ),
    m && /* @__PURE__ */ f.jsx(Vp, { shape: "basic", size: "small", label: "Optional" }),
    g
  ] }),
  e
] }) : /* @__PURE__ */ f.jsx(f.Fragment, { children: e }), Ds = ({
  children: e,
  defaultValues: t,
  store: a,
  noValidate: i = !1,
  // use browser validation by default
  ...h
}) => /* @__PURE__ */ f.jsx(PE, { defaultValues: t, store: a, children: /* @__PURE__ */ f.jsx(ZE, { noValidate: i, ...h, role: "form", children: e }) }), DG = ({ ...e }) => /* @__PURE__ */ f.jsx(VE, { ...e, render: /* @__PURE__ */ f.jsx(ct, { color: "bad" }) }), jG = (e) => /* @__PURE__ */ f.jsx(qE, { render: /* @__PURE__ */ f.jsx(d3, {}), ...e }), AG = Oy(
  ({
    label: e,
    labelTag: t,
    icon: a,
    cssClass: i,
    size: h,
    collapsed: g,
    truncate: m,
    outline: C,
    name: S,
    rounded: R,
    ...D
  }, T) => {
    const j = Pt(null), A = T ?? j;
    Sa.useEffect(() => {
      g && A.current && A.current.blur();
    }, [g]), A.current && A.current.value && (g = !1);
    const L = D.type === "number";
    L && (D.step = D.step ?? 1);
    const P = () => {
      const V = new Event("change", {
        bubbles: !0
      });
      A.current.dispatchEvent(V);
    };
    return /* @__PURE__ */ f.jsx(
      FO,
      {
        label: e,
        name: S,
        icon: a,
        tag: t,
        disabled: D.disabled,
        children: /* @__PURE__ */ f.jsxs(ct, { position: "relative", flex: "stretch", children: [
          /* @__PURE__ */ f.jsx(
            Jy,
            {
              ref: A,
              name: S,
              className: Br(
                MG({
                  size: h,
                  collapsed: g,
                  outline: C,
                  truncate: m,
                  rounded: R
                }),
                i,
                {
                  [TG]: L
                }
              ),
              ...D
            }
          ),
          L && /* @__PURE__ */ f.jsxs(
            ct,
            {
              display: "flex",
              position: "absolute",
              flexDirection: "column",
              style: { top: 0, right: 0, bottom: 0 },
              children: [
                /* @__PURE__ */ f.jsx(
                  "button",
                  {
                    type: "button",
                    className: YR,
                    onClick: (V) => {
                      var Y;
                      const F = V.shiftKey ? 10 : 1;
                      (Y = A.current) == null || Y.stepUp(F), P();
                    },
                    children: /* @__PURE__ */ f.jsx(
                      FU,
                      {
                        size: "16",
                        className: $R
                      }
                    )
                  }
                ),
                /* @__PURE__ */ f.jsx(ct, { cssClass: OG }),
                /* @__PURE__ */ f.jsx(
                  "button",
                  {
                    type: "button",
                    className: YR,
                    onClick: (V) => {
                      var Y;
                      const F = V.shiftKey ? 10 : 1;
                      (Y = A.current) == null || Y.stepDown(F), P();
                    },
                    children: /* @__PURE__ */ f.jsx(
                      Nx,
                      {
                        size: "16",
                        className: $R
                      }
                    )
                  }
                )
              ]
            }
          )
        ] })
      }
    );
  }
), kG = ({
  children: e,
  label: t = "",
  tag: a,
  optional: i,
  name: h,
  options: g,
  creatable: m,
  disabled: C,
  filterable: S,
  checkType: R,
  defaultValue: D,
  displayMode: T,
  loading: j,
  trigger: A,
  onValueChange: L,
  onCreate: P,
  renderValue: V,
  ...F
}) => {
  const Y = Rl(), W = F.value ?? Y.useValue(h);
  return /* @__PURE__ */ f.jsxs(Do, { direction: "column", gap: "4", children: [
    t.trim() !== "" && /* @__PURE__ */ f.jsx(
      cS,
      {
        label: t,
        name: h,
        tag: a,
        optional: i,
        disabled: C
      }
    ),
    /* @__PURE__ */ f.jsx(
      Jy,
      {
        name: h,
        render: /* @__PURE__ */ f.jsx(
          B0,
          {
            value: W,
            options: g,
            creatable: m,
            disabled: C,
            filterable: S,
            checkType: R,
            defaultValue: D,
            displayMode: T,
            loading: j,
            trigger: A,
            renderValue: V,
            onCreate: P,
            onValueChange: (Q) => {
              Y.setValue(h, Q.value), L && L(Q);
            }
          }
        ),
        ...F,
        children: e
      }
    )
  ] });
}, LG = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(B0.Option, { ...t, children: e });
Ds.Input = AG;
Ds.Error = DG;
Ds.Submit = jG;
Ds.Label = cS;
Ds.Select = kG;
Ds.Option = LG;
Ds.NamedSection = FO;
Ds.useStore = Gy;
Ds.useContext = Rl;
var IG = "_11uj8320", HG = $o({ defaultClassName: "_11uj8322 _11uj8321 _1faqfmv4e _1faqfmv4y _1faqfmv37 _1faqfmv3r _1faqfmvsz _1faqfmv1x _1faqfmvtn", variantClassNames: { selected: { true: "_11uj8323", false: "_11uj8324" } }, defaultVariants: { selected: !1 }, compoundVariants: [] }), ZG = "_11uj8325", PG = "_11uj8326";
const da = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(eT, { ...t, children: e }), VG = ({
  children: e,
  ...t
}) => {
  const a = yf(), i = t.icon && !e ? /* @__PURE__ */ f.jsx(h3, { icon: t.icon }) : /* @__PURE__ */ f.jsx(d3, {});
  return /* @__PURE__ */ f.jsx(nT, { render: i, store: a, ...t, children: e });
}, NG = ({ children: e, cssClass: t, ...a }) => {
  const i = yf();
  return /* @__PURE__ */ f.jsxs(
    JM,
    {
      store: i,
      gutter: 4,
      className: Br(IG, t),
      ...a,
      children: [
        /* @__PURE__ */ f.jsx(tT, { size: 0 }),
        e
      ]
    }
  );
}, BG = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(
  lT,
  {
    className: HG({ selected: !1 }),
    ...t,
    children: typeof e == "string" ? /* @__PURE__ */ f.jsx(Fr, { children: e }) : e
  }
), UO = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f.jsx(uT, { className: ZG, ...t, children: e }), FG = ({
  children: e,
  className: t,
  ...a
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsx(
    iT,
    {
      className: Br(PG, t),
      ...a,
      children: e
    }
  ),
  /* @__PURE__ */ f.jsx(UO, {})
] });
da.Button = VG;
da.List = NG;
da.Item = BG;
da.Divider = UO;
da.Heading = FG;
da.useStore = Tx;
da.useContext = yf;
const UG = (e) => {
  const { selected: t, disabled: a, range: i } = e;
  return a ? "n8" : t || i == "will-be-range-start" || i == "will-be-range-end" ? "white" : "inherit";
}, YG = (e) => {
  const { range: t, selected: a, now: i } = e;
  return !a && !i && t === "" || i || a && t === "" || i && t === "will-be-range-end" || a && t === "range-start" || i && a || t === "will-be-range-start" ? "6" : "inherit";
}, $G = (e) => {
  const { range: t, selected: a, now: i } = e;
  return !a && !i && t === "" || i || a && t === "" || i && a || a && t === "range-end" || t === "will-be-range-end" ? "6" : "inherit";
}, WG = (e) => {
  const { range: t, selected: a, now: i } = e;
  return !a && !i && t === "" || i || a && t === "" || i && t === "will-be-range-end" || i && a || a && t === "range-start" || t === "will-be-range-start" ? "6" : "inherit";
}, zG = (e) => {
  const { range: t, selected: a, now: i } = e;
  return !a && !i && t === "" || i || a && t === "range-end" || i && a || a && t === "" ? "6" : a && t === "in-range" ? "inherit" : t === "will-be-range-end" ? "6" : "inherit";
}, qG = (e) => {
  const { selected: t, range: a, now: i, disabled: h } = e;
  return h ? "inherit" : i && t || i && a === "will-be-range-end" ? "p9" : i && a === "will-be-in-range" || t || a === "will-be-range-end" || a === "will-be-range-start" ? "p6" : "inherit";
}, GG = (e) => {
  const { selected: t, range: a, now: i, disabled: h } = e;
  return h ? "inherit" : i ? "lb300" : t || a == "will-be-range-end" || a == "will-be-range-start" ? "p9" : a == "will-be-in-range" || a == "in-range" ? "p6" : "inherit";
}, c5 = (e) => {
  const { selected: t, range: a, now: i } = e;
  return i ? "round" : t || a == "will-be-range-start" || a == "will-be-range-end" ? "6" : "inherit";
}, KG = (e) => {
  const { disabled: t } = e;
  return t ? "not-allowed" : "pointer";
}, QG = (e) => {
  const { now: t } = e;
  return t ? "24px" : "36px";
}, XG = (e) => {
  const { now: t } = e;
  return t ? "24px" : "34px";
}, WR = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, JG = ({ children: e, day: t, onMouseEnter: a, onMouseLeave: i }) => {
  const { dayButton: h } = XY(), g = t.now ? ct : iE, m = t.now ? {
    style: WR,
    backgroundColor: t.range === "will-be-in-range" || t.range === "in-range" || t.range === "will-be-range-end" || t.selected ? "p6" : "inherit",
    borderTopRightRadius: t.range === "range-end" || t.range === "will-be-range-end" ? "6" : "inherit",
    borderBottomRightRadius: t.range === "range-end" || t.range === "will-be-range-end" ? "6" : "inherit"
  } : {}, C = h(t);
  return /* @__PURE__ */ f.jsx(g, { ...m, children: /* @__PURE__ */ f.jsx(
    ct,
    {
      onMouseLeave: i,
      ...C,
      onMouseEnter: function() {
        var S;
        a == null || a(), (S = C == null ? void 0 : C.onMouseEnter) == null || S.call(C);
      },
      cursor: KG(t),
      style: WR,
      backgroundColor: {
        default: qG(t),
        hover: t.disabled || t.selected || t.range === "will-be-range-end" || t.range === "will-be-range-start" ? void 0 : "p4"
      },
      borderTopLeftRadius: YG(t),
      borderTopRightRadius: $G(t),
      borderBottomLeftRadius: WG(t),
      borderBottomRightRadius: zG(
        t
      ),
      children: /* @__PURE__ */ f.jsx(
        ct,
        {
          color: UG(t),
          backgroundColor: GG(t),
          padding: "10",
          style: {
            width: QG(t),
            height: XG(t),
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          borderTopLeftRadius: c5(t),
          borderBottomLeftRadius: c5(t),
          borderTopRightRadius: c5(t),
          borderBottomRightRadius: c5(t),
          children: e
        }
      )
    }
  ) });
};
var zR = "xcbb8h0", eK = "xcbb8h1", tK = "xcbb8h2";
$o({ defaultClassName: "xcbb8h3", variantClassNames: {}, defaultVariants: {}, compoundVariants: [] });
const nK = ({
  prevButton: e,
  nextButton: t,
  calendar: a,
  hasSelectedRange: i
}) => {
  const { weekDays: h } = FT(), [g, m] = Qt(!1), { days: C, month: S, year: R } = a;
  return /* @__PURE__ */ f.jsxs(ct, { backgroundColor: "white", p: "10", cursor: "default", children: [
    /* @__PURE__ */ f.jsxs(Do, { direction: "row", align: "center", children: [
      e,
      /* @__PURE__ */ f.jsx(ct, { flexGrow: 1, children: /* @__PURE__ */ f.jsxs(Fr, { userSelect: "none", align: "center", children: [
        S,
        " ",
        R
      ] }) }),
      t
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: eK, children: h.map((D) => /* @__PURE__ */ f.jsx(Fr, { align: "center", userSelect: "none", children: D }, D)) }),
    /* @__PURE__ */ f.jsx(
      "main",
      {
        className: tK,
        onMouseLeave: function() {
          m(!0);
        },
        children: C.map((D) => /* @__PURE__ */ f.jsx(
          JG,
          {
            day: {
              ...D,
              range: i ? D.range : g ? "" : D.range
            },
            onMouseEnter: function() {
              m(D.disabled);
            },
            children: /* @__PURE__ */ f.jsx(Fr, { userSelect: "none", align: "center", children: D.day })
          },
          D.$date.toString()
        ))
      }
    )
  ] });
}, rK = ({ hasSelectedRange: e }) => {
  const { calendars: t } = FT(), { addOffset: a, subtractOffset: i } = JY();
  return /* @__PURE__ */ f.jsx(
    nK,
    {
      hasSelectedRange: e,
      prevButton: /* @__PURE__ */ f.jsx(
        ct,
        {
          cursor: "pointer",
          ...i({ months: 1 }),
          cssClass: zR,
          children: /* @__PURE__ */ f.jsx(BU, {})
        }
      ),
      nextButton: /* @__PURE__ */ f.jsx(
        ct,
        {
          cursor: "pointer",
          ...a({ months: 1 }),
          cssClass: zR,
          children: /* @__PURE__ */ f.jsx(hy, {})
        }
      ),
      calendar: t[0]
    }
  );
};
function qR({ name: e, onDateChange: t, placeholder: a }) {
  const [i, h] = Qt(a), g = (C) => {
    const { value: S } = C.target;
    h(S);
  }, m = () => {
    i && t(i);
  };
  return gt(
    function() {
      h(a);
    },
    [a]
  ), /* @__PURE__ */ f.jsx(
    Ds.Input,
    {
      name: e,
      placeholder: a,
      type: "input",
      color: "n12",
      value: i,
      style: {
        border: "none",
        background: "none",
        fontSize: "13px",
        fontWeight: "500 !important",
        paddingLeft: "6px",
        width: "130px"
      },
      className: "date-input",
      onChange: g,
      onBlur: m,
      onKeyDown: (C) => {
        C.key === "Enter" && m();
      }
    }
  );
}
function GR({ placeholder: e, name: t, onTimeChange: a }) {
  const [i, h] = Qt(""), g = (C) => {
    const { value: S } = C.target;
    h(S);
  }, m = () => {
    i && a(i);
  };
  return /* @__PURE__ */ f.jsx(
    Ds.Input,
    {
      name: t,
      placeholder: e,
      type: "input",
      color: "n12",
      value: i,
      style: {
        border: "none",
        background: "none",
        fontSize: "13px",
        fontWeight: "500 !important",
        paddingLeft: "6px",
        width: "130px"
      },
      className: "date-input",
      onChange: g,
      onBlur: m,
      onKeyDown: (C) => {
        C.key === "Enter" && m();
      }
    }
  );
}
const aK = "MMM DD, YYYY", oK = "MMM DD YYYY", iK = "MMM DD", lK = "MMM D, YYYY", uK = "MMM D YYYY", sK = "MMM D", cK = "MMMM DD, YYYY", fK = "MMMM DD YYYY", dK = "MMMM DD", hK = "MMMM D, YYYY", vK = "MMMM D YYYY", pK = "MMMM D", mK = "MM/DD/YYYY", gK = "MM/DD", wK = "MM-DD-YYYY", yK = "MM-DD", xK = "MM.DD.YYYY", SK = "MM.DD", YO = "HH:mm a", CK = "HH:mma", bK = "h:mm a", _K = "h:mma", RK = "HH:mm", EK = "h:mm", MK = "h a", TK = "h", OK = "ha", DK = "HH", jK = "hh:mm a", KR = [
  mK,
  wK,
  xK,
  aK,
  oK,
  uK,
  lK,
  cK,
  dK,
  iK,
  sK,
  gK,
  yK,
  SK,
  fK,
  hK,
  vK,
  pK
], QR = [
  YO,
  CK,
  bK,
  _K,
  MK,
  OK,
  TK,
  DK,
  RK,
  EK
], XR = (e) => e ? new Date(e).toLocaleDateString("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric"
}) : "", JR = (e, t) => e ? Ke(e).format(jK) : t ? "11:59pm" : "12:00 AM", eE = (e) => {
  const t = Ke(e, YO);
  return {
    hour: t.format("HH"),
    minute: t.minute(),
    timeOfDay: t.format("a"),
    hour24: t.hour()
  };
}, Z5 = (e, t) => t ? Ty(t) === Ty(e) : !1, AK = ({
  presets: e,
  selectedValue: t
}) => !e.find((i) => Z5(i, t.selectedPreset)), tE = (e, t) => {
  const a = {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  };
  return t && (a.year = "numeric"), e.toLocaleDateString("en-us", a);
}, f5 = (e, t, a) => {
  const i = new Date(e);
  return i.setHours(t), i.setMinutes(a), i;
}, nE = ({
  selectedValue: e,
  presets: t
}) => {
  const a = t.find((g) => Z5(g, e.selectedPreset));
  if (a)
    return $O(a);
  const { startDate: i, endDate: h } = e;
  if (i && h) {
    const g = h.getFullYear() > i.getFullYear();
    return `${tE(i, g)} - ${tE(
      h,
      g
    )}`;
  }
  return "";
};
var kK = /* @__PURE__ */ ((e) => (e[e.Default = 0] = "Default", e[e.Custom = 1] = "Custom", e))(kK || {});
const LK = [
  {
    unit: "minutes",
    quantity: 15
  },
  {
    unit: "minutes",
    quantity: 60
  },
  {
    unit: "hours",
    quantity: 4
  },
  {
    unit: "hours",
    quantity: 24
  },
  {
    unit: "days",
    quantity: 7
  },
  {
    unit: "days",
    quantity: 30
  }
], Uie = LK.concat({
  unit: "months",
  quantity: 3
}), $O = (e) => e.label || `Last ${e.quantity} ${e.unit}`, Ty = (e) => e.value || `last_${e.quantity}_${e.unit}`, Yie = (e) => {
  const [, t, a] = e.split("_");
  return {
    quantity: Number(t),
    unit: a
  };
}, IK = (e) => Ke().subtract(e.quantity, e.unit).toDate(), $ie = (e) => {
  const [t, a] = Qt(!1);
  return /* @__PURE__ */ f.jsx(da, { open: t, setOpen: a, placement: "bottom-end", children: /* @__PURE__ */ f.jsx(HK, { ...e, open: t }) });
}, $8 = ({
  isSelected: e,
  size: t = 16
}) => /* @__PURE__ */ f.jsx(ct, { style: { height: t, width: t }, color: "primaryEnabled", children: e && /* @__PURE__ */ f.jsx(kT, { size: t }) }), HK = ({
  selectedValue: e,
  onDatesChange: t,
  presets: a,
  noCustom: i,
  defaultPreset: h,
  setDefaultPreset: g,
  minDate: m,
  maxDate: C = Ke().toDate(),
  open: S,
  ...R
}) => {
  const [D, T] = Sa.useState(
    0
    /* Default */
  ), [j, A] = Qt(!0), [L, P] = Qt(!0), [V, F] = Qt(!0), [Y, W] = Qt(!0), Q = !e.selectedPreset, [$, le] = Qt(
    Q ? [e.startDate, e.endDate] : []
  ), te = yf();
  gt(() => {
    S || T(
      0
      /* Default */
    );
  }, [S]);
  const Se = Lr(
    () => XR(e.startDate),
    [e.startDate]
  ), re = Lr(
    () => XR(e.endDate),
    [e.endDate]
  ), ve = Lr(
    () => JR(e.startDate),
    [e.startDate]
  ), K = Lr(
    () => JR(e.endDate, !0),
    [e.endDate]
  ), [de, fe] = Qt(
    nE({ selectedValue: e, presets: a })
  ), xe = ({
    startDate: Qe,
    endDate: et,
    selectedPreset: wt
  }) => {
    t(Qe, et, wt), Qe && et && (te.setOpen(!1), T(
      0
      /* Default */
    ));
  }, Le = (Qe) => {
    const et = KR.find(
      (wt) => Ke(Qe, wt, !0).isValid()
    );
    if (A(!!et), et) {
      const wt = Ke(Qe, et).toDate(), St = f5(
        wt,
        e.startDate.getHours(),
        e.startDate.getMinutes()
      );
      t(St, e.endDate, void 0);
    }
  }, be = (Qe) => {
    const et = KR.find(
      (wt) => Ke(Qe, wt, !0).isValid()
    );
    if (P(!!et), et) {
      const wt = Ke(Qe, et).toDate(), St = f5(
        wt,
        e.endDate.getHours(),
        e.endDate.getMinutes()
      );
      t(e.startDate, St, void 0);
    }
  }, Ue = (Qe) => {
    const et = QR.map(
      (wt) => Ke(Qe, wt, !0).isValid()
    ).some((wt) => wt);
    if (F(et), et && e.startDate) {
      const wt = eE(Qe), St = f5(
        e.startDate,
        wt.hour24,
        wt.minute
      );
      t(St, e.endDate, void 0);
    }
  }, ie = (Qe) => {
    const et = QR.map(
      (wt) => Ke(Qe, wt, !0).isValid()
    ).some((wt) => wt);
    if (W(et), et && e.endDate) {
      const wt = eE(Qe), St = f5(
        e.endDate,
        wt.hour24,
        wt.minute
      );
      t(e.startDate, St, void 0);
    }
  };
  gt(() => {
    (e.selectedPreset || e.startDate && e.endDate) && fe(nE({ selectedValue: e, presets: a }));
  }, [e]);
  const _e = Lr(
    () => e.startDate && e.endDate && [e.startDate, e.endDate].filter(
      (Qe) => Ke(Qe).isValid()
    ).length === 2,
    [e]
  ), Ze = Lr(() => a.map((Qe) => ({
    label: $O(Qe),
    value: Ty(Qe),
    quantity: Qe.quantity,
    unit: Qe.unit
  })), [a]), mt = (Qe) => {
    let et = Qe[0], wt = Qe[1];
    et && (et = Ke.max(Ke(et).startOf("day"), Ke(m)).toDate()), wt && (wt = Ke.min(Ke(wt).endOf("day"), Ke(C)).toDate()), et && wt && xe({ startDate: et, endDate: wt });
    const St = [et, wt].filter((_n) => !!_n);
    le(St);
  }, Pe = (Qe) => {
    const et = Ke().toDate(), wt = IK(Qe);
    xe({
      startDate: wt,
      endDate: et,
      selectedPreset: Qe
    });
  }, Vt = j && V, Dt = L && Y;
  return /* @__PURE__ */ f.jsxs(
    QY,
    {
      config: {
        selectedDates: $,
        onDatesChange: mt,
        dates: {
          mode: "range",
          minDate: m,
          maxDate: C,
          selectSameDate: !0
        }
      },
      children: [
        /* @__PURE__ */ f.jsx(
          da.Button,
          {
            kind: "secondary",
            iconRight: /* @__PURE__ */ f.jsx(Nx, {}),
            style: {
              whiteSpace: "nowrap",
              overflow: "hidden"
            },
            ...R,
            children: de
          }
        ),
        /* @__PURE__ */ f.jsxs(da.List, { children: [
          D === 0 && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
            Ze.map((Qe) => /* @__PURE__ */ f.jsx(
              da.Item,
              {
                onClick: (et) => {
                  et.preventDefault(), et.stopPropagation(), Pe(Qe);
                },
                children: /* @__PURE__ */ f.jsxs(
                  Do,
                  {
                    py: "2",
                    direction: "row",
                    align: "center",
                    gap: "4",
                    children: [
                      /* @__PURE__ */ f.jsx(
                        $8,
                        {
                          isSelected: Z5(
                            Qe,
                            e.selectedPreset
                          )
                        }
                      ),
                      /* @__PURE__ */ f.jsx(Fr, { userSelect: "none", children: Qe.label })
                    ]
                  }
                )
              },
              Qe.label
            )),
            i ? null : /* @__PURE__ */ f.jsx(
              da.Item,
              {
                onClick: (Qe) => {
                  Qe.preventDefault(), Qe.stopPropagation(), T(
                    1
                    /* Custom */
                  );
                },
                children: /* @__PURE__ */ f.jsxs(
                  Do,
                  {
                    width: "full",
                    display: "flex",
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                      /* @__PURE__ */ f.jsxs(
                        Do,
                        {
                          direction: "row",
                          align: "center",
                          gap: "4",
                          children: [
                            /* @__PURE__ */ f.jsx(
                              $8,
                              {
                                isSelected: AK({
                                  presets: a,
                                  selectedValue: e
                                })
                              }
                            ),
                            /* @__PURE__ */ f.jsx(Fr, { userSelect: "none", children: "Custom" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ f.jsx(hy, { size: 16 })
                    ]
                  }
                )
              }
            ),
            h && g && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
              /* @__PURE__ */ f.jsx(da.Divider, {}),
              /* @__PURE__ */ f.jsxs(da, { children: [
                /* @__PURE__ */ f.jsx(da.Button, { render: /* @__PURE__ */ f.jsx(da.Item, {}), children: /* @__PURE__ */ f.jsxs(
                  Do,
                  {
                    width: "full",
                    display: "flex",
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                      /* @__PURE__ */ f.jsxs(
                        Do,
                        {
                          direction: "row",
                          align: "center",
                          gap: "4",
                          children: [
                            /* @__PURE__ */ f.jsx(UU, { size: 16 }),
                            /* @__PURE__ */ f.jsx(Fr, { userSelect: "none", children: "Default" }),
                            /* @__PURE__ */ f.jsx(
                              Vp,
                              {
                                label: `${h.quantity} ${h.unit}`
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ f.jsx(hy, { size: 16 })
                    ]
                  }
                ) }),
                /* @__PURE__ */ f.jsx(da.List, { children: Ze.map((Qe) => /* @__PURE__ */ f.jsx(
                  da.Item,
                  {
                    onClick: (et) => {
                      et.preventDefault(), et.stopPropagation(), g(Qe);
                    },
                    children: /* @__PURE__ */ f.jsxs(
                      Do,
                      {
                        py: "2",
                        direction: "row",
                        align: "center",
                        gap: "4",
                        children: [
                          /* @__PURE__ */ f.jsx(
                            $8,
                            {
                              isSelected: Z5(
                                Qe,
                                h
                              )
                            }
                          ),
                          /* @__PURE__ */ f.jsx(Fr, { userSelect: "none", children: `${Qe.quantity} ${Qe.unit}` })
                        ]
                      }
                    )
                  },
                  Qe.label
                )) })
              ] })
            ] })
          ] }),
          D === 1 && /* @__PURE__ */ f.jsxs(Ds, { children: [
            /* @__PURE__ */ f.jsxs(
              ct,
              {
                borderBottom: "divider",
                pb: "4",
                px: "4",
                display: "flex",
                gap: "4",
                children: [
                  /* @__PURE__ */ f.jsxs(
                    ct,
                    {
                      style: { width: 130 },
                      border: Vt ? "secondary" : "error",
                      borderRadius: "6",
                      children: [
                        /* @__PURE__ */ f.jsx(
                          ct,
                          {
                            borderBottom: Vt ? "secondary" : "error",
                            children: /* @__PURE__ */ f.jsx(
                              qR,
                              {
                                name: "startDate",
                                placeholder: Se || "Start date",
                                onDateChange: Le
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ f.jsx(ct, { children: /* @__PURE__ */ f.jsx(
                          GR,
                          {
                            name: "startTime",
                            placeholder: ve,
                            onTimeChange: Ue
                          }
                        ) })
                      ]
                    }
                  ),
                  /* @__PURE__ */ f.jsxs(
                    ct,
                    {
                      style: { width: 130 },
                      border: Dt ? "secondary" : "error",
                      borderRadius: "6",
                      children: [
                        /* @__PURE__ */ f.jsx(
                          ct,
                          {
                            borderBottom: Dt ? "secondary" : "error",
                            children: /* @__PURE__ */ f.jsx(
                              qR,
                              {
                                name: "endDate",
                                placeholder: re || "End date",
                                onDateChange: be
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ f.jsx(ct, { children: /* @__PURE__ */ f.jsx(
                          GR,
                          {
                            name: "endTime",
                            placeholder: K,
                            onTimeChange: ie
                          }
                        ) })
                      ]
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ f.jsx(
              da.Item,
              {
                style: { padding: 0 },
                onClick: (Qe) => {
                  Qe.preventDefault(), Qe.stopPropagation();
                },
                children: /* @__PURE__ */ f.jsx(rK, { hasSelectedRange: _e })
              }
            )
          ] })
        ] })
      ]
    }
  );
}, ZK = Ke(), Wie = () => ZK.clone(), fS = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(lx, { ...t, children: e });
fS.useStore = G4;
fS.useContext = z4;
fS.Provider = ux;
var PK = $o({ defaultClassName: "_1njg9051 _1njg9050 _1faqfmv5b", variantClassNames: { align: { center: "_1njg9052" }, level: { h1: "_1njg9053", h2: "_1njg9054", h3: "_1njg9055", h4: "_1njg9056" } }, defaultVariants: {}, compoundVariants: [] });
const zie = ({
  align: e,
  as: t,
  children: a,
  level: i = "h2",
  lines: h,
  title: g,
  ...m
}) => {
  const C = h ? /* @__PURE__ */ f.jsx(Zx, { lines: h, children: a }) : a;
  return /* @__PURE__ */ f.jsx(
    ct,
    {
      as: t || i,
      cssClass: PK({ align: e, level: i }),
      title: g,
      ...m,
      children: C
    }
  );
};
var VK = $o({ defaultClassName: "_10i04yv0", variantClassNames: { size: { medium: "_10i04yv1" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });
const qie = ({ ...e }) => {
  const [t, a] = Sa.useState(
    e.selectedKey ?? e.options[0].key
  );
  return /* @__PURE__ */ f.jsxs(da, { children: [
    /* @__PURE__ */ f.jsx(
      da.Button,
      {
        size: e.size,
        kind: "secondary",
        emphasis: "low",
        className: VK({ size: e.size }),
        children: /* @__PURE__ */ f.jsxs(ct, { display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ f.jsx(Fr, { case: "capital", children: t }),
          /* @__PURE__ */ f.jsx(Nx, {})
        ] })
      }
    ),
    /* @__PURE__ */ f.jsx(da.List, { children: e.options.map((i, h) => {
      var m;
      const g = /* @__PURE__ */ f.jsx(
        da.Item,
        {
          onClick: () => {
            a(i.key), e.onChange(i.key);
          },
          children: i.variants ? /* @__PURE__ */ f.jsx(ct, { display: "flex", alignItems: "center", children: /* @__PURE__ */ f.jsx(
            Vp,
            {
              size: "medium",
              label: (m = i.render) == null ? void 0 : m.toString(),
              ...i.variants
            }
          ) }) : /* @__PURE__ */ f.jsx(ct, { paddingLeft: "2", children: /* @__PURE__ */ f.jsx(Fr, { children: i.render }) })
        },
        i.key
      );
      return e.divider && e.options.length > 2 && h === 0 ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        g,
        /* @__PURE__ */ f.jsx(da.Divider, {})
      ] }) : g;
    }) })
  ] });
};
var NK = "_48zb7v0";
const Fp = ({
  children: e,
  hideOnInteractOutside: t,
  unmountOnHide: a,
  width: i = 360,
  onClose: h,
  ...g
}) => /* @__PURE__ */ f.jsx(ux, { ...g, children: /* @__PURE__ */ f.jsx(
  lx,
  {
    modal: !0,
    render: /* @__PURE__ */ f.jsx(
      ct,
      {
        border: "divider",
        borderRadius: "8",
        boxShadow: "small",
        overflow: "hidden",
        cssClass: NK,
        style: { width: i }
      }
    ),
    hideOnInteractOutside: t,
    unmountOnHide: a,
    onClose: h,
    getPersistentElements: () => Array.from(
      document.querySelectorAll(
        "[data-persistent-element]"
      )
    ).filter((m) => m != null),
    backdrop: /* @__PURE__ */ f.jsx(
      ct,
      {
        style: {
          backgroundColor: "rgba(111, 110, 119, 0.48)"
        }
      }
    ),
    children: e
  }
) }), BK = ({ children: e }) => {
  const t = z4();
  return /* @__PURE__ */ f.jsxs(
    ct,
    {
      py: "6",
      px: "8",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      bb: "divider",
      borderTopLeftRadius: "8",
      borderTopRightRadius: "8",
      backgroundColor: "raised",
      position: "relative",
      children: [
        /* @__PURE__ */ f.jsx(Do, { align: "center", direction: "row", gap: "6", children: e }),
        /* @__PURE__ */ f.jsx(
          h3,
          {
            icon: /* @__PURE__ */ f.jsx(Bx, {}),
            size: "xSmall",
            emphasis: "low",
            kind: "secondary",
            onClick: t.hide,
            style: { position: "absolute", top: 6, right: 8 }
          }
        )
      ]
    }
  );
}, FK = ({ children: e }) => /* @__PURE__ */ f.jsx(ct, { backgroundColor: "white", padding: "12", children: e }), UK = ({ actions: e, children: t }) => /* @__PURE__ */ f.jsxs(
  ct,
  {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "4",
    borderTop: "divider",
    borderBottomLeftRadius: "8",
    borderBottomRightRadius: "8",
    backgroundColor: "raised",
    children: [
      /* @__PURE__ */ f.jsx(ct, { display: "flex", alignItems: "center", flexDirection: "row", children: t }),
      /* @__PURE__ */ f.jsx(Do, { gap: "4", direction: "row", children: e })
    ]
  }
), YK = (e) => {
  const t = z4();
  return /* @__PURE__ */ f.jsx(
    d3,
    {
      onClick: t.hide,
      kind: "secondary",
      emphasis: "high",
      ...e,
      children: "Cancel"
    }
  );
};
Fp.Header = BK;
Fp.Body = FK;
Fp.Footer = UK;
Fp.CancelButton = YK;
Fp.useStore = G4;
Fp.useContext = z4;
var $K = "v28rj20", WK = "v28rj21", zK = "v28rj22", qK = "v28rj23", GK = "v28rj24", KK = "v28rj25";
const Gie = ({
  label: e,
  icon: t,
  defaultValue: a,
  value: i,
  options: h,
  onChange: g,
  selected: m
}) => {
  const C = Pp({
    defaultValue: a ? [a] : [],
    value: i,
    setValue: (S) => g(S)
  });
  return /* @__PURE__ */ f.jsxs(ct, { children: [
    /* @__PURE__ */ f.jsx(
      Sw,
      {
        store: C,
        className: $K,
        children: e
      }
    ),
    /* @__PURE__ */ f.jsx(
      f3,
      {
        store: C,
        className: Br(WK, {
          [zK]: m
        }),
        children: /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          t,
          /* @__PURE__ */ f.jsx(
            Fr,
            {
              size: "xSmall",
              color: m ? "white" : "secondaryContentText",
              children: e
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ f.jsxs(
      Cw,
      {
        store: C,
        gutter: 4,
        className: qK,
        children: [
          /* @__PURE__ */ f.jsx(Zp, { size: 0 }),
          h.map((S) => /* @__PURE__ */ f.jsxs(
            xw,
            {
              value: S.key,
              className: GK,
              children: [
                /* @__PURE__ */ f.jsx("div", { className: KK, children: S.clearsOnClick && !i.includes(S.key) ? /* @__PURE__ */ f.jsx(zU, { color: "grey" }) : /* @__PURE__ */ f.jsx(Vx, { color: "white" }) }),
                S.render
              ]
            },
            S.key
          ))
        ]
      }
    )
  ] });
};
var QK = "high", XK = "primary", JK = "rounded", eQ = "medium", rE = $o({ defaultClassName: "p08wka0", variantClassNames: { size: { small: "p08wka1", medium: "p08wka2", large: "p08wka3" } }, defaultVariants: { size: "medium" }, compoundVariants: [] }), tQ = $o({ defaultClassName: "p08wkak p08wka4 _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvsz _1faqfmvex _1faqfmv21 _1faqfmv2g", variantClassNames: { emphasis: { low: "p08wkal", medium: "p08wkam", high: "p08wkan" }, kind: { primary: "p08wkao", secondary: "p08wkap", danger: "p08wkaq", success: "p08wkar" }, shape: { rounded: "p08wkas", basic: "p08wkat", leftBasic: "p08wkau", rightBasic: "p08wkav", square: "p08wkaw" }, size: { small: "p08wkax", medium: "p08wkay", large: "p08wkaz" } }, defaultVariants: { emphasis: "high", kind: "primary", size: "medium", shape: "rounded" }, compoundVariants: [[{ kind: "primary", emphasis: "high" }, "p08wka10"], [{ kind: "primary", emphasis: "medium" }, "p08wka11"], [{ kind: "primary", emphasis: "low" }, "p08wka12"], [{ kind: "secondary", emphasis: "high" }, "p08wka13"], [{ kind: "secondary", emphasis: "medium" }, "p08wka14"], [{ kind: "secondary", emphasis: "low" }, "p08wka15"], [{ size: "small", shape: "rounded" }, "p08wka16 p08wka5 _1faqfmv4c _1faqfmv4w _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmva"], [{ size: "medium", shape: "rounded" }, "p08wka17 p08wka6 _1faqfmv4e _1faqfmv4y _1faqfmv35 _1faqfmv3p _1faqfmvub _1faqfmv9"], [{ size: "large", shape: "rounded" }, "p08wka18 p08wka7 _1faqfmv4g _1faqfmv50 _1faqfmv35 _1faqfmv3p _1faqfmvub _1faqfmv7"], [{ size: "small", shape: "basic" }, "p08wka19 p08wka8 _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmv2"], [{ size: "medium", shape: "basic" }, "p08wka1a p08wka9 _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmv4"], [{ size: "large", shape: "basic" }, "p08wka1b p08wkaa _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmv5"], [{ size: "small", shape: "leftBasic" }, "p08wka1c p08wkab _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmvf _1faqfmv15"], [{ size: "medium", shape: "leftBasic" }, "p08wka1d p08wkac _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvh _1faqfmv17"], [{ size: "large", shape: "leftBasic" }, "p08wka1e p08wkad _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvi _1faqfmv18"], [{ size: "small", shape: "square" }, "p08wka1f p08wkae _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7"], [{ size: "medium", shape: "square" }, "p08wka1g p08wkaf _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7"], [{ size: "large", shape: "square" }, "p08wka1h p08wkag _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7"], [{ size: "small", shape: "rightBasic" }, "p08wka1i p08wkah _1faqfmv4b _1faqfmv4v _1faqfmv33 _1faqfmv3n _1faqfmvu7 _1faqfmvs _1faqfmv1i"], [{ size: "medium", shape: "rightBasic" }, "p08wka1j p08wkai _1faqfmv4b _1faqfmv4v _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvu _1faqfmv1k"], [{ size: "large", shape: "rightBasic" }, "p08wka1k p08wkaj _1faqfmv4c _1faqfmv4w _1faqfmv35 _1faqfmv3p _1faqfmvu7 _1faqfmvv _1faqfmv1l"]] });
const nQ = {
  small: "xSmall",
  medium: "xSmall",
  large: "small"
}, dS = ({
  children: e,
  className: t,
  icon: a,
  iconLeft: i,
  iconRight: h,
  emphasis: g = QK,
  shape: m = JK,
  size: C = eQ,
  kind: S = XK,
  lines: R,
  wordBreak: D,
  onIconLeftClick: T,
  onIconRightClick: j,
  ...A
}) => {
  const L = nQ[C];
  return a = a || i, /* @__PURE__ */ f.jsxs(
    $5,
    {
      render: /* @__PURE__ */ f.jsx("button", {}),
      className: Br([
        t,
        tQ({
          emphasis: g,
          kind: S,
          size: C,
          shape: m
        })
      ]),
      style: { cursor: A.onClick ? "pointer" : "default" },
      type: "button",
      ...A,
      children: [
        a && /* @__PURE__ */ f.jsx(
          ct,
          {
            as: "span",
            display: "inline-flex",
            cssClass: rE({ size: C }),
            onClick: T,
            children: a
          }
        ),
        e && /* @__PURE__ */ f.jsx(
          Fr,
          {
            lines: R,
            size: L,
            userSelect: "none",
            color: "inherit",
            display: "inline-flex",
            break: D,
            children: e
          }
        ),
        h && /* @__PURE__ */ f.jsx(
          ct,
          {
            as: "span",
            display: "inline-flex",
            cssClass: rE({ size: C }),
            onClick: j,
            children: h
          }
        )
      ]
    }
  );
}, Up = ({
  children: e,
  ...t
}) => /* @__PURE__ */ f.jsx(BM, { placement: "bottom", ...t, children: e }), rQ = ({
  children: e,
  ...t
}) => {
  const a = bh();
  return /* @__PURE__ */ f.jsx(
    fw,
    {
      store: a,
      render: /* @__PURE__ */ f.jsx(d3, {}),
      ...t,
      children: e
    }
  );
}, aQ = ({
  children: e,
  ...t
}) => {
  const a = bh();
  return /* @__PURE__ */ f.jsx(fw, { store: a, render: /* @__PURE__ */ f.jsx(dS, {}), ...t, children: e });
}, oQ = ({ children: e, ...t }) => {
  const a = bh();
  return /* @__PURE__ */ f.jsx(fw, { store: a, render: /* @__PURE__ */ f.jsx(ct, {}), ...t, children: e });
}, iQ = ({ children: e, className: t, ...a }) => {
  const i = bh();
  return /* @__PURE__ */ f.jsxs(
    VM,
    {
      ...a,
      className: t,
      store: i,
      gutter: 4,
      children: [
        /* @__PURE__ */ f.jsx(Zp, { size: 0 }),
        e
      ]
    }
  );
};
Up.ButtonTrigger = rQ;
Up.TagTrigger = aQ;
Up.BoxTrigger = oQ;
Up.Content = iQ;
Up.useContext = bh;
Up.useStore = cx;
var lQ = $o({ defaultClassName: "_1c7l6so1 _1c7l6so0 _1faqfmv5", variantClassNames: { size: { xxSmall: "_1c7l6so2", xSmall: "_1c7l6so3", small: "_1c7l6so4", medium: "_1c7l6so5" }, variant: { checked: "_1c7l6so6", unchecked: "_1c7l6so7" } }, defaultVariants: { variant: "unchecked" }, compoundVariants: [] });
const Kie = ({
  onChange: e,
  checked: t,
  size: a,
  iconLeft: i,
  iconRight: h,
  children: g,
  ...m
}) => {
  const C = lQ({
    size: a,
    variant: t ? "checked" : "unchecked"
  }), S = Y4();
  return /* @__PURE__ */ f.jsxs(
    kE,
    {
      render: /* @__PURE__ */ f.jsx("button", {}),
      className: C,
      store: S,
      onChange: e,
      checked: t,
      ...m,
      children: [
        i && /* @__PURE__ */ f.jsx(ct, { as: "span", display: "inline-flex", children: i }),
        g && /* @__PURE__ */ f.jsx(Fr, { size: "xSmall", children: g }),
        h && /* @__PURE__ */ f.jsx(ct, { as: "span", display: "inline-flex", children: h })
      ]
    }
  );
}, uQ = Sa.forwardRef(
  ({ children: e, ...t }, a) => /* @__PURE__ */ f.jsx(ct, { ref: a, ...t, children: e })
);
var sQ = "_1j3v9ks0";
const WO = ({ children: e, icon: t, ...a }) => /* @__PURE__ */ f.jsxs(
  ct,
  {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: a.onClick ? "pointer" : void 0,
    gap: "6",
    cssClass: sQ,
    borderRadius: "6",
    p: "8",
    ...a,
    children: [
      t && /* @__PURE__ */ f.jsx(ct, { as: "span", display: "inline-flex", children: t }),
      e
    ]
  }
);
var cQ = "_13pq1ik0", fQ = "_13pq1ik1", dQ = "_13pq1ik2", hQ = "_13pq1ik3";
const vQ = ({
  children: e,
  trigger: t = "cell"
}) => /* @__PURE__ */ f.jsx(
  ct,
  {
    display: "flex",
    cssClass: Br(cQ, {
      [fQ]: t === "row",
      [dQ]: t === "cell",
      [hQ]: t === "header"
    }),
    children: e
  }
);
var pQ = "_1kalioo0", mQ = "_1kalioo1";
const zO = ({
  children: e,
  gridColumns: t,
  selected: a,
  forwardRef: i,
  className: h,
  ...g
}) => {
  const C = Sa.Children.toArray(e).map(() => "1fr").join(" ");
  return /* @__PURE__ */ f.jsx(
    ct,
    {
      ref: i,
      cssClass: Br(pQ, h, {
        [mQ]: a
      }),
      cursor: g.onClick ? "pointer" : void 0,
      style: {
        gridTemplateColumns: t ? t.join(" ") : C
      },
      ...g,
      children: e
    }
  );
}, gQ = ({ children: e }) => /* @__PURE__ */ f.jsx(zO, { gridColumns: ["100%"], children: /* @__PURE__ */ f.jsx(WO, { justifyContent: "center", my: "8", children: e }) });
var wQ = "_1pj3g9p0";
const yQ = ({ children: e, className: t, ...a }) => /* @__PURE__ */ f.jsx(ct, { cssClass: Br(wQ, t), ...a, children: e });
var xQ = "_1z0mwsn0", SQ = "_1z0mwsn1";
const CQ = Oy(
  ({ children: e, noPadding: t, ...a }, i) => /* @__PURE__ */ f.jsx(
    ct,
    {
      cssClass: Br(xQ, {
        [SQ]: t
      }),
      ref: i,
      ...a,
      children: /* @__PURE__ */ f.jsx(Fr, { size: "xSmall", children: e })
    }
  )
);
var bQ = "_16l1zil1 _16l1zil0 _1faqfmv38 _1faqfmv3s", _Q = "_16l1zil2";
const RQ = ({ placeholder: e, handleChange: t }) => {
  const a = J4();
  return /* @__PURE__ */ f.jsxs(
    ct,
    {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      cssClass: bQ,
      px: "8",
      gap: "8",
      children: [
        /* @__PURE__ */ f.jsx(LT, { color: lh.theme.static.content.default }),
        /* @__PURE__ */ f.jsx(
          v3,
          {
            store: a,
            name: "search",
            placeholder: e ?? "Search...",
            className: _Q,
            onChange: t
          }
        )
      ]
    }
  );
};
var EQ = "_84yol10", MQ = "_84yol11";
const TQ = ({
  children: e,
  className: t,
  noBorder: a,
  ...i
}) => /* @__PURE__ */ f.jsx(
  ct,
  {
    cssClass: Br(EQ, t, {
      [MQ]: a
    }),
    width: "full",
    ...i,
    children: e
  }
), Rh = TQ;
Rh.Body = uQ;
Rh.Cell = WO;
Rh.Discoverable = vQ;
Rh.FullRow = gQ;
Rh.Head = yQ;
Rh.Header = CQ;
Rh.Row = zO;
Rh.Search = RQ;
const qO = ka({
  size: "sm"
}), y3 = ({
  children: e,
  defaultSelectedId: t,
  selectedId: a,
  size: i = "sm",
  onChange: h,
  scrollable: g
}) => {
  const m = ww({
    defaultSelectedId: t,
    setSelectedId: (C) => {
      h && h(C);
    }
  });
  return /* @__PURE__ */ f.jsx(qO.Provider, { value: { size: i }, children: /* @__PURE__ */ f.jsx(xT, { store: m, selectedId: a, children: /* @__PURE__ */ f.jsx(
    Do,
    {
      direction: "column",
      flexGrow: 1,
      gap: "0",
      width: "full",
      overflowY: g ? "hidden" : void 0,
      children: e
    }
  ) }) });
}, OQ = ({
  children: e,
  gap: t = "16",
  ...a
}) => /* @__PURE__ */ f.jsx(
  ST,
  {
    ...a,
    render: /* @__PURE__ */ f.jsx(
      Do,
      {
        align: "center",
        direction: "row",
        gap: t,
        borderBottom: "dividerWeak",
        children: e
      }
    )
  }
), DQ = ({ badgeText: e, children: t, icon: a, ...i }) => {
  const { size: h } = Yo(qO), m = Hx().useState("selectedId") === i.id, [C, S] = Qt(!1), R = C || m;
  return /* @__PURE__ */ f.jsx(
    yT,
    {
      ...i,
      render: /* @__PURE__ */ f.jsxs(
        ct,
        {
          display: "flex",
          gap: "4",
          pb: "6",
          flexDirection: "row",
          alignItems: "center",
          position: "relative",
          cursor: "pointer",
          onMouseEnter: () => S(!0),
          onMouseLeave: () => S(!1),
          children: [
            /* @__PURE__ */ f.jsx(
              dS,
              {
                shape: "basic",
                size: h === "xs" ? "medium" : "large",
                emphasis: "low",
                kind: m ? "primary" : "secondary",
                icon: a,
                children: t
              }
            ),
            e && /* @__PURE__ */ f.jsx(
              Vp,
              {
                label: e,
                variant: m ? "purple" : "gray",
                shape: "basic",
                size: "small"
              }
            ),
            R && /* @__PURE__ */ f.jsx(
              ct,
              {
                position: "absolute",
                backgroundColor: m ? "p9" : "n7",
                borderTopLeftRadius: "2",
                borderTopRightRadius: "2",
                width: "full",
                style: {
                  height: 2,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  width: "100%"
                }
              }
            )
          ]
        }
      )
    }
  );
}, jQ = ({
  children: e,
  scrollable: t,
  unmountOnHide: a = !0,
  ...i
}) => /* @__PURE__ */ f.jsx(
  CT,
  {
    ...i,
    unmountOnHide: a,
    render: /* @__PURE__ */ f.jsx(
      Do,
      {
        direction: "column",
        flexGrow: 1,
        id: i.id,
        overflowY: t ? "auto" : void 0
      }
    ),
    children: e
  }
);
y3.Tab = DQ;
y3.List = OQ;
y3.Panel = jQ;
y3.useStore = ww;
y3.useContext = Hx;
const Qie = ({
  background: e = !0,
  defaultValue: t,
  name: a,
  options: i,
  onChange: h,
  cssClass: g,
  disabled: m
}) => {
  const [C, S] = Qt(
    t ?? i[0]
  ), R = (D) => {
    S(D), h && h(D);
  };
  return /* @__PURE__ */ f.jsx(OT, { children: /* @__PURE__ */ f.jsx(
    DT,
    {
      "data-testid": "radio-group",
      className: Br(g),
      children: /* @__PURE__ */ f.jsx(
        Do,
        {
          direction: "row",
          gap: "4",
          p: "4",
          borderRadius: "8",
          backgroundColor: e ? "elevated" : void 0,
          flexGrow: 0,
          style: { borderRadius: 9 },
          children: i.map((D, T) => {
            const j = C === D;
            return /* @__PURE__ */ f.jsx(
              zE,
              {
                name: a,
                value: D,
                disabled: m,
                render: /* @__PURE__ */ f.jsx(
                  dS,
                  {
                    kind: j ? "primary" : "secondary",
                    emphasis: j ? "high" : "low",
                    size: "large",
                    shape: "basic",
                    onClick: () => R(D),
                    style: {
                      alignItems: "center",
                      justifyContent: "center",
                      flex: 1,
                      textAlign: "center"
                    },
                    "data-testid": "radio-option",
                    type: "button",
                    children: D
                  },
                  D
                )
              },
              T
            );
          })
        }
      )
    }
  ) });
};
var AQ = $o({ defaultClassName: "cuhupy0", variantClassNames: { underline: { none: "cuhupy1", solid: "cuhupy2" }, color: { none: "cuhupy3", default: "cuhupy4" } }, defaultVariants: { underline: "none" }, compoundVariants: [] });
const Xie = ({
  children: e,
  href: t,
  underline: a,
  target: i,
  rel: h,
  color: g
}) => /* @__PURE__ */ f.jsx(
  "a",
  {
    className: AQ({ underline: a, color: g }),
    href: t,
    target: i ?? "_blank",
    rel: h ?? "noreferrer",
    children: e
  }
), kQ = 500, Jie = ({
  children: e,
  trigger: t,
  disabled: a,
  style: i,
  delayed: h,
  renderInLine: g,
  maxWidth: m,
  shift: C,
  ...S
}) => {
  const R = Ax({
    placement: "top",
    timeout: h ? kQ : 0,
    ...S
  });
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      fT,
      {
        store: R,
        style: { display: "flex", ...i },
        children: t
      }
    ),
    !a && /* @__PURE__ */ f.jsxs(
      cT,
      {
        store: R,
        gutter: 4,
        style: { zIndex: 20001 },
        portal: !g,
        shift: C,
        children: [
          /* @__PURE__ */ f.jsx(dT, { size: 0 }),
          /* @__PURE__ */ f.jsx(LQ, { maxWidth: m, children: e })
        ]
      }
    )
  ] });
}, LQ = ({ children: e, maxWidth: t = 350 }) => /* @__PURE__ */ f.jsx(
  ct,
  {
    backgroundColor: "white",
    border: "secondary",
    p: "4",
    borderRadius: "6",
    shadow: "small",
    wordBreak: "break-word",
    style: { maxWidth: t },
    children: e
  }
);
export {
  FQ as Ariakit,
  Vp as Badge,
  ct as Box,
  d3 as Button,
  ZU as ButtonContent,
  h3 as ButtonIcon,
  WQ as ButtonLink,
  Pie as Callout,
  Vie as Card,
  aY as Column,
  v3 as Combobox,
  Bie as ComboboxSelect,
  Fie as Container,
  LK as DEFAULT_TIME_PRESETS,
  $ie as DateRangePicker,
  fS as Dialog,
  Uie as EXTENDED_TIME_PRESETS,
  DG as Error,
  Ds as Form,
  lY as Group,
  uY as GroupLabel,
  zie as Heading,
  zQ as IconOutlineAcademicCap,
  qQ as IconOutlineAdjustments,
  GQ as IconOutlineAnnotation,
  KQ as IconOutlineArchive,
  QQ as IconOutlineArrowCircleDown,
  XQ as IconOutlineArrowCircleLeft,
  JQ as IconOutlineArrowCircleRight,
  eX as IconOutlineArrowCircleUp,
  tX as IconOutlineArrowDown,
  nX as IconOutlineArrowLeft,
  rX as IconOutlineArrowNarrowDown,
  aX as IconOutlineArrowNarrowLeft,
  oX as IconOutlineArrowNarrowRight,
  iX as IconOutlineArrowNarrowUp,
  lX as IconOutlineArrowRight,
  sX as IconOutlineArrowSmDown,
  cX as IconOutlineArrowSmLeft,
  fX as IconOutlineArrowSmRight,
  dX as IconOutlineArrowSmUp,
  hX as IconOutlineArrowUp,
  uX as IconOutlineArrowsExpand,
  vX as IconOutlineAtSymbol,
  pX as IconOutlineBackspace,
  mX as IconOutlineBadgeCheck,
  gX as IconOutlineBan,
  wX as IconOutlineBeaker,
  yX as IconOutlineBell,
  CX as IconOutlineBookOpen,
  xX as IconOutlineBookmark,
  SX as IconOutlineBookmarkAlt,
  bX as IconOutlineBriefcase,
  _X as IconOutlineCake,
  RX as IconOutlineCalculator,
  EX as IconOutlineCalendar,
  MX as IconOutlineCamera,
  TX as IconOutlineCash,
  OX as IconOutlineChartBar,
  DX as IconOutlineChartPie,
  jX as IconOutlineChartSquareBar,
  AX as IconOutlineChat,
  kX as IconOutlineChatAlt,
  LX as IconOutlineChatAlt_2,
  IX as IconOutlineCheck,
  HX as IconOutlineCheckCircle,
  ZX as IconOutlineCheveronDown,
  PX as IconOutlineCheveronLeft,
  VX as IconOutlineCheveronRight,
  NX as IconOutlineCheveronUp,
  BX as IconOutlineChevronDoubleDown,
  FX as IconOutlineChevronDoubleLeft,
  UX as IconOutlineChevronDoubleRight,
  YX as IconOutlineChevronDoubleUp,
  $X as IconOutlineChip,
  WX as IconOutlineClipboard,
  zX as IconOutlineClipboardCheck,
  qX as IconOutlineClipboardCopy,
  GX as IconOutlineClipboardList,
  KX as IconOutlineClock,
  QX as IconOutlineCloud,
  XX as IconOutlineCloudDownload,
  JX as IconOutlineCloudUpload,
  eJ as IconOutlineCode,
  tJ as IconOutlineCog,
  nJ as IconOutlineCollection,
  rJ as IconOutlineColorSwatch,
  aJ as IconOutlineCreditCard,
  oJ as IconOutlineCube,
  iJ as IconOutlineCubeTransparent,
  lJ as IconOutlineCurrencyBangladeshi,
  uJ as IconOutlineCurrencyDollar,
  sJ as IconOutlineCurrencyEuro,
  cJ as IconOutlineCurrencyPound,
  fJ as IconOutlineCurrencyRupee,
  dJ as IconOutlineCurrencyYen,
  hJ as IconOutlineCursorClick,
  vJ as IconOutlineDatabase,
  pJ as IconOutlineDesktopComputer,
  mJ as IconOutlineDeviceMobile,
  gJ as IconOutlineDeviceTablet,
  wJ as IconOutlineDocument,
  yJ as IconOutlineDocumentAdd,
  xJ as IconOutlineDocumentDownload,
  SJ as IconOutlineDocumentDuplicate,
  CJ as IconOutlineDocumentRemove,
  bJ as IconOutlineDocumentReport,
  _J as IconOutlineDocumentSearch,
  RJ as IconOutlineDocumentText,
  EJ as IconOutlineDotsCircleHorizontal,
  MJ as IconOutlineDotsHorizontal,
  TJ as IconOutlineDotsVertical,
  OJ as IconOutlineDownload,
  DJ as IconOutlineDuplicate,
  jJ as IconOutlineEmojiHappy,
  AJ as IconOutlineEmojiSad,
  kJ as IconOutlineExclamation,
  LJ as IconOutlineExclamationCircle,
  IJ as IconOutlineExit,
  HJ as IconOutlineExternalLink,
  ZJ as IconOutlineEye,
  PJ as IconOutlineEyeOff,
  VJ as IconOutlineFastForward,
  NJ as IconOutlineFilm,
  BJ as IconOutlineFilter,
  FJ as IconOutlineFingerPrint,
  UJ as IconOutlineFire,
  YJ as IconOutlineFlag,
  $J as IconOutlineFolder,
  WJ as IconOutlineFolderAdd,
  zJ as IconOutlineFolderDownload,
  qJ as IconOutlineFolderOpen,
  GJ as IconOutlineFolderRemove,
  KJ as IconOutlineGift,
  QJ as IconOutlineGlobe,
  XJ as IconOutlineGlobeAlt,
  JJ as IconOutlineHand,
  eee as IconOutlineHashtag,
  tee as IconOutlineHeart,
  nee as IconOutlineHome,
  ree as IconOutlineIconUserRemove,
  aee as IconOutlineIdentification,
  oee as IconOutlineInbox,
  iee as IconOutlineInboxIn,
  lee as IconOutlineInformationCircle,
  uee as IconOutlineKey,
  see as IconOutlineLibrary,
  cee as IconOutlineLightBulb,
  fee as IconOutlineLightningBolt,
  dee as IconOutlineLink,
  hee as IconOutlineLocationMarker,
  vee as IconOutlineLockClosed,
  pee as IconOutlineLockOpen,
  mee as IconOutlineLogout,
  gee as IconOutlineMail,
  wee as IconOutlineMailOpen,
  yee as IconOutlineMap,
  xee as IconOutlineMenu,
  See as IconOutlineMenuAlt_1,
  Cee as IconOutlineMenuAlt_2,
  bee as IconOutlineMenuAlt_3,
  _ee as IconOutlineMenuAlt_4,
  Ree as IconOutlineMicrophone,
  Eee as IconOutlineMinus,
  Mee as IconOutlineMinusCircle,
  Tee as IconOutlineMinusSm,
  Oee as IconOutlineMoon,
  Dee as IconOutlineMusicNote,
  jee as IconOutlineNewspaper,
  Aee as IconOutlineOfficeBuilding,
  kee as IconOutlinePaperAirplane,
  Lee as IconOutlinePaperClip,
  Iee as IconOutlinePauseCircle,
  Hee as IconOutlinePencil,
  Zee as IconOutlinePencilAlt,
  Pee as IconOutlinePhone,
  Vee as IconOutlinePhoneIncoming,
  Nee as IconOutlinePhoneMissedCall,
  Bee as IconOutlinePhoneOutgoing,
  Fee as IconOutlinePhotograph,
  Uee as IconOutlinePlayCircle,
  Yee as IconOutlinePlus,
  $ee as IconOutlinePlusCircle,
  Wee as IconOutlinePlusSm,
  zee as IconOutlinePresentationChartBar,
  qee as IconOutlinePresentationChartLine,
  Gee as IconOutlinePrinter,
  Kee as IconOutlinePuzzle,
  Qee as IconOutlineQrCode,
  Xee as IconOutlineQuestionMarkCircle,
  Jee as IconOutlineReceiptRefund,
  ete as IconOutlineReceiptTax,
  tte as IconOutlineRefresh,
  nte as IconOutlineReply,
  rte as IconOutlineRewind,
  ate as IconOutlineRss,
  ote as IconOutlineSankeyChart,
  ite as IconOutlineSave,
  lte as IconOutlineSaveAs,
  ute as IconOutlineScale,
  ste as IconOutlineScissors,
  cte as IconOutlineSearch,
  fte as IconOutlineSearchCircle,
  dte as IconOutlineSelector,
  hte as IconOutlineServer,
  vte as IconOutlineShare,
  pte as IconOutlineShieldCheck,
  mte as IconOutlineShieldExclamation,
  gte as IconOutlineShoppingBag,
  wte as IconOutlineShoppingCart,
  yte as IconOutlineSixDotsVertical,
  xte as IconOutlineSmViewGridAdd,
  Ste as IconOutlineSortAscending,
  Cte as IconOutlineSortDescending,
  bte as IconOutlineSparkles,
  _te as IconOutlineSpeakerphone,
  Rte as IconOutlineStackedBarChart,
  Ete as IconOutlineStar,
  Mte as IconOutlineStatusOffline,
  Tte as IconOutlineStatusOnline,
  Ote as IconOutlineStopCircle,
  Dte as IconOutlineSun,
  jte as IconOutlineSunburstChart,
  Ate as IconOutlineSupport,
  kte as IconOutlineSwitchHorizontal,
  Lte as IconOutlineSwitchVertical,
  Ite as IconOutlineTable,
  Hte as IconOutlineTag,
  Zte as IconOutlineTemplate,
  Pte as IconOutlineTerminal,
  Vte as IconOutlineThumbDown,
  Nte as IconOutlineThumbUp,
  Bte as IconOutlineTicket,
  Fte as IconOutlineTranslate,
  Ute as IconOutlineTrash,
  Yte as IconOutlineTrendingDown,
  $te as IconOutlineTrendingUp,
  Wte as IconOutlineTruck,
  zte as IconOutlineUpload,
  qte as IconOutlineUser,
  Gte as IconOutlineUserAdd,
  Kte as IconOutlineUserCircle,
  Qte as IconOutlineUserGroup,
  Xte as IconOutlineUsers,
  Jte as IconOutlineVariable,
  ene as IconOutlineVideoCamera,
  tne as IconOutlineViewBoards,
  nne as IconOutlineViewGrid,
  rne as IconOutlineViewList,
  ane as IconOutlineVolumeOff,
  one as IconOutlineVolumeUp,
  ine as IconOutlineWifi,
  lne as IconOutlineX,
  une as IconOutlineXCircle,
  sne as IconOutlineZoomIn,
  cne as IconOutlineZoomOut,
  fne as IconSolidAcademicCap,
  dne as IconSolidAdjustments,
  hne as IconSolidAnnotation,
  vne as IconSolidArchive,
  pne as IconSolidArrowCircleDown,
  mne as IconSolidArrowCircleLeft,
  gne as IconSolidArrowCircleRight,
  wne as IconSolidArrowCircleUp,
  yne as IconSolidArrowDown,
  xne as IconSolidArrowLeft,
  Sne as IconSolidArrowNarrowDown,
  Cne as IconSolidArrowNarrowLeft,
  bne as IconSolidArrowNarrowRight,
  _ne as IconSolidArrowNarrowUp,
  Rne as IconSolidArrowRight,
  Mne as IconSolidArrowSmDown,
  Tne as IconSolidArrowSmLeft,
  One as IconSolidArrowSmRight,
  Dne as IconSolidArrowSmUp,
  jne as IconSolidArrowUp,
  Ene as IconSolidArrowsExpand,
  Ane as IconSolidAtSymbol,
  kne as IconSolidAvatar,
  Lne as IconSolidBackspace,
  Ine as IconSolidBadgeCheck,
  Hne as IconSolidBan,
  Zne as IconSolidBeaker,
  Pne as IconSolidBell,
  Bne as IconSolidBookOpen,
  Vne as IconSolidBookmark,
  Nne as IconSolidBookmarkAlt,
  Fne as IconSolidBriefcase,
  Une as IconSolidCake,
  Yne as IconSolidCalculator,
  $ne as IconSolidCalendar,
  Wne as IconSolidCamera,
  zne as IconSolidCart,
  qne as IconSolidCash,
  Gne as IconSolidChartBar,
  Kne as IconSolidChartPie,
  Qne as IconSolidChartSquareBar,
  Xne as IconSolidChartSquareLine,
  Jne as IconSolidChat,
  ere as IconSolidChatAlt,
  tre as IconSolidChatAlt_2,
  kT as IconSolidCheck,
  Vx as IconSolidCheckCircle,
  Nx as IconSolidCheveronDown,
  BU as IconSolidCheveronLeft,
  hy as IconSolidCheveronRight,
  FU as IconSolidCheveronUp,
  nre as IconSolidChevronDoubleDown,
  rre as IconSolidChevronDoubleLeft,
  are as IconSolidChevronDoubleRight,
  ore as IconSolidChevronDoubleUp,
  ire as IconSolidChip,
  lre as IconSolidClickUp,
  ure as IconSolidClipboard,
  sre as IconSolidClipboardCheck,
  cre as IconSolidClipboardCopy,
  fre as IconSolidClipboardList,
  UU as IconSolidClock,
  dre as IconSolidCloseLeft,
  hre as IconSolidCloud,
  vre as IconSolidCloudDownload,
  pre as IconSolidCloudUpload,
  mre as IconSolidCode,
  gre as IconSolidCog,
  wre as IconSolidCollection,
  yre as IconSolidColorSwatch,
  xre as IconSolidCreditCard,
  Sre as IconSolidCube,
  Cre as IconSolidCubeTransparent,
  bre as IconSolidCurrencyBangladeshi,
  _re as IconSolidCurrencyDollar,
  Rre as IconSolidCurrencyEuro,
  Ere as IconSolidCurrencyPound,
  Mre as IconSolidCurrencyRupee,
  Tre as IconSolidCurrencyYen,
  Ore as IconSolidCursorClick,
  Dre as IconSolidDatabase,
  jre as IconSolidDesktopComputer,
  Are as IconSolidDeviceMobile,
  kre as IconSolidDiscord,
  Lre as IconSolidDocument,
  Ire as IconSolidDocumentAdd,
  Hre as IconSolidDocumentDownload,
  Zre as IconSolidDocumentDuplicate,
  Pre as IconSolidDocumentRemove,
  Vre as IconSolidDocumentReport,
  Nre as IconSolidDocumentSearch,
  Bre as IconSolidDocumentText,
  Fre as IconSolidDotsCircleHorizontal,
  Ure as IconSolidDotsHorizontal,
  Yre as IconSolidDotsVertical,
  $re as IconSolidDownload,
  Wre as IconSolidDragger,
  zre as IconSolidDuplicate,
  qre as IconSolidEmojiHappy,
  Gre as IconSolidEmojiSad,
  YU as IconSolidExclamation,
  Kre as IconSolidExclamationCircle,
  Qre as IconSolidExitRight,
  Xre as IconSolidExternalLink,
  Jre as IconSolidEye,
  eae as IconSolidEyeOff,
  tae as IconSolidFastForward,
  nae as IconSolidFilm,
  rae as IconSolidFilter,
  aae as IconSolidFingerPrint,
  oae as IconSolidFire,
  iae as IconSolidFlag,
  lae as IconSolidFolder,
  uae as IconSolidFolderAdd,
  sae as IconSolidFolderDownload,
  cae as IconSolidFolderOpen,
  fae as IconSolidFolderRemove,
  dae as IconSolidGift,
  hae as IconSolidGithub,
  vae as IconSolidGitlab,
  pae as IconSolidGlobe,
  mae as IconSolidGlobeAlt,
  gae as IconSolidGoogle,
  wae as IconSolidGrafana,
  yae as IconSolidHand,
  xae as IconSolidHashtag,
  Sae as IconSolidHeart,
  Cae as IconSolidHeight,
  bae as IconSolidHighlight,
  _ae as IconSolidHome,
  Rae as IconSolidIdentification,
  Eae as IconSolidInbox,
  Mae as IconSolidInboxIn,
  $U as IconSolidInformationCircle,
  Tae as IconSolidInspect,
  Oae as IconSolidJira,
  Dae as IconSolidKey,
  jae as IconSolidLightBulb,
  Aae as IconSolidLightningBolt,
  kae as IconSolidLinear,
  Lae as IconSolidLink,
  WU as IconSolidLoading,
  Iae as IconSolidLoadingProgress,
  Hae as IconSolidLocationMarker,
  Zae as IconSolidLockClosed,
  Pae as IconSolidLockOpen,
  Vae as IconSolidLogout,
  Nae as IconSolidLogs,
  Bae as IconSolidMail,
  Fae as IconSolidMailOpen,
  Uae as IconSolidMap,
  Yae as IconSolidMdLibrary,
  $ae as IconSolidMenu,
  Wae as IconSolidMenuAlt_1,
  zae as IconSolidMenuAlt_2,
  qae as IconSolidMenuAlt_3,
  Gae as IconSolidMenuAlt_4,
  Kae as IconSolidMetrics,
  Qae as IconSolidMicrophone,
  Xae as IconSolidMicrosoftTeams,
  zU as IconSolidMinus,
  Jae as IconSolidMinusCircle,
  eoe as IconSolidMinusSm,
  toe as IconSolidMoon,
  noe as IconSolidMusicNote,
  roe as IconSolidNewspaper,
  aoe as IconSolidOfficeBuilding,
  ooe as IconSolidOpenLeft,
  ioe as IconSolidPaperAirplane,
  loe as IconSolidPaperClip,
  uoe as IconSolidPause,
  soe as IconSolidPauseCircle,
  coe as IconSolidPencil,
  foe as IconSolidPencilAlt,
  doe as IconSolidPhone,
  hoe as IconSolidPhoneIncoming,
  voe as IconSolidPhoneMissedCall,
  poe as IconSolidPhoneOutgoing,
  moe as IconSolidPhotograph,
  goe as IconSolidPlay,
  woe as IconSolidPlayCircle,
  yoe as IconSolidPlus,
  xoe as IconSolidPlusCircle,
  Soe as IconSolidPlusSm,
  Coe as IconSolidPresentationChartBar,
  boe as IconSolidPresentationChartLine,
  _oe as IconSolidPrinter,
  Roe as IconSolidPuzzle,
  Eoe as IconSolidQrCode,
  Moe as IconSolidQuestionMarkCircle,
  Toe as IconSolidReceiptRefund,
  Ooe as IconSolidReceiptTax,
  Doe as IconSolidRefresh,
  joe as IconSolidReply,
  Aoe as IconSolidRewind,
  koe as IconSolidRss,
  Loe as IconSolidSave,
  Ioe as IconSolidSaveAs,
  Hoe as IconSolidScale,
  Zoe as IconSolidScissors,
  LT as IconSolidSearch,
  Poe as IconSolidSearchCircle,
  Voe as IconSolidSegment,
  IT as IconSolidSelector,
  Noe as IconSolidServer,
  Boe as IconSolidShare,
  Foe as IconSolidShieldCheck,
  Uoe as IconSolidShieldExclamation,
  Yoe as IconSolidShoppingBag,
  $oe as IconSolidSkip,
  Woe as IconSolidSkipLeft,
  zoe as IconSolidSlack,
  qoe as IconSolidSmartphone,
  Goe as IconSolidSortAscending,
  Koe as IconSolidSortDescending,
  Qoe as IconSolidSparkles,
  Xoe as IconSolidSpeakerphone,
  Joe as IconSolidStar,
  eie as IconSolidStatusOffline,
  tie as IconSolidStatusOnline,
  nie as IconSolidStopCircle,
  rie as IconSolidSun,
  aie as IconSolidSupport,
  oie as IconSolidSwitchHorizontal,
  iie as IconSolidSwitchVertical,
  lie as IconSolidTable,
  uie as IconSolidTag,
  sie as IconSolidTemplate,
  cie as IconSolidTerminal,
  fie as IconSolidThumbDown,
  die as IconSolidThumbUp,
  hie as IconSolidTicket,
  vie as IconSolidTraces,
  pie as IconSolidTranslate,
  mie as IconSolidTrash,
  gie as IconSolidTrendingDown,
  wie as IconSolidTrendingUp,
  yie as IconSolidTruck,
  xie as IconSolidUpload,
  Sie as IconSolidUser,
  Cie as IconSolidUserAdd,
  bie as IconSolidUserCircle,
  _ie as IconSolidUserGroup,
  Rie as IconSolidUserRemove,
  Eie as IconSolidUsers,
  Mie as IconSolidVariable,
  Tie as IconSolidVideoCamera,
  Oie as IconSolidViewBoards,
  Die as IconSolidViewGrid,
  jie as IconSolidViewGridAdd,
  Aie as IconSolidViewList,
  kie as IconSolidVolumeOff,
  Lie as IconSolidVolumeUp,
  Iie as IconSolidWifi,
  Bx as IconSolidX,
  Fx as IconSolidXCircle,
  Hie as IconSolidZoomIn,
  Zie as IconSolidZoomOut,
  AG as Input,
  iY as Item,
  cS as Label,
  da as Menu,
  qie as MenuButton,
  kK as MenuState,
  Fp as Modal,
  Gie as MultiSelectButton,
  FO as NamedSection,
  LG as Option,
  Up as Popover,
  B0 as Select,
  Do as Stack,
  jG as Submit,
  Kie as SwitchButton,
  Rh as Table,
  y3 as Tabs,
  dS as Tag,
  Qie as TagSwitchGroup,
  Fr as Text,
  Xie as TextLink,
  Jie as Tooltip,
  LQ as TooltipContent,
  $Q as buttonStyles,
  Wie as getNow,
  Yie as parsePreset,
  $O as presetLabel,
  IK as presetStartDate,
  Ty as presetValue,
  UQ as sMonotype,
  YQ as typographyStyles,
  Nie as useComboboxStore
};
//# sourceMappingURL=components.js.map
